/* 2026-07-20 SEGURANCA: injeta X-Tsf-Key (staff) nas chamadas ao toth-checkout. Fail-safe. */
(function(){try{if(window.__tsfCK)return;window.__tsfCK=1;var _f=window.fetch.bind(window),CK='/functions/v1/toth-checkout';window.fetch=function(i,o){try{var u=(typeof i==='string')?i:(i&&i.url)||'';var k=window.TSF_KEY;if(k&&u.indexOf(CK)>-1){o=o||{};var h=new Headers((o&&o.headers)||(typeof i!=='string'&&i&&i.headers)||{});if(!h.has('X-Tsf-Key'))h.set('X-Tsf-Key',k);o.headers=h;}}catch(e){}return _f(i,o);};}catch(e){}})();
/**
 * TOTH SPECIFICA · COMPANION JS
 * V1.2 · 2026-05-16 · Sprint 9
 *
 * Web Components puros (zero dependencies). Padrões:
 *  - #privateMethod
 *  - AbortController para cleanup
 *  - async/await
 *  - for...of (não forEach)
 *  - Defensive: try/catch em todos handlers, falha silenciosa
 *
 * Componentes ATIVOS:
 *  - <tsf-companion>   : sidebar floating expand/collapse + keyboard nav
 *  - TsfSearchOverlay  : ⌘K search overlay (predictive search Shopify)
 *  - TsfPricingMain    : slider colapsado de markup em produto hide_price
 *
 * Removidos:
 *  - TsfCalculator (2026-05-16): UX desnecessário, valor já no card de proposta
 *  - Commission-copy handler (2026-05-16): modo INDICAR removido (sem backend)
 */

(function () {
  'use strict';

  /* ════════════════════════════════════════════════════════════════════
     0. CUSTOMER CONTEXT — lê JSON injetado pelo snippet
        OBS: pode ser null em páginas onde companion não renderiza
        (ex.: /pages/specifica-orcamento). Componentes que dependem
        de CUSTOMER devem fazer check próprio.
     ════════════════════════════════════════════════════════════════════ */
  let CUSTOMER = null;
  try {
    const el = document.getElementById('tsf-customer-context');
    if (el) CUSTOMER = JSON.parse(el.textContent);
  } catch (err) {
    // Falha silenciosa
  }

  /* ════════════════════════════════════════════════════════════════════
     0.5 TOTAL DO DOCUMENTO — FONTE ÚNICA DA VERDADE (markup manda)
        Usada por venda (editor + lista) e orçamento. price_centavos é só
        cache, NÃO verdade: o preço do cliente = custo × (1 + markup),
        recomputado ao vivo. Espelha o back-end computeSaleTotalCentavos
        e o editor #computeFinanceSummary — uma fórmula só, sem divergir.
     ════════════════════════════════════════════════════════════════════ */
  function tsfDocTotalCentavos(doc) {
    const d = doc || {};
    const items = Array.isArray(d.items) ? d.items : [];
    const globalPct = parseFloat(d.default_markup_pct) || 50;
    let produtos = 0;
    for (const it of items) {
      const qty = it.qty || 1;
      const snap = it.snapshot || {};
      const ov = it.overrides || {};
      const cost = (typeof ov.cost_centavos === 'number') ? ov.cost_centavos :
                   (typeof snap.cost_centavos === 'number' && snap.cost_centavos > 0) ? snap.cost_centavos :
                   (snap.price_centavos || 0);
      const markup = (typeof it.markup_pct === 'number') ? it.markup_pct : null;
      const nativePct = (typeof snap.cost_centavos === 'number' && snap.cost_centavos > 0 &&
                         typeof snap.price_centavos === 'number' && snap.price_centavos > 0)
        ? ((snap.price_centavos - snap.cost_centavos) / snap.cost_centavos) * 100 : null;
      const src = ov.markup_source;
      let useM;
      if (src === 'manual') useM = (markup !== null) ? markup : globalPct;
      else if (src === 'global') useM = globalPct;
      else if (markup !== null) useM = markup;
      else if (nativePct !== null) useM = nativePct;
      else useM = globalPct;
      produtos += (cost * (1 + useM / 100)) * qty;
    }
    // 2026-06-30 · Desconto do cliente em R$ sobre o subtotal de PRODUTOS (com markup) · NÃO incide no frete.
    const desconto = Math.max(0, parseInt(d.client_info && d.client_info.discount_centavos, 10) || 0);
    const produtosNet = Math.max(0, produtos - desconto);
    const frete = d.frete_centavos || 0;
    const cardPct = parseFloat(d.client_info && d.client_info.card_surcharge_pct) || 0;
    const denom = 1 - cardPct / 100;
    const freteAj = (frete > 0 && cardPct > 0 && denom > 0) ? (frete / denom) : frete;
    const mode = String((d.client_info && d.client_info.freight_mode) || 'charge').toLowerCase();
    const freteIn = (mode === 'charge') ? freteAj : 0;
    return Math.round(produtosNet + freteIn);
  }

  /* ════════════════════════════════════════════════════════════════════
     tsfSplitRua / tsfDeriveAddress · endereço combinado do checkout
     O checkout Shopify grava o endereço num campo `rua` só ("Rua X, 1540"),
     sem logradouro/numero separados. Estes helpers DERIVAM logradouro+numero
     do `rua` quando estão vazios — usado no form do cliente e no gate de
     conversão de venda. Bairro e CPF NÃO são deriváveis (o checkout não coleta),
     então continuam obrigatórios. Não-destrutivo: só preenche o que falta.
     ════════════════════════════════════════════════════════════════════ */
  function tsfSplitRua(rua) {
    const s = String(rua || '').trim();
    if (!s) return { logradouro: '', numero: '' };
    // "Rua Heitor Penteado, 1540" · tolera sem vírgula e número com letra (1540A)
    const m = s.match(/^(.*?)[,\s]+(\d+[A-Za-z]?)\s*$/);
    if (m) return { logradouro: m[1].trim().replace(/[,\s]+$/, ''), numero: m[2] };
    return { logradouro: s, numero: '' };
  }
  function tsfDeriveAddress(a) {
    a = a || {};
    // só deriva quando NÃO há logradouro separado mas EXISTE o `rua` combinado
    if ((a.logradouro && String(a.logradouro).trim()) || !a.rua) return a;
    const sp = tsfSplitRua(a.rua);
    return Object.assign({}, a, {
      logradouro: sp.logradouro,
      numero: (a.numero && String(a.numero).trim()) ? a.numero : sp.numero,
    });
  }

  // 2026-06-30 · Parse de valor em R$ (formato BR) → centavos. "1.000,00" e "1000" → 100000. Nunca negativo.
  function tsfParseMoneyCentavos(v) {
    const s = String(v == null ? '' : v).replace(/[^\d.,]/g, '');
    if (!s) return 0;
    const n = parseFloat(s.replace(/\./g, '').replace(',', '.'));
    return isFinite(n) ? Math.max(0, Math.round(n * 100)) : 0;
  }

  /* ════════════════════════════════════════════════════════════════════
     1. <tsf-companion> — Sidebar floating
     ════════════════════════════════════════════════════════════════════ */
  class TsfCompanion extends HTMLElement {
    #abortController = null;
    #toggleBtn = null;
    #expanded = false;

    connectedCallback() {
      this.#abortController = new AbortController();
      const { signal } = this.#abortController;

      this.#toggleBtn = this.querySelector('.tsf-companion__toggle');
      if (!this.#toggleBtn) return;

      // Toggle on click (mobile + click users)
      this.#toggleBtn.addEventListener('click', (e) => {
        e.preventDefault();
        this.#toggleExpand();
      }, { signal });

      // Escape to collapse
      window.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.#expanded) {
          this.#collapse();
        }
        // ⌘K or Ctrl+K opens search
        if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') {
          e.preventDefault();
          this.#openSearch();
        }
      }, { signal });

      // Search trigger
      const searchBtn = this.querySelector('[data-tsf-search-trigger]');
      if (searchBtn) {
        searchBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.#openSearch();
        }, { signal });
      }

    }

    disconnectedCallback() {
      this.#abortController?.abort();
    }

    #toggleExpand() {
      if (this.#expanded) {
        this.#collapse();
      } else {
        this.#expand();
      }
    }

    #expand() {
      this.#expanded = true;
      this.setAttribute('data-expanded', 'true');
      this.#toggleBtn?.setAttribute('aria-expanded', 'true');
    }

    #collapse() {
      this.#expanded = false;
      this.removeAttribute('data-expanded');
      this.#toggleBtn?.setAttribute('aria-expanded', 'false');
    }

    #openSearch() {
      const overlay = TsfSearchOverlay.getInstance();
      overlay.open();
    }
  }

  /* ════════════════════════════════════════════════════════════════════
     2. TsfSearchOverlay — ⌘K Quick Search (Shopify Predictive Search API)
     ════════════════════════════════════════════════════════════════════ */
  class TsfSearchOverlay {
    static #instance = null;
    #overlay = null;
    #input = null;
    #results = null;
    #abortController = null;
    #debounceTimer = null;

    static getInstance() {
      if (!TsfSearchOverlay.#instance) {
        TsfSearchOverlay.#instance = new TsfSearchOverlay();
      }
      return TsfSearchOverlay.#instance;
    }

    constructor() {
      this.#render();
    }

    #render() {
      this.#overlay = document.createElement('div');
      this.#overlay.className = 'tsf-search-overlay';
      this.#overlay.setAttribute('role', 'dialog');
      this.#overlay.setAttribute('aria-modal', 'true');
      this.#overlay.setAttribute('aria-label', 'Buscar produtos Toth');
      this.#overlay.innerHTML = `
        <div class="tsf-search-overlay__panel">
          <div class="tsf-search-overlay__input-wrap">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" style="opacity:0.4;">
              <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
            </svg>
            <input class="tsf-search-overlay__input" type="text" placeholder="Buscar produtos, fornecedores, ambientes..." aria-label="Termo de busca">
            <button class="tsf-search-overlay__close" type="button" aria-label="Fechar busca">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </button>
          </div>
          <div class="tsf-search-overlay__results">
            <p class="tsf-search-overlay__hint">Digite para buscar — Esc para fechar</p>
          </div>
        </div>
      `;
      document.body.appendChild(this.#overlay);

      this.#abortController = new AbortController();
      const { signal } = this.#abortController;

      this.#input = this.#overlay.querySelector('.tsf-search-overlay__input');
      this.#results = this.#overlay.querySelector('.tsf-search-overlay__results');

      this.#input.addEventListener('input', () => this.#onInput(), { signal });

      const closeBtn = this.#overlay.querySelector('.tsf-search-overlay__close');
      closeBtn.addEventListener('click', () => this.close(), { signal });

      this.#overlay.addEventListener('click', (e) => {
        if (e.target === this.#overlay) this.close();
      }, { signal });

      window.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.#overlay.getAttribute('data-open') === 'true') {
          this.close();
        }
      }, { signal });
    }

    #onInput() {
      window.clearTimeout(this.#debounceTimer);
      const q = this.#input.value.trim();
      if (q.length < 2) {
        this.#results.innerHTML = '<p class="tsf-search-overlay__hint">Digite pelo menos 2 letras…</p>';
        return;
      }
      this.#debounceTimer = window.setTimeout(() => this.#search(q), 250);
    }

    async #search(q) {
      this.#results.innerHTML = '<p class="tsf-search-overlay__hint">Buscando…</p>';
      try {
        const url = `/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product,collection&resources[limit]=8`;
        const resp = await fetch(url);
        const data = await resp.json();
        const products = data?.resources?.results?.products || [];
        const collections = data?.resources?.results?.collections || [];

        if (products.length === 0 && collections.length === 0) {
          this.#results.innerHTML = '<p class="tsf-search-overlay__hint">Nada encontrado para "' + this.#escapeHtml(q) + '"</p>';
          return;
        }

        let html = '';
        if (products.length) {
          html += '<div style="padding:8px 12px 4px;font-size:10px;letter-spacing:0.18em;text-transform:uppercase;color:rgba(26,25,24,0.42);font-weight:500;">Produtos</div>';
          for (const p of products.slice(0, 6)) {
            html += `<a href="${p.url}" style="display:flex;align-items:center;gap:12px;padding:10px 12px;text-decoration:none;color:#1a1918;border-radius:8px;">
              ${p.image ? `<img src="${p.image}" alt="" width="40" height="40" style="border-radius:6px;object-fit:cover;flex-shrink:0;">` : ''}
              <div style="flex:1;min-width:0;">
                <div style="font-size:13px;font-weight:500;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">${this.#escapeHtml(p.title)}</div>
                <div style="font-size:11px;color:rgba(26,25,24,0.62);margin-top:2px;">${p.product_type || ''}</div>
              </div>
            </a>`;
          }
        }
        if (collections.length) {
          html += '<div style="padding:8px 12px 4px;font-size:10px;letter-spacing:0.18em;text-transform:uppercase;color:rgba(26,25,24,0.42);font-weight:500;">Coleções</div>';
          for (const c of collections.slice(0, 3)) {
            html += `<a href="${c.url}" style="display:flex;align-items:center;gap:12px;padding:10px 12px;text-decoration:none;color:#1a1918;border-radius:8px;font-size:13px;">${this.#escapeHtml(c.title)}</a>`;
          }
        }
        this.#results.innerHTML = html;
      } catch (err) {
        this.#results.innerHTML = '<p class="tsf-search-overlay__hint">Erro ao buscar. Tente novamente.</p>';
      }
    }

    #escapeHtml(s) {
      return String(s).replace(/[<>&"]/g, (c) => ({ '<':'&lt;','>':'&gt;','&':'&amp;','"':'&quot;' }[c]));
    }

    open() {
      this.#overlay?.setAttribute('data-open', 'true');
      window.requestAnimationFrame(() => this.#input?.focus());
    }

    close() {
      this.#overlay?.removeAttribute('data-open');
    }
  }

  /* ════════════════════════════════════════════════════════════════════
     4. TsfPricingMain — Slider interativo de markup em página de produto
     ════════════════════════════════════════════════════════════════════ */
  class TsfPricingMain {
    static #instances = new WeakMap();
    #root;
    #abortController;
    #tothPrice;
    #defaultPct;
    #slider;
    #sliderPanel;
    #toggleBtn;
    #clientOutput;
    #gainOutput;
    #pctOutput;
    #copyBtn;

    static init(root) {
      if (TsfPricingMain.#instances.has(root)) return;
      const inst = new TsfPricingMain(root);
      TsfPricingMain.#instances.set(root, inst);
    }

    constructor(root) {
      this.#root = root;
      this.#tothPrice = parseInt(root.dataset.tothPrice, 10) || 0; // centavos
      this.#defaultPct = parseInt(root.dataset.defaultPct, 10) || 0;

      this.#slider = root.querySelector('[data-tsf-markup-input]');
      this.#sliderPanel = root.querySelector('.tsf-proposal__slider');
      this.#toggleBtn = root.querySelector('[data-tsf-toggle-slider]');
      this.#clientOutput = root.querySelector('[data-tsf-client-output]');
      this.#gainOutput = root.querySelector('[data-tsf-gain-output]');
      this.#pctOutput = root.querySelector('[data-tsf-pct-output]');
      this.#copyBtn = root.querySelector('[data-tsf-pricing-copy]');

      if (!this.#slider) return;

      this.#abortController = new AbortController();
      const { signal } = this.#abortController;

      this.#slider.addEventListener('input', () => this.#recalc(), { signal });
      this.#copyBtn?.addEventListener('click', () => this.#copyProposal(), { signal });
      this.#toggleBtn?.addEventListener('click', () => this.#toggleSlider(), { signal });
    }

    #toggleSlider() {
      if (!this.#sliderPanel || !this.#toggleBtn) return;
      const isOpen = this.#toggleBtn.getAttribute('aria-expanded') === 'true';
      if (isOpen) {
        this.#sliderPanel.setAttribute('hidden', '');
        this.#toggleBtn.setAttribute('aria-expanded', 'false');
      } else {
        this.#sliderPanel.removeAttribute('hidden');
        this.#toggleBtn.setAttribute('aria-expanded', 'true');
      }
    }

    #recalc() {
      const pct = parseInt(this.#slider.value, 10) || 0;
      const markupValue = (this.#tothPrice * pct) / 100;
      const clientPrice = this.#tothPrice + markupValue;
      this.#clientOutput.textContent = this.#money(clientPrice);
      this.#gainOutput.textContent = this.#money(markupValue);
      this.#pctOutput.textContent = '+' + pct;
      this.#slider.setAttribute('aria-valuenow', String(pct));
    }

    #reset() {
      this.#slider.value = this.#defaultPct;
      this.#recalc();
    }

    async #copyProposal() {
      const pct = parseInt(this.#slider.value, 10) || 0;
      const markupValue = (this.#tothPrice * pct) / 100;
      const clientPrice = this.#tothPrice + markupValue;
      const productName = document.querySelector('.product__title h1, h1.product__title')?.textContent.trim() || '';
      const productUrl = window.location.origin + window.location.pathname;

      const text = `Proposta · ${productName}\n\n` +
        `Valor: ${this.#money(clientPrice)}\n` +
        `Link: ${productUrl}\n\n` +
        `Curadoria Toth Móveis · entrega para todo o Brasil`;

      try {
        await navigator.clipboard.writeText(text);
        this.#feedback('Proposta copiada');
      } catch {
        this.#feedback('Selecione manualmente');
      }
    }

    #feedback(msg) {
      if (!this.#copyBtn) return;
      const label = this.#copyBtn.querySelector('[data-tsf-copy-label]');
      const original = label?.textContent || 'Copiar proposta';
      if (label) label.textContent = msg;
      this.#copyBtn.setAttribute('data-tsf-copied', 'true');
      window.setTimeout(() => {
        if (label) label.textContent = original;
        this.#copyBtn.removeAttribute('data-tsf-copied');
      }, 2000);
    }

    #money(centavos) {
      return (centavos / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    }
  }

  /* ════════════════════════════════════════════════════════════════════
     4. Quote handler — POST /quote/add-item via Edge Function
     ════════════════════════════════════════════════════════════════════ */
  const QUOTE_ENDPOINT = 'https://pucrgwvcgagbapzvphao.supabase.co/functions/v1/toth-checkout/quote';

  /* ════════════════════════════════════════════════════════════════════
     UI-FIX 2/2b · TsfPeriodFilter · helper compartilhado para filtro temporal
     Usado por TsfAdminVendas, TsfAdminOrcamentos, TsfPedidoApp.
     ════════════════════════════════════════════════════════════════════ */
  const TSF_MONTH_NAMES = ['Janeiro','Fevereiro','Março','Abril','Maio','Junho',
                           'Julho','Agosto','Setembro','Outubro','Novembro','Dezembro'];

  const TsfPeriodFilter = {
    monthsList() {
      const out = [];
      const now = new Date();
      for (let i = 1; i <= 12; i++) {
        const d = new Date(now.getFullYear(), now.getMonth() - i, 1);
        const y = d.getFullYear();
        const mo = d.getMonth() + 1;
        out.push({
          key: `month-${y}-${String(mo).padStart(2,'0')}`,
          label: `${TSF_MONTH_NAMES[d.getMonth()]} ${y}`,
        });
      }
      return out;
    },

    isMonthPeriod(period) {
      return period === 'month' || /^month-\d{4}-\d{1,2}$/.test(String(period || ''));
    },

    isValidPeriod(period) {
      return ['today','month','7d','30d','60d','90d','12m','all'].includes(period) ||
             /^month-\d{4}-\d{1,2}$/.test(String(period || ''));
    },

    monthBtnLabel(currentPeriod) {
      if (currentPeriod === 'month') return 'Mês atual';
      const m = String(currentPeriod || '').match(/^month-(\d{4})-(\d{1,2})$/);
      if (m) {
        const item = this.monthsList().find(mo => mo.key === currentPeriod);
        return item ? item.label : currentPeriod;
      }
      return 'Mês';
    },

    periodLabel(currentPeriod) {
      const m = String(currentPeriod || '').match(/^month-(\d{4})-(\d{1,2})$/);
      if (m) {
        const y = parseInt(m[1], 10);
        const mo = parseInt(m[2], 10) - 1;
        return `em ${TSF_MONTH_NAMES[mo]} de ${y}`;
      }
      return ({ today: 'hoje', month: 'no mês atual', '7d': 'nos últimos 7 dias',
               '30d': 'nos últimos 30 dias', '60d': 'nos últimos 60 dias', '90d': 'nos últimos 90 dias',
               '12m': 'nos últimos 12 meses', 'all': '' })[currentPeriod] || '';
    },

    dateRange(currentPeriod) {
      const now = new Date();
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      const m = String(currentPeriod || '').match(/^month-(\d{4})-(\d{1,2})$/);
      if (m) {
        const y = parseInt(m[1], 10);
        const mo = parseInt(m[2], 10) - 1;
        return [new Date(y, mo, 1), new Date(y, mo + 1, 1)];
      }
      switch (currentPeriod) {
        case 'today': return [today, new Date(today.getTime() + 86400000)];
        case 'month': return [new Date(now.getFullYear(), now.getMonth(), 1), new Date(now.getFullYear(), now.getMonth() + 1, 1)];
        case '7d': return [new Date(today.getTime() - 7 * 86400000), new Date(today.getTime() + 86400000)];
        case '30d': return [new Date(today.getTime() - 30 * 86400000), new Date(today.getTime() + 86400000)];
        case '60d': return [new Date(today.getTime() - 60 * 86400000), new Date(today.getTime() + 86400000)];
        case '90d': return [new Date(today.getTime() - 90 * 86400000), new Date(today.getTime() + 86400000)];
        case '12m': return [new Date(now.getFullYear() - 1, now.getMonth(), 1), new Date(today.getTime() + 86400000)];
        case 'all': default: return [null, null];
      }
    },

    renderToggle(currentPeriod) {
      const months = this.monthsList();
      const isMonth = this.isMonthPeriod(currentPeriod);
      const monthLabel = this.monthBtnLabel(currentPeriod);
      const cls = (k) => `tsf-admin-period-toggle__btn ${currentPeriod === k ? 'is-active' : ''}`;
      const sel = (k) => currentPeriod === k ? 'true' : 'false';
      // UI-FIX 2 v3 · estado do menu via classe is-open no wrap (não mais `hidden` attribute)
      return `
        <div class="tsf-admin-period-toggle" role="tablist" aria-label="Período">
          <button type="button" class="${cls('today')}" data-period="today" role="tab" aria-selected="${sel('today')}">Hoje</button>
          <div class="tsf-admin-period-toggle__month-wrap" data-tsf-month-wrap>
            <button type="button"
              class="tsf-admin-period-toggle__btn tsf-admin-period-toggle__month-btn ${isMonth ? 'is-active' : ''}"
              data-tsf-month-toggle
              aria-haspopup="listbox"
              aria-expanded="false"><span data-tsf-month-label>${monthLabel}</span></button>
            <div class="tsf-admin-period-toggle__month-menu" data-tsf-month-menu role="listbox" aria-label="Selecionar mês">
              <button type="button" class="tsf-admin-period-toggle__month-item ${currentPeriod === 'month' ? 'is-active' : ''}" data-period="month" role="option" aria-selected="${currentPeriod === 'month'}">Mês atual</button>
              ${months.map(m => `
                <button type="button" class="tsf-admin-period-toggle__month-item ${currentPeriod === m.key ? 'is-active' : ''}" data-period="${m.key}" role="option" aria-selected="${currentPeriod === m.key}">${m.label}</button>
              `).join('')}
            </div>
          </div>
          <button type="button" class="${cls('7d')}" data-period="7d" role="tab" aria-selected="${sel('7d')}">7 dias</button>
          <button type="button" class="${cls('30d')}" data-period="30d" role="tab" aria-selected="${sel('30d')}">30 dias</button>
          <button type="button" class="${cls('60d')}" data-period="60d" role="tab" aria-selected="${sel('60d')}">60 dias</button>
          <button type="button" class="${cls('90d')}" data-period="90d" role="tab" aria-selected="${sel('90d')}">90 dias</button>
          <button type="button" class="${cls('12m')}" data-period="12m" role="tab" aria-selected="${sel('12m')}">12 meses</button>
          <button type="button" class="${cls('all')}" data-period="all" role="tab" aria-selected="${sel('all')}">Tudo</button>
        </div>
      `;
    },

    isMenuOpen(hostElement) {
      const wrap = hostElement.querySelector('[data-tsf-month-wrap]');
      return !!(wrap && wrap.classList.contains('is-open'));
    },

    openMenu(hostElement) {
      const wrap = hostElement.querySelector('[data-tsf-month-wrap]');
      const toggle = hostElement.querySelector('[data-tsf-month-toggle]');
      if (wrap) wrap.classList.add('is-open');
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
    },

    // Atualiza is-active dos botões + label do MÊS, sem re-render full
    syncActiveState(hostElement, currentPeriod) {
      const isMonth = this.isMonthPeriod(currentPeriod);
      // Presets
      hostElement.querySelectorAll('.tsf-admin-period-toggle__btn[data-period]').forEach(b => {
        const k = b.getAttribute('data-period');
        const active = (k === currentPeriod) || (k === 'month' && currentPeriod === 'month');
        b.classList.toggle('is-active', active);
        b.setAttribute('aria-selected', String(active));
      });
      // Botão MÊS (wrapper toggle)
      const monthBtn = hostElement.querySelector('[data-tsf-month-toggle]');
      const monthLbl = hostElement.querySelector('[data-tsf-month-label]');
      if (monthBtn) monthBtn.classList.toggle('is-active', isMonth);
      if (monthLbl) monthLbl.textContent = this.monthBtnLabel(currentPeriod);
      // Items do menu
      hostElement.querySelectorAll('.tsf-admin-period-toggle__month-item').forEach(b => {
        const k = b.getAttribute('data-period');
        b.classList.toggle('is-active', k === currentPeriod);
        b.setAttribute('aria-selected', String(k === currentPeriod));
      });
    },

    closeMenu(hostElement) {
      const wrap = hostElement.querySelector('[data-tsf-month-wrap]');
      const toggle = hostElement.querySelector('[data-tsf-month-toggle]');
      if (wrap) wrap.classList.remove('is-open');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    },

    toggleMenu(hostElement) {
      if (this.isMenuOpen(hostElement)) this.closeMenu(hostElement);
      else this.openMenu(hostElement);
    },

    // Anexa listeners. Captura em CAPTURE phase pra fechar IMEDIATAMENTE antes
    // de qualquer outro handler do componente.
    attachListeners(hostElement, getCurrent, onChange, abortSignal) {
      const self = this; // garantir binding correto dentro de listeners

      // Click em qualquer [data-period] dentro do host (preset OU item do menu)
      // Bubble phase do hostElement — pega tudo que está dentro.
      hostElement.addEventListener('click', (e) => {
        const target = e.target;
        if (!target || !target.closest) return;

        // 1. Item do menu (data-period dentro do data-tsf-month-menu) → seleciona + FECHA
        const menuItem = target.closest('[data-tsf-month-menu] [data-period]');
        if (menuItem) {
          e.preventDefault();
          e.stopPropagation();
          const newPeriod = menuItem.getAttribute('data-period');
          self.closeMenu(hostElement);
          if (newPeriod !== getCurrent()) onChange(newPeriod);
          return;
        }

        // 2. Preset normal (data-period FORA do menu) → seleciona + fecha menu
        const presetBtn = target.closest('[data-period]');
        if (presetBtn && !presetBtn.hasAttribute('data-tsf-month-toggle')) {
          e.preventDefault();
          e.stopPropagation();
          const newPeriod = presetBtn.getAttribute('data-period');
          self.closeMenu(hostElement);
          if (newPeriod !== getCurrent()) onChange(newPeriod);
          return;
        }

        // 3. Botão MÊS (toggle) → alterna abertura
        const monthToggle = target.closest('[data-tsf-month-toggle]');
        if (monthToggle) {
          e.preventDefault();
          e.stopPropagation();
          self.toggleMenu(hostElement);
          return;
        }
      }, { signal: abortSignal });

      // Click fora · fecha o menu (capture phase pra rodar antes de qualquer outro)
      document.addEventListener('click', (e) => {
        if (!self.isMenuOpen(hostElement)) return;
        const wrap = hostElement.querySelector('[data-tsf-month-wrap]');
        if (!wrap) return;
        if (!wrap.contains(e.target)) self.closeMenu(hostElement);
      }, { signal: abortSignal, capture: true });

      // ESC fecha o menu
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && self.isMenuOpen(hostElement)) self.closeMenu(hostElement);
      }, { signal: abortSignal });
    },
  };

  // ═══════════════════════════════════════════════════════════════════
  // TOTH BRAND DATA · fonte única de verdade para credenciais institucionais
  // que aparecem no PDF do orçamento. Atualizar aqui altera capa, fechamento
  // e todos os blocos editoriais sem mexer em metaobjects.
  // ═══════════════════════════════════════════════════════════════════
  const TOTH_BRAND = {
    // Logo oficial horizontal (1080x324) · usado em header e cover
    logoUrl: 'https://cdn.shopify.com/s/files/1/0649/2510/6388/files/LOGO-TOTH-MOVEIS-0.png?v=1657568348',
    // Métricas de escala da empresa (16 anos · 500+ obras · 26 estados · 600m² fábrica)
    metrics: [
      { number: '500+', label: 'obras entregues' },
      { number: '26', label: 'estados atendidos' },
      { number: '2010', label: 'fundada em' },
      { number: '600m²', label: 'fábrica própria' },
    ],
    // Marcas corporativas que já receberam mobiliário Toth (alta credibilidade)
    trustedBrands: ['Club Med', 'Globo', 'Honda', 'Pirelli', 'CAIXA', 'SENAI', "Bob's", 'WeWork', 'Alphaville', 'MSC Cruzeiros', 'ESPM', 'Itaipu Binacional'],
    // Endereços oficiais
    showroom: 'Av. da Saudade, 1351 · Cidade Universitária · Pres. Prudente · SP · CEP 19050-310',
    factory: 'Estr. Vicinal Ver. José Molina, km 1 · Álvares Machado · SP · CEP 19160-000',
    phone: '+55 (18) 99671-4293',
    email: 'contato@tothmoveis.com.br',
    site: 'www.tothmoveis.com.br',
  };
  const money = (centavos) => (centavos / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

  async function addToQuote(btn) {
    if (!CUSTOMER || !CUSTOMER.customer_id) {
      window.alert('Faça login com sua conta Specifica para criar um orçamento.');
      window.location.href = '/account/login?return_url=' + encodeURIComponent(window.location.pathname);
      return;
    }
    const productId = btn.getAttribute('data-tsf-add-quote');
    if (!productId) return;

    const snapshotEl = document.querySelector(`script[data-tsf-product-snapshot="${productId}"]`);
    if (!snapshotEl) {
      console.warn('[tsf] snapshot not found for product', productId);
      return;
    }

    let payload;
    try {
      const item = JSON.parse(snapshotEl.textContent);
      const kind = btn.getAttribute('data-tsf-quote-kind') || 'specifica';
      payload = {
        specifier_customer_id: CUSTOMER.customer_id,
        specifier_tier: CUSTOMER.tier || (kind === 'toth_internal' ? 'toth' : 'gold'),
        specifier_email: CUSTOMER.email,
        quote_kind: kind,
        item,
      };
    } catch (err) {
      console.error('[tsf] snapshot parse failed', err);
      return;
    }

    const label = btn.querySelector('[data-tsf-add-quote-label]');
    const original = label?.textContent || 'Adicionar ao orçamento';
    btn.disabled = true;
    if (label) label.textContent = 'Adicionando…';

    try {
      const res = await fetch(`${QUOTE_ENDPOINT}/add-item`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      const data = await res.json();
      if (!res.ok || !data.ok) throw new Error(data.error || 'erro desconhecido');

      btn.setAttribute('data-tsf-added', 'true');
      if (label) label.textContent = 'Adicionado ✓';
      // Atualiza badge de contador se existir
      const totalItems = (data.quote.items || []).length;
      window.dispatchEvent(new CustomEvent('tsf:quote-updated', { detail: { quote: data.quote, totalItems } }));

      window.setTimeout(() => {
        btn.disabled = false;
        btn.removeAttribute('data-tsf-added');
        if (label) label.textContent = 'Ver orçamento';
        btn.setAttribute('data-tsf-action', 'view');
      }, 1800);
    } catch (err) {
      console.error('[tsf] add-to-quote failed', err);
      btn.disabled = false;
      if (label) label.textContent = 'Tentar novamente';
      window.setTimeout(() => {
        if (label) label.textContent = original;
      }, 2500);
    }
  }

  function handleQuoteButton(btn) {
    const action = btn.getAttribute('data-tsf-action');
    const kind = btn.getAttribute('data-tsf-quote-kind') || 'specifica';
    if (action === 'view') {
      window.location.href = kind === 'toth_internal' ? '/pages/orcamento' : '/pages/specifica-orcamento';
      return;
    }
    addToQuote(btn);
  }

  /* ════════════════════════════════════════════════════════════════════
     4.5. <tsf-quote-builder> — Página /pages/specifica-orcamento
     Web Component que lê draft do specifier e renderiza tabela editável.
     Phase 0: edit qty + remove + markup slider universal + print.
     ════════════════════════════════════════════════════════════════════ */
  class TsfQuoteBuilder extends HTMLElement {
    #abortController = null;
    #ctx = null;
    #quote = null;
    #kind = 'specifica'; // 'specifica' | 'toth_internal'
    #rowsEl = null;
    #loadingEl = null;
    #emptyEl = null;
    #toolbarEl = null;
    #totalBlockEl = null;
    #markupInput = null;
    #markupOutput = null;
    #totalTothEl = null;
    #totalGainEl = null;
    #totalClienteEl = null;
    #totalProductsEl = null;
    #totalFreightEl = null;
    #totalFreightRowEl = null;
    #totalPixEl = null;
    #statusEl = null;
    #dateEl = null;
    #saveTimer = null;
    // Client + freight
    #clientCardEl = null;
    #clientBodyEl = null;
    #clientToggleEl = null;
    #clientToggleLabelEl = null;
    #cepStatusEl = null;
    #addressEl = null;
    #addressTextEl = null;
    #clientPrintEl = null;
    #freightBlockEl = null;
    #freightBodyEl = null;
    #freightTitleEl = null;
    #freightTotal = 0;
    #freightPrazo = null;
    #cepTimer = null;
    #freightRecalcTimer = null;
    #cepBusy = false;
    // Card surcharge · sempre aplicado ao frete (sem toggle); user só edita o %
    #cardPctInputEl = null;
    #discountInputEl = null;
    #totalDiscountEl = null;
    #totalDiscountRowEl = null;
    #freightOriginalRowEl = null;
    #freightOriginalValueEl = null;
    #freightOriginalLabelEl = null;
    // Photo switcher
    #photoDialogEl = null;
    #photoGridEl = null;
    #photoDialogTitleEl = null;
    #photoActiveUid = null;
    #photoCache = new Map();
    // Onda 6.13A · Indicador visual quando o quote já virou venda
    // Carregado uma vez no fetch, usado em #render() pra mostrar banner topo
    // + transformar botão "Converter em venda" em "Ver venda VND-XXXX".
    #linkedSale = null;

    async connectedCallback() {
      this.#abortController = new AbortController();
      const { signal } = this.#abortController;

      // Context próprio (independente de companion estar na página)
      try {
        const el = this.querySelector('[data-tsf-quote-context]');
        if (el) this.#ctx = JSON.parse(el.textContent);
      } catch {}
      if (!this.#ctx?.customer_id) {
        this.#renderError('Contexto de cliente não encontrado.');
        return;
      }
      // Determina modo (specifica vs toth_internal)
      this.#kind = this.getAttribute('data-quote-kind') || this.#ctx.quote_kind || 'specifica';

      // Cache de elementos
      this.#rowsEl = this.querySelector('[data-tsf-quote-rows]');
      this.#loadingEl = this.querySelector('[data-tsf-quote-loading]');
      this.#emptyEl = this.querySelector('[data-tsf-quote-empty]');
      this.#toolbarEl = this.querySelector('[data-tsf-quote-toolbar]');
      this.#totalBlockEl = this.querySelector('[data-tsf-quote-total]');
      this.#markupInput = this.querySelector('[data-tsf-quote-markup-input]');
      this.#markupOutput = this.querySelector('[data-tsf-quote-markup-output]');
      this.#totalTothEl = this.querySelector('[data-tsf-quote-total-toth]');
      this.#totalGainEl = this.querySelector('[data-tsf-quote-total-gain]');
      this.#totalClienteEl = this.querySelector('[data-tsf-quote-total-cliente]');
      this.#totalProductsEl = this.querySelector('[data-tsf-quote-total-products]');
      this.#totalFreightEl = this.querySelector('[data-tsf-quote-total-freight]');
      this.#totalFreightRowEl = this.querySelector('[data-tsf-quote-total-freight-row]');
      this.#totalPixEl = this.querySelector('[data-tsf-quote-total-pix]');
      this.#statusEl = document.querySelector('[data-tsf-quote-status]');
      this.#dateEl = document.querySelector('[data-tsf-quote-byline-date]');
      // Client card
      this.#clientCardEl = this.querySelector('[data-tsf-quote-client]');
      this.#clientBodyEl = this.querySelector('#tsf-quote-client-body');
      this.#clientToggleEl = this.querySelector('[data-tsf-client-toggle]');
      this.#clientToggleLabelEl = this.querySelector('[data-tsf-client-toggle-label]');
      this.#cepStatusEl = this.querySelector('[data-tsf-client-cep-status]');
      this.#addressEl = this.querySelector('[data-tsf-client-address]');
      this.#addressTextEl = this.querySelector('[data-tsf-client-address-text]');
      this.#clientPrintEl = this.querySelector('[data-tsf-client-print]');
      // Freight
      this.#freightBlockEl = this.querySelector('[data-tsf-quote-freight]');
      this.#freightBodyEl = this.querySelector('[data-tsf-quote-freight-body]');
      this.#freightTitleEl = this.querySelector('[data-tsf-quote-freight-title]');
      // Card surcharge · sempre aplicado · usuário só edita o %
      this.#cardPctInputEl = this.querySelector('[data-tsf-quote-card-pct-input]');
      this.#discountInputEl = this.querySelector('[data-tsf-quote-discount-input]');
      this.#totalDiscountEl = this.querySelector('[data-tsf-quote-total-discount]');
      this.#totalDiscountRowEl = this.querySelector('[data-tsf-quote-total-discount-row]');
      this.#freightOriginalRowEl = this.querySelector('[data-tsf-quote-freight-original]');
      this.#freightOriginalValueEl = this.querySelector('[data-tsf-quote-freight-orig-value]');
      this.#freightOriginalLabelEl = this.querySelector('[data-tsf-quote-freight-orig-label]');
      // Photo dialog
      this.#photoDialogEl = this.querySelector('[data-tsf-photo-dialog]');
      this.#photoGridEl = this.querySelector('[data-tsf-photo-grid]');
      this.#photoDialogTitleEl = this.querySelector('[data-tsf-photo-dialog-product]');

      // Listeners
      this.#markupInput?.addEventListener('input', () => this.#onMarkupChange(), { signal });
      // PARITY-C · attach em TODOS os botões com esse data-attr (inclui header admin FORA do web component)
      document.querySelectorAll('[data-tsf-quote-print]').forEach(btn =>
        btn.addEventListener('click', () => this.#openPrintWindow(), { signal }));
      document.querySelectorAll('[data-tsf-quote-to-pedido]').forEach(btn =>
        btn.addEventListener('click', () => this.#openPedidoFromQuote(), { signal }));
      document.querySelectorAll('[data-tsf-quote-add-product]').forEach(btn =>
        btn.addEventListener('click', () => this.#openProductPicker(), { signal }));
      document.querySelectorAll('[data-tsf-quote-delete]').forEach(btn =>
        btn.addEventListener('click', () => this.#deleteQuote(), { signal }));
      this.querySelector('[data-tsf-quote-save-back]')?.addEventListener('click', () => this.#saveAndBack(), { signal });

      // Onda 8.5 · MANUAL SAVE · botões Salvar + Descartar
      // QA · no admin esses botões ficam no HEADER da página (fora de <tsf-quote-builder>) → busca document-wide
      document.querySelector('[data-tsf-quote-save]')?.addEventListener('click', () => this.#commitSave(), { signal });
      document.querySelector('[data-tsf-quote-discard]')?.addEventListener('click', () => this.#discardChanges(), { signal });
      // QA · Salvar cliente · save DEDICADO (sincroniza o cadastro no Shopify) · botão dentro da seção cliente
      this.querySelector('[data-tsf-quote-client-save]')?.addEventListener('click', () => this.#commitClient(), { signal });
      // 05-08 · A PONTE no orçamento: aplica o código da conversa e credita o anúncio.
      // Mesma rota da venda (/sale/claim-code) — ela grava no CLIENTE, não na venda,
      // então o crédito viaja sozinho pro fechamento dias depois.
      this.querySelectorAll('[data-tsf-quote-ponte-aplicar]').forEach((b) => {
        b.addEventListener('click', () => this.#aplicarPonte(b), { signal });
      });
      // 2026-06-25 · "Trocar cliente" no orçamento (paridade com a venda) · abre o MESMO picker e re-vincula via tsf:client-linked
      this.querySelector('[data-tsf-quote-client-swap]')?.addEventListener('click', () => {
        if (typeof TsfClientPicker !== 'undefined' && TsfClientPicker?.open) {
          TsfClientPicker.open({
            title: 'Trocar cliente',
            subtitle: 'Busque outro cadastro · ou cadastre na hora',
            specifierId: this.#ctx?.customer_id || null,
            onSelect: (client) => this.dispatchEvent(new CustomEvent('tsf:client-linked', { detail: { client }, bubbles: true })),
          });
        }
      }, { signal });
      // Onda 8.5 · Beforeunload guard · avisa se sair com mudanças não salvas
      window.addEventListener('beforeunload', (e) => {
        if (this.#countPendingChanges() > 0) {
          e.preventDefault();
          e.returnValue = 'Você tem alterações não salvas. Deseja sair mesmo assim?';
          return e.returnValue;
        }
      }, { signal });

      // Onda 8.5 · Toggle "Endereço fiscal diferente"
      this.querySelector('[data-tsf-client-fiscal-toggle]')?.addEventListener('change', (e) => {
        const checked = e.target.checked;
        const fields = this.querySelector('[data-tsf-client-fiscal-fields]');
        if (fields) {
          if (checked) fields.removeAttribute('hidden');
          else fields.setAttribute('hidden', '');
        }
        // Onda 8.5 · Marca dirty com flag explícita
        this.#updateClientInfo({ has_endereco_fiscal: checked });
      }, { signal });

      // Onda 8 · Empty state acionável · search button + chips abrem o picker.
      // UNIFIED-4 · <tsf-inline-client> no empty state · vincula cliente sem sair da página
      // Recebe evento tsf:client-linked com detail.client = {id, nome, ...}
      this.addEventListener('tsf:client-linked', async (ev) => {
        const c = ev.detail?.client;
        if (!c?.id) return;
        // Atualiza quote.client_info + customer_id e persiste via #save
        const addr = c.endereco || {};
        const clientInfoPatch = {
          name: c.nome,
          // tipo SEMPRE derivado do documento (CNPJ 14 díg = empresa, senão pessoa física).
          // Não confia em c.tipo: a tag b2b/b2c do Shopify pode contradizer o documento
          // (ex.: pessoa física com CPF mas marcada b2b → causava "FALTAM: CNPJ" no salvar).
          tipo: ((c.cnpj || '').replace(/\D/g, '').length === 14) ? 'b2b' : 'b2c',
          email: c.email,
          whatsapp: c.whatsapp,
          cpf: c.cpf,
          cnpj: c.cnpj,
          ie: c.ie,
          im: c.im,
          cep: addr.cep,
          address: {
            logradouro: addr.logradouro,
            numero: addr.numero,
            complemento: addr.complemento,
            bairro: addr.bairro,
            localidade: addr.cidade || addr.localidade,
            cidade: addr.cidade || addr.localidade,
            uf: addr.uf,
          },
        };
        // Mutate quote em memória
        if (this.#quote) {
          this.#quote.customer_id = c.id;
          this.#quote.customer_snapshot = c;
          this.#quote.client_info = { ...(this.#quote.client_info || {}), ...clientInfoPatch };
        }
        // 2026-06-29 · ENFILEIRA (não grava na hora) · paridade c/ a venda + modelo MANUAL:
        //   trocar/vincular cliente vira "alteração pendente" e só persiste quando o usuário clica em Salvar.
        //   (antes era #save = gravava imediato, fora do controle do Salvar — o founder pegou isso 29-06.)
        //   Se trocar só pra conferir e sair sem salvar, volta o cliente original.
        this.#queueSave({
          customer_id: c.id,
          customer_snapshot: c,
          // manda o client_info JÁ MESCLADO (l.916) — não o patch parcial — pra não
          //   dropar freight_mode/card_surcharge_pct/authority_blocks no PATCH do backend.
          client_info: this.#quote.client_info,
        });
        // 2026-06-25 · refresca o form do cliente após vincular/trocar
        try { this.#hydrateClientCard(); } catch (_e) {}
      }, { signal });

      // Permite adicionar produto sem sair da página (substitui o link pra /collections/all).
      this.querySelector('[data-tsf-quote-empty-search]')?.addEventListener('click', () => this.#openProductPicker(), { signal });
      this.querySelectorAll('[data-tsf-quote-empty-chip]').forEach(btn => {
        btn.addEventListener('click', () => {
          const term = btn.getAttribute('data-tsf-quote-empty-chip') || '';
          this.#openProductPicker();
          // Preenche query e dispara search · espera próximo frame pro picker hidratar
          requestAnimationFrame(() => {
            if (this.#pickerInputEl) {
              this.#pickerInputEl.value = term;
              this.#runPickerSearch(term);
            }
          });
        }, { signal });
      });

      // Atalho ⌘K (Mac) / Ctrl+K (Win) abre o picker em qualquer lugar da página
      document.addEventListener('keydown', (e) => {
        const isMeta = e.metaKey || e.ctrlKey;
        if (isMeta && e.key.toLowerCase() === 'k') {
          e.preventDefault();
          this.#openProductPicker();
        }
      }, { signal });

      // Autoridade · toggle + checkboxes (Onda 4 PDF Premium)
      this.querySelector('[data-tsf-authority-toggle]')?.addEventListener('click', () => this.#toggleAuthority(), { signal });
      this.querySelectorAll('[data-tsf-authority-check]').forEach(cb => {
        cb.addEventListener('change', () => this.#onAuthorityChange(cb), { signal });
      });

      // Client card toggle
      this.#clientToggleEl?.addEventListener('click', () => this.#toggleClientBody(), { signal });
      // Onda 8.4 · Tipo agora é derivado do documento (não tem mais toggle manual)

      // Card surcharge · só input do percentual
      this.#cardPctInputEl?.addEventListener('input', () => this.#onCardPctChange(), { signal });
      this.#discountInputEl?.addEventListener('input', () => this.#onDiscountChange(), { signal });

      // FREIGHT-TOGGLE · checkbox simples · ON=charge, OFF=none
      this.querySelector('[data-tsf-freight-toggle]')?.addEventListener('change', (ev) => {
        this.#onFreightModeChange(ev.target.checked ? 'charge' : 'none');
      }, { signal });

      // Client inputs (debounced save)
      this.#clientCardEl?.addEventListener('input', (e) => {
        const input = e.target.closest?.('[data-tsf-client-input]');
        if (input) this.#onClientInputChange(input);
      }, { signal });

      // Event delegation pras ações de cada item
      this.#rowsEl?.addEventListener('click', (e) => {
        const removeBtn = e.target.closest?.('[data-tsf-quote-remove]');
        if (removeBtn) {
          this.#onRemove(removeBtn.getAttribute('data-tsf-quote-remove'));
          return;
        }
        const photoBtn = e.target.closest?.('[data-tsf-photo-trigger]');
        if (photoBtn) {
          e.preventDefault();
          this.#openPhotoDialog(photoBtn.getAttribute('data-tsf-photo-trigger'));
          return;
        }
        const resetBtn = e.target.closest?.('[data-tsf-quote-markup-reset]');
        if (resetBtn) {
          e.preventDefault();
          this.#resetMarkupToNative(resetBtn.getAttribute('data-tsf-quote-markup-reset'));
          return;
        }
        const vipexReset = e.target.closest?.('[data-tsf-quote-vipex-reset]');
        if (vipexReset) {
          e.preventDefault();
          this.#resetVipexToNative(vipexReset.getAttribute('data-tsf-quote-vipex-reset'));
          return;
        }
        // Reset genérico pra qualquer spec editável (cor, materiais, dimens_es, prazo)
        const specReset = e.target.closest?.('[data-tsf-quote-spec-reset]');
        if (specReset) {
          e.preventDefault();
          this.#resetSpecToNative(specReset.getAttribute('data-uid'), specReset.getAttribute('data-tsf-quote-spec-reset'));
          return;
        }
        // Reset pra custo unitário
        const costReset = e.target.closest?.('[data-tsf-quote-cost-reset]');
        if (costReset) {
          e.preventDefault();
          this.#resetCostToNative(costReset.getAttribute('data-tsf-quote-cost-reset'));
        }
      }, { signal });

      this.#rowsEl?.addEventListener('input', (e) => {
        const qtyInput = e.target.closest?.('[data-tsf-quote-qty-input]');
        if (qtyInput) {
          this.#onQtyChange(qtyInput);
          return;
        }
        const editInput = e.target.closest?.('[data-tsf-quote-edit]');
        if (editInput) this.#onInlineEdit(editInput);
      }, { signal });

      // F3 · frete avulso/negociado · #freightBlockEl é estável (o body re-renderiza dentro dele)
      this.#freightBlockEl?.addEventListener('input', (e) => {
        const f = e.target.closest?.('[data-tsf-quote-freight-edit]');
        if (f) this.#onFreightEdit(f);
      }, { signal });
      this.#freightBlockEl?.addEventListener('change', (e) => {
        const f = e.target.closest?.('[data-tsf-quote-freight-edit]');
        if (f) this.#refreshFreightField();
      }, { signal });
      this.#freightBlockEl?.addEventListener('click', (e) => {
        const r = e.target.closest?.('[data-tsf-quote-freight-reset]');
        if (r) { e.preventDefault(); this.#resetFreightToNative(); }
      }, { signal });

      // <select> dispara 'change' não 'input' · após mudar, re-renderiza row pra
      // atualizar o badge de estado (nativo → editado) imediatamente sem precisar
      // do user clicar em outro campo.
      this.#rowsEl?.addEventListener('change', (e) => {
        const editInput = e.target.closest?.('[data-tsf-quote-edit]');
        if (editInput && editInput.tagName === 'SELECT') {
          this.#onInlineEdit(editInput);
          this.#refreshRow(editInput.getAttribute('data-uid'));
        }
      }, { signal });

      // Re-render row no blur de QUALQUER input editável · atualiza badges 3-state
      // (cost_centavos, markup_pct, cor, materiais, dimens_es, prazo)
      // Pra <select> isso é tratado no listener 'change' acima.
      this.#rowsEl?.addEventListener('blur', (e) => {
        const editInput = e.target.closest?.('[data-tsf-quote-edit]');
        if (editInput && editInput.tagName !== 'SELECT') {
          this.#refreshRow(editInput.getAttribute('data-uid'));
        }
      }, { signal, capture: true });

      // Photo dialog listeners
      this.#photoDialogEl?.addEventListener('click', (e) => {
        if (e.target.closest?.('[data-tsf-photo-close]') || e.target === this.#photoDialogEl) {
          this.#closePhotoDialog();
          return;
        }
        // Delete (precisa vir ANTES do pick · está dentro do slot)
        const del = e.target.closest?.('[data-tsf-photo-delete]');
        if (del) {
          e.stopPropagation();
          this.#deleteCustomPhoto(del.getAttribute('data-tsf-photo-delete'), del.closest('.tsf-quote-photo-dialog__slot'));
          return;
        }
        const pick = e.target.closest?.('[data-tsf-photo-pick]');
        if (pick) this.#pickPhoto(pick.getAttribute('data-tsf-photo-pick'));
      }, { signal });
      this.#photoDialogEl?.addEventListener('cancel', (e) => {
        e.preventDefault();
        this.#closePhotoDialog();
      }, { signal });

      // Upload de foto custom · trigger abre file picker; input change → upload
      this.querySelector('[data-tsf-photo-upload-trigger]')?.addEventListener('click', () => {
        this.querySelector('[data-tsf-photo-upload-input]')?.click();
      }, { signal });
      this.querySelector('[data-tsf-photo-upload-input]')?.addEventListener('change', (e) => {
        const file = e.target.files?.[0];
        if (file) this.#uploadCustomPhoto(file);
        // limpa input pra permitir mesmo arquivo de novo
        e.target.value = '';
      }, { signal });

      // Atualiza date no header
      if (this.#dateEl) {
        const now = new Date();
        const fmt = new Intl.DateTimeFormat('pt-BR', { day: '2-digit', month: 'long', year: 'numeric' });
        this.#dateEl.textContent = fmt.format(now);
      }

      await this.#fetchQuote();
    }

    disconnectedCallback() {
      this.#abortController?.abort();
    }

    async #fetchQuote() {
      let phase = 'fetch';
      try {
        // Se a URL tem ?id=X, abre a quote específica (admin abre histórico).
        // Caso contrário:
        //   - Admin (toth_internal): UI-FIX 1 · POST /quote/create sempre cria nova quote
        //   - Specifica: GET /quote/mine retorna draft único per-specifier (legacy behavior)
        const urlParams = new URLSearchParams(window.location.search);
        const quoteId = urlParams.get('id');
        let res;
        if (quoteId) {
          res = await fetch(`${QUOTE_ENDPOINT}/get?id=${encodeURIComponent(quoteId)}`);
        } else if (this.#kind === 'toth_internal') {
          // Admin · sempre cria NOVA quote (evita "continuar antigo")
          res = await fetch(`${QUOTE_ENDPOINT}/create`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              specifier_customer_id: this.#ctx.customer_id,
              specifier_email: this.#ctx.email || null,
              quote_kind: this.#kind,
            }),
          });
        } else {
          res = await fetch(`${QUOTE_ENDPOINT}/mine?specifier_customer_id=${this.#ctx.customer_id}&quote_kind=${this.#kind}`);
        }
        phase = 'json-parse';
        const data = await res.json();
        phase = 'response-validate';
        if (!data.ok) {
          // /get retorna 404 quando a quote não existe · UX informativa
          if (quoteId && data.error === 'not_found') {
            throw new Error(`Orçamento não encontrado (id=${quoteId.slice(0,8)}…). Pode ter sido apagado.`);
          }
          throw new Error(data.error || 'response not ok');
        }
        this.#quote = data.quote;
        // UI-FIX 1 · Admin sem ?id na URL: atualiza URL pra ?id={new} sem reload
        // Permite refresh + share + back/forward funcionar corretamente
        if (!quoteId && this.#kind === 'toth_internal' && this.#quote?.id) {
          try {
            const newUrl = `${window.location.pathname}?id=${this.#quote.id}`;
            window.history.replaceState({}, '', newUrl);
          } catch (_) { /* non-fatal */ }
        }
        // Onda 6.13A · Check sale vinculada · best-effort (não bloqueia render)
        phase = 'linked-sale-fetch';
        try { await this.#fetchLinkedSale(); }
        catch (e) { console.warn('[tsf-quote] linkedSale fetch failed (non-fatal):', e); }
        // Onda 10.9 · Backfill cost_centavos pra items legados (added pre-v51)
        phase = 'backfill-cost';
        try { await this.#backfillMissingCosts(); }
        catch (e) { console.warn('[tsf-quote] backfill cost failed (non-fatal):', e); }
        phase = 'render';
        this.#render();
      } catch (err) {
        console.error('[tsf-quote] failed at phase=' + phase, err);
        const detail = (err && err.message) ? err.message : String(err);
        this.#renderError(`Falha ao carregar orçamento (${phase}): ${detail}. Recarregue a página ou abra DevTools (F12) e copia o stack pro time Toth.`);
      }
    }

    // Onda 6.13A · Busca venda vinculada ao quote atual (idempotência visual).
    // Se existe, render mostra banner topo + transforma botão "Converter em venda"
    // em "Ver venda VND-XXXX". Sem isso, vendor podia clicar e ver o wizard
    // mesmo após conversão (UX inconsistente vs ribbon do card na lista).
    async #fetchLinkedSale() {
      this.#linkedSale = null;
      if (!this.#quote?.id) return;
      const url = `${SALE_ENDPOINT}/list?specifier_customer_id=${this.#ctx.customer_id}&scope=all`;
      const res = await fetch(url);
      if (!res.ok) return;
      const data = await res.json();
      if (!data.ok) return;
      const sale = (data.sales || []).find(s => s.quote_id === this.#quote.id);
      this.#linkedSale = sale || null;
    }

    // Onda 10.9 · Backfill automático · items adicionados antes do Edge Function v51
    // (que não retornava cost_centavos) ficavam sem dado nativo de custo. Aqui detectamos
    // esses items e refazemos product-snapshot pra completar · uma única vez por load.
    async #backfillMissingCosts() {
      if (!this.#quote?.items?.length || !this.#quote?.id) return;
      const itemsMissingCost = this.#quote.items.filter(it => {
        const snap = it.snapshot || {};
        const hasHandle = !!(snap.handle || it.product_handle);
        const missingCost = typeof snap.cost_centavos !== 'number' || snap.cost_centavos <= 0;
        return hasHandle && missingCost;
      });
      if (!itemsMissingCost.length) return;
      try {
        const results = await Promise.allSettled(
          itemsMissingCost.map(it => {
            const handle = it.snapshot?.handle || it.product_handle;
            return fetch(`${QUOTE_ENDPOINT}/product-snapshot?handle=${encodeURIComponent(handle)}`)
              .then(r => r.json()).then(d => ({ uid: it.uid, data: d }));
          })
        );
        let updated = false;
        for (const r of results) {
          if (r.status !== 'fulfilled' || !r.value?.data?.ok) continue;
          const { uid, data } = r.value;
          const fresh = data.item?.snapshot;
          if (typeof fresh?.cost_centavos !== 'number' || fresh.cost_centavos <= 0) continue;
          const item = this.#quote.items.find(x => x.uid === uid);
          if (!item) continue;
          // Merge SÓ o cost_centavos · preserva overrides + edições manuais do vendor
          item.snapshot = { ...(item.snapshot || {}), cost_centavos: fresh.cost_centavos };
          updated = true;
        }
        if (updated) {
          // Save silencioso · não dispara UX de save (não é edição do user)
          // Mesmo body shape de #save() · endpoint identifica quote por specifier+kind
          await fetch(`${QUOTE_ENDPOINT}/update`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              specifier_customer_id: this.#ctx.customer_id,
              quote_kind: this.#kind,
              quote_id: this.#quote?.id,
              patch: { items: this.#quote.items },
            }),
          }).catch(() => {});
        }
      } catch (err) {
        console.warn('[tsf-quote] backfill cost failed', err);
      }
    }

    #render() {
      this.#loadingEl?.setAttribute('hidden', '');
      // PARITY-B · Hidrata header admin (title TOTH-ORC-XXXX + byline + actions)
      this.#hydrateAdminHeader();
      if (!this.#quote || !this.#quote.items?.length) {
        this.#emptyEl?.removeAttribute('hidden');
        this.#toolbarEl?.setAttribute('hidden', '');
        this.#clientCardEl?.setAttribute('hidden', '');
        this.#freightBlockEl?.setAttribute('hidden', '');
        this.#rowsEl?.setAttribute('hidden', '');
        this.#totalBlockEl?.setAttribute('hidden', '');
        if (this.#statusEl) this.#statusEl.textContent = 'Rascunho';
        return;
      }
      this.#emptyEl?.setAttribute('hidden', '');
      this.#toolbarEl?.removeAttribute('hidden');
      this.#clientCardEl?.removeAttribute('hidden');
      this.querySelector('[data-tsf-quote-ponte]')?.removeAttribute('hidden');
      this.querySelector('[data-tsf-quote-authority]')?.removeAttribute('hidden');
      this.#freightBlockEl?.removeAttribute('hidden');
      this.#rowsEl?.removeAttribute('hidden');
      this.#totalBlockEl?.removeAttribute('hidden');

      const n = this.#quote.items.length;
      if (this.#statusEl) this.#statusEl.textContent = `${n} ${n > 1 ? 'produtos' : 'produto'}`;

      // Cada step com try/catch · não bloqueia render dos demais se um falhar
      const safe = (name, fn) => { try { fn(); } catch (e) { console.error('[tsf-quote] '+name+' failed:', e); } };

      safe('markup-slider-init', () => {
        if (this.#markupInput && this.#quote.default_markup_pct != null) {
          this.#markupInput.value = String(this.#quote.default_markup_pct);
          if (this.#markupOutput) this.#markupOutput.textContent = this.#fmtMarkupOutput(this.#quote.default_markup_pct);
        }
        this.#updateSliderGradient();
      });

      safe('hydrate-client-card', () => this.#hydrateClientCard());
      safe('hydrate-card-surcharge', () => this.#hydrateCardSurcharge());
      safe('hydrate-discount', () => this.#hydrateDiscount());
      safe('hydrate-freight-mode', () => this.#hydrateFreightMode());
      safe('hydrate-authority', () => this.#hydrateAuthority());
      safe('render-rows', () => this.#renderRows());
      safe('update-totals', () => this.#updateTotals());
      // Onda 6.13A · Mostra banner "Já virou venda" + transforma botão
      safe('linked-sale-indicator', () => this.#renderLinkedSaleIndicator());

      // Se já tem CEP válido, calcula frete (async, fire-and-forget)
      const cep = (this.#quote.client_info?.cep || '').replace(/\D/g, '');
      if (cep.length === 8) {
        this.#calculateFreight(cep).catch(e => console.error('[tsf-quote] freight failed:', e));
      } else {
        safe('freight-placeholder', () => this.#renderFreightPlaceholder());
      }
    }

    #updateSliderGradient() {
      // 2026-06-29 · delega pro helper compartilhado (a venda pinta com o MESMO)
      tsfPaintSliderGradient(this.#markupInput);
    }

    // ── Helpers de markup (modo specifica vs toth_internal) ────────
    #isTothMode() { return this.#kind === 'toth_internal'; }

    #fmtMarkupOutput(pctVal) {
      if (this.#isTothMode()) {
        const mult = (1 + (pctVal / 100));
        return `${mult.toFixed(2).replace('.', ',')}x`;
      }
      return `+${pctVal}%`;
    }

    #parseCurrency(input) {
      // Aceita "R$ 1.234,56" ou "1234,56" ou "1234.56"
      const cleaned = String(input).replace(/[^\d,.-]/g, '').replace(/\.(?=\d{3}(\D|$))/g, '').replace(',', '.');
      const n = parseFloat(cleaned);
      return isNaN(n) ? 0 : Math.round(n * 100);
    }

    #parseMultiplier(input) {
      // Aceita "1,85" / "1.85" / "1,85x" → retorna pct (1.85 → 85)
      const cleaned = String(input).replace(/[^\d,.]/g, '').replace(',', '.');
      const n = parseFloat(cleaned);
      if (isNaN(n)) return 0;
      // Se < 10, interpreta como multiplicador (1.85 = 85%). Se ≥ 10, como % direto (185 = 185%).
      const pct = n < 10 ? (n - 1) * 100 : n;
      return Math.max(0, Math.min(999, parseFloat(pct.toFixed(2))));
    }

    #renderRows() {
      const pct = parseFloat(this.#markupInput?.value || this.#quote.default_markup_pct || 0);
      const items = this.#quote.items.slice().sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
      this.#rowsEl.innerHTML = items.map((item, idx) => this.#rowHtml(item, pct, idx + 1)).join('');
    }

    #rowHtml(item, pct, index) {
      const s = item.snapshot || {};
      const m = s.metafields || {};
      const ov = item.overrides || {};
      const isToth = this.#isTothMode();

      // Cost: em modo toth, prioridade:
      //   1) override manual (overrides.cost_centavos)
      //   2) custo REAL buscado do Shopify Admin API (snapshot.cost_centavos)
      //   3) preço de venda público (snapshot.price_centavos) — fallback p/ itens antigos
      const tothUnit =
        (typeof ov.cost_centavos === 'number') ? ov.cost_centavos :
        (typeof s.cost_centavos === 'number' && s.cost_centavos > 0) ? s.cost_centavos :
        (s.price_centavos || 0);

      // Markup nativo do item = razão preço de venda / custo (apenas modo toth_internal).
      // Ex.: Banqueta Monic custo R$ 1.038,41, preço venda R$ 2.180,66 → 109,99% → 2,10x
      let nativeMarkupPct = null;
      if (isToth && s.price_centavos && s.cost_centavos && s.cost_centavos > 0) {
        nativeMarkupPct = ((s.price_centavos - s.cost_centavos) / s.cost_centavos) * 100;
        nativeMarkupPct = Math.round(nativeMarkupPct * 100) / 100; // 2 casas
      }

      // 3-state resolution do markup:
      //   - source='manual' (override individual): usa item.markup_pct
      //   - source='global': usa pct (vem do slider global)
      //   - default (source=null): usa nativeMarkupPct se disponível, senão pct
      const markupSource = ov.markup_source || (item.markup_pct != null ? 'manual' : null);
      let useMarkup;
      if (markupSource === 'manual') {
        useMarkup = item.markup_pct;
      } else if (markupSource === 'global') {
        useMarkup = pct;
      } else if (isToth && nativeMarkupPct != null) {
        useMarkup = nativeMarkupPct;
      } else {
        useMarkup = (item.markup_pct != null) ? item.markup_pct : pct;
      }

      const tothTotal = tothUnit * (item.qty || 1);
      const clienteUnit = tothUnit * (1 + useMarkup / 100);
      const clienteTotal = clienteUnit * (item.qty || 1);
      const photoUrl = item.selected_photo_url || s.image_url || '';
      const productUrl = s.url || (s.handle ? `/products/${s.handle}` : '#');

      // Resolve specs com fallback pra override (toth pode editar tudo)
      const cor = (ov.cor != null) ? ov.cor : (m.cor || '');
      const materiais = (ov.materiais != null) ? ov.materiais : (m.materiais || '');
      const dimens_es = (ov.dimens_es != null) ? ov.dimens_es : (m.dimens_es || '');
      const prazoProducao = (ov.prazo != null) ? ov.prazo : (m.prazo || 0);
      const prazoTotal = prazoProducao > 0 ? Number(prazoProducao) + 14 : 0;

      // Vipex Origem: 3-state (igual ao markup)
      // - nativo: valor do metafield/fornecedor
      // - editado: vendor mudou via dropdown
      // - vazio:  produto não tem nem metafield nem fornecedor
      const vipexNative = m.vipex_origem || s.fornecedor?.vipex_origem || null;
      const vipexOverride = (ov.vipex_origem != null) ? ov.vipex_origem : null;
      let vipexOrigem, vipexSource;
      if (vipexOverride != null) {
        vipexOrigem = vipexOverride;
        vipexSource = 'edited';
      } else if (vipexNative) {
        vipexOrigem = vipexNative;
        vipexSource = 'native';
      } else {
        vipexOrigem = '';
        vipexSource = 'empty';
      }

      // Helper: resolve 3-state source pra um spec
      //   native = sem override, com valor no metafield
      //   edited = override existe (e diff do nativo)
      //   empty  = sem override e sem valor nativo
      const specSource = (key) => {
        const nativeVal = m[key];
        const overVal = ov[key];
        const hasNative = nativeVal != null && String(nativeVal) !== '';
        const hasOverride = overVal != null && String(overVal) !== '';
        if (hasOverride && String(overVal) !== String(nativeVal ?? '')) return 'edited';
        if (hasNative) return 'native';
        return 'empty';
      };

      // Modo SPECIFICA: specs read-only · modo TOTH: specs editáveis inline
      const vipexOptions = [
        { value: 'SP-INT3', label: 'SP-INT3 · São Paulo interior' },
        { value: 'SC-INT', label: 'SC-INT · Santa Catarina interior' },
        { value: 'RS-CAP', label: 'RS-CAP · Rio Grande do Sul capital' },
        { value: 'RS-INT1', label: 'RS-INT1 · Rio Grande do Sul interior' },
      ];
      const specsHtml = isToth ? `
        <dl class="tsf-quote-item__specs tsf-quote-item__specs--editable">
          ${this.#editableSpecHtml('Acabamento', 'cor', cor, item.uid, specSource('cor'), m.cor)}
          ${this.#editableSpecHtml('Materiais', 'materiais', materiais, item.uid, specSource('materiais'), m.materiais, true)}
          ${this.#editableSpecHtml('Dimensões', 'dimens_es', dimens_es, item.uid, specSource('dimens_es'), m.dimens_es, true)}
          ${this.#editableSpecHtml('Prazo (dias)', 'prazo', prazoProducao || '', item.uid, specSource('prazo'), m.prazo, false, 'number')}
          ${this.#editableSelectHtml('Origem Vipex', 'vipex_origem', vipexOrigem, vipexOptions, item.uid, vipexSource, vipexNative)}
        </dl>
      ` : `
        <dl class="tsf-quote-item__specs">
          ${[
            { label: 'Acabamento', value: cor },
            { label: 'Materiais', value: materiais },
            { label: 'Dimensões', value: dimens_es },
            { label: 'Prazo', value: prazoTotal > 0 ? `${prazoTotal} dias úteis` : null },
          ].filter(sp => sp.value).map(sp => `
            <div class="tsf-quote-item__spec">
              <dt>${this.#esc(sp.label)}</dt>
              <dd>${this.#esc(sp.value)}</dd>
            </div>
          `).join('')}
        </dl>
      `;

      // Modo TOTH: cost editável + markup individual + título editável
      const titleHtml = isToth
        ? `<input type="text" class="tsf-quote-item__title-input"
                  value="${this.#esc(s.title || '')}"
                  data-tsf-quote-edit="title" data-uid="${item.uid}"
                  aria-label="Título do produto">`
        : `<a href="${productUrl}" target="_blank" rel="noopener">${this.#esc(s.title || '')}</a>`;

      const pricingHtml = isToth ? this.#tothPricingHtml(item, tothUnit, useMarkup, clienteUnit, clienteTotal, nativeMarkupPct, markupSource, pct) : `
        <div class="tsf-quote-item__pricing">
          <div class="tsf-quote-item__cost tsf-print-hide">
            <span class="tsf-quote-item__cost-label">Toth · custo unitário</span>
            <span class="tsf-quote-item__cost-value">${money(tothUnit)}</span>
            ${useMarkup > 0 ? `<span class="tsf-quote-item__cost-markup">+${useMarkup}% markup</span>` : '<span class="tsf-quote-item__cost-markup tsf-quote-item__cost-markup--zero">sem markup</span>'}
          </div>
          <div class="tsf-quote-item__client">
            <span class="tsf-quote-item__client-label">Valor cliente</span>
            <span class="tsf-quote-item__client-value" data-tsf-quote-row-total>${money(clienteTotal)}</span>
            <span class="tsf-quote-item__client-meta">${item.qty || 1} × ${money(clienteUnit)}</span>
          </div>
        </div>
      `;

      return `
        <li class="tsf-quote-item${isToth ? ' tsf-quote-item--toth' : ''}" data-tsf-quote-row="${item.uid}" data-tsf-fab="${this.#esc(s.vendor || s.fornecedor?.nome || '')}">
          <span class="tsf-quote-item__index" aria-hidden="true">${String(index).padStart(2, '0')}</span>

          <figure class="tsf-quote-item__media">
            <button type="button" class="tsf-quote-item__photo-btn tsf-print-hide"
                    data-tsf-photo-trigger="${item.uid}"
                    aria-label="Trocar foto principal">
              <img src="${photoUrl}" alt="${this.#esc(s.title || '')}" loading="lazy" width="200" height="200">
              <span class="tsf-quote-item__photo-overlay" aria-hidden="true">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                  <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
                  <circle cx="8.5" cy="8.5" r="1.5"/>
                  <polyline points="21 15 16 10 5 21"/>
                </svg>
                <span>Trocar foto</span>
              </span>
            </button>
            <a class="tsf-quote-item__photo-print" href="${productUrl}" target="_blank" rel="noopener" aria-hidden="true">
              <img src="${photoUrl}" alt="" loading="lazy" width="200" height="200">
            </a>
          </figure>

          <div class="tsf-quote-item__body">
            <header class="tsf-quote-item__header">
              <h3 class="tsf-quote-item__title">${titleHtml}</h3>
              <button type="button" class="tsf-quote-item__remove tsf-print-hide"
                      data-tsf-quote-remove="${item.uid}"
                      aria-label="Remover do orçamento">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                  <path d="M3 6h18"/><path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/>
                </svg>
              </button>
            </header>

            ${specsHtml}

            <footer class="tsf-quote-item__footer">
              <div class="tsf-quote-item__qty">
                <label class="tsf-quote-item__qty-label" for="qty-${item.uid}">Quantidade</label>
                <input type="number" id="qty-${item.uid}"
                       class="tsf-quote-item__qty-input"
                       min="1" max="9999" step="1"
                       value="${item.qty || 1}"
                       data-tsf-quote-qty-input="${item.uid}"
                       aria-label="Quantidade">
              </div>
              ${pricingHtml}
            </footer>
          </div>
        </li>
      `;
    }

    #editableSpecHtml(label, key, value, uid, source, nativeValue, multiline = false, type = 'text') {
      // 2026-06-28 · delega pro helper compartilhado (de-dup · paridade c/ a venda)
      return tsfEditableSpecHtml(label, key, value, uid, source, nativeValue, multiline, type,
        { editAttr: 'data-tsf-quote-edit', resetAttr: 'data-tsf-quote-spec-reset' });
    }

    #editableSelectHtml(label, key, value, options, uid, source, nativeValue) {
      // 2026-06-28 · delega pro helper compartilhado (de-dup · paridade c/ a venda)
      return tsfEditableSelectHtml(label, key, value, options, uid, source, nativeValue,
        { editAttr: 'data-tsf-quote-edit', resetAttrs: (u) => `data-tsf-quote-vipex-reset="${u}"` });
    }

    #tothPricingHtml(item, tothUnit, useMarkup, clienteUnit, clienteTotal, nativeMarkupPct, markupSource, globalPct) {
      // 2026-06-29 · delega pro helper compartilhado (de-dup · Item 6: guarda do reset agora = a da venda)
      return tsfTothPricingHtml(item, tothUnit, useMarkup, clienteUnit, clienteTotal, nativeMarkupPct, markupSource, globalPct, item.uid,
        { editAttr: 'data-tsf-quote-edit', markupField: 'markup_pct',
          markupReset: (u) => `data-tsf-quote-markup-reset="${u}"`,
          costReset: (u) => `data-tsf-quote-cost-reset="${u}"`,
          rowTotalAttr: 'data-tsf-quote-row-total' });
    }

    #updateTotals() {
      const pct = parseFloat(this.#markupInput?.value || this.#quote.default_markup_pct || 0);
      const isToth = this.#isTothMode();
      let totalToth = 0;
      let totalProdutos = 0;
      for (const item of this.#quote.items) {
        const ov = item.overrides || {};
        const s = item.snapshot || {};

        // Cost unitário usa cascade override → cost_centavos → price_centavos
        const unitCost =
          (typeof ov.cost_centavos === 'number') ? ov.cost_centavos :
          (typeof s.cost_centavos === 'number' && s.cost_centavos > 0) ? s.cost_centavos :
          (s.price_centavos || 0);

        // Markup resolution igual ao #rowHtml (3-state):
        let nativeMarkupPct = null;
        if (isToth && s.price_centavos && s.cost_centavos && s.cost_centavos > 0) {
          nativeMarkupPct = ((s.price_centavos - s.cost_centavos) / s.cost_centavos) * 100;
        }
        const markupSource = ov.markup_source || (item.markup_pct != null ? 'manual' : null);
        let useMarkup;
        if (markupSource === 'manual') useMarkup = item.markup_pct;
        else if (markupSource === 'global') useMarkup = pct;
        else if (isToth && nativeMarkupPct != null) useMarkup = nativeMarkupPct;
        else useMarkup = (item.markup_pct != null) ? item.markup_pct : pct;

        const toth = unitCost * (item.qty || 1);
        totalToth += toth;
        totalProdutos += toth * (1 + useMarkup / 100);
      }
      // Frete: gross-up SEMPRE aplicado (taxa cartão embutida no orçamento).
      // Fórmula: frete_ajustado = frete / (1 - pct/100). Vendor vê os 2 valores;
      // cliente final no PDF vê só o ajustado. Pix dá 8% off em tudo.
      // F3 (2026-06-23) · frete = quote.frete_centavos (auto OU avulso/negociado persistido) = bate com a lista;
      //   cai pro #freightTotal efêmero só enquanto ainda não há valor persistido.
      const freightOriginal = (typeof this.#quote?.frete_centavos === 'number') ? this.#quote.frete_centavos : (this.#freightTotal || 0);
      const ci = this.#quote?.client_info || {};
      const cardPct = parseFloat(ci.card_surcharge_pct) || 0;
      const denom = 1 - cardPct / 100;
      const freightAdjusted = (freightOriginal > 0 && cardPct > 0 && denom > 0)
        ? (freightOriginal / denom)
        : freightOriginal;

      // FREIGHT-TOGGLE · 'charge' (default · soma no total) ou 'none' (não soma · linha some)
      const freightEnabled = ((ci.freight_mode || 'charge').toString().toLowerCase() !== 'none');
      const freightInTotal = freightEnabled ? freightAdjusted : 0;
      const descontoQ = Math.max(0, parseInt(ci.discount_centavos, 10) || 0);
      const produtosNetQ = Math.max(0, totalProdutos - descontoQ);
      const totalCliente = produtosNetQ + freightInTotal;
      const totalGain = produtosNetQ - totalToth;
      // 2026-06-30 · desconto negociado JÁ É o valor à vista → NÃO soma os 8% do Pix por cima (é um OU outro).
      const totalPix = descontoQ > 0 ? totalCliente : totalCliente * 0.92;

      if (this.#totalTothEl) this.#totalTothEl.textContent = money(totalToth);
      if (this.#totalGainEl) this.#totalGainEl.textContent = money(totalGain);
      if (this.#totalProductsEl) this.#totalProductsEl.textContent = money(totalProdutos);
      if (this.#totalDiscountEl) this.#totalDiscountEl.textContent = '−' + money(descontoQ);
      if (this.#totalDiscountRowEl) { if (descontoQ > 0) this.#totalDiscountRowEl.removeAttribute('hidden'); else this.#totalDiscountRowEl.setAttribute('hidden', ''); }
      if (this.#totalFreightEl) this.#totalFreightEl.textContent = money(freightAdjusted);
      if (this.#totalClienteEl) this.#totalClienteEl.textContent = money(totalCliente);

      // Frete original (Vipex sem taxa cartão) · só visível pro vendor quando há ajuste E habilitado
      const freteIsVipexAuto = (this.#quote?.frete_centavos != null && this.#quote?.native_frete_centavos != null && this.#quote.frete_centavos === this.#quote.native_frete_centavos);
      if (this.#freightOriginalLabelEl) this.#freightOriginalLabelEl.textContent = freteIsVipexAuto ? 'Vipex' : 'avulso';
      if (this.#freightOriginalValueEl) this.#freightOriginalValueEl.textContent = money(freightOriginal);
      if (this.#freightOriginalRowEl) {
        if (freightAdjusted > freightOriginal && freightOriginal > 0 && freightEnabled) {
          this.#freightOriginalRowEl.removeAttribute('hidden');
        } else {
          this.#freightOriginalRowEl.setAttribute('hidden', '');
        }
      }
      if (this.#totalPixEl) this.#totalPixEl.textContent = money(totalPix);
      const pixLabelEl = this.querySelector('[data-tsf-quote-pix-label]');
      if (pixLabelEl) pixLabelEl.textContent = descontoQ > 0 ? 'à vista no Pix · desconto negociado já aplicado' : 'à vista no Pix · 8% off em tudo';
      // Esconde "ganho" quando = 0
      const gainMeta = this.querySelector('.tsf-quote-builder__total-cost-meta');
      if (gainMeta) {
        if (totalGain > 0) gainMeta.removeAttribute('hidden');
        else gainMeta.setAttribute('hidden', '');
      }
      // Linha "+ frete" no resumo · só aparece quando há valor E está habilitado
      if (this.#totalFreightRowEl) {
        if (freightAdjusted > 0 && freightEnabled) this.#totalFreightRowEl.removeAttribute('hidden');
        else this.#totalFreightRowEl.setAttribute('hidden', '');
      }
    }

    #onMarkupChange() {
      const val = parseFloat(this.#markupInput.value);
      if (this.#markupOutput) this.#markupOutput.textContent = this.#fmtMarkupOutput(val);
      this.#updateSliderGradient();

      // Modo TOTH: aplicar global a TODOS os items que não estão em 'manual' override
      // (preserva edições manuais individuais; sobrescreve nativo+global anteriores)
      if (this.#isTothMode() && this.#quote?.items) {
        for (const item of this.#quote.items) {
          if (!item.overrides) item.overrides = {};
          if (item.overrides.markup_source !== 'manual') {
            item.markup_pct = val;
            item.overrides.markup_source = 'global';
          }
        }
      }

      this.#renderRows();
      this.#updateTotals();
      this.#queueFreightRecalc();
      this.#queueSave({ default_markup_pct: val, items: this.#quote.items });
    }

    #onInlineEdit(input) {
      const uid = input.getAttribute('data-uid');
      const key = input.getAttribute('data-tsf-quote-edit');
      const item = this.#quote.items.find((i) => i.uid === uid);
      if (!item) return;

      // Inicializa overrides se necessário
      if (!item.overrides) item.overrides = {};

      let value;
      if (key === 'title') {
        value = input.value;
        if (!item.snapshot) item.snapshot = {};
        item.snapshot.title = value;
      } else if (key === 'cost_centavos') {
        value = this.#parseCurrency(input.value);
        item.overrides.cost_centavos = value;
      } else if (key === 'markup_pct') {
        value = this.#parseMultiplier(input.value);
        item.markup_pct = value;
        item.overrides.markup_source = 'manual';
      } else if (key === 'prazo') {
        value = parseInt(input.value, 10) || 0;
        item.overrides.prazo = value;
      } else {
        // text fields (cor, materiais, dimens_es, vipex_origem)
        value = input.value;
        item.overrides[key] = value;
      }

      // Pra inputs de cost/markup: só recalcula o total da linha (refreshRow no blur reformata)
      // Pra inputs de texto: aceita inline sem re-render
      if (key === 'cost_centavos' || key === 'markup_pct' || key === 'prazo') {
        this.#updateRowMath(uid);
        this.#updateTotals();
      }

      // Mudanças que afetam o cálculo de frete:
      //   - vipex_origem: muda a tabela de tarifas (regrupa por origem)
      //   - cost_centavos: muda o valor da mercadoria (ad valorem/GRIS/EMEX)
      if (key === 'vipex_origem' || key === 'cost_centavos') {
        this.#queueFreightRecalc();
      }

      this.#queueSave({ items: this.#quote.items });
    }

    #resetMarkupToNative(uid) {
      const item = this.#quote.items.find((i) => i.uid === uid);
      if (!item) return;
      // Reset = remove markup_pct e markup_source · render volta a calcular o nativo
      item.markup_pct = null;
      if (item.overrides) delete item.overrides.markup_source;
      this.#refreshRow(uid);
      this.#updateTotals();
      this.#queueFreightRecalc();
      this.#queueSave({ items: this.#quote.items });
    }

    #resetVipexToNative(uid) {
      const item = this.#quote.items.find((i) => i.uid === uid);
      if (!item) return;
      // Remove override → estado volta a 'native' (lê do metafield)
      if (item.overrides) delete item.overrides.vipex_origem;
      this.#refreshRow(uid);
      this.#queueFreightRecalc(); // origem mudou · frete pode mudar
      this.#queueSave({ items: this.#quote.items });
    }

    #resetSpecToNative(uid, key) {
      const item = this.#quote.items.find((i) => i.uid === uid);
      if (!item) return;
      if (item.overrides) delete item.overrides[key];
      this.#refreshRow(uid);
      // prazo afeta total? Não direto, mas vou re-render só por garantia visual
      if (key === 'prazo') this.#updateTotals();
      this.#queueSave({ items: this.#quote.items });
    }

    #resetCostToNative(uid) {
      const item = this.#quote.items.find((i) => i.uid === uid);
      if (!item) return;
      if (item.overrides) delete item.overrides.cost_centavos;
      this.#refreshRow(uid);
      this.#updateTotals();
      this.#queueFreightRecalc(); // cost afeta valor mercadoria do frete
      this.#queueSave({ items: this.#quote.items });
    }

    #refreshRow(uid) {
      // Reformata o input (ex.: 1,85 → 1,85x; 1234,5 → 1.234,50) e atualiza badge "editado"
      const idx = this.#quote.items.findIndex((i) => i.uid === uid);
      if (idx < 0) return;
      const item = this.#quote.items[idx];
      const oldRow = this.#rowsEl.querySelector(`[data-tsf-quote-row="${uid}"]`);
      if (!oldRow) return;
      const pct = parseFloat(this.#markupInput?.value || this.#quote.default_markup_pct || 0);
      const newHtml = this.#rowHtml(item, pct, idx + 1);
      const tmp = document.createElement('div');
      tmp.innerHTML = newHtml.trim();
      oldRow.replaceWith(tmp.firstElementChild);
    }

    #updateRowMath(uid) {
      const item = this.#quote.items.find((i) => i.uid === uid);
      if (!item) return;
      const row = this.#rowsEl.querySelector(`[data-tsf-quote-row="${uid}"]`);
      if (!row) return;
      const pct = parseFloat(this.#markupInput?.value || this.#quote.default_markup_pct || 0);
      const isToth = this.#isTothMode();
      const ov = item.overrides || {};
      const s = item.snapshot || {};

      const tothUnit =
        (typeof ov.cost_centavos === 'number') ? ov.cost_centavos :
        (typeof s.cost_centavos === 'number' && s.cost_centavos > 0) ? s.cost_centavos :
        (s.price_centavos || 0);

      let nativeMarkupPct = null;
      if (isToth && s.price_centavos && s.cost_centavos && s.cost_centavos > 0) {
        nativeMarkupPct = ((s.price_centavos - s.cost_centavos) / s.cost_centavos) * 100;
      }
      const markupSource = ov.markup_source || (item.markup_pct != null ? 'manual' : null);
      let useMarkup;
      if (markupSource === 'manual') useMarkup = item.markup_pct;
      else if (markupSource === 'global') useMarkup = pct;
      else if (isToth && nativeMarkupPct != null) useMarkup = nativeMarkupPct;
      else useMarkup = (item.markup_pct != null) ? item.markup_pct : pct;

      const clienteUnit = tothUnit * (1 + useMarkup / 100);
      const clienteTotal = clienteUnit * (item.qty || 1);
      const valueEl = row.querySelector('[data-tsf-quote-row-total]');
      const metaEl = row.querySelector('.tsf-quote-item__client-meta');
      if (valueEl) valueEl.textContent = money(clienteTotal);
      if (metaEl) metaEl.textContent = `${item.qty || 1} × ${money(clienteUnit)}`;
    }

    #onQtyChange(input) {
      const uid = input.getAttribute('data-tsf-quote-qty-input');
      const newQty = Math.max(1, parseInt(input.value, 10) || 1);
      const item = this.#quote.items.find((i) => i.uid === uid);
      if (!item) return;
      item.qty = newQty;
      this.#updateTotals();
      this.#queueFreightRecalc(); // qty afeta m³/peso → recalcula frete
      // QA C3 · usa a fórmula canônica da linha (cost cascade + markup 3-state), não o preço público cru
      this.#updateRowMath(uid);
      this.#queueSave({ items: this.#quote.items });
    }

    async #onRemove(uid) {
      const item = this.#quote.items.find((i) => i.uid === uid);
      if (!item) return;
      if (!window.confirm(`Remover "${item.snapshot?.title || item.snapshot?.name || 'este produto'}" do orçamento?`)) return;

      // QA · save MANUAL · remove LOCAL (pendente) · grava SÓ no Salvar
      this.#quote.items = (this.#quote.items || []).filter((i) => i.uid !== uid);
      this.#queueSave({ items: this.#quote.items });
      this.#render();
    }

    // Onda 8.5 · MANUAL SAVE
    // Antes (autosave): #queueSave acumulava patch + dispara timer 600ms.
    // Agora (manual): #queueSave SÓ acumula + atualiza UI dirty. User clica
    // "Salvar" pra persistir. Padrão de NF-e/sistema bancário.
    //
    // Adições estruturais (add/remove produto via /quote/add-item) continuam
    // imediatas no banco · só edições agregadas (markup, client_info, qty,
    // inline-edit) ficam pendentes até user confirmar.
    #pendingQuoteSavePatch = null;
    #queueSave(patch) {
      // Merge raso · client_info e address fazem merge profundo
      const base = this.#pendingQuoteSavePatch || {};
      const merged = { ...base, ...patch };
      if (patch.client_info && base.client_info) {
        merged.client_info = { ...base.client_info, ...patch.client_info };
        if (patch.client_info.address && base.client_info.address) {
          merged.client_info.address = { ...base.client_info.address, ...patch.client_info.address };
        }
        if (patch.client_info.endereco_fiscal && base.client_info.endereco_fiscal) {
          merged.client_info.endereco_fiscal = { ...base.client_info.endereco_fiscal, ...patch.client_info.endereco_fiscal };
        }
      }
      this.#pendingQuoteSavePatch = merged;
      this.#updateSaveStatus('dirty'); // "● N alterações pendentes"
      // Onda 8.5 · sem setTimeout · user clica Salvar manualmente
    }

    // Conta quantos campos top-level estão pendentes (pra mostrar "● 3 alterações")
    #countPendingChanges() {
      const p = this.#pendingQuoteSavePatch;
      if (!p) return 0;
      let n = 0;
      for (const k of Object.keys(p)) {
        if (k === 'client_info' && p.client_info) {
          n += Object.keys(p.client_info).filter(kk => kk !== 'address' && kk !== 'endereco_fiscal').length;
          if (p.client_info.address) n += Object.keys(p.client_info.address).length;
          if (p.client_info.endereco_fiscal) n += Object.keys(p.client_info.endereco_fiscal).length;
        } else {
          n++;
        }
      }
      return n;
    }

    // Onda 8.5 · Flush · usado por #saveAndBack + botão "Salvar" + antes do PDF
    async #flushSave() {
      const patch = this.#pendingQuoteSavePatch;
      if (!patch) return;
      this.#pendingQuoteSavePatch = null;
      await this.#save(patch);
    }

    // Onda 8.5 · Commit manual · acionado pelo botão "Salvar"
    async #commitSave() {
      if (this.#countPendingChanges() === 0) return;
      await this.#flushSave();
    }

    // Onda 8.5 · Merge defensive · ao receber quote do servidor (add-item,
    // remove-item, etc), preserva mudanças locais pendentes.
    // Evita perder edições de cliente quando vendedor adiciona produto.
    #applyServerQuote(serverQuote) {
      const pending = this.#pendingQuoteSavePatch;
      this.#quote = serverQuote;
      if (!pending) return;
      // Re-aplica patches em cima do quote do servidor (top-level)
      for (const k of Object.keys(pending)) {
        if (k === 'client_info' && pending.client_info) {
          const merged = { ...(this.#quote.client_info || {}), ...pending.client_info };
          if (pending.client_info.address) {
            merged.address = { ...(this.#quote.client_info?.address || {}), ...pending.client_info.address };
          }
          if (pending.client_info.endereco_fiscal) {
            merged.endereco_fiscal = { ...(this.#quote.client_info?.endereco_fiscal || {}), ...pending.client_info.endereco_fiscal };
          }
          this.#quote.client_info = merged;
        } else {
          this.#quote[k] = pending[k];
        }
      }
    }

    // Onda 8.5 · Descarta mudanças pendentes recarregando do servidor
    async #discardChanges() {
      const n = this.#countPendingChanges();
      if (n === 0) return;
      const ok = confirm(`Descartar ${n} alteração${n > 1 ? 'ões' : ''} não salvas? Isso recarrega o orçamento do servidor.`);
      if (!ok) return;
      this.#pendingQuoteSavePatch = null;
      this.#updateSaveStatus('saved');
      // Recarrega do servidor
      await this.#fetchQuote();
    }

    async #save(patch) {
      this.#updateSaveStatus('saving');
      try {
        const res = await fetch(`${QUOTE_ENDPOINT}/update`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            specifier_customer_id: this.#ctx.customer_id,
            quote_kind: this.#kind,
            quote_id: this.#quote?.id,
            patch,
          }),
        });
        const data = await res.json();
        if (!data.ok) throw new Error(data.error || 'erro');
        this.#quote = data.quote;
        this.#updateSaveStatus('saved');
      } catch (err) {
        console.error('[tsf-quote] save failed', err);
        this.#updateSaveStatus('error');
      }
    }

    // PARITY-B · Hidrata title + byline + actions do header admin
    // Espelha TsfAdminVendaEditor (linha ~10223) · mesma estrutura visual
    #hydrateAdminHeader() {
      const q = this.#quote;
      if (!q) return;
      // 2026-06-28 · selo de conversão no editor (paridade c/ a venda + o card da lista) · só Meta (orçamento não vai como conversão Google)
      const sigEl = document.querySelector('[data-tsf-quote-conversion-signal]');
      if (sigEl) sigEl.innerHTML = tsfDispatchSignalHtml(q.tsf_conversion_dispatch_log, { google: false });
      // Title · número do orçamento (TOTH-2026-ORC-XXXX)
      const titleEl = document.querySelector('[data-tsf-admin-orcamento-title]');
      if (titleEl) {
        titleEl.textContent = q.numero_orcamento || 'Orçamento';
      }
      // Byline · cliente · criado data · por specifier_email
      const bylineEl = document.querySelector('[data-tsf-admin-orcamento-byline]');
      if (bylineEl) {
        const ci = q.client_info || {};
        const created = q.created_at
          ? new Date(q.created_at).toLocaleDateString('pt-BR', { day: '2-digit', month: 'long', year: 'numeric' })
          : '—';
        const parts = [
          ci.name || 'Cliente sem nome',
          `criado ${created}`,
          q.specifier_email ? `por ${q.specifier_email}` : null,
        ].filter(Boolean);
        // Preserva o save-badge dentro do byline (se ainda existir o data-tsf-quote-status nele)
        const statusBadge = bylineEl.querySelector('[data-tsf-quote-status]');
        bylineEl.textContent = parts.join(' · ');
        if (statusBadge) {
          bylineEl.append(' · ', statusBadge);
        }
      }
      // Actions · mostra após carregar (mesmo padrão da venda)
      const actionsEl = document.querySelector('[data-tsf-admin-orcamento-actions]');
      if (actionsEl) {
        actionsEl.removeAttribute('hidden');
        // Esconde "Excluir" se quote já virou venda ou tem status protegido
        const deleteBtn = actionsEl.querySelector('[data-tsf-quote-delete]');
        if (deleteBtn) {
          const canDelete = !q.linked_sale_id && (!q.status || q.status === 'draft' || q.status === 'rascunho' || q.status === 'cancelled' || q.status === 'lost');
          deleteBtn.style.display = canDelete ? '' : 'none';
        }
        // Esconde "Converter em venda" se já virou venda
        const toPedidoBtn = actionsEl.querySelector('[data-tsf-quote-to-pedido]');
        if (toPedidoBtn) {
          if (q.linked_sale_id) {
            toPedidoBtn.style.display = 'none';
          } else {
            toPedidoBtn.style.display = '';
          }
        }
      }
    }

    // Onda 8.5 · Status do save + atualização dos botões Salvar/Descartar
    // Estados: idle | dirty | saving | saved | error
    #updateSaveStatus(state) {
      // 2026-06-29 · delega pro selo de status compartilhado (de-dup · a venda usa o MESMO)
      return tsfRenderSaveStatus(state, this.#countPendingChanges(), {
        statusSel: '[data-tsf-quote-status]', saveSel: '[data-tsf-quote-save]', discardSel: '[data-tsf-quote-discard]',
        labelSel: '[data-tsf-quote-save-label]', countSel: '[data-tsf-quote-save-count]' });
    }

    /* ════ CLIENT CARD ══════════════════════════════════════════════ */
    // Onda 8.4 · Schema unificado: campo "documento" detecta CPF/CNPJ.
    // Até 11 dígitos → cpf + tipo b2c. 12-14 → cnpj + tipo b2b.
    // IE/IM aparecem só quando tipo derivado é b2b.
    #hydrateClientCard() {
      const ci = this.#quote.client_info || {};
      // 2026-06-25 · mostra "Trocar cliente" só quando há cliente vinculado
      const swapBtn = this.querySelector('[data-tsf-quote-client-swap]');
      if (swapBtn) swapBtn.hidden = !(this.#quote?.customer_id || this.#quote?.client_id);
      const name = ci.name || '';
      const cpf = ci.cpf || '';
      const cnpj = ci.cnpj || '';
      const ie = ci.ie || '';
      const im = ci.im || '';
      // Backward-compat: contact legacy → email ou whatsapp
      let email = ci.email || '';
      let whatsapp = ci.whatsapp || '';
      if (!email && !whatsapp && ci.contact) {
        if (ci.contact.includes('@')) email = ci.contact;
        else whatsapp = ci.contact;
      }
      const cep = ci.cep || '';
      // 2026-06-30 · deriva logradouro/numero do `rua` combinado (orçamento criado pelo checkout do site)
      const address = tsfDeriveAddress(ci.address);
      const logradouro = address.logradouro || '';
      const numero = address.numero || '';
      const complemento = address.complemento || '';
      const bairro = address.bairro || '';
      const cidade = address.localidade || address.cidade || '';
      const uf = address.uf || '';
      const validDays = ci.valid_days != null ? ci.valid_days : 30;
      // Documento unificado · se tem cnpj usa cnpj, senão cpf, senão vazio
      const docDigits = cnpj ? cnpj : cpf;
      const docFormatted = this.#formatDocumento(docDigits);
      // Tipo derivado do documento (não mais persistido explicitamente)
      const tipo = (cnpj && cnpj.replace(/\D/g, '').length >= 12) ? 'b2b' : 'b2c';

      const set = (selector, value, formatter) => {
        const el = this.querySelector(`[data-tsf-client-input="${selector}"]`);
        if (!el) return;
        el.value = formatter ? formatter(value) : (value || '');
      };

      set('name', name);
      set('documento', docFormatted);
      set('email', email);
      set('whatsapp', whatsapp, (v) => this.#formatPhoneDisplay(v));
      set('ie', ie);
      set('im', im);
      set('cep', cep, (v) => this.#formatCepDisplay(v));
      set('logradouro', logradouro);
      set('numero', numero);
      set('complemento', complemento);
      set('bairro', bairro);
      set('cidade', cidade);
      set('uf', (uf || '').toUpperCase());
      set('valid_days', String(validDays));

      // Onda 8.5 · Notas internas
      set('notes', ci.notes || '');
      // 05-08 · A PONTE · reexibe o código já aplicado neste orçamento
      this.querySelectorAll('[data-tsf-quote-ponte-cod]').forEach((x) => { x.value = ci.ponte_code ? '#' + ci.ponte_code : ''; });
      if (ci.ponte_code) {
        this.querySelectorAll('[data-tsf-quote-ponte-status]').forEach((x) => {
          x.textContent = 'código #' + ci.ponte_code + ' aplicado — este orçamento já sabe de onde o cliente veio';
        });
      }

      // Onda 8.5 · Endereço fiscal (toggle + fields)
      const fiscal = ci.endereco_fiscal || {};
      const hasFiscal = !!(ci.has_endereco_fiscal || fiscal.cep || fiscal.logradouro);
      const fiscalToggle = this.querySelector('[data-tsf-client-fiscal-toggle]');
      const fiscalFields = this.querySelector('[data-tsf-client-fiscal-fields]');
      if (fiscalToggle) fiscalToggle.checked = hasFiscal;
      if (fiscalFields) {
        if (hasFiscal) fiscalFields.removeAttribute('hidden');
        else fiscalFields.setAttribute('hidden', '');
      }
      set('fiscal_cep', fiscal.cep, (v) => this.#formatCepDisplay(v));
      set('fiscal_logradouro', fiscal.logradouro);
      set('fiscal_numero', fiscal.numero);
      set('fiscal_complemento', fiscal.complemento);
      set('fiscal_bairro', fiscal.bairro);
      set('fiscal_cidade', fiscal.localidade || fiscal.cidade);
      set('fiscal_uf', (fiscal.uf || '').toUpperCase());

      this.#updateValidityDisplay(validDays);
      this.#applyClientTypeUI(tipo);

      this.#renderClientPrint();

      const hasData = name || email || whatsapp || cep || cpf || cnpj;
      if (hasData) this.#expandClientBody();
    }

    // Onda 8.4 · Aplica tipo derivado (B2C/B2B) · só visual (badge + show/hide IE/IM)
    #applyClientTypeUI(tipo) {
      const t = tipo === 'b2b' ? 'b2b' : 'b2c';
      // Badge no header de Identidade
      const badge = this.querySelector('[data-tsf-client-type-badge]');
      if (badge) {
        badge.textContent = t === 'b2b' ? 'Empresa · B2B' : 'Pessoa física · B2C';
        badge.setAttribute('data-tipo', t);
      }
      // Mostra/esconde IE e IM (só fazem sentido pra B2B)
      this.querySelectorAll('[data-tsf-client-only]').forEach(el => {
        const only = el.getAttribute('data-tsf-client-only');
        if (only === t) el.removeAttribute('hidden');
        else el.setAttribute('hidden', '');
      });
    }

    // Onda 8.4 · Formata documento unificado · auto-detecta CPF/CNPJ pelos dígitos
    #formatDocumento(value) {
      const d = String(value || '').replace(/\D/g, '');
      if (d.length === 0) return '';
      if (d.length <= 11) return this.#formatCpfDisplay(d);
      return this.#formatCnpjDisplay(d);
    }

    // Onda 8.1 · Formatadores de display pra documentos brasileiros
    #formatCpfDisplay(digits) {
      const d = (digits || '').replace(/\D/g, '').slice(0, 11);
      if (d.length <= 3) return d;
      if (d.length <= 6) return `${d.slice(0,3)}.${d.slice(3)}`;
      if (d.length <= 9) return `${d.slice(0,3)}.${d.slice(3,6)}.${d.slice(6)}`;
      return `${d.slice(0,3)}.${d.slice(3,6)}.${d.slice(6,9)}-${d.slice(9)}`;
    }

    #formatCnpjDisplay(digits) {
      const d = (digits || '').replace(/\D/g, '').slice(0, 14);
      if (d.length <= 2) return d;
      if (d.length <= 5) return `${d.slice(0,2)}.${d.slice(2)}`;
      if (d.length <= 8) return `${d.slice(0,2)}.${d.slice(2,5)}.${d.slice(5)}`;
      if (d.length <= 12) return `${d.slice(0,2)}.${d.slice(2,5)}.${d.slice(5,8)}/${d.slice(8)}`;
      return `${d.slice(0,2)}.${d.slice(2,5)}.${d.slice(5,8)}/${d.slice(8,12)}-${d.slice(12)}`;
    }

    #formatPhoneDisplay(digits) {
      let d = (digits || '').replace(/\D/g, '');
      if ((d.length === 12 || d.length === 13) && d.startsWith('55')) d = d.slice(2); // tira DDI +55 → exibe local
      d = d.slice(0, 11);
      if (d.length === 0) return '';
      if (d.length <= 2) return `(${d}`;
      if (d.length <= 6) return `(${d.slice(0,2)}) ${d.slice(2)}`;
      if (d.length <= 10) return `(${d.slice(0,2)}) ${d.slice(2,6)}-${d.slice(6)}`;
      return `(${d.slice(0,2)}) ${d.slice(2,7)}-${d.slice(7)}`;
    }

    // Onda 8.1 · Print version inclui endereço completo + CPF/CNPJ
    #renderClientPrint() {
      if (!this.#clientPrintEl) return;
      const ci = this.#quote.client_info || {};
      const parts = [];
      if (ci.name) parts.push(`<strong>${this.#esc(ci.name)}</strong>`);
      // Documento
      if (ci.cpf) parts.push(`CPF ${this.#esc(this.#formatCpfDisplay(ci.cpf))}`);
      if (ci.cnpj) parts.push(`CNPJ ${this.#esc(this.#formatCnpjDisplay(ci.cnpj))}`);
      // Contato
      const contactParts = [];
      if (ci.email) contactParts.push(this.#esc(ci.email));
      if (ci.whatsapp) contactParts.push(this.#esc(this.#formatPhoneDisplay(ci.whatsapp)));
      if (contactParts.length === 0 && ci.contact) contactParts.push(this.#esc(ci.contact));
      if (contactParts.length) parts.push(contactParts.join(' · '));
      // Endereço completo
      const addr = ci.address || {};
      const city = addr.localidade || addr.cidade || '';
      if (city) {
        const street = [addr.logradouro, addr.numero].filter(Boolean).join(', ');
        const compl = addr.complemento ? ` (${this.#esc(addr.complemento)})` : '';
        const neighborhood = addr.bairro ? ' · ' + this.#esc(addr.bairro) : '';
        parts.push(`${this.#esc(street)}${compl}${neighborhood} · ${this.#esc(city)}/${this.#esc(addr.uf || '')} · CEP ${this.#esc(this.#formatCepDisplay(ci.cep || ''))}`);
      } else if (ci.cep) {
        parts.push(`CEP ${this.#esc(this.#formatCepDisplay(ci.cep))}`);
      }
      if (parts.length === 0) {
        this.#clientPrintEl.setAttribute('hidden', '');
        this.#clientPrintEl.innerHTML = '';
      } else {
        this.#clientPrintEl.removeAttribute('hidden');
        this.#clientPrintEl.innerHTML = parts.join('<br>');
      }
    }

    #toggleClientBody() {
      if (!this.#clientBodyEl) return;
      const open = !this.#clientBodyEl.hasAttribute('hidden');
      if (open) {
        this.#clientBodyEl.setAttribute('hidden', '');
        this.#clientToggleEl?.setAttribute('aria-expanded', 'false');
        if (this.#clientToggleLabelEl) this.#clientToggleLabelEl.textContent = 'Adicionar dados do cliente';
      } else {
        this.#expandClientBody();
      }
    }

    #expandClientBody() {
      if (!this.#clientBodyEl) return;
      this.#clientBodyEl.removeAttribute('hidden');
      this.#clientToggleEl?.setAttribute('aria-expanded', 'true');
      if (this.#clientToggleLabelEl) this.#clientToggleLabelEl.textContent = 'Recolher';
    }

    #onClientInputChange(input) {
      const field = input.getAttribute('data-tsf-client-input');
      const raw = input.value;

      // CEP mask + lookup
      if (field === 'cep') {
        const digits = raw.replace(/\D/g, '').slice(0, 8);
        input.value = this.#formatCepDisplay(digits);
        this.#updateClientInfo({ cep: digits });
        if (digits.length === 8) {
          window.clearTimeout(this.#cepTimer);
          this.#cepTimer = window.setTimeout(() => this.#lookupCep(digits), 250);
        } else {
          this.#setCepStatus('');
        }
        return;
      }

      // Onda 8.4 · Documento unificado · detecta CPF (≤11) ou CNPJ (12-14) auto
      if (field === 'documento') {
        const digits = raw.replace(/\D/g, '').slice(0, 14);
        input.value = this.#formatDocumento(digits);
        // Tipo derivado pelos dígitos · 1-11 = B2C/CPF, 12-14 = B2B/CNPJ
        const tipo = digits.length >= 12 ? 'b2b' : 'b2c';
        if (tipo === 'b2b') {
          this.#updateClientInfo({ cnpj: digits, cpf: '', tipo: 'b2b' });
        } else {
          this.#updateClientInfo({ cpf: digits, cnpj: '', tipo: 'b2c' });
        }
        this.#applyClientTypeUI(tipo);
        this.#markClientDirty();
        return;
      }

      // Onda 8.1 · WhatsApp mask
      if (field === 'whatsapp') {
        const digits = raw.replace(/\D/g, '').slice(0, 11);
        input.value = this.#formatPhoneDisplay(digits);
        this.#updateClientInfo({ whatsapp: digits });
        this.#markClientDirty();
        return;
      }

      // Onda 8.1 · UF · uppercase automático
      if (field === 'uf') {
        const uf = (raw || '').toUpperCase().replace(/[^A-Z]/g, '').slice(0, 2);
        input.value = uf;
        this.#updateAddressInfo({ uf });
        this.#markClientDirty();
        return;
      }

      // Onda 8.1 · Endereço (logradouro, número, complemento, bairro, cidade)
      // são parte de address (não top-level)
      if (['logradouro','numero','complemento','bairro','cidade'].includes(field)) {
        this.#updateAddressInfo({ [field === 'cidade' ? 'localidade' : field]: raw });
        // Compat dupla: salva 'cidade' E 'localidade' (ViaCEP usa localidade)
        if (field === 'cidade') this.#updateAddressInfo({ cidade: raw });
        this.#markClientDirty();
        return;
      }

      // Onda 8.5 · Endereço fiscal (mesma lógica, mas em endereco_fiscal sub-object)
      if (field.startsWith('fiscal_')) {
        const sub = field.replace('fiscal_', '');
        if (sub === 'cep') {
          const digits = raw.replace(/\D/g, '').slice(0, 8);
          input.value = this.#formatCepDisplay(digits);
          this.#updateFiscalInfo({ cep: digits });
          return;
        }
        if (sub === 'uf') {
          const uf = (raw || '').toUpperCase().replace(/[^A-Z]/g, '').slice(0, 2);
          input.value = uf;
          this.#updateFiscalInfo({ uf });
          return;
        }
        // localidade/cidade duplo
        if (sub === 'cidade') {
          this.#updateFiscalInfo({ localidade: raw, cidade: raw });
        } else {
          this.#updateFiscalInfo({ [sub]: raw });
        }
        return;
      }

      // Onda 8.5 · Notas internas
      if (field === 'notes') {
        this.#updateClientInfo({ notes: raw });
        return;
      }

      // Validade: força inteiro 1-365, atualiza display "até DD/MM"
      if (field === 'valid_days') {
        const digits = raw.replace(/\D/g, '').slice(0, 3);
        const n = Math.max(1, Math.min(365, parseInt(digits, 10) || 30));
        input.value = String(n);
        this.#updateValidityDisplay(n);
        this.#updateClientInfo({ valid_days: n });
        return;
      }

      // Outros campos (name, email, ie, im, consultant_message)
      this.#updateClientInfo({ [field]: raw });

      // QA · marca cliente alterado (acende "Salvar cliente") ao mudar nome/email/IE/IM
      if (['name', 'email', 'ie', 'im'].includes(field)) this.#markClientDirty();
    }

    // Onda 8.1 · Merge no address dentro de client_info (sem perder outros campos)
    #updateAddressInfo(patch) {
      const ci = this.#quote.client_info || {};
      const newAddress = { ...(ci.address || {}), ...patch };
      this.#updateClientInfo({ address: newAddress });
    }

    // Onda 8.5 · Merge no endereco_fiscal dentro de client_info
    #updateFiscalInfo(patch) {
      const ci = this.#quote.client_info || {};
      const newFiscal = { ...(ci.endereco_fiscal || {}), ...patch };
      this.#updateClientInfo({ endereco_fiscal: newFiscal });
    }

    #updateValidityDisplay(days) {
      const displayEl = this.querySelector('[data-tsf-client-validity-display]');
      if (!displayEl) return;
      const n = Math.max(1, Math.min(365, parseInt(days, 10) || 30));
      const base = this.#quote?.created_at ? new Date(this.#quote.created_at) : new Date();
      const expiry = new Date(base.getTime() + n * 24 * 60 * 60 * 1000);
      const fmt = new Intl.DateTimeFormat('pt-BR', { day: '2-digit', month: 'short', year: 'numeric' });
      displayEl.textContent = `até ${fmt.format(expiry).replace(' de ', ' de ')}`;
    }

    // 05-08 · A PONTE · resgata a sessão de navegação pelo código do WhatsApp.
    async #aplicarPonte(botao) {
      const raiz = botao.closest('[data-tsf-quote-ponte], [data-tsf-quote-ponte-empty]') || this;
      const inp = raiz.querySelector('[data-tsf-quote-ponte-cod]');
      const st = raiz.querySelector('[data-tsf-quote-ponte-status]');
      const diz = (t) => { if (st) st.textContent = t; };
      const code = String(inp?.value || '').trim().toUpperCase().replace(/^#/, '');
      if (!/^[0-9A-F]{8}$/.test(code)) return diz('o código tem 8 caracteres (números e letras de A a F), como #A1B2C3D4');
      const cid = this.#quote?.customer_id;
      if (!cid) return diz('vincule o cliente primeiro — o crédito vai no cadastro dele');
      diz('procurando a navegação desta pessoa…');
      botao.disabled = true;
      try {
        const r = await fetch(`${SALE_ENDPOINT}/claim-code`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ code, customer_id: cid })
        });
        const d = await r.json().catch(() => ({}));
        if (!r.ok || !d.ok) return diz(d.error || `não deu (erro ${r.status})`);
        const a = d.achou || {};
        const pistas = [
          a.gclid ? 'veio de anúncio no GOOGLE' : null,
          a.fbc ? 'veio de anúncio no META' : null,
          (!a.gclid && !a.fbc && a.utm_source) ? ('veio de ' + a.utm_source) : null
        ].filter(Boolean);
        diz('✅ achei: ' + (pistas.join(' + ') || 'navegação direta, sem anúncio') + ' · ' + (a.toques_da_sessao || 1) + ' visita(s) antes de falar com você');
        this.#updateClientInfo({ ponte_code: code });
        this.querySelectorAll('[data-tsf-quote-ponte-cod]').forEach((x) => { x.value = '#' + code; });
      } catch (e) {
        diz('erro de rede: ' + (e?.message || e));
      } finally {
        botao.disabled = false;
      }
    }
    #updateClientInfo(patch) {
      const merged = { ...(this.#quote.client_info || {}), ...patch };
      this.#quote.client_info = merged;
      this.#renderClientPrint();
      // CLI-7 · Editar dados do cliente acende SÓ o "Salvar cliente" (não o Salvar do TOPO).
      // O Salvar do topo é do ORÇAMENTO (produtos/markup/frete) e não grava o cadastro do
      // cliente — quem grava é o "Salvar cliente". Marcar o topo aqui enganava o usuário.
      // Em Specifica (sem botão dedicado · #markClientDirty é no-op) cai no save do orçamento.
      // 2026-07-01 · edições do cliente agora entram no Salvar do TOPO também (persiste no orçamento +
      //   sincroniza o cadastro via /quote/update). Antes, em modo Toth, editar o cliente só acendia o
      //   "Salvar cliente" → o usuário editava o endereço, salvava no topo e PERDIA. Agora qualquer Salvar grava.
      this.#queueSave({ client_info: merged });
      if (this.#isTothMode()) this.#markClientDirty();
    }

    // CLI-7 · Persiste SÓ o client_info no orçamento (acionado pelo "Salvar cliente").
    // Usa o merge defensivo pra preservar mudanças de produto/markup pendentes e NÃO mexe
    // no status do Salvar do TOPO (que reflete apenas o corpo do orçamento).
    async #saveClientInfo() {
      const res = await fetch(`${QUOTE_ENDPOINT}/update`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          specifier_customer_id: this.#ctx.customer_id,
          quote_kind: this.#kind,
          quote_id: this.#quote?.id,
          patch: { client_info: this.#quote.client_info },
        }),
      });
      const data = await res.json();
      if (!data.ok) throw new Error(data.error || 'falha ao salvar cliente no orçamento');
      this.#applyServerQuote(data.quote); // re-aplica corpo pendente · preserva produtos/markup
    }

    async #lookupCep(digits) {
      if (this.#cepBusy) return;
      this.#cepBusy = true;
      this.#setCepStatus('buscando…');
      try {
        const res = await fetch(`https://viacep.com.br/ws/${digits}/json/`);
        const data = await res.json();
        if (data.erro) {
          this.#setCepStatus('CEP não encontrado', 'error');
          this.#freightTotal = 0;
          this.#renderFreightError('CEP inválido.');
        } else {
          this.#setCepStatus(`✓ ${data.localidade}/${data.uf}`, 'ok');
          // Onda 8.1 · Preenche campos visíveis diretamente · merge com address existente
          const ci = this.#quote.client_info || {};
          const currentAddress = ci.address || {};
          const newAddress = {
            ...currentAddress,
            logradouro: data.logradouro || currentAddress.logradouro || '',
            bairro: data.bairro || currentAddress.bairro || '',
            localidade: data.localidade || currentAddress.localidade || '',
            cidade: data.localidade || currentAddress.cidade || '',
            uf: data.uf || currentAddress.uf || '',
          };
          this.#updateClientInfo({ cep: digits, address: newAddress });
          // Reflete nos inputs visíveis (sem sobrescrever número/complemento)
          const set = (selector, value) => {
            const el = this.querySelector(`[data-tsf-client-input="${selector}"]`);
            if (el) el.value = value || '';
          };
          set('logradouro', newAddress.logradouro);
          set('bairro', newAddress.bairro);
          set('cidade', newAddress.localidade);
          set('uf', (newAddress.uf || '').toUpperCase());
          // Dispara frete
          this.#calculateFreight(digits);
          // Dispara upsert do cliente (CEP completo é sinal de progresso)
          this.#markClientDirty();
        }
      } catch (err) {
        this.#setCepStatus('Falha ao buscar CEP', 'error');
      } finally {
        this.#cepBusy = false;
      }
    }

    // ════════════════════════════════════════════════════════════════════
    // Onda 8.2 · Auto-upsert em toth_clients
    // ════════════════════════════════════════════════════════════════════
    // Quando user preenche CPF (11 dígitos) ou CNPJ (14) + nome → salva em
    // toth_clients (upsert por CPF/CNPJ). Vincula client_id no quote.
    // Mostra badge "✓ Salvo em Clientes". Debounced 1.5s · evita lixo.
    // ════════════════════════════════════════════════════════════════════
    #clientUpsertTimer = null;
    #clientUpsertInflight = false;

    // QA · save MANUAL do cliente · acabou o auto-upsert. Editar um campo do cadastro marca
    // "alterado" → acende o botão "Salvar cliente". Só vai pro Shopify no clique.
    #clientDirty = false;
    #markClientDirty() {
      if (!this.#isTothMode()) return; // só Toth interno salva clientes formalmente
      this.#clientDirty = true;
      this.#updateClientSaveButton();
    }
    #updateClientSaveButton(state) {
      const btn = this.querySelector('[data-tsf-quote-client-save]');
      if (!btn) return;
      const lbl = btn.querySelector('[data-tsf-quote-client-save-label]');
      if (state === 'saving') { btn.disabled = true; if (lbl) lbl.textContent = 'Salvando…'; return; }
      if (state === 'saved')  { this.#clientDirty = false; btn.disabled = true; if (lbl) lbl.textContent = 'Cliente salvo ✓'; return; }
      btn.disabled = !this.#clientDirty;
      if (lbl) lbl.textContent = 'Salvar cliente';
    }
    // Salvar cliente · valida → upsert no Shopify (atualiza pelo customer_id · anti-dup) → persiste o orçamento.
    async #commitClient() {
      const ci = this.#quote?.client_info || {};
      const name = (ci.name || '').trim();
      // Documento É o tipo: aceita CPF (11 díg) OU CNPJ (14 díg). NÃO exige um específico
      // a partir de ci.tipo (que pode estar stale — ex.: pessoa física marcada b2b no Shopify).
      // Isso corrige o "FALTAM: CNPJ" num cliente que só tem CPF.
      const cpf = (ci.cpf || '').replace(/\D/g, '');
      const cnpj = (ci.cnpj || '').replace(/\D/g, '');
      const hasCpf = cpf.length === 11;
      const hasCnpj = cnpj.length === 14;
      const missing = [];
      if (!name) missing.push('nome');
      if (!hasCpf && !hasCnpj) missing.push('CPF ou CNPJ');
      // 2026-06-24 · e-mail OU WhatsApp (igual ao backend ensureQuoteCustomer) — não exige os 2.
      // Cliente B2C que só tem telefone (ou só e-mail) não trava mais aqui.
      const hasEmail = !!ci.email && /@/.test(ci.email);
      const hasWhats = (ci.whatsapp || '').replace(/\D/g, '').length >= 10;
      if (!hasEmail && !hasWhats) missing.push('WhatsApp ou e-mail');
      if ((ci.cep || '').replace(/\D/g, '').length !== 8) missing.push('CEP');
      if (missing.length) { this.#setClientSaveBadge('error', 'Faltam: ' + missing.join(', ')); return; }
      // FIX 2026-06-26 · AVISO de telefone inválido (não bloqueia — confirma). Número incompleto não
      //   aparece direito no perfil e NÃO casa no remarketing (Meta/Google). Celular BR = 11 díg
      //   (DDD + 9 + 8 números); fixo = 10. Tira o 55 só quando 12-13 díg (DDD 55 = Santa Maria fica intacto).
      let phD = (ci.whatsapp || '').replace(/\D/g, '');
      if ((phD.length === 12 || phD.length === 13) && phD.startsWith('55')) phD = phD.slice(2);
      const okMobile = phD.length === 11 && phD[2] === '9';
      const okFixo = phD.length === 10 && /[2-8]/.test(phD[2] || '');
      if (hasWhats && !okMobile && !okFixo) {
        const aviso = (phD.length === 10 && phD[2] === '9')
          ? 'O WhatsApp tem 10 dígitos e parece um CELULAR incompleto (falta 1 dígito). Celular = 11 (DDD + 9 + 8 números).'
          : `O WhatsApp tem ${phD.length} dígito(s) — parece inválido. Celular = 11 dígitos (DDD + 9 + número); fixo = 10.`;
        if (!confirm(`${aviso}\n\nSalvar assim mesmo? Número inválido pode não aparecer no perfil do cliente e não casa no remarketing.`)) {
          this.#updateClientSaveButton();
          return;
        }
      }
      // Auto-heal: normaliza ci.tipo pelo documento real antes de salvar (evita propagar stale pra venda).
      const derivedTipo = hasCnpj ? 'b2b' : 'b2c';
      if (ci.tipo !== derivedTipo) this.#updateClientInfo({ tipo: derivedTipo });
      this.#updateClientSaveButton('saving');
      try {
        await this.#runClientUpsert();   // push Shopify customer (update via customer_id · anti-dup)
        await this.#saveClientInfo();     // persiste só o client_info no orçamento (não acende/zera o Salvar do topo)
        this.#updateClientSaveButton('saved');
      } catch (e) {
        this.#setClientSaveBadge('error', e?.message || 'falha ao salvar');
        this.#updateClientSaveButton();
      }
    }

    async #runClientUpsert() {
      if (this.#clientUpsertInflight) return;
      const ci = this.#quote?.client_info || {};
      const cpf = (ci.cpf || '').replace(/\D/g, '');
      const cnpj = (ci.cnpj || '').replace(/\D/g, '');
      const name = (ci.name || '').trim();
      // tipo DERIVADO do documento (CNPJ 14 díg = empresa; senão pessoa física).
      // Não confia em ci.tipo (pode estar stale) — o documento é a fonte da verdade.
      const tipo = cnpj.length === 14 ? 'b2b' : 'b2c';

      // Requer nome + AO MENOS UM documento válido (CPF 11 díg OU CNPJ 14 díg)
      if (!name) return;
      if (cpf.length !== 11 && cnpj.length !== 14) return;

      this.#clientUpsertInflight = true;
      this.#setClientSaveBadge('saving');
      try {
        const addr = ci.address || {};
        const payload = {
          nome: name,
          email: ci.email || null,
          whatsapp: (ci.whatsapp || '').replace(/\D/g, '') || null,
          tipo,
          specifier_customer_id: this.#ctx?.customer_id ? Number(this.#ctx.customer_id) : null,
          endereco: {
            cep: (ci.cep || '').replace(/\D/g, ''),
            logradouro: addr.logradouro || '',
            numero: addr.numero || '',
            complemento: addr.complemento || '',
            bairro: addr.bairro || '',
            cidade: addr.localidade || addr.cidade || '',
            uf: addr.uf || '',
          },
        };
        // Onda 8.8 · SEMPRE envia ambos os campos (mutuamente exclusivos).
        // Antes só mandava o documento atual → o outro ficava órfão no banco.
        // Ex: mudou CNPJ → CPF · CPF atualizava mas CNPJ antigo persistia.
        payload.cpf = tipo === 'b2c' ? cpf : '';
        payload.cnpj = tipo === 'b2b' ? cnpj : '';
        if (tipo === 'b2b') {
          if (ci.ie) payload.ie = ci.ie;
          if (ci.im) payload.im = ci.im;
        }
        // Onda 15D · Shopify Customer ID é bigint · usa customer_id (não client_id UUID legacy)
        // Se quote já tem customer_id (ou client_id legacy), passa pra atualizar
        const existingClientRef = this.#quote?.customer_id || this.#quote?.client_id;
        if (existingClientRef) payload.id = existingClientRef;

        const res = await fetch(`${CLIENT_ENDPOINT}/upsert`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        });
        const data = await res.json();
        if (!data.ok || !data.client?.id) {
          this.#setClientSaveBadge('error', data.error || 'falha');
          return;
        }
        // Onda 15D · customer_id (bigint Shopify) é o ID estrutural · persiste IMEDIATO
        const newCustomerId = data.client.id;
        const currentRef = this.#quote.customer_id || this.#quote.client_id;
        if (!currentRef || currentRef !== newCustomerId) {
          this.#quote.customer_id = newCustomerId;
          this.#quote.customer_snapshot = data.client;
          // Save direto, fora do dirty queue · não conta como "alteração pendente"
          try {
            await fetch(`${QUOTE_ENDPOINT}/update`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                specifier_customer_id: this.#ctx.customer_id,
                quote_kind: this.#kind,
                quote_id: this.#quote?.id,
                patch: { customer_id: newCustomerId, customer_snapshot: data.client },
              }),
            });
          } catch (e) { console.warn('[tsf-quote] persist customer_id failed:', e); }
        }
        this.#setClientSaveBadge('saved', data.action === 'created' ? 'Cadastrado em Clientes' : 'Atualizado em Clientes');
      } catch (err) {
        this.#setClientSaveBadge('error', err.message);
      } finally {
        this.#clientUpsertInflight = false;
      }
    }

    #setClientSaveBadge(state, text) {
      const badge = this.querySelector('[data-tsf-client-save-badge]');
      const textEl = this.querySelector('[data-tsf-client-save-badge-text]');
      if (!badge) return;
      badge.removeAttribute('hidden');
      badge.setAttribute('data-state', state);
      if (textEl) {
        textEl.textContent = state === 'saving' ? 'Salvando…'
          : state === 'saved'  ? (text || 'Salvo em Clientes')
          : state === 'error'  ? `Erro: ${text || ''}`
          : 'Salvo em Clientes';
      }
      // Auto-hide depois de 4s no caso de saved
      if (state === 'saved') {
        clearTimeout(this.#clientSaveBadgeTimer);
        this.#clientSaveBadgeTimer = setTimeout(() => badge.setAttribute('hidden', ''), 4000);
      }
    }
    #clientSaveBadgeTimer = null;

    #setCepStatus(msg, kind) {
      if (!this.#cepStatusEl) return;
      this.#cepStatusEl.textContent = msg;
      this.#cepStatusEl.setAttribute('data-state', kind || 'idle');
    }

    #formatCepDisplay(digits) {
      const d = (digits || '').replace(/\D/g, '').slice(0, 8);
      if (d.length <= 5) return d;
      return `${d.slice(0, 5)}-${d.slice(5)}`;
    }

    /* ════ FRETE ═══════════════════════════════════════════════════ */
    // ═══════════════════════════════════════════════════════════════
    // PRINT / PDF · janela isolada (bypassa app Roar Content Protector)
    // Gera HTML standalone editorial · só "Adicionar ao carrinho normal"
    // do tema NÃO é incluído. Auto-print no load.
    // ═══════════════════════════════════════════════════════════════
    // ═══════════════════════════════════════════════════════════════════
    // AUTORIDADE · Onda 4 PDF Premium · 4 toggles opcionais que injetam
    // páginas extras editoriais (institucional, clientes, depoimentos, projetos)
    // no PDF do orçamento. Conteúdo curado via Edge Fn /quote/authority.
    // ═══════════════════════════════════════════════════════════════════
    #authorityContent = null;
    #authorityFetchPromise = null;
    // PDF-FIX 2 · cache do QR code prefetchado (base64 data URI)
    #qrCodeDataUri = null;

    #hydrateAuthority() {
      const blocks = (this.#quote.client_info?.authority_blocks) || [];
      const selected = new Set(blocks);
      this.querySelectorAll('[data-tsf-authority-check]').forEach(cb => {
        const key = cb.dataset.tsfAuthorityCheck;
        cb.checked = selected.has(key);
      });
      this.#updateAuthorityCount();
      // Pre-fetch async (warm cache · não bloqueia)
      this.#fetchAuthorityContentSafe().catch(() => {});
    }

    #toggleAuthority() {
      const body = this.querySelector('#tsf-quote-authority-body');
      const btn = this.querySelector('[data-tsf-authority-toggle]');
      const label = this.querySelector('[data-tsf-authority-toggle-label]');
      if (!body || !btn) return;
      const isOpen = !body.hasAttribute('hidden');
      if (isOpen) {
        body.setAttribute('hidden', '');
        btn.setAttribute('aria-expanded', 'false');
        if (label) label.textContent = this.#authorityCountText() || 'Adicionar conteúdo editorial ao PDF';
      } else {
        body.removeAttribute('hidden');
        btn.setAttribute('aria-expanded', 'true');
        if (label) label.textContent = 'Recolher';
      }
    }

    #onAuthorityChange(_cb) {
      const blocks = Array.from(this.querySelectorAll('[data-tsf-authority-check]'))
        .filter(c => c.checked)
        .map(c => c.dataset.tsfAuthorityCheck);
      const ci = { ...(this.#quote.client_info || {}), authority_blocks: blocks };
      this.#quote.client_info = ci;
      this.#queueSave({ client_info: ci });
      this.#updateAuthorityCount();
      // Carrega conteúdo se ainda não carregou
      this.#fetchAuthorityContentSafe().catch(() => {});
    }

    #authorityCountText() {
      const n = (this.#quote.client_info?.authority_blocks || []).length;
      if (n === 0) return '';
      return `${n} ${n === 1 ? 'bloco' : 'blocos'} no PDF`;
    }

    #updateAuthorityCount() {
      const countEl = this.querySelector('[data-tsf-authority-count]');
      const n = (this.#quote.client_info?.authority_blocks || []).length;
      if (countEl) {
        countEl.textContent = n === 0
          ? 'Nenhum bloco selecionado'
          : `${n} ${n === 1 ? 'bloco selecionado' : 'blocos selecionados'} · entram no PDF`;
      }
      // Atualiza descrições com dados reais (count de logos/projetos)
      this.#updateAuthorityMeta();
    }

    #updateAuthorityMeta() {
      const c = this.#authorityContent;
      if (!c) return;
      const set = (key, text) => {
        const el = this.querySelector(`[data-tsf-authority-meta="${key}"]`);
        if (el) el.textContent = text;
      };
      if (c.institucional) {
        const inst = c.institucional;
        const titles = ['titulo_1', 'titulo_2', 'titulo_3'].filter(k => inst[k]).length;
        const logos = ['cliente_1', 'cliente_2', 'cliente_3', 'cliente_4', 'cliente_5'].filter(k => inst[k]).length;
        set('institucional', `Heritage editorial · ${titles} ${titles === 1 ? 'card' : 'cards'} + ${logos} ${logos === 1 ? 'logo' : 'logos'} de clientes`);
      } else {
        set('institucional', 'Sem conteúdo institucional cadastrado · adicione em Admin → Content → Metaobjects → Institucional');
      }
      if (c.clients) {
        const n = (c.clients.logo || []).length;
        set('clients', `${n} ${n === 1 ? 'logo corporativo' : 'logos corporativos'} (${c.clients.title || 'Casas que confiaram'})`);
      } else {
        set('clients', 'Sem grupo de clientes cadastrado · adicione em Admin → Content → Metaobjects → Grupo de Clientes');
      }
      const t = (c.testimonials || []).length;
      set('testimonials', t === 0
        ? 'Sem depoimentos cadastrados · adicione em Admin → Content → Metaobjects → Client Proof'
        : `${t} ${t === 1 ? 'depoimento curado' : 'depoimentos curados'}`);
      const p = (c.projects || []).length;
      set('projects', p === 0
        ? 'Sem realizações cadastradas · adicione em Admin → Content → Metaobjects → Toth Projects'
        : `${p} ${p === 1 ? 'projeto curado' : 'projetos curados'} por material/ambiente`);
    }

    async #fetchAuthorityContentSafe() {
      if (this.#authorityContent) return this.#authorityContent;
      if (this.#authorityFetchPromise) return this.#authorityFetchPromise;
      const id = this.#quote?.id;
      if (!id) return null;
      this.#authorityFetchPromise = (async () => {
        const statusEl = this.querySelector('[data-tsf-authority-status]');
        if (statusEl) statusEl.textContent = 'Carregando conteúdo curado…';
        try {
          const res = await fetch(`${QUOTE_ENDPOINT}/authority?id=${encodeURIComponent(id)}`);
          const data = await res.json();
          if (data?.ok && data.content) {
            this.#authorityContent = data.content;
            if (statusEl) statusEl.textContent = 'Conteúdo curado pronto';
            this.#updateAuthorityMeta();
            return data.content;
          }
          if (statusEl) statusEl.textContent = 'Não foi possível carregar';
        } catch (err) {
          if (statusEl) statusEl.textContent = 'Falha de rede';
        }
        return null;
      })();
      return this.#authorityFetchPromise;
    }

    // ═══════════════════════════════════════════════════════════════════
    // GERAR PEDIDOS · Toth team-only · 1 pedido por fornecedor
    // Redireciona pra /pages/pedido?from_quote=<id> que dispara
    // /pedido/create-from-quote via TsfPedidoApp.
    // ═══════════════════════════════════════════════════════════════════
    // ═══════════════════════════════════════════════════════════════════
    // PRODUCT PICKER · Search + add direto no orçamento (⌘K)
    // Fluxo: search Shopify Predictive → renderiza cards → click "Adicionar"
    // → fetch /products/handle.js → POST /quote/add-item → re-render
    // ═══════════════════════════════════════════════════════════════════
    #pickerEl = null;
    #pickerInputEl = null;
    #pickerResultsEl = null;
    #pickerFootMetaEl = null;
    #pickerHintEl = null;
    #pickerSearchTimer = null;
    #pickerSearchAbort = null;
    #pickerActiveFilter = 'all';
    #pickerLastResults = [];
    #pickerActiveIdx = 0;
    #pickerPendingAdds = new Set();

    #openProductPicker() {
      if (!this.#isTothMode()) return; // só faz sentido pra Toth interno
      if (!this.#pickerEl) {
        this.#pickerEl = this.querySelector('[data-tsf-quote-picker]');
        if (!this.#pickerEl) return;
        this.#pickerInputEl = this.querySelector('[data-tsf-quote-picker-input]');
        this.#pickerResultsEl = this.querySelector('[data-tsf-quote-picker-results]');
        this.#pickerFootMetaEl = this.querySelector('[data-tsf-quote-picker-foot-meta]');
        this.#pickerHintEl = this.querySelector('[data-tsf-quote-picker-hint]');
        this.#bindPickerEvents();
        this.#renderPickerFilters();
      }
      this.#pickerEl.removeAttribute('hidden');
      // foco com pequeno delay pra animação CSS rolar
      requestAnimationFrame(() => {
        this.#pickerInputEl?.focus();
        this.#pickerInputEl?.select();
      });
      // se já tem texto, refetch
      if (this.#pickerInputEl?.value?.trim()) {
        this.#runPickerSearch(this.#pickerInputEl.value);
      }
    }

    #closeProductPicker() {
      if (!this.#pickerEl) return;
      this.#pickerEl.setAttribute('hidden', '');
      // limpa qualquer fetch pendente
      this.#pickerSearchAbort?.abort();
      this.#pickerSearchAbort = null;
    }

    #bindPickerEvents() {
      const { signal } = this.#abortController;
      // Close · backdrop + botão X
      this.#pickerEl.addEventListener('click', (e) => {
        if (e.target.closest?.('[data-tsf-quote-picker-close]') ||
            e.target.closest?.('[data-tsf-quote-picker-backdrop]')) {
          this.#closeProductPicker();
        }
      }, { signal });
      // ESC global enquanto picker aberto
      document.addEventListener('keydown', (e) => {
        if (this.#pickerEl?.hasAttribute('hidden')) return;
        if (e.key === 'Escape') { e.preventDefault(); this.#closeProductPicker(); return; }
        if (e.key === 'ArrowDown') { e.preventDefault(); this.#movePickerActive(1); return; }
        if (e.key === 'ArrowUp') { e.preventDefault(); this.#movePickerActive(-1); return; }
        if (e.key === 'Enter' && document.activeElement === this.#pickerInputEl) {
          e.preventDefault();
          const card = this.#pickerResultsEl?.querySelector('.tsf-quote-picker__card.is-active');
          card?.querySelector('[data-tsf-picker-add]')?.click();
        }
      }, { signal });
      // Search input com debounce
      this.#pickerInputEl?.addEventListener('input', () => {
        const q = this.#pickerInputEl.value.trim();
        window.clearTimeout(this.#pickerSearchTimer);
        if (q.length < 2) {
          this.#renderPickerEmpty(q.length === 0 ? 'idle' : 'short');
          return;
        }
        this.#pickerSearchTimer = window.setTimeout(() => this.#runPickerSearch(q), 200);
      }, { signal });
      // Click delegation no grid de resultados
      this.#pickerResultsEl?.addEventListener('click', (e) => {
        const addBtn = e.target.closest?.('[data-tsf-picker-add]');
        if (addBtn) {
          e.preventDefault();
          this.#addPickerProduct(addBtn);
          return;
        }
        const qtyBtn = e.target.closest?.('[data-tsf-picker-qty]');
        if (qtyBtn) {
          e.preventDefault();
          this.#stepPickerQty(qtyBtn);
          return;
        }
        // Click no card seleciona ele
        const card = e.target.closest?.('.tsf-quote-picker__card');
        if (card) this.#setPickerActive(card);
      }, { signal });
    }

    #renderPickerFilters() {
      const wrap = this.querySelector('[data-tsf-quote-picker-filters]');
      if (!wrap) return;
      // Filtros estáticos baseados nos fornecedores cadastrados na Toth
      const filters = [
        { key: 'all', label: 'Todos' },
        { key: 'vendor:heitor', label: 'Heitor' },
        { key: 'vendor:n-correa', label: 'N Correa' },
        { key: 'vendor:diplomata', label: 'Diplomata' },
        { key: 'vendor:cmd', label: 'CMD' },
        { key: 'vendor:aco-mobilia', label: 'Aço Mobília' },
        { key: 'vendor:zomer', label: 'Zomer' },
      ];
      wrap.innerHTML = filters.map(f => `
        <button type="button" class="tsf-quote-picker__filter${f.key === this.#pickerActiveFilter ? ' is-active' : ''}"
                data-tsf-picker-filter="${this.#esc(f.key)}">
          ${this.#esc(f.label)}
        </button>
      `).join('');
      wrap.querySelectorAll('[data-tsf-picker-filter]').forEach(b => {
        b.addEventListener('click', () => {
          this.#pickerActiveFilter = b.dataset.tsfPickerFilter;
          wrap.querySelectorAll('[data-tsf-picker-filter]').forEach(x => x.classList.toggle('is-active', x === b));
          // Refetch com filtro
          const q = this.#pickerInputEl?.value?.trim() || '';
          if (q.length >= 2) this.#runPickerSearch(q);
        });
      });
    }

    async #runPickerSearch(q) {
      // Abort fetch anterior
      this.#pickerSearchAbort?.abort();
      this.#pickerSearchAbort = new AbortController();

      // Composição da query · adiciona vendor filter se ativo
      let searchQuery = q;
      if (this.#pickerActiveFilter && this.#pickerActiveFilter !== 'all' && this.#pickerActiveFilter.startsWith('vendor:')) {
        const vendor = this.#pickerActiveFilter.slice('vendor:'.length);
        // Shopify Predictive aceita query simples · adicionamos vendor filter post-fetch
      }

      this.#renderPickerLoading();
      try {
        // Shopify Predictive Search Suggest API
        const params = new URLSearchParams({
          q: searchQuery,
          'resources[type]': 'product',
          'resources[limit]': '12',
          'resources[options][fields]': 'title,vendor,product_type,variants.title,variants.sku,tag',
        });
        const res = await fetch(`/search/suggest.json?${params.toString()}`, {
          signal: this.#pickerSearchAbort.signal,
        });
        const data = await res.json();
        let products = data?.resources?.results?.products || [];

        // Filtro client-side por vendor (predictive não filtra direto)
        if (this.#pickerActiveFilter && this.#pickerActiveFilter.startsWith('vendor:')) {
          const wantVendor = this.#pickerActiveFilter.slice('vendor:'.length).toLowerCase();
          products = products.filter(p => {
            const v = (p.vendor || '').toLowerCase().replace(/\s+/g, '-').normalize('NFD').replace(/[̀-ͯ]/g, '');
            return v === wantVendor || v.includes(wantVendor) || wantVendor.includes(v);
          });
        }

        this.#pickerLastResults = products;
        this.#renderPickerResults(products, q);
      } catch (err) {
        if (err.name !== 'AbortError') {
          this.#renderPickerError(err.message);
        }
      }
    }

    #renderPickerLoading() {
      if (!this.#pickerResultsEl) return;
      this.#pickerResultsEl.innerHTML = `
        <div class="tsf-quote-picker__loading">
          <span class="tsf-quote-picker__loading-spinner" aria-hidden="true"></span>
          <span>Buscando…</span>
        </div>
      `;
      if (this.#pickerHintEl) this.#pickerHintEl.textContent = 'Buscando';
    }

    #renderPickerError(msg) {
      if (!this.#pickerResultsEl) return;
      this.#pickerResultsEl.innerHTML = `
        <div class="tsf-quote-picker__empty">
          <p>Erro de rede: ${this.#esc(msg)}</p>
          <p class="tsf-quote-picker__empty-hint">Tente de novo.</p>
        </div>
      `;
    }

    #renderPickerEmpty(state = 'idle') {
      if (!this.#pickerResultsEl) return;
      const msgs = {
        idle: { title: 'Digite no campo acima pra buscar produtos.', hint: 'Atalho rápido: <kbd>⌘K</kbd> em qualquer lugar do orçamento' },
        short: { title: 'Digite pelo menos 2 letras.', hint: 'Ex: <em>banqueta</em>, <em>mesa</em>, <em>cadeira</em>…' },
      };
      const m = msgs[state] || msgs.idle;
      this.#pickerResultsEl.innerHTML = `
        <div class="tsf-quote-picker__empty">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="0.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <circle cx="11" cy="11" r="7"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
          </svg>
          <p>${m.title}</p>
          <p class="tsf-quote-picker__empty-hint">${m.hint}</p>
        </div>
      `;
      if (this.#pickerHintEl) this.#pickerHintEl.textContent = '';
      if (this.#pickerFootMetaEl) this.#pickerFootMetaEl.textContent = '—';
    }

    #renderPickerResults(products, query) {
      if (!this.#pickerResultsEl) return;
      const n = products.length;
      if (n === 0) {
        this.#pickerResultsEl.innerHTML = `
          <div class="tsf-quote-picker__empty">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="0.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <circle cx="11" cy="11" r="7"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
            </svg>
            <p>Nenhum produto encontrado para <strong>${this.#esc(query)}</strong>.</p>
            <p class="tsf-quote-picker__empty-hint">Tente outro termo ou remova o filtro de fornecedor.</p>
          </div>
        `;
        if (this.#pickerFootMetaEl) this.#pickerFootMetaEl.textContent = '0 resultados';
        return;
      }

      // Items já no orçamento (pra mostrar badge)
      const existing = new Set((this.#quote?.items || []).map(it => String(it.product_id || it.snapshot?.product_id || '')));

      this.#pickerResultsEl.innerHTML = products.map((p, idx) => this.#pickerCardHtml(p, existing, idx)).join('');
      this.#pickerActiveIdx = 0;
      this.#setPickerActive(this.#pickerResultsEl.querySelector('.tsf-quote-picker__card'));

      if (this.#pickerFootMetaEl) {
        this.#pickerFootMetaEl.textContent = `${n} ${n === 1 ? 'resultado' : 'resultados'} · enter pra adicionar primeiro`;
      }
      if (this.#pickerHintEl) this.#pickerHintEl.textContent = '';
    }

    #pickerCardHtml(p, existingProducts, idx) {
      const productId = String(p.id || '');
      const alreadyAdded = existingProducts.has(productId);
      const variants = Array.isArray(p.variants) ? p.variants : [];
      const hasVariants = variants.length > 1;
      const firstVariant = variants[0] || {};
      // Preço · Shopify retorna como string "1234.56" (BRL) · Math.round funciona com coerção
      const priceCents = p.price ? Math.round(parseFloat(p.price) * 100) : (firstVariant.price ? Math.round(parseFloat(firstVariant.price) * 100) : 0);
      // Imagem · Shopify retorna `featured_image` como OBJETO {url,width,height,alt}
      // OU `image` como STRING. Precisa unwrap pra pegar a URL.
      let imgUrl = '';
      if (p.featured_image) {
        imgUrl = typeof p.featured_image === 'string'
          ? p.featured_image
          : (p.featured_image.url || p.featured_image.src || '');
      }
      if (!imgUrl && p.image) {
        imgUrl = typeof p.image === 'string' ? p.image : (p.image.url || p.image.src || '');
      }
      // Normaliza protocol-relative
      if (imgUrl && imgUrl.startsWith('//')) imgUrl = 'https:' + imgUrl;
      const img = imgUrl;
      const optImg = img ? this.#optImg(img, 200) : '';

      // Variant select (se +1 variant)
      const variantsHtml = hasVariants
        ? `<select class="tsf-quote-picker__variant" data-tsf-picker-variant aria-label="Variante">
             ${variants.map(v => `<option value="${this.#esc(v.id)}" data-price="${v.price || 0}">${this.#esc(v.title || 'Padrão')}</option>`).join('')}
           </select>`
        : '';

      // Cost field só aparece após backend retornar (preenchido on-demand)
      // Mostra estimativa price/cliente direto
      return `
        <article class="tsf-quote-picker__card" data-product-id="${this.#esc(productId)}" data-product-handle="${this.#esc(p.handle || '')}" data-idx="${idx}">
          <figure class="tsf-quote-picker__thumb">
            ${img ? `<img src="${optImg}" alt="" loading="lazy">` : `<span class="tsf-quote-picker__thumb-empty" aria-hidden="true">▢</span>`}
          </figure>
          <div class="tsf-quote-picker__body">
            <header class="tsf-quote-picker__card-head">
              <h3 class="tsf-quote-picker__card-title">${this.#esc(p.title || '')}</h3>
              ${alreadyAdded ? `<span class="tsf-quote-picker__card-badge">já no orçamento</span>` : ''}
            </header>
            <div class="tsf-quote-picker__card-meta">
              ${p.vendor ? `<span>${this.#esc(p.vendor)}</span>` : ''}
              ${p.type ? `<span>${this.#esc(p.type)}</span>` : ''}
            </div>
            <div class="tsf-quote-picker__card-pricing">
              ${priceCents > 0 ? `<span class="tsf-quote-picker__card-price">${money(priceCents)}</span>` : ''}
              <span class="tsf-quote-picker__card-price-label">preço cliente · custo Toth aplicado no add</span>
            </div>
            ${variantsHtml}
          </div>
          <div class="tsf-quote-picker__card-actions">
            <div class="tsf-quote-picker__qty">
              <button type="button" class="tsf-quote-picker__qty-btn" data-tsf-picker-qty="-1" aria-label="Diminuir">−</button>
              <input type="text" inputmode="numeric" class="tsf-quote-picker__qty-input" data-tsf-picker-qty-input value="1" aria-label="Quantidade">
              <button type="button" class="tsf-quote-picker__qty-btn" data-tsf-picker-qty="1" aria-label="Aumentar">+</button>
            </div>
            <button type="button" class="tsf-quote-picker__add" data-tsf-picker-add aria-label="Adicionar ao orçamento">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true">
                <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
              </svg>
              <span>Adicionar</span>
            </button>
          </div>
        </article>
      `;
    }

    #setPickerActive(card) {
      if (!card) return;
      this.#pickerResultsEl?.querySelectorAll('.tsf-quote-picker__card.is-active').forEach(c => c.classList.remove('is-active'));
      card.classList.add('is-active');
      card.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }

    #movePickerActive(delta) {
      const cards = Array.from(this.#pickerResultsEl?.querySelectorAll('.tsf-quote-picker__card') || []);
      if (!cards.length) return;
      const cur = cards.findIndex(c => c.classList.contains('is-active'));
      const next = ((cur < 0 ? 0 : cur + delta) + cards.length) % cards.length;
      this.#setPickerActive(cards[next]);
    }

    #stepPickerQty(btn) {
      const card = btn.closest('.tsf-quote-picker__card');
      const input = card?.querySelector('[data-tsf-picker-qty-input]');
      if (!input) return;
      const delta = parseInt(btn.dataset.tsfPickerQty, 10) || 0;
      const cur = Math.max(1, parseInt(input.value, 10) || 1);
      input.value = String(Math.max(1, cur + delta));
    }

    async #addPickerProduct(btn) {
      const card = btn.closest('.tsf-quote-picker__card');
      if (!card) return;
      const productHandle = card.dataset.productHandle;
      const productId = card.dataset.productId;
      if (!productHandle || !productId) return;
      const qtyInput = card.querySelector('[data-tsf-picker-qty-input]');
      const qty = Math.max(1, parseInt(qtyInput?.value, 10) || 1);
      const variantSelect = card.querySelector('[data-tsf-picker-variant]');
      const selectedVariantId = variantSelect?.value;

      // Anti double-click
      const key = `${productId}:${selectedVariantId || ''}:${qty}`;
      if (this.#pickerPendingAdds.has(key)) return;
      this.#pickerPendingAdds.add(key);

      btn.setAttribute('disabled', '');
      btn.classList.add('is-loading');
      const originalLabel = btn.querySelector('span')?.textContent;
      if (btn.querySelector('span')) btn.querySelector('span').textContent = 'Adicionando…';

      try {
        // 1. Tenta primeiro reaproveitar o SNAPSHOT RICO renderizado pelo Liquid
        //    (snippet tsf-commission-badge.liquid · contém metafields, embalagem, fornecedor)
        //    Se não conseguir, fallback pro snapshot leve via /products/<handle>.js
        let item = await this.#fetchRichProductSnapshot(productHandle);
        let productTitle = item?.snapshot?.title || item?.snapshot?.name || '';

        if (item) {
          // Override qty + variant se vendedor escolheu uma específica
          item.qty = qty;
          if (selectedVariantId) {
            item.variant_id = parseInt(selectedVariantId, 10);
          }
        } else {
          // Fallback · snapshot leve sem metafields (último recurso)
          const prodRes = await fetch(`/products/${productHandle}.js`);
          const product = await prodRes.json();
          const variant = selectedVariantId
            ? product.variants.find(v => String(v.id) === String(selectedVariantId))
            : product.variants[0];
          if (!variant) throw new Error('variante não encontrada');
          productTitle = product.title;

          const featured = (product.images && product.images[0]) || product.featured_image || '';
          let featuredUrl = '';
          if (typeof featured === 'string') featuredUrl = featured;
          else if (featured && typeof featured === 'object') featuredUrl = featured.url || featured.src || '';
          if (featuredUrl && featuredUrl.startsWith('//')) featuredUrl = 'https:' + featuredUrl;

          item = {
            product_id: product.id,
            variant_id: variant.id,
            product_handle: product.handle,
            qty,
            snapshot: {
              title: product.title,
              handle: product.handle,
              url: `/products/${product.handle}`,
              image_url: featuredUrl,
              price_centavos: variant.price,
              metafields: {},
              vendor: product.vendor,
              variant_title: variant.title,
            },
          };
        }

        // 2. QA · save MANUAL · persist:false → backend enriquece (custo real + uid) SEM gravar.
        const res = await fetch(`${QUOTE_ENDPOINT}/add-item`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            specifier_customer_id: this.#ctx.customer_id,
            quote_kind: this.#kind,
            item,
            persist: false,
          }),
        });
        const data = await res.json();
        if (!data.ok || !data.item) throw new Error(data.error || 'falha ao adicionar');

        // 3. Adiciona LOCAL (pendente) · dedup por variant_id → incrementa qty. Grava SÓ no Salvar.
        const newItem = data.item;
        if (!Array.isArray(this.#quote.items)) this.#quote.items = [];
        const existing = this.#quote.items.find((i) => i.variant_id === newItem.variant_id);
        if (existing) {
          existing.qty = (existing.qty || 1) + (newItem.qty || 1);
        } else {
          newItem.order = this.#quote.items.length;
          this.#quote.items.push(newItem);
        }
        this.#queueSave({ items: this.#quote.items });
        // Full re-render (não só renderRows): trata a transição vazio→populado.
        // Num orçamento NOVO o #rowsEl/#toolbarEl/#clientCardEl/#freightBlockEl/#totalBlockEl
        // nascem com [hidden] e o #emptyEl visível; só #render() inverte isso. Sem ele o
        // produto entra nos dados mas não aparece (bug "não consigo adicionar produto").
        this.#render();

        // 4. Toast · deixa claro que é pendente (só grava no Salvar)
        this.#showPickerToast(`✓ ${productTitle.slice(0, 50)}${productTitle.length > 50 ? '…' : ''} adicionado (${qty}x) · salve pra confirmar`);

        // 5. Update card badge
        const titleEl = card.querySelector('.tsf-quote-picker__card-head');
        if (titleEl && !titleEl.querySelector('.tsf-quote-picker__card-badge')) {
          titleEl.insertAdjacentHTML('beforeend', `<span class="tsf-quote-picker__card-badge">já no orçamento</span>`);
        }

        // 6. Reset qty
        if (qtyInput) qtyInput.value = '1';

      } catch (err) {
        this.#showPickerToast(`✗ Erro: ${err.message}`, 'error');
      } finally {
        this.#pickerPendingAdds.delete(key);
        btn.removeAttribute('disabled');
        btn.classList.remove('is-loading');
        if (btn.querySelector('span') && originalLabel) btn.querySelector('span').textContent = originalLabel;
      }
    }

    // Cache de snapshots ricos · evita refetch quando user adiciona mesmo produto várias vezes
    #richSnapshotCache = new Map();

    // Busca snapshot COMPLETO do produto via Edge Function (GraphQL Admin API).
    // Equivalente server-side ao snippet tsf-commission-badge.liquid · paridade total
    // com o flow "Adicionar ao orçamento" da página de produto.
    async #fetchRichProductSnapshot(handle) {
      if (!handle) return null;
      if (this.#richSnapshotCache.has(handle)) {
        return JSON.parse(JSON.stringify(this.#richSnapshotCache.get(handle)));
      }
      try {
        const res = await fetch(`${QUOTE_ENDPOINT}/product-snapshot?handle=${encodeURIComponent(handle)}`);
        if (!res.ok) return null;
        const data = await res.json();
        if (!data?.ok || !data.item) return null;
        this.#richSnapshotCache.set(handle, JSON.parse(JSON.stringify(data.item)));
        return data.item;
      } catch (err) {
        console.warn('[tsf-picker] rich snapshot fetch failed for', handle, err);
        return null;
      }
    }

    #showPickerToast(msg, kind = 'success') {
      const toast = this.querySelector('[data-tsf-quote-picker-toast]');
      if (!toast) return;
      toast.textContent = msg;
      toast.setAttribute('data-kind', kind);
      toast.removeAttribute('hidden');
      window.clearTimeout(this.#_pickerToastTimer);
      this.#_pickerToastTimer = window.setTimeout(() => toast.setAttribute('hidden', ''), 3000);
    }
    #_pickerToastTimer = null;

    // Salva alterações pendentes e volta pra lista admin-orcamentos
    async #saveAndBack() {
      try {
        await this.#flushSave();
        // Pequeno delay pra dar feedback visual antes do redirect
        this.#updateSaveStatus('saved');
        setTimeout(() => {
          window.location.href = '/pages/admin-orcamentos';
        }, 300);
      } catch (err) {
        alert('Erro ao salvar: ' + err.message + '\n\nNão vou redirecionar pra você não perder alterações.');
      }
    }

    // Excluir orçamento · só permite se status='draft'
    async #deleteQuote() {
      if (!this.#quote?.id) return;
      const cliente = this.#quote.client_info?.name || 'sem nome';
      const itemsN = (this.#quote.items || []).length;
      const ok = confirm(
        `Excluir este orçamento permanentemente?\n\n` +
        `Cliente: ${cliente}\n` +
        `Items: ${itemsN}\n\n` +
        `Esta ação NÃO PODE ser desfeita. Só funciona se o orçamento ainda estiver em rascunho.`
      );
      if (!ok) return;
      try {
        const res = await fetch(`${QUOTE_ENDPOINT}/delete`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: this.#quote.id }),
        });
        const data = await res.json();
        if (!data.ok) {
          if (data.error === 'cannot_delete_locked') {
            alert(data.message || 'Não foi possível excluir · orçamento já foi enviado/fechado.');
            return;
          }
          throw new Error(data.error || 'falha');
        }
        alert(`Orçamento excluído.`);
        window.location.href = '/pages/admin-orcamentos';
      } catch (err) {
        alert('Erro ao excluir: ' + err.message);
      }
    }

    async #openPedidoFromQuote() {
      // Onda 6.11 · Fluxo correto orçamento → venda → pedidos
      // Onda 6.13A · #linkedSale já carregado no #fetchQuote · zero fetch redundante
      if (!this.#isTothMode()) return;
      if (!this.#quote?.id) return;
      if (!this.#quote?.items?.length) {
        alert('Adicione itens ao orçamento antes de converter em venda.');
        return;
      }

      // Se já tem venda vinculada · navega direto (sem confirm intermediário)
      if (this.#linkedSale) {
        window.location.href = `/pages/admin-venda?id=${encodeURIComponent(this.#linkedSale.id)}`;
        return;
      }

      // Sem venda · abre wizard de conversão (cliente + condição de pagamento)
      TsfSaleConversionWizard.open({
        quote: this.#quote,
        onConfirm: (sale) => {
          window.location.href = `/pages/admin-venda?id=${encodeURIComponent(sale.id)}`;
        },
      });
    }

    // Onda 6.13A · Indica visualmente que o quote já virou venda.
    // Render idempotente: cria banner uma vez (topo do <tsf-quote-builder>) e
    // mantém sincronizado com #linkedSale. Botão "Converter em venda" vira
    // "Ver venda VND-XXXX" com mesmo handler (#openPedidoFromQuote checa).
    #renderLinkedSaleIndicator() {
      const toPedidoBtn = this.querySelector('[data-tsf-quote-to-pedido]');
      let banner = this.querySelector('[data-tsf-quote-converted-banner]');

      if (!this.#linkedSale) {
        // Sem venda · esconde banner, restaura label original do botão
        if (banner) banner.hidden = true;
        if (toPedidoBtn) {
          toPedidoBtn.classList.remove('is-converted');
          toPedidoBtn.setAttribute('title', 'Converte orçamento em venda · depois você gera pedidos pra fábrica na tela da venda');
          const span = toPedidoBtn.querySelector('span');
          if (span) span.textContent = 'Converter em venda';
        }
        return;
      }

      // Tem venda · injeta banner se necessário + transforma botão
      const sale = this.#linkedSale;
      if (!banner) {
        banner = document.createElement('a');
        banner.className = 'tsf-quote-converted-banner';
        banner.setAttribute('data-tsf-quote-converted-banner', '');
        // Insere no topo (antes do primeiro filho do <tsf-quote-builder>)
        this.insertBefore(banner, this.firstChild);
      }
      banner.href = `/pages/admin-venda?id=${encodeURIComponent(sale.id)}`;
      banner.hidden = false;
      banner.innerHTML = `
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>
        <span class="tsf-quote-converted-banner__text">Este orçamento já virou venda <strong>${this.#escapeHtml(sale.numero_venda)}</strong></span>
        <span class="tsf-quote-converted-banner__cta">Abrir venda
          <svg width="12" height="8" viewBox="0 0 14 10" fill="none" aria-hidden="true"><path fill="currentColor" d="M8.537.808a.5.5 0 0 1 .817-.162l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 1 1-.708-.708L11.793 5.5H1a.5.5 0 0 1 0-1h10.793L8.646 1.354a.5.5 0 0 1-.109-.546Z"/></svg>
        </span>
      `;

      // Transforma o botão · mesmo handler navega direto pra venda
      if (toPedidoBtn) {
        toPedidoBtn.classList.add('is-converted');
        toPedidoBtn.setAttribute('title', `Ir pra venda ${sale.numero_venda}`);
        const span = toPedidoBtn.querySelector('span');
        if (span) span.textContent = `Ver venda ${sale.numero_venda}`;
      }
    }

    #escapeHtml(s) {
      return String(s || '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
    }

    // PDF-FIX 2 · Prefetch QR code como base64 data URI · evita img vazia no PDF
    // Tenta serviços em ordem: qrserver → google charts. Salva em #qrCodeDataUri pra reuso.
    async #prefetchQrCode() {
      if (this.#qrCodeDataUri) return; // cache
      const number = this.#quote?.numero_orcamento || 'orçamento';
      const phone = '5518996714293';
      const msg = encodeURIComponent(`Olá! Recebi o orçamento ${number} e gostaria de prosseguir.`);
      const wa = `https://wa.me/${phone}?text=${msg}`;
      const services = [
        `https://api.qrserver.com/v1/create-qr-code/?size=320x320&margin=0&data=${encodeURIComponent(wa)}`,
        `https://chart.googleapis.com/chart?cht=qr&chs=320x320&chl=${encodeURIComponent(wa)}`,
      ];
      for (const url of services) {
        try {
          const r = await fetch(url, { mode: 'cors' });
          if (!r.ok) continue;
          const blob = await r.blob();
          const dataUri = await new Promise((resolve) => {
            const fr = new FileReader();
            fr.onload = () => resolve(typeof fr.result === 'string' ? fr.result : null);
            fr.onerror = () => resolve(null);
            fr.readAsDataURL(blob);
          });
          if (dataUri && dataUri.startsWith('data:image')) {
            this.#qrCodeDataUri = dataUri;
            return;
          }
        } catch (e) {
          console.warn('[QR prefetch] service failed:', url, e);
        }
      }
      // se nenhum serviço funcionou, deixa null → fallback URL direta no qrUrl
    }

    async #openPrintWindow() {
      if (!this.#quote?.items?.length) return;
      // window.open vazia primeiro pra evitar popup blocker (gesto do user)
      const w = window.open('', '_blank', 'width=900,height=1200');
      if (!w) {
        alert('Permita pop-ups pra gerar o PDF. Clique no ícone de bloqueio na barra de endereços.');
        return;
      }
      // CRÍTICO · força flush de qualquer save pendente antes de gerar PDF.
      // Garante que mudanças recentes (ex: apagar carta do consultor) estejam
      // persistidas e que `this.#quote` reflita o servidor antes do build.
      try { await this.#flushSave(); } catch {}
      // Loading placeholder enquanto busca conteúdo de autoridade (se selecionado)
      const hasAuthority = (this.#quote.client_info?.authority_blocks || []).length > 0;
      if (hasAuthority && !this.#authorityContent) {
        w.document.open();
        w.document.write('<!DOCTYPE html><html><head><meta charset="utf-8"><title>Gerando…</title><style>body{font-family:Montserrat,sans-serif;display:grid;place-items:center;min-height:100vh;margin:0;color:#1a1918}.l{font-size:11px;letter-spacing:.18em;text-transform:uppercase;color:#A16207}</style></head><body><div><div class="l">Curando conteúdo editorial…</div></div></body></html>');
        w.document.close();
        try { await this.#fetchAuthorityContentSafe(); } catch {}
      }
      // PDF-FIX 2 · Prefetch QR code como base64 data URI · evita img vazia no PDF
      try { await this.#prefetchQrCode(); } catch {}
      const html = this.#buildPrintDocument();
      w.document.open();
      w.document.write(html);
      w.document.close();
      // Espera renderização completa (incl. imagens) antes de print
      const printWhenReady = () => {
        try {
          const imgs = Array.from(w.document.images || []);
          const pending = imgs.filter(img => !img.complete);
          if (pending.length === 0) {
            w.focus();
            w.print();
            return;
          }
          // Espera todas as imagens carregarem (max 5s)
          let loaded = 0;
          const checkDone = () => {
            loaded++;
            if (loaded >= pending.length) { w.focus(); w.print(); }
          };
          pending.forEach(img => {
            img.addEventListener('load', checkDone);
            img.addEventListener('error', checkDone);
          });
          setTimeout(() => { try { w.focus(); w.print(); } catch {} }, 5000);
        } catch (e) {
          try { w.print(); } catch {}
        }
      };
      if (w.document.readyState === 'complete') printWhenReady();
      else w.addEventListener('load', printWhenReady, { once: true });
    }

    #buildPrintDocument() {
      const q = this.#quote;
      const ci = q.client_info || {};
      const isToth = this.#isTothMode();
      const globalPct = parseFloat(this.#markupInput?.value || q.default_markup_pct || 0);

      // Onda 7 · numero_orcamento persistido no banco (TOTH-2026-ORC-1001+).
      // Fallback gerado on-the-fly se ainda não populado (quotes pré-Onda 7).
      const created = q.created_at ? new Date(q.created_at) : new Date();
      const year = created.getFullYear();
      let quoteNumber = q.numero_orcamento || '';
      if (!quoteNumber) {
        const digitsOnly = (q.id || '').replace(/[^0-9]/g, '');
        const suffix = digitsOnly.slice(-4).padStart(4, '0');
        quoteNumber = `TOTH-${year}-ORC-${suffix}`;
      }
      const fmtDate = (d) => new Intl.DateTimeFormat('pt-BR', { day: '2-digit', month: 'long', year: 'numeric' }).format(d);
      const dateStr = fmtDate(created);
      // Validade configurável pelo vendor (default 30 dias)
      const validDays = Math.max(1, Math.min(365, parseInt(ci.valid_days, 10) || 30));
      const validUntil = new Date(created.getTime() + validDays * 24 * 60 * 60 * 1000);
      const validUntilStr = fmtDate(validUntil);

      // Vendedor (toth_internal) ou specifier
      const vendor = this.#ctx || {};
      const vendorName = vendor.first_name ? `${vendor.first_name} ${vendor.last_name || ''}`.trim() : 'Toth Móveis';
      const vendorEmail = vendor.email || 'contato@tothmoveis.com.br';
      // Display name elegante: se vendor é só "Toth" (admin/team account), expande pra "Toth Móveis"
      // Senão usa primeiro nome (Ex: "Valter J T Franco" → "Valter")
      const vendorDisplayName = (() => {
        const parts = vendorName.split(' ').filter(Boolean);
        if (parts.length === 0) return 'Toth Móveis';
        if (parts.length === 1) return parts[0].toLowerCase() === 'toth' ? 'Toth Móveis' : parts[0];
        return parts[0];
      })();

      // Items
      const items = (q.items || []).slice().sort((a, b) => (a.order ?? 0) - (b.order ?? 0));

      // Compute totals e items pra render
      let totalProdutos = 0;
      const rowsHtml = items.map((item, idx) => {
        const s = item.snapshot || {};
        const ov = item.overrides || {};
        const tothUnit =
          (typeof ov.cost_centavos === 'number') ? ov.cost_centavos :
          (typeof s.cost_centavos === 'number' && s.cost_centavos > 0) ? s.cost_centavos :
          (s.price_centavos || 0);
        let nativeMarkupPct = null;
        if (isToth && s.price_centavos && s.cost_centavos && s.cost_centavos > 0) {
          nativeMarkupPct = ((s.price_centavos - s.cost_centavos) / s.cost_centavos) * 100;
        }
        const markupSource = ov.markup_source || (item.markup_pct != null ? 'manual' : null);
        let useMarkup;
        if (markupSource === 'manual') useMarkup = item.markup_pct;
        else if (markupSource === 'global') useMarkup = globalPct;
        else if (isToth && nativeMarkupPct != null) useMarkup = nativeMarkupPct;
        else useMarkup = (item.markup_pct != null) ? item.markup_pct : globalPct;
        const clienteUnit = tothUnit * (1 + useMarkup / 100);
        const clienteTotal = clienteUnit * (item.qty || 1);
        totalProdutos += clienteTotal;

        const cor = (ov.cor != null) ? ov.cor : (s.metafields?.cor || '');
        const materiais = (ov.materiais != null) ? ov.materiais : (s.metafields?.materiais || '');
        const dimens = (ov.dimens_es != null) ? ov.dimens_es : (s.metafields?.dimens_es || '');
        const prazoProd = (ov.prazo != null) ? ov.prazo : (s.metafields?.prazo || 0);
        const prazoTotal = prazoProd > 0 ? Number(prazoProd) + 14 : 0;
        const photoUrl = item.selected_photo_url || s.image_url || '';

        // PDF-FIX 4 · Materiais com texto longo (ESTRUTURA:... ESPECIFICAÇÕES:...) quebra o layout do PDF.
        // Extrai só palavras-chave de materiais (primeiras 120 chars · até próximo "." ou ";")
        const compactMateriais = (() => {
          if (!materiais) return null;
          let m = String(materiais).trim();
          // Se tem prefixo tipo "ESTRUTURA:" remove até o primeiro substantivo
          m = m.replace(/^(ESTRUTURA|MATERIAIS|ESPECIFICAÇÕES|COMPOSIÇÃO)[:\s-]+/i, '');
          // Pega só primeira frase (até ponto, ponto-vírgula ou quebra de linha)
          const stop = m.search(/[.;\n]/);
          if (stop > 30 && stop < 140) m = m.slice(0, stop);
          // Hard limit 140 chars + ellipsis se ainda for grande
          if (m.length > 140) m = m.slice(0, 137).replace(/[\s,]+$/, '') + '…';
          return m.trim();
        })();
        const specs = [
          { label: 'Acabamento', value: cor },
          { label: 'Materiais', value: compactMateriais },
          { label: 'Dimensões', value: dimens },
          { label: 'Prazo', value: prazoTotal > 0 ? `${prazoTotal} dias úteis` : null },
        ].filter(sp => sp.value);

        return `
          <article class="item">
            <div class="item__index">${String(idx + 1).padStart(2, '0')}</div>
            <div class="item__media">${photoUrl ? `<img src="${this.#optImg(photoUrl, 480)}" alt="">` : ''}</div>
            <div class="item__body">
              <h3 class="item__title">${this.#escHtml(s.title || '')}</h3>
              <dl class="item__specs">
                ${specs.map(sp => `<div><dt>${this.#escHtml(sp.label)}</dt><dd>${this.#escHtml(sp.value)}</dd></div>`).join('')}
              </dl>
              <div class="item__pricing">
                <span class="item__qty">${item.qty || 1} × ${money(clienteUnit)}</span>
                <span class="item__total">${money(clienteTotal)}</span>
              </div>
            </div>
          </article>`;
      }).join('');

      // F-fix · PDF usa o frete PERSISTIDO (auto OU avulso), não o #freightTotal efêmero (que só guarda o cálculo Vipex)
      const freightOriginal = (typeof this.#quote?.frete_centavos === 'number') ? this.#quote.frete_centavos : (this.#freightTotal || 0);
      const freteIsVipexAuto = (this.#quote?.frete_centavos != null && this.#quote?.native_frete_centavos != null && this.#quote.frete_centavos === this.#quote.native_frete_centavos);
      const cardPct = parseFloat(ci.card_surcharge_pct) || 0;
      const denomCard = 1 - cardPct / 100;
      // Frete ajustado já com taxa do cartão embutida (sempre)
      const freightAdjusted = (freightOriginal > 0 && cardPct > 0 && denomCard > 0)
        ? (freightOriginal / denomCard)
        : freightOriginal;
      // FREIGHT-TOGGLE · só inclui frete no total se habilitado. Quando OFF, omite linha completamente.
      const freightEnabled = ((ci.freight_mode || 'charge').toString().toLowerCase() !== 'none');
      const freightInTotal = freightEnabled ? freightAdjusted : 0;
      // 2026-06-30 · desconto do cliente sobre produtos (não incide no frete)
      const descontoPdf = Math.max(0, parseInt(ci.discount_centavos, 10) || 0);
      const produtosNetPdf = Math.max(0, totalProdutos - descontoPdf);
      const totalCliente = produtosNetPdf + freightInTotal;
      // 2026-06-30 · desconto negociado JÁ É o à vista → não soma os 8% do Pix (um OU outro)
      const totalPix = descontoPdf > 0 ? totalCliente : totalCliente * 0.92;

      // Cliente info
      const clientName = this.#escHtml(ci.name || '—');
      const clientNameRaw = ci.name || '';
      // Email + WhatsApp em linhas separadas no PDF; fallback pro contact antigo
      const clientEmail = ci.email || (ci.contact && ci.contact.includes('@') ? ci.contact : '');
      const clientWhatsapp = ci.whatsapp || (ci.contact && !ci.contact.includes('@') ? ci.contact : '');
      // PDF-FIX 3 · CEP formatado com hífen (00000-000) · era 19050310 sem máscara
      const cepDigits = String(ci.cep || '').replace(/\D/g, '');
      const cepFormatted = cepDigits.length === 8 ? `${cepDigits.slice(0,5)}-${cepDigits.slice(5)}` : (ci.cep || '');
      const cep = this.#escHtml(cepFormatted);
      const addr = this.#escHtml(ci.address_text || '');
      const consultantMessage = (ci.consultant_message || '').trim();

      // Capa · escolhe hero photo do primeiro item com image_url
      const heroPhoto = items.reduce((acc, it) => acc || it.snapshot?.image_url || it.snapshot?.image || '', '');

      // QR WhatsApp · prefetch como base64 evita falha de carregamento no print
      const whatsappPhone = '5518996714293';
      const whatsappMsg = encodeURIComponent(
        `Olá! Recebi o orçamento ${quoteNumber} e gostaria de prosseguir.`
      );
      const whatsappUrl = `https://wa.me/${whatsappPhone}?text=${whatsappMsg}`;
      // PDF-FIX 2 · Cache pré-resolvido pelo #openPrintWindow (await this.#prefetchQrCode)
      // Se não tem data URI cached, fallback pra URL direta (legacy behavior)
      const qrUrl = this.#qrCodeDataUri || `https://api.qrserver.com/v1/create-qr-code/?size=320x320&margin=0&data=${encodeURIComponent(whatsappUrl)}`;

      // Total quantity pra capa
      const totalQty = items.reduce((acc, it) => acc + (it.qty || 1), 0);

      const css = this.#printDocumentCss();
      return `<!DOCTYPE html><html lang="pt-BR"><head><meta charset="utf-8"><title>${quoteNumber} · Orçamento Toth Móveis</title><style>${css}</style></head><body>

${this.#buildCoverPageHtml({ heroPhoto, clientName, clientNameRaw, quoteNumber, dateStr, validUntilStr, totalQty, totalCliente, vendorName, vendorDisplayName })}

${consultantMessage ? this.#buildConsultantLetterHtml({ consultantMessage, vendorName, vendorEmail, dateStr, clientNameRaw }) : ''}

<div class="doc">
  <header class="header">
    <div class="header__brand">
      <img src="${this.#optImg(TOTH_BRAND.logoUrl, 400)}" alt="Toth Móveis" class="header__logo-img">
      <div class="header__tagline">Móveis de alto padrão · curadoria autoral</div>
    </div>
    <div class="header__meta">
      <div class="header__meta-label">Orçamento</div>
      <div class="header__meta-number">№ ${quoteNumber}</div>
      <div class="header__meta-date">${dateStr}</div>
      <div class="header__meta-valid">Válido até ${validUntilStr}</div>
    </div>
  </header>

  <section class="parties">
    <div class="party">
      <div class="party__eyebrow">Para</div>
      <div class="party__name">${clientName}</div>
      ${clientEmail ? `<div class="party__line">${this.#escHtml(clientEmail)}</div>` : ''}
      ${clientWhatsapp ? `<div class="party__line">${this.#escHtml(clientWhatsapp)}</div>` : ''}
      ${(!clientEmail && !clientWhatsapp) ? `<div class="party__line">—</div>` : ''}
      ${cep ? `<div class="party__line">CEP ${cep}${addr ? ` · ${addr}` : ''}</div>` : ''}
    </div>
    <div class="party party--right">
      <div class="party__eyebrow">De</div>
      <div class="party__name">${this.#escHtml(vendorName)}</div>
      <div class="party__line">Toth Móveis</div>
      <div class="party__line">${this.#escHtml(vendorEmail)}</div>
      <div class="party__line">+55 (18) 99671-4293</div>
    </div>
  </section>

  <section class="items">
    ${rowsHtml}
  </section>

  <section class="footer-totals">
    <div class="payments">
      <div class="payments__eyebrow">Formas de pagamento</div>
      <div class="payments__row payments__row--highlight">
        <span>À vista no Pix · ${descontoPdf > 0 ? 'desconto negociado já aplicado' : '8% de desconto em tudo'}</span>
        <strong>${money(totalPix)}</strong>
      </div>
      <div class="payments__row">
        <span>Cartão de crédito · à vista ou parcelado sem juros</span>
        <strong>${money(totalCliente)}</strong>
      </div>
      ${(freightEnabled && freightAdjusted > 0) ? `<div class="payments__row payments__row--logi"><span>Frete ${freteIsVipexAuto ? 'Vipex ' : ''}Portaria${cep ? ` · CEP ${cep}` : ''}</span><strong>${money(freightAdjusted)}</strong></div>` : ''}
    </div>
    <div class="grand-total">
      <div class="grand-total__label">Total</div>
      <div class="grand-total__value">${money(totalCliente)}</div>
    </div>
  </section>

  ${this.#buildAuthorityPagesHtml()}

  <footer class="legal">
    <div class="legal__row">
      <span>GARANTIA</span><strong>3 meses contra defeitos de fabricação</strong>
    </div>
    <div class="legal__row">
      <span>FABRICAÇÃO</span><strong>Brasil · 16 anos de mercado</strong>
    </div>
    <div class="legal__row">
      <span>PERSONALIZAÇÃO</span><strong>Acabamento sob consulta</strong>
    </div>
    <div class="legal__brand">
      <span>${this.#escHtml(vendorName)} · ${this.#escHtml(vendorEmail)}</span>
      <span>www.tothmoveis.com.br · Presidente Prudente · SP</span>
    </div>
  </footer>
</div>

${this.#buildClosingPageHtml({ quoteNumber, vendorName, vendorDisplayName, vendorEmail, whatsappUrl, qrUrl, totalCliente, totalPix, validUntilStr })}

</body></html>`;
    }

    // ─── CAPA · primeira página editorial cinematográfica ────────────
    #buildCoverPageHtml({ heroPhoto, clientName, clientNameRaw, quoteNumber, dateStr, validUntilStr, totalQty, totalCliente, vendorName, vendorDisplayName }) {
      // Quando há foto hero, usa layout split 60/40. Sem foto, vai pra full editorial.
      const hasHero = !!heroPhoto;
      const audienceLine = clientNameRaw
        ? `Proposta para <strong>${clientName}</strong>`
        : `Proposta Comercial`;

      return `
<section class="cover" aria-label="Capa do orçamento">
  ${hasHero ? `
    <div class="cover__hero">
      <img src="${this.#optImg(heroPhoto, 1100)}" alt="" loading="eager">
      <div class="cover__hero-overlay" aria-hidden="true"></div>
      <div class="cover__hero-mark">
        <span class="cover__hero-mark-eyebrow">Curadoria Toth</span>
        <span class="cover__hero-mark-year">MMXXVI</span>
      </div>
    </div>
  ` : '<div class="cover__hero cover__hero--blank" aria-hidden="true"></div>'}

  <div class="cover__caption">
    <header class="cover__brand">
      <img src="${this.#optImg(TOTH_BRAND.logoUrl, 600)}" alt="Toth Móveis" class="cover__logo-img">
      <div class="cover__tagline">Móveis Autorais · Presidente Prudente · Brasil</div>
    </header>

    <div class="cover__title-wrap">
      <span class="cover__eyebrow">${audienceLine}</span>
      <h1 class="cover__title">Uma proposta<br/>desenhada para você.</h1>
      <div class="cover__rule" aria-hidden="true"></div>
      <div class="cover__meta">
        <span class="cover__meta-num">${this.#escHtml(quoteNumber)}</span>
        <span class="cover__meta-dot" aria-hidden="true">·</span>
        <span>${this.#escHtml(dateStr)}</span>
        <span class="cover__meta-dot" aria-hidden="true">·</span>
        <span class="cover__meta-valid">Válida até ${this.#escHtml(validUntilStr)}</span>
      </div>
      <div class="cover__proposal-stats">
        <span><strong>${totalQty}</strong> ${totalQty === 1 ? 'produto curado' : 'produtos curados'}</span>
        <span class="cover__stats-dot" aria-hidden="true">·</span>
        <span><strong>${money(totalCliente)}</strong> valor da proposta</span>
        <span class="cover__stats-dot" aria-hidden="true">·</span>
        <span>Consultor <strong>${this.#escHtml(vendorDisplayName || vendorName)}</strong></span>
      </div>
    </div>

    <footer class="cover__foot">
      <div class="cover__credentials">
        <span class="cover__credentials-eyebrow">Toth Móveis · em números</span>
        <div class="cover__credentials-row">
          ${TOTH_BRAND.metrics.map(m => `
            <div class="cover__credential">
              <strong>${this.#escHtml(m.number)}</strong>
              <span>${this.#escHtml(m.label)}</span>
            </div>
          `).join('')}
        </div>
      </div>
      <div class="cover__trusted">
        <span class="cover__trusted-label">Marcas que confiam em nós</span>
        <span class="cover__trusted-list">${TOTH_BRAND.trustedBrands.map(b => this.#escHtml(b)).join(' · ')}</span>
      </div>
    </footer>
  </div>
</section>`;
    }

    // ─── CARTA DO CONSULTOR · página editorial pessoal ───────────────
    #buildConsultantLetterHtml({ consultantMessage, vendorName, vendorEmail, dateStr, clientNameRaw }) {
      const greeting = clientNameRaw
        ? `Olá, ${this.#escHtml(clientNameRaw.split(' ')[0])}.`
        : `Olá.`;
      // Preserva quebras de linha do textarea no PDF
      const messageHtml = this.#escHtml(consultantMessage).replace(/\n\n+/g, '</p><p>').replace(/\n/g, '<br>');

      return `
<section class="letter" aria-label="Mensagem do consultor">
  <div class="letter__inner">
    <header class="letter__head">
      <span class="letter__eyebrow">Da mesa do consultor</span>
      <div class="letter__rule" aria-hidden="true"></div>
    </header>

    <div class="letter__body">
      <p class="letter__greeting">${greeting}</p>
      <p>${messageHtml}</p>
    </div>

    <footer class="letter__sign">
      <div class="letter__signature">
        <span class="letter__signature-name">${this.#escHtml(vendorName)}</span>
        <span class="letter__signature-role">Consultor Toth Móveis</span>
        <span class="letter__signature-mail">${this.#escHtml(vendorEmail)}</span>
      </div>
      <div class="letter__date">${this.#escHtml(dateStr)}</div>
    </footer>
  </div>
</section>`;
    }

    // ─── FECHAMENTO · última página · QR WhatsApp + próximos passos ──
    #buildClosingPageHtml({ quoteNumber, vendorName, vendorDisplayName, vendorEmail, whatsappUrl, qrUrl, totalCliente, totalPix, validUntilStr }) {
      return `
<section class="closing" aria-label="Próximos passos">
  <header class="closing__head">
    <span class="closing__eyebrow">Como prosseguir</span>
    <h2 class="closing__title">Três passos<br/>até a sua casa.</h2>
    <div class="closing__rule" aria-hidden="true"></div>
  </header>

  <div class="closing__grid">
    <article class="closing__step">
      <span class="closing__step-num">01</span>
      <h3 class="closing__step-title">Converse</h3>
      <p class="closing__step-desc">Tire dúvidas ou peça ajustes pelo WhatsApp do seu consultor. Cada peça pode ser personalizada.</p>
    </article>
    <article class="closing__step">
      <span class="closing__step-num">02</span>
      <h3 class="closing__step-title">Aprove</h3>
      <p class="closing__step-desc">Validada a proposta, enviamos o link de pagamento Pix com 8% de desconto ou cartão sem juros.</p>
    </article>
    <article class="closing__step">
      <span class="closing__step-num">03</span>
      <h3 class="closing__step-title">Receba</h3>
      <p class="closing__step-desc">Produção iniciada, acompanhe cada fase até o agendamento de entrega na sua porta.</p>
    </article>
  </div>

  <aside class="closing__cta">
    <div class="closing__cta-qr">
      <img src="${this.#escAttr(qrUrl)}" alt="QR code pra abrir WhatsApp" loading="lazy" width="160" height="160">
    </div>
    <div class="closing__cta-body">
      <span class="closing__cta-eyebrow">Aponte a câmera</span>
      <h3 class="closing__cta-name">Falar com ${this.#escHtml(vendorDisplayName || vendorName)}</h3>
      <p class="closing__cta-desc">Atendimento personalizado, consultoria de ambiente e suporte até a entrega.</p>
      <a class="closing__cta-link" href="${this.#escAttr(whatsappUrl)}">+55 (18) 99671-4293</a>
      <span class="closing__cta-mail">${this.#escHtml(vendorEmail)}</span>
    </div>
    <div class="closing__cta-summary">
      <div class="closing__cta-summary-row">
        <span>Valor da proposta</span>
        <strong>${money(totalCliente)}</strong>
      </div>
      <div class="closing__cta-summary-row closing__cta-summary-row--pix">
        <span>À vista no Pix · 8% off</span>
        <strong>${money(totalPix)}</strong>
      </div>
      <div class="closing__cta-summary-foot">
        <span>${this.#escHtml(quoteNumber)}</span>
        <span>Válida até ${this.#escHtml(validUntilStr)}</span>
      </div>
    </div>
  </aside>

  <footer class="closing__brand">
    <img src="${this.#optImg(TOTH_BRAND.logoUrl, 280)}" alt="Toth Móveis" class="closing__brand-mark-img">
    <div class="closing__brand-info">
      <span>Curadoria · Marcenaria · Mobiliário sob medida</span>
      <span>Showroom: ${this.#escHtml(TOTH_BRAND.showroom)}</span>
      <span>Fábrica: ${this.#escHtml(TOTH_BRAND.factory)}</span>
      <span>${this.#escHtml(TOTH_BRAND.site)} · ${this.#escHtml(TOTH_BRAND.phone)}</span>
    </div>
  </footer>
</section>`;
    }

    // Constrói as páginas extras do PDF baseado nas escolhas do vendedor.
    // Cada bloco selecionado em quote.client_info.authority_blocks adiciona
    // uma seção page-break · só renderiza se o conteúdo tiver chegado.
    #buildAuthorityPagesHtml() {
      // 2026-06-29 · delega pro helper compartilhado (de-dup · a venda usa o MESMO)
      return tsfBuildAuthorityPagesHtml(this.#quote?.client_info?.authority_blocks, this.#authorityContent, { scopePhrase: 'deste orçamento' });
    }

    #printDocumentCss() {
      return `
        @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;0,500;1,300;1,400&family=Montserrat:wght@200;300;400;500;600&display=swap');
        *,*:before,*:after { box-sizing: border-box; margin: 0; padding: 0; }
        @page { size: A4; margin: 14mm 16mm; }
        @page :first { margin: 0; }
        html,body { background: #fff; color: #1a1918; font-family: 'Montserrat', -apple-system, BlinkMacSystemFont, 'Helvetica Neue', Arial, sans-serif; font-weight: 300; line-height: 1.45; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
        .doc { max-width: 178mm; margin: 0 auto; padding: 0; }
        /* HEADER */
        .header { display: flex; justify-content: space-between; align-items: flex-start; padding-bottom: 14mm; border-bottom: 1px solid rgba(26, 25, 24, 0.12); position: relative; }
        .header::after { content: ''; position: absolute; left: 0; bottom: -1px; width: 18mm; height: 1.6px; background: #A16207; }
        .header__brand { }
        .header__logo { font-size: 28pt; font-weight: 200; letter-spacing: 0.06em; line-height: 1; color: #1a1918; }
        .header__tagline { margin-top: 4mm; font-size: 8pt; letter-spacing:.18em; text-transform: uppercase; color: rgba(26,25,24,0.55); font-weight: 400; }
        .header__meta { text-align: right; }
        .header__meta-label { font-size: 8pt; font-weight: 500; letter-spacing:.18em; text-transform: uppercase; color: #A16207; margin-bottom: 4mm; }
        .header__meta-number { font-size: 12pt; font-weight: 400; letter-spacing: 0.02em; color: #1a1918; margin-bottom: 1.5mm; font-variant-numeric: tabular-nums; }
        .header__meta-date { font-size: 9pt; color: rgba(26,25,24,0.72); margin-bottom: 1mm; }
        .header__meta-valid { font-size: 8.5pt; color: rgba(26,25,24,0.55); font-style: italic; }
        /* PARTIES */
        .parties { display: flex; justify-content: space-between; padding: 10mm 0; gap: 14mm; border-bottom: 1px solid rgba(26,25,24,0.08); }
        .party { flex: 1; }
        .party--right { text-align: right; }
        .party__eyebrow { font-size: 8pt; font-weight: 500; letter-spacing:.22em; text-transform: uppercase; color: #A16207; margin-bottom: 3mm; }
        .party__name { font-size: 13pt; font-weight: 400; color: #1a1918; margin-bottom: 2mm; letter-spacing: -0.01em; }
        .party__line { font-size: 9pt; color: rgba(26,25,24,0.7); margin-bottom: 0.8mm; }
        /* ITEMS */
        .items { padding: 8mm 0; }
        .item { display: grid; grid-template-columns: 8mm 38mm 1fr; gap: 6mm; padding: 5mm 0; border-bottom: 1px solid rgba(26,25,24,0.06); page-break-inside: avoid; break-inside: avoid; }
        .item__index { font-size: 8pt; font-weight: 500; color: #A16207; letter-spacing: 0.18em; padding-top: 2mm; font-variant-numeric: tabular-nums; }
        .item__media { width: 38mm; height: 38mm; background: #f3f1ed; overflow: hidden; }
        .item__media img { width: 100%; height: 100%; object-fit: cover; display: block; }
        .item__body { display: flex; flex-direction: column; gap: 3mm; min-width: 0; }
        .item__title { font-size: 12pt; font-weight: 300; letter-spacing: -0.01em; color: #1a1918; line-height: 1.25; margin: 0; }
        .item__specs { display: grid; grid-template-columns: repeat(2, 1fr); gap: 2mm 6mm; }
        .item__specs > div { display: flex; flex-direction: column; gap: 0.5mm; }
        .item__specs dt { font-size: 7pt; font-weight: 500; letter-spacing:.18em; text-transform: uppercase; color: rgba(26,25,24,0.5); }
        .item__specs dd { font-size: 9pt; color: #1a1918; font-weight: 400; line-height: 1.4; }
        .item__pricing { display: flex; justify-content: space-between; align-items: baseline; padding-top: 2mm; border-top: 1px solid rgba(26,25,24,0.06); margin-top: 1.5mm; font-variant-numeric: tabular-nums; }
        .item__qty { font-size: 8.5pt; color: rgba(26,25,24,0.6); }
        .item__total { font-size: 14pt; font-weight: 300; color: #1a1918; letter-spacing: -0.015em; }
        /* FOOTER TOTALS */
        .footer-totals { display: grid; grid-template-columns: 1fr auto; gap: 12mm; padding: 8mm 0 6mm; border-top: 2px solid #A16207; margin-top: 4mm; page-break-inside: avoid; break-inside: avoid; }
        .payments { font-size: 9.5pt; }
        .payments__eyebrow { font-size: 8pt; font-weight: 500; letter-spacing:.22em; text-transform: uppercase; color: #A16207; margin-bottom: 3mm; }
        .payments__row { display: flex; justify-content: space-between; align-items: baseline; padding: 1.5mm 0; gap: 8mm; border-bottom: 1px dotted rgba(26,25,24,0.12); font-variant-numeric: tabular-nums; }
        .payments__row span { color: rgba(26,25,24,0.7); }
        .payments__row strong { font-weight: 500; color: #1a1918; }
        .payments__row--logi span { color: rgba(26,25,24,0.55); font-style: italic; }
        .payments__row--highlight span { color: #A16207; font-weight: 500; }
        .payments__row--highlight strong { color: #A16207; font-size: 11pt; }
        .grand-total { text-align: right; min-width: 60mm; }
        .grand-total__label { font-size: 9pt; font-weight: 500; letter-spacing:.18em; text-transform: uppercase; color: #A16207; margin-bottom: 2mm; }
        /* PDF-FIX 1 · letter-spacing 0 + tabular-nums + ligatures none evita overlap entre "11" "00" etc na Cormorant Garamond */
        .grand-total__value { font-size: 26pt; font-weight: 300; letter-spacing: 0; color: #1a1918; line-height: 1; font-variant-numeric: tabular-nums; font-variant-ligatures: none; font-feature-settings: "tnum" 1, "liga" 0, "calt" 0; }
        /* LEGAL */
        .legal { margin-top: 8mm; padding-top: 5mm; border-top: 1px solid rgba(26,25,24,0.1); font-size: 8pt; color: rgba(26,25,24,0.6); }
        .legal__row { display: flex; gap: 4mm; padding: 1mm 0; }
        .legal__row > span { min-width: 26mm; font-weight: 500; letter-spacing:.18em; text-transform: uppercase; color: rgba(26,25,24,0.55); }
        .legal__row strong { font-weight: 400; color: rgba(26,25,24,0.78); }
        .legal__brand { display: flex; justify-content: space-between; margin-top: 5mm; padding-top: 3mm; border-top: 1px dotted rgba(26,25,24,0.18); font-size: 7.5pt; color: rgba(26,25,24,0.45); letter-spacing: 0.04em; }

        /* ═══════════════════════════════════════════════════════════════
           CAPA CINEMATOGRÁFICA · primeira página fullbleed editorial
           ═══════════════════════════════════════════════════════════════ */
        .cover {
          page-break-after: always;
          break-after: page;
          page-break-inside: avoid;
          break-inside: avoid;
          display: grid;
          grid-template-columns: 1.05fr 1fr;
          width: 210mm;
          height: 297mm;
          margin: 0;
          position: relative;
          overflow: hidden;
          background: #fdfcfa;
        }
        .cover__hero {
          position: relative;
          overflow: hidden;
          background: linear-gradient(135deg, #1a1918 0%, #2d2825 100%);
        }
        .cover__hero img {
          width: 100%; height: 100%;
          object-fit: cover;
          display: block;
          filter: brightness(0.92) saturate(1.05);
        }
        .cover__hero-overlay {
          position: absolute; inset: 0;
          background: linear-gradient(180deg, rgba(0,0,0,0.18) 0%, rgba(0,0,0,0) 30%, rgba(0,0,0,0) 70%, rgba(0,0,0,0.32) 100%);
          pointer-events: none;
        }
        .cover__hero-mark {
          position: absolute;
          left: 0; right: 0; bottom: 14mm;
          padding: 0 14mm;
          display: flex;
          align-items: flex-end;
          justify-content: space-between;
          color: #fff;
          font-size: 7.5pt;
          letter-spacing:.18em;
          text-transform: uppercase;
          opacity: 0.85;
        }
        .cover__hero-mark-eyebrow { font-weight: 500; }
        .cover__hero-mark-year {
          font-family: var(--font-heading-family,'Montserrat'),'Montserrat',sans-serif;
          font-size: 11pt;
          font-style: italic;
          letter-spacing: 0.16em;
          font-weight: 400;
          text-transform: none;
        }
        .cover__hero--blank {
          background:
            radial-gradient(at top right, rgba(161,98,7,0.06), transparent 50%),
            linear-gradient(180deg, #f3f1ed 0%, #e8e3da 100%);
        }
        .cover__hero--blank::before {
          content: 'TOTH';
          position: absolute;
          left: 50%; top: 50%;
          transform: translate(-50%, -50%);
          font-size: 96pt;
          font-weight: 200;
          letter-spacing: 0.18em;
          color: rgba(26,25,24,0.06);
        }
        .cover__caption {
          padding: 18mm 16mm;
          display: grid;
          grid-template-rows: auto 1fr auto;
          gap: 10mm;
          position: relative;
        }
        .cover__caption::before {
          content: '';
          position: absolute;
          top: 18mm; bottom: 18mm;
          left: 0;
          width: 1px;
          background: rgba(26,25,24,0.06);
        }
        .cover__brand {
          display: flex;
          flex-direction: column;
          gap: 3mm;
        }
        .cover__logo {
          font-size: 22pt;
          font-weight: 200;
          letter-spacing: 0.16em;
          line-height: 1;
          color: #1a1918;
        }
        .cover__logo-img {
          height: 11mm;
          width: auto;
          object-fit: contain;
          display: block;
        }
        .header__logo-img {
          height: 8mm;
          width: auto;
          object-fit: contain;
          display: block;
          margin-bottom: 2mm;
        }
        .closing__brand-mark-img {
          height: 9mm;
          width: auto;
          object-fit: contain;
          display: block;
          flex-shrink: 0;
        }
        .cover__proposal-stats {
          display: flex;
          align-items: center;
          gap: 3mm;
          flex-wrap: wrap;
          margin-top: 6mm;
          font-size: 8.5pt;
          color: rgba(26,25,24,0.55);
          letter-spacing: 0.02em;
        }
        .cover__proposal-stats strong {
          color: #1a1918;
          font-weight: 500;
          font-variant-numeric: tabular-nums;
        }
        .cover__stats-dot { color: rgba(161,98,7,0.5); }

        /* Bloco de credenciais Toth · 4 métricas em destaque editorial */
        .cover__credentials {
          padding: 4mm 0;
          border-top: 1px solid rgba(26,25,24,0.12);
          border-bottom: 1px solid rgba(26,25,24,0.08);
          margin-bottom: 6mm;
        }
        .cover__credentials-eyebrow {
          display: block;
          font-size: 7pt;
          font-weight: 600;
          letter-spacing:.22em;
          text-transform: uppercase;
          color: #A16207;
          margin-bottom: 4mm;
        }
        .cover__credentials-row {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 4mm;
        }
        .cover__credential {
          display: flex;
          flex-direction: column;
          gap: 1mm;
        }
        .cover__credential strong {
          font-family: var(--font-heading-family,'Montserrat'),'Montserrat',sans-serif;
          font-size: 24pt;
          font-weight: 400;
          color: #1a1918;
          letter-spacing: -0.018em;
          line-height: 1;
        }
        .cover__credential span {
          font-size: 7pt;
          letter-spacing:.18em;
          text-transform: uppercase;
          color: rgba(26,25,24,0.55);
          font-weight: 500;
        }

        /* Linha de marcas confiadoras · social proof condensado */
        .cover__trusted {
          padding-top: 4mm;
          display: flex;
          flex-direction: column;
          gap: 2mm;
        }
        .cover__trusted-label {
          font-size: 7pt;
          font-weight: 600;
          letter-spacing:.18em;
          text-transform: uppercase;
          color: rgba(26,25,24,0.45);
        }
        .cover__trusted-list {
          font-size: 8.5pt;
          line-height: 1.6;
          color: rgba(26,25,24,0.7);
          letter-spacing: 0.02em;
          font-weight: 400;
        }
        .cover__tagline {
          font-size: 7.5pt;
          font-weight: 500;
          letter-spacing:.18em;
          text-transform: uppercase;
          color: rgba(26,25,24,0.5);
        }
        .cover__title-wrap {
          display: flex;
          flex-direction: column;
          justify-content: center;
        }
        .cover__eyebrow {
          font-size: 9pt;
          font-weight: 500;
          letter-spacing:.22em;
          text-transform: uppercase;
          color: #A16207;
          margin-bottom: 6mm;
          display: block;
        }
        .cover__eyebrow strong {
          font-weight: 600;
          color: #1a1918;
          letter-spacing: 0.04em;
          text-transform: none;
          font-size: 10pt;
          font-family: var(--font-heading-family,'Montserrat'),'Montserrat',sans-serif;
          font-style: italic;
        }
        .cover__title {
          font-family: var(--font-heading-family,'Montserrat'),'Montserrat',sans-serif;
          font-size: 40pt;
          font-weight: 300;
          letter-spacing: -0.018em;
          line-height: 1.02;
          color: #1a1918;
          margin: 0;
        }
        .cover__title br { display: block; }
        .cover__rule {
          width: 14mm;
          height: 1.2px;
          background: #A16207;
          margin-top: 8mm;
          margin-bottom: 6mm;
        }
        .cover__meta {
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          gap: 3mm;
          font-size: 9pt;
          color: rgba(26,25,24,0.6);
          font-variant-numeric: tabular-nums;
          letter-spacing: 0.04em;
        }
        .cover__meta-num {
          font-family: 'Fira Code', ui-monospace, monospace;
          font-weight: 500;
          color: #1a1918;
          letter-spacing: 0.06em;
        }
        .cover__meta-dot { color: rgba(161,98,7,0.6); }
        .cover__meta-valid { font-style: italic; }
        .cover__foot {
          padding-top: 6mm;
          border-top: 1px solid rgba(26,25,24,0.1);
        }
        .cover__stats {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 6mm;
        }
        .cover__stat {
          display: flex;
          flex-direction: column;
          gap: 1.5mm;
        }
        .cover__stat strong {
          font-family: var(--font-heading-family,'Montserrat'),'Montserrat',sans-serif;
          font-size: 22pt;
          font-weight: 400;
          color: #1a1918;
          letter-spacing: -0.015em;
          line-height: 1;
        }
        .cover__stat span {
          font-size: 7.5pt;
          letter-spacing:.18em;
          text-transform: uppercase;
          color: rgba(26,25,24,0.55);
          font-weight: 500;
        }

        /* ═══════════════════════════════════════════════════════════════
           CARTA DO CONSULTOR · página editorial de mensagem pessoal
           ═══════════════════════════════════════════════════════════════ */
        .letter {
          page-break-before: always;
          break-before: page;
          page-break-after: always;
          break-after: page;
          page-break-inside: avoid;
          padding: 30mm 22mm 20mm;
          min-height: 245mm;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .letter__inner {
          max-width: 140mm;
          width: 100%;
        }
        .letter__head {
          text-align: center;
          margin-bottom: 14mm;
        }
        .letter__eyebrow {
          display: block;
          font-size: 8.5pt;
          font-weight: 500;
          letter-spacing:.22em;
          text-transform: uppercase;
          color: #A16207;
          margin-bottom: 5mm;
        }
        .letter__rule {
          width: 18mm;
          height: 1.2px;
          background: #A16207;
          margin: 0 auto;
        }
        .letter__body {
          font-family: var(--font-heading-family,'Montserrat'),'Montserrat',sans-serif;
          color: #1a1918;
          margin-bottom: 14mm;
        }
        .letter__greeting {
          font-size: 18pt;
          font-weight: 400;
          font-style: italic;
          letter-spacing: -0.01em;
          margin-bottom: 8mm;
          color: #A16207;
        }
        .letter__body p {
          font-size: 13pt;
          line-height: 1.75;
          font-weight: 400;
          letter-spacing: 0.005em;
          margin-bottom: 5mm;
          text-align: justify;
          hyphens: auto;
        }
        .letter__sign {
          display: flex;
          justify-content: space-between;
          align-items: flex-end;
          padding-top: 8mm;
          border-top: 1px solid rgba(26,25,24,0.1);
        }
        .letter__signature {
          display: flex;
          flex-direction: column;
          gap: 1mm;
        }
        .letter__signature-name {
          font-family: var(--font-heading-family,'Montserrat'),'Montserrat',sans-serif;
          font-size: 18pt;
          font-weight: 400;
          font-style: italic;
          color: #1a1918;
          letter-spacing: -0.01em;
        }
        .letter__signature-role {
          font-size: 8pt;
          letter-spacing:.18em;
          text-transform: uppercase;
          color: rgba(26,25,24,0.55);
          font-weight: 500;
        }
        .letter__signature-mail {
          font-size: 8pt;
          color: rgba(26,25,24,0.45);
          margin-top: 1mm;
        }
        .letter__date {
          font-size: 9pt;
          color: rgba(26,25,24,0.5);
          letter-spacing: 0.04em;
          font-style: italic;
        }

        /* ═══════════════════════════════════════════════════════════════
           FECHAMENTO · página final com QR code WhatsApp + próximos passos
           ═══════════════════════════════════════════════════════════════ */
        .closing {
          page-break-before: always;
          break-before: page;
          padding-top: 4mm;
          padding-bottom: 4mm;
        }
        .closing__head {
          text-align: center;
          margin-bottom: 14mm;
        }
        .closing__eyebrow {
          display: block;
          font-size: 9pt;
          font-weight: 500;
          letter-spacing:.22em;
          text-transform: uppercase;
          color: #A16207;
          margin-bottom: 5mm;
        }
        .closing__title {
          font-family: var(--font-heading-family,'Montserrat'),'Montserrat',sans-serif;
          font-size: 28pt;
          font-weight: 300;
          letter-spacing: -0.018em;
          line-height: 1.05;
          color: #1a1918;
          margin: 0 0 5mm;
        }
        .closing__rule {
          width: 14mm;
          height: 1.2px;
          background: #A16207;
          margin: 0 auto;
        }
        .closing__grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 6mm;
          margin-bottom: 12mm;
        }
        .closing__step {
          text-align: center;
          padding: 6mm 4mm 4mm;
          background: #faf9f7;
          border-top: 2px solid #A16207;
        }
        .closing__step-num {
          font-family: var(--font-heading-family,'Montserrat'),'Montserrat',sans-serif;
          font-size: 28pt;
          font-weight: 300;
          font-style: italic;
          color: #A16207;
          display: block;
          line-height: 1;
          margin-bottom: 3mm;
        }
        .closing__step-title {
          font-size: 12pt;
          font-weight: 500;
          letter-spacing: -0.005em;
          color: #1a1918;
          margin: 0 0 2.5mm;
        }
        .closing__step-desc {
          font-size: 8.5pt;
          line-height: 1.6;
          color: rgba(26,25,24,0.6);
          font-weight: 300;
        }
        .closing__cta {
          display: grid;
          grid-template-columns: auto 1.2fr 1fr;
          gap: 8mm;
          align-items: stretch;
          padding: 8mm 10mm;
          background: linear-gradient(135deg, #fdfcfa 0%, #f3f1ed 100%);
          border: 1px solid rgba(161,98,7,0.18);
          margin-bottom: 10mm;
          page-break-inside: avoid;
          break-inside: avoid;
        }
        .closing__cta-qr {
          background: #fff;
          padding: 4mm;
          border: 1px solid rgba(26,25,24,0.08);
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .closing__cta-qr img {
          width: 38mm; height: 38mm;
          display: block;
        }
        .closing__cta-body {
          display: flex;
          flex-direction: column;
          gap: 1.5mm;
          justify-content: center;
        }
        .closing__cta-eyebrow {
          font-size: 7.5pt;
          letter-spacing:.22em;
          text-transform: uppercase;
          color: #A16207;
          font-weight: 500;
        }
        .closing__cta-name {
          font-family: var(--font-heading-family,'Montserrat'),'Montserrat',sans-serif;
          font-size: 22pt;
          font-weight: 400;
          color: #1a1918;
          letter-spacing: -0.015em;
          margin: 0;
          line-height: 1.05;
        }
        .closing__cta-desc {
          font-size: 8.5pt;
          line-height: 1.55;
          color: rgba(26,25,24,0.6);
          margin: 1mm 0 2mm;
          max-width: 60mm;
        }
        .closing__cta-link {
          font-size: 11pt;
          color: #1a1918;
          text-decoration: none;
          font-weight: 500;
          letter-spacing: 0.04em;
          padding-bottom: 0.5mm;
          border-bottom: 1px solid #A16207;
          display: inline-block;
          width: max-content;
        }
        .closing__cta-mail {
          font-size: 8pt;
          color: rgba(26,25,24,0.5);
          margin-top: 1mm;
        }
        .closing__cta-summary {
          display: flex;
          flex-direction: column;
          gap: 2mm;
          padding-left: 6mm;
          border-left: 1px solid rgba(26,25,24,0.12);
        }
        .closing__cta-summary-row {
          display: flex;
          justify-content: space-between;
          align-items: baseline;
          gap: 4mm;
          font-size: 9pt;
          color: rgba(26,25,24,0.62);
        }
        .closing__cta-summary-row strong {
          font-family: var(--font-heading-family,'Montserrat'),'Montserrat',sans-serif;
          font-size: 13pt;
          font-weight: 400;
          color: #1a1918;
          /* PDF-FIX 1 · letter-spacing 0 + tnum + no liga · evita overlap "11"/"00" */
          letter-spacing: 0;
          font-variant-numeric: tabular-nums;
          font-variant-ligatures: none;
          font-feature-settings: "tnum" 1, "liga" 0, "calt" 0;
        }
        .closing__cta-summary-row--pix {
          color: #A16207;
        }
        .closing__cta-summary-row--pix strong { color: #A16207; }
        .closing__cta-summary-foot {
          margin-top: 3mm;
          padding-top: 3mm;
          border-top: 1px dashed rgba(26,25,24,0.12);
          display: flex;
          justify-content: space-between;
          font-size: 7.5pt;
          color: rgba(26,25,24,0.5);
          letter-spacing: 0.06em;
        }
        .closing__brand {
          display: flex;
          align-items: center;
          gap: 8mm;
          padding-top: 6mm;
          border-top: 1px solid rgba(26,25,24,0.1);
        }
        .closing__brand-mark {
          font-size: 18pt;
          font-weight: 200;
          letter-spacing: 0.18em;
          color: #1a1918;
        }
        .closing__brand-info {
          display: flex;
          flex-direction: column;
          gap: 0.8mm;
          font-size: 7.5pt;
          color: rgba(26,25,24,0.5);
          letter-spacing: 0.06em;
        }
        .closing__brand-info span:first-child {
          font-family: var(--font-heading-family,'Montserrat'),'Montserrat',sans-serif;
          font-style: italic;
          font-size: 9pt;
          color: rgba(26,25,24,0.7);
          letter-spacing: 0.01em;
        }

        /* Refinos editoriais aplicados aos blocos existentes ────────────── */
        .header__logo,
        .party__name,
        .grand-total__value,
        .item__title {
          font-family: var(--font-heading-family,'Montserrat'),'Montserrat',sans-serif;
          font-weight: 400;
          letter-spacing: -0.005em;
        }
        .header__logo {
          font-size: 30pt;
          font-weight: 300;
          letter-spacing: 0.08em;
        }
        .grand-total__value {
          font-size: 24pt;
          font-weight: 400;
          letter-spacing: 0;
          font-variant-numeric: tabular-nums;
          font-variant-ligatures: none;
          font-feature-settings: "tnum" 1, "liga" 0, "calt" 0;
        }

        /* ── AUTORIDADE · Páginas editoriais opcionais (Onda 4) ─────────── */
        .aut-page { page-break-before: always; break-before: page; padding-top: 4mm; padding-bottom: 6mm; }
        .aut-page__head { text-align: center; padding-bottom: 10mm; margin-bottom: 8mm; position: relative; }
        .aut-page__eyebrow { display: block; font-size: 8pt; font-weight: 500; letter-spacing:.22em; text-transform: uppercase; color: #A16207; margin-bottom: 4mm; }
        .aut-page__title { font-size: 22pt; font-weight: 200; letter-spacing: -0.02em; line-height: 1.1; color: #1a1918; margin: 0 0 4mm; }
        .aut-page__rule { width: 14mm; height: 1.2px; background: #A16207; margin: 0 auto 4mm; }
        .aut-page__lede { font-size: 9.5pt; font-weight: 300; line-height: 1.6; color: rgba(26,25,24,0.62); max-width: 110mm; margin: 0 auto; }

        /* Bloco institucional · 3 cards lado a lado + logos */
        .aut-inst__grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 7mm; margin-bottom: 10mm; }
        .aut-inst__card { display: flex; flex-direction: column; gap: 3mm; page-break-inside: avoid; break-inside: avoid; }
        .aut-inst__media { aspect-ratio: 4/5; overflow: hidden; background: #f3f1ed; }
        .aut-inst__media img { width: 100%; height: 100%; object-fit: cover; display: block; }
        .aut-inst__title { font-size: 11pt; font-weight: 400; letter-spacing: -0.005em; color: #1a1918; margin: 0; line-height: 1.3; }
        .aut-inst__desc { font-size: 8.5pt; line-height: 1.6; color: rgba(26,25,24,0.65); font-weight: 300; margin: 0; }
        .aut-inst__logos { display: flex; gap: 6mm; padding-top: 8mm; border-top: 1px solid rgba(26,25,24,0.1); align-items: center; justify-content: center; flex-wrap: wrap; }
        .aut-inst__logos img { max-height: 12mm; max-width: 24mm; object-fit: contain; opacity: 0.7; }

        /* Bloco clientes corporativos · grade densa de logos */
        .aut-clients__grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 6mm 8mm; padding-top: 4mm; }
        .aut-clients__logo { aspect-ratio: 3/2; display: flex; align-items: center; justify-content: center; padding: 3mm; background: #fff; border: 1px solid rgba(26,25,24,0.06); page-break-inside: avoid; break-inside: avoid; }
        .aut-clients__logo img { max-width: 100%; max-height: 100%; object-fit: contain; filter: grayscale(0.2); }

        /* Bloco depoimentos · 1-2 cards stack */
        .aut-test__grid { display: flex; flex-direction: column; gap: 8mm; }
        .aut-test__card { display: grid; grid-template-columns: 60mm 1fr; gap: 6mm; padding: 6mm; background: #faf9f7; border-left: 2px solid #A16207; page-break-inside: avoid; break-inside: avoid; }
        .aut-test__card:has(.aut-test__media) { grid-template-columns: 60mm 1fr; }
        .aut-test__card:not(:has(.aut-test__media)) { grid-template-columns: 1fr; }
        .aut-test__media { aspect-ratio: 4/3; overflow: hidden; background: #ece9e3; }
        .aut-test__media img { width: 100%; height: 100%; object-fit: cover; display: block; }
        .aut-test__quote { font-size: 11pt; line-height: 1.6; color: #1a1918; font-weight: 300; font-style: italic; margin: 0 0 3mm; position: relative; padding-left: 5mm; }
        .aut-test__mark { position: absolute; left: 0; top: -2mm; font-size: 22pt; font-weight: 200; color: #A16207; font-family: Georgia, serif; line-height: 1; }
        .aut-test__quote p { margin: 0; }
        .aut-test__author { display: flex; gap: 3mm; align-items: center; padding-top: 3mm; border-top: 1px solid rgba(26,25,24,0.1); }
        .aut-test__avatar { width: 12mm; height: 12mm; border-radius: 50%; object-fit: cover; }
        .aut-test__author > div { display: flex; flex-direction: column; gap: 0.5mm; }
        .aut-test__name { font-size: 9.5pt; font-weight: 500; color: #1a1918; }
        .aut-test__role { font-size: 8pt; color: rgba(26,25,24,0.55); }
        .aut-test__loc { font-size: 7.5pt; color: rgba(26,25,24,0.45); letter-spacing: 0.04em; }

        /* Bloco projetos · grade 2x3 ou 3x2 */
        .aut-proj__grid { display: grid; grid-template-columns: repeat(2, 1fr); gap: 7mm; }
        .aut-proj__card { display: flex; flex-direction: column; gap: 3mm; page-break-inside: avoid; break-inside: avoid; }
        .aut-proj__media { aspect-ratio: 4/3; overflow: hidden; background: #f3f1ed; }
        .aut-proj__media img { width: 100%; height: 100%; object-fit: cover; display: block; }
        .aut-proj__name { font-size: 10.5pt; font-weight: 400; letter-spacing: -0.005em; color: #1a1918; margin: 0; }
        .aut-proj__meta { display: flex; flex-direction: column; gap: 0.8mm; font-size: 8pt; color: rgba(26,25,24,0.55); }
      `;
    }

    // 2026-06-29 · delegam pros helpers compartilhados (de-dup · a venda usa os MESMOS)
    #escAttr(s) { return tsfEscAttr(s); }
    #escHtml(s) { return tsfEscHtml(s); }
    #optImg(url, width = 800) { return tsfOptImg(url, width); }

    #onCardPctChange() {
      if (!this.#quote) return;
      this.#quote.client_info = this.#quote.client_info || {};
      this.#quote.client_info.card_surcharge_pct = this.#parseDecimal(this.#cardPctInputEl?.value);
      this.#updateTotals();
      this.#queueSave({ client_info: this.#quote.client_info });
    }

    // 2026-06-30 · Desconto do cliente em R$ sobre o subtotal de produtos (não incide no frete)
    #onDiscountChange() {
      if (!this.#quote) return;
      this.#quote.client_info = this.#quote.client_info || {};
      this.#quote.client_info.discount_centavos = tsfParseMoneyCentavos(this.#discountInputEl?.value);
      this.#updateTotals();
      this.#queueSave({ client_info: this.#quote.client_info });
    }
    #hydrateDiscount() {
      const c = Math.max(0, parseInt(this.#quote?.client_info?.discount_centavos, 10) || 0);
      if (this.#discountInputEl) this.#discountInputEl.value = c > 0 ? (c / 100).toFixed(2).replace('.', ',') : '';
    }

    // FREIGHT-TOGGLE · só 2 estados: 'charge' (default · inclui no total) ou 'none' (não inclui)
    #onFreightModeChange(mode) {
      if (!this.#quote) return;
      const m = (mode === 'none') ? 'none' : 'charge';
      this.#quote.client_info = this.#quote.client_info || {};
      this.#quote.client_info.freight_mode = m;
      this.#applyFreightModeToUi(m);
      this.#updateTotals();
      this.#queueSave({ client_info: this.#quote.client_info });
    }

    // Esconde/mostra body do frete + taxa cartão quando OFF
    #applyFreightModeToUi(mode) {
      const enabled = (mode !== 'none');
      const cardPctWrap = this.querySelector('[data-tsf-card-pct-wrap]');
      if (cardPctWrap) cardPctWrap.style.display = enabled ? '' : 'none';
      const body = this.#freightBodyEl;
      if (body) body.style.display = enabled ? '' : 'none';
      // Sincroniza checkbox
      const checkbox = this.querySelector('[data-tsf-freight-toggle]');
      if (checkbox) checkbox.checked = enabled;
    }

    // Hidrata no load
    #hydrateFreightMode() {
      const mode = (this.#quote?.client_info?.freight_mode || 'charge').toString().toLowerCase();
      this.#applyFreightModeToUi(mode);
    }

    #parseDecimal(v) {
      if (v == null) return 0;
      const cleaned = String(v).replace(/[^\d,.-]/g, '').replace(',', '.');
      const n = parseFloat(cleaned);
      return isFinite(n) ? n : 0;
    }

    #hydrateCardSurcharge() {
      const ci = this.#quote?.client_info || {};
      // % default 15 se nunca foi salvo
      const pct = ci.card_surcharge_pct != null ? ci.card_surcharge_pct : 15;
      if (this.#cardPctInputEl) {
        this.#cardPctInputEl.value = String(pct).replace('.', ',');
      }
      // Garante que o quote tem o valor salvo
      if (ci.card_surcharge_pct == null) {
        this.#quote.client_info = this.#quote.client_info || {};
        this.#quote.client_info.card_surcharge_pct = 15;
      }
    }

    // F3 (2026-06-23) · Frete AVULSO/NEGOCIADO · mesmo padrão dos produtos (editar + nativo + reset)
    #freightFieldHtml() {
      const q = this.#quote || {};
      const nat = (typeof q.native_frete_centavos === 'number') ? q.native_frete_centavos : null;
      const cur = (typeof q.frete_centavos === 'number') ? q.frete_centavos : (nat != null ? nat : 0);
      const edited = (nat != null) && (typeof q.frete_centavos === 'number') && (q.frete_centavos !== nat);
      const valStr = (cur / 100).toFixed(2).replace('.', ',');
      const natStr = (nat != null && nat > 0) ? (nat / 100).toFixed(2).replace('.', ',') : null;
      const badge = edited
        ? '<span class="tsf-quote-item__markup-badge tsf-quote-item__markup-badge--manual" title="Frete negociado (avulso)">editado</span>'
        : '<span class="tsf-quote-item__markup-badge tsf-quote-item__markup-badge--native" title="Frete automático da transportadora">nativo</span>';
      const reset = (edited && natStr)
        ? `<button type="button" class="tsf-quote-item__markup-reset" data-tsf-quote-freight-reset title="Restaurar frete automático da transportadora">
             <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 12a9 9 0 1 0 3-6.7"/><polyline points="3 4 3 10 9 10"/></svg>
             <span>nativo R$ ${natStr}</span>
           </button>`
        : '';
      return `
        <div class="tsf-quote-freight__edit" data-tsf-quote-freight-edit-host>
          <label class="tsf-quote-item__toth-edit-label tsf-quote-item__markup-label-wrap">
            <span class="tsf-quote-item__markup-label-top"><span>Frete (R$) · avulso/negociado</span>${badge}</span>
            <span class="tsf-quote-item__toth-input-row">
              <span class="tsf-quote-item__toth-prefix">R$</span>
              <input type="text" inputmode="decimal" class="tsf-quote-item__toth-input"
                     value="${valStr}" data-tsf-quote-freight-edit aria-label="Valor do frete avulso ou negociado">
            </span>
            ${reset}
          </label>
        </div>`;
    }
    #refreshFreightField() {
      const host = this.querySelector('[data-tsf-quote-freight-edit-host]');
      if (host) host.outerHTML = this.#freightFieldHtml();
    }
    #onFreightEdit(input) {
      const cleaned = String(input.value).replace(/[^\d,.-]/g, '').replace(/\.(?=\d{3}(\D|$))/g, '').replace(',', '.');
      const n = parseFloat(cleaned);
      if (!isFinite(n) || n < 0) return;
      this.#quote.frete_centavos = Math.round(n * 100);
      this.#updateTotals();
      this.#queueSave({ frete_centavos: this.#quote.frete_centavos });
    }
    #resetFreightToNative() {
      const nat = this.#quote?.native_frete_centavos;
      if (typeof nat !== 'number') return;
      this.#quote.frete_centavos = nat;
      this.#quote.transportadora = this.#quote.native_transportadora || 'Vipex';
      this.#updateTotals();
      this.#refreshFreightField();
      this.#queueSave({ frete_centavos: nat, transportadora: this.#quote.transportadora });
    }

    #renderFreightPlaceholder() {
      this.#freightTotal = 0;
      this.#freightPrazo = null;
      if (this.#freightBodyEl) {
        this.#freightBodyEl.innerHTML = `<p class="tsf-quote-freight__placeholder">Informe o CEP do cliente para calcular o frete automático — ou digite um frete avulso abaixo.</p>${this.#freightFieldHtml()}`;
      }
      this.#updateTotals();
    }

    // Recálculo automático do frete quando origem/qty/custo mudam.
    // Debounce 400ms pra não martelar a Edge Function durante edições rápidas.
    #queueFreightRecalc() {
      const cep = (this.#quote?.client_info?.cep || '').replace(/\D/g, '');
      if (cep.length !== 8) return; // sem CEP válido, não recalcula
      window.clearTimeout(this.#freightRecalcTimer);
      this.#freightRecalcTimer = window.setTimeout(() => this.#calculateFreight(cep), 400);
    }

    #renderFreightError(msg) {
      this.#freightTotal = 0;
      if (this.#freightBodyEl) {
        this.#freightBodyEl.innerHTML = `<p class="tsf-quote-freight__error">${this.#esc(msg)}</p>${this.#freightFieldHtml()}`;
      }
      this.#updateTotals();
    }

    async #calculateFreight(cepDigits) {
      if (!this.#quote?.items?.length) return;
      if (!this.#freightBodyEl) return;

      this.#freightBodyEl.innerHTML = `<p class="tsf-quote-freight__loading"><span class="tsf-quote-builder__loading-spinner" aria-hidden="true"></span> Calculando rotas Vipex…</p>`;

      // 2026-06-29 · PADRONIZAÇÃO: o motor multi-origem agora é o helper COMPARTILHADO
      // tsfComputeMultiOriginFreight (o MESMO da venda). Extração fiel — comportamento idêntico.
      // A persistência (native/avulso) + o render dos cards por origem abaixo continuam iguais.
      const { totalCentavos, prazoMin, prazoMax, groups: groupCards, empty } = await tsfComputeMultiOriginFreight(this.#quote.items, cepDigits);

      if (empty) {
        this.#freightBodyEl.innerHTML = `<p class="tsf-quote-freight__error">Nenhum produto deste orçamento tem dados de embalagem cadastrados — digite o frete avulso abaixo.</p>${this.#freightFieldHtml()}`;
        this.#freightTotal = 0;
        this.#updateTotals();
        return;
      }

      this.#freightTotal = totalCentavos;
      // F3 (2026-06-23) · persiste o automático como NATIVO; espelha no frete atual SÓ se não foi editado à mão (avulso/negociado)
      {
        const oldNative = this.#quote.native_frete_centavos;
        const curFrete = this.#quote.frete_centavos;
        const freteWasEdited = (curFrete != null) && (oldNative != null) && (curFrete !== oldNative);
        this.#quote.native_frete_centavos = totalCentavos;
        this.#quote.native_transportadora = 'Vipex';
        if (!freteWasEdited) { this.#quote.frete_centavos = totalCentavos; this.#quote.transportadora = 'Vipex'; }
        this.#queueSave({ frete_centavos: this.#quote.frete_centavos, native_frete_centavos: totalCentavos, transportadora: this.#quote.transportadora || 'Vipex', native_transportadora: 'Vipex' });
        this.#refreshFreightField();
      }
      this.#freightPrazo = prazoMax ? { min: prazoMin, max: prazoMax } : null;

      // Render
      const groupsHtml = groupCards.map((g) => {
        if (g.error) {
          return `
            <li class="tsf-quote-freight__group tsf-quote-freight__group--error">
              <span class="tsf-quote-freight__group-origem">Origem ${this.#esc(g.origem)}</span>
              <span class="tsf-quote-freight__group-meta">${g.count} produto(s) · ${this.#esc(g.error)}</span>
            </li>
          `;
        }
        return `
          <li class="tsf-quote-freight__group">
            <span class="tsf-quote-freight__group-origem">Origem ${this.#esc(g.origem)}</span>
            <span class="tsf-quote-freight__group-meta">${g.count} ${g.count > 1 ? 'produtos' : 'produto'} · entrega ${g.prazo_min}–${g.prazo_max} dias úteis</span>
            <span class="tsf-quote-freight__group-value">${money(g.price)}</span>
          </li>
        `;
      }).join('');

      const sub = this.#freightPrazo
        ? `Entrega total estimada: ${this.#freightPrazo.min}–${this.#freightPrazo.max} dias úteis`
        : '';

      this.#freightBodyEl.innerHTML = `
        <ul class="tsf-quote-freight__groups">${groupsHtml}</ul>
        <div class="tsf-quote-freight__summary">
          <span class="tsf-quote-freight__summary-label">Frete total Vipex · portaria</span>
          <span class="tsf-quote-freight__summary-value">${money(totalCentavos)}</span>
          ${sub ? `<span class="tsf-quote-freight__summary-sub">${sub}</span>` : ''}
        </div>
        ${this.#freightFieldHtml()}
      `;

      this.#updateTotals();
    }

    /* ════ FOTO SWITCHER ═══════════════════════════════════════════ */
    async #openPhotoDialog(uid) {
      const item = this.#quote.items.find((i) => i.uid === uid);
      if (!item || !this.#photoDialogEl) return;
      this.#photoActiveUid = uid;
      if (this.#photoDialogTitleEl) this.#photoDialogTitleEl.textContent = item.snapshot?.title || item.snapshot?.name || 'Produto';

      // Loading state
      if (this.#photoGridEl) {
        this.#photoGridEl.innerHTML = `<div class="tsf-quote-photo-dialog__loading">Carregando…</div>`;
      }
      this.#photoDialogEl.showModal?.() || this.#photoDialogEl.setAttribute('open', '');

      // Fetch em paralelo · galeria do produto + uploads custom
      const handle = item.snapshot?.handle || item.product_handle;
      const [media, uploads] = await Promise.all([
        this.#fetchProductGallery(handle),
        this.#fetchCustomPhotos(),
      ]);

      this.#renderPhotoDialog(media, uploads, item);
    }

    async #fetchProductGallery(handle) {
      if (!handle) return [];
      if (this.#photoCache.has(handle)) return this.#photoCache.get(handle);
      try {
        const res = await fetch(`/products/${handle}.js`);
        const data = await res.json();
        const media = (data.media || data.images || []).map((m, i) => {
          if (typeof m === 'string') return { id: i, src: m.startsWith('//') ? 'https:' + m : m };
          const src = m.src || m.preview_image?.src || m.url;
          return src ? { id: m.id || i, src: src.startsWith('//') ? 'https:' + src : src } : null;
        }).filter(Boolean);
        this.#photoCache.set(handle, media);
        return media;
      } catch (err) {
        return [];
      }
    }

    async #fetchCustomPhotos() {
      if (!this.#quote?.id) return [];
      try {
        const res = await fetch(`${QUOTE_ENDPOINT}/list-photos?quote_id=${encodeURIComponent(this.#quote.id)}`);
        const data = await res.json();
        return data.ok ? (data.photos || []) : [];
      } catch {
        return [];
      }
    }

    #renderPhotoDialog(media, uploads, item) {
      if (!this.#photoGridEl) return;
      const currentPhoto = item.selected_photo_url || item.snapshot?.image_url || '';
      const same = (a, b) => a && b && (a === b || a.split('?')[0] === b.split('?')[0]);

      // Helper · template de uma foto selecionável (com optional delete)
      const photoCard = (src, opts = {}) => {
        const isActive = same(src, currentPhoto);
        const deleteBtn = opts.deletable
          ? `<button type="button" class="tsf-quote-photo-dialog__delete"
                     data-tsf-photo-delete="${this.#esc(opts.filename)}"
                     aria-label="Remover esta foto"
                     title="Remover foto enviada">
               <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true">
                 <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
               </svg>
             </button>`
          : '';
        const badge = opts.badge ? `<span class="tsf-quote-photo-dialog__badge">${this.#esc(opts.badge)}</span>` : '';
        return `
          <div class="tsf-quote-photo-dialog__slot">
            <button type="button" class="tsf-quote-photo-dialog__pick${isActive ? ' is-active' : ''}"
                    data-tsf-photo-pick="${this.#esc(src)}"
                    aria-label="Selecionar esta foto">
              <img src="${this.#esc(src)}" alt="" loading="lazy">
              ${isActive ? '<span class="tsf-quote-photo-dialog__check" aria-hidden="true">✓</span>' : ''}
              ${badge}
            </button>
            ${deleteBtn}
          </div>
        `;
      };

      // Identifica uploads do item atual vs outros items do quote
      const ownUploads = uploads.filter(p => p.item_uid === item.uid);
      const otherUploads = uploads.filter(p => p.item_uid !== item.uid);

      let html = '';

      if (ownUploads.length) {
        html += `
          <section class="tsf-quote-photo-dialog__section">
            <header class="tsf-quote-photo-dialog__section-head">
              <span class="tsf-quote-photo-dialog__section-title">Suas fotos enviadas</span>
              <span class="tsf-quote-photo-dialog__section-count">${ownUploads.length}</span>
            </header>
            <div class="tsf-quote-photo-dialog__grid-inner">
              ${ownUploads.map(p => photoCard(p.url, { deletable: true, filename: p.filename })).join('')}
            </div>
          </section>
        `;
      }

      if (otherUploads.length) {
        html += `
          <section class="tsf-quote-photo-dialog__section tsf-quote-photo-dialog__section--muted">
            <header class="tsf-quote-photo-dialog__section-head">
              <span class="tsf-quote-photo-dialog__section-title">Fotos enviadas em outros produtos deste orçamento</span>
              <span class="tsf-quote-photo-dialog__section-count">${otherUploads.length}</span>
            </header>
            <div class="tsf-quote-photo-dialog__grid-inner">
              ${otherUploads.map(p => photoCard(p.url, { deletable: true, filename: p.filename, badge: 'reaproveitar' })).join('')}
            </div>
          </section>
        `;
      }

      if (media.length) {
        html += `
          <section class="tsf-quote-photo-dialog__section">
            <header class="tsf-quote-photo-dialog__section-head">
              <span class="tsf-quote-photo-dialog__section-title">Galeria do produto</span>
              <span class="tsf-quote-photo-dialog__section-count">${media.length}</span>
            </header>
            <div class="tsf-quote-photo-dialog__grid-inner">
              ${media.map(m => photoCard(m.src)).join('')}
            </div>
          </section>
        `;
      }

      if (!html) {
        html = `<p class="tsf-quote-photo-dialog__error">Este produto não tem galeria · envie uma foto do seu computador acima.</p>`;
      }

      this.#photoGridEl.innerHTML = html;
    }

    // ─── Delete de foto custom ─────────────────────────────────────────
    async #deleteCustomPhoto(filename, slotEl) {
      if (!filename) return;
      if (!confirm('Remover esta foto enviada? A ação não pode ser desfeita.')) return;
      try {
        if (slotEl) slotEl.setAttribute('data-deleting', 'true');
        const res = await fetch(`${QUOTE_ENDPOINT}/delete-photo`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ filename }),
        });
        const data = await res.json();
        if (!data.ok) throw new Error(data.error || 'falha ao deletar');

        // Se algum item está usando essa foto, limpa
        const publicUrl = `https://pucrgwvcgagbapzvphao.supabase.co/storage/v1/object/public/quote-photos/${filename}`;
        let touchedItems = false;
        for (const it of (this.#quote.items || [])) {
          if (it.selected_photo_url === publicUrl) {
            delete it.selected_photo_url;
            touchedItems = true;
          }
        }
        if (touchedItems) {
          this.#queueSave({ items: this.#quote.items });
          this.#renderRows();
        }

        // Remove do DOM
        slotEl?.remove();
        // Re-render se vazio o grupo
        const dlg = this.#photoGridEl;
        dlg?.querySelectorAll('.tsf-quote-photo-dialog__section').forEach(sec => {
          const cards = sec.querySelectorAll('.tsf-quote-photo-dialog__slot').length;
          if (cards === 0) sec.remove();
        });
      } catch (err) {
        alert('Erro ao remover: ' + err.message);
        slotEl?.removeAttribute('data-deleting');
      }
    }

    #closePhotoDialog() {
      this.#photoDialogEl?.close?.();
      this.#photoDialogEl?.removeAttribute('open');
      this.#photoActiveUid = null;
    }

    #pickPhoto(src) {
      if (!this.#photoActiveUid) return;
      const item = this.#quote.items.find((i) => i.uid === this.#photoActiveUid);
      if (!item) return;
      item.selected_photo_url = src;
      this.#renderRows();
      this.#queueSave({ items: this.#quote.items });
      this.#closePhotoDialog();
    }

    // ─── Upload de foto custom · vendor envia foto fora do catálogo ──────
    async #uploadCustomPhoto(file) {
      if (!this.#photoActiveUid || !this.#quote?.id) return;
      const statusEl = this.querySelector('[data-tsf-photo-upload-status]');
      const triggerBtn = this.querySelector('[data-tsf-photo-upload-trigger]');
      const setStatus = (txt, state = '') => {
        if (statusEl) {
          statusEl.textContent = txt;
          statusEl.setAttribute('data-state', state);
        }
      };

      // Validação client-side
      if (!file.type?.startsWith('image/')) {
        setStatus('Arquivo precisa ser uma imagem', 'error');
        return;
      }
      if (file.size > 10 * 1024 * 1024) {
        setStatus('Arquivo muito grande (máx 10 MB)', 'error');
        return;
      }

      try {
        triggerBtn?.setAttribute('disabled', '');
        setStatus(`Enviando ${(file.size / 1024 / 1024).toFixed(1)} MB…`, 'loading');

        const formData = new FormData();
        formData.append('photo', file);
        formData.append('quote_id', this.#quote.id);
        formData.append('item_uid', this.#photoActiveUid);

        const res = await fetch(`${QUOTE_ENDPOINT}/upload-photo`, {
          method: 'POST',
          body: formData,
        });
        const data = await res.json();
        if (!data.ok) throw new Error(data.error || 'falha no upload');

        setStatus('Foto enviada ✓', 'success');
        // Aplica imediatamente como foto selecionada do item · #pickPhoto fecha o dialog
        this.#pickPhoto(data.url);
      } catch (err) {
        setStatus('Erro: ' + err.message, 'error');
      } finally {
        triggerBtn?.removeAttribute('disabled');
        // Reseta status depois de 4s
        setTimeout(() => setStatus(''), 4000);
      }
    }

    #renderError(msg) {
      this.#loadingEl?.setAttribute('hidden', '');
      // Não duplicar erros se já existe um banner
      const existing = this.querySelector('.tsf-quote-builder__error');
      if (existing) { existing.querySelector('span').textContent = msg; return; }
      const wrap = document.createElement('div');
      wrap.className = 'tsf-quote-builder__error tsf-quote-builder__error--dismissable';
      wrap.innerHTML = `
        <span>${this.#esc(msg)}</span>
        <button type="button" class="tsf-quote-builder__error-close" aria-label="Dispensar">×</button>
      `;
      wrap.querySelector('button').addEventListener('click', () => wrap.remove());
      // Coloca NO TOPO (não no fim) pra não confundir com rodapé
      this.insertBefore(wrap, this.firstChild);
    }

    #esc(s) {
      return String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
    }
  }

  /* ════════════════════════════════════════════════════════════════════
     4.5 TsfPedidoApp · /pages/pedido orchestrator
     ═══════════════════════════════════════════════════════════════════════

     Decide entre lista ou editor baseado em ?id na URL.
     Ambos modos sob um único Web Component (auto-init via attribute).
  ════════════════════════════════════════════════════════════════════════ */

  const PEDIDO_ENDPOINT = 'https://pucrgwvcgagbapzvphao.supabase.co/functions/v1/toth-checkout/pedido';

  // Helper · aplica desconto sequencial · 873.40 × [10,5] = 873.40 × 0.90 × 0.95
  function applyDiscountLayers(value, layers) {
    if (!Array.isArray(layers) || layers.length === 0) return value;
    return layers.reduce((acc, pct) => acc * (1 - (parseFloat(pct) || 0) / 100), value);
  }

  // Helper · "10+5+5" → [10, 5, 5]
  function parseDiscountString(s) {
    if (!s || typeof s !== 'string') return [];
    return s.split('+').map(x => parseFloat(x.trim())).filter(n => isFinite(n) && n >= 0);
  }

  // Helper · [10, 5, 5] → "10+5+5"
  function discountLayersToString(layers) {
    if (!Array.isArray(layers) || layers.length === 0) return '';
    return layers.join('+');
  }

  // Status badge mapping
  const STATUS_LABELS = {
    draft:     { label: 'rascunho',  className: 'tsf-pedido-badge--draft' },
    sent:      { label: 'enviado',   className: 'tsf-pedido-badge--sent' },
    confirmed: { label: 'confirmado',className: 'tsf-pedido-badge--confirmed' },
    shipped:   { label: 'em rota',   className: 'tsf-pedido-badge--shipped' },
    delivered: { label: 'entregue',  className: 'tsf-pedido-badge--delivered' },
    cancelled: { label: 'cancelado', className: 'tsf-pedido-badge--cancelled' },
  };

  class TsfPedidoApp extends HTMLElement {
    #ctx = null;
    #pedidoId = null;
    #fromQuoteId = null;
    #pedidos = [];
    #quotesById = new Map(); // quote_id → quote (contexto secundário)
    #salesById = new Map();  // Onda 7 · sale_id → sale (agrupamento primário)
    #viewMode = 'venda'; // 'venda' | 'status' | 'fornecedor' (Onda 7: era 'orcamento')
    #scope = 'all'; // 'mine' | 'team' | 'specifica' | 'all' (default: panorama)
    #statusFilter = 'all'; // filtro por status (ortogonal ao viewMode)
    #periodFilter = 'all'; // UI-FIX 2b · default Tudo (pedidos podem ser antigos)

    // UI-FIX 2b · period helpers via TsfPeriodFilter
    #dateRange() { return TsfPeriodFilter.dateRange(this.#periodFilter); }
    #periodLabel() { return TsfPeriodFilter.periodLabel(this.#periodFilter); }
    #effectivePedidoDate(p) {
      const raw = p.updated_at || p.created_at;
      return raw ? new Date(raw) : null;
    }
    #filterPedidosByPeriod(list) {
      const [start, end] = this.#dateRange();
      if (!start || !end) return list;
      return list.filter(p => {
        const d = this.#effectivePedidoDate(p);
        return d && d >= start && d < end;
      });
    }
    #collapsedGroups = new Set(); // ids de grupos colapsados (persiste durante sessão)
    #currentPedido = null;
    #abortController = null;
    #saveTimer = null;
    #catalogCache = new Map();

    async connectedCallback() {
      this.#abortController = new AbortController();
      try {
        const ctxEl = document.getElementById('tsf-pedido-context');
        if (ctxEl) this.#ctx = JSON.parse(ctxEl.textContent);
      } catch {}
      if (!this.#ctx?.customer_id) {
        this.#renderError('Contexto de cliente não encontrado · recarregue a página.');
        return;
      }
      // URL params · Shopify Liquid não tem `request.url_parameters` ·
      // parsing tem que ser feito aqui no JS via URLSearchParams.
      const urlParams = new URLSearchParams(window.location.search);
      this.#pedidoId = urlParams.get('id') || this.getAttribute('data-pedido-id') || '';
      this.#fromQuoteId = urlParams.get('from_quote') || this.getAttribute('data-from-quote') || '';

      // beforeunload · avisa se há save pendente
      window.addEventListener('beforeunload', this.#onBeforeUnload, { signal: this.#abortController.signal });

      this.#setByline();

      // Se veio de uma quote (?from_quote=X), cria pedidos primeiro · depois renderiza lista
      if (this.#fromQuoteId) {
        await this.#createFromQuoteAndRedirect();
        return;
      }

      if (this.#pedidoId) {
        await this.#renderEditor();
      } else {
        await this.#renderList();
      }

      // Botão "Pedido direto" no header (admin-pedidos list view)
      document.querySelector('[data-tsf-admin-pedido-direct]')?.addEventListener('click', () => {
        const handle = prompt('Pedido direto · digite o handle do fornecedor (ex: heitor, pelinson, zomer):\n\nVocê pode editar o pedido depois de criar.');
        if (!handle) return;
        this.#createDirectPedido(handle.trim().toLowerCase());
      }, { signal: this.#abortController.signal });
    }

    async #createDirectPedido(fornecedor_handle) {
      try {
        const res = await fetch(`${PEDIDO_ENDPOINT}/create-direct`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            specifier_customer_id: this.#ctx.customer_id,
            specifier_email: this.#ctx.customer_email || null,
            fornecedor_handle,
            items: [],
            notes: 'Pedido direto · sem venda vinculada',
          }),
        });
        const data = await res.json();
        if (!data.ok) {
          alert('Erro: ' + (data.error || 'falha'));
          return;
        }
        const pedido = data.pedido;
        alert(`Pedido criado · ${pedido.numero_pedido} · fornecedor ${pedido.fornecedor_handle}\n\nVamos pra tela do pedido pra você adicionar items.`);
        window.location.href = `/pages/admin-pedido?id=${encodeURIComponent(pedido.id)}`;
      } catch (err) {
        alert('Erro ao criar pedido direto: ' + err.message);
      }
    }

    disconnectedCallback() {
      this.#abortController?.abort();
    }

    #onBeforeUnload = (e) => {
      if (this.#pendingPatch || this.#saveTimer) {
        e.preventDefault();
        e.returnValue = 'Há alterações ainda sendo salvas. Deseja sair mesmo assim?';
        return e.returnValue;
      }
    };

    #setByline() {
      const dateEl = document.querySelector('[data-tsf-pedido-byline-date]');
      if (dateEl) {
        const fmt = new Intl.DateTimeFormat('pt-BR', { day: '2-digit', month: 'long', year: 'numeric' });
        dateEl.textContent = fmt.format(new Date());
      }
    }

    #setBylineStatus(text) {
      const statusEl = document.querySelector('[data-tsf-pedido-byline-status]');
      if (statusEl) statusEl.textContent = text;
    }

    async #createFromQuoteAndRedirect() {
      this.innerHTML = `
        <div class="tsf-pedido-app__loading">
          <span class="tsf-pedido-app__loading-spinner" aria-hidden="true"></span>
          <span>Gerando pedidos do orçamento…</span>
        </div>
      `;
      try {
        const res = await fetch(`${PEDIDO_ENDPOINT}/create-from-quote`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            specifier_customer_id: this.#ctx.customer_id,
            quote_id: this.#fromQuoteId,
          }),
        });
        const data = await res.json();
        if (!data.ok) {
          // Mostra erro contextual no lugar do error genérico · ajuda diagnosticar
          const msg = data.error || 'falha ao gerar pedidos';
          if (msg.includes('nenhum item') || msg.includes('fornecedor')) {
            this.#renderFornecedorEmpty();
            return;
          }
          throw new Error(msg);
        }
        if (!data.count || data.count === 0) {
          this.#renderFornecedorEmpty();
          return;
        }
        // Redireciona pra lista sem ?from_quote, com banner de sucesso
        const url = new URL(window.location.href);
        url.searchParams.delete('from_quote');
        url.searchParams.set('created', String(data.count));
        window.location.href = url.toString();
      } catch (err) {
        this.#renderError('Falha ao gerar pedidos: ' + err.message);
      }
    }

    // Renderiza UI explicativa quando nenhum item da quote tem fornecedor
    // associado · explica as 3 estratégias de lookup pra educar o usuário.
    #renderFornecedorEmpty() {
      this.#setBylineStatus('Atenção');
      this.innerHTML = `
        <div class="tsf-pedido-app__empty-state">
          <svg width="56" height="56" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="0.8" aria-hidden="true">
            <circle cx="12" cy="12" r="10"/>
            <line x1="12" y1="8" x2="12" y2="12"/>
            <line x1="12" y1="16" x2="12.01" y2="16"/>
          </svg>
          <h2>Nenhum produto deste orçamento tem fornecedor associado</h2>
          <p>
            Pra gerar pedidos automaticamente, o sistema precisa identificar o fornecedor
            de cada produto. Isso pode ser feito de 3 maneiras (ordem de prioridade):
          </p>
          <ol class="tsf-pedido-app__empty-state-list">
            <li>
              <strong>Vendor do produto</strong> casa com handle ou nome do fornecedor metaobject.
              <em>Ex: produto com <code>vendor: "Heitor"</code> casa com metaobject fornecedor
              <code>heitor</code>.</em>
            </li>
            <li>
              <strong>Coleção <code>custom.mesmo_fornecedor</code></strong> do produto casa com a
              <code>colecao_associada</code> do fornecedor metaobject.
            </li>
            <li>
              <strong>Metafield direto <code>custom.fornecedor</code></strong> do produto (referência
              ao metaobject). <em>Mais robusto, requer cadastro manual.</em>
            </li>
          </ol>
          <p class="tsf-pedido-app__empty-state-hint">
            <strong>Caminho mais rápido:</strong> em <em>Admin Shopify → Content → Metaobjects → Fornecedor</em>,
            crie um novo com <code>handle</code> igual ao slug do vendor do produto.
            Ex: vendor <code>"Heitor"</code> → handle <code>heitor</code>.
          </p>
          <div class="tsf-pedido-app__empty-state-actions">
            <a href="/pages/admin-pedidos" class="tsf-pedido-app__empty-state-link">← Ver lista de pedidos</a>
            <a href="/pages/admin-orcamentos" class="tsf-pedido-app__empty-state-cta">Voltar pros orçamentos</a>
          </div>
        </div>
      `;
    }

    async #renderList() {
      this.#setBylineStatus('Carregando');

      // Onda 7 · Fetch paralelo · pedidos + vendas + orçamentos
      // Vendas viram fonte primária do agrupamento (pedido nasce da venda).
      // Quotes ainda úteis pra contexto (mostrar de qual orçamento veio).
      try {
        const pedParams = new URLSearchParams();
        const saleParams = new URLSearchParams();
        const qParams = new URLSearchParams();
        if (this.#scope === 'mine') {
          pedParams.set('specifier_customer_id', this.#ctx.customer_id);
          saleParams.set('specifier_customer_id', this.#ctx.customer_id);
          qParams.set('specifier_customer_id', this.#ctx.customer_id);
        } else {
          pedParams.set('scope', this.#scope);
          pedParams.set('specifier_customer_id', this.#ctx.customer_id);
          saleParams.set('scope', this.#scope);
          saleParams.set('specifier_customer_id', this.#ctx.customer_id);
          qParams.set('scope', this.#scope);
          qParams.set('specifier_customer_id', this.#ctx.customer_id);
        }
        const [pedRes, saleRes, quoteRes] = await Promise.all([
          fetch(`${PEDIDO_ENDPOINT}/mine?${pedParams.toString()}`, { signal: this.#abortController.signal }),
          fetch(`${SALE_ENDPOINT}/list?${saleParams.toString()}`, { signal: this.#abortController.signal }),
          fetch(`${QUOTE_ENDPOINT}/list?${qParams.toString()}`, { signal: this.#abortController.signal }),
        ]);
        const pedData = await pedRes.json();
        const saleData = await saleRes.json();
        const quoteData = await quoteRes.json();
        if (!pedData.ok) throw new Error(pedData.error || 'falha pedidos');
        this.#pedidos = pedData.pedidos || [];
        const sales = (saleData && saleData.ok) ? (saleData.sales || []) : [];
        this.#salesById = new Map();
        for (const s of sales) this.#salesById.set(s.id, s);
        const quotes = (quoteData && quoteData.ok) ? (quoteData.quotes || []) : [];
        this.#quotesById = new Map();
        for (const q of quotes) this.#quotesById.set(q.id, q);
      } catch (err) {
        this.#renderError('Falha ao carregar pedidos: ' + err.message);
        return;
      }

      // Inicializa viewMode + statusFilter + scope da URL (permite link direto)
      const urlParams = new URLSearchParams(window.location.search);
      const urlView = urlParams.get('view');
      // Onda 7 · 'orcamento' legacy é re-mapeado pra 'venda' (mesma intenção,
      // agora a fonte primária de agrupamento é a venda, não o orçamento)
      if (['venda','orcamento','status','fornecedor'].includes(urlView)) {
        this.#viewMode = urlView === 'orcamento' ? 'venda' : urlView;
      }
      const urlStatus = urlParams.get('status');
      if (['all','draft','sent','confirmed','cancelled'].includes(urlStatus)) this.#statusFilter = urlStatus;
      const urlScope = urlParams.get('scope');
      if (['mine','team','specifica','all'].includes(urlScope)) this.#scope = urlScope;
      // UI-FIX 2b · period URL param
      const urlPeriod = urlParams.get('period');
      if (urlPeriod && TsfPeriodFilter.isValidPeriod(urlPeriod)) this.#periodFilter = urlPeriod;

      const created = urlParams.get('created');
      // UI-FIX 2b · counts respeitam período
      const pedidosScoped = this.#filterPedidosByPeriod(this.#pedidos);
      const totalDraft = pedidosScoped.filter(p => p.status === 'draft').length;
      const totalSent = pedidosScoped.filter(p => p.status === 'sent').length;
      const totalConfirmed = pedidosScoped.filter(p => p.status === 'confirmed').length;
      this.#setBylineStatus(`${pedidosScoped.length} pedidos · ${totalDraft} rascunho · ${totalSent} enviados · ${totalConfirmed} confirmados`);

      const successBanner = created
        ? `<div class="tsf-pedido-banner tsf-pedido-banner--success">
             <span><strong>${created}</strong> pedido${created > 1 ? 's' : ''} processado${created > 1 ? 's' : ''} a partir do orçamento</span>
             <button type="button" class="tsf-pedido-banner__close" aria-label="Dispensar">×</button>
           </div>`
        : '';

      this.innerHTML = `
        ${successBanner}
        <div class="tsf-pedido-list" data-view-mode="${this.#viewMode}">
          ${renderScopeToggleHtml(this.#scope)}
          ${TsfPeriodFilter.renderToggle(this.#periodFilter)}
          <header class="tsf-pedido-list__toolbar">
            <div class="tsf-pedido-list__view-modes" role="tablist" aria-label="Modo de visualização">
              <button type="button" class="tsf-pedido-list__view-mode ${this.#viewMode==='venda'?'is-active':''}" data-view="venda" role="tab" aria-selected="${this.#viewMode==='venda'}" title="Agrupado por venda · cada pedido nasce de uma venda (fluxo orçamento → venda → pedidos)">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6h18l-2 13H5z"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>
                <span>Por venda</span>
              </button>
              <button type="button" class="tsf-pedido-list__view-mode ${this.#viewMode==='status'?'is-active':''}" data-view="status" role="tab" aria-selected="${this.#viewMode==='status'}" title="Kanban por status · fluxo Rascunho → Enviado → Confirmado → Cancelado">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="3" width="6" height="18" rx="1"/><rect x="10" y="3" width="6" height="13" rx="1"/><rect x="17" y="3" width="4" height="8" rx="1"/></svg>
                <span>Por status</span>
              </button>
              <button type="button" class="tsf-pedido-list__view-mode ${this.#viewMode==='fornecedor'?'is-active':''}" data-view="fornecedor" role="tab" aria-selected="${this.#viewMode==='fornecedor'}" title="Agrupado por fornecedor · útil para enviar todas as ordens de uma fábrica em paralelo">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2 22V8a2 2 0 0 1 2-2h4l4-4 4 4h4a2 2 0 0 1 2 2v14"/><path d="M2 14h20"/><path d="M2 18h20"/></svg>
                <span>Por fornecedor</span>
              </button>
            </div>
            <a href="/pages/admin-orcamento" class="tsf-pedido-list__new">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true">
                <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
              </svg>
              <span>Novo orçamento</span>
            </a>
          </header>

          <nav class="tsf-pedido-list__filters" role="tablist" aria-label="Filtrar por status">
            <button type="button" class="tsf-pedido-list__filter ${this.#statusFilter==='all'?'is-active':''}" data-filter="all" role="tab" aria-selected="${this.#statusFilter==='all'}">Todos <span>${pedidosScoped.length}</span></button>
            <button type="button" class="tsf-pedido-list__filter ${this.#statusFilter==='draft'?'is-active':''}" data-filter="draft" role="tab" aria-selected="${this.#statusFilter==='draft'}">Rascunhos <span>${totalDraft}</span></button>
            <button type="button" class="tsf-pedido-list__filter ${this.#statusFilter==='sent'?'is-active':''}" data-filter="sent" role="tab" aria-selected="${this.#statusFilter==='sent'}">Enviados <span>${totalSent}</span></button>
            <button type="button" class="tsf-pedido-list__filter ${this.#statusFilter==='confirmed'?'is-active':''}" data-filter="confirmed" role="tab" aria-selected="${this.#statusFilter==='confirmed'}">Confirmados <span>${totalConfirmed}</span></button>
            <button type="button" class="tsf-pedido-list__filter ${this.#statusFilter==='cancelled'?'is-active':''}" data-filter="cancelled" role="tab" aria-selected="${this.#statusFilter==='cancelled'}">Cancelados <span>${pedidosScoped.filter(p=>p.status==='cancelled').length}</span></button>
          </nav>

          <div class="tsf-pedido-list__body" data-tsf-pedido-body>
            ${pedidosScoped.length === 0 ? this.#renderEmptyState() : this.#renderByCurrentView(pedidosScoped)}
          </div>
        </div>
      `;

      this.#bindListEvents();
      // UI-FIX 2b · period toggle listeners
      TsfPeriodFilter.attachListeners(
        this,
        () => this.#periodFilter,
        (newPeriod) => this.#onPeriodChange(newPeriod),
        this.#abortController.signal,
      );
    }

    #onPeriodChange(period) {
      this.#periodFilter = period;
      try {
        const url = new URL(window.location.href);
        if (period !== 'all') url.searchParams.set('period', period);
        else url.searchParams.delete('period');
        window.history.replaceState({}, '', url.toString());
      } catch {}
      // Re-render list (mais simples que sync inline — pedidos têm view-mode complexo)
      this.#renderList();
    }

    #renderEmptyState() {
      return `
        <div class="tsf-pedido-list__empty">
          <svg width="56" height="56" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="0.8" aria-hidden="true">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="9" y1="13" x2="15" y2="13"/><line x1="9" y1="17" x2="15" y2="17"/>
          </svg>
          <h2>Nenhum pedido ainda</h2>
          <p>Pedidos criados a partir de um orçamento aparecem aqui · um por fornecedor.</p>
          <a href="/pages/admin-orcamento" class="tsf-pedido-list__empty-cta">
            <span>Ir pro orçamento</span>
            <svg width="14" height="10" viewBox="0 0 14 10" fill="none" aria-hidden="true"><path fill="currentColor" d="M8.537.808a.5.5 0 0 1 .817-.162l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 1 1-.708-.708L11.793 5.5H1a.5.5 0 0 1 0-1h10.793L8.646 1.354a.5.5 0 0 1-.109-.546Z"/></svg>
          </a>
        </div>
      `;
    }

    // Onda 7 · Usa numero_orcamento persistido (TOTH-2026-ORC-1001+).
    // Fallback gerado se quote ainda não migrou.
    #computeOrcNumber(quote) {
      if (!quote) return 'ORC-?';
      if (quote.numero_orcamento) return quote.numero_orcamento;
      const created = quote.created_at ? new Date(quote.created_at) : new Date();
      const year = created.getFullYear();
      const digitsOnly = (quote.id || '').replace(/[^0-9]/g, '');
      const suffix = digitsOnly.slice(-4).padStart(4, '0');
      return `TOTH-${year}-ORC-${suffix}`;
    }

    // Filtra pedidos pelo statusFilter atual
    #applyStatusFilter(pedidos) {
      if (this.#statusFilter === 'all') return pedidos;
      return pedidos.filter(p => p.status === this.#statusFilter);
    }

    // Router · escolhe render baseado no viewMode
    #renderByCurrentView(pedidosSource) {
      // UI-FIX 2b · aceita lista pré-filtrada por período (fallback para #pedidos pra backcompat)
      const source = Array.isArray(pedidosSource) ? pedidosSource : this.#filterPedidosByPeriod(this.#pedidos);
      const filtered = this.#applyStatusFilter(source);
      if (filtered.length === 0) {
        return `<div class="tsf-pedido-list__empty tsf-pedido-list__empty--filtered">
          <p>Nenhum pedido com o filtro <strong>${this.#esc(this.#statusFilter)}</strong>.</p>
        </div>`;
      }
      if (this.#viewMode === 'status') return this.#renderByStatus(filtered);
      if (this.#viewMode === 'fornecedor') return this.#renderByFornecedor(filtered);
      return this.#renderByVenda(filtered);
    }

    // Onda 7 · MODO 1 · Por venda (default)
    // Pedido nasce da venda · agrupamento primário é sale_id.
    // Pedidos sem sale_id vão pra "sem venda" (legacy ou pedido direto).
    #renderByVenda(pedidos) {
      const groups = new Map();
      const orphans = [];
      for (const p of pedidos) {
        if (!p.sale_id) {
          orphans.push(p);
          continue;
        }
        if (!groups.has(p.sale_id)) groups.set(p.sale_id, []);
        groups.get(p.sale_id).push(p);
      }

      // Ordena grupos por updated_at mais recente do pedido no grupo
      const groupArr = Array.from(groups.entries()).map(([saleId, peds]) => {
        const sale = this.#salesById.get(saleId);
        const quote = sale?.quote_id ? this.#quotesById.get(sale.quote_id) : null;
        const mostRecent = peds.reduce((acc, p) => {
          const t = new Date(p.updated_at).getTime();
          return t > acc ? t : acc;
        }, 0);
        return { saleId, peds, sale, quote, mostRecent };
      });
      groupArr.sort((a, b) => b.mostRecent - a.mostRecent);

      let html = '<ol class="tsf-pedido-groups">';
      for (const { saleId, peds, sale, quote } of groupArr) {
        html += this.#groupCardHtml({ saleId, peds, sale, quote });
      }
      if (orphans.length > 0) {
        html += `
          <li class="tsf-pedido-group tsf-pedido-group--orphans">
            <header class="tsf-pedido-group__head">
              <div class="tsf-pedido-group__id-row">
                <span class="tsf-pedido-group__number tsf-pedido-group__number--ghost">SEM VENDA</span>
                <span class="tsf-pedido-group__client">Pedidos legacy / diretos</span>
              </div>
              <div class="tsf-pedido-group__stats">
                <span>${orphans.length} pedido${orphans.length>1?'s':''}</span>
              </div>
            </header>
            <div class="tsf-pedido-group__body">
              <ol class="tsf-pedido-list__grid">${orphans.map(p => this.#cardHtml(p, { hideOrcLink: true })).join('')}</ol>
            </div>
          </li>
        `;
      }
      html += '</ol>';
      return html;
    }

    // Onda 7 · Header do grupo mostra VND-NNNN (venda) com link pra editor da venda.
    // Mostra também ORC-NNNN secundário quando a venda veio de um orçamento.
    #groupCardHtml({ saleId, peds, sale, quote }) {
      const vendaNumber = sale?.numero_venda || 'VND-?';
      const orcNumber = quote ? this.#computeOrcNumber(quote) : null;
      const collapsed = this.#collapsedGroups.has(saleId);
      const clientName = sale?.client_info?.name || quote?.client_info?.name || 'Cliente sem nome';
      const kind = quote?.quote_kind === 'toth_internal' ? 'Toth Internal' : 'Specifica';
      const kindClass = quote?.quote_kind === 'toth_internal' ? 'tsf-pedido-group__kind--toth' : 'tsf-pedido-group__kind--specifica';

      // Stats
      const fornecedoresSet = new Set(peds.map(p => p.fornecedor_handle));
      const totalItems = peds.reduce((acc, p) => acc + (Array.isArray(p.items) ? p.items.length : 0), 0);
      const totalUnits = peds.reduce((acc, p) => {
        return acc + (Array.isArray(p.items) ? p.items.reduce((a, it) => a + (it.qty || 1), 0) : 0);
      }, 0);
      const totalCentavos = peds.reduce((acc, p) => {
        const layers = Array.isArray(p.discount_layers) ? p.discount_layers : [];
        const items = Array.isArray(p.items) ? p.items : [];
        return acc + items.reduce((a, it) => {
          const cost = it.snapshot?.cost_centavos || 0;
          const net = applyDiscountLayers(cost, layers);
          return a + net * (it.qty || 1);
        }, 0);
      }, 0);

      // Progresso por status
      const byStatus = { draft: 0, sent: 0, confirmed: 0, cancelled: 0 };
      for (const p of peds) {
        if (p.status in byStatus) byStatus[p.status]++;
      }

      const saleLinkHref = sale ? `/pages/admin-venda?id=${this.#esc(saleId)}` : '#';
      const orcLinkHref = quote ? `/pages/admin-orcamento?id=${this.#esc(quote.id)}` : null;

      return `
        <li class="tsf-pedido-group ${collapsed ? 'is-collapsed' : ''}" data-sale-id="${this.#esc(saleId)}">
          <header class="tsf-pedido-group__head">
            <button type="button" class="tsf-pedido-group__toggle" aria-expanded="${!collapsed}" aria-label="${collapsed ? 'Expandir' : 'Colapsar'} grupo" data-group-toggle="${this.#esc(saleId)}">
              <svg width="12" height="12" viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><polyline points="3 4.5 6 7.5 9 4.5"/></svg>
            </button>
            <div class="tsf-pedido-group__main">
              <div class="tsf-pedido-group__id-row">
                <span class="tsf-pedido-group__number">${this.#esc(vendaNumber)}</span>
                ${orcNumber ? `<span class="tsf-pedido-group__sub" title="Origem">de ${this.#esc(orcNumber)}</span>` : ''}
                <span class="tsf-pedido-group__client">${this.#esc(clientName)}</span>
                <span class="tsf-pedido-group__kind ${kindClass}">${kind}</span>
              </div>
              <div class="tsf-pedido-group__stats">
                <span class="tsf-pedido-group__stat"><strong>${fornecedoresSet.size}</strong> ${fornecedoresSet.size === 1 ? 'fornecedor' : 'fornecedores'}</span>
                <span class="tsf-pedido-group__stat"><strong>${totalItems}</strong> ${totalItems === 1 ? 'item' : 'items'}</span>
                <span class="tsf-pedido-group__stat"><strong>${totalUnits}</strong> ${totalUnits === 1 ? 'unidade' : 'unidades'}</span>
                <span class="tsf-pedido-group__stat tsf-pedido-group__stat--value"><strong>${money(totalCentavos)}</strong></span>
              </div>
              <div class="tsf-pedido-group__progress" aria-label="Progresso por status">
                ${byStatus.draft > 0 ? `<span class="tsf-pedido-group__pill tsf-pedido-group__pill--draft">${byStatus.draft} rascunho${byStatus.draft>1?'s':''}</span>` : ''}
                ${byStatus.sent > 0 ? `<span class="tsf-pedido-group__pill tsf-pedido-group__pill--sent">${byStatus.sent} enviado${byStatus.sent>1?'s':''}</span>` : ''}
                ${byStatus.confirmed > 0 ? `<span class="tsf-pedido-group__pill tsf-pedido-group__pill--confirmed">${byStatus.confirmed} confirmado${byStatus.confirmed>1?'s':''}</span>` : ''}
                ${byStatus.cancelled > 0 ? `<span class="tsf-pedido-group__pill tsf-pedido-group__pill--cancelled">${byStatus.cancelled} cancelado${byStatus.cancelled>1?'s':''}</span>` : ''}
              </div>
            </div>
            <div class="tsf-pedido-group__actions">
              ${sale ? `<a href="${saleLinkHref}" class="tsf-pedido-group__view-orc">
                <span>Ver venda</span>
                <svg width="12" height="10" viewBox="0 0 12 10" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><line x1="1" y1="5" x2="11" y2="5"/><polyline points="7 1 11 5 7 9"/></svg>
              </a>` : ''}
            </div>
          </header>
          <div class="tsf-pedido-group__body">
            <ol class="tsf-pedido-list__grid">${peds.map(p => this.#cardHtml(p, { hideOrcLink: true })).join('')}</ol>
          </div>
        </li>
      `;
    }

    // MODO 2 · Kanban por status
    #renderByStatus(pedidos) {
      const columns = [
        { key: 'draft', label: 'Rascunho', desc: 'Em construção pelo vendedor' },
        { key: 'sent', label: 'Enviado', desc: 'Aguardando confirmação da fábrica' },
        { key: 'confirmed', label: 'Confirmado', desc: 'Em produção pela fábrica' },
        { key: 'cancelled', label: 'Cancelado', desc: 'Pedido encerrado' },
      ];
      const byStatus = new Map();
      for (const col of columns) byStatus.set(col.key, []);
      for (const p of pedidos) {
        if (byStatus.has(p.status)) byStatus.get(p.status).push(p);
      }
      let html = '<div class="tsf-pedido-kanban">';
      for (const col of columns) {
        const items = byStatus.get(col.key) || [];
        html += `
          <div class="tsf-pedido-kanban__col" data-status="${col.key}">
            <header class="tsf-pedido-kanban__head">
              <h3>${col.label} <span class="tsf-pedido-kanban__count">${items.length}</span></h3>
              <p>${col.desc}</p>
            </header>
            <ol class="tsf-pedido-kanban__items">
              ${items.length === 0
                ? `<li class="tsf-pedido-kanban__empty">Nenhum pedido</li>`
                : items.map(p => this.#cardHtml(p, { compact: true, showOrcRef: true })).join('')}
            </ol>
          </div>
        `;
      }
      html += '</div>';
      return html;
    }

    // MODO 3 · Agrupado por fornecedor
    #renderByFornecedor(pedidos) {
      const groups = new Map();
      for (const p of pedidos) {
        const handle = p.fornecedor_handle || 'sem-fornecedor';
        if (!groups.has(handle)) groups.set(handle, []);
        groups.get(handle).push(p);
      }
      // Ordena por count desc · fornecedor mais ativo primeiro
      const groupArr = Array.from(groups.entries()).sort((a, b) => b[1].length - a[1].length);

      let html = '<ol class="tsf-pedido-groups tsf-pedido-groups--fornecedor">';
      for (const [handle, peds] of groupArr) {
        const collapsed = this.#collapsedGroups.has('forn:' + handle);
        const fornecedorName = peds[0]?.snapshot_fornecedor?.nome || handle;
        const totalCentavos = peds.reduce((acc, p) => {
          const layers = Array.isArray(p.discount_layers) ? p.discount_layers : [];
          const items = Array.isArray(p.items) ? p.items : [];
          return acc + items.reduce((a, it) => {
            const cost = it.snapshot?.cost_centavos || 0;
            const net = applyDiscountLayers(cost, layers);
            return a + net * (it.qty || 1);
          }, 0);
        }, 0);
        html += `
          <li class="tsf-pedido-group ${collapsed ? 'is-collapsed' : ''}" data-fornecedor-handle="${this.#esc(handle)}">
            <header class="tsf-pedido-group__head">
              <button type="button" class="tsf-pedido-group__toggle" aria-expanded="${!collapsed}" data-group-toggle="forn:${this.#esc(handle)}">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><polyline points="3 4.5 6 7.5 9 4.5"/></svg>
              </button>
              <div class="tsf-pedido-group__main">
                <div class="tsf-pedido-group__id-row">
                  <span class="tsf-pedido-group__number tsf-pedido-group__number--fornecedor">${this.#esc(fornecedorName)}</span>
                  <span class="tsf-pedido-group__client">${peds.length} pedido${peds.length>1?'s':''}</span>
                </div>
                <div class="tsf-pedido-group__stats">
                  <span class="tsf-pedido-group__stat tsf-pedido-group__stat--value"><strong>${money(totalCentavos)}</strong></span>
                </div>
              </div>
            </header>
            <div class="tsf-pedido-group__body">
              <ol class="tsf-pedido-list__grid">${peds.map(p => this.#cardHtml(p, { showOrcRef: true })).join('')}</ol>
            </div>
          </li>
        `;
      }
      html += '</ol>';
      return html;
    }

    #renderListCards(pedidos) {
      return pedidos.map(p => this.#cardHtml(p)).join('');
    }

    #cardHtml(p, opts = {}) {
      const { compact = false, showOrcRef = false } = opts;
      const status = STATUS_LABELS[p.status] || STATUS_LABELS.draft;
      const fornecedor = p.snapshot_fornecedor || {};
      const fornecedorName = fornecedor.nome || p.fornecedor_handle;
      const items = Array.isArray(p.items) ? p.items : [];
      const totalUnits = items.reduce((acc, it) => acc + (it.qty || 1), 0);
      const layers = Array.isArray(p.discount_layers) ? p.discount_layers : [];
      const totalCentavos = items.reduce((acc, it) => {
        const cost = it.snapshot?.cost_centavos || 0;
        const net = applyDiscountLayers(cost, layers);
        return acc + net * (it.qty || 1);
      }, 0);
      const updatedAt = p.updated_at ? new Date(p.updated_at) : null;
      const ago = updatedAt ? this.#timeAgo(updatedAt) : '—';

      // Reference ao orçamento (modo kanban + fornecedor)
      const quote = p.quote_id ? this.#quotesById.get(p.quote_id) : null;
      const orcRefHtml = (showOrcRef && quote)
        ? `<div class="tsf-pedido-card__orc-ref" title="Orçamento de origem">
             <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>
             <span>${this.#esc(this.#computeOrcNumber(quote))}</span>
             <span class="tsf-pedido-card__orc-ref-client">${this.#esc(quote?.client_info?.name || '')}</span>
           </div>`
        : '';

      const compactClass = compact ? ' tsf-pedido-card--compact' : '';

      // Onda 6.12 · permite hard delete em draft OU cancelled (status finais)
      const canDelete = ['draft', 'cancelled'].includes(p.status);
      return `
        <li class="tsf-pedido-card${compactClass}" data-pedido-status="${this.#esc(p.status)}">
          <a class="tsf-pedido-card__link" href="/pages/admin-pedido?id=${this.#esc(p.id)}">
            <header class="tsf-pedido-card__head">
              <span class="tsf-pedido-card__number">${this.#esc(p.numero_pedido)}</span>
              <span class="tsf-pedido-badge ${status.className}">${status.label}</span>
            </header>
            <h3 class="tsf-pedido-card__forn">${this.#esc(fornecedorName)}</h3>
            ${orcRefHtml}
            <div class="tsf-pedido-card__meta">
              ${items.length} ${items.length === 1 ? 'item' : 'items'} · ${totalUnits} ${totalUnits === 1 ? 'unidade' : 'unidades'}
            </div>
            <div class="tsf-pedido-card__value">
              ${money(totalCentavos)}
            </div>
          </a>
          <footer class="tsf-admin-card-footer">
            <span class="tsf-admin-card-footer__meta">${p.specifier_email ? 'Por ' + this.#esc(p.specifier_email) + ' · ' : ''}${p.status === 'sent' && p.sent_at ? 'Enviado ' + this.#timeAgo(new Date(p.sent_at)) : 'Editado ' + ago}</span>
            <div class="tsf-admin-card-footer__actions">
              ${canDelete ? `
                <button type="button" class="tsf-admin-card-footer__delete" data-tsf-admin-delete-pedido="${this.#esc(p.id)}" data-numero="${this.#esc(p.numero_pedido)}" title="Excluir pedido" aria-label="Excluir pedido">
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                    <polyline points="3 6 5 6 21 6"/><path d="M19 6l-2 14a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2L5 6"/><path d="M10 11l0 6"/><path d="M14 11l0 6"/><path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>
                  </svg>
                </button>
              ` : ''}
              <a href="/pages/admin-pedido?id=${this.#esc(p.id)}" class="tsf-admin-card-footer__cta">Abrir →</a>
            </div>
          </footer>
        </li>
      `;
    }

    async #onCardDeletePedido(id, numero) {
      const ok = confirm(`Excluir pedido ${numero}?\n\nEsta ação NÃO PODE ser desfeita. Só funciona se rascunho.`);
      if (!ok) return;
      try {
        const res = await fetch(`${PEDIDO_ENDPOINT}/delete`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id }),
        });
        const data = await res.json();
        if (!data.ok) {
          alert(data.message || data.error || 'Falha');
          return;
        }
        this.#pedidos = this.#pedidos.filter(p => p.id !== id);
        this.#refreshBody();
      } catch (err) {
        alert('Erro: ' + err.message);
      }
    }

    #timeAgo(date) {
      const seconds = Math.floor((Date.now() - date.getTime()) / 1000);
      if (seconds < 60) return 'agora';
      const minutes = Math.floor(seconds / 60);
      if (minutes < 60) return `${minutes} min`;
      const hours = Math.floor(minutes / 60);
      if (hours < 24) return `${hours}h`;
      const days = Math.floor(hours / 24);
      if (days < 30) return `${days}d`;
      const months = Math.floor(days / 30);
      return `${months} mês${months > 1 ? 'es' : ''}`;
    }

    #bindListEvents() {
      const { signal } = this.#abortController;

      this.querySelector('.tsf-pedido-banner__close')?.addEventListener('click', (e) => {
        e.currentTarget.closest('.tsf-pedido-banner')?.remove();
      }, { signal });

      // Status filter
      this.querySelectorAll('.tsf-pedido-list__filter').forEach(btn => {
        btn.addEventListener('click', () => this.#onFilterChange(btn), { signal });
      });

      // View mode toggle (Por orçamento · Por status · Por fornecedor)
      this.querySelectorAll('.tsf-pedido-list__view-mode').forEach(btn => {
        btn.addEventListener('click', () => this.#onViewModeChange(btn), { signal });
      });

      // Delegação · botão excluir direto + scope toggle
      this.addEventListener('click', (e) => {
        const delBtn = e.target.closest?.('[data-tsf-admin-delete-pedido]');
        if (delBtn) {
          e.preventDefault();
          e.stopPropagation();
          this.#onCardDeletePedido(delBtn.getAttribute('data-tsf-admin-delete-pedido'), delBtn.getAttribute('data-numero'));
          return;
        }
        const scopeBtn = e.target.closest?.('[data-scope]');
        if (scopeBtn) {
          e.preventDefault();
          const scope = scopeBtn.getAttribute('data-scope');
          if (['mine','team','specifica','all'].includes(scope) && scope !== this.#scope) {
            this.#scope = scope;
            try {
              const url = new URL(window.location.href);
              if (scope !== 'all') url.searchParams.set('scope', scope);
              else url.searchParams.delete('scope');
              window.history.replaceState({}, '', url.toString());
            } catch {}
            this.#renderList(); // refetch + re-render
          }
        }
      }, { signal });

      // Toggle de colapso dos grupos (delegação · funciona após re-render)
      this.addEventListener('click', (e) => {
        const toggle = e.target.closest('[data-group-toggle]');
        if (!toggle) return;
        e.preventDefault();
        const key = toggle.getAttribute('data-group-toggle');
        const group = toggle.closest('.tsf-pedido-group');
        if (this.#collapsedGroups.has(key)) {
          this.#collapsedGroups.delete(key);
          group?.classList.remove('is-collapsed');
          toggle.setAttribute('aria-expanded', 'true');
        } else {
          this.#collapsedGroups.add(key);
          group?.classList.add('is-collapsed');
          toggle.setAttribute('aria-expanded', 'false');
        }
      }, { signal });
    }

    #onFilterChange(btn) {
      const filter = btn.getAttribute('data-filter');
      this.#statusFilter = filter;
      this.querySelectorAll('.tsf-pedido-list__filter').forEach(b => {
        b.classList.toggle('is-active', b === btn);
        b.setAttribute('aria-selected', b === btn ? 'true' : 'false');
      });
      this.#refreshBody();
      this.#syncUrlState();
    }

    #onViewModeChange(btn) {
      const view = btn.getAttribute('data-view');
      if (!['orcamento','status','fornecedor'].includes(view)) return;
      this.#viewMode = view;
      this.querySelectorAll('.tsf-pedido-list__view-mode').forEach(b => {
        b.classList.toggle('is-active', b === btn);
        b.setAttribute('aria-selected', b === btn ? 'true' : 'false');
      });
      const listEl = this.querySelector('.tsf-pedido-list');
      if (listEl) listEl.setAttribute('data-view-mode', view);
      this.#refreshBody();
      this.#syncUrlState();
    }

    // Re-renderiza apenas o body (sem refetch · sem re-renderizar toolbar)
    #refreshBody() {
      const bodyEl = this.querySelector('[data-tsf-pedido-body]');
      if (!bodyEl) return;
      bodyEl.innerHTML = this.#pedidos.length === 0 ? this.#renderEmptyState() : this.#renderByCurrentView();
    }

    // Sync state pra URL · permite bookmark/compartilhar view
    // Onda 7 · default 'venda' (era 'orcamento')
    #syncUrlState() {
      try {
        const url = new URL(window.location.href);
        if (this.#viewMode !== 'venda') url.searchParams.set('view', this.#viewMode);
        else url.searchParams.delete('view');
        if (this.#statusFilter !== 'all') url.searchParams.set('status', this.#statusFilter);
        else url.searchParams.delete('status');
        url.searchParams.delete('created'); // clean banner state from URL após interação
        window.history.replaceState({}, '', url.toString());
      } catch {}
    }

    // EDITOR ════════════════════════════════════════════════════════════
    // Inline edit factory-grade · auto-save debounced · NF-e feel
    // ════════════════════════════════════════════════════════════════════

    async #renderEditor() {
      this.#setBylineStatus('Carregando');
      try {
        const res = await fetch(`${PEDIDO_ENDPOINT}/get?id=${encodeURIComponent(this.#pedidoId)}`, { signal: this.#abortController.signal });
        const data = await res.json();
        if (!data.ok) throw new Error(data.error || 'falha ao carregar');
        this.#currentPedido = data.pedido;
      } catch (err) {
        this.#renderError('Falha ao carregar pedido: ' + err.message);
        return;
      }

      this.#paintEditor();
    }

    #paintEditor() {
      const p = this.#currentPedido;
      if (!p) return;

      const status = STATUS_LABELS[p.status] || STATUS_LABELS.draft;
      const isEditable = p.status === 'draft';
      this.#setBylineStatus(`${this.#esc(p.numero_pedido)} · ${status.label}`);

      const totals = this.#computeTotals(p);
      const fornecedor = p.snapshot_fornecedor || {};
      const toth = p.snapshot_toth || {};
      const layersStr = discountLayersToString(p.discount_layers || []);

      this.innerHTML = `
        <div class="tsf-pedido-editor" data-pedido-status="${this.#esc(p.status)}" data-editable="${isEditable}">

          ${this.#editorToolbarHtml(p, status, isEditable)}

          <section class="tsf-pedido-editor__parties" aria-label="Endereçamento do pedido">
            ${this.#partyCardHtml('PARA · Fornecedor', fornecedor, 'forn')}
            ${this.#partyCardHtml('DE · Toth', toth, 'toth')}
          </section>

          <section class="tsf-pedido-editor__items">
            <header class="tsf-pedido-editor__section-head">
              <h2>Itens do pedido</h2>
              <span class="tsf-pedido-editor__section-meta">${totals.itemCount} ${totals.itemCount === 1 ? 'produto' : 'produtos'} · ${totals.unitCount} ${totals.unitCount === 1 ? 'unidade' : 'unidades'}</span>
            </header>

            ${(p.items || []).length === 0
              ? `<div class="tsf-pedido-editor__items-empty">
                   <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="0.8" aria-hidden="true">
                     <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/>
                   </svg>
                   <p><strong>Este pedido está vazio.</strong></p>
                   <p>O fluxo recomendado é: monte um <a href="/pages/orcamento">orçamento</a> com os produtos, depois clique em <strong>Gerar pedidos</strong> — o sistema separa automaticamente por fornecedor.</p>
                 </div>`
              : `<ol class="tsf-pedido-editor__items-list" data-tsf-pedido-items>
                   ${p.items.map((it, idx) => this.#itemRowHtml(it, idx + 1, p.discount_layers || [], isEditable)).join('')}
                 </ol>`
            }
          </section>

          <section class="tsf-pedido-editor__config" aria-label="Condições e endereçamento">
            <header class="tsf-pedido-editor__section-head">
              <h2>Condições</h2>
            </header>

            <div class="tsf-pedido-editor__config-grid">
              <label class="tsf-pedido-editor__field">
                <span class="tsf-pedido-editor__field-label">Condição de pagamento</span>
                <select class="tsf-pedido-editor__select" data-tsf-pedido-edit="payment_condition" ${!isEditable ? 'disabled' : ''}>
                  <option value="" ${!p.payment_condition ? 'selected' : ''}>— Selecione</option>
                  <option value="antecipado_100" ${p.payment_condition === 'antecipado_100' ? 'selected' : ''}>Antecipado 100%</option>
                  <option value="antecipado_50_50" ${p.payment_condition === 'antecipado_50_50' ? 'selected' : ''}>Antecipado 50% + 50% na entrega</option>
                  <option value="antecipado_30_70" ${p.payment_condition === 'antecipado_30_70' ? 'selected' : ''}>Antecipado 30% + 70% na entrega</option>
                  <option value="boleto_30dd" ${p.payment_condition === 'boleto_30dd' ? 'selected' : ''}>Boleto 30 dias</option>
                </select>
              </label>

              ${this.#fieldWithNativeHtml({
                label: 'Transportadora',
                field: 'transportadora',
                current: p.transportadora || '',
                native: p.native_transportadora || '',
                isEditable,
                inputType: 'text',
                placeholder: 'Ex: Vipex, TJ Frete, Total Express…',
                hint: 'Onda 11.2 · Propagado da venda · pode editar livre',
              })}

              ${this.#fieldWithNativeHtml({
                label: 'Camadas de desconto',
                field: 'discount_layers',
                current: layersStr,
                native: discountLayersToString(p.native_discount_layers || []),
                isEditable,
                inputType: 'text',
                inputClass: 'tsf-pedido-editor__input--mono',
                placeholder: '10+5+5',
                pattern: '^\\\\d{1,2}(\\\\+\\\\d{1,2})*$',
                hint: 'Aplicado sobre o custo · ex: <code>10+5+5</code> = preço × 0,90 × 0,95 × 0,95',
              })}

              ${this.#fieldWithNativeHtml({
                label: 'Frete (R$) <em class="tsf-pedido-editor__field-tag">controle interno</em>',
                field: 'frete_centavos',
                current: ((p.frete_centavos || 0) / 100).toFixed(2),
                native: ((p.native_frete_centavos || 0) / 100).toFixed(2),
                isEditable,
                inputType: 'number',
                inputClass: 'tsf-pedido-editor__input--mono',
                placeholder: '0.00',
                inputAttrs: 'inputmode="decimal" step="0.01" min="0"',
                hint: 'Rateado automático da venda · não soma no total do pedido · pra conferência com a transportadora depois',
                formatNative: (v) => `R$ ${parseFloat(v || 0).toFixed(2).replace('.', ',')}`,
              })}

              <label class="tsf-pedido-editor__field tsf-pedido-editor__field--wide">
                <span class="tsf-pedido-editor__field-label">Observações gerais</span>
                <textarea class="tsf-pedido-editor__textarea"
                          data-tsf-pedido-edit="notes"
                          rows="2"
                          placeholder="Instruções específicas pra fábrica · prazos, embalagem, contatos…"
                          ${!isEditable ? 'disabled' : ''}>${this.#esc(p.notes || '')}</textarea>
              </label>
            </div>
          </section>

          ${this.#totalsHtml(totals)}

          ${this.#editorActionsHtml(p, isEditable)}
        </div>
      `;

      this.#bindEditorEvents();
    }

    #editorToolbarHtml(p, status, isEditable) {
      // Botões contextuais por status:
      // · draft           → Excluir (hard delete)
      // · sent/confirmed  → Solicitar alteração (request-alteration · dispara reenvio fábrica)
      // · todos exceto cancelled → Cancelar (soft, status='cancelled')
      const canDelete = p.status === 'draft';
      const canRequestAlteration = ['sent', 'confirmed'].includes(p.status);
      const canCancel = !['cancelled', 'alteration_requested'].includes(p.status);

      return `
        <header class="tsf-pedido-editor__toolbar">
          <a href="/pages/admin-pedidos" class="tsf-pedido-editor__back">
            <svg width="14" height="10" viewBox="0 0 14 10" fill="none" aria-hidden="true">
              <path fill="currentColor" d="M5.463 9.192a.5.5 0 0 1-.817.162l-4-4a.5.5 0 0 1 0-.708l4-4a.5.5 0 1 1 .708.708L2.207 4.5H13a.5.5 0 0 1 0 1H2.207l3.147 3.146a.5.5 0 0 1 .109.546Z"/>
            </svg>
            <span>Voltar à lista</span>
          </a>
          <div class="tsf-pedido-editor__toolbar-meta">
            <span class="tsf-pedido-editor__numero">${this.#esc(p.numero_pedido)}</span>
            <span class="tsf-pedido-badge ${status.className}">${status.label}</span>
            <span class="tsf-pedido-editor__save-status" data-tsf-pedido-save-status>—</span>
          </div>
          <div class="tsf-pedido-editor__toolbar-actions">
            ${canRequestAlteration ? `
              <button type="button" class="tsf-pedido-editor__btn-secondary" data-tsf-pedido-request-alteration title="Marca pedido como 'alteração solicitada' · email automático Onda 7">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                  <path d="M21 12a9 9 0 0 1-9 9m9-9a9 9 0 0 0-9-9m9 9H3m9 9a9 9 0 0 1-9-9m9 9c2.5-2.5 4-5.5 4-9s-1.5-6.5-4-9m0 18c-2.5-2.5-4-5.5-4-9s1.5-6.5 4-9"/>
                </svg>
                <span>Solicitar alteração</span>
              </button>
            ` : ''}
            ${canCancel ? `
              <button type="button" class="tsf-pedido-editor__btn-ghost" data-tsf-pedido-cancel title="Cancela pedido (preserva histórico)">
                Cancelar
              </button>
            ` : ''}
            ${canDelete ? `
              <button type="button" class="tsf-pedido-editor__btn-danger" data-tsf-pedido-delete title="Apaga pedido permanente (só rascunho)">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                  <polyline points="3 6 5 6 21 6"/><path d="M19 6l-2 14a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2L5 6"/>
                </svg>
                <span>Excluir</span>
              </button>
            ` : ''}
          </div>
        </header>
      `;
    }

    // Onda 11.2 · Field com tracking nativo vs editado (pattern do orçamento)
    // Compara current vs native · mostra badge "editado"/"nativo" · botão reset quando edited
    #fieldWithNativeHtml({ label, field, current, native, isEditable, inputType = 'text',
      inputClass = '', placeholder = '', pattern = '', inputAttrs = '', hint = '',
      formatNative = null }) {
      const currStr = String(current ?? '');
      const nativeStr = String(native ?? '');
      const hasNative = nativeStr !== '' && nativeStr !== '0.00';
      const isEdited = hasNative && currStr !== nativeStr;
      let badgeHtml = '';
      if (hasNative) {
        badgeHtml = isEdited
          ? `<span class="tsf-pedido-editor__field-badge tsf-pedido-editor__field-badge--manual" title="Valor alterado manualmente">editado</span>`
          : `<span class="tsf-pedido-editor__field-badge tsf-pedido-editor__field-badge--native" title="Valor do sistema (fornecedor/venda)">nativo</span>`;
      }
      const resetHtml = (isEdited && isEditable) ? `
        <button type="button" class="tsf-pedido-editor__field-reset"
                data-tsf-pedido-reset-field="${this.#esc(field)}"
                data-native-value="${this.#esc(nativeStr)}"
                title="Restaurar valor nativo do sistema">
          <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="M3 12a9 9 0 1 0 3-6.7"/><polyline points="3 4 3 10 9 10"/>
          </svg>
          <span>nativo ${this.#esc(formatNative ? formatNative(nativeStr) : nativeStr)}</span>
        </button>` : '';
      return `
        <label class="tsf-pedido-editor__field">
          <span class="tsf-pedido-editor__field-label">${label} ${badgeHtml}</span>
          <input type="${inputType}" class="tsf-pedido-editor__input ${inputClass}"
                 data-tsf-pedido-edit="${this.#esc(field)}"
                 value="${this.#esc(currStr)}"
                 placeholder="${this.#esc(placeholder)}"
                 ${pattern ? `pattern="${pattern}"` : ''}
                 ${inputAttrs}
                 ${!isEditable ? 'disabled' : ''}>
          ${resetHtml}
          ${hint ? `<small class="tsf-pedido-editor__field-hint">${hint}</small>` : ''}
        </label>
      `;
    }

    #partyCardHtml(label, party, kind) {
      const lines = [];
      if (party.razao_social || party.nome) {
        lines.push(`<strong class="tsf-pedido-editor__party-name">${this.#esc(party.razao_social || party.nome)}</strong>`);
      }
      if (party.nome_fantasia && party.nome_fantasia !== (party.razao_social || party.nome)) {
        lines.push(`<span class="tsf-pedido-editor__party-fantasia">${this.#esc(party.nome_fantasia)}</span>`);
      }
      if (party.cnpj) lines.push(`<span>CNPJ ${this.#esc(party.cnpj)}</span>`);
      if (party.inscricao_estadual) lines.push(`<span>IE ${this.#esc(party.inscricao_estadual)}</span>`);
      // Endereço composto
      const addrParts = [];
      if (party.endereco_fabrica) addrParts.push(party.endereco_fabrica);
      else if (party.endereco) addrParts.push(party.endereco);
      if (party.bairro) addrParts.push(party.bairro);
      const cityState = [];
      if (party.cidade) cityState.push(party.cidade);
      if (party.estado || party.uf) cityState.push(party.estado || party.uf);
      if (cityState.length) addrParts.push(cityState.join(' · '));
      if (party.cep_fabrica) addrParts.push(`CEP ${party.cep_fabrica}`);
      else if (party.cep) addrParts.push(`CEP ${party.cep}`);
      if (addrParts.length) {
        lines.push(`<span class="tsf-pedido-editor__party-addr">${this.#esc(addrParts.join(' · '))}</span>`);
      }
      if (party.email_fabrica) lines.push(`<a href="mailto:${this.#esc(party.email_fabrica)}">${this.#esc(party.email_fabrica)}</a>`);
      else if (party.email) lines.push(`<a href="mailto:${this.#esc(party.email)}">${this.#esc(party.email)}</a>`);
      if (party.whatsapp_fabrica) lines.push(`<span>📱 ${this.#esc(party.whatsapp_fabrica)}</span>`);
      else if (party.whatsapp) lines.push(`<span>📱 ${this.#esc(party.whatsapp)}</span>`);
      if (party.email_representante) lines.push(`<span class="tsf-pedido-editor__party-rep">Repr: ${this.#esc(party.email_representante)}</span>`);

      return `
        <article class="tsf-pedido-editor__party tsf-pedido-editor__party--${kind}">
          <header class="tsf-pedido-editor__party-head">
            <span class="tsf-pedido-editor__party-label">${this.#esc(label)}</span>
          </header>
          <div class="tsf-pedido-editor__party-body">
            ${lines.join('')}
          </div>
        </article>
      `;
    }

    #itemRowHtml(item, index, layers, isEditable) {
      const s = item.snapshot || {};
      const m = s.metafields || {};
      const ov = item.overrides || {};
      // Photo fallback robusto (snapshot pode ter image_url ou image)
      const photoUrl = item.selected_photo_url || s.image_url || s.image || s.featured_image || '';
      const productUrl = s.url || (item.product_handle ? `/products/${item.product_handle}` : '#');
      const title = s.title || '—';

      // 3-state helper genérico
      const specSource = (key) => {
        const native = m[key];
        const over = ov[key];
        const hasNative = native != null && String(native) !== '';
        const hasOver = over != null && String(over) !== '';
        if (hasOver && String(over) !== String(native ?? '')) return 'edited';
        if (hasNative) return 'native';
        return 'empty';
      };

      // Código: snapshot.codigo_fornecedor / codigo_produto / sku como native
      const codigoNative = s.codigo_fornecedor || s.codigo_produto || s.sku || '';
      const codigoOver = ov.codigo_produto;
      const codigoValue = codigoOver != null ? codigoOver : codigoNative;
      const codigoSource = (codigoOver != null && String(codigoOver) !== String(codigoNative))
        ? 'edited'
        : (codigoNative ? 'native' : 'empty');

      // Observações: sem native (sempre vazio ou editado)
      const obsValue = ov.observacoes != null ? ov.observacoes : '';
      const obsSource = obsValue ? 'edited' : 'empty';

      // Specs from metafields (cor, materiais, dimens_es, prazo)
      const cor = (ov.cor != null) ? ov.cor : (m.cor || '');
      const materiais = (ov.materiais != null) ? ov.materiais : (m.materiais || '');
      const dimens_es = (ov.dimens_es != null) ? ov.dimens_es : (m.dimens_es || '');
      const prazoProducao = (ov.prazo != null) ? ov.prazo : (m.prazo || '');

      // Cost: override → snapshot.cost_centavos → price_centavos fallback
      const nativeCost = (typeof s.cost_centavos === 'number' && s.cost_centavos > 0) ? s.cost_centavos : 0;
      const costOverridden = typeof ov.cost_centavos === 'number';
      const cost = costOverridden ? ov.cost_centavos : (nativeCost || s.price_centavos || 0);
      const costEditValue = (cost / 100).toFixed(2).replace('.', ',');
      const costNativeStr = nativeCost > 0 ? (nativeCost / 100).toFixed(2).replace('.', ',') : null;

      const net = applyDiscountLayers(cost, layers);
      const qty = item.qty || 1;
      const subtotalNet = net * qty;
      const savingsPerUnit = cost - net;
      const savingsTotal = savingsPerUnit * qty;

      // Badge helpers (mesmo padrão do orçamento)
      const badge = (source, nativePreview) => {
        if (source === 'native') return `<span class="tsf-quote-item__spec-badge tsf-quote-item__spec-badge--native" title="Valor vindo do cadastro do produto">nativo</span>`;
        if (source === 'edited') return `<span class="tsf-quote-item__spec-badge tsf-quote-item__spec-badge--manual" title="${this.#esc(nativePreview ? 'nativo · ' + nativePreview : 'Valor alterado manualmente')}">editado</span>`;
        return `<span class="tsf-quote-item__spec-badge tsf-quote-item__spec-badge--empty" title="Produto sem este dado cadastrado">vazio</span>`;
      };

      const resetBtn = (key, uid, nativeValue, prefix = '') => {
        if (nativeValue == null || nativeValue === '') return '';
        const nativeStr = String(nativeValue);
        const preview = nativeStr.length > 22 ? nativeStr.slice(0, 20) + '…' : nativeStr;
        return `
          <button type="button" class="tsf-quote-item__spec-reset"
                  data-tsf-pedido-item-reset="${this.#esc(key)}" data-uid="${this.#esc(uid)}"
                  title="Restaurar valor nativo">
            <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <path d="M3 12a9 9 0 1 0 3-6.7"/><polyline points="3 4 3 10 9 10"/>
            </svg>
            <span>nativo ${this.#esc(prefix + preview)}</span>
          </button>`;
      };

      // Spec block (input + badge + optional reset)
      const specBlock = (label, key, value, source, nativeValue, multiline = false, type = 'text') => {
        const v = value == null ? '' : value;
        const inputTag = multiline
          ? `<textarea class="tsf-quote-item__spec-input" rows="2"
                       data-tsf-pedido-item-edit="${key}" data-uid="${item.uid}"
                       aria-label="${this.#esc(label)}">${this.#esc(v)}</textarea>`
          : `<input type="${type}" class="tsf-quote-item__spec-input"
                    value="${this.#esc(v)}"
                    data-tsf-pedido-item-edit="${key}" data-uid="${item.uid}"
                    aria-label="${this.#esc(label)}">`;
        const showReset = source === 'edited' && nativeValue != null && String(nativeValue) !== '';
        return `
          <div class="tsf-quote-item__spec tsf-quote-item__spec--editable tsf-quote-item__spec--source-${source}">
            <dt class="tsf-quote-item__spec-dt-wrap">
              <span>${this.#esc(label)}</span>
              ${badge(source, nativeValue)}
            </dt>
            <dd>
              ${inputTag}
              ${showReset ? resetBtn(key, item.uid, nativeValue) : ''}
            </dd>
          </div>
        `;
      };

      // Cost block (mirror orçamento toth-edit pattern)
      const costBadge = costOverridden
        ? `<span class="tsf-quote-item__markup-badge tsf-quote-item__markup-badge--manual" title="Custo alterado manualmente">editado</span>`
        : `<span class="tsf-quote-item__markup-badge tsf-quote-item__markup-badge--native" title="Custo real do produto no Shopify Admin">nativo</span>`;

      const costResetHtml = (costOverridden && costNativeStr)
        ? `<button type="button" class="tsf-quote-item__markup-reset"
                   data-tsf-pedido-item-reset="cost_centavos" data-uid="${item.uid}"
                   title="Restaurar custo nativo do Shopify">
             <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
               <path d="M3 12a9 9 0 1 0 3-6.7"/><polyline points="3 4 3 10 9 10"/>
             </svg>
             <span>nativo R$ ${costNativeStr}</span>
           </button>`
        : '';

      // Painel direito · custo + desconto + líquido (mirror tothPricingHtml)
      const pricingHtml = `
        <div class="tsf-quote-item__pricing tsf-quote-item__pricing--toth">
          <div class="tsf-quote-item__toth-edit tsf-print-hide">
            <label class="tsf-quote-item__toth-edit-label tsf-quote-item__markup-label-wrap">
              <span class="tsf-quote-item__markup-label-top">
                <span>Custo unitário</span>
                ${costBadge}
              </span>
              <span class="tsf-quote-item__toth-input-row">
                <span class="tsf-quote-item__toth-prefix">R$</span>
                <input type="text" inputmode="decimal"
                       class="tsf-quote-item__toth-input tsf-quote-item__toth-input--cost"
                       value="${costEditValue}"
                       data-tsf-pedido-item-edit="cost_centavos" data-uid="${item.uid}"
                       ${!isEditable ? 'disabled' : ''}
                       aria-label="Custo unitário">
              </span>
              ${costResetHtml}
            </label>
          </div>
          <div class="tsf-quote-item__client tsf-pedido-item__net-block">
            ${layers.length > 0 ? `
              <span class="tsf-pedido-item__discount-line" data-tsf-pedido-item-discount-line="${item.uid}">
                Desconto <strong>${discountLayersToString(layers)}</strong> · −<span data-tsf-pedido-item-savings="${item.uid}">${money(savingsTotal)}</span>
              </span>
            ` : '<span class="tsf-pedido-item__discount-line tsf-pedido-item__discount-line--empty" data-tsf-pedido-item-discount-line="' + item.uid + '">Sem desconto aplicado</span>'}
            <span class="tsf-quote-item__client-label">Valor líquido</span>
            <span class="tsf-quote-item__client-value" data-tsf-pedido-item-subtotal="${item.uid}">${money(subtotalNet)}</span>
            <span class="tsf-quote-item__client-meta">${qty} × <span data-tsf-pedido-item-net-unit="${item.uid}">${money(net)}</span></span>
          </div>
        </div>
      `;

      return `
        <li class="tsf-quote-item tsf-quote-item--toth tsf-pedido-item" data-tsf-pedido-item="${item.uid}">
          <span class="tsf-quote-item__index" aria-hidden="true">${String(index).padStart(2, '0')}</span>

          <figure class="tsf-quote-item__media">
            <a class="tsf-quote-item__photo-print" href="${this.#esc(productUrl)}" target="_blank" rel="noopener" aria-hidden="true">
              ${photoUrl
                ? `<img src="${this.#esc(photoUrl)}" alt="${this.#esc(title)}" loading="lazy" width="200" height="200">`
                : `<span class="tsf-pedido-item__media-placeholder" aria-hidden="true">
                     <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" aria-hidden="true">
                       <rect x="3" y="3" width="18" height="18" rx="2"/>
                       <circle cx="8.5" cy="8.5" r="1.5"/>
                       <polyline points="21 15 16 10 5 21"/>
                     </svg>
                   </span>`}
            </a>
          </figure>

          <div class="tsf-quote-item__body">
            <header class="tsf-quote-item__header">
              <h3 class="tsf-quote-item__title">
                <a href="${this.#esc(productUrl)}" target="_blank" rel="noopener">${this.#esc(title)}</a>
              </h3>
              ${isEditable ? `
                <button type="button" class="tsf-quote-item__remove tsf-print-hide"
                        data-tsf-pedido-item-remove="${item.uid}"
                        aria-label="Remover do pedido">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                    <path d="M3 6h18"/><path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/>
                  </svg>
                </button>
              ` : ''}
            </header>

            <dl class="tsf-quote-item__specs tsf-quote-item__specs--editable">
              ${specBlock('Código fábrica', 'codigo_produto', codigoValue, codigoSource, codigoNative)}
              ${specBlock('Observações', 'observacoes', obsValue, obsSource, null, true)}
              ${specBlock('Acabamento', 'cor', cor, specSource('cor'), m.cor)}
              ${specBlock('Materiais', 'materiais', materiais, specSource('materiais'), m.materiais, true)}
              ${specBlock('Dimensões', 'dimens_es', dimens_es, specSource('dimens_es'), m.dimens_es, true)}
              ${specBlock('Prazo (dias)', 'prazo', prazoProducao || '', specSource('prazo'), m.prazo, false, 'number')}
            </dl>

            <footer class="tsf-quote-item__footer">
              <div class="tsf-quote-item__qty">
                <label class="tsf-quote-item__qty-label" for="qty-${item.uid}">Quantidade</label>
                <input type="number" id="qty-${item.uid}" min="1" step="1"
                       class="tsf-quote-item__qty-input"
                       data-tsf-pedido-item-edit="qty" data-uid="${item.uid}"
                       value="${qty}"
                       ${!isEditable ? 'disabled' : ''}
                       aria-label="Quantidade">
              </div>
              ${pricingHtml}
            </footer>
          </div>
        </li>
      `;
    }

    // Onda 11 · Resumo correto · (cost − desconto) + IPI = total · frete fora do total
    #totalsHtml(totals) {
      const ipiLabel = totals.ipiPct > 0 ? totals.ipiPct.toFixed(2).replace('.', ',') + '%' : '';
      return `
        <section class="tsf-pedido-editor__totals" aria-label="Totais do pedido">
          <div class="tsf-pedido-editor__totals-row">
            <span class="tsf-pedido-editor__totals-label">Subtotal bruto (custo)</span>
            <span class="tsf-pedido-editor__totals-value" data-tsf-pedido-total="gross">${money(totals.gross)}</span>
          </div>
          ${totals.discount > 0 ? `
            <div class="tsf-pedido-editor__totals-row tsf-pedido-editor__totals-row--discount">
              <span class="tsf-pedido-editor__totals-label">Economia (descontos)</span>
              <span class="tsf-pedido-editor__totals-value" data-tsf-pedido-total="discount">−${money(totals.discount)}</span>
            </div>
          ` : ''}
          <div class="tsf-pedido-editor__totals-row">
            <span class="tsf-pedido-editor__totals-label">Subtotal líquido <em>(custo − desconto)</em></span>
            <span class="tsf-pedido-editor__totals-value" data-tsf-pedido-total="net">${money(totals.net)}</span>
          </div>
          ${totals.ipi > 0 ? `
            <div class="tsf-pedido-editor__totals-row tsf-pedido-editor__totals-row--ipi">
              <span class="tsf-pedido-editor__totals-label">IPI <em>(${ipiLabel} · sobre subtotal líquido)</em></span>
              <span class="tsf-pedido-editor__totals-value" data-tsf-pedido-total="ipi">+${money(totals.ipi)}</span>
            </div>
          ` : ''}
          <div class="tsf-pedido-editor__totals-row tsf-pedido-editor__totals-row--final">
            <span class="tsf-pedido-editor__totals-label">Total do pedido</span>
            <span class="tsf-pedido-editor__totals-value" data-tsf-pedido-total="final">${money(totals.final)}</span>
          </div>
          ${totals.frete > 0 ? `
            <div class="tsf-pedido-editor__totals-row tsf-pedido-editor__totals-row--info">
              <span class="tsf-pedido-editor__totals-label">Frete <em>(informativo · cobrado pela transportadora · não soma no pedido)</em></span>
              <span class="tsf-pedido-editor__totals-value" data-tsf-pedido-total="frete">${money(totals.frete)}</span>
            </div>
          ` : ''}
        </section>
      `;
    }

    #editorActionsHtml(p, isEditable) {
      const buttons = [];

      if (p.status === 'draft') {
        buttons.push(`
          <button type="button" class="tsf-pedido-editor__action tsf-pedido-editor__action--ghost" data-tsf-pedido-action="cancel">
            <span>Cancelar pedido</span>
          </button>
        `);
      }

      buttons.push(`
        <button type="button" class="tsf-pedido-editor__action tsf-pedido-editor__action--ghost" data-tsf-pedido-action="pdf">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/>
          </svg>
          <span>Gerar PDF</span>
        </button>
      `);

      if (p.status === 'draft') {
        buttons.push(`
          <button type="button" class="tsf-pedido-editor__action tsf-pedido-editor__action--primary" data-tsf-pedido-action="send">
            <span>Enviar pedido</span>
            <svg width="14" height="10" viewBox="0 0 14 10" fill="none" aria-hidden="true">
              <path fill="currentColor" d="M8.537.808a.5.5 0 0 1 .817-.162l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 1 1-.708-.708L11.793 5.5H1a.5.5 0 0 1 0-1h10.793L8.646 1.354a.5.5 0 0 1-.109-.546Z"/>
            </svg>
          </button>
        `);
      } else if (p.status === 'sent') {
        buttons.push(`
          <button type="button" class="tsf-pedido-editor__action tsf-pedido-editor__action--primary" data-tsf-pedido-action="reopen" disabled title="Reabrir pedido enviado · Fase futura">
            <span>Pedido enviado</span>
          </button>
        `);
      }

      return `
        <footer class="tsf-pedido-editor__actions">
          ${buttons.join('')}
        </footer>
      `;
    }

    // Onda 11 · Fórmula correta · (cost × qty − desconto) + IPI = total do pedido
    // Frete é INFORMATIVO · NÃO soma no total (cobrado pela transportadora, fora do pedido)
    // IPI vem do fornecedor (snapshot · pode estar em p.ipi_pct ou snapshot_fornecedor.ipi_pct_resolved)
    #computeTotals(p) {
      const layers = Array.isArray(p.discount_layers) ? p.discount_layers : [];
      const items = Array.isArray(p.items) ? p.items : [];
      const ipiPct = (typeof p.ipi_pct === 'number') ? p.ipi_pct
        : (typeof p.snapshot_fornecedor?.ipi_pct_resolved === 'number') ? p.snapshot_fornecedor.ipi_pct_resolved
        : 0;
      let gross = 0;       // soma de cost × qty (bruto, sem desconto)
      let net = 0;         // soma de cost-com-desconto × qty (sem IPI)
      let ipiTotal = 0;    // soma de IPI por item (sobre o net unit)
      let unitCount = 0;
      for (const it of items) {
        const s = it.snapshot || {};
        const ov = it.overrides || {};
        const cost = (typeof ov.cost_centavos === 'number') ? ov.cost_centavos :
                     (typeof s.cost_centavos === 'number' && s.cost_centavos > 0) ? s.cost_centavos :
                     (s.price_centavos || 0);
        const qty = it.qty || 1;
        const netUnit = applyDiscountLayers(cost, layers);
        const ipiUnit = ipiPct > 0 ? (netUnit * ipiPct / 100) : 0;
        gross += cost * qty;
        net += netUnit * qty;
        ipiTotal += ipiUnit * qty;
        unitCount += qty;
      }
      const discount = Math.max(0, gross - net);
      const frete = p.frete_centavos || 0; // informativo, separado
      const final = net + ipiTotal;
      return { gross, net, discount, ipi: ipiTotal, ipiPct, frete, final, itemCount: items.length, unitCount };
    }

    // Onda 6.7D · Ações de status do pedido (toolbar buttons)
    async #deletePedido() {
      const p = this.#currentPedido;
      if (!p) return;
      const ok = confirm(`Excluir pedido ${p.numero_pedido} permanentemente?\n\nEssa ação NÃO PODE ser desfeita. Só funciona com pedido em rascunho.`);
      if (!ok) return;
      try {
        const res = await fetch(`${PEDIDO_ENDPOINT}/delete`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: p.id }),
        });
        const data = await res.json();
        if (!data.ok) {
          alert(data.message || data.error || 'Falha ao excluir');
          return;
        }
        window.location.href = '/pages/admin-pedidos';
      } catch (err) {
        alert('Erro: ' + err.message);
      }
    }

    async #cancelPedido() {
      const p = this.#currentPedido;
      if (!p) return;
      const ok = confirm(`Cancelar pedido ${p.numero_pedido}?\n\nStatus será 'cancelled'. Pedido fica preservado no histórico.`);
      if (!ok) return;
      try {
        const res = await fetch(`${PEDIDO_ENDPOINT}/cancel`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: p.id }),
        });
        const data = await res.json();
        if (!data.ok) {
          alert(data.error || 'Falha ao cancelar');
          return;
        }
        this.#currentPedido = data.pedido;
        this.#paintEditor();
      } catch (err) {
        alert('Erro: ' + err.message);
      }
    }

    async #requestAlteration() {
      const p = this.#currentPedido;
      if (!p) return;
      const ok = confirm(
        `Solicitar alteração do pedido ${p.numero_pedido}?\n\n` +
        `Status passa a 'alteration_requested'. Onda 7 vai disparar email automático pra fornecedor + representante avisando.\n\n` +
        `Continuar?`
      );
      if (!ok) return;
      try {
        const res = await fetch(`${PEDIDO_ENDPOINT}/request-alteration`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: p.id }),
        });
        const data = await res.json();
        if (!data.ok) {
          alert(data.error || 'Falha');
          return;
        }
        this.#currentPedido = data.pedido;
        this.#paintEditor();
        if (data.note) console.info('[tsf-pedido]', data.note);
      } catch (err) {
        alert('Erro: ' + err.message);
      }
    }

    #bindEditorEvents() {
      const { signal } = this.#abortController;

      // Config section · binding direto (não muda dinamicamente)
      this.querySelectorAll('[data-tsf-pedido-edit]').forEach(el => {
        const evt = el.tagName === 'SELECT' ? 'change' : 'input';
        el.addEventListener(evt, () => this.#onConfigEdit(el), { signal });
      });

      // Event delegation pra items + ações (sobrevive a re-renders)
      this.addEventListener('input', (e) => {
        const el = e.target.closest?.('[data-tsf-pedido-item-edit]');
        if (el) this.#onItemEdit(el);
      }, { signal });

      this.addEventListener('change', (e) => {
        const el = e.target.closest?.('[data-tsf-pedido-item-edit]');
        if (el && el.tagName === 'SELECT') this.#onItemEdit(el);
      }, { signal });

      this.addEventListener('click', (e) => {
        const removeBtn = e.target.closest?.('[data-tsf-pedido-item-remove]');
        if (removeBtn) {
          this.#onItemRemove(removeBtn.dataset.tsfPedidoItemRemove);
          return;
        }
        const resetBtn = e.target.closest?.('[data-tsf-pedido-item-reset]');
        if (resetBtn) {
          this.#onItemReset(resetBtn.dataset.tsfPedidoItemReset, resetBtn.dataset.uid);
          return;
        }
        const actionBtn = e.target.closest?.('[data-tsf-pedido-action]');
        if (actionBtn) {
          this.#onAction(actionBtn.dataset.tsfPedidoAction);
          return;
        }
        // Onda 6.7D · Botões da toolbar (Excluir/Solicitar alteração/Cancelar)
        if (e.target.closest?.('[data-tsf-pedido-delete]')) {
          this.#deletePedido();
          return;
        }
        if (e.target.closest?.('[data-tsf-pedido-cancel]')) {
          this.#cancelPedido();
          return;
        }
        if (e.target.closest?.('[data-tsf-pedido-request-alteration]')) {
          this.#requestAlteration();
          return;
        }
        // Onda 11.2 · Reset campo do pedido (transportadora/discount_layers/frete_centavos) pra nativo
        const fieldResetBtn = e.target.closest?.('[data-tsf-pedido-reset-field]');
        if (fieldResetBtn) {
          e.preventDefault();
          const field = fieldResetBtn.dataset.tsfPedidoResetField;
          const nativeValue = fieldResetBtn.dataset.nativeValue || '';
          this.#onFieldReset(field, nativeValue);
          return;
        }
      }, { signal });

      // Auto-resize textareas (apply on initial render)
      this.querySelectorAll('textarea[data-tsf-pedido-item-edit], textarea[data-tsf-pedido-edit]').forEach(el => {
        this.#autoResizeTextarea(el);
      });
      // Auto-resize on input via delegation
      this.addEventListener('input', (e) => {
        const ta = e.target.closest?.('textarea[data-tsf-pedido-item-edit], textarea[data-tsf-pedido-edit]');
        if (ta) this.#autoResizeTextarea(ta);
      }, { signal });

      // Onda 11.2 · Blur em fields com native tracking · atualiza badge "editado"/"nativo" sem perder foco
      this.addEventListener('blur', (e) => {
        const el = e.target.closest?.('[data-tsf-pedido-edit]');
        if (!el) return;
        const field = el.dataset.tsfPedidoEdit;
        if (['transportadora', 'discount_layers', 'frete_centavos'].includes(field)) {
          // Re-render só a config section pra refletir o badge novo
          this.#rerenderConfigSection();
        }
      }, { signal, capture: true });
    }

    #autoResizeTextarea(el) {
      el.style.height = 'auto';
      el.style.height = (el.scrollHeight + 2) + 'px';
    }

    #onConfigEdit(el) {
      const field = el.dataset.tsfPedidoEdit;
      const p = this.#currentPedido;
      if (!p) return;
      switch (field) {
        case 'payment_condition':
          p.payment_condition = el.value || null;
          this.#scheduleSave({ payment_condition: p.payment_condition });
          break;
        case 'transportadora':
          p.transportadora = el.value;
          this.#scheduleSave({ transportadora: p.transportadora });
          break;
        case 'discount_layers':
          // Valida pattern leve · só salva se passar regex
          const raw = el.value.trim();
          const ok = raw === '' || /^\d{1,2}(\+\d{1,2})*$/.test(raw);
          el.setAttribute('data-tsf-pedido-invalid', ok ? 'false' : 'true');
          if (ok) {
            p.discount_layers = parseDiscountString(raw);
            this.#scheduleSave({ discount_layers: p.discount_layers });
            // Layers mudou → re-render TODAS as linhas + totais
            this.#rerenderAllItems();
            this.#updateTotalsOnly();
          }
          break;
        case 'frete_centavos':
          const v = parseFloat(el.value);
          p.frete_centavos = isFinite(v) && v > 0 ? Math.round(v * 100) : 0;
          this.#scheduleSave({ frete_centavos: p.frete_centavos });
          this.#updateTotalsOnly();
          break;
        case 'notes':
          p.notes = el.value;
          this.#scheduleSave({ notes: p.notes });
          break;
      }
    }

    // Onda 11.2 · Reset de campo do pedido pro valor nativo (do sistema/fornecedor/venda)
    #onFieldReset(field, nativeValue) {
      const p = this.#currentPedido;
      if (!p) return;
      switch (field) {
        case 'transportadora':
          p.transportadora = nativeValue || null;
          this.#scheduleSave({ transportadora: p.transportadora });
          break;
        case 'discount_layers':
          p.discount_layers = parseDiscountString(nativeValue);
          this.#scheduleSave({ discount_layers: p.discount_layers });
          this.#rerenderAllItems();
          break;
        case 'frete_centavos': {
          const cents = Math.round((parseFloat(nativeValue) || 0) * 100);
          p.frete_centavos = cents;
          this.#scheduleSave({ frete_centavos: p.frete_centavos });
          break;
        }
        default:
          return;
      }
      // Re-render seção de config + totais pra atualizar badges/reset · NÃO faz #render full
      this.#rerenderConfigSection();
      this.#updateTotalsOnly();
    }

    // Onda 11.2 · Re-render só do bloco de Condições (sem re-render full) · atualiza badges
    #rerenderConfigSection() {
      const p = this.#currentPedido;
      if (!p) return;
      const oldSection = this.querySelector('.tsf-pedido-editor__config');
      if (!oldSection) return;
      const isEditable = p.status === 'draft';
      const layersStr = discountLayersToString(p.discount_layers || []);
      const newHtml = `
        <section class="tsf-pedido-editor__config" aria-label="Condições e endereçamento">
          <header class="tsf-pedido-editor__section-head">
            <h2>Condições</h2>
          </header>
          <div class="tsf-pedido-editor__config-grid">
            <label class="tsf-pedido-editor__field">
              <span class="tsf-pedido-editor__field-label">Condição de pagamento</span>
              <select class="tsf-pedido-editor__select" data-tsf-pedido-edit="payment_condition" ${!isEditable ? 'disabled' : ''}>
                <option value="" ${!p.payment_condition ? 'selected' : ''}>— Selecione</option>
                <option value="antecipado_100" ${p.payment_condition === 'antecipado_100' ? 'selected' : ''}>Antecipado 100%</option>
                <option value="antecipado_50_50" ${p.payment_condition === 'antecipado_50_50' ? 'selected' : ''}>Antecipado 50% + 50% na entrega</option>
                <option value="antecipado_30_70" ${p.payment_condition === 'antecipado_30_70' ? 'selected' : ''}>Antecipado 30% + 70% na entrega</option>
                <option value="boleto_30dd" ${p.payment_condition === 'boleto_30dd' ? 'selected' : ''}>Boleto 30 dias</option>
              </select>
            </label>
            ${this.#fieldWithNativeHtml({
              label: 'Transportadora',
              field: 'transportadora',
              current: p.transportadora || '',
              native: p.native_transportadora || '',
              isEditable, inputType: 'text',
              placeholder: 'Ex: Vipex, TJ Frete, Total Express…',
              hint: 'Onda 11.2 · Propagado da venda · pode editar livre',
            })}
            ${this.#fieldWithNativeHtml({
              label: 'Camadas de desconto',
              field: 'discount_layers',
              current: layersStr,
              native: discountLayersToString(p.native_discount_layers || []),
              isEditable, inputType: 'text',
              inputClass: 'tsf-pedido-editor__input--mono',
              placeholder: '10+5+5',
              pattern: '^\\\\d{1,2}(\\\\+\\\\d{1,2})*$',
              hint: 'Aplicado sobre o custo · ex: <code>10+5+5</code> = preço × 0,90 × 0,95 × 0,95',
            })}
            ${this.#fieldWithNativeHtml({
              label: 'Frete (R$) <em class="tsf-pedido-editor__field-tag">controle interno</em>',
              field: 'frete_centavos',
              current: ((p.frete_centavos || 0) / 100).toFixed(2),
              native: ((p.native_frete_centavos || 0) / 100).toFixed(2),
              isEditable, inputType: 'number',
              inputClass: 'tsf-pedido-editor__input--mono',
              placeholder: '0.00',
              inputAttrs: 'inputmode="decimal" step="0.01" min="0"',
              hint: 'Rateado automático da venda · não soma no total do pedido',
              formatNative: (v) => `R$ ${parseFloat(v || 0).toFixed(2).replace('.', ',')}`,
            })}
            <label class="tsf-pedido-editor__field tsf-pedido-editor__field--wide">
              <span class="tsf-pedido-editor__field-label">Observações gerais</span>
              <textarea class="tsf-pedido-editor__textarea" data-tsf-pedido-edit="notes" rows="2"
                        placeholder="Instruções específicas pra fábrica · prazos, embalagem, contatos…"
                        ${!isEditable ? 'disabled' : ''}>${this.#esc(p.notes || '')}</textarea>
            </label>
          </div>
        </section>
      `;
      const tmp = document.createElement('template');
      tmp.innerHTML = newHtml.trim();
      oldSection.replaceWith(tmp.content.firstElementChild);
      // Re-bind direct listeners pros novos campos
      this.querySelectorAll('.tsf-pedido-editor__config [data-tsf-pedido-edit]').forEach(el => {
        const evt = el.tagName === 'SELECT' ? 'change' : 'input';
        el.addEventListener(evt, () => this.#onConfigEdit(el), { signal: this.#abortController.signal });
      });
    }

    #onItemEdit(el) {
      const field = el.dataset.tsfPedidoItemEdit;
      const uid = el.dataset.uid;
      const p = this.#currentPedido;
      if (!p) return;
      const items = p.items || [];
      const idx = items.findIndex(it => it.uid === uid);
      if (idx < 0) return;
      const item = items[idx];
      item.overrides = item.overrides || {};

      let needsPricingRecalc = false;
      switch (field) {
        case 'codigo_produto':
        case 'observacoes':
        case 'cor':
        case 'materiais':
        case 'dimens_es':
          item.overrides[field] = el.value;
          break;
        case 'prazo':
          item.overrides.prazo = el.value === '' ? '' : parseInt(el.value, 10) || 0;
          break;
        case 'qty':
          const q = parseInt(el.value, 10);
          item.qty = isFinite(q) && q >= 1 ? q : 1;
          needsPricingRecalc = true;
          break;
        case 'cost_centavos':
          // Aceita "1.234,56" ou "1234,56" ou "1234.56"
          const raw = String(el.value).replace(/[^\d,.-]/g, '')
            .replace(/\.(?=\d{3}(\D|$))/g, '').replace(',', '.');
          const cents = Math.round((parseFloat(raw) || 0) * 100);
          item.overrides.cost_centavos = cents;
          needsPricingRecalc = true;
          break;
      }

      this.#scheduleSave({ items: p.items });
      if (needsPricingRecalc) {
        this.#updateItemPricing(uid);
        this.#updateTotalsOnly();
      }
      // Atualiza badge inline sem re-render completo (preserva foco)
      this.#refreshItemBadges(uid);
    }

    // Atualiza prices de UM item específico sem re-render (preserva foco do input)
    #updateItemPricing(uid) {
      const p = this.#currentPedido;
      if (!p) return;
      const item = (p.items || []).find(it => it.uid === uid);
      if (!item) return;
      const layers = Array.isArray(p.discount_layers) ? p.discount_layers : [];
      const s = item.snapshot || {};
      const ov = item.overrides || {};
      const cost = (typeof ov.cost_centavos === 'number') ? ov.cost_centavos :
                   (typeof s.cost_centavos === 'number' && s.cost_centavos > 0) ? s.cost_centavos :
                   (s.price_centavos || 0);
      const net = applyDiscountLayers(cost, layers);
      const qty = item.qty || 1;
      const savings = (cost - net) * qty;

      const subtotalEl = this.querySelector(`[data-tsf-pedido-item-subtotal="${uid}"]`);
      if (subtotalEl) subtotalEl.textContent = money(net * qty);
      const unitEl = this.querySelector(`[data-tsf-pedido-item-net-unit="${uid}"]`);
      if (unitEl) unitEl.textContent = money(net);
      const savingsEl = this.querySelector(`[data-tsf-pedido-item-savings="${uid}"]`);
      if (savingsEl) savingsEl.textContent = money(savings);
    }

    #refreshItemBadges(uid) {
      // Re-renderiza apenas a linha do item afetada (preserva foco se possível)
      const p = this.#currentPedido;
      if (!p) return;
      const item = (p.items || []).find(it => it.uid === uid);
      if (!item) return;
      const rowEl = this.querySelector(`[data-tsf-pedido-item="${uid}"]`);
      if (!rowEl) return;
      const layers = Array.isArray(p.discount_layers) ? p.discount_layers : [];
      const idx = (p.items || []).indexOf(item) + 1;
      // Captura foco e seleção pra restaurar depois
      const active = document.activeElement;
      const activeField = active && rowEl.contains(active) ? active.getAttribute('data-tsf-pedido-item-edit') : null;
      const activeSelStart = activeField && 'selectionStart' in active ? active.selectionStart : null;
      const activeSelEnd = activeField && 'selectionEnd' in active ? active.selectionEnd : null;

      const newHtml = this.#itemRowHtml(item, idx, layers, p.status === 'draft');
      const wrap = document.createElement('template');
      wrap.innerHTML = newHtml.trim();
      const newRow = wrap.content.firstChild;
      rowEl.replaceWith(newRow);

      // Restaura foco
      if (activeField) {
        const newInput = newRow.querySelector(`[data-tsf-pedido-item-edit="${activeField}"]`);
        if (newInput) {
          newInput.focus();
          if (activeSelStart != null && 'setSelectionRange' in newInput) {
            try { newInput.setSelectionRange(activeSelStart, activeSelEnd); } catch {}
          }
        }
      }
    }

    // Re-renderiza TODOS os items (uso: layers globais mudaram)
    #rerenderAllItems() {
      const p = this.#currentPedido;
      if (!p) return;
      const listEl = this.querySelector('[data-tsf-pedido-items]');
      if (!listEl) return;
      const layers = Array.isArray(p.discount_layers) ? p.discount_layers : [];
      const isEditable = p.status === 'draft';
      listEl.innerHTML = (p.items || []).map((it, i) => this.#itemRowHtml(it, i + 1, layers, isEditable)).join('');
    }

    // Atualiza só os totais globais sem mexer em items
    // Onda 11.1 · Inclui IPI nas atualizações inline · sem precisar re-render full
    // Se IPI/desconto mudaram de visível pra invisível (ou vice-versa), faz re-render full
    #updateTotalsOnly() {
      const p = this.#currentPedido;
      if (!p) return;
      const totals = this.#computeTotals(p);
      const grossEl = this.querySelector('[data-tsf-pedido-total="gross"]');
      if (grossEl) grossEl.textContent = money(totals.gross);
      const netEl = this.querySelector('[data-tsf-pedido-total="net"]');
      if (netEl) netEl.textContent = money(totals.net);
      const finalEl = this.querySelector('[data-tsf-pedido-total="final"]');
      if (finalEl) finalEl.textContent = money(totals.final);
      const discountEl = this.querySelector('[data-tsf-pedido-total="discount"]');
      const ipiEl = this.querySelector('[data-tsf-pedido-total="ipi"]');
      const freteEl = this.querySelector('[data-tsf-pedido-total="frete"]');
      // Se elementos condicionais aparecem/somem (passou de 0 a >0), precisa re-render
      const discShouldShow = totals.discount > 0;
      const ipiShouldShow = totals.ipi > 0;
      const freteShouldShow = totals.frete > 0;
      const needFullRender =
        (discShouldShow && !discountEl) || (!discShouldShow && discountEl) ||
        (ipiShouldShow && !ipiEl) || (!ipiShouldShow && ipiEl) ||
        (freteShouldShow && !freteEl) || (!freteShouldShow && freteEl);
      if (needFullRender) {
        const totalsEl = this.querySelector('.tsf-pedido-editor__totals');
        if (totalsEl) {
          const tmp = document.createElement('template');
          tmp.innerHTML = this.#totalsHtml(totals).trim();
          totalsEl.replaceWith(tmp.content.firstElementChild);
        }
        return;
      }
      if (discountEl) discountEl.textContent = '−' + money(totals.discount);
      if (ipiEl) ipiEl.textContent = '+' + money(totals.ipi);
      if (freteEl) freteEl.textContent = money(totals.frete);
    }

    // Reset de override · volta ao valor nativo
    #onItemReset(key, uid) {
      const p = this.#currentPedido;
      if (!p) return;
      const item = (p.items || []).find(it => it.uid === uid);
      if (!item) return;
      item.overrides = item.overrides || {};
      delete item.overrides[key];
      this.#scheduleSave({ items: p.items });
      // Re-render linha + atualiza totais (cost reset afeta totais)
      this.#refreshItemBadges(uid);
      if (key === 'cost_centavos' || key === 'qty') {
        this.#updateTotalsOnly();
      }
    }

    async #onItemRemove(uid) {
      const p = this.#currentPedido;
      if (!p) return;
      if (!confirm('Remover este item do pedido?')) return;
      p.items = (p.items || []).filter(it => it.uid !== uid);
      this.#scheduleSave({ items: p.items }, /* immediate */ true);
      // Re-render para refletir remoção (mantém UX simples)
      this.#paintEditor();
    }

    async #onAction(action) {
      switch (action) {
        case 'send':
          if (!confirm('Confirmar envio do pedido? Após enviado, ele entra em modo somente-leitura.\n\nA automação de email pra fábrica será habilitada na próxima fase.')) return;
          await this.#performSend();
          break;
        case 'cancel':
          if (!confirm('Cancelar este pedido? A operação não pode ser desfeita.')) return;
          await this.#performCancel();
          break;
        case 'pdf':
          this.#openPdf();
          break;
      }
    }

    async #performSend() {
      this.#setSaveStatus('saving', 'Enviando…');
      try {
        // Flush qualquer pending save primeiro
        await this.#flushPendingSave();
        const res = await fetch(`${PEDIDO_ENDPOINT}/send`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: this.#pedidoId }),
        });
        const data = await res.json();
        if (!data.ok) throw new Error(data.error || 'falha ao enviar');
        this.#currentPedido = data.pedido;
        this.#setSaveStatus('saved', 'Enviado');
        this.#paintEditor();
      } catch (err) {
        this.#setSaveStatus('error', 'Falha: ' + err.message);
        alert('Falha ao enviar: ' + err.message);
      }
    }

    async #performCancel() {
      this.#setSaveStatus('saving', 'Cancelando…');
      try {
        await this.#flushPendingSave();
        const res = await fetch(`${PEDIDO_ENDPOINT}/cancel`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: this.#pedidoId }),
        });
        const data = await res.json();
        if (!data.ok) throw new Error(data.error || 'falha ao cancelar');
        this.#currentPedido = data.pedido;
        this.#setSaveStatus('saved', 'Cancelado');
        this.#paintEditor();
      } catch (err) {
        this.#setSaveStatus('error', 'Falha: ' + err.message);
        alert('Falha ao cancelar: ' + err.message);
      }
    }

    // ── PDF · janela isolada (bypassa Roar Content Protector) ──────────
    // Documento fiscal-grade NF-e style · APENAS custo + desconto · zero markup
    // ───────────────────────────────────────────────────────────────────
    #openPdf() {
      if (!this.#currentPedido) return;
      const html = this.#buildPedidoPdfDocument();
      const w = window.open('', '_blank', 'width=900,height=1200');
      if (!w) {
        alert('Permita pop-ups pra gerar o PDF. Clique no ícone de bloqueio na barra de endereços.');
        return;
      }
      w.document.open();
      w.document.write(html);
      w.document.close();
      const printWhenReady = () => {
        try {
          const imgs = Array.from(w.document.images || []);
          const pending = imgs.filter(img => !img.complete);
          if (pending.length === 0) {
            w.focus();
            w.print();
            return;
          }
          let loaded = 0;
          const checkDone = () => {
            loaded++;
            if (loaded >= pending.length) { w.focus(); w.print(); }
          };
          pending.forEach(img => {
            img.addEventListener('load', checkDone);
            img.addEventListener('error', checkDone);
          });
          setTimeout(() => { try { w.focus(); w.print(); } catch {} }, 5000);
        } catch (e) {
          try { w.print(); } catch {}
        }
      };
      if (w.document.readyState === 'complete') printWhenReady();
      else w.addEventListener('load', printWhenReady, { once: true });
    }

    #buildPedidoPdfDocument() {
      const p = this.#currentPedido;
      const fornecedor = p.snapshot_fornecedor || {};
      const toth = p.snapshot_toth || {};
      const layers = Array.isArray(p.discount_layers) ? p.discount_layers : [];
      const layersStr = discountLayersToString(layers);
      const created = p.created_at ? new Date(p.created_at) : new Date();
      const fmtDate = (d) => new Intl.DateTimeFormat('pt-BR', { day: '2-digit', month: 'long', year: 'numeric' }).format(d);
      const dateStr = fmtDate(created);
      const items = Array.isArray(p.items) ? p.items : [];
      const totals = this.#computeTotals(p);

      const paymentLabels = {
        antecipado_100: 'Antecipado · 100%',
        antecipado_50_50: 'Antecipado · 50% + 50% na entrega',
        antecipado_30_70: 'Antecipado · 30% + 70% na entrega',
        boleto_30dd: 'Boleto · 30 dias',
      };
      const paymentLabel = p.payment_condition ? (paymentLabels[p.payment_condition] || p.payment_condition) : '—';
      const transportadoraLabel = p.transportadora || '—';

      // Linhas da tabela de itens
      const rowsHtml = items.map((it, idx) => {
        const s = it.snapshot || {};
        const ov = it.overrides || {};
        const codigo = ov.codigo_produto || s.codigo_fornecedor || s.codigo_produto || s.sku || '—';
        const observacoes = ov.observacoes || '';
        // Cost respeita override (mirror frontend)
        const cost = (typeof ov.cost_centavos === 'number') ? ov.cost_centavos :
                     (typeof s.cost_centavos === 'number' && s.cost_centavos > 0) ? s.cost_centavos :
                     (s.price_centavos || 0);
        const net = applyDiscountLayers(cost, layers);
        const qty = it.qty || 1;
        const subtotal = net * qty;
        const title = s.title || '—';

        return `
          <tr class="row">
            <td class="row__index">${String(idx + 1).padStart(2, '0')}</td>
            <td class="row__code">${this.#esc(codigo)}</td>
            <td class="row__desc">
              <div class="row__desc-title">${this.#esc(title)}</div>
              ${observacoes ? `<div class="row__desc-obs">${this.#esc(observacoes)}</div>` : ''}
            </td>
            <td class="row__qty">${qty}</td>
            <td class="row__cost">${money(cost)}</td>
            <td class="row__net">${money(net)}</td>
            <td class="row__subtotal">${money(subtotal)}</td>
          </tr>
        `;
      }).join('');

      // PARA · Fornecedor block
      const fornLines = [];
      if (fornecedor.razao_social || fornecedor.nome) fornLines.push(`<div class="party__name">${this.#esc(fornecedor.razao_social || fornecedor.nome)}</div>`);
      if (fornecedor.nome_fantasia) fornLines.push(`<div class="party__line party__line--alt">${this.#esc(fornecedor.nome_fantasia)}</div>`);
      if (fornecedor.cnpj) fornLines.push(`<div class="party__line">CNPJ ${this.#esc(fornecedor.cnpj)}</div>`);
      if (fornecedor.inscricao_estadual) fornLines.push(`<div class="party__line">IE ${this.#esc(fornecedor.inscricao_estadual)}</div>`);
      const fornAddr = [fornecedor.endereco_fabrica || fornecedor.endereco, fornecedor.bairro].filter(Boolean).join(' · ');
      if (fornAddr) fornLines.push(`<div class="party__line">${this.#esc(fornAddr)}</div>`);
      const fornCity = [fornecedor.cidade, fornecedor.estado || fornecedor.uf].filter(Boolean).join(' · ');
      if (fornCity || fornecedor.cep_fabrica || fornecedor.cep) {
        const cep = fornecedor.cep_fabrica || fornecedor.cep || '';
        fornLines.push(`<div class="party__line">${this.#esc(fornCity)}${cep ? ' · CEP ' + this.#esc(cep) : ''}</div>`);
      }
      if (fornecedor.email_fabrica || fornecedor.email) fornLines.push(`<div class="party__line">${this.#esc(fornecedor.email_fabrica || fornecedor.email)}</div>`);
      if (fornecedor.whatsapp_fabrica || fornecedor.whatsapp) fornLines.push(`<div class="party__line">${this.#esc(fornecedor.whatsapp_fabrica || fornecedor.whatsapp)}</div>`);

      // DE · Toth block
      const tothLines = [];
      if (toth.razao_social) tothLines.push(`<div class="party__name">${this.#esc(toth.razao_social)}</div>`);
      if (toth.nome_fantasia) tothLines.push(`<div class="party__line party__line--alt">${this.#esc(toth.nome_fantasia)}</div>`);
      if (toth.cnpj) tothLines.push(`<div class="party__line">CNPJ ${this.#esc(toth.cnpj)}</div>`);
      if (toth.inscricao_estadual) tothLines.push(`<div class="party__line">IE ${this.#esc(toth.inscricao_estadual)}</div>`);
      const tothAddr = [toth.endereco, toth.bairro].filter(Boolean).join(' · ');
      if (tothAddr) tothLines.push(`<div class="party__line">${this.#esc(tothAddr)}</div>`);
      const tothCity = [toth.cidade, toth.estado || toth.uf].filter(Boolean).join(' · ');
      if (tothCity || toth.cep) {
        tothLines.push(`<div class="party__line">${this.#esc(tothCity)}${toth.cep ? ' · CEP ' + this.#esc(toth.cep) : ''}</div>`);
      }
      if (toth.email) tothLines.push(`<div class="party__line">${this.#esc(toth.email)}</div>`);
      if (toth.telefone) tothLines.push(`<div class="party__line">${this.#esc(toth.telefone)}</div>`);

      const css = this.#pedidoPdfCss();
      const statusStr = (STATUS_LABELS[p.status] || STATUS_LABELS.draft).label.toUpperCase();

      return `<!DOCTYPE html><html lang="pt-BR"><head><meta charset="utf-8"><title>${this.#esc(p.numero_pedido)} · Pedido Toth Móveis</title><style>${css}</style></head><body>
<div class="doc">
  <header class="header">
    <div class="header__brand">
      <div class="header__logo">TOTH</div>
      <div class="header__tagline">Pedido de compra · Mobiliário</div>
    </div>
    <div class="header__meta">
      <div class="header__meta-label">Pedido</div>
      <div class="header__meta-number">№ ${this.#esc(p.numero_pedido)}</div>
      <div class="header__meta-date">${dateStr}</div>
      <div class="header__meta-status">${statusStr}</div>
    </div>
  </header>

  <section class="parties">
    <div class="party party--from">
      <div class="party__eyebrow">De · Comprador</div>
      ${tothLines.join('')}
    </div>
    <div class="party party--to">
      <div class="party__eyebrow">Para · Fornecedor</div>
      ${fornLines.join('')}
    </div>
  </section>

  <section class="terms">
    <div class="term">
      <span class="term__label">Condição de pagamento</span>
      <strong class="term__value">${this.#esc(paymentLabel)}</strong>
    </div>
    <div class="term">
      <span class="term__label">Transportadora</span>
      <strong class="term__value">${this.#esc(transportadoraLabel)}</strong>
    </div>
    <div class="term">
      <span class="term__label">Camadas de desconto</span>
      <strong class="term__value">${this.#esc(layersStr || '—')}</strong>
    </div>
  </section>

  <section class="items">
    <table class="items-table" cellspacing="0" cellpadding="0">
      <thead>
        <tr>
          <th class="th-idx">#</th>
          <th class="th-code">Código</th>
          <th class="th-desc">Descrição</th>
          <th class="th-qty">Qty</th>
          <th class="th-cost">Custo unit.</th>
          <th class="th-net">Líquido${layers.length > 0 ? ' (c/desc)' : ''}</th>
          <th class="th-sub">Subtotal</th>
        </tr>
      </thead>
      <tbody>
        ${rowsHtml || `<tr><td colspan="7" class="row__empty">Sem itens neste pedido.</td></tr>`}
      </tbody>
    </table>
  </section>

  <section class="totals">
    <div class="totals__col">
      ${p.notes ? `
        <div class="notes">
          <div class="notes__label">Observações gerais</div>
          <div class="notes__body">${this.#esc(p.notes)}</div>
        </div>
      ` : ''}
    </div>
    <div class="totals__col totals__col--right">
      <div class="totals__row">
        <span>Subtotal bruto (custo)</span>
        <strong>${money(totals.gross)}</strong>
      </div>
      ${totals.discount > 0 ? `
        <div class="totals__row totals__row--discount">
          <span>Economia ${layersStr ? '(' + layersStr + ')' : ''}</span>
          <strong>−${money(totals.discount)}</strong>
        </div>
      ` : ''}
      <div class="totals__row">
        <span>Subtotal líquido</span>
        <strong>${money(totals.net)}</strong>
      </div>
      ${totals.frete > 0 ? `
        <div class="totals__row">
          <span>Frete</span>
          <strong>${money(totals.frete)}</strong>
        </div>
      ` : ''}
      <div class="totals__row totals__row--grand">
        <span>Total do pedido</span>
        <strong>${money(totals.final)}</strong>
      </div>
    </div>
  </section>

  <section class="signature">
    <div class="signature__col">
      <div class="signature__line"></div>
      <div class="signature__label">${this.#esc(toth.razao_social || 'Toth Móveis')} · Comprador</div>
    </div>
    <div class="signature__col">
      <div class="signature__line"></div>
      <div class="signature__label">${this.#esc(fornecedor.razao_social || fornecedor.nome || 'Fornecedor')} · Confirmação</div>
    </div>
  </section>

  <footer class="legal">
    <div class="legal__row">
      <span>FORNECIMENTO</span><strong>Conforme catálogo Toth Móveis · garantia de fabricação 12 meses</strong>
    </div>
    <div class="legal__row">
      <span>FATURAMENTO</span><strong>NF-e ao CNPJ de comprador · ICMS conforme acordado</strong>
    </div>
    <div class="legal__brand">
      <span>${this.#esc(toth.razao_social || 'Toth Móveis')} · ${this.#esc(toth.cnpj || '')}</span>
      <span>${this.#esc(toth.email || 'contato@tothmoveis.com.br')} · www.tothmoveis.com.br</span>
    </div>
  </footer>
</div>
</body></html>`;
    }

    #pedidoPdfCss() {
      return `
        *,*:before,*:after { box-sizing: border-box; margin: 0; padding: 0; }
        @page { size: A4; margin: 12mm 14mm; }
        html,body { background: #fff; color: #1a1918; font-family: 'Montserrat', -apple-system, BlinkMacSystemFont, 'Helvetica Neue', Arial, sans-serif; font-weight: 300; line-height: 1.45; -webkit-print-color-adjust: exact; print-color-adjust: exact; font-size: 10pt; }
        .doc { max-width: 182mm; margin: 0 auto; }
        /* HEADER */
        .header { display: flex; justify-content: space-between; align-items: flex-start; padding-bottom: 10mm; border-bottom: 1.5px solid #1a1918; position: relative; }
        .header::after { content: ''; position: absolute; left: 0; bottom: -1.5px; width: 22mm; height: 2px; background: #A16207; }
        .header__logo { font-size: 28pt; font-weight: 200; letter-spacing: 0.06em; line-height: 1; color: #1a1918; }
        .header__tagline { margin-top: 3mm; font-size: 7.5pt; letter-spacing:.18em; text-transform: uppercase; color: rgba(26,25,24,0.55); font-weight: 500; }
        .header__meta { text-align: right; }
        .header__meta-label { font-size: 7.5pt; font-weight: 600; letter-spacing:.18em; text-transform: uppercase; color: #A16207; margin-bottom: 3mm; }
        .header__meta-number { font-size: 14pt; font-weight: 500; letter-spacing: 0.04em; color: #1a1918; margin-bottom: 1.5mm; font-variant-numeric: tabular-nums; font-family: 'Fira Code', ui-monospace, monospace; }
        .header__meta-date { font-size: 9pt; color: rgba(26,25,24,0.72); margin-bottom: 1mm; }
        .header__meta-status { font-size: 7.5pt; font-weight: 600; letter-spacing: 0.2em; color: #057a55; padding: 1.2mm 3mm; background: rgba(5, 122, 85, 0.08); display: inline-block; border-radius: 2mm; }
        /* PARTIES */
        .parties { display: grid; grid-template-columns: 1fr 1fr; gap: 8mm; padding: 7mm 0; border-bottom: 1px solid rgba(26,25,24,0.08); }
        .party { position: relative; padding-left: 4mm; }
        .party::before { content: ''; position: absolute; left: 0; top: 0; bottom: 0; width: 1px; background: rgba(26,25,24,0.15); }
        .party--to::before { background: linear-gradient(180deg, #A16207, #c9952e); width: 2px; }
        .party__eyebrow { font-size: 7pt; font-weight: 600; letter-spacing:.22em; text-transform: uppercase; color: rgba(26,25,24,0.5); margin-bottom: 3mm; }
        .party--to .party__eyebrow { color: #A16207; }
        .party__name { font-size: 12pt; font-weight: 400; color: #1a1918; margin-bottom: 1.5mm; letter-spacing: -0.005em; }
        .party__line { font-size: 8.5pt; color: rgba(26,25,24,0.72); margin-bottom: 0.6mm; line-height: 1.45; }
        .party__line--alt { font-style: italic; font-size: 8pt; color: rgba(26,25,24,0.55); margin-bottom: 2mm; }
        /* TERMS */
        .terms { display: grid; grid-template-columns: repeat(3, 1fr); gap: 6mm; padding: 5mm 0; border-bottom: 1px solid rgba(26,25,24,0.08); }
        .term { display: flex; flex-direction: column; gap: 1mm; }
        .term__label { font-size: 7pt; font-weight: 600; letter-spacing:.18em; text-transform: uppercase; color: rgba(26,25,24,0.5); }
        .term__value { font-size: 9.5pt; font-weight: 500; color: #1a1918; }
        /* ITEMS TABLE */
        .items { padding: 6mm 0; }
        .items-table { width: 100%; border-collapse: collapse; font-variant-numeric: tabular-nums; }
        .items-table thead th { text-align: left; font-size: 7pt; font-weight: 600; letter-spacing:.18em; text-transform: uppercase; color: rgba(26,25,24,0.55); padding: 2.5mm 2mm; border-bottom: 1.5px solid #1a1918; }
        .items-table thead .th-qty, .items-table thead .th-cost, .items-table thead .th-net, .items-table thead .th-sub { text-align: right; }
        .items-table tbody tr { border-bottom: 1px solid rgba(26,25,24,0.06); page-break-inside: avoid; break-inside: avoid; }
        .items-table tbody td { padding: 3.5mm 2mm; font-size: 9pt; vertical-align: top; }
        .row__index { font-size: 8pt; color: rgba(26,25,24,0.45); font-weight: 500; letter-spacing: 0.04em; }
        .row__code { font-family: 'Fira Code', ui-monospace, monospace; font-size: 8.5pt; color: #1a1918; font-weight: 500; }
        .row__desc-title { font-size: 9.5pt; color: #1a1918; font-weight: 400; line-height: 1.35; }
        .row__desc-obs { font-size: 8pt; color: rgba(26,25,24,0.65); margin-top: 1mm; font-style: italic; line-height: 1.45; }
        .row__qty, .row__cost, .row__net, .row__subtotal { text-align: right; }
        .row__qty { font-weight: 500; }
        .row__cost { color: rgba(26,25,24,0.65); }
        .row__net { color: rgba(26,25,24,0.85); }
        .row__subtotal { font-weight: 600; color: #1a1918; }
        .row__empty { text-align: center; padding: 10mm; color: rgba(26,25,24,0.5); font-style: italic; }
        /* TOTALS */
        .totals { display: grid; grid-template-columns: 1fr 1fr; gap: 8mm; padding: 4mm 0 6mm; border-bottom: 1.5px solid #1a1918; page-break-inside: avoid; break-inside: avoid; }
        .totals__col { display: flex; flex-direction: column; gap: 2mm; }
        .totals__col--right { align-items: flex-end; }
        .totals__row { display: flex; justify-content: space-between; gap: 8mm; font-size: 9pt; min-width: 80mm; color: rgba(26,25,24,0.65); }
        .totals__row strong { font-weight: 500; font-variant-numeric: tabular-nums; min-width: 30mm; text-align: right; }
        .totals__row--discount { color: #b91c1c; }
        .totals__row--grand { margin-top: 3mm; padding-top: 3mm; border-top: 1px solid rgba(26,25,24,0.15); color: #1a1918; }
        .totals__row--grand span { font-size: 8pt; font-weight: 600; letter-spacing:.18em; text-transform: uppercase; color: rgba(26,25,24,0.5); padding-top: 2mm; }
        .totals__row--grand strong { font-size: 18pt; font-weight: 300; color: #A16207; letter-spacing: -0.01em; }
        /* NOTES */
        .notes { background: rgba(243, 241, 237, 0.55); padding: 4mm 5mm; border-left: 2px solid #A16207; border-radius: 1mm; }
        .notes__label { font-size: 7pt; font-weight: 600; letter-spacing:.18em; text-transform: uppercase; color: #A16207; margin-bottom: 2mm; }
        .notes__body { font-size: 9pt; color: rgba(26,25,24,0.78); line-height: 1.55; white-space: pre-wrap; }
        /* SIGNATURE */
        .signature { display: grid; grid-template-columns: 1fr 1fr; gap: 14mm; padding: 12mm 0 8mm; page-break-inside: avoid; break-inside: avoid; }
        .signature__col { display: flex; flex-direction: column; align-items: center; gap: 2mm; }
        .signature__line { width: 100%; height: 1px; background: rgba(26,25,24,0.4); }
        .signature__label { font-size: 7.5pt; letter-spacing:.18em; color: rgba(26,25,24,0.6); text-transform: uppercase; font-weight: 500; }
        /* LEGAL */
        .legal { padding: 6mm 0 0; border-top: 1px solid rgba(26,25,24,0.1); }
        .legal__row { display: flex; gap: 4mm; padding: 1.5mm 0; font-size: 7.5pt; color: rgba(26,25,24,0.65); }
        .legal__row span { font-weight: 600; letter-spacing:.18em; text-transform: uppercase; color: rgba(26,25,24,0.45); min-width: 24mm; }
        .legal__row strong { font-weight: 400; color: rgba(26,25,24,0.72); }
        .legal__brand { margin-top: 4mm; padding-top: 3mm; border-top: 1px dashed rgba(26,25,24,0.12); display: flex; justify-content: space-between; font-size: 7pt; color: rgba(26,25,24,0.5); letter-spacing: 0.04em; }
      `;
    }

    // ── Auto-save debounced ─────────────────────────────────────────────
    #pendingPatch = null;

    #scheduleSave(patch, immediate = false) {
      this.#pendingPatch = { ...(this.#pendingPatch || {}), ...patch };
      if (this.#saveTimer) clearTimeout(this.#saveTimer);
      this.#setSaveStatus('saving', 'Salvando…');
      if (immediate) {
        this.#performSave();
      } else {
        this.#saveTimer = setTimeout(() => this.#performSave(), 700);
      }
    }

    async #flushPendingSave() {
      if (this.#saveTimer) {
        clearTimeout(this.#saveTimer);
        this.#saveTimer = null;
      }
      if (this.#pendingPatch) await this.#performSave();
    }

    async #performSave() {
      const patch = this.#pendingPatch;
      this.#pendingPatch = null;
      this.#saveTimer = null;
      if (!patch) return;
      try {
        const res = await fetch(`${PEDIDO_ENDPOINT}/update`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: this.#pedidoId, patch }),
        });
        const data = await res.json();
        if (!data.ok) throw new Error(data.error || 'falha');
        // Mantém items + snapshots locais (server retorna pedido completo)
        if (data.pedido) {
          this.#currentPedido.updated_at = data.pedido.updated_at;
        }
        this.#setSaveStatus('saved', 'Salvo · ' + new Date().toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' }));
      } catch (err) {
        this.#setSaveStatus('error', 'Erro · ' + err.message);
      }
    }

    #setSaveStatus(state, text) {
      const el = this.querySelector('[data-tsf-pedido-save-status]');
      if (!el) return;
      el.textContent = text;
      el.setAttribute('data-state', state);
    }

    #renderError(msg) {
      this.innerHTML = `<div class="tsf-pedido-app__error">${this.#esc(msg)}</div>`;
    }

    #esc(s) {
      return String(s ?? '').replace(/[&<>"']/g, c => ({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c]));
    }
  }

  /* ════════════════════════════════════════════════════════════════════
     TSF-ADMIN-ORCAMENTOS · web component da view /pages/admin-orcamentos
     Lista todas as quotes do customer (não só drafts) · usa /quote/list
     com pedidos_count anexado. Filtros por status + busca client-side.
     ════════════════════════════════════════════════════════════════════ */
  /* ── Sinal de conversão por registro (venda/orçamento) · Meta + Google + qualidade do match ──
     Lê tsf_conversion_dispatch_log. Honesto: mostra ENVIADO+RECEBIDO (plataforma aceitou) + match (quão usável).
     "Contabilizado" de fato é relatório da plataforma (não por-registro) → não forjamos aqui. */
  const TSF_SIGNAL_COLORS = { ok: ['#166534', '#dcfce7'], warn: ['#92400e', '#fef3c7'], fail: ['#991b1b', '#fee2e2'], pending: ['#6f6a63', '#f3f4f6'] };
  const TSF_SIGNAL_ICON = { ok: '✓', warn: '⏰', fail: '✕', pending: '·' };
  function tsfSignalPill(label, state, title) {
    const c = TSF_SIGNAL_COLORS[state] || TSF_SIGNAL_COLORS.pending;
    return '<span title="' + title + '" style="display:inline-flex;align-items:center;gap:3px;font-size:10.5px;font-weight:600;line-height:1;padding:3px 7px;border-radius:999px;color:' + c[0] + ';background:' + c[1] + '">' + label + ' ' + TSF_SIGNAL_ICON[state] + '</span>';
  }
  function tsfDispatchSignalHtml(log, opts) {
    opts = opts || {};
    const showGoogle = opts.google !== false;   // orçamento = só Meta (Google entra via Customer Match)
    const wrap = (inner) => '<div class="tsf-admin-card-signal" style="display:flex;align-items:center;gap:5px;flex-wrap:wrap;margin-top:8px"><span style="font-size:9px;letter-spacing:.6px;color:#6f6a63;font-weight:600">SINAL</span>' + inner + '</div>';
    if (log && log.source === 'historical_import_conta_azul') {
      return wrap('<span title="Venda importada do Conta Azul — não enviada às plataformas (fora da janela de 7 dias do Meta)" style="font-size:10.5px;color:#6f6a63">importado · não enviado</span>');
    }
    if (!log || (!log.meta && !log.google)) {
      return wrap(tsfSignalPill('Meta', 'pending', 'Envio ao Meta ainda pendente') + (showGoogle ? tsfSignalPill('Google', 'pending', 'Envio ao Google ainda pendente') : ''));
    }
    const m = log.meta, g = log.google, mq = log.match_quality;
    let metaPill;
    if (m && m.ok === true) metaPill = tsfSignalPill('Meta', 'ok', 'Enviado e recebido pelo Meta — conversão aceita');
    else if (m && m.skipped === 'event_too_old') metaPill = tsfSignalPill('Meta', 'warn', 'NÃO enviado ao Meta: venda confirmada há mais de 7 dias (limite do Meta). Confirme mais perto da data da venda.');
    else if (m && m.ok === false) metaPill = tsfSignalPill('Meta', 'fail', 'Falha no envio ao Meta');
    else metaPill = tsfSignalPill('Meta', 'pending', 'Envio ao Meta ainda pendente');
    let gPill;
    if (g && g.ok === true) gPill = tsfSignalPill('Google', 'ok', 'Enviado e recebido pelo Google — conversão aceita');
    else if (g && g.ok === false) gPill = tsfSignalPill('Google', 'fail', 'Falha no envio ao Google');
    else gPill = tsfSignalPill('Google', 'pending', 'Envio ao Google ainda pendente');
    let emq = '';
    if (mq && typeof mq.score === 'number') {
      const st = mq.score >= 90 ? 'ok' : (mq.score >= 70 ? 'warn' : 'fail');
      const c = TSF_SIGNAL_COLORS[st];
      const miss = (mq.missing && mq.missing.length) ? ' · falta: ' + mq.missing.join(', ') : ' · dado completo';
      emq = '<span title="Qualidade do dado pra casar com o usuário (match ' + mq.score + '/100' + miss + '). Quanto maior, melhor o Meta/Google usam a conversão." style="font-size:10.5px;font-weight:600;color:' + c[0] + '">match ' + mq.score + '</span>';
    }
    return wrap(metaPill + (showGoogle ? gPill : '') + emq);
  }

  /* ── 2026-06-28 · Item 1 (DESDUPLICAÇÃO) · helpers compartilhados pelos 2 editores ──
     Antes cada editor tinha cópia 1:1 ("clone EXATO") → "corrige um, esquece o outro".
     Agora a lógica vive AQUI; cada classe delega passando só o prefixo de data-attr
     (venda: data-tsf-venda-item-*, orçamento: data-tsf-quote-*). Saída byte-idêntica. */
  function tsfEsc(s) { const d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }

  function tsfEditableSpecHtml(label, key, value, uid, source, nativeValue, multiline, type, opts) {
    multiline = multiline || false; type = type || 'text';
    const editAttr = (opts && opts.editAttr) || 'data-tsf-quote-edit';
    const resetAttr = (opts && opts.resetAttr) || 'data-tsf-quote-spec-reset';
    const v = value == null ? '' : value;
    const inputTag = multiline
      ? `<textarea class="tsf-quote-item__spec-input" rows="2"
                    ${editAttr}="${key}" data-uid="${uid}"
                    aria-label="${tsfEsc(label)}">${tsfEsc(v)}</textarea>`
      : `<input type="${type}" class="tsf-quote-item__spec-input"
                  value="${tsfEsc(v)}"
                  ${editAttr}="${key}" data-uid="${uid}"
                  aria-label="${tsfEsc(label)}">`;

    let badgeHtml = '';
    if (source === 'native') {
      badgeHtml = `<span class="tsf-quote-item__spec-badge tsf-quote-item__spec-badge--native" title="Valor vindo do cadastro do produto">nativo</span>`;
    } else if (source === 'edited') {
      badgeHtml = `<span class="tsf-quote-item__spec-badge tsf-quote-item__spec-badge--manual" title="Valor alterado manualmente">editado</span>`;
    } else if (source === 'empty') {
      badgeHtml = `<span class="tsf-quote-item__spec-badge tsf-quote-item__spec-badge--empty" title="Produto sem este dado cadastrado">vazio</span>`;
    }

    let resetHtml = '';
    if (source === 'edited' && nativeValue != null && nativeValue !== '') {
      const nativeStr = String(nativeValue);
      const nativePreview = nativeStr.length > 24 ? nativeStr.slice(0, 22) + '…' : nativeStr;
      resetHtml = `
          <button type="button" class="tsf-quote-item__spec-reset"
                  ${resetAttr}="${key}" data-uid="${uid}"
                  title="Restaurar valor nativo do produto">
            <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <path d="M3 12a9 9 0 1 0 3-6.7"/><polyline points="3 4 3 10 9 10"/>
            </svg>
            <span>nativo ${tsfEsc(nativePreview)}</span>
          </button>`;
    }

    return `
        <div class="tsf-quote-item__spec tsf-quote-item__spec--editable tsf-quote-item__spec--source-${source || 'native'}">
          <dt class="tsf-quote-item__spec-dt-wrap">
            <span>${tsfEsc(label)}</span>
            ${badgeHtml}
          </dt>
          <dd>
            ${inputTag}
            ${resetHtml}
          </dd>
        </div>
      `;
  }

  function tsfEditableSelectHtml(label, key, value, options, uid, source, nativeValue, opts) {
    opts = opts || {};
    const editAttr = opts.editAttr || 'data-tsf-quote-edit';
    const resetAttrs = opts.resetAttrs || ((u) => `data-tsf-quote-vipex-reset="${u}"`);
    const current = value == null ? '' : String(value).toUpperCase();
    const placeholder = source === 'empty' ? `<option value="" selected disabled>—  Selecione  —</option>` : '';
    const optsHtml = options.map(({ value: v, label: l }) => {
      const selected = (v === current && source !== 'empty') ? ' selected' : '';
      return `<option value="${tsfEsc(v)}"${selected}>${tsfEsc(l)}</option>`;
    }).join('');

    let badgeHtml = '';
    if (source === 'native') {
      badgeHtml = `<span class="tsf-quote-item__spec-badge tsf-quote-item__spec-badge--native" title="Origem vinda do cadastro do produto">nativo</span>`;
    } else if (source === 'edited') {
      badgeHtml = `<span class="tsf-quote-item__spec-badge tsf-quote-item__spec-badge--manual" title="Origem alterada manualmente">editado</span>`;
    } else if (source === 'empty') {
      badgeHtml = `<span class="tsf-quote-item__spec-badge tsf-quote-item__spec-badge--empty" title="Produto sem origem cadastrada · selecione uma">vazio</span>`;
    }

    let resetHtml = '';
    if (source === 'edited' && nativeValue) {
      const nativeOption = options.find(o => o.value === String(nativeValue).toUpperCase());
      const nativeLabel = nativeOption ? nativeOption.value : nativeValue;
      resetHtml = `
          <button type="button" class="tsf-quote-item__spec-reset"
                  ${resetAttrs(uid)}
                  title="Restaurar origem nativa do produto">
            <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <path d="M3 12a9 9 0 1 0 3-6.7"/><polyline points="3 4 3 10 9 10"/>
            </svg>
            <span>nativo ${tsfEsc(nativeLabel)}</span>
          </button>`;
    }

    return `
        <div class="tsf-quote-item__spec tsf-quote-item__spec--editable tsf-quote-item__spec--select tsf-quote-item__spec--source-${source}">
          <dt class="tsf-quote-item__spec-dt-wrap">
            <span>${tsfEsc(label)}</span>
            ${badgeHtml}
          </dt>
          <dd>
            <select class="tsf-quote-item__spec-input tsf-quote-item__spec-select"
                    ${editAttr}="${key}" data-uid="${uid}"
                    aria-label="${tsfEsc(label)}">
              ${placeholder}${optsHtml}
            </select>
            ${resetHtml}
          </dd>
        </div>
      `;
  }

  // 2026-06-29 · pinta o fill dourado proporcional de um slider <input type=range>.
  // Helper compartilhado: orçamento (#updateSliderGradient) e venda usam o MESMO (de-dup + paridade).
  function tsfPaintSliderGradient(input) {
    if (!input) return;
    const min = parseFloat(input.min) || 0;
    const max = parseFloat(input.max) || 400;
    const val = parseFloat(input.value) || 0;
    const pct = Math.max(0, Math.min(100, ((val - min) / (max - min)) * 100));
    input.style.background =
      `linear-gradient(to right, var(--gold-accent) 0%, var(--gold-accent) ${pct}%, rgba(26, 25, 24, 0.12) ${pct}%, rgba(26, 25, 24, 0.12) 100%)`;
  }

  // 2026-06-29 · MOTOR DE FRETE VIPEX MULTI-ORIGEM (padrão · o melhor dos dois editores).
  // Agrupa itens por origem Vipex, faz 1 chamada por origem EM PARALELO e SOMA — o jeito correto
  // quando a venda/orçamento tem fornecedores de origens diferentes. Extraído fielmente do
  // #calculateFreight do orçamento. Retorna { totalCentavos, prazoMin, prazoMax, groups, empty }.
  // Cada editor faz sua própria persistência/render a partir desse retorno.
  async function tsfComputeMultiOriginFreight(items, cepDigits) {
    const groups = new Map();
    for (const item of (items || [])) {
      const s = item.snapshot || {};
      const ov = item.overrides || {};
      // Resolução: override → metafield do produto → metaobject fornecedor → default SP-INT3
      const origemRaw = ov.vipex_origem || s.metafields?.vipex_origem || s.fornecedor?.vipex_origem || 'SP-INT3';
      const origem = String(origemRaw).toUpperCase();
      if (!s.embalagem || !s.embalagem.comprimento) continue; // sem embalagem, não calcula
      if (!groups.has(origem)) groups.set(origem, []);
      groups.get(origem).push(item);
    }
    if (groups.size === 0) return { totalCentavos: 0, prazoMin: null, prazoMax: null, groups: [], empty: true };

    const requests = [];
    for (const [origem, gItems] of groups) {
      const payload = {
        cep: cepDigits,
        items: gItems.map((it) => {
          const s = it.snapshot || {};
          const ov = it.overrides || {};
          // Valor da mercadoria: cost override → cost real → price público
          const unitCentavos =
            (typeof ov.cost_centavos === 'number') ? ov.cost_centavos :
            (typeof s.cost_centavos === 'number' && s.cost_centavos > 0) ? s.cost_centavos :
            (s.price_centavos || 0);
          return { embalagem: s.embalagem, quantity: it.qty || 1, price: unitCentavos / 100, origem };
        }),
      };
      requests.push(
        fetch(`https://pucrgwvcgagbapzvphao.supabase.co/functions/v1/toth-checkout/calculate-shipping`, {
          method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload),
        })
          .then((r) => r.json())
          .then((data) => ({ origem, items: gItems, data }))
          .catch((err) => ({ origem, items: gItems, error: err.message }))
      );
    }

    const results = await Promise.all(requests);

    let totalCentavos = 0, maxPrazoMax = 0, minPrazoMin = 999;
    const groupCards = [];
    for (const r of results) {
      if (r.error || !r.data?.ok) {
        groupCards.push({ origem: r.origem, count: r.items.length, error: r.data?.error || r.error || 'Falha' });
        continue;
      }
      const opt = r.data.options?.[0];
      if (opt) {
        totalCentavos += Math.round(opt.price * 100);
        if (opt.prazo_max > maxPrazoMax) maxPrazoMax = opt.prazo_max;
        if (opt.prazo_min < minPrazoMin) minPrazoMin = opt.prazo_min;
        groupCards.push({ origem: r.origem, count: r.items.length, price: Math.round(opt.price * 100), prazo_min: opt.prazo_min, prazo_max: opt.prazo_max, dest: r.data.dest });
      }
    }
    return { totalCentavos, prazoMin: maxPrazoMax > 0 ? minPrazoMin : null, prazoMax: maxPrazoMax > 0 ? maxPrazoMax : null, groups: groupCards, empty: false };
  }

  // 2026-06-29 · BLOCO DE PRICING POR ITEM (custo + markup + badges 3-state + resets) · helper COMPARTILHADO
  //   (de-dup #tothPricingHtml ↔ #renderVendaTothPricing). ITEM 6 RESOLVIDO: a guarda do reset é a da VENDA
  //   (esconde o botão quando o markup já é ~nativo) — agora é padrão nos dois. Parametriza só os data-attrs.
  function tsfTothPricingHtml(item, tothUnit, useMarkup, clienteUnit, clienteTotal, nativeMarkupPct, markupSource, globalPct, uid, opts) {
    opts = opts || {};
    const editAttr = opts.editAttr || 'data-tsf-quote-edit';
    const markupField = opts.markupField || 'markup_pct';
    const markupReset = opts.markupReset || ((u) => `data-tsf-quote-markup-reset="${u}"`);
    const costReset = opts.costReset || ((u) => `data-tsf-quote-cost-reset="${u}"`);
    const rowTotalAttr = opts.rowTotalAttr || 'data-tsf-quote-row-total';

    const mult = (1 + useMarkup / 100);
    const ov = item.overrides || {};
    const snap = item.snapshot || {};
    const costOverridden = typeof ov.cost_centavos === 'number';
    const multDisplay = mult.toFixed(2).replace('.', ',');
    const costEditValue = (tothUnit / 100).toFixed(2).replace('.', ',');

    let badgeHtml = '';
    let nativeHintHtml = '';
    const hasNative = nativeMarkupPct != null;
    const nativeMult = hasNative ? (1 + nativeMarkupPct / 100).toFixed(2).replace('.', ',') : null;
    // ITEM 6 (2026-06-29) · guarda unificada (a melhor · da venda): reset só quando o markup atual
    //   diverge do nativo (>0,5pp) — esconde o botão quando clicar não faria nada.
    const shouldShowReset = hasNative && Math.abs(nativeMarkupPct - useMarkup) > 0.5;
    const resetBtnHtml = shouldShowReset ? `
        <button type="button" class="tsf-quote-item__markup-reset"
                ${markupReset(uid)}
                title="Restaurar markup nativo do site">
          <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="M3 12a9 9 0 1 0 3-6.7"/><polyline points="3 4 3 10 9 10"/>
          </svg>
          <span>nativo ${nativeMult}x</span>
        </button>` : '';

    if (markupSource === 'manual') {
      badgeHtml = `<span class="tsf-quote-item__markup-badge tsf-quote-item__markup-badge--manual" title="Markup editado manualmente">editado</span>`;
      nativeHintHtml = resetBtnHtml;
    } else if (markupSource === 'global') {
      const globalMult = (1 + globalPct / 100).toFixed(2).replace('.', ',');
      badgeHtml = `<span class="tsf-quote-item__markup-badge tsf-quote-item__markup-badge--global" title="Aplicado pelo markup global">global ${globalMult}x</span>`;
      nativeHintHtml = resetBtnHtml;
    } else if (hasNative) {
      badgeHtml = `<span class="tsf-quote-item__markup-badge tsf-quote-item__markup-badge--native" title="Markup nativo: preço de venda do site ÷ custo">nativo</span>`;
    }

    const costBadgeHtml = costOverridden
      ? `<span class="tsf-quote-item__markup-badge tsf-quote-item__markup-badge--manual" title="Custo alterado manualmente">editado</span>`
      : `<span class="tsf-quote-item__markup-badge tsf-quote-item__markup-badge--native" title="Custo real do produto no Shopify Admin">nativo</span>`;

    const nativeCostCents = snap.cost_centavos;
    const costNativeStr = (nativeCostCents != null && nativeCostCents > 0)
      ? (nativeCostCents / 100).toFixed(2).replace('.', ',')
      : null;
    const costResetHtml = (costOverridden && costNativeStr)
      ? `<button type="button" class="tsf-quote-item__markup-reset"
                 ${costReset(uid)}
                 title="Restaurar custo real do Shopify">
           <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
             <path d="M3 12a9 9 0 1 0 3-6.7"/><polyline points="3 4 3 10 9 10"/>
           </svg>
           <span>nativo R$ ${costNativeStr}</span>
         </button>`
      : '';

    return `
        <div class="tsf-quote-item__pricing tsf-quote-item__pricing--toth">
          <div class="tsf-quote-item__toth-edit tsf-print-hide">
            <label class="tsf-quote-item__toth-edit-label tsf-quote-item__markup-label-wrap">
              <span class="tsf-quote-item__markup-label-top">
                <span>Custo unitário</span>
                ${costBadgeHtml}
              </span>
              <span class="tsf-quote-item__toth-input-row">
                <span class="tsf-quote-item__toth-prefix">R$</span>
                <input type="text" inputmode="decimal"
                       class="tsf-quote-item__toth-input tsf-quote-item__toth-input--cost"
                       value="${costEditValue}"
                       ${editAttr}="cost_centavos" data-uid="${uid}"
                       aria-label="Preço de custo unitário">
              </span>
              ${costResetHtml}
            </label>
            <label class="tsf-quote-item__toth-edit-label tsf-quote-item__markup-label-wrap">
              <span class="tsf-quote-item__markup-label-top">
                <span>Markup</span>
                ${badgeHtml}
              </span>
              <span class="tsf-quote-item__toth-input-row">
                <input type="text" inputmode="decimal"
                       class="tsf-quote-item__toth-input tsf-quote-item__toth-input--markup"
                       value="${multDisplay}"
                       ${editAttr}="${markupField}" data-uid="${uid}"
                       aria-label="Multiplicador de markup">
                <span class="tsf-quote-item__toth-suffix">x</span>
              </span>
              ${nativeHintHtml}
            </label>
          </div>
          <div class="tsf-quote-item__client">
            <span class="tsf-quote-item__client-label">Valor cliente</span>
            <span class="tsf-quote-item__client-value" ${rowTotalAttr}>${money(clienteTotal)}</span>
            <span class="tsf-quote-item__client-meta">${item.qty || 1} × ${money(clienteUnit)}</span>
          </div>
        </div>
      `;
  }

  // 2026-06-29 · formatadores de PDF COMPARTILHADOS (de-dup #escHtml/#escAttr/#optImg · orçamento ↔ venda).
  //   Versão segura (?? '') unificada. #optImg otimiza CDN Shopify (?width=N) p/ PDF leve; externas passam intactas.
  function tsfEscHtml(s) { return String(s ?? '').replace(/[&<>]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;' })[c]); }
  function tsfEscAttr(s) { return String(s ?? '').replace(/[&"<>]/g, c => ({ '&': '&amp;', '"': '&quot;', '<': '&lt;', '>': '&gt;' })[c]); }
  function tsfOptImg(url, width = 800) {
    if (!url || typeof url !== 'string') return '';
    const isShopifyCdn = url.includes('cdn.shopify.com') || url.includes('cdn.shop') || url.includes('/cdn/shop/');
    if (!isShopifyCdn) return tsfEscAttr(url);
    try {
      const u = new URL(url);
      u.searchParams.set('width', String(width));
      return tsfEscAttr(u.toString());
    } catch {
      return tsfEscAttr(url);
    }
  }

  // 2026-06-29 · PÁGINAS DE AUTORIDADE DO PDF (institucional/clientes/depoimentos/projetos) · COMPARTILHADO
  //   (de-dup #buildAuthorityPagesHtml orçamento ↔ venda · era "Clone EXATO"). blocks = authority_blocks,
  //   content = #authorityContent, opts.scopePhrase = 'deste orçamento'|'desta venda' (só a lede de projetos muda).
  function tsfBuildAuthorityPagesHtml(blocks, content, opts) {
    blocks = blocks || [];
    opts = opts || {};
    const scopePhrase = opts.scopePhrase || 'deste orçamento';
    if (!blocks.length || !content) return '';
    const c = content;
    const parts = [];

    if (blocks.includes('institucional') && c.institucional) {
      const inst = c.institucional;
      const cards = [];
      for (const i of [1, 2, 3]) {
        const titulo = inst[`titulo_${i}`];
        const desc = inst[`descricao_${i}`];
        const arquivo = inst[`arquivo_${i}`];
        if (titulo || desc) {
          cards.push(`
              <article class="aut-inst__card">
                ${arquivo ? `<div class="aut-inst__media"><img src="${tsfOptImg(arquivo, 520)}" alt=""></div>` : ''}
                ${titulo ? `<h3 class="aut-inst__title">${tsfEscHtml(titulo)}</h3>` : ''}
                ${desc ? `<p class="aut-inst__desc">${tsfEscHtml(desc)}</p>` : ''}
              </article>
            `);
        }
      }
      const logos = [1, 2, 3, 4, 5].map(i => inst[`cliente_${i}`]).filter(Boolean);
      const logosHtml = logos.length
        ? `<div class="aut-inst__logos">${logos.map(url => `<img src="${tsfOptImg(url, 240)}" alt="" loading="lazy">`).join('')}</div>`
        : '';
      if (cards.length) {
        parts.push(`
            <section class="aut-page aut-inst">
              <header class="aut-page__head">
                <span class="aut-page__eyebrow">Quem é a Toth</span>
                <h2 class="aut-page__title">Mobiliário com história</h2>
                <div class="aut-page__rule" aria-hidden="true"></div>
              </header>
              <div class="aut-inst__grid">${cards.join('')}</div>
              ${logosHtml}
            </section>
          `);
      }
    }

    if (blocks.includes('clients') && c.clients) {
      const cg = c.clients;
      const logos = (cg.logo || []).filter(Boolean);
      if (logos.length) {
        parts.push(`
            <section class="aut-page aut-clients">
              <header class="aut-page__head">
                <span class="aut-page__eyebrow">Provas de confiança</span>
                <h2 class="aut-page__title">${tsfEscHtml(cg.title || 'Casas que confiaram em nós')}</h2>
                <div class="aut-page__rule" aria-hidden="true"></div>
                <p class="aut-page__lede">Empresas e instituições que já receberam mobiliário Toth.</p>
              </header>
              <div class="aut-clients__grid">
                ${logos.map(url => `<div class="aut-clients__logo"><img src="${tsfOptImg(url, 240)}" alt="" loading="lazy"></div>`).join('')}
              </div>
            </section>
          `);
      }
    }

    if (blocks.includes('testimonials') && (c.testimonials || []).length) {
      const cards = c.testimonials.map(t => {
        const envImgs = (t.environment_images || []).slice(0, 1);
        return `
            <article class="aut-test__card">
              ${envImgs.length ? `<div class="aut-test__media"><img src="${tsfOptImg(envImgs[0], 540)}" alt="" loading="lazy"></div>` : ''}
              <blockquote class="aut-test__quote">
                <span class="aut-test__mark" aria-hidden="true">"</span>
                <p>${tsfEscHtml(t.testimonial || '')}</p>
              </blockquote>
              <footer class="aut-test__author">
                ${t.avatar ? `<img class="aut-test__avatar" src="${tsfOptImg(t.avatar, 160)}" alt="" loading="lazy">` : ''}
                <div>
                  <span class="aut-test__name">${tsfEscHtml(t.name || '')}</span>
                  ${t.role_subtitle ? `<span class="aut-test__role">${tsfEscHtml(t.role_subtitle)}</span>` : ''}
                  ${t.location ? `<span class="aut-test__loc">${tsfEscHtml(t.location)}</span>` : ''}
                </div>
              </footer>
            </article>
          `;
      }).join('');
      parts.push(`
          <section class="aut-page aut-test">
            <header class="aut-page__head">
              <span class="aut-page__eyebrow">A palavra de quem viveu</span>
              <h2 class="aut-page__title">Depoimentos</h2>
              <div class="aut-page__rule" aria-hidden="true"></div>
            </header>
            <div class="aut-test__grid">${cards}</div>
          </section>
        `);
    }

    if (blocks.includes('projects') && (c.projects || []).length) {
      const cards = c.projects.slice(0, 6).map(p => {
        const cover = p.main_media || (p.gallery && p.gallery[0]);
        const rooms = Array.isArray(p.room_type) ? p.room_type.join(' · ') : '';
        return `
            <article class="aut-proj__card">
              ${cover ? `<div class="aut-proj__media"><img src="${tsfOptImg(cover, 640)}" alt="" loading="lazy"></div>` : ''}
              <div class="aut-proj__body">
                <h3 class="aut-proj__name">${tsfEscHtml(p.name || 'Projeto Toth')}</h3>
                <div class="aut-proj__meta">
                  ${p.architect ? `<span>${tsfEscHtml(p.architect)}</span>` : ''}
                  ${rooms ? `<span>${tsfEscHtml(rooms)}</span>` : ''}
                </div>
              </div>
            </article>
          `;
      }).join('');
      parts.push(`
          <section class="aut-page aut-proj">
            <header class="aut-page__head">
              <span class="aut-page__eyebrow">Inspirações</span>
              <h2 class="aut-page__title">Realizações como a sua</h2>
              <div class="aut-page__rule" aria-hidden="true"></div>
              <p class="aut-page__lede">Projetos selecionados com curadoria editorial Toth, próximos do escopo ${scopePhrase}.</p>
            </header>
            <div class="aut-proj__grid">${cards}</div>
          </section>
        `);
    }

    return parts.join('\n');
  }

  // 2026-06-29 · SELO DE STATUS DO SAVE MANUAL (idle/dirty/saving/saved/error) · COMPARTILHADO
  //   (de-dup #updateSaveStatus orçamento ↔ venda). Parametriza os seletores; lógica/textos idênticos.
  function tsfRenderSaveStatus(state, count, opts) {
    opts = opts || {};
    const fmtTime = (d) => `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
    const states = {
      idle:   { text: 'Pronto', kind: 'idle' },
      dirty:  { text: `● ${count} alteraç${count === 1 ? 'ão pendente' : 'ões pendentes'}`, kind: 'dirty' },
      queued: { text: `● ${count} alteraç${count === 1 ? 'ão pendente' : 'ões pendentes'}`, kind: 'dirty' },
      saving: { text: 'Salvando…', kind: 'saving' },
      saved:  { text: `✓ Salvo às ${fmtTime(new Date())}`, kind: 'saved' },
      error:  { text: '⚠ Falha ao salvar · tente novamente', kind: 'error' },
    };
    const s = states[state] || states.idle;
    if (opts.statusSel) document.querySelectorAll(opts.statusSel).forEach((el) => {
      el.textContent = s.text;
      el.setAttribute('data-save-state', s.kind);
    });
    const saveBtn = opts.saveSel ? document.querySelector(opts.saveSel) : null;
    const discardBtn = opts.discardSel ? document.querySelector(opts.discardSel) : null;
    const isDirty = s.kind === 'dirty' || s.kind === 'saving';
    if (saveBtn) {
      saveBtn.disabled = !isDirty || s.kind === 'saving';
      saveBtn.classList.toggle('is-dirty', s.kind === 'dirty');
      if (opts.labelSel) { const lbl = saveBtn.querySelector(opts.labelSel); if (lbl) lbl.textContent = s.kind === 'saving' ? 'Salvando…' : 'Salvar'; }
      if (opts.countSel) { const dot = saveBtn.querySelector(opts.countSel); if (dot) dot.textContent = count > 0 ? String(count) : ''; }
    }
    if (discardBtn) discardBtn.disabled = !isDirty || s.kind === 'saving';
    return s;
  }

  class TsfAdminOrcamentos extends HTMLElement {
    #customerId = null;
    #quotes = [];
    #salesByQuoteId = new Map(); // 6.11D · indicador "quote → venda"
    #statusFilter = 'all';
    #teto = 20; // paginacao: 20 cards por vez (a lista chegou a 14 telas)
    #scope = 'all'; // Default 'all' · admin ve panorama completo ao abrir.
                    // Valores: 'mine' | 'team' | 'specifica' | 'all'
    #periodFilter = 'all'; // UI-FIX 2b · default Tudo (orçamentos podem ser antigos)
    #abortController = null;

    // UI-FIX 2b · helpers period (delegam ao TsfPeriodFilter)
    #dateRange() { return TsfPeriodFilter.dateRange(this.#periodFilter); }
    #periodLabel() { return TsfPeriodFilter.periodLabel(this.#periodFilter); }
    // Data efetiva pra filtro: updated_at > created_at fallback
    #effectiveDate(q) {
      const raw = q.updated_at || q.created_at;
      return raw ? new Date(raw) : null;
    }

    async connectedCallback() {
      this.#abortController = new AbortController();
      this.#customerId = this.getAttribute('data-customer-id');
      if (!this.#customerId) {
        this.#renderError('Customer ID ausente · faça login novamente.');
        return;
      }

      // Captura filtros existentes do Liquid slot
      this.querySelectorAll('[data-filter]').forEach(btn => {
        btn.addEventListener('click', () => this.#onFilterChange(btn), { signal: this.#abortController.signal });
      });

      // Inicializa filter + scope + period da URL
      const urlParams = new URLSearchParams(window.location.search);
      const urlStatus = urlParams.get('status');
      if (['all','draft','sent','won','lost'].includes(urlStatus)) {
        this.#statusFilter = urlStatus;
        this.#syncFilterUI();
      }
      const urlScope = urlParams.get('scope');
      if (['mine','team','specifica','all'].includes(urlScope)) {
        this.#scope = urlScope;
      }
      const urlPeriod = urlParams.get('period');
      if (urlPeriod && TsfPeriodFilter.isValidPeriod(urlPeriod)) {
        this.#periodFilter = urlPeriod;
      }

      // Injeta toggle de scope no DOM (acima dos filtros)
      this.#injectScopeToggle();
      this.#injectPeriodToggle();

      // Delegação · botão excluir direto no card
      this.addEventListener('click', (e) => {
        const btn = e.target.closest?.('[data-tsf-admin-delete-orcamento]');
        if (btn) {
          e.preventDefault();
          e.stopPropagation();
          this.#onCardDelete(btn.getAttribute('data-tsf-admin-delete-orcamento'), btn.getAttribute('data-cliente'));
        }
      }, { signal: this.#abortController.signal });

      await this.#fetch();
    }

    // Injeta tabs de scope multi-tenant (Meus · Time interno · Specifica · Todos)
    #injectScopeToggle() {
      const filtersNav = this.querySelector('[data-tsf-admin-orcamentos-filters]');
      if (!filtersNav) return;
      const toggle = document.createElement('div');
      toggle.className = 'tsf-admin-scope-toggle';
      toggle.setAttribute('role', 'tablist');
      toggle.setAttribute('aria-label', 'Visualização multi-tenant');
      toggle.innerHTML = `
        <button type="button" class="tsf-admin-scope-toggle__btn ${this.#scope==='mine'?'is-active':''}" data-scope="mine" role="tab" aria-selected="${this.#scope==='mine'}" title="Apenas os orçamentos que você criou">
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
          <span>Meus</span>
        </button>
        <button type="button" class="tsf-admin-scope-toggle__btn ${this.#scope==='team'?'is-active':''}" data-scope="team" role="tab" aria-selected="${this.#scope==='team'}" title="Todos os orçamentos do time interno Toth">
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
          <span>Time interno</span>
        </button>
        <button type="button" class="tsf-admin-scope-toggle__btn ${this.#scope==='specifica'?'is-active':''}" data-scope="specifica" role="tab" aria-selected="${this.#scope==='specifica'}" title="Orçamentos dos arquitetos Specifica">
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 2L2 7l10 5 10-5-10-5z"/><path d="M2 17l10 5 10-5"/><path d="M2 12l10 5 10-5"/></svg>
          <span>Specifica</span>
        </button>
        <button type="button" class="tsf-admin-scope-toggle__btn ${this.#scope==='all'?'is-active':''}" data-scope="all" role="tab" aria-selected="${this.#scope==='all'}" title="Panorama completo · time interno + specifica">
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></svg>
          <span>Todos</span>
        </button>
      `;
      filtersNav.parentElement?.insertBefore(toggle, filtersNav);
      toggle.querySelectorAll('[data-scope]').forEach(btn => {
        btn.addEventListener('click', () => this.#onScopeChange(btn), { signal: this.#abortController.signal });
      });
    }

    // UI-FIX 2b · Injeta period toggle (botão MÊS com dropdown integrado)
    #injectPeriodToggle() {
      const filtersNav = this.querySelector('[data-tsf-admin-orcamentos-filters]');
      if (!filtersNav) return;
      const periodWrap = document.createElement('div');
      periodWrap.innerHTML = TsfPeriodFilter.renderToggle(this.#periodFilter);
      filtersNav.parentElement?.insertBefore(periodWrap.firstElementChild, filtersNav);
      TsfPeriodFilter.attachListeners(
        this,
        () => this.#periodFilter,
        (newPeriod) => this.#onPeriodChange(newPeriod),
        this.#abortController.signal,
      );
    }

    #onPeriodChange(period) {
      this.#periodFilter = period;
      this.#teto = 20;
      TsfPeriodFilter.syncActiveState(this, period);
      this.#renderResults();
      this.#updateSummary();
      this.#updateCounts();
      try {
        const url = new URL(window.location.href);
        if (period !== 'all') url.searchParams.set('period', period);
        else url.searchParams.delete('period');
        window.history.replaceState({}, '', url.toString());
      } catch {}
    }

    async #onScopeChange(btn) {
      const scope = btn.getAttribute('data-scope');
      if (!['mine','team','specifica','all'].includes(scope)) return;
      this.#scope = scope;
      this.#teto = 20;
      // Sync UI
      this.querySelectorAll('[data-scope]').forEach(b => {
        const isActive = b.getAttribute('data-scope') === scope;
        b.classList.toggle('is-active', isActive);
        b.setAttribute('aria-selected', String(isActive));
      });
      // Sync URL
      try {
        const url = new URL(window.location.href);
        if (scope !== 'mine') url.searchParams.set('scope', scope);
        else url.searchParams.delete('scope');
        window.history.replaceState({}, '', url.toString());
      } catch {}
      // Refetch
      await this.#fetch();
    }

    disconnectedCallback() {
      this.#abortController?.abort();
    }

    async #fetch() {
      try {
        // Monta URL baseado no scope · 'mine' usa specifier, demais ignoram
        const params = new URLSearchParams();
        if (this.#scope === 'mine') {
          params.set('specifier_customer_id', this.#customerId);
        } else {
          params.set('scope', this.#scope);
          // specifier_customer_id continua passando pra backward compat (não usado quando scope != mine)
          params.set('specifier_customer_id', this.#customerId);
        }
        // Onda 6.11D · Fetch paralelo de quotes + sales pra indicar "já virou venda"
        const [qRes, sRes] = await Promise.all([
          fetch(`${QUOTE_ENDPOINT}/list?${params.toString()}`, { signal: this.#abortController.signal }),
          fetch(`${SALE_ENDPOINT}/list?${params.toString()}`, { signal: this.#abortController.signal }),
        ]);
        const data = await qRes.json();
        const salesData = await sRes.json();
        if (!data.ok) throw new Error(data.error || 'falha');
        this.#quotes = data.quotes || [];
        // Index sales por quote_id pra lookup O(1)
        this.#salesByQuoteId = new Map();
        if (salesData?.ok) {
          for (const s of (salesData.sales || [])) {
            if (s.quote_id) this.#salesByQuoteId.set(s.quote_id, s);
          }
        }
      } catch (err) {
        this.#renderError('Falha ao carregar orçamentos: ' + err.message);
        return;
      }
      this.#updateCounts();
      this.#renderResults();
      this.#updateSummary();
    }

    #applyPeriodFilter(list) {
      const [start, end] = this.#dateRange();
      if (!start || !end) return list;
      return list.filter(q => {
        const d = this.#effectiveDate(q);
        return d && d >= start && d < end;
      });
    }

    #updateCounts() {
      // UI-FIX 2b · counts respeitam período
      const scoped = this.#applyPeriodFilter(this.#quotes);
      const countAll = scoped.length;
      const countDraft = scoped.filter(q => q.status === 'draft').length;
      const countSent = scoped.filter(q => q.status === 'sent').length;
      const countWon = scoped.filter(q => q.status === 'won' || q.status === 'closed').length;
      const countLost = scoped.filter(q => q.status === 'lost' || q.status === 'cancelled').length;
      const setCount = (key, val) => {
        const el = this.querySelector(`[data-tsf-admin-orcamentos-count="${key}"]`);
        if (el) el.textContent = val;
      };
      setCount('all', countAll);
      setCount('draft', countDraft);
      setCount('sent', countSent);
      setCount('won', countWon);
      setCount('lost', countLost);
    }

    #updateSummary() {
      const summaryEl = this.parentElement?.querySelector('[data-tsf-admin-orcamentos-summary]') || document.querySelector('[data-tsf-admin-orcamentos-summary]');
      if (!summaryEl) return;
      // UI-FIX 2b · summary respeita período
      const scoped = this.#applyPeriodFilter(this.#quotes);
      const total = scoped.length;
      const pedidosTotal = scoped.reduce((acc, q) => acc + (q.pedidos_count?.total || 0), 0);
      const periodLbl = this.#periodLabel();
      if (total === 0) {
        if (periodLbl) summaryEl.textContent = `Nenhum orçamento ${periodLbl} · troque o período ou crie um novo`;
        else summaryEl.textContent = 'Nenhum orçamento ainda · clique em "Novo orçamento" pra começar';
      } else {
        const suffix = periodLbl ? ` ${periodLbl}` : '';
        summaryEl.textContent = `${total} orçamento${total>1?'s':''}${suffix} · ${pedidosTotal} pedido${pedidosTotal!==1?'s':''} gerado${pedidosTotal!==1?'s':''} pra fábrica`;
      }
    }

    #onFilterChange(btn) {
      const filter = btn.getAttribute('data-filter');
      this.#statusFilter = filter;
      this.#teto = 20;
      this.#syncFilterUI();
      this.#renderResults();

      // Sync URL pra permitir bookmark
      try {
        const url = new URL(window.location.href);
        if (filter !== 'all') url.searchParams.set('status', filter);
        else url.searchParams.delete('status');
        window.history.replaceState({}, '', url.toString());
      } catch {}
    }

    #syncFilterUI() {
      this.querySelectorAll('[data-filter]').forEach(b => {
        const isActive = b.getAttribute('data-filter') === this.#statusFilter;
        b.classList.toggle('is-active', isActive);
        b.setAttribute('aria-selected', String(isActive));
      });
    }

    #applyFilter(quotes) {
      // UI-FIX 2b · primeiro aplica período, depois status
      const scoped = this.#applyPeriodFilter(quotes);
      if (this.#statusFilter === 'all') return scoped;
      if (this.#statusFilter === 'won') return scoped.filter(q => q.status === 'won' || q.status === 'closed');
      if (this.#statusFilter === 'lost') return scoped.filter(q => q.status === 'lost' || q.status === 'cancelled');
      return scoped.filter(q => q.status === this.#statusFilter);
    }

    // Onda 7 · Usa numero_orcamento persistido (TOTH-2026-ORC-1001+) com fallback
    #computeOrcNumber(quote) {
      if (quote.numero_orcamento) return quote.numero_orcamento;
      const created = quote.created_at ? new Date(quote.created_at) : new Date();
      const year = created.getFullYear();
      const digitsOnly = (quote.id || '').replace(/[^0-9]/g, '');
      const suffix = digitsOnly.slice(-4).padStart(4, '0');
      return `TOTH-${year}-ORC-${suffix}`;
    }

    #timeAgo(date) {
      const seconds = Math.floor((Date.now() - date.getTime()) / 1000);
      if (seconds < 60) return 'agora';
      const minutes = Math.floor(seconds / 60);
      if (minutes < 60) return `${minutes} min`;
      const hours = Math.floor(minutes / 60);
      if (hours < 24) return `${hours}h`;
      const days = Math.floor(hours / 24);
      if (days < 30) return `${days}d`;
      const months = Math.floor(days / 30);
      return `${months} mês${months > 1 ? 'es' : ''}`;
    }

    #computeQuoteTotal(quote) {
      // 2026-06-23 FIX · usa a fonte unica tsfDocTotalCentavos (= editor + backend + lista de vendas).
      // O calculo bespoke antigo ignorava overrides.cost_centavos + markup por item (inflava/desinflava).
      return tsfDocTotalCentavos(quote);
    }

    #renderResults() {
      const resultsEl = this.querySelector('[data-tsf-admin-orcamentos-results]');
      if (!resultsEl) return;

      const filtered = this.#applyFilter(this.#quotes);

      if (filtered.length === 0) {
        const isFiltered = this.#statusFilter !== 'all';
        resultsEl.innerHTML = `
          <div class="tsf-admin-list-page__empty">
            <svg width="56" height="56" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="0.8" aria-hidden="true">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/>
            </svg>
            <h3>${isFiltered ? `Nenhum orçamento com status "${this.#statusFilter}"` : 'Nenhum orçamento ainda'}</h3>
            <p>${isFiltered ? 'Tente outro filtro ou crie um novo orçamento.' : 'Cada vez que você adiciona produtos pra um cliente, o orçamento aparece aqui.'}</p>
            ${!isFiltered ? `<a href="/pages/admin-orcamento" class="tsf-admin-list-page__empty-cta">Novo orçamento →</a>` : ''}
          </div>
        `;
        return;
      }

      // Cards grid — JANELA de 20: ordenado por atualizacao, o que importa esta em cima.
      const visiveis = filtered.slice(0, this.#teto);
      const sobra = filtered.length - visiveis.length;
      resultsEl.innerHTML = `<ol class="tsf-admin-orcamentos-grid">${visiveis.map(q => this.#cardHtml(q)).join('')}</ol>` +
        (sobra > 0
          ? `<button type="button" class="tsf-admin-list-page__empty-cta" data-tsf-orc-mais style="display:flex;justify-content:center;margin:18px auto 0;border:0;cursor:pointer">Mostrar mais ${Math.min(20, sobra)} · faltam ${sobra}</button>`
          : '');
      resultsEl.querySelector('[data-tsf-orc-mais]')?.addEventListener('click', () => {
        this.#teto += 20;
        this.#renderResults();
      });
    }

    #cardHtml(q) {
      const orcNumber = this.#computeOrcNumber(q);
      const clientName = q.client_info?.name || 'Cliente sem nome';
      const clientCity = q.client_info?.address?.localidade || q.client_info?.address?.cidade || '';
      const items = Array.isArray(q.items) ? q.items : [];
      const total = this.#computeQuoteTotal(q);
      const updatedAt = q.updated_at ? new Date(q.updated_at) : null;
      const ago = updatedAt ? this.#timeAgo(updatedAt) : '—';
      const pedidos = q.pedidos_count || { total: 0, draft: 0, sent: 0, confirmed: 0 };

      const isToth = q.quote_kind === 'toth_internal';
      const kindBadge = isToth
        ? '<span class="tsf-admin-orcamento-card__kind tsf-admin-orcamento-card__kind--toth">Toth Internal</span>'
        : '<span class="tsf-admin-orcamento-card__kind tsf-admin-orcamento-card__kind--specifica">Specifica</span>';

      const statusLabels = {
        draft: { label: 'Rascunho', cls: 'tsf-admin-orcamento-card__status--draft' },
        sent: { label: 'Enviado', cls: 'tsf-admin-orcamento-card__status--sent' },
        won: { label: 'Fechado', cls: 'tsf-admin-orcamento-card__status--won' },
        closed: { label: 'Fechado', cls: 'tsf-admin-orcamento-card__status--won' },
        lost: { label: 'Perdido', cls: 'tsf-admin-orcamento-card__status--lost' },
        cancelled: { label: 'Cancelado', cls: 'tsf-admin-orcamento-card__status--lost' },
      };
      const statusInfo = statusLabels[q.status] || statusLabels.draft;

      const pedidosBadge = pedidos.total > 0
        ? `<div class="tsf-admin-orcamento-card__pedidos">
             <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>
             <strong>${pedidos.total}</strong> pedido${pedidos.total>1?'s':''} pra fábrica
             ${pedidos.draft > 0 ? `<span class="tsf-admin-orcamento-card__pedidos-pill">${pedidos.draft} rasc.</span>` : ''}
             ${pedidos.sent > 0 ? `<span class="tsf-admin-orcamento-card__pedidos-pill tsf-admin-orcamento-card__pedidos-pill--sent">${pedidos.sent} env.</span>` : ''}
             ${pedidos.confirmed > 0 ? `<span class="tsf-admin-orcamento-card__pedidos-pill tsf-admin-orcamento-card__pedidos-pill--confirmed">${pedidos.confirmed} confirm.</span>` : ''}
           </div>`
        : `<div class="tsf-admin-orcamento-card__pedidos tsf-admin-orcamento-card__pedidos--empty">
             <span>Nenhum pedido gerado ainda</span>
           </div>`;

      // Onda 6.12 · permite hard delete em status finais (rascunho/perdido/cancelado/fechado)
      const canDelete = ['draft', 'lost', 'cancelled', 'closed'].includes(q.status);
      const linkedSale = this.#salesByQuoteId.get(q.id);
      return `
        <li class="tsf-admin-orcamento-card${linkedSale ? ' is-converted' : ''}" data-quote-status="${this.#esc(q.status)}" data-quote-id="${this.#esc(q.id)}">
          ${linkedSale ? `
            <a class="tsf-admin-orcamento-card__sale-ribbon" href="/pages/admin-venda?id=${this.#esc(linkedSale.id)}" title="Ver venda ${this.#esc(linkedSale.numero_venda)}">
              <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>
              <span>Virou ${this.#esc(linkedSale.numero_venda)}</span>
            </a>
          ` : ''}
          <a class="tsf-admin-orcamento-card__link" href="/pages/admin-orcamento?id=${this.#esc(q.id)}">
            <header class="tsf-admin-orcamento-card__head">
              <div class="tsf-admin-orcamento-card__id-row">
                <span class="tsf-admin-orcamento-card__number">${this.#esc(orcNumber)}</span>
                ${kindBadge}
              </div>
              <span class="tsf-admin-orcamento-card__status ${statusInfo.cls}">${statusInfo.label}</span>
            </header>
            <h3 class="tsf-admin-orcamento-card__client">${this.#esc(clientName)}</h3>
            ${clientCity ? `<div class="tsf-admin-orcamento-card__city">${this.#esc(clientCity)}</div>` : ''}
            <div class="tsf-admin-orcamento-card__meta">
              ${items.length} ${items.length === 1 ? 'item' : 'items'}
            </div>
            <div class="tsf-admin-orcamento-card__value">${money(total)}</div>
            ${pedidosBadge}
            ${tsfDispatchSignalHtml(q.tsf_conversion_dispatch_log, { google: false })}
          </a>
          <footer class="tsf-admin-card-footer">
            <span class="tsf-admin-card-footer__meta">${q.specifier_email ? 'Por ' + this.#esc(q.specifier_email) + ' · ' : ''}Editado ${ago}</span>
            <div class="tsf-admin-card-footer__actions">
              ${canDelete ? `
                <button type="button" class="tsf-admin-card-footer__delete" data-tsf-admin-delete-orcamento="${this.#esc(q.id)}" data-cliente="${this.#esc(clientName)}" title="Excluir orçamento" aria-label="Excluir orçamento">
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                    <polyline points="3 6 5 6 21 6"/><path d="M19 6l-2 14a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2L5 6"/><path d="M10 11l0 6"/><path d="M14 11l0 6"/><path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>
                  </svg>
                </button>
              ` : ''}
              <a href="/pages/admin-orcamento?id=${this.#esc(q.id)}" class="tsf-admin-card-footer__cta">Abrir →</a>
            </div>
          </footer>
        </li>
      `;
    }

    // Handler do botão "excluir direto" no card · delegação via click no container
    async #onCardDelete(id, cliente) {
      const ok = confirm(
        `Excluir orçamento de "${cliente}" permanentemente?\n\n` +
        `Esta ação NÃO PODE ser desfeita. Só funciona com orçamento em rascunho.`
      );
      if (!ok) return;
      try {
        const res = await fetch(`${QUOTE_ENDPOINT}/delete`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id }),
        });
        const data = await res.json();
        if (!data.ok) {
          alert(data.message || data.error || 'Falha ao excluir');
          return;
        }
        // Remove da lista local + re-renderiza (mais rápido que refetch)
        this.#quotes = this.#quotes.filter(q => q.id !== id);
        this.#updateCounts();
        this.#renderResults();
        this.#updateSummary();
      } catch (err) {
        alert('Erro: ' + err.message);
      }
    }

    #renderError(msg) {
      const resultsEl = this.querySelector('[data-tsf-admin-orcamentos-results]');
      if (resultsEl) {
        resultsEl.innerHTML = `<div class="tsf-admin-list-page__error">${this.#esc(msg)}</div>`;
      }
    }

    #esc(s) {
      return String(s ?? '').replace(/[&<>"']/g, c => ({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c]));
    }
  }

  /* ════════════════════════════════════════════════════════════════════
     ONDA 9 · PAYMENT PRESETS · ÚNICA fonte de verdade
     Movido pra escopo de módulo (em vez de fechado dentro do wizard) pra
     que TsfAdminVendaEditor + TsfSaleConversionWizard + futuros usem MESMA
     estrutura. Garantia de paridade total entre orçamento → venda → pedido.
     ════════════════════════════════════════════════════════════════════ */
  const PAYMENT_PRESETS_GLOBAL = [
    // PIX / Transferência (8% off em tudo)
    { key: 'pix_100',     group: 'PIX / Transferência', label: '100% à vista',          hint: 'Integral · 8% off em tudo', discount: 8 },
    { key: 'pix_70_30',   group: 'PIX / Transferência', label: 'Sinal 70% + saldo 30%', hint: '70% assinatura · 30% entrega · 8% off', discount: 8 },
    { key: 'pix_50_50',   group: 'PIX / Transferência', label: 'Sinal 50% + saldo 50%', hint: '50% assinatura · 50% entrega · 8% off', discount: 8 },
    // Cartão (sem desconto · permite parcelar)
    { key: 'cartao_100',  group: 'Cartão de crédito',   label: '100% no cartão',        hint: 'Integral no cartão · sem desconto',     requiresParcels: true },
    { key: 'cartao_70_30',group: 'Cartão de crédito',   label: 'Sinal 70% + saldo 30%', hint: '70% no cartão · 30% no cartão',          requiresParcels: true },
    { key: 'cartao_50_50',group: 'Cartão de crédito',   label: 'Sinal 50% + saldo 50%', hint: '50% no cartão · 50% no cartão',          requiresParcels: true },
    // Boleto (sem desconto)
    { key: 'boleto_15',   group: 'Boleto bancário',     label: '15 dias após NF',       hint: 'Vencimento 15 dias após emissão da nota' },
    { key: 'boleto_30',   group: 'Boleto bancário',     label: '30 dias após NF',       hint: 'Vencimento 30 dias após emissão da nota' },
    // Outro · acordo customizado (textarea obrigatório)
    { key: 'outro',       group: 'Outro · acordo customizado', label: 'Outro',          hint: 'Descreva detalhadamente abaixo',          requiresNotes: true },
  ];

  function findPaymentPreset(key) {
    return PAYMENT_PRESETS_GLOBAL.find(p => p.key === key) || null;
  }

  // Onda 9.2 · Meta visual por grupo (8% off, sem desconto, flexível)
  const PAYMENT_GROUP_META = {
    'PIX / Transferência':        { meta: '8% off em tudo',  accent: true,  special: false },
    'Cartão de crédito':          { meta: 'sem desconto',    accent: false, special: false },
    'Boleto bancário':            { meta: 'sem desconto',    accent: false, special: false },
    'Outro · acordo customizado': { meta: 'flexível',        accent: false, special: true  },
  };

  // Onda 9.2 · Render PREMIUM da seção inteira de pagamento (presets + parcelas + notes)
  // Substitui renderPaymentPresetsHtml + parcels + notes scattered. Uma única função
  // garantindo paridade visual exata entre wizard e editor de venda.
  function renderPaymentSection(state, opts = {}) {
    const {
      presetAttr = 'data-tsf-preset',
      parcelsAttr = 'data-tsf-parcels',
      notesAttr = 'data-tsf-notes',
      isLocked = false,
    } = opts;
    const esc = (s) => String(s ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
    const selectedKey = state.method || '';
    const selectedPreset = findPaymentPreset(selectedKey);

    // Agrupa presets preservando ordem do array
    const groups = new Map();
    for (const p of PAYMENT_PRESETS_GLOBAL) {
      if (!groups.has(p.group)) groups.set(p.group, []);
      groups.get(p.group).push(p);
    }

    let html = '<div class="tsf-payment-section">';

    // Grupos com presets
    for (const [groupName, presets] of groups) {
      const meta = PAYMENT_GROUP_META[groupName] || { meta: '', accent: false, special: false };
      html += `
        <div class="tsf-payment-group${meta.special ? ' tsf-payment-group--special' : ''}">
          <div class="tsf-payment-group__head">
            <span class="tsf-payment-group__name">${esc(groupName)}</span>
            ${meta.meta ? `<span class="tsf-payment-group__meta${meta.accent ? ' tsf-payment-group__meta--accent' : ''}">${esc(meta.meta)}</span>` : ''}
          </div>
          <div class="tsf-payment-group__options" role="radiogroup" aria-label="${esc(groupName)}">
            ${presets.map(p => `
              <button type="button" class="tsf-payment-option ${selectedKey === p.key ? 'is-selected' : ''}"
                      ${presetAttr}="${esc(p.key)}"
                      role="radio"
                      aria-checked="${selectedKey === p.key}"
                      ${isLocked ? 'disabled' : ''}>
                <span class="tsf-payment-option__radio" aria-hidden="true"></span>
                <span class="tsf-payment-option__body">
                  <span class="tsf-payment-option__label">${esc(p.label)}</span>
                  <span class="tsf-payment-option__hint">${esc(p.hint)}</span>
                </span>
              </button>
            `).join('')}
          </div>
        </div>
      `;
    }

    // Parcelas (só pra cartão) · stepper com botões +/-
    if (selectedPreset?.requiresParcels) {
      const parcels = Math.max(1, Math.min(12, parseInt(state.parcels, 10) || 3));
      html += `
        <div class="tsf-payment-extra">
          <span class="tsf-payment-extra__label">Parcelas no cartão</span>
          <div class="tsf-payment-extra__field">
            <button type="button" class="tsf-payment-extra__btn" data-tsf-parcels-step="-1" ${isLocked || parcels <= 1 ? 'disabled' : ''} aria-label="Diminuir parcelas">−</button>
            <input type="number" min="1" max="12" value="${parcels}" ${parcelsAttr} class="tsf-payment-extra__input" ${isLocked ? 'disabled' : ''} aria-label="Número de parcelas">
            <button type="button" class="tsf-payment-extra__btn" data-tsf-parcels-step="+1" ${isLocked || parcels >= 12 ? 'disabled' : ''} aria-label="Aumentar parcelas">+</button>
            <span class="tsf-payment-extra__suffix">vez${parcels > 1 ? 'es' : ''} no cartão</span>
          </div>
        </div>
      `;
    }

    // Notes (sempre · obrigatório quando preset.requiresNotes)
    const notesRequired = !!selectedPreset?.requiresNotes;
    html += `
      <div class="tsf-payment-notes${notesRequired ? ' tsf-payment-notes--required' : ''}">
        <label class="tsf-payment-notes__label">
          ${notesRequired ? 'Descreva o acordo *' : 'Observações sobre o pagamento'}
          ${!notesRequired ? '<em>(opcional)</em>' : ''}
        </label>
        <textarea rows="2" class="tsf-payment-notes__textarea" ${notesAttr} ${isLocked ? 'disabled' : ''}
                  placeholder="${notesRequired ? 'Ex: 30% PIX à vista + 70% cartão em 6x · descreva detalhadamente' : 'Detalhes adicionais sobre o pagamento, se houver'}">${esc(state.notes || '')}</textarea>
      </div>
    `;

    html += '</div>';
    return html;
  }

  // Wrapper legacy · ainda usado pelo wizard que constrói layout próprio
  // (Pra refator total, wizard pode chamar renderPaymentSection direto)
  function renderPaymentPresetsHtml(selectedKey, opts = {}) {
    return renderPaymentSection({ method: selectedKey, parcels: opts.parcels || 3, notes: opts.notes || '' }, {
      presetAttr: opts.dataAttr || 'data-tsf-preset',
      parcelsAttr: opts.parcelsAttr || 'data-tsf-wizard-payment-parcels',
      notesAttr: opts.notesAttr || 'data-tsf-wizard-payment-notes',
      isLocked: opts.isLocked || false,
    });
  }

  /* ════════════════════════════════════════════════════════════════════
     TSF-SALE-CONVERSION-WIZARD · modal pra converter quote em venda
     Garante que vendor confirma cliente + escolhe payment_terms antes
     de gravar a venda. Resolve a falha de "venda nasce incompleta".
     ════════════════════════════════════════════════════════════════════ */
  const TsfSaleConversionWizard = (() => {
    let modal = null;
    let state = null; // { quote, onConfirm }

    function ensureModal() {
      if (modal) return modal;
      modal = document.createElement('div');
      modal.className = 'tsf-conversion-wizard';
      modal.hidden = true;
      modal.setAttribute('role', 'dialog');
      modal.setAttribute('aria-modal', 'true');
      modal.innerHTML = `
        <div class="tsf-conversion-wizard__backdrop" data-tsf-wizard-backdrop></div>
        <div class="tsf-conversion-wizard__panel">
          <header class="tsf-conversion-wizard__head">
            <div>
              <span class="tsf-conversion-wizard__eyebrow">Converter em venda</span>
              <h2 class="tsf-conversion-wizard__title" data-tsf-wizard-title>Confirme antes de criar a venda</h2>
              <p class="tsf-conversion-wizard__lede" data-tsf-wizard-lede></p>
            </div>
            <button type="button" class="tsf-conversion-wizard__close" data-tsf-wizard-close aria-label="Fechar">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            </button>
          </header>
          <div class="tsf-conversion-wizard__body" data-tsf-wizard-body></div>
          <footer class="tsf-conversion-wizard__foot">
            <span class="tsf-conversion-wizard__foot-hint" data-tsf-wizard-confirm-hint hidden></span>
            <button type="button" class="tsf-conversion-wizard__btn-ghost" data-tsf-wizard-cancel>Cancelar</button>
            <button type="button" class="tsf-conversion-wizard__btn-primary" data-tsf-wizard-confirm>Criar venda</button>
          </footer>
        </div>
      `;
      document.body.appendChild(modal);
      modal.querySelector('[data-tsf-wizard-close]').addEventListener('click', close);
      modal.querySelector('[data-tsf-wizard-backdrop]').addEventListener('click', close);
      modal.querySelector('[data-tsf-wizard-cancel]').addEventListener('click', close);
      modal.querySelector('[data-tsf-wizard-confirm]').addEventListener('click', confirm);
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && !modal.hidden) close();
      });
      return modal;
    }

    // Onda 9 · alias pra constante de módulo (única fonte de verdade)
    const PAYMENT_PRESETS = PAYMENT_PRESETS_GLOBAL;

    // Onda 8.3 · Campos obrigatórios pra criar venda.
    // Cada item retorna { ok: bool, label: string } usado no checklist visual.
    function checkClientCompleteness(ci) {
      const a = tsfDeriveAddress(ci.address); // 2026-06-30 · aceita endereço combinado do checkout (deriva logradouro/numero do `rua`)
      // Documento É o tipo: aceita CPF (11 díg) OU CNPJ (14 díg). Não exige um específico via
      // ci.tipo (pode estar stale) — corrige o gate da conversão venda pedindo CNPJ em cliente com CPF.
      const cpfD = (ci.cpf || '').replace(/\D/g, '');
      const cnpjD = (ci.cnpj || '').replace(/\D/g, '');
      const docOk = cpfD.length === 11 || cnpjD.length === 14;
      const checks = [
        { key: 'name',       ok: !!(ci.name && ci.name.trim()),                      label: 'Nome do cliente' },
        { key: 'document',   ok: docOk,                                               label: 'CPF ou CNPJ' },
        // 2026-07-02 · e-mail OU WhatsApp (não exige os 2 · alinha com o cadastro). Cliente que só deu WhatsApp
        // fecha venda normal · Meta/Google casam por telefone. Antes exigia email → travava venda de quem só tem zap.
        { key: 'contato',    ok: !!(ci.email && /@/.test(ci.email)) || !!(ci.whatsapp && (ci.whatsapp || '').replace(/\D/g, '').length >= 10), label: 'E-mail ou WhatsApp' },
        { key: 'cep',        ok: !!(ci.cep && (ci.cep || '').replace(/\D/g, '').length === 8), label: 'CEP' },
        { key: 'logradouro', ok: !!(a.logradouro && a.logradouro.trim()),            label: 'Logradouro' },
        { key: 'numero',     ok: !!(a.numero && String(a.numero).trim()),            label: 'Número' },
        { key: 'bairro',     ok: !!(a.bairro && a.bairro.trim()),                    label: 'Bairro' },
        { key: 'cidade',     ok: !!((a.localidade || a.cidade) && (a.localidade || a.cidade).trim()), label: 'Cidade' },
        { key: 'uf',         ok: !!(a.uf && a.uf.length === 2),                      label: 'UF' },
      ];
      const missing = checks.filter(c => !c.ok);
      return { checks, missing, complete: missing.length === 0 };
    }

    function render() {
      const q = state.quote;
      const ci = q.client_info || {};
      const addr = tsfDeriveAddress(ci.address || {}); // 2026-06-30 · resumo mostra endereço derivado do `rua` combinado
      const esc = (s) => String(s ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
      const completeness = checkClientCompleteness(ci);

      const lede = modal.querySelector('[data-tsf-wizard-lede]');
      lede.textContent = completeness.complete
        ? `Cliente: ${ci.name} · Confirme abaixo a forma de pagamento.`
        : `Faltam ${completeness.missing.length} campo${completeness.missing.length > 1 ? 's' : ''} do cliente pra criar a venda.`;

      // Group presets by category
      const groups = {};
      for (const p of PAYMENT_PRESETS) {
        if (!groups[p.group]) groups[p.group] = [];
        groups[p.group].push(p);
      }

      // Selected preset (default null until user picks)
      const selected = state.selectedPreset || null;
      const selectedPreset = PAYMENT_PRESETS.find(p => p.key === selected) || null;

      const tipo = ((ci.cnpj || '').replace(/\D/g, '').length === 14) ? 'B2B' : 'B2C';

      const body = modal.querySelector('[data-tsf-wizard-body]');
      body.innerHTML = `
        <section class="tsf-conversion-wizard__section">
          <header class="tsf-conversion-wizard__section-head">
            <h3>1 · Cliente</h3>
            <span class="tsf-conversion-wizard__section-pill tsf-conversion-wizard__section-pill--${tipo.toLowerCase()}">${tipo}</span>
          </header>
          ${ci.name ? `
            <div class="tsf-conversion-wizard__client-summary">
              <strong>${esc(ci.name)}</strong>
              ${ci.cpf ? `<span>CPF ${esc(formatCpfHtml(ci.cpf))}</span>` : ''}
              ${ci.cnpj ? `<span>CNPJ ${esc(formatCnpjHtml(ci.cnpj))}</span>` : ''}
              ${ci.email ? `<span>${esc(ci.email)}</span>` : ''}
              ${ci.whatsapp ? `<span>${esc(formatPhoneHtml(ci.whatsapp))}</span>` : ''}
              ${addr.logradouro ? `<span class="tsf-conversion-wizard__client-summary-addr">
                ${esc(addr.logradouro)}${addr.numero ? ', ' + esc(addr.numero) : ''}
                ${addr.complemento ? ' · ' + esc(addr.complemento) : ''}
                ${addr.bairro ? ' · ' + esc(addr.bairro) : ''}
                ${addr.localidade || addr.cidade ? ' · ' + esc(addr.localidade || addr.cidade) + '/' + esc(addr.uf || '') : ''}
              </span>` : ''}
            </div>
          ` : ''}

          <div class="tsf-conversion-wizard__checklist">
            <span class="tsf-conversion-wizard__checklist-label">${completeness.complete ? 'Tudo certo' : 'Pendências'}</span>
            <ul class="tsf-conversion-wizard__checklist-items">
              ${completeness.checks.map(c => `
                <li class="tsf-conversion-wizard__checklist-item ${c.ok ? 'is-ok' : 'is-missing'}">
                  ${c.ok
                    ? `<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>`
                    : `<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>`
                  }
                  <span>${esc(c.label)}</span>
                </li>
              `).join('')}
            </ul>
          </div>

          ${!completeness.complete ? `
            <div class="tsf-conversion-wizard__client-actions">
              <button type="button" class="tsf-conversion-wizard__btn-link" data-tsf-wizard-back-to-quote>← Voltar pro orçamento pra completar</button>
              <button type="button" class="tsf-conversion-wizard__btn-link" data-tsf-wizard-change-client>Ou vincular cliente cadastrado</button>
            </div>
          ` : `
            <div class="tsf-conversion-wizard__client-actions">
              <button type="button" class="tsf-conversion-wizard__btn-link" data-tsf-wizard-change-client>Trocar cliente</button>
            </div>
          `}
        </section>

        <section class="tsf-conversion-wizard__section">
          <header class="tsf-conversion-wizard__section-head"><h3>2 · Forma de pagamento</h3></header>
          ${renderPaymentSection(
            { method: state.selectedPreset, parcels: state.parcels, notes: state.notes },
            {
              presetAttr: 'data-tsf-wizard-preset',
              parcelsAttr: 'data-tsf-wizard-payment-parcels',
              notesAttr: 'data-tsf-wizard-payment-notes',
              isLocked: false,
            }
          )}
        </section>
      `;

      // Wire-ups
      body.querySelectorAll('[data-tsf-wizard-preset]').forEach(btn => {
        btn.addEventListener('click', () => {
          state.selectedPreset = btn.getAttribute('data-tsf-wizard-preset');
          state.notes = body.querySelector('[data-tsf-wizard-payment-notes]')?.value || state.notes || '';
          state.parcels = parseInt(body.querySelector('[data-tsf-wizard-payment-parcels]')?.value, 10) || state.parcels || 3;
          render();
          updateConfirmButton();
        });
      });

      // Onda 9.2 · stepper +/- de parcelas no wizard
      body.querySelectorAll('[data-tsf-parcels-step]').forEach(btn => {
        btn.addEventListener('click', () => {
          const step = parseInt(btn.getAttribute('data-tsf-parcels-step'), 10) || 0;
          const current = parseInt(state.parcels, 10) || 3;
          const next = Math.max(1, Math.min(12, current + step));
          if (next !== current) {
            state.parcels = next;
            state.notes = body.querySelector('[data-tsf-wizard-payment-notes]')?.value || state.notes || '';
            render();
            updateConfirmButton();
          }
        });
      });

      body.querySelector('[data-tsf-wizard-change-client]')?.addEventListener('click', () => {
        TsfClientPicker.open({
          title: 'Vincular cliente à venda',
          subtitle: 'Busque um cadastro existente · ou cadastre direto no modal',
          specifierId: state.specifierId || state.customer_id || null,
          onSelect: (client) => {
            state.selectedClientId = client.id;
            const addr = client.endereco || {};
            state.quote.client_info = {
              ...state.quote.client_info,
              name: client.nome,
              // tipo derivado do documento (não confia em client.tipo, que pode estar stale)
              tipo: ((client.cnpj || '').replace(/\D/g, '').length === 14) ? 'b2b' : 'b2c',
              email: client.email,
              whatsapp: client.whatsapp,
              cpf: client.cpf,
              cnpj: client.cnpj,
              ie: client.ie,
              im: client.im,
              cep: addr.cep,
              address: {
                logradouro: addr.logradouro,
                numero: addr.numero,
                complemento: addr.complemento,
                bairro: addr.bairro,
                localidade: addr.cidade || addr.localidade,
                cidade: addr.cidade || addr.localidade,
                uf: addr.uf,
              },
            };
            render();
            updateConfirmButton();
          },
        });
      });

      body.querySelector('[data-tsf-wizard-back-to-quote]')?.addEventListener('click', () => {
        close();
      });

      // Onda 8.9b · revalida confirm button quando user digita observação ou parcelas
      // (antes só revalidava ao trocar preset · pagamento misto ficava travado)
      body.querySelector('[data-tsf-wizard-payment-notes]')?.addEventListener('input', () => {
        state.notes = body.querySelector('[data-tsf-wizard-payment-notes]').value;
        updateConfirmButton();
      });
      body.querySelector('[data-tsf-wizard-payment-parcels]')?.addEventListener('input', () => {
        state.parcels = parseInt(body.querySelector('[data-tsf-wizard-payment-parcels]').value, 10) || 3;
        updateConfirmButton();
      });

      updateConfirmButton();
    }

    // Onda 8.9b · feedback explícito de POR QUE está disabled
    // Antes só apagava silenciosamente · usuário não entendia o que faltava
    function updateConfirmButton() {
      const btn = modal.querySelector('[data-tsf-wizard-confirm]');
      const hint = modal.querySelector('[data-tsf-wizard-confirm-hint]');
      if (!btn) return;
      const ci = state.quote.client_info || {};
      const c = checkClientCompleteness(ci);
      const preset = PAYMENT_PRESETS.find(p => p.key === state.selectedPreset);
      const notes = modal.querySelector('[data-tsf-wizard-payment-notes]')?.value?.trim() || '';

      // Determina próximo bloqueio (uma coisa por vez · evita overwhelm)
      let blocker = null;
      if (!c.complete) blocker = `Faltam dados do cliente: ${c.missing.map(m => m.label).join(', ')}`;
      else if (!preset) blocker = 'Selecione uma forma de pagamento acima ↑';
      else if (preset.requiresNotes && !notes) blocker = 'Pagamento misto exige descrição na observação';

      btn.disabled = !!blocker;
      btn.textContent = 'Criar venda';
      btn.setAttribute('title', blocker || 'Cria a venda e te leva pra tela dela');

      if (hint) {
        hint.textContent = blocker || '';
        hint.hidden = !blocker;
      }
    }

    // Helpers de formatação (replicados pra wizard ser standalone)
    function formatCpfHtml(digits) {
      const d = (digits || '').replace(/\D/g, '').slice(0, 11);
      if (d.length !== 11) return d;
      return `${d.slice(0,3)}.${d.slice(3,6)}.${d.slice(6,9)}-${d.slice(9)}`;
    }
    function formatCnpjHtml(digits) {
      const d = (digits || '').replace(/\D/g, '').slice(0, 14);
      if (d.length !== 14) return d;
      return `${d.slice(0,2)}.${d.slice(2,5)}.${d.slice(5,8)}/${d.slice(8,12)}-${d.slice(12)}`;
    }
    function formatPhoneHtml(digits) {
      let d = (digits || '').replace(/\D/g, '');
      if ((d.length === 12 || d.length === 13) && d.startsWith('55')) d = d.slice(2); // tira DDI +55 → exibe local
      d = d.slice(0, 11);
      if (d.length < 10) return d;
      if (d.length === 10) return `(${d.slice(0,2)}) ${d.slice(2,6)}-${d.slice(6)}`;
      return `(${d.slice(0,2)}) ${d.slice(2,7)}-${d.slice(7)}`;
    }

    async function confirm() {
      const preset = PAYMENT_PRESETS.find(p => p.key === state.selectedPreset);
      if (!preset) {
        alert('Selecione uma forma de pagamento.');
        return;
      }

      const ci = state.quote.client_info || {};
      const c = checkClientCompleteness(ci);
      if (!c.complete) {
        alert('Faltam campos do cliente: ' + c.missing.map(m => m.label).join(', '));
        return;
      }

      const parcelsInput = modal.querySelector('[data-tsf-wizard-payment-parcels]');
      const parcels = preset.requiresParcels
        ? Math.max(2, Math.min(12, parseInt(parcelsInput?.value, 10) || 3))
        : 1;
      const notes = modal.querySelector('[data-tsf-wizard-payment-notes]')?.value?.trim() || null;
      if (preset.requiresNotes && !notes) {
        alert('Pagamento misto exige descrição na observação.');
        return;
      }

      // Onda 15D · usa customer_id (Shopify bigint) com fallback pra client_id legacy
      const payload = {
        quote_id: state.quote.id,
        customer_id: state.selectedClientId || state.quote.customer_id || null,
        client_id: state.quote.client_id || null,  // legacy UUID se ainda existir
        payment_terms: {
          method: preset.key,
          label: preset.label,
          group: preset.group,
          parcels,
          notes,
        },
      };

      const btn = modal.querySelector('[data-tsf-wizard-confirm]');
      btn.disabled = true;
      btn.textContent = 'Criando venda…';

      try {
        const res = await fetch(`${SALE_ENDPOINT}/create-from-quote`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        });
        const data = await res.json();
        if (!data.ok) {
          alert(data.message || data.error || 'Falha ao criar venda');
          btn.disabled = false;
          btn.textContent = 'Criar venda';
          return;
        }
        const cb = state.onConfirm;
        const sale = data.sale;
        close();
        if (cb) cb(sale);
      } catch (err) {
        alert('Erro: ' + err.message);
        btn.disabled = false;
        btn.textContent = 'Criar venda';
      }
    }

    function open(opts) {
      ensureModal();
      const ci0 = opts.quote.client_info || {};
      state = {
        quote: opts.quote,
        onConfirm: opts.onConfirm || null,
        // Onda 15D · prefere customer_id Shopify (bigint), fallback client_id legacy
        selectedClientId: opts.quote.customer_id || opts.quote.client_id || null,
        // 2026-06-30 · pré-seleciona o pagamento quando o orçamento já sabe (ex.: checkout pago via PIX → pix_100)
        selectedPreset: ci0.payment_preset || null,
        parcels: 3,              // default razoável quando cartão parcelado
        notes: '',
        // UX-FIX C · specifierId propaga pro picker (cadastro inline associa ao vendor logado)
        specifierId: opts.specifierId || opts.specifier_customer_id || opts.quote.specifier_customer_id || null,
      };
      modal.hidden = false;
      render();
      // 2026-06-30 · orçamento vindo do site: puxa CPF + forma de pagamento + endereço do PEDIDO PAGO
      // (o rascunho não tem esses dados · só o pedido após pagar). Servidor faz merge não-destrutivo →
      // a venda "bate" com o pedido. Silencioso se não houver pedido ainda / estiver offline.
      if (ci0.origem === 'checkout') enrichFromOrder();
    }

    async function enrichFromOrder() {
      const q = state && state.quote;
      if (!q) return;
      try {
        const res = await fetch(`${SALE_ENDPOINT}/enrich-from-order`, {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ quote_id: q.id }),
        });
        const data = await res.json();
        if (!state || state.quote !== q) return; // modal já fechou/trocou
        if (data && data.ok && data.client_info) {
          state.quote.client_info = data.client_info;
          if (!state.selectedPreset && data.client_info.payment_preset) state.selectedPreset = data.client_info.payment_preset;
          render();
        }
      } catch (_) { /* offline · segue com o que tem · vendedor completa na mão */ }
    }

    function close() {
      if (modal) modal.hidden = true;
      state = null;
    }

    return { open, close };
  })();

  /* ════════════════════════════════════════════════════════════════════
     TSF-SCOPE-TOGGLE · Helper compartilhado (admin lists)
     Renderiza tabs "Meus | Time interno | Specifica | Todos" antes dos filtros
     de status. Usado em admin-orcamentos, admin-vendas, admin-pedidos.
     ════════════════════════════════════════════════════════════════════ */
  function renderScopeToggleHtml(currentScope) {
    const opts = [
      { key: 'mine', label: 'Meus', svg: '<path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/>' },
      { key: 'team', label: 'Time interno', svg: '<path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>' },
      { key: 'specifica', label: 'Specifica', svg: '<path d="M12 2L2 7l10 5 10-5-10-5z"/><path d="M2 17l10 5 10-5"/><path d="M2 12l10 5 10-5"/>' },
      { key: 'all', label: 'Todos', svg: '<circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>' },
    ];
    return `
      <div class="tsf-admin-scope-toggle" role="tablist" aria-label="Visualização multi-tenant">
        ${opts.map(o => `
          <button type="button" class="tsf-admin-scope-toggle__btn ${currentScope===o.key?'is-active':''}" data-scope="${o.key}" role="tab" aria-selected="${currentScope===o.key}">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${o.svg}</svg>
            <span>${o.label}</span>
          </button>
        `).join('')}
      </div>
    `;
  }

  /* ════════════════════════════════════════════════════════════════════
     TSF-CLIENT-PICKER · modal compartilhado pra escolher cliente
     Usado em: Nova venda direta · Trocar cliente da venda · Pedido direto
     ════════════════════════════════════════════════════════════════════ */
  const CLIENT_ENDPOINT = 'https://pucrgwvcgagbapzvphao.supabase.co/functions/v1/toth-checkout/client';

  const TsfClientPicker = (() => {
    let modal = null;
    let onSelectCb = null;
    let searchTimer = null;
    let abortController = null;
    let currentMode = 'search'; // 'search' | 'create'
    let currentSpecifierId = null;

    function ensureModal() {
      if (modal) return modal;
      modal = document.createElement('div');
      modal.className = 'tsf-client-picker';
      modal.hidden = true;
      modal.setAttribute('role', 'dialog');
      modal.setAttribute('aria-modal', 'true');
      modal.setAttribute('aria-labelledby', 'tsf-client-picker-title');
      modal.innerHTML = `
        <div class="tsf-client-picker__backdrop" data-tsf-client-picker-backdrop></div>
        <div class="tsf-client-picker__panel">
          <header class="tsf-client-picker__head">
            <div class="tsf-client-picker__heading">
              <span class="tsf-client-picker__eyebrow" data-tsf-client-picker-eyebrow>Selecionar cliente</span>
              <h2 id="tsf-client-picker-title" class="tsf-client-picker__title" data-tsf-client-picker-title>Cliente</h2>
              <p class="tsf-client-picker__lede" data-tsf-client-picker-subtitle></p>
            </div>
            <button type="button" class="tsf-client-picker__close" data-tsf-client-picker-close aria-label="Fechar">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
              </svg>
            </button>
          </header>

          <div data-tsf-client-picker-body-search>
            <div class="tsf-client-picker__search">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" aria-hidden="true">
                <circle cx="11" cy="11" r="7"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
              </svg>
              <input type="search" class="tsf-client-picker__input" placeholder="Buscar por nome, CPF, CNPJ ou e-mail…" autocomplete="off" data-tsf-client-picker-search>
            </div>
            <div class="tsf-client-picker__results" data-tsf-client-picker-results>
              <div class="tsf-client-picker__loading">Carregando clientes…</div>
            </div>
          </div>

          <div data-tsf-client-picker-body-create hidden>
            <form class="tsf-client-picker__form" data-tsf-client-picker-create-form novalidate>
              <p class="tsf-client-picker__form-lede">Cadastro rápido · só nome + 1 forma de contato. O sistema completa o resto depois.</p>
              <div class="tsf-client-picker__form-grid">
                <label class="tsf-client-picker__field tsf-client-picker__field--full">
                  <span>Nome *</span>
                  <input type="text" name="nome" required autocomplete="name" placeholder="Ex.: Maria Silva">
                </label>
                <label class="tsf-client-picker__field">
                  <span>E-mail</span>
                  <input type="email" name="email" autocomplete="email" placeholder="cliente@email.com">
                </label>
                <label class="tsf-client-picker__field">
                  <span>WhatsApp</span>
                  <input type="tel" name="whatsapp" autocomplete="tel" placeholder="(11) 99999-9999">
                </label>
                <label class="tsf-client-picker__field">
                  <span>CPF ou CNPJ <em>(opcional)</em></span>
                  <input type="text" name="documento" placeholder="Pode preencher depois">
                </label>
                <label class="tsf-client-picker__field">
                  <span>Perfil</span>
                  <select name="tipo">
                    <option value="auto" selected>Detectar pelo e-mail</option>
                    <option value="b2c">B2C · Consumidor final</option>
                    <option value="b2b-arquitetura">B2B · Arquiteto / Designer</option>
                    <option value="b2b-construcao">B2B · Construtora</option>
                    <option value="b2b-hospitalidade">B2B · Hotel / Restaurante</option>
                  </select>
                </label>
              </div>
              <p class="tsf-client-picker__form-msg" data-tsf-client-picker-create-msg></p>
              <div class="tsf-client-picker__form-actions">
                <button type="button" class="tsf-client-picker__form-btn" data-tsf-client-picker-create-cancel>← Voltar pra busca</button>
                <button type="submit" class="tsf-client-picker__form-btn tsf-client-picker__form-btn--primary" data-tsf-client-picker-create-submit>
                  <span data-tsf-client-picker-create-submit-label>Cadastrar e vincular</span>
                </button>
              </div>
            </form>
          </div>

          <footer class="tsf-client-picker__foot">
            <button type="button" class="tsf-client-picker__cta" data-tsf-client-picker-toggle-create>
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
              </svg>
              <span data-tsf-client-picker-toggle-label>Cadastrar novo cliente</span>
            </button>
          </footer>
        </div>
      `;
      document.body.appendChild(modal);

      modal.querySelector('[data-tsf-client-picker-close]').addEventListener('click', close);
      modal.querySelector('[data-tsf-client-picker-backdrop]').addEventListener('click', close);
      modal.querySelector('[data-tsf-client-picker-search]').addEventListener('input', onSearch);
      modal.querySelector('[data-tsf-client-picker-toggle-create]').addEventListener('click', () => {
        if (currentMode === 'search') switchToCreate();
        else switchToSearch();
      });
      modal.querySelector('[data-tsf-client-picker-create-cancel]').addEventListener('click', switchToSearch);
      modal.querySelector('[data-tsf-client-picker-create-form]').addEventListener('submit', onCreateSubmit);

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && !modal.hidden) close();
      });
      return modal;
    }

    function switchToCreate() {
      currentMode = 'create';
      modal.querySelector('[data-tsf-client-picker-body-search]').hidden = true;
      modal.querySelector('[data-tsf-client-picker-body-create]').hidden = false;
      modal.querySelector('[data-tsf-client-picker-toggle-label]').textContent = '← Voltar pra busca';
      // Prefill: se o usuário digitou algo, usa como nome
      const searchInput = modal.querySelector('[data-tsf-client-picker-search]');
      const nameInput = modal.querySelector('input[name="nome"]');
      if (searchInput?.value?.trim() && !nameInput.value) {
        // Detecta se parece email vs nome
        const q = searchInput.value.trim();
        if (q.includes('@')) {
          modal.querySelector('input[name="email"]').value = q;
        } else if (/^\d/.test(q)) {
          modal.querySelector('input[name="documento"]').value = q;
        } else {
          nameInput.value = q;
        }
      }
      setTimeout(() => nameInput.focus(), 50);
    }

    function switchToSearch() {
      currentMode = 'search';
      modal.querySelector('[data-tsf-client-picker-body-search]').hidden = false;
      modal.querySelector('[data-tsf-client-picker-body-create]').hidden = true;
      modal.querySelector('[data-tsf-client-picker-toggle-label]').textContent = 'Cadastrar novo cliente';
      modal.querySelector('[data-tsf-client-picker-create-msg]').textContent = '';
      setTimeout(() => modal.querySelector('[data-tsf-client-picker-search]').focus(), 50);
    }

    async function onCreateSubmit(ev) {
      ev.preventDefault();
      const form = ev.currentTarget;
      const fd = new FormData(form);
      const nome = String(fd.get('nome') || '').trim();
      const email = String(fd.get('email') || '').trim();
      const whatsapp = String(fd.get('whatsapp') || '').trim();
      const documentoRaw = String(fd.get('documento') || '').trim();
      const tipoInput = String(fd.get('tipo') || 'auto').trim();
      const msg = modal.querySelector('[data-tsf-client-picker-create-msg]');
      const submitBtn = modal.querySelector('[data-tsf-client-picker-create-submit]');
      const submitLabel = modal.querySelector('[data-tsf-client-picker-create-submit-label]');

      if (!nome) {
        msg.textContent = 'Nome é obrigatório.';
        msg.style.color = '#B53E2F';
        return;
      }
      if (!email && !whatsapp && !documentoRaw) {
        msg.textContent = 'Informe pelo menos e-mail, WhatsApp ou documento.';
        msg.style.color = '#B53E2F';
        return;
      }

      const docDigits = documentoRaw.replace(/\D/g, '');
      const cpf = docDigits.length >= 11 && docDigits.length < 12 ? docDigits : '';
      const cnpj = docDigits.length >= 12 ? docDigits : '';
      let tipo = '';
      if (tipoInput !== 'auto') tipo = tipoInput;
      else if (cnpj) tipo = 'b2b-arquitetura';

      const payload = { nome, email: email || undefined, whatsapp: whatsapp || undefined };
      if (cpf) payload.cpf = cpf;
      if (cnpj) payload.cnpj = cnpj;
      if (tipo) payload.tipo = tipo;
      if (currentSpecifierId) payload.specifier_customer_id = currentSpecifierId;

      submitBtn.disabled = true;
      submitLabel.textContent = 'Cadastrando…';
      msg.textContent = '';

      try {
        const res = await fetch(`${CLIENT_ENDPOINT}/upsert`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json; charset=utf-8' },
          body: JSON.stringify(payload),
        });
        const result = await res.json();
        if (!result.ok || !result.client?.id) {
          throw new Error(result.error || 'falha ao criar');
        }
        // Sucesso · seleciona automaticamente
        selectClient(result.client);
      } catch (err) {
        submitBtn.disabled = false;
        submitLabel.textContent = 'Cadastrar e vincular';
        msg.textContent = 'Erro: ' + (err?.message || 'falha');
        msg.style.color = '#B53E2F';
      }
    }

    async function loadClients(query = '') {
      if (abortController) abortController.abort();
      abortController = new AbortController();
      try {
        const params = new URLSearchParams();
        if (query) params.set('q', query);
        const res = await fetch(`${CLIENT_ENDPOINT}/list?${params.toString()}`, { signal: abortController.signal });
        const data = await res.json();
        if (!data.ok) throw new Error(data.error || 'falha');
        renderResults(data.clients || []);
      } catch (err) {
        if (err.name === 'AbortError') return;
        const resultsEl = modal.querySelector('[data-tsf-client-picker-results]');
        resultsEl.innerHTML = `<div class="tsf-client-picker__error">Erro: ${err.message}</div>`;
      }
    }

    function renderResults(clients) {
      const resultsEl = modal.querySelector('[data-tsf-client-picker-results]');
      if (clients.length === 0) {
        resultsEl.innerHTML = `<div class="tsf-client-picker__empty">
          <p style="margin:0 0 12px;color:var(--tsf-admin-ink-mute,#6e6a63);font-size:13px;">Nenhum cliente encontrado pra essa busca.</p>
          <button type="button" class="tsf-client-picker__empty-cta" data-tsf-client-picker-empty-create>
            Cadastrar este cliente agora →
          </button>
        </div>`;
        resultsEl.querySelector('[data-tsf-client-picker-empty-create]')?.addEventListener('click', switchToCreate);
        return;
      }
      const esc = (s) => String(s ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
      resultsEl.innerHTML = `<ol class="tsf-client-picker__list">${
        clients.map(c => {
          const tipo = c.tipo || 'b2c';
          const tipoBadge = tipo === 'b2c-interno' ? '<span class="tsf-client-picker__badge tsf-client-picker__badge--internal">INTERNO</span>' :
            tipo.startsWith('b2b') ? `<span class="tsf-client-picker__badge tsf-client-picker__badge--b2b">${esc(tipo.replace('b2b-','').toUpperCase())}</span>` :
            '<span class="tsf-client-picker__badge">B2C</span>';
          const doc = c.cpf ? `CPF ${esc(c.cpf)}` : c.cnpj ? `CNPJ ${esc(c.cnpj)}` : '';
          const cidade = c.endereco?.cidade || c.endereco?.localidade || '';
          return `
            <li class="tsf-client-picker__item" data-client-id="${esc(c.id)}">
              <div class="tsf-client-picker__item-main">
                <div class="tsf-client-picker__item-name">${esc(c.nome)} ${tipoBadge}</div>
                <div class="tsf-client-picker__item-meta">${doc}${cidade ? ' · ' + esc(cidade) : ''}${c.email ? ' · ' + esc(c.email) : ''}</div>
              </div>
              <svg class="tsf-client-picker__item-arrow" width="14" height="10" viewBox="0 0 14 10" fill="none" aria-hidden="true"><path fill="currentColor" d="M8.537.808a.5.5 0 0 1 .817-.162l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 1 1-.708-.708L11.793 5.5H1a.5.5 0 0 1 0-1h10.793L8.646 1.354a.5.5 0 0 1-.109-.546Z"/></svg>
            </li>
          `;
        }).join('')
      }</ol>`;
      resultsEl.querySelectorAll('.tsf-client-picker__item').forEach(item => {
        item.addEventListener('click', () => {
          const id = item.getAttribute('data-client-id');
          // 2026-06-29 · FIX: data-client-id é STRING; c.id é NÚMERO (bigint Shopify) → `===` dava sempre false
          //   e o clique não selecionava ninguém. Coerção pra string resolve (robusto a número ou string).
          const client = clients.find(c => String(c.id) === id);
          if (client) selectClient(client);
        });
      });
    }

    function onSearch(e) {
      const query = e.target.value.trim();
      clearTimeout(searchTimer);
      searchTimer = setTimeout(() => loadClients(query), 250);
    }

    function selectClient(client) {
      const cb = onSelectCb;
      close();
      if (cb) cb(client);
    }

    function open(opts = {}) {
      ensureModal();
      onSelectCb = opts.onSelect || null;
      currentSpecifierId = opts.specifierId || opts.specifier_customer_id || null;
      if (opts.title) modal.querySelector('[data-tsf-client-picker-title]').textContent = opts.title;
      if (opts.subtitle) modal.querySelector('[data-tsf-client-picker-subtitle]').textContent = opts.subtitle;
      if (opts.eyebrow) modal.querySelector('[data-tsf-client-picker-eyebrow]').textContent = opts.eyebrow;
      modal.hidden = false;
      // Reset estado · sempre abre em modo busca
      switchToSearch();
      const input = modal.querySelector('[data-tsf-client-picker-search]');
      input.value = '';
      // Limpa form de create
      modal.querySelector('[data-tsf-client-picker-create-form]')?.reset();
      modal.querySelector('[data-tsf-client-picker-create-msg]').textContent = '';
      const submitBtn = modal.querySelector('[data-tsf-client-picker-create-submit]');
      const submitLabel = modal.querySelector('[data-tsf-client-picker-create-submit-label]');
      if (submitBtn) submitBtn.disabled = false;
      if (submitLabel) submitLabel.textContent = 'Cadastrar e vincular';
      setTimeout(() => input.focus(), 100);
      loadClients('');
    }

    function close() {
      if (modal) modal.hidden = true;
      onSelectCb = null;
      if (abortController) abortController.abort();
    }

    return { open, close };
  })();

  /* ════════════════════════════════════════════════════════════════════
     TSF-INLINE-CLIENT · combobox embedded em venda/orçamento (UNIFIED-1)
     Padrão ERP Pipedrive/HubSpot · search + create inline · sem modal
     ────────────────────────────────────────────────────────────────────
     Estados:
       'empty'    → search box com dropdown autocomplete
       'creating' → mini-form inline (nome + email + whatsapp + doc + tipo)
       'linked'   → client info card com [Trocar] [Editar 360°]
     Eventos disparados:
       'tsf:client-linked' → detail.client = {id, nome, email, ...}
       'tsf:client-cleared'
     Props (data-attributes):
       data-specifier-id    → vendor logged-in (pra atribuir specifier_customer_id)
       data-client          → JSON do cliente já vinculado (opcional)
     ════════════════════════════════════════════════════════════════════ */
  class TsfInlineClient extends HTMLElement {
    #abortController = null;
    #searchAbort = null;
    #searchTimer = null;
    #state = 'empty';            // 'empty' | 'creating' | 'linked'
    #client = null;
    #specifierId = null;
    #lastSearchQuery = '';

    static get observedAttributes() { return ['data-client']; }

    connectedCallback() {
      this.#abortController = new AbortController();
      this.#specifierId = this.getAttribute('data-specifier-id') || null;
      const clientRaw = this.getAttribute('data-client');
      if (clientRaw) {
        try { this.#client = JSON.parse(clientRaw); this.#state = 'linked'; } catch {}
      }
      this.classList.add('tsf-inline-client');
      this.#render();
    }

    disconnectedCallback() {
      this.#abortController?.abort();
      this.#searchAbort?.abort();
      clearTimeout(this.#searchTimer);
    }

    attributeChangedCallback(name, oldVal, newVal) {
      if (name === 'data-client' && newVal !== oldVal) {
        if (newVal) {
          try { this.#client = JSON.parse(newVal); this.#state = 'linked'; }
          catch { this.#client = null; this.#state = 'empty'; }
        } else {
          this.#client = null;
          this.#state = 'empty';
        }
        this.#render();
      }
    }

    // Public API · parent pode chamar
    setClient(client) {
      this.#client = client;
      this.#state = client ? 'linked' : 'empty';
      this.#render();
    }
    clearClient() {
      this.#client = null;
      this.#state = 'empty';
      this.#render();
      this.dispatchEvent(new CustomEvent('tsf:client-cleared', { bubbles: true }));
    }

    #esc(s) {
      return String(s ?? '').replace(/[&<>"']/g, c => ({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c]));
    }

    #render() {
      this.dataset.state = this.#state;
      if (this.#state === 'linked') this.#renderLinked();
      else if (this.#state === 'creating') this.#renderCreating();
      else this.#renderEmpty();
    }

    // ───────── EMPTY: combobox search ─────────
    #renderEmpty() {
      this.innerHTML = `
        <p class="tsf-inline-client__intro" style="margin:0 0 9px;font-size:12px;color:rgba(26,25,24,0.55);">Selecione um cliente já cadastrado <strong style="font-weight:600;">ou</strong> cadastre um novo.</p>
        <div class="tsf-inline-client__search-wrap">
          <span class="tsf-inline-client__icon" aria-hidden="true">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
          </span>
          <input type="search"
                 class="tsf-inline-client__input"
                 placeholder="Buscar cliente por nome, CPF, CNPJ ou e-mail…"
                 autocomplete="off"
                 data-tsf-ic-search
                 value="${this.#esc(this.#lastSearchQuery)}">
        </div>
        <div class="tsf-inline-client__dropdown" data-tsf-ic-dropdown hidden></div>
        <button type="button" class="tsf-inline-client__create-cta" data-tsf-ic-create-cta>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true">
            <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
          </svg>
          <span>Cadastrar cliente novo</span>
        </button>
      `;
      const input = this.querySelector('[data-tsf-ic-search]');
      const dropdown = this.querySelector('[data-tsf-ic-dropdown]');
      const createCta = this.querySelector('[data-tsf-ic-create-cta]');

      input.addEventListener('input', (e) => {
        const q = e.target.value.trim();
        this.#lastSearchQuery = q;
        clearTimeout(this.#searchTimer);
        if (q.length < 2) {
          dropdown.hidden = true;
          return;
        }
        this.#searchTimer = setTimeout(() => this.#search(q, dropdown), 220);
      }, { signal: this.#abortController.signal });

      input.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') { dropdown.hidden = true; input.blur(); }
        if (e.key === 'Enter' && this.#lastSearchQuery && dropdown.hidden) {
          // Enter sem dropdown aberto: vai pra criar com nome prefilled
          this.#switchToCreating(this.#lastSearchQuery);
        }
      }, { signal: this.#abortController.signal });

      input.addEventListener('blur', () => {
        // Delay pra permitir clique em items
        setTimeout(() => { if (dropdown && !this.matches(':hover')) dropdown.hidden = true; }, 180);
      }, { signal: this.#abortController.signal });

      createCta.addEventListener('click', () => {
        this.#switchToCreating(this.#lastSearchQuery);
      }, { signal: this.#abortController.signal });
    }

    async #search(q, dropdown) {
      this.#searchAbort?.abort();
      this.#searchAbort = new AbortController();
      dropdown.hidden = false;
      dropdown.innerHTML = `<div class="tsf-inline-client__loading">Buscando…</div>`;
      try {
        const params = new URLSearchParams({ q });
        const res = await fetch(`${CLIENT_ENDPOINT}/list?${params}`, { signal: this.#searchAbort.signal });
        const data = await res.json();
        const clients = (data.clients || []).slice(0, 6);
        this.#renderResults(dropdown, clients, q);
      } catch (err) {
        if (err.name === 'AbortError') return;
        dropdown.innerHTML = `<div class="tsf-inline-client__error">Erro na busca: ${this.#esc(err.message || '')}</div>`;
      }
    }

    #renderResults(dropdown, clients, q) {
      const isEmail = q.includes('@');
      const isDoc = /^\d/.test(q);
      const createLabel = isEmail ? `Cadastrar com e-mail "${this.#esc(q)}"` :
                          isDoc ? `Cadastrar com documento "${this.#esc(q)}"` :
                          `Cadastrar "${this.#esc(q)}" como novo cliente`;

      let html = '';
      if (clients.length === 0) {
        html = `<div class="tsf-inline-client__no-results">Nenhum cadastrado encontrado.</div>`;
      } else {
        html = `<ol class="tsf-inline-client__results" role="listbox">${clients.map(c => {
          const tipo = c.tipo || 'b2c';
          const tipoBadge = tipo === 'b2c-interno' ? 'INTERNO' :
                            tipo.startsWith('b2b') ? tipo.replace('b2b-','').toUpperCase() : 'B2C';
          const doc = c.cpf ? `CPF ${this.#esc(c.cpf)}` : c.cnpj ? `CNPJ ${this.#esc(c.cnpj)}` : '';
          const sub = [doc, c.email].filter(Boolean).join(' · ');
          return `
            <li class="tsf-inline-client__result" data-tsf-ic-result data-client-id="${this.#esc(c.id)}" role="option" tabindex="0">
              <span class="tsf-inline-client__result-badge">${this.#esc(tipoBadge)}</span>
              <div class="tsf-inline-client__result-body">
                <div class="tsf-inline-client__result-name">${this.#esc(c.nome || '—')}</div>
                ${sub ? `<div class="tsf-inline-client__result-meta">${sub}</div>` : ''}
              </div>
              <svg class="tsf-inline-client__result-arrow" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="9 18 15 12 9 6"/></svg>
            </li>
          `;
        }).join('')}</ol>`;
      }
      html += `
        <button type="button" class="tsf-inline-client__create-row" data-tsf-ic-create-from-search>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
          <span>${createLabel}</span>
        </button>
      `;
      dropdown.innerHTML = html;

      dropdown.querySelectorAll('[data-tsf-ic-result]').forEach(li => {
        const handler = () => {
          const id = li.getAttribute('data-client-id');
          const client = clients.find(c => String(c.id) === String(id));
          if (client) this.#linkClient(client);
        };
        li.addEventListener('click', handler, { signal: this.#abortController.signal });
        li.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handler(); }
        }, { signal: this.#abortController.signal });
      });

      dropdown.querySelector('[data-tsf-ic-create-from-search]')?.addEventListener('click', () => {
        this.#switchToCreating(q);
      }, { signal: this.#abortController.signal });
    }

    // ───────── CREATING: inline form ─────────
    #switchToCreating(prefill = '') {
      this.#state = 'creating';
      this.#lastSearchQuery = prefill || '';
      this.#render();
    }

    // AUDIT-5 · Máscaras automáticas BR (CPF/CNPJ/Phone/CEP)
    #maskDoc(v) {
      const d = String(v).replace(/\D/g, '').slice(0, 14);
      if (d.length <= 11) {
        return d.replace(/^(\d{3})(\d)/, '$1.$2').replace(/^(\d{3})\.(\d{3})(\d)/, '$1.$2.$3').replace(/\.(\d{3})(\d)/, '.$1-$2');
      }
      return d.replace(/^(\d{2})(\d)/, '$1.$2').replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3').replace(/\.(\d{3})(\d)/, '.$1/$2').replace(/(\d{4})(\d)/, '$1-$2');
    }
    #maskPhone(v) {
      let d = String(v).replace(/\D/g, '');
      if ((d.length === 12 || d.length === 13) && d.startsWith('55')) d = d.slice(2); // tira DDI +55 → exibe local
      d = d.slice(0, 11);
      if (d.length <= 10) return d.replace(/^(\d{2})(\d)/, '($1) $2').replace(/(\d{4})(\d)/, '$1-$2');
      return d.replace(/^(\d{2})(\d)/, '($1) $2').replace(/(\d{5})(\d)/, '$1-$2');
    }
    #maskCep(v) {
      return String(v).replace(/\D/g, '').slice(0, 8).replace(/^(\d{5})(\d)/, '$1-$2');
    }

    #renderCreating() {
      const q = this.#lastSearchQuery || '';
      const isEmail = q.includes('@');
      const isDoc = /^\d/.test(q);
      const prefillName = (!isEmail && !isDoc) ? q : '';
      const prefillEmail = isEmail ? q : '';
      const prefillDoc = isDoc ? this.#maskDoc(q) : '';
      this.innerHTML = `
        <form class="tsf-inline-client__form" data-tsf-ic-form novalidate>
          <header class="tsf-inline-client__form-head">
            <span class="tsf-inline-client__form-eyebrow">Cadastro rápido</span>
            <h3 class="tsf-inline-client__form-title">Novo cliente</h3>
          </header>
          <div class="tsf-inline-client__form-grid">
            <label class="tsf-inline-client__field tsf-inline-client__field--full">
              <span>Nome / Razão social *</span>
              <input type="text" name="nome" required autocomplete="name"
                     value="${this.#esc(prefillName)}"
                     placeholder="Ex.: Maria Silva ou Atelier Arquitetura Ltda" autofocus>
            </label>
            <label class="tsf-inline-client__field">
              <span>E-mail</span>
              <input type="email" name="email" autocomplete="email"
                     value="${this.#esc(prefillEmail)}"
                     placeholder="cliente@email.com">
            </label>
            <label class="tsf-inline-client__field">
              <span>WhatsApp / Telefone</span>
              <input type="tel" name="whatsapp" autocomplete="tel"
                     placeholder="(11) 99999-9999"
                     data-tsf-ic-mask="phone">
            </label>
            <label class="tsf-inline-client__field">
              <span>CPF ou CNPJ <em>(detecta automático)</em></span>
              <input type="text" name="documento"
                     value="${this.#esc(prefillDoc)}"
                     placeholder="000.000.000-00 ou 00.000.000/0000-00"
                     inputmode="numeric"
                     data-tsf-ic-mask="doc">
            </label>
            <label class="tsf-inline-client__field">
              <span>Perfil</span>
              <select name="tipo">
                <option value="auto" selected>Detectar pelo e-mail</option>
                <option value="b2c">B2C · Consumidor final</option>
                <option value="b2b-arquitetura">B2B · Arquiteto / Designer</option>
                <option value="b2b-construcao">B2B · Construtora / Engenharia</option>
                <option value="b2b-hospitalidade">B2B · Hotel / Restaurante / Spa</option>
              </select>
            </label>
            <label class="tsf-inline-client__field tsf-inline-client__field--full">
              <span>CEP de entrega <em>(opcional · usado pra calcular frete · auto-completa endereço)</em></span>
              <div style="display:grid;grid-template-columns:140px 1fr;gap:10px;align-items:start;">
                <input type="text" name="cep" autocomplete="postal-code"
                       placeholder="00000-000"
                       inputmode="numeric"
                       data-tsf-ic-mask="cep"
                       data-tsf-ic-cep>
                <output class="tsf-inline-client__cep-status" data-tsf-ic-cep-status style="font-size:11px;color:var(--tsf-admin-ink-mute,#6e6a63);line-height:1.4;padding-top:10px;"></output>
              </div>
            </label>
          </div>
          <p class="tsf-inline-client__form-msg" data-tsf-ic-form-msg></p>
          <div class="tsf-inline-client__form-actions">
            <button type="button" class="tsf-inline-client__btn" data-tsf-ic-form-cancel>← Voltar pra busca</button>
            <button type="submit" class="tsf-inline-client__btn tsf-inline-client__btn--primary" data-tsf-ic-form-submit>
              <span data-tsf-ic-form-submit-label>Cadastrar e vincular</span>
            </button>
          </div>
        </form>
      `;
      const form = this.querySelector('[data-tsf-ic-form]');
      const msg = this.querySelector('[data-tsf-ic-form-msg]');
      const submitBtn = this.querySelector('[data-tsf-ic-form-submit]');
      const submitLabel = this.querySelector('[data-tsf-ic-form-submit-label]');
      const cancelBtn = this.querySelector('[data-tsf-ic-form-cancel]');

      // AUDIT-5 · Aplica máscaras enquanto usuário digita
      const maskMap = { phone: (v) => this.#maskPhone(v), doc: (v) => this.#maskDoc(v), cep: (v) => this.#maskCep(v) };
      form.querySelectorAll('[data-tsf-ic-mask]').forEach((inp) => {
        const fn = maskMap[inp.getAttribute('data-tsf-ic-mask')];
        if (!fn) return;
        inp.addEventListener('input', (e) => { e.target.value = fn(e.target.value); }, { signal: this.#abortController.signal });
      });

      // AUDIT-3 · CEP auto-fill via ViaCEP API · busca quando user completa 8 dígitos
      const cepInput = form.querySelector('[data-tsf-ic-cep]');
      const cepStatus = form.querySelector('[data-tsf-ic-cep-status]');
      let viaCepCache = {};
      cepInput?.addEventListener('blur', async () => {
        const digits = String(cepInput.value).replace(/\D/g, '');
        if (digits.length !== 8) { cepStatus.textContent = digits.length > 0 ? 'CEP incompleto' : ''; cepStatus.style.color = digits.length > 0 ? '#B53E2F' : ''; return; }
        if (viaCepCache[digits]) {
          const c = viaCepCache[digits];
          cepStatus.textContent = `${c.logradouro || ''}${c.bairro ? ' · ' + c.bairro : ''}${c.localidade ? ' · ' + c.localidade : ''}${c.uf ? '/' + c.uf : ''}`;
          cepStatus.style.color = '';
          return;
        }
        cepStatus.textContent = 'Consultando ViaCEP…';
        cepStatus.style.color = '';
        try {
          const r = await fetch(`https://viacep.com.br/ws/${digits}/json/`);
          const j = await r.json();
          if (j.erro) { cepStatus.textContent = 'CEP não encontrado'; cepStatus.style.color = '#B53E2F'; return; }
          viaCepCache[digits] = j;
          cepStatus.textContent = `${j.logradouro || ''}${j.bairro ? ' · ' + j.bairro : ''}${j.localidade ? ' · ' + j.localidade : ''}${j.uf ? '/' + j.uf : ''}`;
          cepStatus.style.color = 'var(--tsf-admin-accent,#3F4D3A)';
        } catch (err) {
          cepStatus.textContent = 'Falha ao consultar CEP';
          cepStatus.style.color = '#B53E2F';
        }
      }, { signal: this.#abortController.signal });

      cancelBtn.addEventListener('click', () => {
        this.#state = 'empty';
        this.#render();
      }, { signal: this.#abortController.signal });

      form.addEventListener('submit', async (ev) => {
        ev.preventDefault();
        const fd = new FormData(form);
        const nome = String(fd.get('nome') || '').trim();
        const email = String(fd.get('email') || '').trim();
        const whatsapp = String(fd.get('whatsapp') || '').trim();
        const documentoRaw = String(fd.get('documento') || '').trim();
        const tipoInput = String(fd.get('tipo') || 'auto').trim();
        const cepRaw = String(fd.get('cep') || '').trim();
        const cepDigits = cepRaw.replace(/\D/g, '');
        if (!nome) {
          msg.textContent = 'Nome é obrigatório.';
          msg.dataset.tone = 'error';
          return;
        }
        if (!email && !whatsapp && !documentoRaw) {
          msg.textContent = 'Informe pelo menos e-mail, WhatsApp ou documento.';
          msg.dataset.tone = 'error';
          return;
        }
        const docDigits = documentoRaw.replace(/\D/g, '');
        const cpf = docDigits.length >= 11 && docDigits.length < 12 ? docDigits : '';
        const cnpj = docDigits.length >= 12 ? docDigits : '';
        let tipo = '';
        if (tipoInput !== 'auto') tipo = tipoInput;
        else if (cnpj) tipo = 'b2b-arquitetura';
        const payload = { nome };
        if (email) payload.email = email;
        if (whatsapp) payload.whatsapp = whatsapp;
        if (cpf) payload.cpf = cpf;
        if (cnpj) payload.cnpj = cnpj;
        if (tipo) payload.tipo = tipo;
        // AUDIT-3 · CEP estruturado + endereco_fiscal (se ViaCEP retornou)
        if (cepDigits.length === 8) {
          payload.cep = cepDigits;
          const cached = viaCepCache[cepDigits];
          if (cached) {
            payload.endereco = {
              cep: cepDigits,
              logradouro: cached.logradouro || '',
              bairro: cached.bairro || '',
              cidade: cached.localidade || '',
              localidade: cached.localidade || '',
              uf: cached.uf || '',
              pais: 'BR',
            };
          }
        }
        if (this.#specifierId) payload.specifier_customer_id = this.#specifierId;

        submitBtn.disabled = true;
        submitLabel.textContent = 'Cadastrando…';
        msg.textContent = '';

        try {
          const res = await fetch(`${CLIENT_ENDPOINT}/upsert`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json; charset=utf-8' },
            body: JSON.stringify(payload),
            signal: this.#abortController.signal,
          });
          const result = await res.json();
          if (!result.ok || !result.client?.id) throw new Error(result.error || 'Falha ao cadastrar');
          this.#linkClient(result.client);
        } catch (err) {
          submitBtn.disabled = false;
          submitLabel.textContent = 'Cadastrar e vincular';
          msg.textContent = 'Erro: ' + (err?.message || 'falha');
          msg.dataset.tone = 'error';
        }
      }, { signal: this.#abortController.signal });
    }

    // ───────── LINKED: client card ─────────
    // QA CLI-2 · formatação BR pro card do cliente vinculado (CPF/CNPJ/telefone)
    #icFmtDoc(c) {
      const cpf = (c.cpf || '').replace(/\D/g, '');
      const cnpj = (c.cnpj || '').replace(/\D/g, '');
      if (cnpj.length === 14) return `CNPJ ${cnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5')}`;
      if (cpf.length === 11) return `CPF ${cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')}`;
      if (cnpj) return `CNPJ ${this.#esc(cnpj)}`;
      if (cpf) return `CPF ${this.#esc(cpf)}`;
      return '';
    }
    #icFmtPhone(raw) {
      let d = (raw || '').replace(/\D/g, '');
      if ((d.length === 13 || d.length === 12) && d.startsWith('55')) d = d.slice(2); // tira DDI +55
      if (d.length === 11) return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`;
      if (d.length === 10) return `(${d.slice(0, 2)}) ${d.slice(2, 6)}-${d.slice(6)}`;
      return raw || '';
    }
    #renderLinked() {
      const c = this.#client || {};
      const tipo = c.tipo || 'b2c';
      const isB2B = tipo.startsWith('b2b');
      const tipoLabel = tipo === 'b2c-interno' ? 'Interno' :
                        isB2B ? `B2B · ${tipo.replace('b2b-','').replace(/-/g,' ')}` : 'B2C';
      const doc = this.#icFmtDoc(c);
      const initials = (c.nome || '?').split(/\s+/).slice(0,2).map(w => w[0]).join('').toUpperCase();
      this.innerHTML = `
        <div class="tsf-inline-client__card">
          <div class="tsf-inline-client__card-head">
            <div class="tsf-inline-client__avatar" data-tipo="${isB2B ? 'b2b' : 'b2c'}">${this.#esc(initials)}</div>
            <div class="tsf-inline-client__card-info">
              <span class="tsf-inline-client__card-tipo">${this.#esc(tipoLabel)}</span>
              <h3 class="tsf-inline-client__card-name">${this.#esc(c.nome || 'Sem nome')}</h3>
              ${doc ? `<p class="tsf-inline-client__card-doc">${doc}</p>` : ''}
            </div>
          </div>
          <dl class="tsf-inline-client__card-fields">
            ${c.email ? `<div><dt>E-mail</dt><dd>${this.#esc(c.email)}</dd></div>` : ''}
            ${c.whatsapp ? `<div><dt>WhatsApp</dt><dd>${this.#esc(this.#icFmtPhone(c.whatsapp))}</dd></div>` : ''}
          </dl>
          <div class="tsf-inline-client__card-actions">
            <button type="button" class="tsf-inline-client__btn" data-tsf-ic-change>Trocar cliente</button>
            <a class="tsf-inline-client__btn tsf-inline-client__btn--primary" href="/pages/admin-cliente?id=${this.#esc(c.id)}">Editar cadastro 360° →</a>
          </div>
        </div>
      `;
      this.querySelector('[data-tsf-ic-change]')?.addEventListener('click', () => {
        // Padronização (2026-06-24) · "Trocar cliente" abre o MESMO modal da venda (TsfClientPicker)
        // em vez de limpar pra busca inline → UX idêntica nas duas páginas. onSelect reusa #linkClient.
        if (typeof TsfClientPicker !== 'undefined' && TsfClientPicker?.open) {
          TsfClientPicker.open({
            title: 'Trocar cliente',
            subtitle: 'Busque um cadastro · ou cadastre direto no modal sem sair daqui',
            specifierId: this.#specifierId || null,
            onSelect: (client) => this.#linkClient(client),
          });
        } else {
          this.clearClient();
        }
      }, { signal: this.#abortController.signal });
    }

    // ───────── Helper · liga cliente e emite evento ─────────
    #linkClient(client) {
      this.#client = client;
      this.#state = 'linked';
      this.#render();
      this.dispatchEvent(new CustomEvent('tsf:client-linked', {
        detail: { client },
        bubbles: true,
      }));
    }
  }

  /* ════════════════════════════════════════════════════════════════════
     TSF-ADMIN-VENDAS · lista de vendas com filtros + cards
     Fetch /sale/list · cards mostram pedidos gerados pra fábrica
     ════════════════════════════════════════════════════════════════════ */
  const SALE_ENDPOINT = 'https://pucrgwvcgagbapzvphao.supabase.co/functions/v1/toth-checkout/sale';

  const SALE_STATUS_LABELS = {
    rascunho: { label: 'Rascunho', cls: 'tsf-admin-sale-card__status--draft' },
    confirmada: { label: 'Confirmada', cls: 'tsf-admin-sale-card__status--sent' },
    em_producao: { label: 'Em produção', cls: 'tsf-admin-sale-card__status--production' },
    entregue: { label: 'Entregue', cls: 'tsf-admin-sale-card__status--delivered' },
    cancelada: { label: 'Cancelada', cls: 'tsf-admin-sale-card__status--cancelled' },
  };

  class TsfAdminVendas extends HTMLElement {
    #customerId = null;
    #sales = [];
    #statusFilter = 'all';
    #scope = 'all'; // default 'all' · admin vê panorama completo igual orçamentos
    #periodFilter = '30d'; // Fase 3.C · default: mês atual
    #abortController = null;

    // UI-FIX 2 (refactored) · usa helper TsfPeriodFilter compartilhado
    #dateRange() { return TsfPeriodFilter.dateRange(this.#periodFilter); }
    #periodLabel() { return TsfPeriodFilter.periodLabel(this.#periodFilter); }

    // Fase 3.C · Data efetiva pra filtragem temporal (preferir confirmed_at, fallback created_at)
    #effectiveDate(sale) {
      const raw = sale.confirmed_at || sale.created_at;
      return raw ? new Date(raw) : null;
    }

    async connectedCallback() {
      this.#abortController = new AbortController();
      this.#customerId = this.getAttribute('data-customer-id');
      if (!this.#customerId) {
        this.#renderError('Customer ID ausente · faça login novamente.');
        return;
      }

      this.querySelectorAll('[data-filter]').forEach(btn => {
        btn.addEventListener('click', () => this.#onFilterChange(btn), { signal: this.#abortController.signal });
      });

      // URL params · scope inicial
      const urlParams = new URLSearchParams(window.location.search);
      const urlScope = urlParams.get('scope');
      if (['mine','team','specifica','all'].includes(urlScope)) this.#scope = urlScope;

      // URL: read period (suporta 'today','month','7d','30d','12m','all','month-YYYY-MM')
      const urlPeriod = urlParams.get('period');
      if (urlPeriod && TsfPeriodFilter.isValidPeriod(urlPeriod)) {
        this.#periodFilter = urlPeriod;
      }

      // Injetar scope toggle + period toggle ANTES dos filtros de status
      const filtersNav = this.querySelector('[data-tsf-admin-vendas-filters]');
      if (filtersNav) {
        const wrap = document.createElement('div');
        wrap.innerHTML = renderScopeToggleHtml(this.#scope);
        filtersNav.parentElement?.insertBefore(wrap.firstElementChild, filtersNav);
        // UI-FIX 2 · period toggle (helper compartilhado · botão MÊS com dropdown integrado)
        const periodWrap = document.createElement('div');
        periodWrap.innerHTML = TsfPeriodFilter.renderToggle(this.#periodFilter);
        filtersNav.parentElement?.insertBefore(periodWrap.firstElementChild, filtersNav);
        // Anexa listeners ao toggle (click muda + fecha menu, click fora fecha)
        TsfPeriodFilter.attachListeners(
          this,
          () => this.#periodFilter,
          (newPeriod) => this.#onPeriodChange(newPeriod),
          this.#abortController.signal,
        );
      }

      // UI-FIX 4 · Botão "Nova venda direta" agora abre página completa direto
      // (sem modal). Cliente é preenchido inline no editor da venda.
      document.querySelector('[data-tsf-admin-vendas-new]')?.addEventListener('click', () => {
        this.#createDirectSale(null);
      }, { signal: this.#abortController.signal });

      // Delegação · botão excluir/cancelar + scope toggle
      this.addEventListener('click', (e) => {
        const delBtn = e.target.closest?.('[data-tsf-admin-delete-venda]');
        if (delBtn) {
          e.preventDefault();
          e.stopPropagation();
          this.#onCardDelete(delBtn.getAttribute('data-tsf-admin-delete-venda'), delBtn.getAttribute('data-numero'));
          return;
        }
        const cancelBtn = e.target.closest?.('[data-tsf-admin-cancel-venda]');
        if (cancelBtn) {
          e.preventDefault();
          e.stopPropagation();
          this.#onCardCancel(cancelBtn.getAttribute('data-tsf-admin-cancel-venda'), cancelBtn.getAttribute('data-numero'));
          return;
        }
        const scopeBtn = e.target.closest?.('[data-scope]');
        if (scopeBtn) {
          e.preventDefault();
          this.#onScopeChange(scopeBtn.getAttribute('data-scope'));
          return;
        }
        // UI-FIX 2 · listeners de [data-period] e [data-tsf-month-toggle] são
        // injetados via TsfPeriodFilter.attachListeners (acima, no setup do toggle)
      }, { signal: this.#abortController.signal });

      const urlStatus = new URLSearchParams(window.location.search).get('status');
      if (['all','rascunho','confirmada','em_producao','entregue','cancelada'].includes(urlStatus)) {
        this.#statusFilter = urlStatus;
        this.#syncFilterUI();
      }

      await this.#fetch();
    }

    async #createDirectSale(client) {
      try {
        const ctx = (typeof CUSTOMER !== 'undefined' && CUSTOMER) ? CUSTOMER : { id: this.#customerId };
        // UI-FIX 3 · client=null = "criar sem cliente, preencher depois no editor"
        const payload = {
          specifier_customer_id: this.#customerId,
          specifier_email: ctx.email || null,
          customer_id: client ? client.id : null,
          allow_empty_client: !client,
        };
        const res = await fetch(`${SALE_ENDPOINT}/create-direct`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        });
        const data = await res.json();
        if (!data.ok) throw new Error(data.error || 'falha ao criar venda');
        const sale = data.sale;
        // UI-FIX 4 · vai direto pro editor; vendor preenche cliente inline.
        window.location.href = `/pages/admin-venda?id=${encodeURIComponent(sale.id)}`;
      } catch (err) {
        alert('Erro ao criar venda: ' + err.message);
      }
    }

    disconnectedCallback() {
      this.#abortController?.abort();
    }

    async #fetch() {
      try {
        const params = new URLSearchParams();
        if (this.#scope === 'mine') {
          params.set('specifier_customer_id', this.#customerId);
        } else {
          params.set('scope', this.#scope);
          params.set('specifier_customer_id', this.#customerId);
        }
        const res = await fetch(`${SALE_ENDPOINT}/list?${params.toString()}`, {
          signal: this.#abortController.signal,
        });
        const data = await res.json();
        if (!data.ok) throw new Error(data.error || 'falha');
        this.#sales = data.sales || [];
      } catch (err) {
        this.#renderError('Falha ao carregar vendas: ' + err.message);
        return;
      }
      this.#updateCounts();
      this.#renderResults();
      this.#updateSummary();
    }

    async #onScopeChange(scope) {
      if (!['mine','team','specifica','all'].includes(scope)) return;
      this.#scope = scope;
      this.querySelectorAll('[data-scope]').forEach(b => {
        const isActive = b.getAttribute('data-scope') === scope;
        b.classList.toggle('is-active', isActive);
        b.setAttribute('aria-selected', String(isActive));
      });
      try {
        const url = new URL(window.location.href);
        if (scope !== 'all') url.searchParams.set('scope', scope);
        else url.searchParams.delete('scope');
        window.history.replaceState({}, '', url.toString());
      } catch {}
      await this.#fetch();
    }

    #updateCounts() {
      // Fase 3.C · contagens refletem período filtrado (mas não status, pra cada botão mostrar seu count)
      const [start, end] = this.#dateRange();
      const inPeriod = (s) => {
        if (!start || !end) return true;
        const d = this.#effectiveDate(s);
        return d && d >= start && d < end;
      };
      const filteredByPeriod = this.#sales.filter(inPeriod);
      const setCount = (key, val) => {
        const el = this.querySelector(`[data-tsf-admin-vendas-count="${key}"]`);
        if (el) el.textContent = val;
      };
      setCount('all', filteredByPeriod.length);
      setCount('rascunho', filteredByPeriod.filter(s => s.status === 'rascunho').length);
      setCount('confirmada', filteredByPeriod.filter(s => s.status === 'confirmada').length);
      setCount('em_producao', filteredByPeriod.filter(s => s.status === 'em_producao').length);
      setCount('entregue', filteredByPeriod.filter(s => s.status === 'entregue').length);
      setCount('cancelada', filteredByPeriod.filter(s => s.status === 'cancelada').length);
    }

    #updateSummary() {
      const summaryEl = document.querySelector('[data-tsf-admin-vendas-summary]');
      if (!summaryEl) return;
      // Fase 3.C · summary reflete filtros aplicados (período + status)
      const filtered = this.#applyFilter();
      const total = filtered.length;
      const pedidosTotal = filtered.reduce((acc, s) => acc + (s.pedidos_count?.total || 0), 0);
      const valorTotal = filtered.reduce((acc, s) => acc + this.#computeSaleTotal(s), 0);
      const periodLabel = this.#periodLabel();
      if (total === 0) {
        summaryEl.textContent = `Nenhuma venda ${periodLabel} · troque o período ou crie nova venda`;
      } else {
        const suffix = periodLabel ? ` ${periodLabel}` : '';
        summaryEl.textContent = `${total} venda${total>1?'s':''}${suffix} · ${pedidosTotal} pedido${pedidosTotal!==1?'s':''} pra fábrica · ${money(valorTotal)}`;
      }
    }

    #onFilterChange(btn) {
      this.#statusFilter = btn.getAttribute('data-filter');
      this.#syncFilterUI();
      this.#renderResults();
      try {
        const url = new URL(window.location.href);
        if (this.#statusFilter !== 'all') url.searchParams.set('status', this.#statusFilter);
        else url.searchParams.delete('status');
        window.history.replaceState({}, '', url.toString());
      } catch {}
    }

    #syncFilterUI() {
      this.querySelectorAll('[data-filter]').forEach(b => {
        const isActive = b.getAttribute('data-filter') === this.#statusFilter;
        b.classList.toggle('is-active', isActive);
        b.setAttribute('aria-selected', String(isActive));
      });
    }

    #applyFilter() {
      // Fase 3.C · aplica status + período em conjunto
      const [start, end] = this.#dateRange();
      return this.#sales.filter(s => {
        if (this.#statusFilter !== 'all' && s.status !== this.#statusFilter) return false;
        if (start && end) {
          const d = this.#effectiveDate(s);
          if (!d || d < start || d >= end) return false;
        }
        return true;
      });
    }

    #onPeriodChange(period) {
      this.#periodFilter = period;
      TsfPeriodFilter.syncActiveState(this, period);
      this.#renderResults();
      this.#updateSummary();
      this.#updateCounts();
      try {
        const url = new URL(window.location.href);
        if (period !== 'month') url.searchParams.set('period', period);
        else url.searchParams.delete('period');
        window.history.replaceState({}, '', url.toString());
      } catch {}
    }

    #computeQuoteNumber(saleId, quoteId) {
      // numero_venda compartilha sufixo com TOTH-ORC (deterministic)
      // formato: TOTH-VND-AAAA-NNNN → reaproveita pra resolver ORC
      return null; // o numero_venda já tem o sufixo · ORC reconstrói usando quote.id se necessário
    }

    #timeAgo(date) {
      const seconds = Math.floor((Date.now() - date.getTime()) / 1000);
      if (seconds < 60) return 'agora';
      const minutes = Math.floor(seconds / 60);
      if (minutes < 60) return `${minutes} min`;
      const hours = Math.floor(minutes / 60);
      if (hours < 24) return `${hours}h`;
      const days = Math.floor(hours / 24);
      if (days < 30) return `${days}d`;
      const months = Math.floor(days / 30);
      return `${months} mês${months > 1 ? 'es' : ''}`;
    }

    #computeSaleTotal(sale) {
      // total_centavos persistido (Conta Azul / back-end) tem prioridade; senão
      // recalcula AO VIVO pela fórmula única (markup manda) → bate com o editor.
      if (sale.total_centavos && sale.total_centavos > 0) return sale.total_centavos;
      return tsfDocTotalCentavos(sale);
    }

    #renderResults() {
      const resultsEl = this.querySelector('[data-tsf-admin-vendas-results]');
      if (!resultsEl) return;
      const filtered = this.#applyFilter();
      if (filtered.length === 0) {
        const isFiltered = this.#statusFilter !== 'all';
        resultsEl.innerHTML = `
          <div class="tsf-admin-list-page__empty">
            <svg width="56" height="56" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="0.8" aria-hidden="true">
              <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/>
            </svg>
            <h3>${isFiltered ? `Nenhuma venda com status "${this.#statusFilter}"` : 'Nenhuma venda ainda'}</h3>
            <p>${isFiltered ? 'Tente outro filtro ou converta um orçamento em venda.' : 'Quando um cliente fecha o orçamento, converta em venda pra registrar o compromisso comercial.'}</p>
            ${!isFiltered ? `<a href="/pages/admin-orcamentos" class="tsf-admin-list-page__empty-cta">Ver orçamentos →</a>` : ''}
          </div>
        `;
        return;
      }
      resultsEl.innerHTML = `<ol class="tsf-admin-vendas-grid">${filtered.map(s => this.#cardHtml(s)).join('')}</ol>`;
    }

    #cardHtml(s) {
      const items = Array.isArray(s.items) ? s.items : [];
      const total = this.#computeSaleTotal(s);
      const updatedAt = s.updated_at ? new Date(s.updated_at) : null;
      const ago = updatedAt ? this.#timeAgo(updatedAt) : '—';
      // Fase 3.C · data real da venda (preferir confirmed_at, fallback created_at)
      const saleDate = this.#effectiveDate(s);
      const saleDateStr = saleDate
        ? saleDate.toLocaleDateString('pt-BR', { day: '2-digit', month: 'short', year: 'numeric' })
        : '—';
      const isHistorical = (s.tsf_conversion_dispatch_log?.source === 'historical_import_conta_azul');
      const pedidos = s.pedidos_count || { total: 0, draft: 0, sent: 0, confirmed: 0 };
      const ci = s.client_info || {};
      const clientName = ci.name || 'Cliente sem nome';
      const clientCity = ci.address?.localidade || ci.address?.cidade || ci.endereco?.cidade || '';
      const statusInfo = SALE_STATUS_LABELS[s.status] || SALE_STATUS_LABELS.rascunho;

      const pedidosBadge = pedidos.total > 0
        ? `<div class="tsf-admin-sale-card__pedidos">
             <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><line x1="16.5" y1="9.4" x2="7.5" y2="4.21"/><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/></svg>
             <strong>${pedidos.total}</strong> pedido${pedidos.total>1?'s':''} pra fábrica
             ${pedidos.draft > 0 ? `<span class="tsf-admin-sale-card__pedidos-pill">${pedidos.draft} rasc.</span>` : ''}
             ${pedidos.sent > 0 ? `<span class="tsf-admin-sale-card__pedidos-pill tsf-admin-sale-card__pedidos-pill--sent">${pedidos.sent} env.</span>` : ''}
             ${pedidos.confirmed > 0 ? `<span class="tsf-admin-sale-card__pedidos-pill tsf-admin-sale-card__pedidos-pill--confirmed">${pedidos.confirmed} conf.</span>` : ''}
           </div>`
        : `<div class="tsf-admin-sale-card__pedidos tsf-admin-sale-card__pedidos--empty">
             <span>Nenhum pedido gerado ainda</span>
           </div>`;

      // Onda 6.12 · permite hard delete em rascunho OU cancelada (status finais)
      const canDelete = ['rascunho', 'cancelada'].includes(s.status);
      const canCancel = !['rascunho','cancelada'].includes(s.status);
      return `
        <li class="tsf-admin-sale-card${isHistorical ? ' tsf-admin-sale-card--historical' : ''}" data-sale-status="${this.#esc(s.status)}">
          <a class="tsf-admin-sale-card__link" href="/pages/admin-venda?id=${this.#esc(s.id)}">
            <header class="tsf-admin-sale-card__head">
              <div class="tsf-admin-sale-card__id-row">
                <span class="tsf-admin-sale-card__number">${this.#esc(s.numero_venda)}</span>
                <span class="tsf-admin-sale-card__date" title="Data da venda">${saleDateStr}</span>
              </div>
              <span class="tsf-admin-sale-card__status ${statusInfo.cls}">${statusInfo.label}</span>
            </header>
            <h3 class="tsf-admin-sale-card__client">${this.#esc(clientName)}</h3>
            ${clientCity ? `<div class="tsf-admin-sale-card__city">${this.#esc(clientCity)}</div>` : ''}
            <div class="tsf-admin-sale-card__meta">
              ${items.length} ${items.length === 1 ? 'item' : 'items'}${isHistorical ? ' · Conta Azul' : ''}
            </div>
            <div class="tsf-admin-sale-card__value">${money(total)}</div>
            ${pedidosBadge}
            ${tsfDispatchSignalHtml(s.tsf_conversion_dispatch_log)}
          </a>
          <footer class="tsf-admin-card-footer">
            <span class="tsf-admin-card-footer__meta">${s.specifier_email ? 'Por ' + this.#esc(s.specifier_email) + ' · ' : ''}${isHistorical ? `Vendido em ${saleDateStr}` : `Editado ${ago}`}</span>
            <div class="tsf-admin-card-footer__actions">
              ${canDelete ? `
                <button type="button" class="tsf-admin-card-footer__delete" data-tsf-admin-delete-venda="${this.#esc(s.id)}" data-numero="${this.#esc(s.numero_venda)}" title="Excluir venda permanentemente" aria-label="Excluir venda">
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                    <polyline points="3 6 5 6 21 6"/><path d="M19 6l-2 14a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2L5 6"/><path d="M10 11l0 6"/><path d="M14 11l0 6"/><path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>
                  </svg>
                </button>
              ` : ''}
              ${canCancel ? `
                <button type="button" class="tsf-admin-card-footer__cancel" data-tsf-admin-cancel-venda="${this.#esc(s.id)}" data-numero="${this.#esc(s.numero_venda)}" title="Cancelar venda (preserva histórico)" aria-label="Cancelar venda">
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                    <circle cx="12" cy="12" r="10"/><line x1="4.93" y1="4.93" x2="19.07" y2="19.07"/>
                  </svg>
                </button>
              ` : ''}
              <a href="/pages/admin-venda?id=${this.#esc(s.id)}" class="tsf-admin-card-footer__cta">Abrir →</a>
            </div>
          </footer>
        </li>
      `;
    }

    async #onCardCancel(id, numero) {
      const ok = confirm(`Cancelar venda ${numero}?\n\nStatus passa pra 'cancelada'. Histórico preservado.`);
      if (!ok) return;
      try {
        const res = await fetch(`${SALE_ENDPOINT}/cancel`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id }),
        });
        const data = await res.json();
        if (!data.ok) { alert(data.error || 'Falha'); return; }
        // Re-fetch pra atualizar status na lista
        await this.#fetch();
      } catch (err) {
        alert('Erro: ' + err.message);
      }
    }

    async #onCardDelete(id, numero) {
      const ok = confirm(`Excluir venda ${numero} permanentemente?\n\nEsta ação NÃO PODE ser desfeita. Só funciona com venda em rascunho.`);
      if (!ok) return;
      try {
        const res = await fetch(`${SALE_ENDPOINT}/delete`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id }),
        });
        const data = await res.json();
        if (!data.ok) {
          alert(data.message || data.error || 'Falha');
          return;
        }
        this.#sales = this.#sales.filter(s => s.id !== id);
        this.#updateCounts();
        this.#renderResults();
        this.#updateSummary();
      } catch (err) {
        alert('Erro: ' + err.message);
      }
    }

    #renderError(msg) {
      const resultsEl = this.querySelector('[data-tsf-admin-vendas-results]');
      if (resultsEl) {
        resultsEl.innerHTML = `<div class="tsf-admin-list-page__error">${this.#esc(msg)}</div>`;
      }
    }

    #esc(s) {
      return String(s ?? '').replace(/[&<>"']/g, c => ({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c]));
    }
  }

  /* ════════════════════════════════════════════════════════════════════
     TSF-ADMIN-VENDA-EDITOR · editor de venda específica
     Read /sale/get?id=X, mostra detalhes, permite confirm/cancel/gerar pedidos
     ════════════════════════════════════════════════════════════════════ */
  class TsfAdminVendaEditor extends HTMLElement {
    #saleId = null;
    #sale = null;
    #quote = null;       // Onda 10 · quote de origem (pra mostrar contexto + frete)
    #pedidos = [];       // Onda 10 · pedidos vinculados a essa venda
    #abortController = null;
    #saveTimer = null;
    #pendingPatch = null;
    #editMode = false;   // Onda 10 · default read-only · clica "Editar" pra ativar
    #authorityContent = null; // Onda 12.1 · cache do conteúdo de autoridade (lazy-fetched via /quote/authority)

    async connectedCallback() {
      this.#abortController = new AbortController();
      const urlParams = new URLSearchParams(window.location.search);
      this.#saleId = urlParams.get('id');
      if (!this.#saleId) {
        this.#renderError('ID da venda ausente na URL.');
        return;
      }
      await this.#fetch();
      // Onda 10 · busca paralela de quote-origem + pedidos vinculados (best-effort)
      if (this.#sale) {
        // Onda 12.3 · Sempre prefetch autoridade · mostra counts ("5 logos", "1 depoimento")
        // e status "Conteúdo curado pronto" desde o load, antes do user selecionar nada.
        this.#prefetchAuthorityMeta(); // não awaited · fire-and-forget
        await Promise.allSettled([
          this.#fetchQuoteOrigem(),
          this.#fetchPedidos(),
          this.#backfillMissingCosts(), // Onda 10.9 · backfill cost_centavos pra items antigos
        ]);
      }
      this.#bindHeaderActions();
      this.#bindEditEvents();
      this.#render();

      // UI-FIX 4 · Se venda recém-criada não tem cliente, ativa editMode automático
      // pra vendor preencher tudo inline sem ter que clicar "Editar".
      if (this.#sale && !this.#sale.customer_id && !this.#sale.client_info?.name) {
        this.#editMode = true;
        this.#render();
      }
    }

    // Onda 10.9 · Backfill automático · items adicionados antes do Edge Function v51
    // (que não retornava cost_centavos) ficavam sem dado nativo de custo. Aqui detectamos
    // esses items e refazemos product-snapshot pra completar · uma única vez por load.
    async #backfillMissingCosts() {
      if (!this.#sale?.items?.length) return;
      const itemsMissingCost = this.#sale.items.filter(it => {
        const snap = it.snapshot || {};
        const hasHandle = !!(snap.handle || it.product_handle);
        const missingCost = typeof snap.cost_centavos !== 'number' || snap.cost_centavos <= 0;
        return hasHandle && missingCost;
      });
      if (!itemsMissingCost.length) return;
      try {
        const results = await Promise.allSettled(
          itemsMissingCost.map(it => {
            const handle = it.snapshot?.handle || it.product_handle;
            return fetch(`${QUOTE_ENDPOINT}/product-snapshot?handle=${encodeURIComponent(handle)}`, {
              signal: this.#abortController.signal,
            }).then(r => r.json()).then(d => ({ uid: it.uid, data: d }));
          })
        );
        let updated = false;
        for (const r of results) {
          if (r.status !== 'fulfilled' || !r.value?.data?.ok) continue;
          const { uid, data } = r.value;
          const fresh = data.item?.snapshot;
          if (typeof fresh?.cost_centavos !== 'number' || fresh.cost_centavos <= 0) continue;
          const item = this.#sale.items.find(x => x.uid === uid);
          if (!item) continue;
          // Merge SÓ o cost_centavos · preserva overrides + edições manuais do vendor
          item.snapshot = { ...(item.snapshot || {}), cost_centavos: fresh.cost_centavos };
          updated = true;
        }
        if (updated) {
          // Salva silenciosamente · sem trigger no save status (não é edição do user)
          await fetch(`${SALE_ENDPOINT}/update`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: this.#saleId, patch: { items: this.#sale.items } }),
          }).catch(() => {});
        }
      } catch (err) {
        // Backfill é best-effort · não bloqueia render se falhar
        if (err.name !== 'AbortError') console.warn('[venda] backfill cost failed', err);
      }
    }

    async #fetchQuoteOrigem() {
      if (!this.#sale?.quote_id) return;
      try {
        const res = await fetch(`${QUOTE_ENDPOINT}/get?id=${encodeURIComponent(this.#sale.quote_id)}`, { signal: this.#abortController.signal });
        const data = await res.json();
        if (data.ok) this.#quote = data.quote;
      } catch {}
    }

    async #fetchPedidos() {
      try {
        const res = await fetch(`${PEDIDO_ENDPOINT}/mine?scope=all&specifier_customer_id=${this.#sale?.specifier_customer_id || 0}`, {
          signal: this.#abortController.signal,
        });
        const data = await res.json();
        if (data.ok) {
          this.#pedidos = (data.pedidos || []).filter(p => p.sale_id === this.#sale.id);
        }
      } catch {}
    }

    // Onda 6.11C · Verifica se status permite edição
    #isEditable() {
      if (!this.#sale) return false;
      return ['rascunho', 'confirmada'].includes(this.#sale.status);
    }

    // 2026-06-28 · SAVE MANUAL (paridade c/ o orçamento · Onda 8.5). #scheduleSave SÓ acumula + marca
    // "dirty"; o user clica "Salvar". Ações que precisam de dado fresco (confirmar/pedidos/cancelar/pdf)
    // fazem #flushSave() antes. Guarda beforeunload em #bindHeaderActions.
    #scheduleSave(patch) {
      const base = this.#pendingPatch || {};
      const merged = { ...base, ...patch };
      if (patch.client_info && base.client_info) {
        merged.client_info = { ...base.client_info, ...patch.client_info };
        if (patch.client_info.address && base.client_info.address) merged.client_info.address = { ...base.client_info.address, ...patch.client_info.address };
        if (patch.client_info.endereco_fiscal && base.client_info.endereco_fiscal) merged.client_info.endereco_fiscal = { ...base.client_info.endereco_fiscal, ...patch.client_info.endereco_fiscal };
      }
      this.#pendingPatch = merged;
      this.#updateSaveStatus('dirty');
    }

    #countPendingChanges() {
      const p = this.#pendingPatch;
      if (!p) return 0;
      let n = 0;
      for (const k of Object.keys(p)) {
        if (k === 'client_info' && p.client_info) {
          n += Object.keys(p.client_info).filter(kk => kk !== 'address' && kk !== 'endereco_fiscal').length;
          if (p.client_info.address) n += Object.keys(p.client_info.address).length;
          if (p.client_info.endereco_fiscal) n += Object.keys(p.client_info.endereco_fiscal).length;
        } else n++;
      }
      return n;
    }

    async #commitSave() {
      if (this.#countPendingChanges() === 0) return;
      await this.#flushSave();
    }

    async #discardChanges() {
      const n = this.#countPendingChanges();
      if (n === 0) return;
      if (!confirm(`Descartar ${n} alteração${n > 1 ? 'ões' : ''} não salvas? Isso recarrega a venda do servidor.`)) return;
      this.#pendingPatch = null;
      await this.#fetch();
      this.#render();
      this.#updateSaveStatus('idle');
    }

    async #flushSave() {
      const patch = this.#pendingPatch;
      if (!patch) return;
      this.#pendingPatch = null;
      this.#updateSaveStatus('saving');
      try {
        const res = await fetch(`${SALE_ENDPOINT}/update`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: this.#saleId, patch }),
        });
        const data = await res.json();
        if (!data.ok) throw new Error(data.error || 'falha');
        this.#sale = data.sale;
        this.#updateSaveStatus('saved');
      } catch (err) {
        console.error('[venda] save failed', err);
        this.#updateSaveStatus('error');
      }
    }

    // 2026-06-28 · status manual (espelha TsfQuoteBuilder#updateSaveStatus): dirty count + habilita Salvar/Descartar
    #updateSaveStatus(state) {
      // 2026-06-29 · delega pro MESMO selo de status compartilhado do orçamento (de-dup)
      return tsfRenderSaveStatus(state, this.#countPendingChanges(), {
        statusSel: '[data-tsf-admin-venda-save-status]', saveSel: '[data-tsf-admin-venda-save]', discardSel: '[data-tsf-admin-venda-discard]',
        labelSel: '[data-tsf-admin-venda-save-label]', countSel: '[data-tsf-admin-venda-save-count]' });
    }

    #bindEditEvents() {
      const { signal } = this.#abortController;

      // UNIFIED-3 · Listener pro <tsf-inline-client> que vive na seção Cliente vazia
      // Quando usuário busca/cria cliente inline, vincula direto sem modal
      this.addEventListener('tsf:client-linked', (ev) => {
        const client = ev.detail?.client;
        if (!client?.id) return;
        // Onda 15D · customer_id (bigint Shopify) é o ID estrutural
        this.#sale.customer_id = client.id;
        this.#sale.customer_snapshot = client;
        // 2026-06-26 · PRESERVA o client_info existente (freight_mode/card_surcharge_pct/authority_blocks)
        //   — ao vincular/trocar cliente NÃO reconstruir do zero, senão some no refresh + muda o total.
        this.#sale.client_info = {
          ...(this.#sale.client_info || {}),
          name: client.nome,
          email: client.email,
          whatsapp: client.whatsapp,
          cpf: client.cpf,
          cnpj: client.cnpj,
          // 2026-06-29 · tipo SEMPRE do documento (paridade c/ orçamento · tag Shopify pode contradizer o doc)
          tipo: ((client.cnpj || '').replace(/\D/g, '').length === 14) ? 'b2b' : 'b2c',
          cep: (client.endereco && client.endereco.cep) || client.cep || '', // QA A3 · frete lê ci.cep
          address: client.endereco || {},
        };
        this.#scheduleSave({
          customer_id: client.id,
          customer_snapshot: client,
          client_info: this.#sale.client_info,
        });
        this.#render();
      }, { signal });

      // 2026-06-28 · "Salvar cliente" (upsert Shopify + persiste na venda · Item 2)
      this.addEventListener('click', (e) => {
        if (e.target.closest?.('[data-tsf-venda-client-save]')) this.#commitVendaClient();
      }, { signal });
      // 04-08 · A PONTE: aplica o código da conversa → /sale/claim-code
      this.addEventListener('click', async (e) => {
        if (!e.target.closest?.('[data-tsf-venda-ponte-aplicar]')) return;
        const inp = this.querySelector('[data-tsf-venda-ponte-cod]');
        const st = this.querySelector('[data-tsf-venda-ponte-status]');
        const code = String(inp?.value || '').trim().toUpperCase().replace(/^#/, '');
        if (!/^[0-9A-F]{8}$/.test(code)) { if (st) st.textContent = 'código deve ter 8 caracteres (0-9 e A-F), ex.: #A1B2C3D4'; return; }
        if (!this.#sale?.customer_id) { if (st) st.textContent = 'vincule um cliente primeiro'; return; }
        if (st) st.textContent = 'procurando a sessão…';
        try {
          const r = await fetch(`${SALE_ENDPOINT}/claim-code`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ code, customer_id: this.#sale.customer_id })
          });
          const d = await r.json().catch(() => ({}));
          if (!r.ok || !d.ok) { if (st) st.textContent = d.error || ('não deu (HTTP ' + r.status + ')'); return; }
          const a = d.achou || {};
          const pistas = [
            a.gclid ? 'clique de anúncio GOOGLE (gclid)' : null,
            a.fbc ? 'clique de anúncio META (fbc)' : null,
            (!a.gclid && !a.fbc && a.utm_source) ? ('origem ' + a.utm_source) : null
          ].filter(Boolean);
          if (st) st.textContent = '✅ sessão encontrada (' + (a.toques_da_sessao || 1) + ' toques): ' + (pistas.join(' + ') || 'sem clique de anúncio — navegação direta/orgânica');
          this.#sale.client_info = { ...(this.#sale.client_info || {}), ponte_code: code };
          this.#scheduleSave({ client_info: this.#sale.client_info });
        } catch (err) {
          if (st) st.textContent = 'erro de rede: ' + (err?.message || err);
        }
      }, { signal });
      // Delegação pra inputs editáveis
      this.addEventListener('input', (e) => {
        if (!this.#isEditable() || !this.#editMode) return;
        // 2026-06-28 · Cliente editável inline (Item 2)
        const clientInp = e.target.closest?.('[data-tsf-venda-client-input]');
        if (clientInp) { this.#onVendaClientInput(clientInp); return; }
        // Onda 10.2 · Markup global slider
        const markupSlider = e.target.closest?.('[data-tsf-venda-markup-input]');
        if (markupSlider) {
          this.#applyGlobalMarkup(markupSlider.value);
          return;
        }
        // Onda 10.1 · Item-level edit (cor, materiais, dimens, prazo, qty, cost, markup)
        const itemEl = e.target.closest?.('[data-tsf-venda-item-edit]');
        if (itemEl) {
          const field = itemEl.dataset.tsfVendaItemEdit;
          const uid = itemEl.dataset.uid;
          this.#onItemFieldEdit(uid, field, itemEl.value);
          return;
        }
        // Sale-level fields (payment, notes)
        const el = e.target.closest?.('[data-tsf-venda-edit]');
        if (!el) return;
        const field = el.dataset.tsfVendaEdit;
        this.#onFieldEdit(field, el.value);
      }, { signal });
      this.addEventListener('change', (e) => {
        // 2026-06-28 · toggle endereço fiscal (cliente editável · Item 2)
        const fiscalToggle = e.target.closest?.('[data-tsf-venda-client-fiscal-toggle]');
        if (fiscalToggle) { const f = this.querySelector('[data-tsf-venda-client-fiscal-fields]'); if (f) f.hidden = !fiscalToggle.checked; return; }
        // Onda 12.3 · Autoridade roda ANTES do gate de editMode · só depende do status da venda
        // (rascunho/confirmada) · paridade total com orçamento
        const authorityCheck = e.target.closest?.('[data-tsf-venda-authority-check]');
        if (authorityCheck) {
          if (!this.#isEditable()) return; // bloqueia só em em_producao/entregue/cancelada
          const key = authorityCheck.dataset.tsfVendaAuthorityCheck;
          this.#onAuthorityToggle(key, authorityCheck.checked);
          return;
        }
        // FREIGHT-TOGGLE · habilitar/desabilitar frete no total da venda
        const freightToggle = e.target.closest?.('[data-tsf-venda-freight-toggle]');
        if (freightToggle && this.#isEditable() && this.#editMode) {
          const mode = freightToggle.checked ? 'charge' : 'none';
          this.#sale.client_info = this.#sale.client_info || {};
          this.#sale.client_info.freight_mode = mode;
          this.#scheduleSave({ client_info: this.#sale.client_info });
          this.#render();
          return;
        }
        // Fase 0.3 · taxa de cartão sobre o frete (gross-up · igual ao orçamento)
        const cardPctInput = e.target.closest?.('[data-tsf-venda-card-pct]');
        if (cardPctInput && this.#isEditable() && this.#editMode) {
          let pct = parseFloat(String(cardPctInput.value).replace(',', '.'));
          if (!isFinite(pct) || pct < 0) pct = 0;
          if (pct > 90) pct = 90; // trava de sanidade · denominador não pode zerar
          this.#sale.client_info = this.#sale.client_info || {};
          this.#sale.client_info.card_surcharge_pct = pct;
          this.#scheduleSave({ client_info: this.#sale.client_info });
          this.#render();
          return;
        }
        // 2026-06-30 · desconto do cliente em R$ sobre produtos (não incide no frete · igual ao orçamento)
        const discountInput = e.target.closest?.('[data-tsf-venda-discount]');
        if (discountInput && this.#isEditable() && this.#editMode) {
          this.#sale.client_info = this.#sale.client_info || {};
          this.#sale.client_info.discount_centavos = tsfParseMoneyCentavos(discountInput.value);
          this.#scheduleSave({ client_info: this.#sale.client_info });
          this.#render();
          return;
        }
        // F3-venda · frete AVULSO/NEGOCIADO (digita à mão; gross-up do cartão é aplicado no total)
        const freightEditInput = e.target.closest?.('[data-tsf-venda-freight-edit]');
        if (freightEditInput && this.#isEditable() && this.#editMode) {
          const cleaned = String(freightEditInput.value).replace(/[^\d,.-]/g, '').replace(/\.(?=\d{3}(\D|$))/g, '').replace(',', '.');
          const n = parseFloat(cleaned);
          if (isFinite(n) && n >= 0) {
            this.#sale.frete_centavos = Math.round(n * 100);
            this.#scheduleSave({ frete_centavos: this.#sale.frete_centavos });
            this.#render();
          }
          return;
        }
        // Demais campos (selects de pagamento, vipex origem do item) exigem modo edit
        if (!this.#isEditable() || !this.#editMode) return;
        const el = e.target.closest?.('[data-tsf-venda-edit]');
        if (el && el.tagName === 'SELECT') this.#onFieldEdit(el.dataset.tsfVendaEdit, el.value);
        // Onda 10.10 · Select de spec (ex: Vipex Origem) · re-render do row pra atualizar badges
        const itemSelect = e.target.closest?.('[data-tsf-venda-item-edit]');
        if (itemSelect && itemSelect.tagName === 'SELECT') {
          const field = itemSelect.dataset.tsfVendaItemEdit;
          const uid = itemSelect.dataset.uid;
          this.#onItemFieldEdit(uid, field, itemSelect.value);
          this.#refreshItemRow(uid);
        }
      }, { signal });
      // Onda 10.10 · blur · re-render do row pra atualizar badges (nativo/editado/global)
      // sem perder foco do usuário · espelha #refreshRow do orçamento
      this.addEventListener('blur', (e) => {
        if (!this.#isEditable() || !this.#editMode) return;
        const itemEl = e.target.closest?.('[data-tsf-venda-item-edit]');
        if (!itemEl) return;
        if (itemEl.tagName === 'SELECT') return; // change handler já cuida
        const uid = itemEl.dataset.uid;
        if (uid) this.#refreshItemRow(uid);
      }, { signal, capture: true });
      this.addEventListener('click', (e) => {
        // Onda 10 · Toggle modo edit
        const editToggle = e.target.closest?.('[data-tsf-venda-edit-toggle]');
        if (editToggle && this.#isEditable()) {
          e.preventDefault();
          this.#editMode = !this.#editMode;
          this.#render();
          return;
        }
        // Onda 12.2 · Toggle collapse da seção autoridade (visual only)
        const authorityToggle = e.target.closest?.('[data-tsf-venda-authority-toggle]');
        if (authorityToggle) {
          e.preventDefault();
          const section = authorityToggle.closest('[data-tsf-venda-authority]');
          if (section) {
            const isCollapsed = section.classList.toggle('is-collapsed');
            authorityToggle.setAttribute('aria-expanded', String(!isCollapsed));
          }
          return;
        }
        const changeClientBtn = e.target.closest?.('[data-tsf-venda-change-client]');
        if (changeClientBtn && this.#editMode && this.#isEditable()) {
          e.preventDefault();
          this.#openClientPicker();
          return;
        }
        // Onda 9 · Click em preset de pagamento · mesmo handler que wizard
        const presetBtn = e.target.closest?.('[data-tsf-venda-preset]');
        if (presetBtn && this.#editMode && this.#isEditable()) {
          e.preventDefault();
          const key = presetBtn.getAttribute('data-tsf-venda-preset');
          this.#onFieldEdit('payment_method', key);
          this.#render();
          return;
        }
        // Onda 10.1 · Item edit · stepper qty +/-
        const qtyStep = e.target.closest?.('[data-tsf-venda-item-qty-step]');
        if (qtyStep && this.#editMode) {
          e.preventDefault();
          const uid = qtyStep.getAttribute('data-uid');
          const step = parseInt(qtyStep.getAttribute('data-tsf-venda-item-qty-step'), 10) || 0;
          const item = (this.#sale?.items || []).find(it => it.uid === uid);
          if (item) {
            const next = Math.max(1, Math.min(999, (item.qty || 1) + step));
            this.#onItemFieldEdit(uid, 'qty', next);
          }
          return;
        }
        // Onda 10.1 · Item · reset (volta pro nativo)
        const resetBtn = e.target.closest?.('[data-tsf-venda-item-reset]');
        if (resetBtn && this.#editMode) {
          e.preventDefault();
          this.#onItemReset(resetBtn.getAttribute('data-uid'), resetBtn.getAttribute('data-tsf-venda-item-reset'));
          return;
        }
        // Onda 10.1 · Item · remover
        const removeBtn = e.target.closest?.('[data-tsf-venda-item-remove]');
        if (removeBtn && this.#editMode) {
          e.preventDefault();
          this.#removeItem(removeBtn.getAttribute('data-tsf-venda-item-remove'));
          return;
        }
        // Onda 10.2 · Recalcular frete
        const recalcBtn = e.target.closest?.('[data-tsf-venda-recalc-freight]');
        if (recalcBtn && this.#editMode) {
          e.preventDefault();
          this.#recalcFreight();
          return;
        }
        // F3-venda · voltar o frete pro automático (nativo)
        const freightResetBtn = e.target.closest?.('[data-tsf-venda-freight-reset]');
        if (freightResetBtn && this.#editMode) {
          e.preventDefault();
          const nat = this.#sale?.native_frete_centavos;
          if (typeof nat === 'number') {
            this.#sale.frete_centavos = nat;
            this.#sale.transportadora = this.#sale.native_transportadora || 'Vipex';
            this.#scheduleSave({ frete_centavos: nat, transportadora: this.#sale.transportadora });
            this.#render();
          }
          return;
        }
        // Onda 10.2 · Adicionar produto
        const addProductBtn = e.target.closest?.('[data-tsf-venda-add-product]');
        if (addProductBtn && this.#editMode) {
          e.preventDefault();
          this.#openProductPicker();
          return;
        }
        // Onda 9.2 · Stepper +/- de parcelas
        const stepBtn = e.target.closest?.('[data-tsf-parcels-step]');
        if (stepBtn && this.#isEditable()) {
          e.preventDefault();
          const step = parseInt(stepBtn.getAttribute('data-tsf-parcels-step'), 10) || 0;
          const current = parseInt(this.#sale?.payment_terms?.parcels, 10) || 3;
          const next = Math.max(1, Math.min(12, current + step));
          if (next !== current) {
            this.#onFieldEdit('payment_parcels', String(next));
            this.#render();
          }
          return;
        }
      }, { signal });
    }

    #onFieldEdit(field, value) {
      if (!this.#sale) return;
      const patch = {};
      switch (field) {
        case 'payment_method': {
          const pt = { ...(this.#sale.payment_terms || {}), method: value || null };
          this.#sale.payment_terms = pt;
          patch.payment_terms = pt;
          break;
        }
        case 'payment_parcels': {
          const pt = { ...(this.#sale.payment_terms || {}), parcels: parseInt(value, 10) || 1 };
          this.#sale.payment_terms = pt;
          patch.payment_terms = pt;
          break;
        }
        case 'payment_notes': {
          const pt = { ...(this.#sale.payment_terms || {}), notes: value?.trim() || null };
          this.#sale.payment_terms = pt;
          patch.payment_terms = pt;
          break;
        }
        case 'notes':
          this.#sale.notes = value?.trim() || null;
          patch.notes = this.#sale.notes;
          break;
        default:
          return;
      }
      this.#scheduleSave(patch);
    }

    #openClientPicker() {
      TsfClientPicker.open({
        title: this.#sale?.customer_id ? 'Trocar cliente desta venda' : 'Vincular cliente à venda',
        subtitle: 'Busque um cadastro · ou cadastre direto no modal sem sair daqui',
        specifierId: this.#sale?.specifier_customer_id || null,
        onSelect: (client) => {
          // Onda 15D · customer_id (bigint Shopify) é o ID estrutural
          this.#sale.customer_id = client.id;
          this.#sale.customer_snapshot = client;
          // 2026-06-26 · PRESERVA o client_info existente (freight_mode/card_surcharge_pct/authority_blocks)
          this.#sale.client_info = {
            ...(this.#sale.client_info || {}),
            name: client.nome,
            email: client.email,
            whatsapp: client.whatsapp,
            cpf: client.cpf,
            cnpj: client.cnpj,
            // 2026-06-29 · tipo SEMPRE derivado do DOCUMENTO (CNPJ 14 díg = empresa) · paridade c/ orçamento (l.899):
            //   a tag b2b/b2c do Shopify pode contradizer o doc (ex.: CPF marcado b2b) → o documento manda.
            tipo: ((client.cnpj || '').replace(/\D/g, '').length === 14) ? 'b2b' : 'b2c',
            cep: (client.endereco && client.endereco.cep) || client.cep || '', // QA A3 · frete lê ci.cep
            address: client.endereco || {},
          };
          this.#scheduleSave({
            customer_id: client.id,
            customer_snapshot: client,
            client_info: this.#sale.client_info,
          });
          this.#render();
        },
      });
    }

    disconnectedCallback() {
      this.#abortController?.abort();
    }

    async #fetch() {
      try {
        const res = await fetch(`${SALE_ENDPOINT}/get?id=${encodeURIComponent(this.#saleId)}`, {
          signal: this.#abortController.signal,
        });
        const data = await res.json();
        if (!data.ok) throw new Error(data.error || 'falha');
        this.#sale = data.sale;
      } catch (err) {
        this.#renderError('Falha ao carregar venda: ' + err.message);
        return;
      }
      // Onda 10 · render é chamado uma vez no connectedCallback após fetchQuote + fetchPedidos
    }

    // Onda 10.15 · Event delegation no document · cobre buttons gerados dinamicamente
    // Antes: forEach + addEventListener rodava ANTES do primeiro render → buttons na
    // seção "Pedidos pra fábrica" (Atualizar pedidos) ficavam sem listener.
    #bindHeaderActions() {
      const { signal } = this.#abortController;
      document.addEventListener('click', (e) => {
        const btn = e.target.closest?.('[data-tsf-admin-venda-action]');
        if (!btn) return;
        const action = btn.getAttribute('data-tsf-admin-venda-action');
        if (action === 'generate-pedidos') this.#generatePedidos();
        else if (action === 'confirm') this.#confirmSale();
        else if (action === 'cancel') this.#cancelSale();
        else if (action === 'pdf') this.#openPdf(); // Onda 12 · PDF da venda
        else if (action === 'save') this.#commitSave();         // 2026-06-28 · save manual
        else if (action === 'discard') this.#discardChanges();  // 2026-06-28 · descartar pendências
        // Onda 10.12 · Editar venda movido pro header (era no hero) · mesma toggle behavior
        else if (action === 'toggle-edit') {
          if (this.#isEditable()) {
            this.#editMode = !this.#editMode;
            this.#render();
          }
        }
      }, { signal });
      // 2026-06-28 · Beforeunload guard · avisa se sair com mudanças não salvas (paridade c/ orçamento)
      window.addEventListener('beforeunload', (e) => {
        if (this.#countPendingChanges() > 0) {
          e.preventDefault();
          e.returnValue = 'Você tem alterações não salvas. Deseja sair mesmo assim?';
          return e.returnValue;
        }
      }, { signal });
    }

    // Onda 10.12 · Atualiza label + icon + visibility do botão "Editar venda" no header
    // Chamado no render · sincroniza com #editMode atual + canEdit
    #updateHeaderEditButton() {
      const btn = document.querySelector('[data-tsf-admin-venda-edit-btn]');
      if (!btn) return;
      const canEdit = this.#isEditable();
      if (!canEdit) {
        btn.setAttribute('hidden', '');
        return;
      }
      btn.removeAttribute('hidden');
      const isEditing = !!this.#editMode;
      const label = btn.querySelector('[data-tsf-admin-venda-edit-label]');
      const icon = btn.querySelector('[data-tsf-admin-venda-edit-icon]');
      if (label) label.textContent = isEditing ? 'Concluir edição' : 'Editar venda';
      if (icon) {
        icon.innerHTML = isEditing
          ? '<polyline points="20 6 9 17 4 12"/>'
          : '<path d="M17 3a2.85 2.85 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5z"/>';
      }
      btn.classList.toggle('is-editing', isEditing);
    }

    async #generatePedidos() {
      if (!this.#sale) return;
      const ok = confirm(`Gerar pedidos pra fábrica desta venda?\n\nUm pedido será criado por fornecedor identificado nos items.`);
      if (!ok) return;
      // Onda 10.15 · Visual feedback em TODOS os botões "Gerar/Atualizar pedidos"
      // Existem 2 buttons na tela: 1 no header da página + 1 na seção · ambos com mesma action
      const btns = Array.from(document.querySelectorAll('[data-tsf-admin-venda-action="generate-pedidos"]'));
      const btnStates = btns.map(b => {
        const sp = b.querySelector('span');
        return { btn: b, span: sp, origLabel: sp?.textContent || '' };
      });
      const setBtnsLabel = (text) => {
        for (const st of btnStates) {
          st.btn.disabled = true;
          if (st.span) st.span.textContent = text;
        }
      };
      const restoreBtns = () => {
        for (const st of btnStates) {
          st.btn.disabled = false;
          if (st.span) st.span.textContent = st.origLabel;
        }
      };
      setBtnsLabel('Gerando pedidos…');
      try {
        // Onda 10.14 · Flush save ANTES de chamar Edge Function · garante que items recentes
        // (qty/cost/etc) estão no banco · sem isso o backend lê dados velhos
        if (this.#pendingPatch || this.#saveTimer) {
          setBtnsLabel('Salvando alterações…');
          await this.#flushSave();
        }
        setBtnsLabel('Gerando pedidos…');
        const res = await fetch('https://pucrgwvcgagbapzvphao.supabase.co/functions/v1/toth-checkout/pedido/create-from-sale', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ sale_id: this.#sale.id }),
        });
        const data = await res.json();
        if (!data.ok) throw new Error(data.error || 'falha');
        const total = (data.created || 0) + (data.updated || 0);
        alert(`${total} pedido${total>1?'s':''} processado${total>1?'s':''} (${data.created} criado${data.created>1?'s':''}, ${data.updated} atualizado${data.updated>1?'s':''})`);
        // Onda 10.13 · redirect limpo · sem query string legacy `?view=orcamento`
        window.location.href = `/pages/admin-pedidos`;
      } catch (err) {
        alert('Erro ao gerar pedidos: ' + err.message);
      } finally {
        restoreBtns();
      }
    }

    async #confirmSale() {
      if (!this.#sale) return;

      // Fase 2.4 · Validação obrigatória de dados mínimos pra match Meta/Google
      const ci = this.#sale.client_info || {};
      const phoneDigits = (ci.whatsapp || ci.phone || '').replace(/\D/g, '');
      const docDigits = (ci.cpf || ci.cnpj || ci.documento || '').replace(/\D/g, '');
      const hasIdentifier = (ci.email && /\S+@\S+\.\S+/.test(ci.email)) || phoneDigits.length >= 10;
      const hasDocument = docDigits.length === 11 || docDigits.length === 14;

      // Venda REAL vira NOTA FISCAL → exige CPF/CNPJ (obrigatório pra nota + melhor match Meta/Google),
      // além de um identificador (e-mail ou telefone). Revertido em 10-06 após o founder lembrar da nota.
      if (!hasIdentifier || !hasDocument) {
        const missing = [];
        if (!hasDocument) missing.push('CPF ou CNPJ (necessário pra emitir a nota fiscal e pro match no Meta/Google)');
        if (!hasIdentifier) missing.push('e-mail ou telefone');
        alert(
          `⛔ Antes de confirmar esta venda, preencha no cadastro do cliente:\n\n` +
          `   • ${missing.join('\n   • ')}\n\n` +
          `Use o botão "Ver/Editar cadastro" pra completar.`
        );
        return;
      }

      // Aviso (não bloqueador) se match quality < 50 — mas com chance de seguir
      const mq = this.#computeMatchQuality();
      if (mq.score < 50) {
        const ok = confirm(
          `⚠️ Match quality previsto: ${mq.score}/100\n\n` +
          `Faltam dados pra match completo: ${mq.missing.join(', ')}.\n\n` +
          `A conversão será enviada, mas com qualidade de match reduzida. ` +
          `Para máximo aproveitamento da otimização Meta/Google, complete o cadastro do cliente antes.\n\n` +
          `Confirmar mesmo assim?`
        );
        if (!ok) return;
      }

      try {
        // Onda 10.14 · Flush save · garante que edições recentes estão no banco
        if (this.#pendingPatch || this.#saveTimer) await this.#flushSave();
        const res = await fetch(`${SALE_ENDPOINT}/confirm`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: this.#sale.id }),
        });
        const data = await res.json();
        if (!data.ok) throw new Error(data.error || 'falha');
        this.#sale = data.sale;
        this.#render();
      } catch (err) {
        alert('Erro ao confirmar venda: ' + err.message);
      }
    }

    async #cancelSale() {
      if (!this.#sale) return;
      const ok = confirm('Cancelar essa venda? Status será marcado como "cancelada".');
      if (!ok) return;
      try {
        // Onda 10.14 · Flush save · evita perder edições pendentes no cancelamento
        if (this.#pendingPatch || this.#saveTimer) await this.#flushSave();
        const res = await fetch(`${SALE_ENDPOINT}/cancel`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: this.#sale.id }),
        });
        const data = await res.json();
        if (!data.ok) throw new Error(data.error || 'falha');
        this.#sale = data.sale;
        this.#render();
      } catch (err) {
        alert('Erro ao cancelar: ' + err.message);
      }
    }

    // Onda 10 · #render premium · auditoria completa em paridade com orçamento + extras
    #render() {
      if (!this.#sale) return;
      const s = this.#sale;
      const ci = s.client_info || {};
      const items = Array.isArray(s.items) ? s.items : [];
      const statusInfo = SALE_STATUS_LABELS[s.status] || SALE_STATUS_LABELS.rascunho;

      // ── Resumo financeiro (computado dinâmicamente) ──────────────────────
      const fin = this.#computeFinanceSummary(s, items);

      // ── Atualiza header section/page ──────────────────────────────────────
      const titleEl = document.querySelector('[data-tsf-admin-venda-title]');
      if (titleEl) titleEl.textContent = s.numero_venda || 'Venda';

      const bylineEl = document.querySelector('[data-tsf-admin-venda-byline]');
      if (bylineEl) {
        const created = s.created_at ? new Date(s.created_at).toLocaleDateString('pt-BR', { day: '2-digit', month: 'long', year: 'numeric' }) : '—';
        const parts = [
          ci.name || 'Cliente sem nome',
          this.#quote?.numero_orcamento ? `de ${this.#quote.numero_orcamento}` : null,
          `criado ${created}`,
          s.specifier_email ? `por ${s.specifier_email}` : null,
        ].filter(Boolean);
        bylineEl.textContent = parts.join(' · ');
      }

      const actionsEl = document.querySelector('[data-tsf-admin-venda-actions]');
      if (actionsEl) {
        actionsEl.removeAttribute('hidden');
        actionsEl.querySelectorAll('[data-status-required]').forEach((btn) => {
          const req = btn.getAttribute('data-status-required');
          btn.style.display = s.status === req ? '' : 'none';
        });
        actionsEl.querySelectorAll('[data-status-not]').forEach((btn) => {
          const notv = btn.getAttribute('data-status-not');
          btn.style.display = s.status !== notv ? '' : 'none';
        });
      }
      // Onda 10.12 · sincroniza botão Editar venda no header (label + icon + visibility)
      this.#updateHeaderEditButton();

      // ── Modo edit · default read-only · só ativa se status permite + user pediu
      const canEdit = this.#isEditable();
      const isEditMode = this.#editMode && canEdit;
      const isLocked = !isEditMode;
      const pt = s.payment_terms || {};

      this.innerHTML = `
        <div class="tsf-admin-venda-editor${isLocked ? ' is-locked' : ''}${isEditMode ? ' is-edit-mode' : ''}">

          <!-- HERO · status timeline + ações editáveis -->
          ${this.#renderHeroBar(s, statusInfo, canEdit, isEditMode, fin)}

          <!-- GRID · Cliente + Resumo financeiro -->
          <div class="tsf-admin-venda-grid">
            ${this.#renderClientSection(s, ci, isEditMode)}
            ${this.#renderPonteConversa(s)}
            ${this.#renderFinancialSummary(fin, s, ci)}
          </div>

          <!-- ITEMS · cards detalhados com TUDO -->
          ${this.#renderItemsRich(items, fin, s, isLocked)}

          <!-- FRETE & LOGÍSTICA · contextualizado -->
          ${this.#renderFreightSection(s, ci, fin)}

          <!-- PAGAMENTO · presets premium -->
          <section class="tsf-admin-venda-section">
            <header class="tsf-admin-venda-section__head">
              <h2>Condições de pagamento</h2>
            </header>
            <div class="tsf-admin-venda-section__body tsf-admin-venda-section__body--payment">
              ${renderPaymentSection(
                { method: pt.method, parcels: pt.parcels, notes: pt.notes },
                {
                  presetAttr: 'data-tsf-venda-preset',
                  parcelsAttr: 'data-tsf-venda-edit="payment_parcels"',
                  notesAttr: 'data-tsf-venda-edit="payment_notes"',
                  isLocked,
                }
              )}
            </div>
          </section>

          <!-- Onda 12.2 · AUTORIDADE · seleção independente da venda (não herda do orçamento) -->
          ${this.#renderAuthoritySection(s, isLocked)}

          <!-- PEDIDOS PRA FÁBRICA -->
          ${this.#renderRelatedPedidos(s)}

          <!-- NOTAS INTERNAS -->
          <section class="tsf-admin-venda-section">
            <header class="tsf-admin-venda-section__head">
              <h2>Notas internas</h2>
              <span class="tsf-admin-venda-section__hint">não vão pro cliente nem pra fábrica</span>
            </header>
            <div class="tsf-admin-venda-section__body">
              <label class="tsf-admin-cliente-field tsf-admin-cliente-field--full">
                <textarea rows="3" class="tsf-admin-cliente-input tsf-admin-cliente-textarea" data-tsf-venda-edit="notes" ${isLocked ? 'disabled' : ''} placeholder="Observações privadas">${this.#esc(s.notes || '')}</textarea>
              </label>
            </div>
          </section>

        </div>
      `;
      // 2026-06-29 · PADRONIZAÇÃO: pinta o fill dourado do slider de markup (espelha #updateSliderGradient do orçamento)
      if (isEditMode) tsfPaintSliderGradient(this.querySelector('[data-tsf-venda-markup-input]'));
    }

    // ──────────────────────────────────────────────────────────────────────
    // Onda 10 · HELPERS DE RENDER · uma seção por método
    // ──────────────────────────────────────────────────────────────────────

    // 04-08 · A PONTE conversa→sessão: o site injeta um código #XXXXXXXX no
    // texto do wa.me; o cliente manda; o vendedor cola aqui e a venda herda o
    // clique de anúncio (gclid/fbc) da sessão de navegação — é o que liga a
    // venda de WhatsApp de volta à campanha.
    #renderPonteConversa(s) {
      const ci = s.client_info || {};
      const aplicado = String(ci.ponte_code || '');
      const temCliente = !!s.customer_id;
      return `
        <section class="tsf-admin-venda-section" data-tsf-venda-ponte>
          <header class="tsf-admin-venda-section__head">
            <h2>Atribuição da conversa</h2>
            <span class="tsf-admin-venda-section__hint">o código #ABC12345 que o cliente manda no WhatsApp</span>
          </header>
          <div class="tsf-admin-venda-section__body" style="display:flex;gap:10px;align-items:center;flex-wrap:wrap">
            <input class="tsf-admin-cliente-input" style="max-width:170px;text-transform:uppercase;font-variant-numeric:tabular-nums"
              maxlength="9" placeholder="#ABC12345" autocomplete="off"
              data-tsf-venda-ponte-cod value="${aplicado ? '#' + this.#esc(aplicado) : ''}" ${temCliente ? '' : 'disabled'}>
            <button type="button" data-tsf-venda-ponte-aplicar ${temCliente ? '' : 'disabled'}
              style="min-height:40px;padding:0 18px;border-radius:999px;border:none;background:#3F4D3A;color:#fff;font-weight:600;font-size:13px;cursor:pointer;${temCliente ? '' : 'opacity:.5;cursor:not-allowed'}">Aplicar</button>
            <span data-tsf-venda-ponte-status style="font-size:12px;color:#6f6a63;min-inline-size:0">${temCliente ? (aplicado ? 'código aplicado — a venda herda a sessão #' + this.#esc(aplicado) : 'cole o código da conversa e aplique') : 'vincule um cliente primeiro'}</span>
          </div>
        </section>`;
    }

    // Computa resumo financeiro completo (igual ao bloco TOTAL do orçamento)
    // Onda 10.7 · Compute LIVE · cost com fallback + markup 3-state (mesma lógica do #renderItemRow)
    // Não depende mais de snap.price_centavos (que era reescrito a cada edição) · preserva nativo
    #computeFinanceSummary(s, items) {
      const globalPct = parseFloat(s.default_markup_pct) || 50;
      let custoTotal = 0;
      let produtosTotal = 0;
      for (const it of (items || [])) {
        const qty = it.qty || 1;
        const snap = it.snapshot || {};
        const ov = it.overrides || {};
        // Cost cascade · igual ao #renderItemRow (override → snap > 0 → price fallback)
        const cost = (typeof ov.cost_centavos === 'number') ? ov.cost_centavos :
                     (typeof snap.cost_centavos === 'number' && snap.cost_centavos > 0) ? snap.cost_centavos :
                     (snap.price_centavos || 0);
        custoTotal += cost * qty;
        // Markup resolution igual ao #renderItemRow
        const markup = (typeof it.markup_pct === 'number') ? it.markup_pct : null;
        const nativeMarkupPct = (typeof snap.cost_centavos === 'number' && snap.cost_centavos > 0 &&
                                 typeof snap.price_centavos === 'number' && snap.price_centavos > 0)
          ? ((snap.price_centavos - snap.cost_centavos) / snap.cost_centavos) * 100
          : null;
        const explicitSource = ov.markup_source;
        let useMarkup;
        if (explicitSource === 'manual') useMarkup = (markup !== null) ? markup : globalPct;
        else if (explicitSource === 'global') useMarkup = globalPct;
        else if (markup !== null) useMarkup = markup;
        else if (nativeMarkupPct !== null) useMarkup = nativeMarkupPct;
        else useMarkup = globalPct;
        const clienteUnit = cost * (1 + useMarkup / 100);
        produtosTotal += clienteUnit * qty;
      }
      const freteRaw = s.frete_centavos || 0;
      // Fase 0.3 · gross-up da taxa de cartão sobre o frete (igual ao orçamento)
      const cardPctF = parseFloat(s.client_info?.card_surcharge_pct) || 0;
      const denomF = 1 - cardPctF / 100;
      const freteAjustado = (freteRaw > 0 && cardPctF > 0 && denomF > 0) ? Math.round(freteRaw / denomF) : freteRaw;
      // FREIGHT-MODE · 'charge' soma no total · qualquer outro (none/courtesy/pickup/included) não soma
      const freightMode = (s.client_info?.freight_mode || 'charge').toString().toLowerCase();
      const freteInTotal = (freightMode === 'charge') ? freteAjustado : 0;
      // 2026-06-30 · desconto do cliente em R$ sobre produtos (não incide no frete)
      const desconto = Math.max(0, parseInt(s.client_info?.discount_centavos, 10) || 0);
      const produtosNet = Math.max(0, produtosTotal - desconto);
      const totalCliente = produtosNet + freteInTotal;
      const margem = produtosNet - custoTotal;
      const margemPct = custoTotal > 0 ? (margem / custoTotal) * 100 : 0;
      // 2026-06-30 · desconto negociado JÁ É o à vista → não soma os 8% do Pix (um OU outro)
      const pixValue = desconto > 0 ? totalCliente : Math.round(totalCliente * 0.92);
      return {
        custoTotal, produtosTotal, desconto,
        frete: freteAjustado,    // JÁ com a taxa de cartão embutida (é o que entra no total)
        freteOriginal: freteRaw, // frete cru antes do cartão · referência pro vendedor
        // Rótulo correto: "Vipex" só quando o frete == nativo (automático); senão é avulso/negociado
        isVipexAuto: (s.frete_centavos != null && s.native_frete_centavos != null && s.frete_centavos === s.native_frete_centavos),
        cardPct: cardPctF,
        freteInTotal,            // só soma se freight_mode === 'charge'
        freightMode,
        totalCliente, margem, margemPct, pixValue
      };
    }

    // Onda 10.3 · Hero compacto · valor à direita do número, timeline subtil em 1 linha
    #renderHeroBar(s, statusInfo, canEdit, isEditMode, fin) {
      const stages = [
        { key: 'rascunho',    label: 'Rascunho' },
        { key: 'confirmada',  label: 'Confirmada' },
        { key: 'em_producao', label: 'Em produção' },
        { key: 'entregue',    label: 'Entregue' },
      ];
      const currentIdx = Math.max(0, stages.findIndex(st => st.key === s.status));
      const isCancelled = s.status === 'cancelada';
      // Onda 10.12 · Botão "Editar venda" foi pra o header da página (junto com Gerar pedidos + Cancelar)
      // Hero fica mais limpo · só com o valor total + status strip

      return `
        <div class="tsf-venda-hero">
          <div class="tsf-venda-hero__topline">
            <div class="tsf-venda-hero__value">
              <span class="tsf-venda-hero__value-label">Valor total</span>
              <span class="tsf-venda-hero__value-num">${money(fin.totalCliente)}</span>
            </div>
          </div>

          ${isCancelled ? `
            <div class="tsf-venda-hero__cancelled">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></svg>
              <span>Venda <strong>cancelada</strong>${s.cancelled_at ? ` em ${new Date(s.cancelled_at).toLocaleDateString('pt-BR')}` : ''}</span>
            </div>
          ` : `
            <div class="tsf-venda-status-strip" role="list" aria-label="Status da venda">
              ${stages.map((st, i) => `
                <span class="tsf-venda-status-strip__stage ${i < currentIdx ? 'is-past' : ''} ${i === currentIdx ? 'is-current' : ''}" role="listitem">
                  <span class="tsf-venda-status-strip__dot" aria-hidden="true"></span>
                  <span class="tsf-venda-status-strip__label">${this.#esc(st.label)}</span>
                </span>
              `).join('')}
            </div>
          `}

          ${this.#renderMatchQualityBadge(s)}
          ${this.#renderConversionBadge(s)}
        </div>
      `;
    }

    // Fase 2.4 · Match Quality · calcula score 0-100 baseado em campos PII preenchidos
    // Espelha computeMatchQuality do Edge Function para dar feedback imediato ao vendedor
    #computeMatchQuality() {
      const ci = this.#sale?.client_info || {};
      const present = [];
      const missing = [];
      let score = 0;

      // Email (25 pts)
      if (ci.email && /\S+@\S+\.\S+/.test(ci.email)) { present.push('email'); score += 25; }
      else missing.push('email');

      // Telefone (25 pts) — aceita só dígitos com 10+
      const phoneDigits = (ci.whatsapp || ci.phone || '').replace(/\D/g, '');
      if (phoneDigits.length >= 10) { present.push('telefone'); score += 25; }
      else missing.push('telefone');

      // Documento (15 pts)
      const docDigits = (ci.cpf || ci.cnpj || ci.documento || '').replace(/\D/g, '');
      if (docDigits.length === 11 || docDigits.length === 14) { present.push('CPF/CNPJ'); score += 15; }
      else missing.push('CPF/CNPJ');

      // Nome (10 pts)
      const nome = (ci.name || ci.nome || '').trim();
      if (nome && nome.split(/\s+/).length >= 2) { present.push('nome completo'); score += 10; }
      else if (nome) { present.push('primeiro nome'); score += 5; }
      else missing.push('nome');

      // CEP (10 pts) — QA A2: a VENDA guarda em ci.cep/ci.address; orçamento em endereco_fiscal/endereco
      const cepFiscal = ((ci.endereco_fiscal || {}).cep || '').replace(/\D/g, '');
      const cepEntrega = ((ci.endereco || {}).cep || '').replace(/\D/g, '');
      const cepAddr = ((ci.address || {}).cep || ci.cep || '').replace(/\D/g, '');
      if (cepFiscal.length === 8 || cepEntrega.length === 8 || cepAddr.length === 8) { present.push('CEP'); score += 10; }
      else missing.push('CEP');

      // Cidade (5 pts)
      const cidade = (ci.address || {}).cidade || (ci.address || {}).localidade || (ci.endereco || {}).cidade || (ci.endereco_fiscal || {}).cidade;
      if (cidade) { present.push('cidade'); score += 5; }
      else missing.push('cidade');

      // Estado (5 pts)
      const uf = (ci.address || {}).uf || (ci.endereco || {}).uf || (ci.endereco_fiscal || {}).uf;
      if (uf) { present.push('estado'); score += 5; }
      else missing.push('estado');

      return { score: Math.min(100, score), present, missing };
    }

    // Fase 2.4 · Badge visual do match quality antes do botão Confirmar
    // Só renderiza em status rascunho (preview do que vai acontecer ao confirmar)
    #renderMatchQualityBadge(s) {
      if (s.status !== 'rascunho') return '';

      const mq = this.#computeMatchQuality();
      const score = mq.score;
      let tier, icon, label;
      if (score >= 85) { tier = 'excelente'; icon = '🟢'; label = 'Match excelente'; }
      else if (score >= 65) { tier = 'bom'; icon = '🟡'; label = 'Match bom'; }
      else if (score >= 40) { tier = 'medio'; icon = '🟠'; label = 'Match médio'; }
      else { tier = 'fraco'; icon = '🔴'; label = 'Match insuficiente'; }

      const missingStr = mq.missing.length
        ? `Faltam: <strong>${mq.missing.join(', ')}</strong>`
        : 'Todos os dados-chave preenchidos';

      return `
        <div class="tsf-venda-matchq tsf-venda-matchq--${tier}" title="Score baseado em campos PII enviados pro Meta CAPI + Google Enhanced Conversions">
          <span class="tsf-venda-matchq__icon" aria-hidden="true">${icon}</span>
          <div class="tsf-venda-matchq__body">
            <span class="tsf-venda-matchq__label">${label} · ${score}/100</span>
            <span class="tsf-venda-matchq__sub">${missingStr}</span>
          </div>
        </div>
      `;
    }

    // Fase 1 Onda F · Badge de status do dispatch de conversões pro Meta + Google
    // Render só quando venda confirmada. Lê tsf_conversion_sent + tsf_conversion_dispatch_log.
    // Fase 3.C · reconhece vendas históricas (Conta Azul) com badge informativo separado
    #renderConversionBadge(s) {
      if (s.status !== 'confirmada' && s.status !== 'em_producao' && s.status !== 'entregue') {
        return '';
      }
      const log = s.tsf_conversion_dispatch_log || null;
      const sentAt = s.tsf_conversion_sent;
      const isHistorical = log?.source === 'historical_import_conta_azul';

      // Estado 0: venda histórica do Conta Azul · registro retroativo
      if (isHistorical) {
        const sentMeta = log?.sent_to_meta;
        const sentGoogle = log?.sent_to_google;
        const batchDate = log?.intelligence_batch_date;
        const batchDateStr = batchDate
          ? new Date(batchDate).toLocaleDateString('pt-BR', { day: '2-digit', month: 'short', year: 'numeric' })
          : 'data desconhecida';
        const status = sentMeta && sentGoogle
          ? `Intelligence enviou pro Meta + Google em ${batchDateStr} (vendas > 7d · provavelmente rejeitadas pelo Meta)`
          : `Pendente · não foi enviada pelo Intelligence`;
        return `
          <div class="tsf-venda-conversion tsf-venda-conversion--info" title="Importada do Conta Azul · histórico retroativo">
            <span class="tsf-venda-conversion__icon" aria-hidden="true">📚</span>
            <div class="tsf-venda-conversion__body">
              <span class="tsf-venda-conversion__label">Histórico Conta Azul</span>
              <span class="tsf-venda-conversion__sub">${status}</span>
            </div>
          </div>
        `;
      }

      // Estado 1: ainda não enviado
      if (!sentAt) {
        return `
          <div class="tsf-venda-conversion tsf-venda-conversion--pending" role="status" aria-live="polite">
            <span class="tsf-venda-conversion__icon" aria-hidden="true">📡</span>
            <div class="tsf-venda-conversion__body">
              <span class="tsf-venda-conversion__label">Disparando conversão</span>
              <span class="tsf-venda-conversion__sub">Meta CAPI + Google Ads em segundo plano…</span>
            </div>
          </div>
        `;
      }

      const sentTime = new Date(sentAt).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
      const sentDate = new Date(sentAt).toLocaleDateString('pt-BR', { day: '2-digit', month: 'short' });

      const meta = log?.meta || {};
      const google = log?.google || {};

      // Casos de "skip" estrutural (sem customer ou sem attribution)
      if (meta.skipped === 'no_customer_id' || google.skipped === 'no_customer_id') {
        return `
          <div class="tsf-venda-conversion tsf-venda-conversion--info">
            <span class="tsf-venda-conversion__icon" aria-hidden="true">ℹ️</span>
            <div class="tsf-venda-conversion__body">
              <span class="tsf-venda-conversion__label">Conversão não enviada</span>
              <span class="tsf-venda-conversion__sub">Venda sem cliente Shopify vinculado · ${sentDate} ${sentTime}</span>
            </div>
          </div>
        `;
      }

      if (meta.skipped === 'customer_fetch_failed') {
        return `
          <div class="tsf-venda-conversion tsf-venda-conversion--warning">
            <span class="tsf-venda-conversion__icon" aria-hidden="true">⚠️</span>
            <div class="tsf-venda-conversion__body">
              <span class="tsf-venda-conversion__label">Falha ao buscar cliente</span>
              <span class="tsf-venda-conversion__sub">Conversão não enviada · ${sentDate} ${sentTime}</span>
            </div>
          </div>
        `;
      }

      const metaOk = meta.ok === true;
      const googleOk = google.ok === true;
      const googleSkipped = !!google.skipped;
      const metaSkipped = !!meta.skipped;

      // Caso success completo
      if (metaOk && googleOk) {
        return `
          <div class="tsf-venda-conversion tsf-venda-conversion--success" title="event_id: ${meta.event_id || ''}">
            <span class="tsf-venda-conversion__icon" aria-hidden="true">✅</span>
            <div class="tsf-venda-conversion__body">
              <span class="tsf-venda-conversion__label">Conversão enviada · Meta + Google</span>
              <span class="tsf-venda-conversion__sub">${sentDate} ${sentTime} · ${meta.action_source || 'website'}</span>
            </div>
          </div>
        `;
      }

      // Caso parcial: Meta OK, Google skipped (sem gclid)
      if (metaOk && googleSkipped) {
        return `
          <div class="tsf-venda-conversion tsf-venda-conversion--info" title="Google skipped: ${google.skipped}">
            <span class="tsf-venda-conversion__icon" aria-hidden="true">✅</span>
            <div class="tsf-venda-conversion__body">
              <span class="tsf-venda-conversion__label">Conversão enviada · Meta</span>
              <span class="tsf-venda-conversion__sub">${sentDate} ${sentTime} · Google ${google.skipped === 'no_gclid' ? 'sem gclid' : google.skipped}</span>
            </div>
          </div>
        `;
      }

      // Caso parcial: Meta skipped (event too old), Google may have sent
      if (metaSkipped && (googleOk || googleSkipped)) {
        return `
          <div class="tsf-venda-conversion tsf-venda-conversion--info" title="Meta skipped: ${meta.skipped}">
            <span class="tsf-venda-conversion__icon" aria-hidden="true">⏱️</span>
            <div class="tsf-venda-conversion__body">
              <span class="tsf-venda-conversion__label">Conversão parcial</span>
              <span class="tsf-venda-conversion__sub">${sentDate} ${sentTime} · Meta ${meta.skipped} · Google ${google.ok ? 'enviada' : (google.skipped || 'erro')}</span>
            </div>
          </div>
        `;
      }

      // Caso erro: ao menos um falhou
      const metaStatus = metaOk ? 'OK' : (meta.error?.substring?.(0, 50) || 'falhou');
      const googleStatus = googleOk ? 'OK' : (google.error?.substring?.(0, 50) || google.skipped || 'falhou');
      return `
        <div class="tsf-venda-conversion tsf-venda-conversion--warning" title="${this.#esc(JSON.stringify(log))}">
          <span class="tsf-venda-conversion__icon" aria-hidden="true">⚠️</span>
          <div class="tsf-venda-conversion__body">
            <span class="tsf-venda-conversion__label">Conversão com problemas</span>
            <span class="tsf-venda-conversion__sub">${sentDate} ${sentTime} · Meta: ${this.#esc(metaStatus)} · Google: ${this.#esc(googleStatus)}</span>
          </div>
        </div>
      `;
    }

    // Resumo financeiro premium (custo, margem, frete, total, PIX)
    #renderFinancialSummary(fin, s, ci) {
      return `
        <section class="tsf-admin-venda-section tsf-venda-finance">
          <header class="tsf-admin-venda-section__head">
            <h2>Resumo financeiro</h2>
          </header>
          <div class="tsf-venda-finance__body">
            <div class="tsf-venda-finance__row">
              <span class="tsf-venda-finance__label">Produtos</span>
              <span class="tsf-venda-finance__value" data-tsf-venda-fin="produtos">${money(fin.produtosTotal)}</span>
            </div>
            ${(this.#editMode && this.#isEditable()) ? `
              <div class="tsf-venda-finance__row tsf-venda-finance__row--discount-ctrl">
                <span class="tsf-venda-finance__label">Desconto <em>(produtos)</em></span>
                <span class="tsf-venda-finance__discount-field">
                  <span class="tsf-venda-finance__discount-prefix">R$</span>
                  <input type="text" inputmode="decimal" data-tsf-venda-discount
                         value="${fin.desconto > 0 ? (fin.desconto / 100).toFixed(2).replace('.', ',') : ''}"
                         placeholder="0,00" class="tsf-venda-finance__discount-input"
                         aria-label="Desconto em reais sobre produtos (não incide no frete)">
                </span>
              </div>
            ` : (fin.desconto > 0 ? `
              <div class="tsf-venda-finance__row tsf-venda-finance__row--discount">
                <span class="tsf-venda-finance__label">Desconto <em>(produtos)</em></span>
                <span class="tsf-venda-finance__value">− ${money(fin.desconto)}</span>
              </div>
            ` : '')}
            ${fin.freightMode !== 'charge' ? `
              <div class="tsf-venda-finance__row tsf-venda-finance__row--muted">
                <span class="tsf-venda-finance__label">Frete</span>
                <span class="tsf-venda-finance__value" data-tsf-venda-fin="frete">não cobrado</span>
              </div>
            ` : (fin.frete > 0 ? `
              <div class="tsf-venda-finance__row">
                <span class="tsf-venda-finance__label">Frete <em>(${fin.isVipexAuto ? 'Vipex' : 'avulso'})</em></span>
                <span class="tsf-venda-finance__value" data-tsf-venda-fin="frete">${money(fin.frete)}</span>
              </div>
            ` : `
              <div class="tsf-venda-finance__row tsf-venda-finance__row--muted">
                <span class="tsf-venda-finance__label">Frete</span>
                <span class="tsf-venda-finance__value" data-tsf-venda-fin="frete">a calcular</span>
              </div>
            `)}
            <div class="tsf-venda-finance__row tsf-venda-finance__row--primary">
              <span class="tsf-venda-finance__label">Total cliente</span>
              <span class="tsf-venda-finance__value">${money(fin.totalCliente)}</span>
            </div>
            <div class="tsf-venda-finance__row tsf-venda-finance__row--pix">
              <span class="tsf-venda-finance__label">À vista no PIX <em>(${fin.desconto > 0 ? 'negociado' : '8% off'})</em></span>
              <span class="tsf-venda-finance__value">${money(fin.pixValue)}</span>
            </div>
            <div class="tsf-venda-finance__divider"></div>
            <div class="tsf-venda-finance__row tsf-venda-finance__row--internal">
              <span class="tsf-venda-finance__label">Custo total</span>
              <span class="tsf-venda-finance__value">${money(fin.custoTotal)}</span>
            </div>
            <div class="tsf-venda-finance__row tsf-venda-finance__row--internal">
              <span class="tsf-venda-finance__label">Margem</span>
              <span class="tsf-venda-finance__value">
                ${money(fin.margem)}
                <em class="tsf-venda-finance__pct">+${fin.margemPct.toFixed(0)}%</em>
              </span>
            </div>
          </div>
        </section>
      `;
    }

    // Onda 10.1 · Items totalmente editáveis no modo edit · isLocked = view-only
    // Inputs inline pra cor, materiais, dimensões, prazo, custo, markup, qty
    // Stepper de qty · botão remover · indicador nativo vs override
    // UX-FIX D · Empty state CTA-driven · venda avulsa sem items mostra "Adicionar produto"
    #renderItemsRich(items, fin, s, isLocked) {
      if (!items.length) {
        // Empty state acionável · em edit mode mostra toolbar markup + botão adicionar produto
        if (isLocked) {
          return `
            <section class="tsf-admin-venda-section">
              <header class="tsf-admin-venda-section__head">
                <h2>Items</h2>
                <span class="tsf-admin-venda-section__hint">clique "Editar venda" pra adicionar produtos</span>
              </header>
              <div class="tsf-admin-venda-section__body">
                <p class="tsf-venda-empty">Nenhum item nesta venda.</p>
              </div>
            </section>
          `;
        }
        return `
          <section class="tsf-admin-venda-section tsf-venda-items-section">
            <header class="tsf-admin-venda-section__head">
              <h2>Items</h2>
              <span class="tsf-admin-venda-section__hint tsf-admin-venda-section__hint--edit">venda avulsa · adicione produtos pra começar</span>
            </header>
            ${this.#renderItemsToolbar(s)}
            <div class="tsf-venda-empty-state">
              <svg width="42" height="42" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" style="opacity:.35;margin-bottom:14px;">
                <rect x="3" y="6" width="18" height="13" rx="2"/>
                <path d="M3 10h18"/>
                <path d="M8 14h3"/>
              </svg>
              <p class="tsf-venda-empty" style="margin:0 0 18px;">Nenhum item adicionado ainda.</p>
              <p style="font-size:12px;color:rgba(26,25,24,0.55);max-width:36ch;margin:0 auto 18px;">Adicione produtos do catálogo Toth pra montar essa venda direta. Você pode ajustar custo, markup, quantidade e materiais item a item.</p>
            </div>
            ${this.#renderAddProductBar()}
          </section>
        `;
      }

      const rows = items.map((it, idx) => this.#renderItemRow(it, idx, isLocked)).join('');

      const origemLink = s.quote_id && this.#quote ? `
        <a href="/pages/admin-orcamento?id=${this.#esc(s.quote_id)}" target="_blank" rel="noopener" class="tsf-admin-venda-section__link">
          ↗ Origem: ${this.#esc(this.#quote.numero_orcamento || 'orçamento')}
        </a>
      ` : '';

      const headHint = isLocked
        ? '<span class="tsf-admin-venda-section__hint">clique "Editar venda" pra ajustar</span>'
        : '<span class="tsf-admin-venda-section__hint tsf-admin-venda-section__hint--edit">modo edição · venda independente do orçamento</span>';

      // Onda 10.2 · toolbar de edição (markup global + adicionar produto) só em editMode
      const editToolbar = !isLocked ? this.#renderItemsToolbar(s) : '';

      return `
        <section class="tsf-admin-venda-section tsf-venda-items-section">
          <header class="tsf-admin-venda-section__head">
            <h2>Items <span>${items.length} ${items.length === 1 ? 'produto' : 'produtos'}</span></h2>
            ${origemLink}
            ${headHint}
          </header>
          ${editToolbar}
          <ol class="tsf-quote-builder__list tsf-venda-items-list">
            ${rows}
          </ol>
          ${!isLocked ? this.#renderAddProductBar() : ''}
        </section>
      `;
    }

    // Onda 10.6 · Toolbar do orçamento (mesmas classes tsf-quote-builder__*)
    // Markup slider · paridade visual ABSOLUTA com /pages/admin-orcamento
    // Onda 10.11 · Botão "Recalcular frete" movido pra seção Frete & Logística
    #renderItemsToolbar(s) {
      const defaultMarkup = parseFloat(s.default_markup_pct) || 50;
      const multDisplay = (1 + defaultMarkup/100).toFixed(2).replace('.', ',');
      return `
        <div class="tsf-quote-builder__toolbar tsf-venda-items-toolbar">
          <label class="tsf-quote-builder__markup-field">
            <span class="tsf-quote-builder__markup-label">Markup multiplicador global</span>
            <div class="tsf-quote-builder__markup">
              <input type="range" min="0" max="400" step="1" value="${defaultMarkup}"
                     class="tsf-quote-builder__markup-slider"
                     data-tsf-venda-markup-input
                     aria-label="Multiplicador de markup global">
              <output class="tsf-quote-builder__markup-output" data-tsf-venda-markup-output>${multDisplay}x</output>
            </div>
            <div class="tsf-quote-builder__markup-hint">
              Multiplica o custo. Ex.: 1,85x = +85% sobre o custo. Edite cada item individualmente abaixo.
            </div>
          </label>
        </div>
      `;
    }

    // Onda 10.6 · Barra "Adicionar produto" com mesma classe do orçamento
    #renderAddProductBar() {
      return `
        <div class="tsf-quote-builder__actions tsf-venda-add-product">
          <button type="button" class="tsf-quote-builder__add-product" data-tsf-venda-add-product>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true">
              <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
            </svg>
            <span>Adicionar produto</span>
          </button>
        </div>
      `;
    }

    #renderItemRow(it, idx, isLocked) {
      const snap = it.snapshot || {};
      const ov = it.overrides || {};
      const m = snap.metafields || {};
      const qty = it.qty || 1;
      const price = snap.price_centavos || 0;
      // Onda 10.7 · Cost com cascade (espelha orçamento): override → snap.cost > 0 → snap.price (fallback)
      const cost = (typeof ov.cost_centavos === 'number') ? ov.cost_centavos :
                   (typeof snap.cost_centavos === 'number' && snap.cost_centavos > 0) ? snap.cost_centavos :
                   (snap.price_centavos || 0);
      const subtotal = price * qty;
      const photo = it.selected_photo_url || snap.image_url || '';
      const fornecedorNome = snap.fornecedor?.nome || snap.vendor || '—';
      // Valores efetivos · override prevalece sobre snapshot
      const cor = (typeof ov.cor === 'string' ? ov.cor : m.cor) || '';
      const materiais = (typeof ov.materiais === 'string' ? ov.materiais : m.materiais) || '';
      const dimensoes = (typeof ov.dimens_es === 'string' ? ov.dimens_es : m.dimens_es) || '';
      const prazo = (typeof ov.prazo === 'string' || typeof ov.prazo === 'number' ? ov.prazo : m.prazo) || '';
      const vipex = m.vipex_origem || '';
      const markup = (typeof it.markup_pct === 'number' ? it.markup_pct : null);
      // Onda 10.7 · Markup nativo · derivado SÓ do snap.cost_centavos × snap.price_centavos original
      // (não usa o cost com fallback porque a fallback chain inclui o próprio price)
      const nativeMarkupPct = (typeof snap.cost_centavos === 'number' && snap.cost_centavos > 0 &&
                               typeof snap.price_centavos === 'number' && snap.price_centavos > 0)
        ? Math.round(((snap.price_centavos - snap.cost_centavos) / snap.cost_centavos) * 100 * 100) / 100
        : null;
      const uid = it.uid || '';
      const esc = (v) => this.#esc(v);

      if (isLocked) {
        // Read-only · valores como texto
        const dimsFormatted = String(dimensoes).replace(/\n/g, ' · ');
        return `
          <li class="tsf-venda-item">
            <div class="tsf-venda-item__index">${idx + 1}</div>
            ${photo ? `<a href="${esc(snap.url || '#')}" target="_blank" rel="noopener" class="tsf-venda-item__photo"><img src="${esc(photo)}" alt="${esc(snap.title || snap.name || '')}" loading="lazy"></a>` : '<div class="tsf-venda-item__photo tsf-venda-item__photo--empty"></div>'}
            <div class="tsf-venda-item__body">
              <h3 class="tsf-venda-item__title">
                ${snap.url ? `<a href="${esc(snap.url)}" target="_blank" rel="noopener">${esc(snap.title || snap.name || it.product_handle || '—')}</a>` : esc(snap.title || snap.name || it.product_handle || '—')}
              </h3>
              <div class="tsf-venda-item__vendor">${esc(fornecedorNome)}${vipex ? ` · Origem ${esc(vipex)}` : ''}</div>
              <dl class="tsf-venda-item__specs">
                <div><dt>Acabamento</dt><dd>${esc(cor || '—')}</dd></div>
                <div><dt>Material</dt><dd>${esc(materiais || '—')}</dd></div>
                <div><dt>Dimensões</dt><dd>${esc(dimsFormatted || '—')}</dd></div>
                <div><dt>Prazo</dt><dd>${esc(prazo || '—')} ${prazo ? 'dias' : ''}</dd></div>
              </dl>
            </div>
            <div class="tsf-venda-item__pricing">
              <div class="tsf-venda-item__qty-line">
                <span class="tsf-venda-item__qty">${qty}×</span>
                <span class="tsf-venda-item__price">${money(price)}</span>
              </div>
              <div class="tsf-venda-item__subtotal">${money(subtotal)}</div>
              <div class="tsf-venda-item__internal">
                <span>custo unit. <strong>${money(cost)}</strong></span>
              </div>
            </div>
          </li>
        `;
      }

      // EDIT MODE · CLONE EXATO da estrutura tsf-quote-item--toth do orçamento (Onda 10.6)
      // Reutiliza CSS já existente em toth-specifica-companion.css · paridade visual ABSOLUTA.
      // Diferença é apenas semântica: data-tsf-venda-item-* em vez de data-tsf-quote-*.

      // Onda 10.7 · 3-state resolution do markup · usa ov.markup_source explícito (espelha orçamento)
      // 'manual' = vendor editou individualmente · 'global' = veio do slider global
      // 'native' = igual ao markup nativo do produto
      // Onda 10.10 · fallback final = 'global' (não null) · sempre mostra origem clara ao usuário
      const globalPct = parseFloat(this.#sale?.default_markup_pct) || 50;
      const explicitSource = ov.markup_source;
      let markupSource;
      if (explicitSource) {
        markupSource = explicitSource;
      } else if (markup !== null) {
        // Sem flag explícito · infere por comparação (legacy fallback)
        if (nativeMarkupPct !== null && Math.abs(markup - nativeMarkupPct) < 0.5) {
          markupSource = 'native';
        } else if (Math.abs(markup - globalPct) < 0.5) {
          markupSource = 'global';
        } else {
          markupSource = 'manual';
        }
      } else if (nativeMarkupPct !== null) {
        markupSource = 'native';
      } else {
        // Sem markup individual e sem nativo · está usando o markup global · mostra badge
        markupSource = 'global';
      }

      let useMarkup;
      if (markupSource === 'manual') useMarkup = markup;
      else if (markupSource === 'global') useMarkup = globalPct;
      else if (nativeMarkupPct !== null) useMarkup = nativeMarkupPct;
      else useMarkup = (markup !== null) ? markup : globalPct;

      // Vipex Origem · 3-state (igual ao orçamento)
      const vipexNative = m.vipex_origem || snap.fornecedor?.vipex_origem || null;
      const vipexOverride = (typeof ov.vipex_origem === 'string' && ov.vipex_origem !== '') ? ov.vipex_origem : null;
      let vipexValue, vipexSource;
      if (vipexOverride != null)      { vipexValue = vipexOverride; vipexSource = 'edited'; }
      else if (vipexNative)           { vipexValue = vipexNative;   vipexSource = 'native'; }
      else                            { vipexValue = '';            vipexSource = 'empty'; }

      // Helper local: 3-state source de cada spec (espelha helper do orçamento)
      const specSource = (key) => {
        const nativeVal = m[key];
        const overVal = ov[key];
        const hasNative = nativeVal != null && String(nativeVal) !== '';
        const hasOverride = overVal != null && String(overVal) !== '';
        if (hasOverride && String(overVal) !== String(nativeVal ?? '')) return 'edited';
        if (hasNative) return 'native';
        return 'empty';
      };

      const vipexOptions = [
        { value: 'SP-INT3', label: 'SP-INT3 · São Paulo interior' },
        { value: 'SC-INT',  label: 'SC-INT · Santa Catarina interior' },
        { value: 'RS-CAP',  label: 'RS-CAP · Rio Grande do Sul capital' },
        { value: 'RS-INT1', label: 'RS-INT1 · Rio Grande do Sul interior' },
      ];

      const photoUrl = it.selected_photo_url || snap.image_url || '';
      const productUrl = snap.url || (snap.handle ? `/products/${snap.handle}` : '#');
      const productTitle = snap.title || snap.name || it.product_handle || '';

      // Pricing toth · cost editável + markup individual · clone tothPricingHtml
      const clienteUnit = cost * (1 + useMarkup / 100);
      const clienteTotal = clienteUnit * qty;

      return `
        <li class="tsf-quote-item tsf-quote-item--toth" data-tsf-venda-row="${esc(uid)}">
          <span class="tsf-quote-item__index" aria-hidden="true">${String(idx + 1).padStart(2, '0')}</span>

          <figure class="tsf-quote-item__media">
            ${photoUrl
              ? `<a href="${esc(productUrl)}" target="_blank" rel="noopener" aria-label="Abrir produto no site">
                  <img src="${esc(photoUrl)}" alt="${esc(productTitle)}" loading="lazy" width="200" height="200">
                </a>`
              : ''}
          </figure>

          <div class="tsf-quote-item__body">
            <header class="tsf-quote-item__header">
              <h3 class="tsf-quote-item__title">
                <input type="text" class="tsf-quote-item__title-input"
                       value="${esc(productTitle)}"
                       data-tsf-venda-item-edit="title" data-uid="${esc(uid)}"
                       aria-label="Título do produto">
              </h3>
              <button type="button" class="tsf-quote-item__remove tsf-print-hide"
                      data-tsf-venda-item-remove="${esc(uid)}"
                      aria-label="Remover item da venda">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                  <path d="M3 6h18"/><path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/>
                </svg>
              </button>
            </header>

            <dl class="tsf-quote-item__specs tsf-quote-item__specs--editable">
              ${this.#renderVendaSpec('Acabamento', 'cor', cor, uid, specSource('cor'), m.cor)}
              ${this.#renderVendaSpec('Materiais', 'materiais', materiais, uid, specSource('materiais'), m.materiais, true)}
              ${this.#renderVendaSpec('Dimensões', 'dimens_es', dimensoes, uid, specSource('dimens_es'), m.dimens_es, true)}
              ${this.#renderVendaSpec('Prazo (dias)', 'prazo', prazo || '', uid, specSource('prazo'), m.prazo, false, 'number')}
              ${this.#renderVendaVipexSelect('Origem Vipex', 'vipex_origem', vipexValue, vipexOptions, uid, vipexSource, vipexNative)}
            </dl>

            <footer class="tsf-quote-item__footer">
              <div class="tsf-quote-item__qty">
                <label class="tsf-quote-item__qty-label" for="vqty-${esc(uid)}">Quantidade</label>
                <input type="number" id="vqty-${esc(uid)}"
                       class="tsf-quote-item__qty-input"
                       min="1" max="9999" step="1"
                       value="${qty}"
                       data-tsf-venda-item-edit="qty" data-uid="${esc(uid)}"
                       aria-label="Quantidade">
              </div>
              ${this.#renderVendaTothPricing(it, cost, useMarkup, clienteUnit, clienteTotal, nativeMarkupPct, markupSource, globalPct, uid)}
            </footer>
          </div>
        </li>
      `;
    }

    // Onda 10.6 · Spec editável · clone EXATO de TsfQuoteBuilder#editableSpecHtml
    // Reutiliza classes tsf-quote-item__spec* (CSS em toth-specifica-companion.css)
    #renderVendaSpec(label, key, value, uid, source, nativeValue, multiline = false, type = 'text') {
      // 2026-06-28 · delega pro MESMO helper compartilhado do orçamento (de-dup)
      return tsfEditableSpecHtml(label, key, value, uid, source, nativeValue, multiline, type,
        { editAttr: 'data-tsf-venda-item-edit', resetAttr: 'data-tsf-venda-item-reset' });
    }

    // Onda 10.6 · Select Vipex · clone EXATO de TsfQuoteBuilder#editableSelectHtml
    #renderVendaVipexSelect(label, key, value, options, uid, source, nativeValue) {
      // 2026-06-28 · delega pro MESMO helper compartilhado do orçamento (de-dup)
      return tsfEditableSelectHtml(label, key, value, options, uid, source, nativeValue,
        { editAttr: 'data-tsf-venda-item-edit', resetAttrs: (u) => `data-tsf-venda-item-reset="vipex_origem" data-uid="${u}"` });
    }

    // Onda 10.6 · Pricing TOTH · clone EXATO de TsfQuoteBuilder#tothPricingHtml
    // Cost com prefix R$ · markup com suffix x · badges 3-state · botões reset com texto
    #renderVendaTothPricing(it, tothUnit, useMarkup, clienteUnit, clienteTotal, nativeMarkupPct, markupSource, globalPct, uid) {
      // 2026-06-29 · delega pro MESMO helper compartilhado do orçamento (de-dup)
      return tsfTothPricingHtml(it, tothUnit, useMarkup, clienteUnit, clienteTotal, nativeMarkupPct, markupSource, globalPct, uid,
        { editAttr: 'data-tsf-venda-item-edit', markupField: 'markup_mult',
          markupReset: (u) => `data-tsf-venda-item-reset="markup_pct" data-uid="${u}"`,
          costReset: (u) => `data-tsf-venda-item-reset="cost_centavos" data-uid="${u}"`,
          rowTotalAttr: 'data-tsf-venda-row-total' });
    }

    // Onda 10.2 · Atualiza item específico · NÃO faz #render full (preserva foco do input)
    // Subtotal e total são atualizados inline via JS direto · só recompute structural
    // muda (qty step, remove, reset) chama #render.
    #onItemFieldEdit(uid, field, raw, shouldRender = false) {
      if (!this.#sale) return;
      const items = (this.#sale.items || []).map(it => {
        if (it.uid !== uid) return it;
        const next = { ...it };
        const ov = { ...(it.overrides || {}) };
        const snap = it.snapshot || {};

        if (field === 'qty') {
          next.qty = Math.max(1, Math.min(999, parseInt(raw, 10) || 1));
        } else if (field === 'title') {
          // Onda 10.6 · Title edita direto o snapshot (espelha orçamento)
          next.snapshot = { ...snap, title: String(raw == null ? '' : raw) };
        } else if (field === 'markup_mult' || field === 'markup_pct') {
          // Onda 10.4 · Aceita formato multiplicador "1,50" / "1.50" / "1,85x" OU pct direto
          const cleaned = String(raw).replace(/[^\d,.]/g, '').replace(',', '.');
          const n = parseFloat(cleaned);
          let pct = null;
          if (isFinite(n) && n >= 0) {
            // Se < 10 interpreta como multiplicador (1.85 → 85%). Se ≥ 10 como pct direto (85 → 85%).
            pct = n < 10 ? (n - 1) * 100 : n;
            pct = Math.max(0, Math.min(999, parseFloat(pct.toFixed(2))));
          }
          next.markup_pct = pct;
          // Onda 10.7 · NÃO overwrite snap.price_centavos · espelha orçamento
          // Marca source='manual' pra render saber que é edição individual (badge + reset)
          ov.markup_source = 'manual';
          next.overrides = ov;
        } else if (field === 'cost_centavos') {
          const cleaned = String(raw).replace(/[^\d,.-]/g, '').replace(/\.(?=\d{3}(\D|$))/g, '').replace(',', '.');
          const n = parseFloat(cleaned);
          if (isFinite(n)) {
            ov.cost_centavos = Math.round(n * 100);
            next.overrides = ov;
          }
        } else {
          const trimmed = (raw == null) ? '' : String(raw);
          if (trimmed === '' || trimmed === '—') delete ov[field];
          else ov[field] = trimmed;
          next.overrides = ov;
        }
        return next;
      });
      this.#sale.items = items;
      this.#scheduleSave({ items });

      // Onda 10.2 · Re-render condicional · preserva foco em inputs de texto
      if (shouldRender) {
        this.#render();
      } else {
        // Atualiza subtotal do item + total da venda inline (sem re-render full)
        this.#refreshItemSubtotal(uid);
        this.#refreshFinancialTotals();
      }
    }

    // Onda 10.10 · Re-render de UMA linha preservando foco + cursor do input ativo
    // Espelha #refreshRow do orçamento · usado no blur pra atualizar badges (nativo/editado/global)
    // após edição inline (markup, cost, cor, materiais, etc).
    #refreshItemRow(uid) {
      if (!this.#sale) return;
      const items = (this.#sale.items || []).slice().sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
      const idx = items.findIndex(x => x.uid === uid);
      if (idx < 0) return;
      const item = items[idx];
      const isLocked = !this.#isEditable() || !this.#editMode;
      const oldRow = this.querySelector(`[data-tsf-venda-row="${CSS.escape(uid)}"], .tsf-venda-item[data-uid="${CSS.escape(uid)}"]`);
      if (!oldRow) return;
      // Snapshot foco/cursor pra restaurar depois do replaceWith
      const active = document.activeElement;
      const isInsideRow = active && oldRow.contains(active);
      const focusKey = isInsideRow ? active.getAttribute('data-tsf-venda-item-edit') : null;
      const focusSelStart = isInsideRow && 'selectionStart' in active ? active.selectionStart : null;
      const focusSelEnd = isInsideRow && 'selectionEnd' in active ? active.selectionEnd : null;
      const newHtml = this.#renderItemRow(item, idx, isLocked);
      const tmp = document.createElement('template');
      tmp.innerHTML = newHtml.trim();
      const newRow = tmp.content.firstElementChild;
      if (!newRow) return;
      oldRow.replaceWith(newRow);
      // Restaura foco no mesmo input
      if (focusKey) {
        const newInput = newRow.querySelector(`[data-tsf-venda-item-edit="${focusKey}"][data-uid="${CSS.escape(uid)}"]`);
        if (newInput) {
          newInput.focus();
          if (focusSelStart != null && 'setSelectionRange' in newInput) {
            try { newInput.setSelectionRange(focusSelStart, focusSelEnd ?? focusSelStart); } catch {}
          }
        }
      }
    }

    // Onda 10.7 · Atualiza inline o valor cliente + meta "qty × unit" sem re-render
    // Computa live (cost × markup) · usa novos seletores (.tsf-quote-item__client-*) + legacy
    #refreshItemSubtotal(uid) {
      const it = (this.#sale?.items || []).find(x => x.uid === uid);
      if (!it) return;
      const snap = it.snapshot || {};
      const ov = it.overrides || {};
      const qty = it.qty || 1;
      // Cost cascade
      const cost = (typeof ov.cost_centavos === 'number') ? ov.cost_centavos :
                   (typeof snap.cost_centavos === 'number' && snap.cost_centavos > 0) ? snap.cost_centavos :
                   (snap.price_centavos || 0);
      // Markup resolution
      const globalPct = parseFloat(this.#sale?.default_markup_pct) || 50;
      const markup = (typeof it.markup_pct === 'number') ? it.markup_pct : null;
      const nativeMarkupPct = (typeof snap.cost_centavos === 'number' && snap.cost_centavos > 0 &&
                               typeof snap.price_centavos === 'number' && snap.price_centavos > 0)
        ? ((snap.price_centavos - snap.cost_centavos) / snap.cost_centavos) * 100
        : null;
      const explicitSource = ov.markup_source;
      let useMarkup;
      if (explicitSource === 'manual') useMarkup = (markup !== null) ? markup : globalPct;
      else if (explicitSource === 'global') useMarkup = globalPct;
      else if (markup !== null) useMarkup = markup;
      else if (nativeMarkupPct !== null) useMarkup = nativeMarkupPct;
      else useMarkup = globalPct;
      const clienteUnit = cost * (1 + useMarkup / 100);
      const clienteTotal = clienteUnit * qty;
      // Localiza a row (suporta nova estrutura tsf-quote-item + legacy tsf-venda-item)
      const anchor = this.querySelector(`[data-uid="${CSS.escape(uid)}"]`);
      const row = anchor?.closest('.tsf-quote-item, .tsf-venda-item');
      if (!row) return;
      // Novo · valor cliente + meta line
      const totalEl = row.querySelector('[data-tsf-venda-row-total]');
      if (totalEl) totalEl.textContent = money(clienteTotal);
      const metaEl = row.querySelector('.tsf-quote-item__client-meta');
      if (metaEl) metaEl.textContent = `${qty} × ${money(clienteUnit)}`;
      // Legacy · subtotal da view bloqueada
      const subtotalEl = row.querySelector('.tsf-venda-item__subtotal');
      if (subtotalEl) subtotalEl.textContent = money(clienteTotal);
    }

    // Recalcula breakdown financeiro do hero + finance section sem re-render full
    #refreshFinancialTotals() {
      if (!this.#sale) return;
      const fin = this.#computeFinanceSummary(this.#sale, this.#sale.items || []);
      // Hero total · seletor CORRETO (.tsf-venda-hero__value-num) · antes apontava
      // p/ .tsf-venda-hero__total-value (classe inexistente) → topo ficava congelado ao editar.
      const heroTotal = this.querySelector('.tsf-venda-hero__value-num');
      if (heroTotal) heroTotal.textContent = money(fin.totalCliente);
      // Finance section
      const finBody = this.querySelector('.tsf-venda-finance__body');
      if (finBody) {
        // 2026-06-28 · por SELETOR (não índice) · robusto quando o frete some/vira "a calcular"
        const prodEl = finBody.querySelector('[data-tsf-venda-fin="produtos"]');
        if (prodEl) prodEl.textContent = money(fin.produtosTotal);
        const freteEl = finBody.querySelector('[data-tsf-venda-fin="frete"]');
        if (freteEl) freteEl.textContent = fin.frete > 0 ? money(fin.frete) : 'a calcular';
        // total primary
        const primaryRow = finBody.querySelector('.tsf-venda-finance__row--primary .tsf-venda-finance__value');
        if (primaryRow) primaryRow.textContent = money(fin.totalCliente);
        const pixRow = finBody.querySelector('.tsf-venda-finance__row--pix .tsf-venda-finance__value');
        if (pixRow) pixRow.textContent = money(fin.pixValue);
        const internalRows = finBody.querySelectorAll('.tsf-venda-finance__row--internal .tsf-venda-finance__value');
        if (internalRows[0]) internalRows[0].textContent = money(fin.custoTotal);
        if (internalRows[1]) {
          internalRows[1].innerHTML = `${money(fin.margem)} <em class="tsf-venda-finance__pct">+${fin.margemPct.toFixed(0)}%</em>`;
        }
      }
    }

    // Onda 10.7 · Reset · markup_pct é um campo TOP-LEVEL (it.markup_pct), não dentro de overrides
    // Limpa também ov.markup_source pra voltar ao estado nativo
    #onItemReset(uid, field) {
      if (!this.#sale) return;
      const items = (this.#sale.items || []).map(it => {
        if (it.uid !== uid) return it;
        const next = { ...it };
        const ov = { ...(it.overrides || {}) };
        if (field === 'markup_pct') {
          next.markup_pct = null;
          delete ov.markup_source;
        } else {
          delete ov[field];
        }
        next.overrides = ov;
        return next;
      });
      this.#sale.items = items;
      this.#scheduleSave({ items });
      this.#render(); // structural change · re-render OK
    }

    #removeItem(uid) {
      if (!this.#sale) return;
      if (!confirm('Remover este item da venda?\n\nIsso não afeta o orçamento original.')) return;
      const items = (this.#sale.items || []).filter(it => it.uid !== uid);
      this.#sale.items = items;
      this.#scheduleSave({ items });
      this.#render(); // structural change · re-render OK
      // Onda 10.10 · auto-recalc frete silencioso · items mudaram, frete pode ter mudado
      this.#recalcFreight({ silent: true });
    }

    // Onda 10.2 · Recalcula frete baseado em items + CEP do cliente (chama /calculate-shipping)
    // Onda 10.10 · suporta opts.silent · usado por auto-recalc após add/remove sem alerts
    // F3-venda (2026-06-23) · Frete AVULSO/NEGOCIADO · editar + nativo (automático) + voltar (mesmo padrão dos produtos)
    #vendaFreightFieldHtml() {
      const s = this.#sale || {};
      const nat = (typeof s.native_frete_centavos === 'number') ? s.native_frete_centavos : null;
      const cur = (typeof s.frete_centavos === 'number') ? s.frete_centavos : (nat != null ? nat : 0);
      const edited = (nat != null) && (typeof s.frete_centavos === 'number') && (s.frete_centavos !== nat);
      const canEdit = this.#isEditable() && this.#editMode;
      const valStr = (cur / 100).toFixed(2).replace('.', ',');
      const natStr = (nat != null && nat > 0) ? (nat / 100).toFixed(2).replace('.', ',') : null;
      const badge = `<em style="font-style:normal;font-size:.74em;padding:1px 7px;border-radius:999px;margin-left:6px;${edited ? 'background:#fef3c7;color:#92400e;' : 'background:#ecfdf5;color:#065f46;'}">${edited ? 'avulso' : 'automático'}</em>`;
      const resetBtn = (edited && natStr && canEdit)
        ? ` <button type="button" data-tsf-venda-freight-reset title="Voltar ao frete automático da transportadora" style="font:inherit;font-size:.8em;background:transparent;border:0;color:inherit;opacity:.7;cursor:pointer;text-decoration:underline;padding:0;">↺ automático R$ ${natStr}</button>`
        : '';
      const valHtml = canEdit
        ? `R$ <input type="text" inputmode="decimal" data-tsf-venda-freight-edit value="${valStr}" aria-label="Frete avulso ou negociado em reais" style="width:7em;text-align:right;font:inherit;color:inherit;background:transparent;border:0;border-bottom:1px solid currentColor;padding:0 2px;">`
        : `R$ ${valStr}`;
      return `
        <div class="tsf-venda-freight-card__row">
          <span class="tsf-venda-freight-card__icon" aria-hidden="true">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>
          </span>
          <span class="tsf-venda-freight-card__label">Frete avulso/negociado${badge}</span>
          <span class="tsf-venda-freight-card__value">${valHtml}${resetBtn}</span>
        </div>`;
    }

    async #recalcFreight(opts = {}) {
      if (!this.#sale) return;
      const silent = opts.silent === true;
      const ci = this.#sale.client_info || {};
      const cep = (ci.cep || '').replace(/\D/g, '');
      if (cep.length !== 8) {
        if (!silent) alert('Cliente não tem CEP válido. Adicione o CEP antes de recalcular o frete.');
        return;
      }
      const btn = this.querySelector('[data-tsf-venda-recalc-freight]');
      if (btn && !silent) { btn.disabled = true; btn.querySelector('span').textContent = 'Calculando…'; }
      // 2026-06-29 · PADRONIZAÇÃO: motor de frete multi-origem COMPARTILHADO com o orçamento
      // (agrupa por origem Vipex · 1 chamada por origem em paralelo · soma). Antes a venda mandava
      // tudo numa chamada só e pegava a 1ª opção → subestimava o frete com fornecedores de origens diferentes.
      const _frete = await tsfComputeMultiOriginFreight(this.#sale.items, cep);
      if (_frete.empty) {
        // Nenhum item com embalagem · zera o frete (não há como calcular) · silencioso quando auto
        if (this.#sale.frete_centavos > 0) {
          this.#sale.frete_centavos = 0;
          this.#scheduleSave({ frete_centavos: 0 });
          this.#refreshFinancialTotals();
        }
        if (btn && !silent) { btn.disabled = false; const _sp = btn.querySelector('span'); if (_sp) _sp.textContent = 'Recalcular frete'; }
        if (!silent) alert('Nenhum item com embalagem cadastrada. Frete não pode ser calculado automaticamente.');
        return;
      }
      try {
        const freteCentavos = _frete.totalCentavos;
        // F3-venda (2026-06-23) · automático = NATIVO; só sobrescreve o atual se não foi editado à mão (avulso/negociado)
        {
          const oldNative = this.#sale.native_frete_centavos;
          const curFrete = this.#sale.frete_centavos;
          const freteWasEdited = (curFrete != null) && (oldNative != null) && (curFrete !== oldNative);
          this.#sale.native_frete_centavos = freteCentavos;
          this.#sale.native_transportadora = 'Vipex';
          if (!freteWasEdited) { this.#sale.frete_centavos = freteCentavos; this.#sale.transportadora = 'Vipex'; }
          this.#scheduleSave({ frete_centavos: this.#sale.frete_centavos, native_frete_centavos: freteCentavos, transportadora: this.#sale.transportadora || 'Vipex', native_transportadora: 'Vipex' });
        }
        if (silent) {
          // Auto-recalc · só atualiza totais inline, evita re-render que desfocaria input ativo
          this.#refreshFinancialTotals();
        } else {
          this.#render();
        }
      } catch (err) {
        if (!silent) alert('Erro: ' + err.message);
      } finally {
        if (btn && !silent) {
          btn.disabled = false;
          const span = btn.querySelector('span');
          if (span) span.textContent = 'Recalcular frete';
        }
      }
    }

    // Onda 10.4 · Picker rico · modal de busca com Shopify Predictive Search
    // Substitui o prompt() arcaico. Search live · resultados em cards · click adiciona.
    // 2026-06-29 · ITEM 5 · picker enriquecido (filtros por fornecedor + teclado + qty) · paridade c/ orçamento
    #pickerFilter = 'all';
    #pickerActiveIdx = -1;
    #openProductPicker() {
      let modal = document.querySelector('.tsf-venda-picker-modal');
      if (modal) { modal.remove(); }
      this.#pickerFilter = 'all';
      this.#pickerActiveIdx = -1;
      modal = document.createElement('div');
      modal.className = 'tsf-venda-picker-modal';
      modal.innerHTML = `
        <div class="tsf-venda-picker-modal__backdrop" data-tsf-picker-close></div>
        <div class="tsf-venda-picker-modal__panel" role="dialog" aria-modal="true" aria-labelledby="tsf-picker-title">
          <header class="tsf-venda-picker-modal__head">
            <div>
              <span class="tsf-venda-picker-modal__eyebrow">Catálogo Toth</span>
              <h2 id="tsf-picker-title" class="tsf-venda-picker-modal__title">Adicionar produto à venda</h2>
              <p class="tsf-venda-picker-modal__lede">Busque · filtre por fornecedor · ↑↓ navega, Enter adiciona</p>
            </div>
            <button type="button" class="tsf-venda-picker-modal__close" data-tsf-picker-close aria-label="Fechar">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            </button>
          </header>
          <div class="tsf-venda-picker-modal__search">
            <svg class="tsf-venda-picker-modal__search-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><circle cx="11" cy="11" r="7"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
            <input type="search" class="tsf-venda-picker-modal__input" placeholder="Buscar · banqueta, mesa, sofá, poltrona…" autocomplete="off" data-tsf-picker-input>
          </div>
          <div class="tsf-venda-picker-modal__filters" data-tsf-picker-filters></div>
          <div class="tsf-venda-picker-modal__results" data-tsf-picker-results>
            <div class="tsf-venda-picker-modal__empty">Digite pra começar a buscar</div>
          </div>
        </div>
      `;
      document.body.appendChild(modal);

      // Filtros por fornecedor (mesma lista do orçamento · filtro client-side no #runProductPickerSearch)
      const filters = [
        { key: 'all', label: 'Todos' }, { key: 'vendor:heitor', label: 'Heitor' }, { key: 'vendor:n-correa', label: 'N Correa' },
        { key: 'vendor:diplomata', label: 'Diplomata' }, { key: 'vendor:cmd', label: 'CMD' }, { key: 'vendor:aco-mobilia', label: 'Aço Mobília' }, { key: 'vendor:zomer', label: 'Zomer' },
      ];
      const filtersEl = modal.querySelector('[data-tsf-picker-filters]');
      filtersEl.innerHTML = filters.map(f => `<button type="button" class="tsf-venda-picker-modal__filter${f.key === 'all' ? ' is-active' : ''}" data-tsf-picker-filter="${f.key}">${this.#esc(f.label)}</button>`).join('');
      filtersEl.querySelectorAll('[data-tsf-picker-filter]').forEach(b => b.addEventListener('click', () => {
        this.#pickerFilter = b.dataset.tsfPickerFilter;
        filtersEl.querySelectorAll('[data-tsf-picker-filter]').forEach(x => x.classList.toggle('is-active', x === b));
        const q = (modal.querySelector('[data-tsf-picker-input]')?.value || '').trim();
        if (q.length >= 2) this.#runProductPickerSearch(q, modal);
      }));

      // Close (backdrop/X) + teclado (ESC/↑↓/Enter · paridade c/ orçamento)
      modal.addEventListener('click', (e) => { if (e.target.closest('[data-tsf-picker-close]')) modal.remove(); });
      const input = modal.querySelector('[data-tsf-picker-input]');
      const keyHandler = (e) => {
        if (!document.body.contains(modal)) { document.removeEventListener('keydown', keyHandler); return; }
        if (e.key === 'Escape') { modal.remove(); document.removeEventListener('keydown', keyHandler); return; }
        if (e.key === 'ArrowDown') { e.preventDefault(); this.#movePickerActive(modal, 1); return; }
        if (e.key === 'ArrowUp') { e.preventDefault(); this.#movePickerActive(modal, -1); return; }
        if (e.key === 'Enter' && document.activeElement === input) {
          e.preventDefault();
          modal.querySelector('[data-tsf-picker-card].is-active [data-tsf-picker-add]')?.click();
        }
      };
      document.addEventListener('keydown', keyHandler);

      // Search debounced
      let searchTimer = null;
      input.addEventListener('input', () => {
        clearTimeout(searchTimer);
        searchTimer = setTimeout(() => this.#runProductPickerSearch(input.value, modal), 220);
      });
      requestAnimationFrame(() => input.focus());
    }

    #movePickerActive(modal, dir) {
      const cards = Array.from(modal.querySelectorAll('[data-tsf-picker-card]'));
      if (!cards.length) return;
      const base = this.#pickerActiveIdx < 0 ? 0 : this.#pickerActiveIdx;
      this.#pickerActiveIdx = Math.max(0, Math.min(cards.length - 1, base + dir));
      cards.forEach((c, i) => c.classList.toggle('is-active', i === this.#pickerActiveIdx));
      cards[this.#pickerActiveIdx]?.scrollIntoView({ block: 'nearest' });
    }

    #syncPickerActive(modal) {
      const cards = Array.from(modal.querySelectorAll('[data-tsf-picker-card]'));
      cards.forEach((c, i) => c.classList.toggle('is-active', i === this.#pickerActiveIdx));
    }

    async #runProductPickerSearch(q, modal) {
      const resultsEl = modal.querySelector('[data-tsf-picker-results]');
      const term = (q || '').trim();
      if (term.length < 2) {
        resultsEl.innerHTML = '<div class="tsf-venda-picker-modal__empty">Digite pelo menos 2 letras</div>';
        return;
      }
      resultsEl.innerHTML = '<div class="tsf-venda-picker-modal__loading">Buscando…</div>';
      try {
        // Shopify Predictive Search API · mesma engine usada no orçamento
        const res = await fetch(`/search/suggest.json?q=${encodeURIComponent(term)}&resources[type]=product&resources[limit]=12&resources[options][unavailable_products]=last&resources[options][fields]=title,vendor,product_type,tag`);
        const data = await res.json();
        let products = data.resources?.results?.products || [];
        // 2026-06-29 · filtro client-side por fornecedor (Predictive não filtra direto · igual orçamento)
        if (this.#pickerFilter && this.#pickerFilter.startsWith('vendor:')) {
          const want = this.#pickerFilter.slice('vendor:'.length);
          products = products.filter(p => {
            const v = (p.vendor || '').toLowerCase().replace(/\s+/g, '-').normalize('NFD').replace(/[̀-ͯ]/g, '');
            return v === want || v.includes(want) || want.includes(v);
          });
        }
        if (products.length === 0) {
          resultsEl.innerHTML = `<div class="tsf-venda-picker-modal__empty">Nenhum produto pra "${this.#esc(term)}"${this.#pickerFilter !== 'all' ? ' nesse fornecedor' : ''}</div>`;
          this.#pickerActiveIdx = -1;
          return;
        }
        resultsEl.innerHTML = `
          <div class="tsf-venda-picker-modal__grid">
            ${products.map((p, idx) => `
              <div class="tsf-venda-picker-modal__card" data-tsf-picker-card data-idx="${idx}" data-tsf-picker-handle="${this.#esc(p.handle)}">
                <div class="tsf-venda-picker-modal__card-photo">
                  ${p.image ? `<img src="${this.#esc(p.image)}" alt="${this.#esc(p.title)}" loading="lazy">` : ''}
                </div>
                <div class="tsf-venda-picker-modal__card-body">
                  <strong class="tsf-venda-picker-modal__card-title">${this.#esc(p.title)}</strong>
                  ${p.vendor ? `<span class="tsf-venda-picker-modal__card-vendor">${this.#esc(p.vendor)}</span>` : ''}
                  ${p.price ? `<span class="tsf-venda-picker-modal__card-price">${this.#esc(p.price)}</span>` : ''}
                </div>
                <div class="tsf-venda-picker-modal__card-qty" data-tsf-picker-qtybox>
                  <button type="button" class="tsf-venda-picker-modal__qty-btn" data-tsf-picker-qty="-1" aria-label="Menos">−</button>
                  <span class="tsf-venda-picker-modal__qty-val" data-tsf-picker-qtyval>1</span>
                  <button type="button" class="tsf-venda-picker-modal__qty-btn" data-tsf-picker-qty="1" aria-label="Mais">+</button>
                </div>
                <button type="button" class="tsf-venda-picker-modal__card-cta" data-tsf-picker-add>+ adicionar</button>
              </div>
            `).join('')}
          </div>
        `;
        this.#pickerActiveIdx = 0;
        this.#syncPickerActive(modal);
        // qty stepper · ajusta a quantidade do card (não adiciona)
        resultsEl.querySelectorAll('[data-tsf-picker-qty]').forEach(btn => {
          btn.addEventListener('click', (e) => {
            e.stopPropagation();
            const valEl = btn.closest('[data-tsf-picker-qtybox]')?.querySelector('[data-tsf-picker-qtyval]');
            if (!valEl) return;
            const cur = parseInt(valEl.textContent, 10) || 1;
            valEl.textContent = String(Math.max(1, Math.min(999, cur + parseInt(btn.dataset.tsfPickerQty, 10))));
          });
        });
        // hover ativa o card (sincroniza com a navegação por teclado)
        resultsEl.querySelectorAll('[data-tsf-picker-card]').forEach(card => {
          card.addEventListener('mouseenter', () => { this.#pickerActiveIdx = parseInt(card.dataset.idx, 10) || 0; this.#syncPickerActive(modal); });
        });
        // adicionar (lê a qty escolhida no card)
        resultsEl.querySelectorAll('[data-tsf-picker-add]').forEach(addBtn => {
          addBtn.addEventListener('click', async (e) => {
            e.stopPropagation();
            const card = addBtn.closest('[data-tsf-picker-card]');
            if (card.dataset.tsfPickerAdded) return; // anti-double-click
            card.dataset.tsfPickerAdded = '1';
            const qty = parseInt(card.querySelector('[data-tsf-picker-qtyval]')?.textContent, 10) || 1;
            addBtn.textContent = 'adicionando…';
            const ok = await this.#addProductByHandle(card.dataset.tsfPickerHandle, qty);
            if (ok) {
              addBtn.textContent = '✓ adicionado'; card.classList.add('is-added');
              setTimeout(() => { delete card.dataset.tsfPickerAdded; addBtn.textContent = '+ adicionar'; card.classList.remove('is-added'); }, 1500);
            } else {
              addBtn.textContent = '✗ falhou'; delete card.dataset.tsfPickerAdded;
            }
          });
        });
      } catch (err) {
        resultsEl.innerHTML = `<div class="tsf-venda-picker-modal__empty">Erro: ${this.#esc(err.message)}</div>`;
      }
    }

    async #addProductByHandle(handle, qty = 1) {
      if (!handle) return false;
      try {
        const snapRes = await fetch(`${QUOTE_ENDPOINT}/product-snapshot?handle=${encodeURIComponent(handle)}`);
        const snapData = await snapRes.json();
        if (!snapData.ok || !snapData.item) return false;
        const newItem = {
          ...snapData.item,
          uid: (crypto.randomUUID ? crypto.randomUUID() : ('uid-' + Math.random().toString(36).slice(2))),
          qty: Math.max(1, parseInt(qty, 10) || 1),
          order: (this.#sale.items || []).length,
          markup_pct: null,
          overrides: {},
          selected_photo_url: null,
        };
        const items = [...(this.#sale.items || []), newItem];
        this.#sale.items = items;
        this.#scheduleSave({ items });
        this.#render();
        // Onda 10.10 · auto-recalc frete silencioso · novo item entrou no cálculo
        this.#recalcFreight({ silent: true });
        return true;
      } catch {
        return false;
      }
    }

    // Onda 10.7 · Markup GLOBAL · aplica % a todos items EXCETO os manualmente editados
    // NÃO overwrite snap.price_centavos (preserva nativo) · marca ov.markup_source='global'
    // Espelha lógica do orçamento (#onMarkupChange)
    #applyGlobalMarkup(pct) {
      if (!this.#sale) return;
      const n = parseFloat(pct);
      if (!isFinite(n) || n < 0) return;
      // 2026-06-29 · padronização: pinta o fill dourado conforme arrasta (paridade c/ orçamento)
      tsfPaintSliderGradient(this.querySelector('[data-tsf-venda-markup-input]'));
      const items = (this.#sale.items || []).map(it => {
        const ov = { ...(it.overrides || {}) };
        // Onda 10.7 · preserva edições manuais individuais
        if (ov.markup_source === 'manual') return it;
        ov.markup_source = 'global';
        return { ...it, markup_pct: n, overrides: ov };
      });
      this.#sale.items = items;
      this.#sale.default_markup_pct = n;
      this.#scheduleSave({ items, default_markup_pct: n });
      this.#refreshFinancialTotals();
      // Sincroniza inputs visíveis (formato multiplicador 1,50x) sem re-render
      const multDisplay = (1 + n/100).toFixed(2).replace('.', ',');
      for (const it of items) {
        this.#refreshItemSubtotal(it.uid);
        // Pula items manuais · não sobrescreve o valor visível deles
        if ((it.overrides?.markup_source) === 'manual') continue;
        const markupInput = this.querySelector(`[data-tsf-venda-item-edit="markup_mult"][data-uid="${CSS.escape(it.uid)}"]`);
        if (markupInput && document.activeElement !== markupInput) {
          markupInput.value = multDisplay;
        }
      }
      const out = this.querySelector('[data-tsf-venda-markup-output]');
      if (out) out.textContent = `${(1 + n/100).toFixed(2).replace('.', ',')}x`;
    }

    // Onda 10.3 · Frete & logística · visual editorial premium · valor grande à direita
    // Onda 10.11 · Botão "Recalcular frete" trazido pra cá (era na toolbar de items)
    #renderFreightSection(s, ci, fin) {
      const cep = (ci.cep || '').replace(/\D/g, '');
      // Fase 0.3 · a seção de frete SEMPRE aparece (toda venda tem frete a controlar).
      // Sem CEP/sem valor → mostra estado-vazio com call-to-action, em vez de sumir.
      const hasCep = cep.length === 8;
      const cepDisplay = hasCep ? `${cep.slice(0,5)}-${cep.slice(5)}` : '—';
      const cardSurchargePct = ci.card_surcharge_pct ?? 15;
      const cidade = ci.address?.localidade || ci.address?.cidade || '—';
      const uf = ci.address?.uf || '';
      const canEdit = this.#isEditable() && this.#editMode;
      const isEditableStatus = this.#isEditable();

      // Botão recalcular · só em modo edit (não tem sentido recalcular em venda confirmada/cancelada)
      const recalcBtn = canEdit ? `
        <button type="button" class="tsf-admin-venda-section__btn tsf-venda-freight-recalc" data-tsf-venda-recalc-freight title="Recalcular frete com items + CEP atuais">
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <polyline points="23 4 23 10 17 10"/><polyline points="1 20 1 14 7 14"/><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/>
          </svg>
          <span>Recalcular frete</span>
        </button>
      ` : '';

      // FREIGHT-TOGGLE · estado do toggle vindo de sale.client_info.freight_mode
      const freightEnabledVenda = ((s.client_info?.freight_mode || 'charge').toString().toLowerCase() !== 'none');
      return `
        <section class="tsf-admin-venda-section">
          <header class="tsf-admin-venda-section__head">
            <h2>Frete &amp; Logística</h2>
            <span class="tsf-admin-venda-section__hint">via Vipex Compact</span>
            ${recalcBtn}
          </header>

          <div class="tsf-freight-toggle">
            <label class="tsf-freight-toggle__row">
              <input type="checkbox" data-tsf-venda-freight-toggle ${freightEnabledVenda ? 'checked' : ''} ${canEdit ? '' : 'disabled'}>
              <span class="tsf-freight-toggle__switch" aria-hidden="true"></span>
              <span class="tsf-freight-toggle__body">
                <span class="tsf-freight-toggle__title">Incluir frete no total da venda</span>
                <span class="tsf-freight-toggle__hint">desligue se for grátis pro cliente ou se o cliente buscar por conta</span>
              </span>
            </label>
          </div>

          <div class="tsf-venda-freight-card" ${freightEnabledVenda ? '' : 'style="display:none;"'}>
            <div class="tsf-venda-freight-card__info">
              <div class="tsf-venda-freight-card__row">
                <span class="tsf-venda-freight-card__icon" aria-hidden="true">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>
                </span>
                <span class="tsf-venda-freight-card__label">Destino</span>
                <span class="tsf-venda-freight-card__value">${hasCep ? `${this.#esc(cidade)}/${this.#esc(uf)} · CEP ${this.#esc(cepDisplay)}` : '<em style="opacity:.65;font-style:normal;">CEP do cliente não informado</em>'}</span>
              </div>
              <div class="tsf-venda-freight-card__row">
                <span class="tsf-venda-freight-card__icon" aria-hidden="true">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>
                </span>
                <span class="tsf-venda-freight-card__label">Transportadora</span>
                <span class="tsf-venda-freight-card__value">${this.#esc(s.transportadora || 'Vipex')}</span>
              </div>
              <div class="tsf-venda-freight-card__row tsf-venda-freight-card__row--meta">
                <span class="tsf-venda-freight-card__icon" aria-hidden="true">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="4" width="22" height="16" rx="2" ry="2"/><line x1="1" y1="10" x2="23" y2="10"/></svg>
                </span>
                <span class="tsf-venda-freight-card__label">Taxa do cartão sobre frete</span>
                <span class="tsf-venda-freight-card__value tsf-venda-freight-card__value--meta">${canEdit
                  ? `<input type="text" inputmode="decimal" data-tsf-venda-card-pct value="${cardSurchargePct}" aria-label="Taxa do cartão sobre o frete em %" style="width:3.4em;text-align:right;font:inherit;color:inherit;background:transparent;border:0;border-bottom:1px solid currentColor;padding:0 2px;">% <em>· embutido no frete</em>`
                  : `${cardSurchargePct}% <em>· embutido no frete</em>`}</span>
              </div>
              ${this.#vendaFreightFieldHtml()}
            </div>

            <div class="tsf-venda-freight-card__total">
              <span class="tsf-venda-freight-card__total-label">Frete total</span>
              ${fin.frete > 0
                ? `<span class="tsf-venda-freight-card__total-value">${money(fin.frete)}${(fin.freteOriginal && fin.frete > fin.freteOriginal) ? `<br><em class="tsf-venda-freight-card__total-orig" style="font-size:.8em;opacity:.6;font-style:normal;">${fin.isVipexAuto ? 'Vipex' : 'Frete avulso'} ${money(fin.freteOriginal)} · +${fin.cardPct}% cartão embutido</em>` : ''}</span>`
                : !isEditableStatus
                  ? `<span class="tsf-venda-freight-card__total-pending" style="opacity:.6;">não informado</span>`
                  : hasCep
                    ? `<span class="tsf-venda-freight-card__total-pending">a calcular<br><em>${canEdit ? 'use o botão “Recalcular frete” acima' : 'entre em “Editar venda” e recalcule'}</em></span>`
                    : `<span class="tsf-venda-freight-card__total-pending">a calcular<br><em>informe o CEP do cliente em Cliente → “Editar cadastro”</em></span>`}
            </div>
          </div>
        </section>
      `;
    }

    // Pedidos pra fábrica · lista os vinculados + botão "Gerar pedidos"

    // Onda 12.2 · Autoridade · seleção INDEPENDENTE da venda (não herda do orçamento)
    // Visual idêntico ao orçamento · usa MESMAS classes CSS pra paridade total
    // Onda 12.3 · Autoridade NÃO depende do editMode · só do status (paridade com orçamento)
    // É metadata do PDF, não decisão financeira · sempre interativa quando venda é editável.
    #renderAuthoritySection(s, _isLocked) {
      const ci = s.client_info || {};
      const blocks = Array.isArray(ci.authority_blocks) ? ci.authority_blocks : [];
      const isSelected = (k) => blocks.includes(k);
      // Autoridade interativa SE venda permite edição por status (rascunho/confirmada)
      // Bloqueia só em em_producao/entregue/cancelada (compromisso histórico)
      const canEditAuthority = this.#isEditable();
      const count = blocks.length;
      const countLabel = count === 0 ? 'Nenhum bloco selecionado'
        : `${count} ${count === 1 ? 'bloco selecionado' : 'blocos selecionados'}`;
      const opt = (key, title, desc) => `
        <label class="tsf-quote-authority__opt" data-tsf-venda-authority-opt="${key}">
          <input type="checkbox" class="tsf-quote-authority__check"
                 data-tsf-venda-authority-check="${key}"
                 ${isSelected(key) ? 'checked' : ''}
                 ${canEditAuthority ? '' : 'disabled'}>
          <span class="tsf-quote-authority__opt-body">
            <span class="tsf-quote-authority__opt-title">${title}</span>
            <span class="tsf-quote-authority__opt-desc" data-tsf-venda-authority-meta="${key}">${desc}</span>
          </span>
        </label>
      `;
      return `
        <section class="tsf-admin-venda-section tsf-quote-authority tsf-venda-authority" data-tsf-venda-authority>
          <header class="tsf-quote-authority__head">
            <h2 class="tsf-quote-authority__heading">Autoridade</h2>
            <button type="button" class="tsf-quote-authority__toggle" data-tsf-venda-authority-toggle aria-expanded="true">
              <span>Páginas editoriais opcionais no PDF</span>
              <svg width="10" height="6" viewBox="0 0 10 6" fill="none" aria-hidden="true">
                <path d="M1 1l4 4 4-4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
          </header>
          <div class="tsf-quote-authority__body">
            <p class="tsf-quote-authority__hint">
              Páginas extras opcionais. Marque o que reforça a proposta — o cliente recebe um documento que vende sozinho.
              <em style="display:block;margin-top:4px;color:rgba(26,25,24,0.4);font-style:italic">Esta seleção é da venda · independente do orçamento que originou.</em>
            </p>
            <div class="tsf-quote-authority__grid">
              ${opt('institucional', 'Quem é a Toth', 'Heritage editorial · 3 cards institucionais com fotos')}
              ${opt('clients', 'Casas que confiaram em nós', 'Grade de logos de clientes corporativos')}
              ${opt('testimonials', 'Depoimentos', 'Citações com nome, cargo e foto do ambiente')}
              ${opt('projects', 'Realizações como a sua', 'Projetos curados por material/ambiente da venda atual')}
            </div>
            <footer class="tsf-quote-authority__foot">
              <span class="tsf-quote-authority__count" data-tsf-venda-authority-count>${countLabel}</span>
              <span class="tsf-quote-authority__status" data-tsf-venda-authority-status></span>
            </footer>
          </div>
        </section>
      `;
    }

    // Onda 12.2 · Toggle de bloco · salva em client_info.authority_blocks
    #onAuthorityToggle(key, checked) {
      if (!this.#sale) return;
      const ci = this.#sale.client_info || {};
      const blocks = Array.isArray(ci.authority_blocks) ? [...ci.authority_blocks] : [];
      const idx = blocks.indexOf(key);
      if (checked && idx < 0) blocks.push(key);
      else if (!checked && idx >= 0) blocks.splice(idx, 1);
      this.#sale.client_info = { ...ci, authority_blocks: blocks };
      this.#scheduleSave({ client_info: this.#sale.client_info });
      // Atualiza count inline · sem re-render full (preserva foco)
      const count = blocks.length;
      const countLabel = count === 0 ? 'Nenhum bloco selecionado'
        : `${count} ${count === 1 ? 'bloco selecionado' : 'blocos selecionados'}`;
      const countEl = this.querySelector('[data-tsf-venda-authority-count]');
      if (countEl) countEl.textContent = countLabel;
      // Se algum bloco está marcado, busca metadata em background pra mostrar "5 logos · 2 depoimentos"
      if (blocks.length > 0) this.#prefetchAuthorityMeta();
    }

    // Onda 12.2 · Busca content metadata pra mostrar count em cada bloco
    async #prefetchAuthorityMeta() {
      if (this.#authorityContent || !this.#sale?.id) return;
      const statusEl = this.querySelector('[data-tsf-venda-authority-status]');
      if (statusEl) statusEl.textContent = 'Carregando conteúdo curado…';
      try {
        const res = await fetch(`${SALE_ENDPOINT}/authority?id=${encodeURIComponent(this.#sale.id)}`);
        const data = await res.json();
        if (data?.ok && data.content) {
          this.#authorityContent = data.content;
          if (statusEl) statusEl.textContent = 'Conteúdo curado pronto';
          this.#updateAuthorityMeta();
        } else {
          if (statusEl) statusEl.textContent = 'Não foi possível carregar';
        }
      } catch {
        if (statusEl) statusEl.textContent = 'Falha de rede';
      }
    }

    // Onda 12.2 · Atualiza os textos "X cards / Y logos / Z depoimentos / N projetos"
    // dentro de cada opção · informa o vendor o que ele vai inserir no PDF.
    #updateAuthorityMeta() {
      const c = this.#authorityContent;
      if (!c) return;
      const set = (key, text) => {
        const el = this.querySelector(`[data-tsf-venda-authority-meta="${key}"]`);
        if (el) el.textContent = text;
      };
      // Institucional · conta cards (titulo_1/2/3) + logos
      if (c.institucional) {
        const cards = [1, 2, 3].filter(i => c.institucional[`titulo_${i}`] || c.institucional[`descricao_${i}`]).length;
        const logos = [1, 2, 3, 4, 5].filter(i => c.institucional[`cliente_${i}`]).length;
        set('institucional', cards === 0
          ? 'Sem conteúdo institucional cadastrado · adicione em Admin → Metaobjects'
          : `${cards} ${cards === 1 ? 'card' : 'cards'} institucionais${logos ? ` + ${logos} ${logos === 1 ? 'logo' : 'logos'}` : ''}`);
      }
      // Clients · grupo de logos
      const clientLogos = (c.clients?.logo || []).filter(Boolean).length;
      set('clients', clientLogos === 0
        ? 'Sem grupo de clientes cadastrado · adicione em Admin → Metaobjects'
        : `${clientLogos} ${clientLogos === 1 ? 'logo corporativo' : 'logos corporativos'}`);
      // Testimonials
      const t = (c.testimonials || []).length;
      set('testimonials', t === 0
        ? 'Sem depoimentos cadastrados · adicione em Admin → Metaobjects'
        : `${t} ${t === 1 ? 'depoimento curado' : 'depoimentos curados'}`);
      // Projects
      const p = (c.projects || []).length;
      set('projects', p === 0
        ? 'Sem realizações cadastradas · adicione em Admin → Metaobjects'
        : `${p} ${p === 1 ? 'projeto curado' : 'projetos curados'} por material/ambiente`);
    }

    #renderRelatedPedidos(s) {
      const peds = this.#pedidos || [];
      const statusBadgeMap = {
        draft: { label: 'Rascunho', cls: 'tsf-venda-ped-status--draft' },
        sent: { label: 'Enviado', cls: 'tsf-venda-ped-status--sent' },
        confirmed: { label: 'Confirmado', cls: 'tsf-venda-ped-status--confirmed' },
        shipped: { label: 'Em rota', cls: 'tsf-venda-ped-status--shipped' },
        delivered: { label: 'Entregue', cls: 'tsf-venda-ped-status--delivered' },
        cancelled: { label: 'Cancelado', cls: 'tsf-venda-ped-status--cancelled' },
        alteration_requested: { label: 'Alteração pedida', cls: 'tsf-venda-ped-status--alt' },
      };

      const generateBtn = (s.status !== 'cancelada') ? `
        <button type="button" class="tsf-admin-venda-section__btn" data-tsf-admin-venda-action="generate-pedidos">
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true">
            <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
          </svg>
          <span>${peds.length ? 'Atualizar pedidos' : 'Gerar pedidos'}</span>
        </button>
      ` : '';

      return `
        <section class="tsf-admin-venda-section">
          <header class="tsf-admin-venda-section__head">
            <h2>Pedidos pra fábrica <span>${peds.length} ${peds.length === 1 ? 'pedido' : 'pedidos'}</span></h2>
            ${generateBtn}
          </header>
          <div class="tsf-admin-venda-section__body">
            ${peds.length === 0 ? `
              <p class="tsf-venda-empty">Nenhum pedido gerado ainda. Clique em "Gerar pedidos" pra criar um por fornecedor automaticamente.</p>
            ` : `
              <ol class="tsf-venda-pedidos-list">
                ${peds.map(p => {
                  const status = statusBadgeMap[p.status] || statusBadgeMap.draft;
                  const itemCount = Array.isArray(p.items) ? p.items.length : 0;
                  const fornecedor = p.snapshot_fornecedor?.nome || p.fornecedor_handle || '—';
                  return `
                    <li class="tsf-venda-pedido-card">
                      <div class="tsf-venda-pedido-card__main">
                        <span class="tsf-venda-pedido-card__number">${this.#esc(p.numero_pedido)}</span>
                        <span class="tsf-venda-pedido-card__vendor">${this.#esc(fornecedor)}</span>
                        <span class="tsf-venda-pedido-card__items">${itemCount} ${itemCount === 1 ? 'item' : 'items'}</span>
                      </div>
                      <span class="tsf-venda-ped-status ${status.cls}">${status.label}</span>
                      <a href="/pages/admin-pedido?id=${this.#esc(p.id)}" class="tsf-venda-pedido-card__open">Abrir →</a>
                    </li>
                  `;
                }).join('')}
              </ol>
            `}
          </div>
        </section>
      `;
    }


    // Onda 12 · PDF da venda · editorial Hermès cliente-final (clone do orçamento adaptado)
    async #openPdf() {
      if (!this.#sale) return;
      const w = window.open('', '_blank', 'width=900,height=1200');
      if (!w) {
        alert('Permita pop-ups pra gerar o PDF. Clique no ícone de bloqueio na barra de endereços.');
        return;
      }
      // Flush save pendente · garante items/valores recentes no banco
      try {
        if (this.#pendingPatch || this.#saveTimer) await this.#flushSave();
      } catch {}
      // Onda 12.2 · Busca conteúdo de autoridade · seleção INDEPENDENTE da venda (não herda do orçamento)
      // Usa /sale/authority com signals baseados nos items DA VENDA (que podem diferir do orçamento)
      const blocks = (this.#sale?.client_info?.authority_blocks) || [];
      if (blocks.length > 0 && !this.#authorityContent) {
        w.document.open();
        w.document.write('<!DOCTYPE html><html><head><meta charset="utf-8"><title>Gerando…</title><style>body{font-family:Montserrat,sans-serif;display:grid;place-items:center;min-height:100vh;margin:0;color:#1a1918}.l{font-size:11px;letter-spacing:.18em;text-transform:uppercase;color:#A16207}</style></head><body><div><div class="l">Curando conteúdo editorial…</div></div></body></html>');
        w.document.close();
        try {
          const res = await fetch(`${SALE_ENDPOINT}/authority?id=${encodeURIComponent(this.#sale.id)}`);
          const data = await res.json();
          if (data?.ok && data.content) this.#authorityContent = data.content;
        } catch {}
      }
      const html = this.#buildVendaPdfDocument();
      w.document.open();
      w.document.write(html);
      w.document.close();
      const printWhenReady = () => {
        try {
          const imgs = Array.from(w.document.images || []);
          const pending = imgs.filter(img => !img.complete);
          if (pending.length === 0) { w.focus(); w.print(); return; }
          let loaded = 0;
          const checkDone = () => { loaded++; if (loaded >= pending.length) { w.focus(); w.print(); } };
          pending.forEach(img => {
            img.addEventListener('load', checkDone);
            img.addEventListener('error', checkDone);
          });
          setTimeout(() => { try { w.focus(); w.print(); } catch {} }, 5000);
        } catch {
          try { w.print(); } catch {}
        }
      };
      if (w.document.readyState === 'complete') printWhenReady();
      else w.addEventListener('load', printWhenReady, { once: true });
    }

    #buildVendaPdfDocument() {
      const s = this.#sale;
      const ci = s.client_info || {};
      const items = Array.isArray(s.items) ? s.items : [];
      const fin = this.#computeFinanceSummary(s, items);
      const created = s.created_at ? new Date(s.created_at) : new Date();
      const fmtDate = (d) => new Intl.DateTimeFormat('pt-BR', { day: '2-digit', month: 'long', year: 'numeric' }).format(d);
      const dateStr = fmtDate(created);
      const vendaNumber = s.numero_venda || `TOTH-VND-${created.getFullYear()}`;
      const esc = (v) => this.#esc(v);

      // Cliente
      const clientName = ci.name || '—';
      const clientEmail = ci.email || '';
      const clientWhatsapp = ci.whatsapp || ci.phone || '';
      const clientDoc = ci.cnpj ? `CNPJ ${this.#fmtDocLocal(ci.cnpj)}` : (ci.cpf ? `CPF ${this.#fmtDocLocal(ci.cpf)}` : '');
      const a = ci.address || {};
      const addrLine = a.logradouro
        ? `${a.logradouro}${a.numero ? ', ' + a.numero : ''}${a.bairro ? ' · ' + a.bairro : ''}${(a.localidade || a.cidade) ? ' · ' + (a.localidade || a.cidade) : ''}${a.uf ? '/' + a.uf : ''}${a.cep ? ' · CEP ' + a.cep : ''}`
        : '';

      // Vendedor (specifier_email)
      const vendorEmail = s.specifier_email || 'contato@tothmoveis.com.br';
      const vendorName = 'Toth Móveis';

      // Pagamento (espelha labels do wizard)
      // Onda 12.1 · Fix linguistic · "100% à vista em 10x" é contraditório · separa
      // parcels=1 (à vista) de parcels>1 (em Nx). Pra staged (70/30, 50/50), as parcelas
      // se aplicam à parte do cartão de cada estágio.
      const pt = s.payment_terms || {};
      const parcels = parseInt(pt.parcels, 10) || 1;
      const cartaoSuffix = parcels > 1 ? ` em ${parcels}x` : ' à vista';
      const paymentLabel = (() => {
        const m = pt.method;
        if (!m) return '—';
        if (m === 'pix_100')   return 'PIX · 100% à vista · 8% off em tudo';
        if (m === 'pix_70_30') return 'PIX · 70% sinal + 30% saldo · 8% off em tudo';
        if (m === 'pix_50_50') return 'PIX · 50% sinal + 50% saldo · 8% off em tudo';
        if (m === 'cartao_100')   return `Cartão · 100%${cartaoSuffix}`;
        if (m === 'cartao_70_30') return `Cartão · 70% sinal + 30% saldo${parcels > 1 ? ' · sinal em ' + parcels + 'x' : ''}`;
        if (m === 'cartao_50_50') return `Cartão · 50% sinal + 50% saldo${parcels > 1 ? ' · sinal em ' + parcels + 'x' : ''}`;
        if (m === 'boleto_15' || m === 'boleto_15dd') return 'Boleto · 15 dias após NF';
        if (m === 'boleto_30' || m === 'boleto_30dd') return 'Boleto · 30 dias após NF';
        if (m === 'outro')       return pt.notes || 'Acordo customizado';
        return m;
      })();

      // Items rows
      const globalPct = parseFloat(s.default_markup_pct) || 50;
      const rowsHtml = items.slice().sort((a, b) => (a.order ?? 0) - (b.order ?? 0)).map((it, idx) => {
        const snap = it.snapshot || {};
        const ov = it.overrides || {};
        const m = snap.metafields || {};
        const qty = it.qty || 1;
        const cost = (typeof ov.cost_centavos === 'number') ? ov.cost_centavos :
                     (typeof snap.cost_centavos === 'number' && snap.cost_centavos > 0) ? snap.cost_centavos :
                     (snap.price_centavos || 0);
        const markup = (typeof it.markup_pct === 'number') ? it.markup_pct : null;
        const nativeMarkupPct = (typeof snap.cost_centavos === 'number' && snap.cost_centavos > 0 &&
                                 typeof snap.price_centavos === 'number' && snap.price_centavos > 0)
          ? ((snap.price_centavos - snap.cost_centavos) / snap.cost_centavos) * 100
          : null;
        const explicitSource = ov.markup_source;
        let useMarkup;
        if (explicitSource === 'manual') useMarkup = (markup !== null) ? markup : globalPct;
        else if (explicitSource === 'global') useMarkup = globalPct;
        else if (markup !== null) useMarkup = markup;
        else if (nativeMarkupPct !== null) useMarkup = nativeMarkupPct;
        else useMarkup = globalPct;
        const clienteUnit = cost * (1 + useMarkup / 100);
        const subtotal = clienteUnit * qty;
        const photoUrl = it.selected_photo_url || snap.image_url || '';
        const cor = (ov.cor != null) ? ov.cor : (m.cor || '');
        const materiais = (ov.materiais != null) ? ov.materiais : (m.materiais || '');
        const dimens = (ov.dimens_es != null) ? ov.dimens_es : (m.dimens_es || '');
        const prazo = (ov.prazo != null) ? ov.prazo : (m.prazo || 0);
        const prazoTotal = prazo > 0 ? (Number(prazo) + 14) : 0;
        const title = snap.title || snap.name || '—';
        const specs = [
          cor && `<span><strong>Acabamento</strong> ${esc(cor)}</span>`,
          materiais && `<span><strong>Materiais</strong> ${esc(materiais)}</span>`,
          dimens && `<span><strong>Dimensões</strong> ${esc(String(dimens).replace(/\n/g, ' · '))}</span>`,
          prazoTotal > 0 && `<span><strong>Prazo</strong> ${prazoTotal} dias úteis</span>`,
        ].filter(Boolean).join('');
        return `
          <div class="row">
            <div class="row__index">${String(idx + 1).padStart(2, '0')}</div>
            ${photoUrl ? `<figure class="row__media"><img src="${esc(photoUrl)}" alt="${esc(title)}"></figure>` : '<div class="row__media row__media--empty"></div>'}
            <div class="row__body">
              <h3 class="row__title">${esc(title)}</h3>
              ${specs ? `<div class="row__specs">${specs}</div>` : ''}
            </div>
            <div class="row__price">
              <div class="row__price-label">${qty} × ${money(clienteUnit)}</div>
              <div class="row__price-total">${money(subtotal)}</div>
            </div>
          </div>
        `;
      }).join('');

      const css = this.#vendaPdfCss();
      const isPixMethod = String(pt.method || '').startsWith('pix');
      const pixHighlight = isPixMethod
        ? `<div class="payments__row payments__row--highlight"><span>À vista no Pix · 8% de desconto em tudo</span><strong>${money(fin.pixValue)}</strong></div>`
        : `<div class="payments__row"><span>À vista no Pix · 8% de desconto em tudo</span><strong>${money(fin.pixValue)}</strong></div>`;

      return `<!DOCTYPE html><html lang="pt-BR"><head><meta charset="utf-8"><title>${esc(vendaNumber)} · Confirmação de Venda Toth Móveis</title><style>${css}</style></head><body>
<div class="doc">
  <header class="header">
    <div class="header__brand">
      <div class="header__logo">TOTH</div>
      <div class="header__tagline">Confirmação de Venda · Mobiliário de alto padrão</div>
    </div>
    <div class="header__meta">
      <div class="header__meta-label">Venda</div>
      <div class="header__meta-number">№ ${esc(vendaNumber)}</div>
      <div class="header__meta-date">${esc(dateStr)}</div>
    </div>
  </header>

  <section class="parties">
    <div class="party">
      <div class="party__eyebrow">Para</div>
      <div class="party__name">${esc(clientName)}</div>
      ${clientDoc ? `<div class="party__line">${esc(clientDoc)}</div>` : ''}
      ${clientEmail ? `<div class="party__line">${esc(clientEmail)}</div>` : ''}
      ${clientWhatsapp ? `<div class="party__line">${esc(clientWhatsapp)}</div>` : ''}
      ${addrLine ? `<div class="party__line">${esc(addrLine)}</div>` : ''}
    </div>
    <div class="party party--right">
      <div class="party__eyebrow">De</div>
      <div class="party__name">${esc(vendorName)}</div>
      <div class="party__line">${esc(vendorEmail)}</div>
      <div class="party__line">+55 (18) 99671-4293</div>
      <div class="party__line">Presidente Prudente · SP</div>
    </div>
  </section>

  <section class="items">
    ${rowsHtml || '<p style="color:rgba(26,25,24,0.4);font-style:italic;text-align:center;padding:40px 0">Nenhum item nesta venda.</p>'}
  </section>

  <section class="footer-totals">
    <div class="payments">
      <div class="payments__eyebrow">Condição de pagamento confirmada</div>
      <div class="payments__row payments__row--accent">
        <span>${esc(paymentLabel)}</span>
        <strong>${money(fin.totalCliente)}</strong>
      </div>
      ${pixHighlight}
      ${(fin.frete > 0 && fin.freightMode !== 'none') ? `<div class="payments__row payments__row--logi"><span>Frete${fin.isVipexAuto ? ' Vipex' : ' avulso'}${a.cep ? ' · CEP ' + esc(a.cep) : ''}</span><strong>${money(fin.frete)}</strong></div>` : ''}
    </div>
    <div class="grand-total">
      <div class="grand-total__label">Total</div>
      <div class="grand-total__value">${money(fin.totalCliente)}</div>
    </div>
  </section>

  ${this.#buildAuthorityPagesHtml()}

  <footer class="legal">
    <div class="legal__brand">
      <span>${esc(vendorName)} · ${esc(vendorEmail)}</span>
      <span>www.tothmoveis.com.br · Presidente Prudente · SP</span>
    </div>
  </footer>
</div>
</body></html>`;
    }


    // Onda 12.1 · Helpers compartilhados com o orçamento pra PDF de autoridade
    // 2026-06-29 · delegam pros MESMOS helpers compartilhados do orçamento (de-dup)
    #escHtml(s) { return tsfEscHtml(s); }
    #escAttr(s) { return tsfEscAttr(s); }
    #optImg(url, width = 800) { return tsfOptImg(url, width); }

    // Onda 12.1 · Clone EXATO de TsfQuoteBuilder#buildAuthorityPagesHtml · zero divergência
    // Pages: institucional · clients · testimonials · projects (selecionados via sale.client_info.authority_blocks)
    #buildAuthorityPagesHtml() {
      // 2026-06-29 · delega pro MESMO helper compartilhado do orçamento (de-dup)
      return tsfBuildAuthorityPagesHtml(this.#sale?.client_info?.authority_blocks, this.#authorityContent, { scopePhrase: 'desta venda' });
    }

    #vendaPdfCss() {
      return `
        @page { size: A4; margin: 14mm 12mm; }
        * { box-sizing: border-box; }
        body { margin: 0; font-family: 'Montserrat', -apple-system, sans-serif; color: #1a1918; background: #fff; font-size: 11px; line-height: 1.5; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
        .doc { max-width: 186mm; margin: 0 auto; padding: 8mm 0; }
        .header { display: grid; grid-template-columns: 1fr auto; gap: 24px; padding-block-end: 18px; border-block-end: 2px solid #1a1918; margin-block-end: 24px; }
        .header__logo { font-family: var(--font-heading-family,'Montserrat'),'Montserrat',sans-serif; font-size: 38px; font-weight: 400; letter-spacing: 0.18em; color: #1a1918; }
        .header__tagline { margin-block-start: 6px; font-size: 10px; letter-spacing:.18em; text-transform: uppercase; color: rgba(26, 25, 24, 0.55); }
        .header__meta { text-align: right; }
        .header__meta-label { font-size: 9px; letter-spacing:.18em; text-transform: uppercase; color: rgba(26, 25, 24, 0.5); }
        .header__meta-number { font-family: var(--font-heading-family,'Montserrat'),'Montserrat',sans-serif; font-size: 22px; font-weight: 500; color: #A16207; margin-block: 4px 2px; }
        .header__meta-date { font-size: 11px; color: rgba(26, 25, 24, 0.7); }
        .parties { display: grid; grid-template-columns: 1fr 1fr; gap: 32px; padding-block-end: 22px; border-block-end: 1px solid rgba(26, 25, 24, 0.1); margin-block-end: 22px; }
        .party__eyebrow { font-size: 9px; letter-spacing:.22em; text-transform: uppercase; color: #A16207; margin-block-end: 8px; }
        .party--right { text-align: right; }
        .party__name { font-family: var(--font-heading-family,'Montserrat'),'Montserrat',sans-serif; font-size: 17px; font-weight: 500; color: #1a1918; margin-block-end: 4px; }
        .party__line { font-size: 10.5px; color: rgba(26, 25, 24, 0.75); line-height: 1.65; }
        .items { margin-block-end: 24px; }
        .row { display: grid; grid-template-columns: auto 70px 1fr auto; gap: 16px; padding-block: 14px; border-block-end: 1px solid rgba(26, 25, 24, 0.08); align-items: start; page-break-inside: avoid; }
        .row:first-child { padding-block-start: 0; }
        .row__index { font-size: 9px; letter-spacing: 0.18em; color: #A16207; padding-block-start: 4px; font-variant-numeric: tabular-nums; }
        .row__media { inline-size: 70px; block-size: 70px; overflow: hidden; border-radius: 2px; background: #f3f1ed; margin: 0; }
        .row__media img { inline-size: 100%; block-size: 100%; object-fit: cover; display: block; }
        .row__media--empty { background: #f3f1ed; }
        .row__body { min-inline-size: 0; }
        .row__title { font-family: var(--font-heading-family,'Montserrat'),'Montserrat',sans-serif; font-size: 15px; font-weight: 500; margin: 0 0 6px; color: #1a1918; letter-spacing: -0.005em; line-height: 1.25; }
        .row__specs { display: flex; flex-wrap: wrap; gap: 4px 16px; font-size: 9.5px; color: rgba(26, 25, 24, 0.65); line-height: 1.6; }
        .row__specs strong { font-weight: 500; color: rgba(26, 25, 24, 0.45); letter-spacing:.18em; text-transform: uppercase; font-size: 8.5px; margin-inline-end: 4px; }
        .row__price { text-align: right; min-inline-size: 110px; }
        .row__price-label { font-size: 9px; letter-spacing:.18em; color: rgba(26, 25, 24, 0.5); text-transform: uppercase; margin-block-end: 4px; font-variant-numeric: tabular-nums; }
        .row__price-total { font-family: var(--font-heading-family,'Montserrat'),'Montserrat',sans-serif; font-size: 17px; font-weight: 500; color: #1a1918; font-variant-numeric: tabular-nums; }
        .footer-totals { display: grid; grid-template-columns: 1.5fr 1fr; gap: 32px; padding-block: 22px; border-block: 1px solid rgba(26, 25, 24, 0.1); margin-block-end: 24px; page-break-inside: avoid; }
        .payments__eyebrow { font-size: 9px; letter-spacing:.22em; text-transform: uppercase; color: #A16207; margin-block-end: 12px; }
        .payments__row { display: flex; justify-content: space-between; gap: 12px; padding-block: 8px; border-block-end: 1px dashed rgba(26, 25, 24, 0.08); font-size: 11px; color: rgba(26, 25, 24, 0.8); }
        .payments__row:last-child { border-block-end: 0; }
        .payments__row strong { font-weight: 500; color: #1a1918; font-variant-numeric: tabular-nums; }
        .payments__row--accent { background: rgba(63, 77, 58, 0.06); padding: 10px 12px; border-radius: 3px; border-block-end: 0; margin-block-end: 4px; }
        .payments__row--accent strong { color: #3F4D3A; }
        .payments__row--highlight { background: rgba(161, 98, 7, 0.05); padding: 10px 12px; border-radius: 3px; border-block-end: 0; }
        .payments__row--highlight strong { color: #A16207; }
        .payments__row--logi { font-size: 10px; color: rgba(26, 25, 24, 0.6); font-style: italic; }
        .grand-total { display: flex; flex-direction: column; justify-content: center; align-items: flex-end; padding-inline-start: 24px; border-inline-start: 1px solid rgba(26, 25, 24, 0.1); }
        .grand-total__label { font-size: 10px; letter-spacing:.18em; text-transform: uppercase; color: rgba(26, 25, 24, 0.55); margin-block-end: 6px; }
        .grand-total__value { font-family: var(--font-heading-family,'Montserrat'),'Montserrat',sans-serif; font-size: 32px; font-weight: 500; color: #1a1918; letter-spacing: -0.01em; font-variant-numeric: tabular-nums; }
        .legal { margin-block-start: 32px; padding-block-start: 18px; border-block-start: 1px solid rgba(26, 25, 24, 0.1); }
        .legal__row { display: flex; justify-content: space-between; gap: 16px; padding-block: 6px; font-size: 10px; color: rgba(26, 25, 24, 0.65); }
        .legal__row span { letter-spacing:.18em; text-transform: uppercase; font-size: 9px; color: rgba(26, 25, 24, 0.45); }
        .legal__row strong { font-weight: 500; color: rgba(26, 25, 24, 0.8); }
        .legal__brand { display: flex; justify-content: space-between; gap: 16px; padding-block-start: 12px; border-block-start: 1px dashed rgba(26, 25, 24, 0.1); font-size: 9.5px; color: rgba(26, 25, 24, 0.5); }

        /* Onda 12.1 · Páginas de autoridade · clone do orçamento (mesmas classes/medidas) */
        .aut-page { page-break-before: always; break-before: page; padding-top: 4mm; padding-bottom: 6mm; }
        .aut-page__head { text-align: center; padding-bottom: 10mm; margin-bottom: 8mm; position: relative; }
        .aut-page__eyebrow { display: block; font-size: 8pt; font-weight: 500; letter-spacing:.22em; text-transform: uppercase; color: #A16207; margin-bottom: 4mm; }
        .aut-page__title { font-size: 22pt; font-weight: 200; letter-spacing: -0.02em; line-height: 1.1; color: #1a1918; margin: 0 0 4mm; font-family: var(--font-heading-family,'Montserrat'),'Montserrat',sans-serif; }
        .aut-page__rule { width: 14mm; height: 1.2px; background: #A16207; margin: 0 auto 4mm; }
        .aut-page__lede { font-size: 9.5pt; font-weight: 300; line-height: 1.6; color: rgba(26,25,24,0.62); max-width: 110mm; margin: 0 auto; }

        .aut-inst__grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 7mm; margin-bottom: 10mm; }
        .aut-inst__card { display: flex; flex-direction: column; gap: 3mm; page-break-inside: avoid; break-inside: avoid; }
        .aut-inst__media { aspect-ratio: 4/5; overflow: hidden; background: #f3f1ed; }
        .aut-inst__media img { width: 100%; height: 100%; object-fit: cover; display: block; }
        .aut-inst__title { font-size: 11pt; font-weight: 400; letter-spacing: -0.005em; color: #1a1918; margin: 0; line-height: 1.3; font-family: var(--font-heading-family,'Montserrat'),'Montserrat',sans-serif; }
        .aut-inst__desc { font-size: 8.5pt; line-height: 1.6; color: rgba(26,25,24,0.65); font-weight: 300; margin: 0; }
        .aut-inst__logos { display: flex; gap: 6mm; padding-top: 8mm; border-top: 1px solid rgba(26,25,24,0.1); align-items: center; justify-content: center; flex-wrap: wrap; }
        .aut-inst__logos img { max-height: 12mm; max-width: 24mm; object-fit: contain; opacity: 0.7; }

        .aut-clients__grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 6mm 8mm; padding-top: 4mm; }
        .aut-clients__logo { aspect-ratio: 3/2; display: flex; align-items: center; justify-content: center; padding: 3mm; background: #fff; border: 1px solid rgba(26,25,24,0.06); page-break-inside: avoid; break-inside: avoid; }
        .aut-clients__logo img { max-width: 100%; max-height: 100%; object-fit: contain; filter: grayscale(0.2); }

        .aut-test__grid { display: flex; flex-direction: column; gap: 8mm; }
        .aut-test__card { display: grid; grid-template-columns: 60mm 1fr; gap: 6mm; padding: 6mm; background: #faf9f7; border-left: 2px solid #A16207; page-break-inside: avoid; break-inside: avoid; }
        .aut-test__card:not(:has(.aut-test__media)) { grid-template-columns: 1fr; }
        .aut-test__media { aspect-ratio: 4/3; overflow: hidden; background: #ece9e3; }
        .aut-test__media img { width: 100%; height: 100%; object-fit: cover; display: block; }
        .aut-test__quote { font-size: 11pt; line-height: 1.6; color: #1a1918; font-weight: 300; font-style: italic; margin: 0 0 3mm; position: relative; padding-left: 5mm; }
        .aut-test__mark { position: absolute; left: 0; top: -2mm; font-size: 22pt; font-weight: 200; color: #A16207; font-family: Georgia, serif; line-height: 1; }
        .aut-test__quote p { margin: 0; }
        .aut-test__author { display: flex; gap: 3mm; align-items: center; padding-top: 3mm; border-top: 1px solid rgba(26,25,24,0.1); }
        .aut-test__avatar { width: 12mm; height: 12mm; border-radius: 50%; object-fit: cover; }
        .aut-test__author > div { display: flex; flex-direction: column; gap: 0.5mm; }
        .aut-test__name { font-size: 9.5pt; font-weight: 500; color: #1a1918; }
        .aut-test__role { font-size: 8pt; color: rgba(26,25,24,0.55); }
        .aut-test__loc { font-size: 7.5pt; color: rgba(26,25,24,0.45); letter-spacing: 0.04em; }

        .aut-proj__grid { display: grid; grid-template-columns: repeat(2, 1fr); gap: 7mm; }
        .aut-proj__card { display: flex; flex-direction: column; gap: 3mm; page-break-inside: avoid; break-inside: avoid; }
        .aut-proj__media { aspect-ratio: 4/3; overflow: hidden; background: #f3f1ed; }
        .aut-proj__media img { width: 100%; height: 100%; object-fit: cover; display: block; }
        .aut-proj__name { font-size: 10.5pt; font-weight: 400; letter-spacing: -0.005em; color: #1a1918; margin: 0; font-family: var(--font-heading-family,'Montserrat'),'Montserrat',sans-serif; }
        .aut-proj__meta { display: flex; flex-direction: column; gap: 0.8mm; font-size: 8pt; color: rgba(26,25,24,0.55); }
      `;
    }

    #renderError(msg) {
      this.innerHTML = `<div class="tsf-admin-list-page__error">${this.#esc(msg)}</div>`;
    }

    #esc(s) {
      return String(s ?? '').replace(/[&<>"']/g, c => ({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c]));
    }

    // Onda 9.1 · Render da seção Cliente · paridade com /admin-cliente
    // Mostra todos os campos + botões "Editar cadastro" / "Ver em nova aba" / "Trocar cliente"
    #renderClientSection(s, ci, isEditable) {
      const doc = ci.cnpj
        ? `CNPJ ${this.#fmtDocLocal(ci.cnpj)}`
        : ci.cpf ? `CPF ${this.#fmtDocLocal(ci.cpf)}` : '—';
      const tipoLabel = ci.cnpj ? 'Empresa · B2B' : 'Pessoa física · B2C';
      const a = ci.address || {};
      const ef = ci.endereco_fiscal || {};
      const addressFull = a.logradouro
        ? `${this.#esc(a.logradouro)}${a.numero ? ', ' + this.#esc(a.numero) : ''}${a.complemento ? ' · ' + this.#esc(a.complemento) : ''}${a.bairro ? ' · ' + this.#esc(a.bairro) : ''}${a.localidade || a.cidade ? ' · ' + this.#esc(a.localidade || a.cidade) : ''}${a.uf ? '/' + this.#esc(a.uf) : ''}${a.cep ? ' · CEP ' + this.#esc(this.#fmtCepLocal(a.cep)) : ''}`
        : '—';
      const fiscalFull = ef.logradouro
        ? `${this.#esc(ef.logradouro)}${ef.numero ? ', ' + this.#esc(ef.numero) : ''}${ef.complemento ? ' · ' + this.#esc(ef.complemento) : ''}${ef.bairro ? ' · ' + this.#esc(ef.bairro) : ''}${ef.localidade || ef.cidade ? ' · ' + this.#esc(ef.localidade || ef.cidade) : ''}${ef.uf ? '/' + this.#esc(ef.uf) : ''}`
        : null;

      // Onda 15D · prefere customer_id (Shopify bigint), fallback client_id legacy
      const clientRef = s.customer_id || s.client_id;

      // UNIFIED-3 · Se sem cliente E modo edição · mostra <tsf-inline-client> combobox embutido
      if (!clientRef && isEditable) {
        const specifierAttr = s.specifier_customer_id ? ` data-specifier-id="${this.#esc(s.specifier_customer_id)}"` : '';
        return `
          <section class="tsf-admin-venda-section tsf-admin-venda-section--composer">
            <header class="tsf-admin-venda-section__head">
              <div>
                <span class="tsf-admin-venda-section__eyebrow">Para quem é esta venda</span>
                <h2>Cliente</h2>
              </div>
              <span class="tsf-admin-venda-section__hint tsf-admin-venda-section__hint--edit">busque ou cadastre na hora · sem sair daqui</span>
            </header>
            <div class="tsf-admin-venda-section__body">
              <tsf-inline-client${specifierAttr} data-tsf-venda-inline-client></tsf-inline-client>
            </div>
          </section>
        `;
      }

      // 2026-06-28 · Cliente VINCULADO + modo edição → formulário editável inline (paridade c/ orçamento · ADITIVO)
      if (clientRef && isEditable) {
        return this.#renderVendaClientEditForm(ci, clientRef);
      }

      const headActions = `
        ${clientRef ? `<a href="/pages/admin-cliente?id=${this.#esc(clientRef)}" class="tsf-admin-venda-section__link tsf-admin-venda-section__link--primary">Editar cadastro →</a>` : ''}
        ${clientRef ? `<a href="/pages/admin-cliente?id=${this.#esc(clientRef)}" target="_blank" rel="noopener" class="tsf-admin-venda-section__link">Abrir em nova aba ↗</a>` : ''}
        ${isEditable ? `<button type="button" class="tsf-admin-venda-section__link" data-tsf-venda-change-client>${clientRef ? 'Trocar cliente' : 'Vincular cliente'}</button>` : ''}
      `;

      return `
        <section class="tsf-admin-venda-section">
          <header class="tsf-admin-venda-section__head">
            <h2>Cliente</h2>
            <div class="tsf-admin-venda-section__head-actions">${headActions}</div>
          </header>
          <div class="tsf-admin-venda-section__body">
            <div class="tsf-admin-venda-field"><span>Nome / Razão social</span><strong>${this.#esc(ci.name || '—')}</strong></div>
            <div class="tsf-admin-venda-field"><span>${ci.cnpj ? 'CNPJ' : 'CPF'} · Tipo</span><strong>${this.#esc(doc)} · ${this.#esc(tipoLabel)}</strong></div>
            <div class="tsf-admin-venda-field"><span>E-mail</span><strong>${this.#esc(ci.email || '—')}</strong></div>
            <div class="tsf-admin-venda-field"><span>WhatsApp</span><strong>${this.#esc(this.#fmtPhoneLocal(ci.whatsapp) || '—')}</strong></div>
            ${ci.cnpj && (ci.ie || ci.im) ? `<div class="tsf-admin-venda-field"><span>IE · IM</span><strong>${this.#esc(ci.ie || '—')} · ${this.#esc(ci.im || '—')}</strong></div>` : ''}
            <div class="tsf-admin-venda-field tsf-admin-venda-field--full"><span>Endereço de entrega</span><strong>${addressFull}</strong></div>
            ${fiscalFull ? `<div class="tsf-admin-venda-field tsf-admin-venda-field--full"><span>Endereço fiscal</span><strong>${fiscalFull}</strong></div>` : ''}
            ${!clientRef ? `
              <div class="tsf-admin-venda-lock-notice" style="grid-column: 1 / -1; margin-block-start: 8px;">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
                <span>Esta venda não está vinculada a um cliente cadastrado · use <strong>Vincular cliente</strong> acima</span>
              </div>
            ` : ''}
          </div>
        </section>
      `;
    }

    /* ── 2026-06-28 · Cliente editável inline na VENDA (Item 2 · paridade c/ orçamento) ──
       Branch ADITIVO: só renderiza em modo edição com cliente vinculado. Visão read-only intacta.
       Salva via /client/upsert (mesmo endpoint do orçamento · anti-dup + enriquece match) + /sale/update
       (allowlist já aceita client_info/customer_id · merge defensivo no back). Edição do cliente acende
       SÓ "Salvar cliente" (não o Salvar do topo) — igual ao orçamento (CLI-7). */
    #vendaCepTimer = null;
    #vendaClientDirty = false;

    #renderVendaClientEditForm(ci, clientRef) {
      const v = (x) => this.#esc(x == null ? '' : String(x));
      const a = ci.address || {};
      const ef = ci.endereco_fiscal || {};
      const isB2b = (String(ci.cnpj || '').replace(/\D/g, '').length === 14);
      const docVal = ci.cnpj ? this.#fmtDocLocal(ci.cnpj) : (ci.cpf ? this.#fmtDocLocal(ci.cpf) : '');
      const hasFiscal = !!(ef.cep || ef.logradouro || ef.numero || ef.bairro || ef.cidade || ef.localidade || ef.uf);
      const fld = (label, field, val, opts = {}) =>
        `<label class="tsf-quote-client__field tsf-quote-client__field--col-${opts.col || 6}"${opts.only ? ` data-tsf-venda-client-only="${opts.only}"${isB2b ? '' : ' hidden'}` : ''}>`
        + `<span class="tsf-quote-client__field-label">${label}</span>`
        + `<input type="${opts.type || 'text'}" class="tsf-quote-client__input" data-tsf-venda-client-input="${field}" value="${v(val)}"${opts.max ? ` maxlength="${opts.max}"` : ''}${opts.num ? ' inputmode="numeric"' : ''} autocomplete="off"></label>`;
      return `
        <section class="tsf-admin-venda-section">
          <header class="tsf-admin-venda-section__head">
            <div><span class="tsf-admin-venda-section__eyebrow">Para quem é esta venda</span><h2>Cliente</h2></div>
            <a href="/pages/admin-cliente?id=${v(clientRef)}" target="_blank" rel="noopener" class="tsf-admin-venda-section__link">Abrir cadastro ↗</a>
          </header>
          <div class="tsf-admin-venda-section__body">
            <div class="tsf-quote-client__body" data-tsf-venda-client-form style="display:block">
              <div class="tsf-quote-client__section">
                <div class="tsf-quote-client__section-head">
                  <span class="tsf-quote-client__section-label">Identidade</span>
                  <span class="tsf-quote-client__type-badge" data-tsf-venda-client-type-badge>${isB2b ? 'Empresa · B2B' : 'Pessoa física · B2C'}</span>
                </div>
                <div class="tsf-quote-client__grid tsf-quote-client__grid--identidade">
                  ${fld('Nome / Razão social *', 'name', ci.name, { col: 7 })}
                  ${fld('CPF ou CNPJ *', 'documento', docVal, { col: 5, num: true, max: 18 })}
                  ${fld('E-mail *', 'email', ci.email, { col: 6, type: 'email' })}
                  ${fld('WhatsApp *', 'whatsapp', this.#fmtPhoneLocal(ci.whatsapp), { col: 6, type: 'tel' })}
                  ${fld('Inscrição estadual <em class="tsf-quote-client__field-hint">(opcional)</em>', 'ie', ci.ie, { col: 6, only: 'b2b' })}
                  ${fld('Inscrição municipal <em class="tsf-quote-client__field-hint">(opcional)</em>', 'im', ci.im, { col: 6, only: 'b2b' })}
                </div>
              </div>
              <div class="tsf-quote-client__section">
                <span class="tsf-quote-client__section-label">Endereço de entrega</span>
                <div class="tsf-quote-client__grid tsf-quote-client__grid--address">
                  <label class="tsf-quote-client__field tsf-quote-client__field--col-3"><span class="tsf-quote-client__field-label">CEP *</span>
                    <div class="tsf-quote-client__cep-wrap"><input type="text" class="tsf-quote-client__input" data-tsf-venda-client-input="cep" value="${v(this.#fmtCepLocal(a.cep || ci.cep))}" inputmode="numeric" maxlength="9" autocomplete="postal-code"><span class="tsf-quote-client__cep-status" data-tsf-venda-client-cep-status aria-live="polite"></span></div></label>
                  ${fld('Logradouro <em class="tsf-quote-client__field-hint">(auto pelo CEP)</em>', 'logradouro', a.logradouro, { col: 9 })}
                  ${fld('Número *', 'numero', a.numero, { col: 2, num: true })}
                  ${fld('Complemento <em class="tsf-quote-client__field-hint">(opcional)</em>', 'complemento', a.complemento, { col: 3 })}
                  ${fld('Bairro *', 'bairro', a.bairro, { col: 3 })}
                  ${fld('Cidade *', 'cidade', a.localidade || a.cidade, { col: 3 })}
                  ${fld('UF *', 'uf', a.uf, { col: 1, max: 2 })}
                </div>
              </div>
              <div class="tsf-quote-client__section">
                <div class="tsf-quote-client__section-head">
                  <span class="tsf-quote-client__section-label">Endereço fiscal <em class="tsf-quote-client__field-hint">(opcional · se diferente)</em></span>
                  <label class="tsf-quote-client__toggle-inline"><input type="checkbox" data-tsf-venda-client-fiscal-toggle${hasFiscal ? ' checked' : ''}><span>Tem endereço fiscal diferente</span></label>
                </div>
                <div class="tsf-quote-client__grid tsf-quote-client__grid--address" data-tsf-venda-client-fiscal-fields${hasFiscal ? '' : ' hidden'}>
                  ${fld('CEP', 'fiscal_cep', this.#fmtCepLocal(ef.cep), { col: 3, num: true, max: 9 })}
                  ${fld('Logradouro', 'fiscal_logradouro', ef.logradouro, { col: 9 })}
                  ${fld('Número', 'fiscal_numero', ef.numero, { col: 2, num: true })}
                  ${fld('Complemento', 'fiscal_complemento', ef.complemento, { col: 3 })}
                  ${fld('Bairro', 'fiscal_bairro', ef.bairro, { col: 3 })}
                  ${fld('Cidade', 'fiscal_cidade', ef.localidade || ef.cidade, { col: 3 })}
                  ${fld('UF', 'fiscal_uf', ef.uf, { col: 1, max: 2 })}
                </div>
              </div>
              <div class="tsf-quote-client__footer" style="display:flex;align-items:center;gap:14px;flex-wrap:wrap;margin-top:14px;padding-top:14px;border-top:1px solid rgba(26,25,24,0.08);">
                <button type="button" class="tsf-admin-editor-page__btn-secondary" data-tsf-venda-client-save disabled>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/><polyline points="17 21 17 13 7 13 7 21"/><polyline points="7 3 7 8 15 8"/></svg>
                  <span data-tsf-venda-client-save-label>Salvar cliente</span>
                </button>
                <span class="tsf-quote-client__footer-hint" style="font-size:12px;color:rgba(26,25,24,0.55);">Atualiza o cadastro no Shopify (não duplica) · enriquece o match Meta/Google</span>
              </div>
            </div>
          </div>
        </section>
      `;
    }

    #onVendaClientInput(input) {
      const field = input.getAttribute('data-tsf-venda-client-input');
      const raw = input.value;
      if (field === 'cep') {
        const digits = raw.replace(/\D/g, '').slice(0, 8);
        input.value = this.#fmtCepLocal(digits);
        this.#updateVendaAddress({ cep: digits });
        this.#updateVendaClientInfo({ cep: digits });
        if (digits.length === 8) { clearTimeout(this.#vendaCepTimer); this.#vendaCepTimer = setTimeout(() => this.#vendaLookupCep(digits), 250); }
        this.#markVendaClientDirty(); return;
      }
      if (field === 'documento') {
        const digits = raw.replace(/\D/g, '').slice(0, 14);
        input.value = this.#fmtDocLocal(digits);
        if (digits.length >= 12) this.#updateVendaClientInfo({ cnpj: digits, cpf: '', tipo: 'b2b' });
        else this.#updateVendaClientInfo({ cpf: digits, cnpj: '', tipo: 'b2c' });
        this.#applyVendaClientTypeUI(digits.length >= 12); this.#markVendaClientDirty(); return;
      }
      if (field === 'whatsapp') { const d = raw.replace(/\D/g, '').slice(0, 11); input.value = this.#fmtPhoneLocal(d); this.#updateVendaClientInfo({ whatsapp: d }); this.#markVendaClientDirty(); return; }
      if (field === 'uf') { const uf = (raw || '').toUpperCase().replace(/[^A-Z]/g, '').slice(0, 2); input.value = uf; this.#updateVendaAddress({ uf }); this.#markVendaClientDirty(); return; }
      if (['logradouro', 'numero', 'complemento', 'bairro', 'cidade'].includes(field)) {
        if (field === 'cidade') this.#updateVendaAddress({ localidade: raw, cidade: raw });
        else this.#updateVendaAddress({ [field]: raw });
        this.#markVendaClientDirty(); return;
      }
      if (field.startsWith('fiscal_')) {
        const sub = field.replace('fiscal_', '');
        if (sub === 'cep') { const d = raw.replace(/\D/g, '').slice(0, 8); input.value = this.#fmtCepLocal(d); this.#updateVendaFiscal({ cep: d }); }
        else if (sub === 'uf') { const uf = (raw || '').toUpperCase().replace(/[^A-Z]/g, '').slice(0, 2); input.value = uf; this.#updateVendaFiscal({ uf }); }
        else if (sub === 'cidade') this.#updateVendaFiscal({ localidade: raw, cidade: raw });
        else this.#updateVendaFiscal({ [sub]: raw });
        this.#markVendaClientDirty(); return;
      }
      this.#updateVendaClientInfo({ [field]: raw }); // name, email, ie, im
      this.#markVendaClientDirty();
    }

    #updateVendaClientInfo(patch) {
      this.#sale.client_info = { ...(this.#sale.client_info || {}), ...patch };
      // 2026-07-01 · edições do cliente na venda agora agendam o save também (persiste na venda +
      //   sincroniza o cadastro via /sale/update). Antes só o "Salvar cliente" gravava → editava e perdia.
      this.#scheduleSave({ client_info: this.#sale.client_info });
    }
    #updateVendaAddress(patch) { const ci = this.#sale.client_info || {}; this.#updateVendaClientInfo({ address: { ...(ci.address || {}), ...patch } }); }
    #updateVendaFiscal(patch) { const ci = this.#sale.client_info || {}; this.#updateVendaClientInfo({ endereco_fiscal: { ...(ci.endereco_fiscal || {}), ...patch } }); }
    #applyVendaClientTypeUI(isB2b) {
      const badge = this.querySelector('[data-tsf-venda-client-type-badge]');
      if (badge) badge.textContent = isB2b ? 'Empresa · B2B' : 'Pessoa física · B2C';
      this.querySelectorAll('[data-tsf-venda-client-only="b2b"]').forEach((el) => { el.hidden = !isB2b; });
    }
    #markVendaClientDirty() {
      this.#vendaClientDirty = true;
      const btn = this.querySelector('[data-tsf-venda-client-save]');
      if (btn) btn.disabled = false;
      const lbl = this.querySelector('[data-tsf-venda-client-save-label]');
      if (lbl) lbl.textContent = 'Salvar cliente';
    }

    async #vendaLookupCep(digits) {
      const statusEl = this.querySelector('[data-tsf-venda-client-cep-status]');
      if (statusEl) statusEl.textContent = 'buscando…';
      try {
        const res = await fetch(`https://viacep.com.br/ws/${digits}/json/`);
        const data = await res.json();
        if (data.erro) { if (statusEl) statusEl.textContent = 'CEP não encontrado'; return; }
        if (statusEl) statusEl.textContent = `✓ ${data.localidade}/${data.uf}`;
        const cur = (this.#sale.client_info || {}).address || {};
        const newAddr = { ...cur, logradouro: data.logradouro || cur.logradouro || '', bairro: data.bairro || cur.bairro || '', localidade: data.localidade || cur.localidade || '', cidade: data.localidade || cur.cidade || '', uf: data.uf || cur.uf || '' };
        this.#updateVendaClientInfo({ cep: digits, address: newAddr });
        const set = (f, val) => { const el = this.querySelector(`[data-tsf-venda-client-input="${f}"]`); if (el) el.value = val || ''; };
        set('logradouro', newAddr.logradouro); set('bairro', newAddr.bairro); set('cidade', newAddr.localidade); set('uf', (newAddr.uf || '').toUpperCase());
        this.#markVendaClientDirty();
        // 2026-06-29 · PADRONIZAÇÃO (orçamento é o melhor): CEP completo → recalcula frete na hora.
        // Espelha o #lookupCep→#calculateFreight do orçamento (l.2533). silent → sem alert/re-render (não perde foco).
        this.#recalcFreight({ silent: true }).catch(e => console.error('[venda] recalc frete pós-CEP falhou (não-fatal):', e));
      } catch { if (statusEl) statusEl.textContent = 'falha ao buscar CEP'; }
    }

    async #commitVendaClient() {
      const ci = this.#sale.client_info || {};
      const a = ci.address || {};
      const name = (ci.name || '').trim();
      const cpf = (ci.cpf || '').replace(/\D/g, '');
      const cnpj = (ci.cnpj || '').replace(/\D/g, '');
      const hasEmail = !!ci.email && /@/.test(ci.email);
      const hasWhats = (ci.whatsapp || '').replace(/\D/g, '').length >= 10;
      const cepD = (ci.cep || a.cep || '').replace(/\D/g, '');
      const lbl = this.querySelector('[data-tsf-venda-client-save-label]');
      const btn = this.querySelector('[data-tsf-venda-client-save]');
      const missing = [];
      if (!name) missing.push('nome');
      if (cpf.length !== 11 && cnpj.length !== 14) missing.push('CPF ou CNPJ');
      if (!hasEmail && !hasWhats) missing.push('WhatsApp ou e-mail');
      if (cepD.length !== 8) missing.push('CEP');
      if (missing.length) { if (lbl) lbl.textContent = 'Faltam: ' + missing.join(', '); return; }
      if (!this.#sale.customer_id) { if (lbl) lbl.textContent = 'Vincule um cliente primeiro'; return; }
      if (btn) btn.disabled = true;
      if (lbl) lbl.textContent = 'Salvando…';
      try {
        const payload = {
          id: this.#sale.customer_id, nome: name, email: ci.email || '', whatsapp: (ci.whatsapp || '').replace(/\D/g, ''),
          tipo: cnpj.length === 14 ? 'b2b' : 'b2c', cpf, cnpj, ie: ci.ie || '', im: ci.im || '',
          specifier_customer_id: this.#sale.specifier_customer_id || null,
          endereco: { cep: cepD, logradouro: a.logradouro || '', numero: a.numero || '', complemento: a.complemento || '', bairro: a.bairro || '', cidade: a.localidade || a.cidade || '', uf: a.uf || '' },
        };
        const upRes = await fetch(`${CLIENT_ENDPOINT}/upsert`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) });
        const upData = await upRes.json();
        if (!upData.ok) throw new Error(upData.error || 'falha no upsert');
        // Persiste o client_info na venda (back faz merge defensivo + recalcula total). Não toca no #pendingPatch do topo.
        const svRes = await fetch(`${SALE_ENDPOINT}/update`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: this.#saleId, patch: { client_info: this.#sale.client_info, customer_id: this.#sale.customer_id } }) });
        const svData = await svRes.json();
        if (svData.ok && svData.sale) this.#sale.client_info = svData.sale.client_info || this.#sale.client_info;
        this.#vendaClientDirty = false;
        if (lbl) lbl.textContent = 'Cliente salvo ✓';
      } catch (e) {
        console.error('[venda] commitVendaClient', e);
        if (lbl) lbl.textContent = 'Falha ao salvar';
        if (btn) btn.disabled = false;
      }
    }

    // Onda 9.1 · Helpers de formatação locais (paridade com TsfQuoteBuilder)
    #fmtDocLocal(digits) {
      const d = String(digits || '').replace(/\D/g, '');
      if (d.length === 0) return '';
      if (d.length <= 11) {
        if (d.length !== 11) return d;
        return `${d.slice(0,3)}.${d.slice(3,6)}.${d.slice(6,9)}-${d.slice(9)}`;
      }
      if (d.length !== 14) return d;
      return `${d.slice(0,2)}.${d.slice(2,5)}.${d.slice(5,8)}/${d.slice(8,12)}-${d.slice(12)}`;
    }

    #fmtCepLocal(digits) {
      const d = String(digits || '').replace(/\D/g, '').slice(0, 8);
      if (d.length <= 5) return d;
      return `${d.slice(0,5)}-${d.slice(5)}`;
    }

    #fmtPhoneLocal(digits) {
      let d = String(digits || '').replace(/\D/g, '');
      if ((d.length === 12 || d.length === 13) && d.startsWith('55')) d = d.slice(2); // tira DDI +55 → exibe local
      d = d.slice(0, 11);
      if (!d) return '';
      if (d.length <= 2) return `(${d}`;
      if (d.length <= 6) return `(${d.slice(0,2)}) ${d.slice(2)}`;
      if (d.length <= 10) return `(${d.slice(0,2)}) ${d.slice(2,6)}-${d.slice(6)}`;
      return `(${d.slice(0,2)}) ${d.slice(2,7)}-${d.slice(7)}`;
    }
  }

  /* ════════════════════════════════════════════════════════════════════
     TSF-ADMIN-CLIENTES · Onda 16A · Editorial concierge desk
     · 8 perfil tabs com contagens reais (segment.totalCount)
     · Sidebar filtros (atividade/estado/valor/cohort/email/specifica/consentimento)
     · Search debounced + abort controller
     · Scroll infinito com cursor pagination
     · Cards ricos com badges + quick actions (WhatsApp/Abrir)
     ════════════════════════════════════════════════════════════════════ */

  const PERFIS_ORDER = [
    { key: 'all',           label: 'Todos' },
    { key: 'cliente-b2c',   label: 'B2C' },
    { key: 'cliente-b2b',   label: 'B2B' },
    { key: 'arquiteto',     label: 'Arquiteto' },
    { key: 'fornecedor',    label: 'Fornecedor' },
    { key: 'transportadora',label: 'Transportadora' },
    { key: 'candidato',     label: 'Candidato' },
    { key: 'franqueado',    label: 'Franqueado' },
    { key: 'toth-team',     label: 'Time Toth' },
  ];

  const FILTER_GROUPS = [
    { key: 'atividade', label: 'Atividade', options: [
      { v: 'hot',  label: 'Hot · 0-30d' },
      { v: 'warm', label: 'Warm · 31-60d' },
      { v: 'cool', label: 'Cool · 61-90d' },
    ]},
    { key: 'valor', label: 'Valor', options: [
      { v: 'vip',    label: 'VIP · R$ 10k+' },
      { v: 'alto',   label: 'Alto · R$ 5k+' },
      { v: 'padrao', label: 'Padrão · R$ 1k+' },
      { v: 'baixo',  label: 'Baixo' },
    ]},
    { key: 'estado', label: 'Estado', options: [
      { v: 'sp', label: 'SP' }, { v: 'rj', label: 'RJ' }, { v: 'mg', label: 'MG' },
      { v: 'pr', label: 'PR' }, { v: 'rs', label: 'RS' }, { v: 'sc', label: 'SC' },
      { v: 'ba', label: 'BA' }, { v: 'df', label: 'DF' }, { v: 'go', label: 'GO' },
      { v: 'pe', label: 'PE' }, { v: 'ce', label: 'CE' },
    ]},
    { key: 'cohort', label: 'Cohort', options: [
      { v: '2024', label: '2024' }, { v: '2025', label: '2025' }, { v: '2026', label: '2026' },
    ]},
    { key: 'email', label: 'E-mail / Setor', options: [
      { v: 'pessoal', label: 'Pessoal' },
      { v: 'corporativo', label: 'Corporativo' },
      { v: 'arquitetura', label: 'Arquitetura' },
      { v: 'construcao', label: 'Construção' },
      { v: 'imobiliario', label: 'Imobiliário' },
      { v: 'hospitalidade', label: 'Hospitalidade' },
      { v: 'educacao', label: 'Educação' },
    ]},
    { key: 'specifica', label: 'Specifica tier', options: [
      { v: 'gold',   label: 'Gold' },
      { v: 'black',  label: 'Black' },
      { v: 'comunidade', label: 'Comunidade' },
    ]},
    { key: 'consentimento', label: 'Consentimento', options: [
      { v: 'marketing-ok',       label: 'Marketing ok' },
      { v: 'marketing-pendente', label: 'Marketing pendente' },
    ]},
  ];

  class TsfAdminClientes extends HTMLElement {
    #abortController = null;
    #searchAbort = null;
    #clients = [];
    #counts = {};
    #activePerfil = 'all';            // default tab = TODOS (universo completo de contatos do site)
    #filters = {};                     // { atividade, estado, valor, cohort, email, specifica, consentimento }
    #search = '';
    #sort = 'updated_desc';
    #cursor = null;
    #hasNextPage = false;
    #isLoading = false;
    #searchDebounceTimer = null;

    async connectedCallback() {
      this.#abortController = new AbortController();

      // URL state restoration
      const url = new URL(window.location.href);
      const urlPerfil = url.searchParams.get('perfil');
      if (urlPerfil && PERFIS_ORDER.some(p => p.key === urlPerfil)) this.#activePerfil = urlPerfil;
      const urlQ = url.searchParams.get('q');
      if (urlQ) this.#search = urlQ;
      FILTER_GROUPS.forEach(g => {
        const v = url.searchParams.get(g.key);
        if (v) this.#filters[g.key] = v;
      });

      this.#renderShell();
      this.#bindEvents();
      // Carrega counts + primeira página em paralelo
      this.#fetchCounts();
      await this.#fetchClients({ reset: true });
    }

    disconnectedCallback() {
      this.#abortController?.abort();
      this.#searchAbort?.abort();
      clearTimeout(this.#searchDebounceTimer);
    }

    #esc(s) {
      return String(s ?? '').replace(/[&<>"']/g, c => ({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c]));
    }

    #renderShell() {
      this.classList.add('tsf-clientes');
      this.innerHTML = `
        <header class="tsf-clientes__head">
          <div class="tsf-clientes__heading">
            <span class="tsf-clientes__eyebrow">Atelier · Concierge desk</span>
            <h1 class="tsf-clientes__title">Clientes</h1>
            <p class="tsf-clientes__lede" data-cli-lede>Carregando contagens…</p>
          </div>
          <div class="tsf-clientes__actions">
            <a class="tsf-clientes__cta" href="/pages/admin-cliente">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
              Novo cliente
            </a>
          </div>
        </header>

        <nav class="tsf-clientes__tabs" role="tablist" aria-label="Filtrar por perfil">
          ${PERFIS_ORDER.map(p => `
            <button type="button" role="tab" class="tsf-clientes__tab" data-perfil="${p.key}" aria-selected="${p.key === this.#activePerfil}">
              <span>${p.label}</span>
              <span class="tsf-clientes__tab-count tsf-clientes__tab-count--loading" data-cli-count="${p.key}">—</span>
            </button>
          `).join('')}
        </nav>

        <div class="tsf-clientes__main">
          <aside class="tsf-clientes__sidebar" aria-label="Filtros">
            ${FILTER_GROUPS.map(g => `
              <div class="tsf-clientes__sb-section">
                <h3 class="tsf-clientes__sb-title">
                  <span>${g.label}</span>
                  ${this.#filters[g.key] ? `<button type="button" class="tsf-clientes__sb-clear" data-clear="${g.key}">limpar</button>` : ''}
                </h3>
                <div class="tsf-clientes__sb-chips">
                  ${g.options.map(o => `
                    <button type="button" class="tsf-clientes__sb-chip"
                            data-filter-group="${g.key}" data-filter-value="${o.v}"
                            aria-pressed="${this.#filters[g.key] === o.v}">${o.label}</button>
                  `).join('')}
                </div>
              </div>
            `).join('')}
          </aside>

          <section class="tsf-clientes__results">
            <div class="tsf-clientes__search">
              <span class="tsf-clientes__search-icon">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
              </span>
              <input type="search" class="tsf-clientes__search-input"
                     placeholder="Buscar por nome, e-mail ou telefone…"
                     value="${this.#esc(this.#search)}"
                     data-cli-search aria-label="Buscar cliente">
            </div>

            <div class="tsf-clientes__toolbar">
              <div class="tsf-clientes__toolbar-count" data-cli-toolbar>—</div>
              <div class="tsf-clientes__toolbar-sort">
                <label for="cli-sort" style="font-size:11px;letter-spacing:0.08em;text-transform:uppercase;">Ordenar</label>
                <select id="cli-sort" data-cli-sort>
                  <option value="updated_desc" ${this.#sort==='updated_desc'?'selected':''}>Recente</option>
                  <option value="created_desc" ${this.#sort==='created_desc'?'selected':''}>Cadastro recente</option>
                  <option value="name_asc"     ${this.#sort==='name_asc'?'selected':''}>Alfabético</option>
                </select>
              </div>
            </div>

            <div data-cli-grid class="tsf-clientes__grid">
              ${Array.from({length: 6}).map(() => `
                <article class="tsf-cli-card tsf-cli-card--skel">
                  <div class="tsf-cli-card__badges"><div class="tsf-cli-skel" style="width:60px;height:14px;border-radius:7px;"></div></div>
                  <div class="tsf-cli-card__name tsf-cli-skel"></div>
                  <div class="tsf-cli-card__meta tsf-cli-skel"></div>
                  <div class="tsf-cli-card__fields"><div class="tsf-cli-skel"></div><div class="tsf-cli-skel"></div><div class="tsf-cli-skel"></div></div>
                  <div class="tsf-cli-card__metric tsf-cli-skel"></div>
                </article>
              `).join('')}
            </div>

            <div data-cli-loadmore class="tsf-clientes__loadmore" hidden>
              <button type="button" class="tsf-clientes__loadmore-btn" data-cli-loadmore-btn>Carregar mais 50</button>
            </div>
          </section>
        </div>
      `;
    }

    #bindEvents() {
      const opts = { signal: this.#abortController.signal };

      // Perfil tabs
      this.querySelectorAll('[data-perfil]').forEach(btn => {
        btn.addEventListener('click', () => {
          this.#activePerfil = btn.getAttribute('data-perfil');
          this.querySelectorAll('[data-perfil]').forEach(b => {
            b.setAttribute('aria-selected', String(b.getAttribute('data-perfil') === this.#activePerfil));
          });
          this.#syncUrl();
          this.#fetchClients({ reset: true });
        }, opts);
      });

      // Filter chips
      this.querySelectorAll('[data-filter-group]').forEach(chip => {
        chip.addEventListener('click', () => {
          const g = chip.getAttribute('data-filter-group');
          const v = chip.getAttribute('data-filter-value');
          if (this.#filters[g] === v) delete this.#filters[g];
          else this.#filters[g] = v;
          this.#renderSidebar();
          this.#syncUrl();
          this.#fetchClients({ reset: true });
        }, opts);
      });

      // Search input · debounce 250ms
      this.querySelector('[data-cli-search]')?.addEventListener('input', (e) => {
        clearTimeout(this.#searchDebounceTimer);
        this.#searchDebounceTimer = setTimeout(() => {
          this.#search = e.target.value.trim();
          this.#syncUrl();
          this.#fetchClients({ reset: true });
        }, 250);
      }, opts);

      // Sort
      this.querySelector('[data-cli-sort]')?.addEventListener('change', (e) => {
        this.#sort = e.target.value;
        this.#fetchClients({ reset: true });
      }, opts);

      // Load more
      this.querySelector('[data-cli-loadmore-btn]')?.addEventListener('click', () => {
        this.#fetchClients({ reset: false });
      }, opts);

      // Auto-scroll trigger near footer (infinite scroll)
      this.#observeLoadmore();
    }

    #observeLoadmore() {
      const sentinel = this.querySelector('[data-cli-loadmore]');
      if (!sentinel || !('IntersectionObserver' in window)) return;
      const io = new IntersectionObserver(entries => {
        for (const e of entries) {
          if (e.isIntersecting && this.#hasNextPage && !this.#isLoading) {
            this.#fetchClients({ reset: false });
          }
        }
      }, { rootMargin: '200px' });
      io.observe(sentinel);
      this.#abortController.signal.addEventListener('abort', () => io.disconnect());
    }

    #renderSidebar() {
      const sb = this.querySelector('.tsf-clientes__sidebar');
      if (!sb) return;
      sb.innerHTML = FILTER_GROUPS.map(g => `
        <div class="tsf-clientes__sb-section">
          <h3 class="tsf-clientes__sb-title">
            <span>${g.label}</span>
            ${this.#filters[g.key] ? `<button type="button" class="tsf-clientes__sb-clear" data-clear="${g.key}">limpar</button>` : ''}
          </h3>
          <div class="tsf-clientes__sb-chips">
            ${g.options.map(o => `
              <button type="button" class="tsf-clientes__sb-chip"
                      data-filter-group="${g.key}" data-filter-value="${o.v}"
                      aria-pressed="${this.#filters[g.key] === o.v}">${o.label}</button>
            `).join('')}
          </div>
        </div>
      `).join('');
      // Rebind chips · they were destroyed
      sb.querySelectorAll('[data-filter-group]').forEach(chip => {
        chip.addEventListener('click', () => {
          const g = chip.getAttribute('data-filter-group');
          const v = chip.getAttribute('data-filter-value');
          if (this.#filters[g] === v) delete this.#filters[g];
          else this.#filters[g] = v;
          this.#renderSidebar();
          this.#syncUrl();
          this.#fetchClients({ reset: true });
        });
      });
      sb.querySelectorAll('[data-clear]').forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.stopPropagation();
          const g = btn.getAttribute('data-clear');
          delete this.#filters[g];
          this.#renderSidebar();
          this.#syncUrl();
          this.#fetchClients({ reset: true });
        });
      });
    }

    #syncUrl() {
      const url = new URL(window.location.href);
      url.searchParams.set('perfil', this.#activePerfil);
      Object.entries(this.#filters).forEach(([k, v]) => {
        if (v) url.searchParams.set(k, v);
        else url.searchParams.delete(k);
      });
      ['atividade','estado','valor','cohort','email','specifica','consentimento'].forEach(k => {
        if (!this.#filters[k]) url.searchParams.delete(k);
      });
      if (this.#search) url.searchParams.set('q', this.#search);
      else url.searchParams.delete('q');
      window.history.replaceState({}, '', url.toString());
    }

    async #fetchCounts() {
      try {
        const params = new URLSearchParams();
        // Counts respeitam filtros adicionais? Por enquanto, sempre globais (ignora filtros).
        // Justificativa UX: tab badge mostra o universo total do perfil pra orientação.
        const res = await fetch(`${CLIENT_ENDPOINT}/counts?${params}`, { signal: this.#abortController.signal });
        const data = await res.json();
        if (!data.ok) throw new Error(data.error || 'falha contagens');
        this.#counts = data.counts || {};
        this.#renderCounts();
      } catch (err) {
        console.warn('[tsf-clientes] counts failed', err);
      }
    }

    #renderCounts() {
      // Total
      const total = this.#counts.total || 0;
      const fmt = (n) => n.toLocaleString('pt-BR');
      const lede = this.querySelector('[data-cli-lede]');
      if (lede) lede.textContent = total ? `${fmt(total)} clientes catalogados em ${PERFIS_ORDER.length - 1} perfis` : 'Nenhum cliente catalogado';

      this.querySelectorAll('[data-cli-count]').forEach(el => {
        const k = el.getAttribute('data-cli-count');
        let n = 0;
        if (k === 'all') n = total;
        else n = this.#counts[k] || 0;
        el.textContent = fmt(n);
        el.classList.remove('tsf-clientes__tab-count--loading');
      });
    }

    async #fetchClients({ reset }) {
      if (this.#isLoading) return;
      this.#isLoading = true;

      if (reset) {
        this.#cursor = null;
        this.#clients = [];
      }

      this.#searchAbort?.abort();
      this.#searchAbort = new AbortController();

      const params = new URLSearchParams();
      if (this.#activePerfil && this.#activePerfil !== 'all') params.set('perfil', this.#activePerfil);
      if (this.#search) params.set('q', this.#search);
      Object.entries(this.#filters).forEach(([k, v]) => { if (v) params.set(k, v); });
      params.set('sort', this.#sort);
      params.set('first', '50');
      if (this.#cursor) params.set('after', this.#cursor);

      const loadmoreEl = this.querySelector('[data-cli-loadmore]');
      const loadmoreBtn = this.querySelector('[data-cli-loadmore-btn]');
      if (loadmoreBtn && !reset) {
        loadmoreBtn.disabled = true;
        loadmoreBtn.textContent = 'Carregando…';
      }

      try {
        const res = await fetch(`${CLIENT_ENDPOINT}/list?${params}`, { signal: this.#searchAbort.signal });
        const data = await res.json();
        if (!data.ok) throw new Error(data.error || 'falha');
        const newClients = data.clients || [];
        this.#clients = reset ? newClients : [...this.#clients, ...newClients];
        this.#cursor = data.pageInfo?.endCursor || null;
        this.#hasNextPage = !!data.pageInfo?.hasNextPage;
        this.#renderResults();
      } catch (err) {
        if (err.name === 'AbortError') return;
        this.#renderError(err.message);
      } finally {
        this.#isLoading = false;
        if (loadmoreBtn) {
          loadmoreBtn.disabled = false;
          loadmoreBtn.textContent = 'Carregar mais 50';
        }
        if (loadmoreEl) loadmoreEl.hidden = !this.#hasNextPage;
      }
    }

    #renderResults() {
      const grid = this.querySelector('[data-cli-grid]');
      const toolbar = this.querySelector('[data-cli-toolbar]');

      if (this.#clients.length === 0) {
        if (grid) {
          grid.innerHTML = '';
          grid.insertAdjacentHTML('afterend', this.#emptyHtml());
        }
        if (toolbar) toolbar.innerHTML = '<strong>0</strong> clientes encontrados';
        return;
      }

      // Remove any prev empty/error blocks
      this.querySelectorAll('.tsf-clientes__empty, .tsf-clientes__error').forEach(el => el.remove());

      if (toolbar) {
        const totalForPerfil = this.#activePerfil === 'all' ? (this.#counts.total || 0) : (this.#counts[this.#activePerfil] || 0);
        const fmt = (n) => n.toLocaleString('pt-BR');
        const filtersActive = Object.keys(this.#filters).length > 0 || this.#search;
        if (filtersActive) {
          toolbar.innerHTML = `Exibindo <strong>${fmt(this.#clients.length)}</strong> resultado${this.#clients.length === 1 ? '' : 's'} (filtro ativo)`;
        } else {
          toolbar.innerHTML = `<strong>${fmt(this.#clients.length)}</strong> de <strong>${fmt(totalForPerfil)}</strong>`;
        }
      }

      if (grid) {
        grid.innerHTML = this.#clients.map(c => this.#cardHtml(c)).join('');
      }
    }

    #emptyHtml() {
      const filtersActive = Object.keys(this.#filters).length > 0 || this.#search;
      return `
        <div class="tsf-clientes__empty">
          <p class="tsf-clientes__empty-eyebrow">Sem resultados</p>
          <h3 class="tsf-clientes__empty-title">${filtersActive ? 'Nenhum cliente bate com esses filtros' : 'Nenhum cliente neste perfil'}</h3>
          <p class="tsf-clientes__empty-lede">${filtersActive ? 'Tente afrouxar algum filtro ou mudar de perfil.' : 'Quando você cadastrar um cliente, ele aparece aqui.'}</p>
        </div>
      `;
    }

    #renderError(msg) {
      const grid = this.querySelector('[data-cli-grid]');
      if (!grid) return;
      grid.innerHTML = '';
      grid.insertAdjacentHTML('afterend', `
        <div class="tsf-clientes__error">
          <p class="tsf-clientes__empty-eyebrow">Erro</p>
          <h3 class="tsf-clientes__empty-title">Falha ao carregar clientes</h3>
          <p class="tsf-clientes__empty-lede">${this.#esc(msg || 'tente novamente em alguns segundos')}</p>
        </div>
      `);
    }

    #cardHtml(c) {
      // Perfil principal · primeiro perfil:* tag encontrado
      const tags = Array.isArray(c.tags) ? c.tags : [];
      const perfilTag = tags.find(t => t.startsWith('perfil:'));
      const perfilKey = perfilTag ? perfilTag.replace('perfil:', '').replace('cliente-', '') : 'b2c';

      // Atividade
      const atividadeTag = tags.find(t => t.startsWith('atividade:'));
      const atividade = atividadeTag ? atividadeTag.replace('atividade:', '') : null;

      // Valor
      const valorTag = tags.find(t => t.startsWith('valor:'));
      const valor = valorTag ? valorTag.replace('valor:', '') : null;

      // Specifica tier
      const specTag = tags.find(t => /^specifica-(gold|black|comunidade)$/.test(t));
      const specTier = specTag ? specTag.replace('specifica-', '') : null;

      const badgesHtml = [
        `<span class="tsf-cli-badge tsf-cli-badge--${this.#esc(perfilKey)}">${this.#esc(this.#perfilLabel(perfilKey))}</span>`,
        specTier ? `<span class="tsf-cli-badge tsf-cli-badge--specifica-${this.#esc(specTier)}">Specifica ${this.#esc(specTier)}</span>` : '',
        atividade ? `<span class="tsf-cli-badge tsf-cli-badge--${this.#esc(atividade)}">${this.#esc(atividade)}</span>` : '',
        valor ? `<span class="tsf-cli-badge tsf-cli-badge--${this.#esc(valor)}">${this.#esc(valor)}</span>` : '',
      ].filter(Boolean).join('');

      const cidade = c.endereco?.cidade || '';
      const uf = c.endereco?.uf || '';
      const local = cidade ? `${this.#esc(cidade)}${uf ? '/' + this.#esc(uf) : ''}` : '';

      // Format doc
      let docHtml = '';
      if (c.cpf) docHtml = `<div class="tsf-cli-card__field" title="CPF"><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><rect x="3" y="4" width="18" height="16" rx="2"/><path d="M3 10h18"/></svg><span>${this.#esc(c.cpf)}</span></div>`;
      else if (c.cnpj) docHtml = `<div class="tsf-cli-card__field" title="CNPJ"><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M3 21V10l9-6 9 6v11M9 21V12h6v9"/></svg><span>${this.#esc(c.cnpj)}</span></div>`;

      const emailHtml = c.email ? `<div class="tsf-cli-card__field" title="${this.#esc(c.email)}"><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><rect x="3" y="5" width="18" height="14" rx="2"/><polyline points="3 7 12 13 21 7"/></svg><span>${this.#esc(c.email)}</span></div>` : '';
      const phoneHtml = c.whatsapp ? `<div class="tsf-cli-card__field" title="${this.#esc(c.whatsapp)}"><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.37 1.9.72 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.35 1.85.59 2.81.72A2 2 0 0 1 22 16.92Z"/></svg><span>${this.#esc(this.#fmtPhone(c.whatsapp))}</span></div>` : '';

      // LTV (lifetime_value_centavos)
      const ltv = Number(c.lifetime_value_centavos || 0);
      const ltvFmt = ltv > 0 ? this.#fmtMoney(ltv) : null;

      // Last interaction
      const updated = c.updated_at ? this.#fmtRelative(c.updated_at) : null;

      // Quick actions
      const phoneDigits = (c.whatsapp || '').replace(/\D/g, '');
      const waHref = phoneDigits ? `https://wa.me/55${phoneDigits.replace(/^55/, '')}` : null;

      // Avatar · foto do especificador (specifica.foto, vem do /client) ou iniciais como fallback
      const initials = (c.nome || '?').trim().split(/\s+/).slice(0, 2).map(w => (w[0] || '')).join('').toUpperCase() || '?';
      const avatarInner = c.foto
        ? `<img src="${this.#esc(String(c.foto) + (String(c.foto).includes('?') ? '&' : '?') + 'width=120')}" alt="" loading="lazy">`
        : `<span>${this.#esc(initials)}</span>`;

      return `
        <article class="tsf-cli-card" data-cli-id="${this.#esc(c.id)}" tabindex="0" role="button">
          <div class="tsf-cli-card__head">
            <div class="tsf-cli-card__avatar tsf-cli-card__avatar--${this.#esc(perfilKey)}">${avatarInner}</div>
            <div class="tsf-cli-card__head-main">
              <div class="tsf-cli-card__badges">${badgesHtml}</div>
              <h3 class="tsf-cli-card__name">${this.#esc(c.nome || '—')}</h3>
              ${local ? `<p class="tsf-cli-card__meta">${local}${updated ? `<span class="tsf-cli-card__meta-sep">·</span>${updated}` : ''}</p>` : (updated ? `<p class="tsf-cli-card__meta">${updated}</p>` : '')}
            </div>
          </div>
          <div class="tsf-cli-card__fields">
            ${docHtml}
            ${emailHtml}
            ${phoneHtml}
          </div>
          ${ltvFmt ? `<div class="tsf-cli-card__metric"><span>LTV total</span><span class="tsf-cli-card__metric-value">${ltvFmt}</span></div>` : ''}
          <div class="tsf-cli-card__actions">
            ${waHref ? `<a href="${waHref}" target="_blank" rel="noopener" class="tsf-cli-action tsf-cli-action--whatsapp" title="WhatsApp" onclick="event.stopPropagation()">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.37 1.9.72 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.35 1.85.59 2.81.72A2 2 0 0 1 22 16.92Z"/></svg>
            </a>` : ''}
            ${c.email ? `<a href="mailto:${this.#esc(c.email)}" class="tsf-cli-action" title="E-mail" onclick="event.stopPropagation()">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><rect x="3" y="5" width="18" height="14" rx="2"/><polyline points="3 7 12 13 21 7"/></svg>
            </a>` : ''}
            <a href="/pages/admin-cliente?id=${this.#esc(c.id)}" class="tsf-cli-action tsf-cli-action--primary" onclick="event.stopPropagation()">
              Abrir
              <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>
            </a>
          </div>
        </article>
      `;
    }

    #perfilLabel(key) {
      const map = {
        'b2c': 'B2C', 'b2b': 'B2B', 'arquiteto': 'Arquiteto',
        'fornecedor': 'Fornecedor', 'transportadora': 'Transportadora',
        'candidato': 'Candidato', 'franqueado': 'Franqueado', 'toth-team': 'Toth Team',
      };
      return map[key] || key;
    }

    #fmtMoney(centavos) {
      return (centavos / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', maximumFractionDigits: 0 });
    }

    #fmtPhone(p) {
      if (!p) return '';
      let d = String(p).replace(/\D/g, '');
      if ((d.length === 12 || d.length === 13) && d.startsWith('55')) d = d.slice(2); // tira DDI +55
      if (d.length < 10) return p;
      const last = d.length >= 11 ? d.slice(-11) : d.slice(-10);
      if (last.length === 11) return `(${last.slice(0,2)}) ${last.slice(2,7)}-${last.slice(7)}`;
      return `(${last.slice(0,2)}) ${last.slice(2,6)}-${last.slice(6)}`;
    }

    #fmtRelative(ts) {
      try {
        const t = new Date(ts).getTime();
        const diff = Date.now() - t;
        const days = Math.floor(diff / 86400000);
        if (days < 1) return 'hoje';
        if (days === 1) return 'ontem';
        if (days < 30) return `há ${days} dias`;
        const months = Math.floor(days / 30);
        if (months < 12) return `há ${months} mês${months > 1 ? 'es' : ''}`;
        const years = Math.floor(months / 12);
        return `há ${years} ano${years > 1 ? 's' : ''}`;
      } catch { return ''; }
    }
  }

  // Card click → abre /admin-cliente
  document.addEventListener('click', (e) => {
    const card = e.target.closest('.tsf-cli-card[data-cli-id]');
    if (card && !e.target.closest('a, button')) {
      const id = card.getAttribute('data-cli-id');
      if (id) window.location.href = `/pages/admin-cliente?id=${encodeURIComponent(id)}`;
    }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Enter') return;
    const card = e.target.closest('.tsf-cli-card[data-cli-id]');
    if (card) {
      const id = card.getAttribute('data-cli-id');
      if (id) window.location.href = `/pages/admin-cliente?id=${encodeURIComponent(id)}`;
    }
  });

  /* ════════════════════════════════════════════════════════════════════
     TSF-ADMIN-CLIENTE-EDITOR · editor de cliente (novo ou existente)
     ════════════════════════════════════════════════════════════════════ */
  class TsfAdminClienteEditor extends HTMLElement {
    #clientId = null;
    #client = null;
    #customerId = null;
    #abortController = null;
    #isDirty = false;
    #cepTimer = null;

    async connectedCallback() {
      this.#abortController = new AbortController();
      this.#customerId = this.getAttribute('data-customer-id');
      const urlParams = new URLSearchParams(window.location.search);
      this.#clientId = urlParams.get('id') || '';

      if (this.#clientId) {
        await this.#fetch();
      } else {
        this.#client = { tipo: 'b2c', endereco: {}, endereco_fiscal: {} };
      }

      this.#render();
      this.#bindHeaderActions();
      this.#bindFormEvents();

      // Onda 8.6 · Beforeunload guard
      window.addEventListener('beforeunload', (e) => {
        if (this.#isDirty) {
          e.preventDefault();
          e.returnValue = 'Você tem alterações não salvas. Deseja sair mesmo assim?';
          return e.returnValue;
        }
      }, { signal: this.#abortController.signal });
    }

    disconnectedCallback() {
      this.#abortController?.abort();
    }

    async #fetch() {
      try {
        const res = await fetch(`${CLIENT_ENDPOINT}/get?id=${encodeURIComponent(this.#clientId)}`, {
          signal: this.#abortController.signal,
        });
        const data = await res.json();
        if (!data.ok) throw new Error(data.error || 'falha');
        this.#client = data.client;
        // Backward-compat: cliente pode ter address sem número/complemento (registros antigos)
        if (!this.#client.endereco) this.#client.endereco = {};
        if (!this.#client.endereco_fiscal) this.#client.endereco_fiscal = {};
      } catch (err) {
        this.innerHTML = `<div class="tsf-admin-list-page__error">Falha ao carregar: ${err.message}</div>`;
      }
    }

    #bindHeaderActions() {
      const { signal } = this.#abortController;
      document.querySelector('[data-tsf-admin-cliente-action="save"]')?.addEventListener('click', () => this.#save(), { signal });
      document.querySelector('[data-tsf-admin-cliente-action="discard"]')?.addEventListener('click', () => this.#discard(), { signal });
    }

    // Onda 8.6 · Eventos de input · dispara máscara + dirty + auto-CEP
    #bindFormEvents() {
      const { signal } = this.#abortController;
      this.addEventListener('input', (e) => {
        const field = e.target.getAttribute('data-field');
        if (!field) return;
        this.#applyMask(e.target, field);
        this.#markDirty();
      }, { signal });
      this.addEventListener('change', (e) => {
        const field = e.target.getAttribute('data-field');
        if (!field) return;
        this.#markDirty();
      }, { signal });
    }

    // Helpers de máscara · idênticos aos do TsfQuoteBuilder pra paridade total
    #fmtCpf(d)   { const s = (d||'').replace(/\D/g,'').slice(0,11); if (s.length<=3) return s; if (s.length<=6) return `${s.slice(0,3)}.${s.slice(3)}`; if (s.length<=9) return `${s.slice(0,3)}.${s.slice(3,6)}.${s.slice(6)}`; return `${s.slice(0,3)}.${s.slice(3,6)}.${s.slice(6,9)}-${s.slice(9)}`; }
    #fmtCnpj(d)  { const s = (d||'').replace(/\D/g,'').slice(0,14); if (s.length<=2) return s; if (s.length<=5) return `${s.slice(0,2)}.${s.slice(2)}`; if (s.length<=8) return `${s.slice(0,2)}.${s.slice(2,5)}.${s.slice(5)}`; if (s.length<=12) return `${s.slice(0,2)}.${s.slice(2,5)}.${s.slice(5,8)}/${s.slice(8)}`; return `${s.slice(0,2)}.${s.slice(2,5)}.${s.slice(5,8)}/${s.slice(8,12)}-${s.slice(12)}`; }
    #fmtDoc(d)   { const s = (d||'').replace(/\D/g,''); return s.length<=11 ? this.#fmtCpf(s) : this.#fmtCnpj(s); }
    #fmtPhone(d) { let s = (d||'').replace(/\D/g,''); if ((s.length===12||s.length===13)&&s.startsWith('55')) s=s.slice(2); s=s.slice(0,11); if (!s) return ''; if (s.length<=2) return `(${s}`; if (s.length<=6) return `(${s.slice(0,2)}) ${s.slice(2)}`; if (s.length<=10) return `(${s.slice(0,2)}) ${s.slice(2,6)}-${s.slice(6)}`; return `(${s.slice(0,2)}) ${s.slice(2,7)}-${s.slice(7)}`; }
    #fmtCep(d)   { const s = (d||'').replace(/\D/g,'').slice(0,8); if (s.length<=5) return s; return `${s.slice(0,5)}-${s.slice(5)}`; }

    #applyMask(input, field) {
      const raw = input.value;
      if (field === 'documento') {
        const digits = raw.replace(/\D/g,'').slice(0,14);
        input.value = this.#fmtDoc(digits);
        this.#updateTypeBadge(digits.length >= 12 ? 'b2b' : 'b2c');
      } else if (field === 'whatsapp') {
        input.value = this.#fmtPhone(raw);
      } else if (field === 'endereco.cep' || field === 'endereco_fiscal.cep') {
        const digits = raw.replace(/\D/g,'').slice(0,8);
        input.value = this.#fmtCep(digits);
        if (digits.length === 8) {
          window.clearTimeout(this.#cepTimer);
          this.#cepTimer = window.setTimeout(() => this.#lookupCep(digits, field.startsWith('endereco_fiscal') ? 'fiscal' : 'entrega'), 250);
        }
      } else if (field === 'endereco.uf' || field === 'endereco_fiscal.uf') {
        input.value = raw.toUpperCase().replace(/[^A-Z]/g,'').slice(0,2);
      }
    }

    // Onda 8.6 · Auto-CEP lookup via ViaCEP · preenche logradouro/bairro/cidade/uf
    async #lookupCep(digits, prefix) {
      try {
        const res = await fetch(`https://viacep.com.br/ws/${digits}/json/`);
        const data = await res.json();
        if (data.erro) return;
        const base = prefix === 'fiscal' ? 'endereco_fiscal' : 'endereco';
        const set = (sub, value) => {
          const el = this.querySelector(`[data-field="${base}.${sub}"]`);
          if (el && !el.value) el.value = value || '';
        };
        set('logradouro', data.logradouro);
        set('bairro', data.bairro);
        set('cidade', data.localidade);
        set('uf', (data.uf || '').toUpperCase());
        this.#markDirty();
      } catch {}
    }

    #updateTypeBadge(tipo) {
      const badge = this.querySelector('[data-tsf-cliente-type-badge]');
      if (!badge) return;
      badge.textContent = tipo === 'b2b' ? 'Empresa · B2B' : 'Pessoa física · B2C';
      badge.setAttribute('data-tipo', tipo);
      // Show/hide IE/IM
      this.querySelectorAll('[data-tsf-cliente-only]').forEach(el => {
        const only = el.getAttribute('data-tsf-cliente-only');
        if (only === tipo) el.removeAttribute('hidden');
        else el.setAttribute('hidden', '');
      });
    }

    #markDirty() {
      this.#isDirty = true;
      this.#updateHeaderState();
    }

    #updateHeaderState() {
      const saveBtn = document.querySelector('[data-tsf-admin-cliente-action="save"]');
      const discardBtn = document.querySelector('[data-tsf-admin-cliente-action="discard"]');
      const statusEl = document.querySelector('[data-tsf-admin-cliente-status]');
      if (saveBtn) {
        saveBtn.disabled = !this.#isDirty;
        saveBtn.classList.toggle('is-dirty', this.#isDirty);
      }
      if (discardBtn) {
        discardBtn.disabled = !this.#isDirty;
      }
      if (statusEl) {
        statusEl.textContent = this.#isDirty ? '● Alterações não salvas' : '';
        statusEl.setAttribute('data-state', this.#isDirty ? 'dirty' : 'clean');
      }
    }

    async #discard() {
      if (!this.#isDirty) return;
      if (!confirm('Descartar alterações não salvas?')) return;
      if (this.#clientId) {
        await this.#fetch();
      } else {
        this.#client = { tipo: 'b2c', endereco: {}, endereco_fiscal: {} };
      }
      this.#isDirty = false;
      this.#render();
    }

    async #save() {
      const data = this.#collectFormData();
      if (!data.nome) {
        alert('Nome do cliente é obrigatório.');
        return;
      }
      // Documento detectado pelo número de dígitos
      const docDigits = (data.documento || '').replace(/\D/g, '');
      let cpf = '', cnpj = '';
      if (docDigits.length >= 12) { cnpj = docDigits; data.tipo = data.tipo === 'b2c' ? 'b2b-arquitetura' : data.tipo; }
      else { cpf = docDigits; }
      delete data.documento;
      if (!cpf && !cnpj && !this.#clientId) {
        alert('CPF ou CNPJ é obrigatório.');
        return;
      }
      try {
        const payload = {
          ...data,
          cpf, cnpj,
          specifier_customer_id: this.#customerId,
        };
        if (this.#clientId) payload.id = this.#clientId;
        const res = await fetch(`${CLIENT_ENDPOINT}/upsert`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json; charset=utf-8' },
          body: JSON.stringify(payload),
        });
        const result = await res.json();
        if (!result.ok) throw new Error(result.error || 'falha');
        this.#isDirty = false;
        this.#updateHeaderState();
        if (!this.#clientId && result.client.id) {
          window.location.href = `/pages/admin-cliente?id=${encodeURIComponent(result.client.id)}`;
        } else {
          this.#client = result.client;
          this.#render();
        }
      } catch (err) {
        alert('Erro ao salvar: ' + err.message);
      }
    }

    #collectFormData() {
      const get = (sel) => this.querySelector(sel)?.value?.trim() || '';
      const enderecoCep = get('[data-field="endereco.cep"]').replace(/\D/g, '');
      const enderecoFiscalCep = get('[data-field="endereco_fiscal.cep"]').replace(/\D/g, '');
      // Fase 2.4 · CEP estruturado para Meta CAPI (zp hashado) + Google Ads (postalCode)
      // Prioridade: endereco_fiscal.cep > endereco.cep (oficial sobre entrega)
      // Só envia se 8 dígitos válidos
      const cepFinal = (enderecoFiscalCep.length === 8) ? enderecoFiscalCep
                     : (enderecoCep.length === 8) ? enderecoCep
                     : '';
      return {
        nome: get('[data-field="nome"]'),
        documento: get('[data-field="documento"]'),
        email: get('[data-field="email"]'),
        whatsapp: get('[data-field="whatsapp"]').replace(/\D/g, ''),
        tipo: get('[data-field="tipo"]'),
        ie: get('[data-field="ie"]'),
        im: get('[data-field="im"]'),
        cep: cepFinal,  // Fase 2.4 · metafield tsf.cep estruturado
        endereco: {
          cep: enderecoCep,
          logradouro: get('[data-field="endereco.logradouro"]'),
          numero: get('[data-field="endereco.numero"]'),
          complemento: get('[data-field="endereco.complemento"]'),
          bairro: get('[data-field="endereco.bairro"]'),
          cidade: get('[data-field="endereco.cidade"]'),
          uf: get('[data-field="endereco.uf"]'),
        },
        endereco_fiscal: {
          cep: enderecoFiscalCep,
          logradouro: get('[data-field="endereco_fiscal.logradouro"]'),
          numero: get('[data-field="endereco_fiscal.numero"]'),
          complemento: get('[data-field="endereco_fiscal.complemento"]'),
          bairro: get('[data-field="endereco_fiscal.bairro"]'),
          cidade: get('[data-field="endereco_fiscal.cidade"]'),
          uf: get('[data-field="endereco_fiscal.uf"]'),
        },
        notes: get('[data-field="notes"]'),
      };
    }

    #render() {
      const c = this.#client || {};
      const titleEl = document.querySelector('[data-tsf-admin-cliente-title]');
      if (titleEl) titleEl.textContent = c.nome || 'Novo cliente';
      const bylineEl = document.querySelector('[data-tsf-admin-cliente-byline]');
      if (bylineEl) {
        const doc = c.cnpj ? `CNPJ ${this.#fmtCnpj(c.cnpj)}` : c.cpf ? `CPF ${this.#fmtCpf(c.cpf)}` : 'sem documento';
        const updated = c.updated_at ? ` · atualizado ${new Date(c.updated_at).toLocaleDateString('pt-BR')}` : '';
        bylineEl.textContent = this.#clientId ? `${doc}${updated}` : 'Preencha os campos abaixo';
      }
      document.querySelector('[data-tsf-admin-cliente-actions]')?.removeAttribute('hidden');

      const e = c.endereco || {};
      const ef = c.endereco_fiscal || {};
      const esc = (s) => String(s ?? '').replace(/"/g, '&quot;');
      // Documento unificado · prioriza CNPJ se existir
      const docDigits = c.cnpj || c.cpf || '';
      const docFormatted = this.#fmtDoc(docDigits);
      const tipoB2B = !!(c.cnpj && c.cnpj.length >= 12);
      const tipoBase = tipoB2B ? 'b2b' : 'b2c';

      this.innerHTML = `
        <div class="tsf-quote-client__body" style="display:block">

          <!-- ─ Identidade ───────────────────────────────── -->
          <div class="tsf-quote-client__section">
            <div class="tsf-quote-client__section-head">
              <span class="tsf-quote-client__section-label">Identidade</span>
              <span class="tsf-quote-client__type-badge" data-tsf-cliente-type-badge data-tipo="${tipoBase}">
                ${tipoB2B ? 'Empresa · B2B' : 'Pessoa física · B2C'}
              </span>
            </div>

            <div class="tsf-quote-client__grid">
              <label class="tsf-quote-client__field tsf-quote-client__field--col-7">
                <span class="tsf-quote-client__field-label">Nome / Razão social *</span>
                <input data-field="nome" type="text" class="tsf-quote-client__input" value="${esc(c.nome || '')}" placeholder="Ex.: Família Silva ou Razão Social" required>
              </label>
              <label class="tsf-quote-client__field tsf-quote-client__field--col-5">
                <span class="tsf-quote-client__field-label">CPF ou CNPJ *</span>
                <input data-field="documento" type="text" class="tsf-quote-client__input" value="${esc(docFormatted)}" placeholder="000.000.000-00 ou 00.000.000/0000-00" inputmode="numeric" maxlength="18">
              </label>
              <label class="tsf-quote-client__field tsf-quote-client__field--col-6">
                <span class="tsf-quote-client__field-label">E-mail *</span>
                <input data-field="email" type="email" class="tsf-quote-client__input" value="${esc(c.email || '')}" placeholder="cliente@exemplo.com.br">
              </label>
              <label class="tsf-quote-client__field tsf-quote-client__field--col-6">
                <span class="tsf-quote-client__field-label">WhatsApp *</span>
                <input data-field="whatsapp" type="tel" class="tsf-quote-client__input" value="${esc(this.#fmtPhone(c.whatsapp || ''))}" placeholder="(11) 99999-9999">
              </label>
              <label class="tsf-quote-client__field tsf-quote-client__field--col-6" data-tsf-cliente-only="b2b" ${tipoB2B ? '' : 'hidden'}>
                <span class="tsf-quote-client__field-label">Subtipo</span>
                <select data-field="tipo" class="tsf-quote-client__input">
                  ${['b2b-arquitetura','b2b-construcao','b2b-imobiliario','b2b-hospitalidade','b2b-educacao'].map(t =>
                    `<option value="${t}" ${(c.tipo||'b2b-arquitetura')===t?'selected':''}>${t.replace('b2b-','').replace(/^./, ch => ch.toUpperCase())}</option>`
                  ).join('')}
                </select>
              </label>
              <label class="tsf-quote-client__field tsf-quote-client__field--col-6" data-tsf-cliente-only="b2b" ${tipoB2B ? '' : 'hidden'}>
                <span class="tsf-quote-client__field-label">Inscrição estadual <em class="tsf-quote-client__field-hint">(opcional)</em></span>
                <input data-field="ie" type="text" class="tsf-quote-client__input" value="${esc(c.ie || '')}" placeholder="000.000.000.000">
              </label>
              <label class="tsf-quote-client__field tsf-quote-client__field--col-6" data-tsf-cliente-only="b2b" ${tipoB2B ? '' : 'hidden'}>
                <span class="tsf-quote-client__field-label">Inscrição municipal <em class="tsf-quote-client__field-hint">(opcional)</em></span>
                <input data-field="im" type="text" class="tsf-quote-client__input" value="${esc(c.im || '')}" placeholder="0000000000">
              </label>
            </div>
          </div>

          <!-- ─ Endereço de entrega · grid 12 cols ──────────── -->
          <div class="tsf-quote-client__section">
            <span class="tsf-quote-client__section-label">Endereço de entrega</span>
            <div class="tsf-quote-client__grid tsf-quote-client__grid--address">
              <label class="tsf-quote-client__field tsf-quote-client__field--col-3">
                <span class="tsf-quote-client__field-label">CEP *</span>
                <input data-field="endereco.cep" type="text" class="tsf-quote-client__input" value="${esc(this.#fmtCep(e.cep || ''))}" placeholder="00000-000" inputmode="numeric" maxlength="9">
              </label>
              <label class="tsf-quote-client__field tsf-quote-client__field--col-9">
                <span class="tsf-quote-client__field-label">Logradouro <em class="tsf-quote-client__field-hint">(auto pelo CEP)</em></span>
                <input data-field="endereco.logradouro" type="text" class="tsf-quote-client__input" value="${esc(e.logradouro || '')}" placeholder="Rua, Avenida…">
              </label>
              <label class="tsf-quote-client__field tsf-quote-client__field--col-2">
                <span class="tsf-quote-client__field-label">Número *</span>
                <input data-field="endereco.numero" type="text" class="tsf-quote-client__input" value="${esc(e.numero || '')}" placeholder="123" inputmode="numeric">
              </label>
              <label class="tsf-quote-client__field tsf-quote-client__field--col-3">
                <span class="tsf-quote-client__field-label">Complemento <em class="tsf-quote-client__field-hint">(opcional)</em></span>
                <input data-field="endereco.complemento" type="text" class="tsf-quote-client__input" value="${esc(e.complemento || '')}" placeholder="Apto 42, bloco B…">
              </label>
              <label class="tsf-quote-client__field tsf-quote-client__field--col-3">
                <span class="tsf-quote-client__field-label">Bairro *</span>
                <input data-field="endereco.bairro" type="text" class="tsf-quote-client__input" value="${esc(e.bairro || '')}" placeholder="Bairro">
              </label>
              <label class="tsf-quote-client__field tsf-quote-client__field--col-3">
                <span class="tsf-quote-client__field-label">Cidade *</span>
                <input data-field="endereco.cidade" type="text" class="tsf-quote-client__input" value="${esc(e.cidade || e.localidade || '')}" placeholder="Cidade">
              </label>
              <label class="tsf-quote-client__field tsf-quote-client__field--col-1">
                <span class="tsf-quote-client__field-label">UF *</span>
                <input data-field="endereco.uf" type="text" class="tsf-quote-client__input" value="${esc((e.uf||'').toUpperCase())}" placeholder="SP" maxlength="2">
              </label>
            </div>
          </div>

          <!-- ─ Endereço fiscal · grid 12 cols ──────────────── -->
          <div class="tsf-quote-client__section">
            <span class="tsf-quote-client__section-label">Endereço fiscal <em class="tsf-quote-client__field-hint">(opcional · se diferente do entrega)</em></span>
            <div class="tsf-quote-client__grid tsf-quote-client__grid--address">
              <label class="tsf-quote-client__field tsf-quote-client__field--col-3">
                <span class="tsf-quote-client__field-label">CEP</span>
                <input data-field="endereco_fiscal.cep" type="text" class="tsf-quote-client__input" value="${esc(this.#fmtCep(ef.cep || ''))}" placeholder="00000-000" inputmode="numeric" maxlength="9">
              </label>
              <label class="tsf-quote-client__field tsf-quote-client__field--col-9">
                <span class="tsf-quote-client__field-label">Logradouro</span>
                <input data-field="endereco_fiscal.logradouro" type="text" class="tsf-quote-client__input" value="${esc(ef.logradouro || '')}" placeholder="Rua, Avenida…">
              </label>
              <label class="tsf-quote-client__field tsf-quote-client__field--col-2">
                <span class="tsf-quote-client__field-label">Número</span>
                <input data-field="endereco_fiscal.numero" type="text" class="tsf-quote-client__input" value="${esc(ef.numero || '')}" placeholder="123" inputmode="numeric">
              </label>
              <label class="tsf-quote-client__field tsf-quote-client__field--col-3">
                <span class="tsf-quote-client__field-label">Complemento</span>
                <input data-field="endereco_fiscal.complemento" type="text" class="tsf-quote-client__input" value="${esc(ef.complemento || '')}" placeholder="Sala, andar…">
              </label>
              <label class="tsf-quote-client__field tsf-quote-client__field--col-3">
                <span class="tsf-quote-client__field-label">Bairro</span>
                <input data-field="endereco_fiscal.bairro" type="text" class="tsf-quote-client__input" value="${esc(ef.bairro || '')}" placeholder="Bairro">
              </label>
              <label class="tsf-quote-client__field tsf-quote-client__field--col-3">
                <span class="tsf-quote-client__field-label">Cidade</span>
                <input data-field="endereco_fiscal.cidade" type="text" class="tsf-quote-client__input" value="${esc(ef.cidade || ef.localidade || '')}" placeholder="Cidade">
              </label>
              <label class="tsf-quote-client__field tsf-quote-client__field--col-1">
                <span class="tsf-quote-client__field-label">UF</span>
                <input data-field="endereco_fiscal.uf" type="text" class="tsf-quote-client__input" value="${esc((ef.uf||'').toUpperCase())}" placeholder="SP" maxlength="2">
              </label>
            </div>
          </div>

          <!-- ─ Notas internas ──────────────────────────────── -->
          <div class="tsf-quote-client__section">
            <span class="tsf-quote-client__section-label">Notas internas <em class="tsf-quote-client__field-hint">(não vão pro PDF nem cliente)</em></span>
            <div class="tsf-quote-client__grid">
              <label class="tsf-quote-client__field tsf-quote-client__field--col-12" style="grid-column: span 12;">
                <textarea data-field="notes" class="tsf-quote-client__input tsf-quote-client__textarea" rows="3" placeholder="Observações privadas · histórico de conversa, preferências, prazo combinado, contatos secundários…">${esc(c.notes || '')}</textarea>
              </label>
            </div>
          </div>

        </div>
      `;
      // Estado inicial dos botões
      this.#updateHeaderState();
    }
  }

  /* ════════════════════════════════════════════════════════════════════
     TSF-ADMIN-CLIENTE-360 · Onda 16B · concierge profile editorial
     · Hero card com avatar, badges, LTV, métricas, quick actions
     · 6 tabs · Visão geral · Pedidos · Orçamentos · Vendas · Interesses · Notas
     · Edit mode pra fiscal data (tsf.* metafields) via /client/upsert
     · Notas internas (textarea bound to tsf.observacoes_vendor)
     · Parallel fetch · orders + quotes + sales carregam em paralelo
     ════════════════════════════════════════════════════════════════════ */
  class TsfAdminCliente360 extends HTMLElement {
    #abortController = null;
    #targetId = null;             // bigint Shopify customer ID (from URL ?id=)
    #specifierId = null;          // logged-in vendor customer ID
    #client = null;               // shopify customer (mapped to legacy shape)
    #orders = [];                 // shopify customer.orders
    #ordersTotal = 0;
    #amountSpent = 0;
    #quotes = [];                 // toth_quotes para esse cliente
    #sales = [];                  // toth_sales para esse cliente
    #activeTab = 'overview';
    #editMode = false;
    #dirty = false;
    #saving = false;
    #cep360Timer = null;          // debounce do ViaCEP no editor de endereço

    async connectedCallback() {
      this.#abortController = new AbortController();
      this.#specifierId = this.getAttribute('data-customer-id') || '';
      const urlParams = new URLSearchParams(window.location.search);
      this.#targetId = urlParams.get('id') || '';

      if (!this.#targetId) {
        // Sem ?id= → cadastro inline editorial · cria customer Shopify direto e redireciona pro 360°
        this.#renderCreateForm();
        return;
      }

      // URL tab restoration
      let urlTab = urlParams.get('tab');
      if (urlTab === 'marketing') urlTab = 'overview'; // Marketing segue na Visão geral; Interesses voltou a ser aba própria (2026-06-27)
      if (['overview','interests','orders','quotes','sales','notes'].includes(urlTab)) {
        this.#activeTab = urlTab;
      }

      this.innerHTML = `<div class="tsf-cli360__loading">Carregando perfil do cliente…</div>`;

      // Parallel fetch · cliente é crítico, outros são lazy mas a gente carrega tudo de uma vez
      await this.#fetchAll();

      if (!this.#client) {
        this.innerHTML = `<div class="tsf-cli360__error">Cliente não encontrado. <a href="/pages/admin-clientes" style="color:inherit;">← Voltar</a></div>`;
        return;
      }

      this.#render();
      this.#bindEvents();

      // Beforeunload guard
      window.addEventListener('beforeunload', (e) => {
        if (this.#dirty) {
          e.preventDefault();
          e.returnValue = 'Você tem alterações não salvas. Sair mesmo assim?';
          return e.returnValue;
        }
      }, { signal: this.#abortController.signal });
    }

    disconnectedCallback() { this.#abortController?.abort(); }

    // -------- CREATE FORM (sem ?id=) --------
    // Form editorial inline · cria customer Shopify · redireciona pro 360°
    // Aceita ?prefill_name=, ?prefill_email=, ?return_to= pra fluxo inline em venda/orçamento
    #renderCreateForm() {
      const urlParams = new URLSearchParams(window.location.search);
      const prefillName = urlParams.get('prefill_name') || '';
      const prefillEmail = urlParams.get('prefill_email') || '';
      const prefillPhone = urlParams.get('prefill_phone') || '';
      const returnTo = urlParams.get('return_to') || ''; // ex: /pages/admin-venda?id=XYZ
      this.classList.add('tsf-cli360', 'tsf-cli360--create');
      this.innerHTML = `
        <a class="tsf-cli360__back" href="${returnTo || '/pages/admin-clientes'}">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 19 5 12 12 5"/></svg>
          <span>${returnTo ? 'voltar' : 'todos os clientes'}</span>
        </a>

        <header class="tsf-cli360__create-head">
          <p class="tsf-cli360__hero-eyebrow">Atelier · Concierge desk · Novo contato</p>
          <h1 class="tsf-cli360__create-title">Cadastrar cliente</h1>
          <p class="tsf-cli360__create-lede">Informe o mínimo · nome + um meio de contato. O sistema identifica o perfil (B2C/B2B) automaticamente pelo e-mail e completa o resto na próxima etapa.</p>
        </header>

        <form class="tsf-cli360__create-form" data-cli-create-form novalidate>
          <div class="tsf-cli360__data-grid">

            <label class="tsf-cli360__data-field tsf-cli360__data-field--full">
              <span class="tsf-cli360__data-label">Nome completo *</span>
              <input type="text" name="nome" class="tsf-cli360__data-input" required
                     value="${this.#esc(prefillName)}"
                     placeholder="Ex.: Maria Silva Arquitetura"
                     autocomplete="name" autofocus>
            </label>

            <label class="tsf-cli360__data-field">
              <span class="tsf-cli360__data-label">E-mail</span>
              <input type="email" name="email" class="tsf-cli360__data-input"
                     value="${this.#esc(prefillEmail)}"
                     placeholder="cliente@email.com"
                     autocomplete="email">
            </label>

            <label class="tsf-cli360__data-field">
              <span class="tsf-cli360__data-label">WhatsApp / Telefone</span>
              <input type="tel" name="whatsapp" class="tsf-cli360__data-input"
                     value="${this.#esc(prefillPhone)}"
                     placeholder="(11) 99999-9999"
                     autocomplete="tel">
            </label>

            <label class="tsf-cli360__data-field">
              <span class="tsf-cli360__data-label">CPF ou CNPJ <span style="opacity:.6">(opcional agora)</span></span>
              <input type="text" name="documento" class="tsf-cli360__data-input"
                     placeholder="Pode preencher depois">
            </label>

            <label class="tsf-cli360__data-field">
              <span class="tsf-cli360__data-label">Perfil inicial</span>
              <select name="tipo" class="tsf-cli360__data-select">
                <option value="auto" selected>Detectar automático pelo e-mail</option>
                <option value="b2c">B2C · Consumidor final</option>
                <option value="b2b-arquitetura">B2B · Arquiteto / Designer</option>
                <option value="b2b-construcao">B2B · Construtora / Engenharia</option>
                <option value="b2b-hospitalidade">B2B · Hotel / Restaurante / Spa</option>
              </select>
            </label>

          </div>

          <p class="tsf-cli360__create-hint" data-cli-create-msg></p>

          <div class="tsf-cli360__create-actions">
            <button type="button" class="tsf-cli360__action" data-cli-cancel>
              <span>Cancelar</span>
            </button>
            <button type="submit" class="tsf-cli360__action tsf-cli360__action--primary" data-cli-submit>
              <span data-cli-submit-label>Cadastrar e abrir perfil 360°</span>
            </button>
          </div>
        </form>
      `;

      const form = this.querySelector('[data-cli-create-form]');
      const msg = this.querySelector('[data-cli-create-msg]');
      const submitBtn = this.querySelector('[data-cli-submit]');
      const submitLabel = this.querySelector('[data-cli-submit-label]');
      const cancelBtn = this.querySelector('[data-cli-cancel]');

      cancelBtn?.addEventListener('click', () => {
        window.location.href = returnTo || '/pages/admin-clientes';
      }, { signal: this.#abortController.signal });

      form?.addEventListener('submit', async (ev) => {
        ev.preventDefault();
        const fd = new FormData(form);
        const nome = String(fd.get('nome') || '').trim();
        const email = String(fd.get('email') || '').trim();
        const whatsapp = String(fd.get('whatsapp') || '').trim();
        const documentoRaw = String(fd.get('documento') || '').trim();
        const tipoInput = String(fd.get('tipo') || 'auto').trim();

        if (!nome) {
          msg.textContent = 'Nome é obrigatório.';
          msg.style.color = '#B53E2F';
          return;
        }
        if (!email && !whatsapp && !documentoRaw) {
          msg.textContent = 'Informe pelo menos e-mail, WhatsApp ou documento — algum identificador.';
          msg.style.color = '#B53E2F';
          return;
        }

        // Documento: detecta CPF vs CNPJ pelo número de dígitos
        const docDigits = documentoRaw.replace(/\D/g, '');
        const cpf = docDigits.length >= 11 && docDigits.length < 12 ? docDigits : '';
        const cnpj = docDigits.length >= 12 ? docDigits : '';

        // Tipo: 'auto' → backend classifica pelo email · ou manual override
        let tipo = '';
        if (tipoInput !== 'auto') tipo = tipoInput;
        else if (cnpj && !tipo) tipo = 'b2b-arquitetura'; // CNPJ default = B2B
        // se 'auto' e sem CNPJ, deixa vazio → upsertShopifyCustomer + autoClassifyNewCustomer cuidam

        const payload = { nome, email: email || undefined, whatsapp: whatsapp || undefined };
        if (cpf) payload.cpf = cpf;
        if (cnpj) payload.cnpj = cnpj;
        if (tipo) payload.tipo = tipo;
        if (this.#specifierId) payload.specifier_customer_id = this.#specifierId;

        submitBtn.disabled = true;
        submitLabel.textContent = 'Cadastrando…';
        msg.textContent = '';
        msg.style.color = '';

        try {
          const res = await fetch(`${CLIENT_ENDPOINT}/upsert`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json; charset=utf-8' },
            body: JSON.stringify(payload),
            signal: this.#abortController.signal,
          });
          const result = await res.json();
          if (!result.ok || !result.client?.id) {
            throw new Error(result.error || 'Falha ao criar cliente');
          }
          const newId = result.client.id;

          // Se veio de venda/orçamento, dispara evento global pra parent component fazer link inline
          if (returnTo) {
            // Caso especial: return_to é venda/orçamento → o ideal é o caller usar drawer inline (UX-FIX C)
            // Aqui só redireciona já com client_id pra próximo passo
            const sep = returnTo.includes('?') ? '&' : '?';
            window.location.href = `${returnTo}${sep}new_client_id=${encodeURIComponent(newId)}`;
            return;
          }

          // Senão, abre o 360° do novo cliente
          window.location.href = `/pages/admin-cliente?id=${encodeURIComponent(newId)}`;
        } catch (err) {
          submitBtn.disabled = false;
          submitLabel.textContent = 'Cadastrar e abrir perfil 360°';
          msg.textContent = 'Erro: ' + (err?.message || 'falha ao cadastrar');
          msg.style.color = '#B53E2F';
        }
      }, { signal: this.#abortController.signal });
    }

    async #fetchAll() {
      const signal = this.#abortController.signal;
      const id = this.#targetId;
      // Parallel · client + orders + quotes + sales
      const [cliRes, ordRes, qRes, sRes] = await Promise.allSettled([
        fetch(`${CLIENT_ENDPOINT}/get?id=${encodeURIComponent(id)}`, { signal }).then(r => r.json()),
        fetch(`${CLIENT_ENDPOINT}/orders?id=${encodeURIComponent(id)}`, { signal }).then(r => r.json()),
        fetch(`${QUOTE_ENDPOINT}/list?customer_id=${encodeURIComponent(id)}`, { signal }).then(r => r.json()),
        fetch(`${SALE_ENDPOINT}/list?customer_id=${encodeURIComponent(id)}`, { signal }).then(r => r.json()),
      ]);

      if (cliRes.status === 'fulfilled' && cliRes.value?.ok) {
        this.#client = cliRes.value.client;
      }
      if (ordRes.status === 'fulfilled' && ordRes.value?.ok) {
        this.#orders = ordRes.value.orders || [];
        this.#ordersTotal = ordRes.value.total || this.#orders.length;
        this.#amountSpent = Number(ordRes.value.amountSpent || 0);
      }
      if (qRes.status === 'fulfilled' && qRes.value?.ok) {
        this.#quotes = qRes.value.quotes || [];
      }
      if (sRes.status === 'fulfilled' && sRes.value?.ok) {
        this.#sales = sRes.value.sales || [];
      }
    }

    #esc(s) {
      return String(s ?? '').replace(/[&<>"']/g, c => ({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c]));
    }
    #fmtMoney(amount, isCentavos = false) {
      const v = isCentavos ? amount / 100 : amount;
      return v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', maximumFractionDigits: 0 });
    }
    #fmtMoneyFull(amount, isCentavos = false) {
      const v = isCentavos ? amount / 100 : amount;
      return v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    }
    #fmtPhone(p) {
      if (!p) return '';
      let d = String(p).replace(/\D/g, '');
      if ((d.length === 12 || d.length === 13) && d.startsWith('55')) d = d.slice(2); // tira DDI +55
      if (d.length < 10) return p;
      const last = d.length >= 11 ? d.slice(-11) : d.slice(-10);
      if (last.length === 11) return `(${last.slice(0,2)}) ${last.slice(2,7)}-${last.slice(7)}`;
      return `(${last.slice(0,2)}) ${last.slice(2,6)}-${last.slice(6)}`;
    }
    #fmtDate(ts, opts = {}) {
      if (!ts) return '—';
      try {
        return new Date(ts).toLocaleDateString('pt-BR', { day: '2-digit', month: 'short', year: 'numeric', ...opts });
      } catch { return '—'; }
    }
    #fmtRelative(ts) {
      if (!ts) return '';
      try {
        const t = new Date(ts).getTime();
        const diff = Date.now() - t;
        const days = Math.floor(diff / 86400000);
        if (days < 1) return 'hoje';
        if (days === 1) return 'ontem';
        if (days < 30) return `há ${days} dias`;
        const months = Math.floor(days / 30);
        if (months < 12) return `há ${months} mês${months > 1 ? 'es' : ''}`;
        const years = Math.floor(months / 12);
        return `há ${years} ano${years > 1 ? 's' : ''}`;
      } catch { return ''; }
    }

    #getPerfis() {
      const tags = Array.isArray(this.#client.tags) ? this.#client.tags : [];
      return tags.filter(t => t.startsWith('perfil:')).map(t => t.replace('perfil:', ''));
    }
    #getPerfilLabel(key) {
      const map = {
        'cliente-b2c': 'B2C', 'cliente-b2b': 'B2B', 'arquiteto': 'Arquiteto',
        'fornecedor': 'Fornecedor', 'transportadora': 'Transportadora',
        'candidato': 'Candidato', 'franqueado': 'Franqueado', 'toth-team': 'Time Toth',
      };
      return map[key] || key;
    }
    #getPrimaryPerfil() {
      const perfis = this.#getPerfis();
      // Ordem de prioridade visual
      const priority = ['toth-team', 'arquiteto', 'cliente-b2b', 'cliente-b2c', 'fornecedor', 'franqueado', 'transportadora', 'candidato'];
      for (const p of priority) {
        if (perfis.includes(p)) return p;
      }
      return perfis[0] || 'cliente-b2c';
    }
    #initials(nome) {
      const n = String(nome || '').trim();
      if (!n) return '?';
      const parts = n.split(/\s+/).filter(Boolean);
      if (parts.length === 1) return parts[0].slice(0,2).toUpperCase();
      return (parts[0][0] + parts[parts.length-1][0]).toUpperCase();
    }

    /* ─────── RENDER ─────── */
    #render() {
      const c = this.#client;
      const perfis = this.#getPerfis();
      const primary = this.#getPrimaryPerfil();
      const tags = c.tags || [];
      const atividade = (tags.find(t => t.startsWith('atividade:')) || '').replace('atividade:', '');
      const valor = (tags.find(t => t.startsWith('valor:')) || '').replace('valor:', '');
      const specTier = ((tags.find(t => /^specifica-(gold|black|comunidade)$/.test(t)) || '').replace('specifica-', ''));

      const phoneDigits = (c.whatsapp || '').replace(/\D/g, '');
      const waHref = phoneDigits ? `https://wa.me/55${phoneDigits.replace(/^55/, '')}` : null;
      const emailHref = c.email ? `mailto:${c.email}` : null;

      const cidade = c.endereco?.cidade || '';
      const uf = c.endereco?.uf || '';
      const locStr = cidade ? `${cidade}${uf ? ' · ' + uf : ''}` : (uf || '');

      const since = c.created_at ? this.#fmtDate(c.created_at, { day: undefined }) : '';

      // Avatar variant
      let avatarVariant = '';
      if (valor === 'vip') avatarVariant = 'tsf-cli360__hero-avatar--vip';
      else if (primary === 'toth-team') avatarVariant = 'tsf-cli360__hero-avatar--toth-team';

      // Compute metrics
      const ltvCentavos = Number(c.lifetime_value_centavos || 0);
      // Fallback: se LTV ainda não foi calculado (Onda 17 vai automatizar), usa amountSpent do Shopify
      const totalSpent = ltvCentavos > 0 ? ltvCentavos / 100 : this.#amountSpent;

      const badgesHtml = this.#heroBadgesHtml();

      // Foto de perfil do especificador (specifica.foto · vem do /client) — exibe a foto se houver; senão, iniciais.
      const heroAvatarInner = c.foto
        ? `<img src="${this.#esc(String(c.foto) + (String(c.foto).includes('?') ? '&' : '?') + 'width=200')}" alt="" loading="lazy" style="width:100%;height:100%;object-fit:cover;border-radius:inherit;display:block;">`
        : this.#esc(this.#initials(c.nome));

      this.classList.add('tsf-cli360');
      this.innerHTML = `
        <a class="tsf-cli360__back" href="/pages/admin-clientes">
          <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>
          Voltar para Clientes
        </a>

        <header class="tsf-cli360__hero">
          <div class="tsf-cli360__hero-avatar ${avatarVariant}">${heroAvatarInner}</div>
          <div class="tsf-cli360__hero-info">
            <p class="tsf-cli360__hero-eyebrow">Atelier · Cliente · ${this.#esc(this.#getPerfilLabel(primary))}</p>
            <h1 class="tsf-cli360__hero-name">${this.#esc(c.nome || '—')}</h1>
            <p class="tsf-cli360__hero-subtitle">${this.#esc(locStr || 'Sem localização')}${since ? ' · cliente desde ' + this.#esc(since) : ''}</p>
            <div class="tsf-cli360__hero-badges">${badgesHtml}</div>
          </div>
          <div class="tsf-cli360__hero-metrics">
            <div class="tsf-cli360__metric">
              <span class="tsf-cli360__metric-value">${totalSpent > 0 ? this.#fmtMoney(totalSpent) : '—'}</span>
              <span class="tsf-cli360__metric-label">${ltvCentavos > 0 ? 'LTV total' : 'Gasto Shopify'}</span>
            </div>
            <div class="tsf-cli360__metric">
              <span class="tsf-cli360__metric-value">${this.#ordersTotal}</span>
              <span class="tsf-cli360__metric-label">Pedidos</span>
            </div>
            <div class="tsf-cli360__metric">
              <span class="tsf-cli360__metric-value">${this.#sales.length}</span>
              <span class="tsf-cli360__metric-label">Vendas Toth</span>
            </div>
          </div>
          <div class="tsf-cli360__hero-actions">
            ${waHref ? `<a class="tsf-cli360__action tsf-cli360__action--whatsapp" href="${waHref}" target="_blank" rel="noopener">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.37 1.9.72 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.35 1.85.59 2.81.72A2 2 0 0 1 22 16.92Z"/></svg>
              WhatsApp
            </a>` : ''}
            ${emailHref ? `<a class="tsf-cli360__action" href="${emailHref}">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><rect x="3" y="5" width="18" height="14" rx="2"/><polyline points="3 7 12 13 21 7"/></svg>
              E-mail
            </a>` : ''}
            <button type="button" class="tsf-cli360__action tsf-cli360__action--primary" data-action="new-quote">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
              Novo orçamento
            </button>
            <button type="button" class="tsf-cli360__action" data-action="new-sale">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
              Venda direta
            </button>
          </div>
        </header>

        <nav class="tsf-cli360__tabs" role="tablist" aria-label="Seções do perfil">
          ${this.#tabBtn('overview', 'Visão geral')}
          ${this.#tabBtn('interests', 'Interesses', (this.#client?.produtos_engajados || []).length || undefined)}
          ${this.#tabBtn('orders', 'Pedidos', this.#ordersTotal)}
          ${this.#tabBtn('quotes', 'Orçamentos', this.#quotes.length)}
          ${this.#tabBtn('sales', 'Vendas', this.#sales.length)}
          ${this.#tabBtn('notes', 'Notas')}
        </nav>

        <div class="tsf-cli360__panes">
          <div class="tsf-cli360__pane" data-pane="overview" data-active="${this.#activeTab === 'overview'}">${this.#renderOverview()}</div>
          <div class="tsf-cli360__pane" data-pane="interests" data-active="${this.#activeTab === 'interests'}">${this.#renderInterests()}</div>
          <div class="tsf-cli360__pane" data-pane="orders" data-active="${this.#activeTab === 'orders'}">${this.#renderOrders()}</div>
          <div class="tsf-cli360__pane" data-pane="quotes" data-active="${this.#activeTab === 'quotes'}">${this.#renderQuotes()}</div>
          <div class="tsf-cli360__pane" data-pane="sales" data-active="${this.#activeTab === 'sales'}">${this.#renderSales()}</div>
          <div class="tsf-cli360__pane" data-pane="notes" data-active="${this.#activeTab === 'notes'}">${this.#renderNotes()}</div>
        </div>
      `;
    }

    #tabBtn(key, label, count) {
      const isActive = this.#activeTab === key;
      const countHtml = count !== undefined ? `<span class="tsf-cli360__tab-count">${count}</span>` : '';
      return `<button type="button" role="tab" class="tsf-cli360__tab" data-tab="${key}" aria-selected="${isActive}">
        <span>${label}</span>${countHtml}
      </button>`;
    }

    /* ─── Visão geral ─── */
    #renderOverview() {
      const c = this.#client;
      const ed = this.#editMode;
      const a = c.endereco || {};
      const af = c.endereco_fiscal || {};
      const bt = c.business_type || '';

      const valueOrInput = (label, val, opts = {}) => {
        const { field, type = 'text', placeholder = '', textarea = false } = opts;
        if (ed && field) {
          if (textarea) {
            return `<div class="tsf-cli360__data-field"><span class="tsf-cli360__data-label">${label}</span><textarea class="tsf-cli360__data-textarea" data-field="${field}" placeholder="${this.#esc(placeholder)}">${this.#esc(val || '')}</textarea></div>`;
          }
          return `<div class="tsf-cli360__data-field"><span class="tsf-cli360__data-label">${label}</span><input type="${type}" class="tsf-cli360__data-input" data-field="${field}" value="${this.#esc(val || '')}" placeholder="${this.#esc(placeholder)}"></div>`;
        }
        return `<div class="tsf-cli360__data-field"><span class="tsf-cli360__data-label">${label}</span><span class="tsf-cli360__data-value ${val ? '' : 'tsf-cli360__data-value--muted'}">${this.#esc(val || '—')}</span></div>`;
      };

      // 2026-06-29 · FIX endereço editável no 360 (antes era só leitura mesmo em modo edição → não dava pra editar).
      // data-field com ponto (endereco.<campo>) → o #saveEdit aninha em `endereco: {...}` (shape que o back-end espera).
      const addrInput = (label, val, key, full = false) => {
        const cls = full ? 'tsf-cli360__data-field tsf-cli360__data-field--full' : 'tsf-cli360__data-field';
        return `<div class="${cls}"><span class="tsf-cli360__data-label">${label}</span><input type="text" class="tsf-cli360__data-input" data-field="endereco.${key}" value="${this.#esc(val || '')}"></div>`;
      };

      const businessTypeOptions = ['', 'residencial','comercial','hospitalidade','educacao','saude','corporativo','governamental','religioso','outro'];
      const btSelect = ed
        ? `<div class="tsf-cli360__data-field"><span class="tsf-cli360__data-label">Tipo de uso (business_type)</span><select class="tsf-cli360__data-select" data-field="business_type">${businessTypeOptions.map(o => `<option value="${o}" ${o === bt ? 'selected' : ''}>${o || '— não definido —'}</option>`).join('')}</select></div>`
        : `<div class="tsf-cli360__data-field"><span class="tsf-cli360__data-label">Tipo de uso</span><span class="tsf-cli360__data-value ${bt ? '' : 'tsf-cli360__data-value--muted'}">${this.#esc(bt || '—')}</span></div>`;

      const editToggle = `<button type="button" class="tsf-cli360__section-action" data-action="toggle-edit">${ed ? 'cancelar edição' : 'editar dados'}</button>`;

      const editBar = ed ? `
        <div class="tsf-cli360__edit-bar">
          <button type="button" class="tsf-cli360__btn" data-action="cancel-edit">Cancelar</button>
          <button type="button" class="tsf-cli360__btn tsf-cli360__btn--primary" data-action="save-edit" ${this.#dirty ? '' : 'disabled'}>${this.#saving ? 'Salvando…' : 'Salvar alterações'}</button>
        </div>
      ` : '';

      return `
        <p class="tsf-cli360__group-eyebrow">Identidade</p>
        ${this.#renderSpecifierProfile()}
        <section class="tsf-cli360__section">
          <h2 class="tsf-cli360__section-title">
            <span>Dados pessoais & fiscais</span>
            ${editToggle}
          </h2>
          <div class="tsf-cli360__data-grid">
            ${valueOrInput('Nome / Razão social', c.nome, { field: 'nome' })}
            ${valueOrInput('E-mail', c.email, { field: 'email', type: 'email' })}
            ${valueOrInput('WhatsApp', this.#fmtPhone(c.whatsapp), { field: 'whatsapp' })}
            ${valueOrInput('CPF', c.cpf, { field: 'cpf' })}
            ${valueOrInput('CNPJ', c.cnpj, { field: 'cnpj' })}
            ${valueOrInput('Razão social (PJ)', c.razao_social, { field: 'razao_social' })}
            ${valueOrInput('Inscrição estadual', c.ie, { field: 'ie' })}
            ${valueOrInput('Inscrição municipal', c.im, { field: 'im' })}
            ${btSelect}
            ${valueOrInput('Vendor responsável', c.specifier_responsavel, { field: 'specifier_responsavel', placeholder: 'Nome do vendor designado' })}
          </div>
        </section>

        <section class="tsf-cli360__section">
          <h2 class="tsf-cli360__section-title"><span>Endereço de entrega</span></h2>
          <div class="tsf-cli360__data-grid">
            ${ed ? `
              ${addrInput('CEP', a.cep, 'cep')}
              ${addrInput('Cidade', a.cidade, 'cidade')}
              ${addrInput('UF', a.uf, 'uf')}
              ${addrInput('Logradouro', a.logradouro, 'logradouro', true)}
              ${addrInput('Número', a.numero, 'numero')}
              ${addrInput('Complemento', a.complemento, 'complemento')}
              ${addrInput('Bairro', a.bairro, 'bairro')}
            ` : `
              <div class="tsf-cli360__data-field">
                <span class="tsf-cli360__data-label">CEP</span>
                <span class="tsf-cli360__data-value ${a.cep ? '' : 'tsf-cli360__data-value--muted'}">${this.#esc(a.cep || '—')}</span>
              </div>
              <div class="tsf-cli360__data-field">
                <span class="tsf-cli360__data-label">Cidade / UF</span>
                <span class="tsf-cli360__data-value ${a.cidade ? '' : 'tsf-cli360__data-value--muted'}">${this.#esc(a.cidade || '—')}${a.uf ? ' / ' + this.#esc(a.uf) : ''}</span>
              </div>
              <div class="tsf-cli360__data-field tsf-cli360__data-field--full">
                <span class="tsf-cli360__data-label">Logradouro</span>
                <span class="tsf-cli360__data-value ${a.logradouro ? '' : 'tsf-cli360__data-value--muted'}">${this.#esc(a.logradouro || '—')}${a.numero ? ', ' + this.#esc(a.numero) : ''}${a.complemento ? ' · ' + this.#esc(a.complemento) : ''}</span>
              </div>
              <div class="tsf-cli360__data-field">
                <span class="tsf-cli360__data-label">Bairro</span>
                <span class="tsf-cli360__data-value ${a.bairro ? '' : 'tsf-cli360__data-value--muted'}">${this.#esc(a.bairro || '—')}</span>
              </div>
            `}
          </div>
        </section>

        ${editBar}
        ${this.#renderMarketing()}
      `;
    }

    /* ─── Perfil do especificador (specifica.*) — só renderiza se for especificador ─── */
    #renderSpecifierProfile() {
      const s = this.#client.specifier;
      const tags = Array.isArray(this.#client.tags) ? this.#client.tags : [];
      const isSpecifier = tags.includes('perfil:arquiteto') || tags.some(t => /^specifica-(comunidade|gold|black)$/.test(t));
      if (!s || !isSpecifier) return '';
      const field = (label, val) => (val
        ? `<div class="tsf-cli360__data-field"><span class="tsf-cli360__data-label">${label}</span><span class="tsf-cli360__data-value">${this.#esc(val)}</span></div>`
        : '');
      const ed = this.#editMode;
      // editField · em editMode vira input (data-field spec_* → /client/upsert grava specifica.* + re-sincroniza o metaobjeto)
      const editField = (label, val, fieldKey, textarea = false) => {
        if (!ed) return field(label, val);
        const inner = textarea
          ? `<textarea class="tsf-cli360__data-textarea" data-field="${fieldKey}" placeholder="—">${this.#esc(val || '')}</textarea>`
          : `<input type="text" class="tsf-cli360__data-input" data-field="${fieldKey}" value="${this.#esc(val || '')}" placeholder="—">`;
        return `<div class="tsf-cli360__data-field${textarea ? ' tsf-cli360__data-field--full' : ''}"><span class="tsf-cli360__data-label">${label}</span>${inner}</div>`;
      };
      // Redes & portfólio clicáveis
      const socials = [
        { label: 'Instagram', url: s.instagram },
        { label: 'Facebook', url: s.facebook },
        { label: 'YouTube', url: s.youtube },
        { label: 'Site / portfólio', url: s.site },
      ].filter(x => x.url && /^https?:\/\//i.test(x.url));
      const socialsHtml = socials.length
        ? `<div class="tsf-cli360__data-field tsf-cli360__data-field--full"><span class="tsf-cli360__data-label">Redes & portfólio</span><div class="tsf-spec-links">${socials.map(x => `<a class="tsf-spec-link" href="${this.#esc(x.url)}" target="_blank" rel="noopener">${this.#esc(x.label)}<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M7 17 17 7M7 7h10v10"/></svg></a>`).join('')}</div></div>`
        : '';
      const interesses = Array.isArray(s.interesses) ? s.interesses.filter(Boolean) : [];
      const interessesHtml = interesses.length
        ? `<div class="tsf-cli360__data-field tsf-cli360__data-field--full"><span class="tsf-cli360__data-label">Atua em / interesses</span><div class="tsf-spec-chips">${interesses.map(i => `<span class="tsf-spec-chip">${this.#esc(i)}</span>`).join('')}</div></div>`
        : '';
      const sobreHtml = s.sobre
        ? `<div class="tsf-cli360__data-field tsf-cli360__data-field--full"><span class="tsf-cli360__data-label">Sobre</span><span class="tsf-cli360__data-value">${this.#esc(s.sobre)}</span></div>`
        : '';
      const planLabel = s.plan ? ({ comunidade: 'Comunidade', gold: 'Gold', black: 'Black' }[s.plan] || s.plan) : null;
      // Status na vitrine pública · fonte da verdade = metaobjeto; espelho rápido = tags vitrine:ok / vitrine:publicada
      const vPublished = tags.includes('vitrine:publicada');
      const vOptedIn = tags.includes('vitrine:ok');
      const vHandle = `esp-${this.#targetId}`;
      const vitrineBanner = vPublished
        ? `<div class="tsf-vitrine tsf-vitrine--live">
             <div class="tsf-vitrine__info"><span class="tsf-vitrine__dot"></span><div><strong class="tsf-vitrine__label">Na vitrine pública</strong><span class="tsf-vitrine__hint">aparece na home e na galeria de profissionais</span></div></div>
             <div class="tsf-vitrine__actions">
               <a class="tsf-vitrine__link" href="/pages/profissional?h=${this.#esc(vHandle)}" target="_blank" rel="noopener">ver na vitrine ↗</a>
               <button type="button" class="tsf-vitrine__btn tsf-vitrine__btn--ghost" data-action="vitrine-unpublish">Remover</button>
             </div>
           </div>`
        : vOptedIn
        ? `<div class="tsf-vitrine tsf-vitrine--pending">
             <div class="tsf-vitrine__info"><span class="tsf-vitrine__dot"></span><div><strong class="tsf-vitrine__label">Aguardando aprovação</strong><span class="tsf-vitrine__hint">optou por aparecer na vitrine — falta você publicar</span></div></div>
             <button type="button" class="tsf-vitrine__btn tsf-vitrine__btn--go" data-action="vitrine-publish">Publicar na vitrine</button>
           </div>`
        : `<div class="tsf-vitrine tsf-vitrine--off">
             <div class="tsf-vitrine__info"><span class="tsf-vitrine__dot"></span><div><strong class="tsf-vitrine__label">Fora da vitrine</strong><span class="tsf-vitrine__hint">não optou por aparecer publicamente</span></div></div>
           </div>`;
      return `
        <section class="tsf-cli360__section tsf-cli360__section--specifier">
          <h2 class="tsf-cli360__section-title">
            <span>Perfil do especificador</span>
            ${planLabel ? `<span class="tsf-spec-plan">Specifica ${this.#esc(planLabel)}</span>` : ''}
          </h2>
          ${vitrineBanner}
          <div class="tsf-cli360__data-grid">
            ${ed ? `
              ${editField('Profissão', s.profissao, 'spec_profissao')}
              ${editField('Cidade', this.#client.endereco?.cidade, 'spec_cidade')}
              ${editField('UF', this.#client.endereco?.uf, 'spec_estado')}
              ${editField('Instagram (URL)', s.instagram, 'spec_instagram')}
              ${editField('Site / portfólio (URL)', s.site, 'spec_site')}
              ${editField('Sobre', s.sobre, 'spec_sobre', true)}
            ` : `
              ${field('Profissão', s.profissao)}
              ${field('Atuação', s.atuacao)}
              ${field('Registro profissional', s.registro_profissional)}
              ${sobreHtml}
              ${interessesHtml}
              ${socialsHtml}
            `}
          </div>
        </section>
      `;
    }

    /* ─── Orders (Shopify) ─── */
    #renderOrders() {
      if (this.#orders.length === 0) {
        return `<div class="tsf-cli360__empty">
          <h3 class="tsf-cli360__empty-title">Nenhum pedido Shopify</h3>
          <p class="tsf-cli360__empty-lede">Este cliente ainda não comprou via checkout Toth.</p>
        </div>`;
      }
      return `<div class="tsf-cli360__list">${this.#orders.map(o => this.#orderCard(o)).join('')}</div>`;
    }
    #orderCard(o) {
      const date = this.#fmtDate(o.processedAt);
      const rel = this.#fmtRelative(o.processedAt);
      const itemsLabel = o.items.length === 0 ? 'sem itens' : `${o.items.length} ${o.items.length === 1 ? 'item' : 'itens'}`;
      const firstItem = o.items[0]?.title || '';
      const statusKey = (o.financialStatus || '').toLowerCase();
      const statusLabel = {
        paid: 'Pago', pending: 'Pendente', authorized: 'Autorizado',
        partially_paid: 'Parcial', refunded: 'Reembolsado', voided: 'Cancelado',
        partially_refunded: 'Reemb. parc.',
      }[statusKey] || (o.financialStatus || '—');
      return `<a class="tsf-cli360__list-card" href="https://tothmoveis.myshopify.com/admin/orders/${o.id}" target="_blank" rel="noopener">
        <span class="tsf-cli360__list-card-num">${this.#esc(o.name)}</span>
        <div class="tsf-cli360__list-card-meta">
          <p class="tsf-cli360__list-card-title">${this.#esc(firstItem || itemsLabel)}</p>
          <span class="tsf-cli360__list-card-sub">${date} · ${rel} · ${itemsLabel}${o.city ? ' · ' + this.#esc(o.city) + (o.uf ? '/' + this.#esc(o.uf) : '') : ''}</span>
        </div>
        <span class="tsf-cli360__list-card-value">${this.#fmtMoney(o.total)}</span>
        <span class="tsf-cli360__list-card-status tsf-cli360__list-card-status--${this.#esc(statusKey)}">${this.#esc(statusLabel)}</span>
      </a>`;
    }

    /* ─── Quotes (Supabase toth_quotes) ─── */
    #renderQuotes() {
      if (this.#quotes.length === 0) {
        return `<div class="tsf-cli360__empty">
          <h3 class="tsf-cli360__empty-title">Nenhum orçamento</h3>
          <p class="tsf-cli360__empty-lede">Comece o primeiro orçamento pra esse cliente.</p>
          <button type="button" class="tsf-cli360__empty-cta" data-action="new-quote">+ Novo orçamento</button>
        </div>`;
      }
      return `<div class="tsf-cli360__list">${this.#quotes.map(q => this.#quoteCard(q)).join('')}</div>`;
    }
    #quoteCard(q) {
      const num = q.numero_orcamento || (q.id ? q.id.slice(0, 8) : 'ORC');
      const date = this.#fmtDate(q.updated_at);
      const rel = this.#fmtRelative(q.updated_at);
      const itemsCount = Array.isArray(q.items) ? q.items.length : 0;
      const totalCentavos = Array.isArray(q.items)
        ? q.items.reduce((sum, i) => sum + Number(i.preco_centavos || i.price_centavos || 0) * Number(i.qty || i.quantity || 1), 0)
        : 0;
      const status = (q.status || 'draft').toLowerCase();
      const statusLabel = { draft: 'Rascunho', sent: 'Enviado', closed: 'Fechado', lost: 'Perdido' }[status] || status;
      return `<a class="tsf-cli360__list-card" href="/pages/admin-orcamento?id=${this.#esc(q.id)}">
        <span class="tsf-cli360__list-card-num">${this.#esc(num)}</span>
        <div class="tsf-cli360__list-card-meta">
          <p class="tsf-cli360__list-card-title">${this.#esc(q.title || itemsCount + ' ' + (itemsCount === 1 ? 'item' : 'itens'))}</p>
          <span class="tsf-cli360__list-card-sub">${date} · ${rel}${q.specifier_email ? ' · ' + this.#esc(q.specifier_email) : ''}</span>
        </div>
        <span class="tsf-cli360__list-card-value">${totalCentavos > 0 ? this.#fmtMoney(totalCentavos, true) : '—'}</span>
        <span class="tsf-cli360__list-card-status tsf-cli360__list-card-status--${this.#esc(status)}">${this.#esc(statusLabel)}</span>
      </a>`;
    }

    /* ─── Sales (Supabase toth_sales) ─── */
    #renderSales() {
      if (this.#sales.length === 0) {
        return `<div class="tsf-cli360__empty">
          <h3 class="tsf-cli360__empty-title">Nenhuma venda Toth</h3>
          <p class="tsf-cli360__empty-lede">Quando um orçamento virar venda, ela aparece aqui.</p>
          <button type="button" class="tsf-cli360__empty-cta" data-action="new-sale">+ Venda direta</button>
        </div>`;
      }
      return `<div class="tsf-cli360__list">${this.#sales.map(s => this.#saleCard(s)).join('')}</div>`;
    }
    #saleCard(s) {
      const num = s.numero_venda || 'VND';
      const date = this.#fmtDate(s.updated_at);
      const rel = this.#fmtRelative(s.updated_at);
      const itemsCount = Array.isArray(s.items) ? s.items.length : 0;
      // Fórmula única (markup manda): total persistido tem prioridade; senão recalcula ao vivo
      const total = (s.total_centavos && s.total_centavos > 0) ? Number(s.total_centavos) : tsfDocTotalCentavos(s);
      const peds = s.pedidos_count?.total || 0;
      const status = (s.status || 'rascunho').toLowerCase();
      const statusLabel = {
        rascunho: 'Rascunho', confirmada: 'Confirmada',
        em_producao: 'Em produção', entregue: 'Entregue', cancelada: 'Cancelada',
      }[status] || status;
      const statusCls = ({ rascunho: 'draft', confirmada: 'confirmed', em_producao: 'sent', entregue: 'fulfilled', cancelada: 'cancelled' })[status] || 'draft';
      return `<a class="tsf-cli360__list-card" href="/pages/admin-venda?id=${this.#esc(s.id)}">
        <span class="tsf-cli360__list-card-num">${this.#esc(num)}</span>
        <div class="tsf-cli360__list-card-meta">
          <p class="tsf-cli360__list-card-title">${itemsCount} ${itemsCount === 1 ? 'item' : 'itens'}${peds > 0 ? ' · ' + peds + ' ' + (peds === 1 ? 'pedido' : 'pedidos') + ' pra fábrica' : ''}</p>
          <span class="tsf-cli360__list-card-sub">${date} · ${rel}${s.specifier_email ? ' · ' + this.#esc(s.specifier_email) : ''}</span>
        </div>
        <span class="tsf-cli360__list-card-value">${total > 0 ? this.#fmtMoney(total, true) : '—'}</span>
        <span class="tsf-cli360__list-card-status tsf-cli360__list-card-status--${statusCls}">${this.#esc(statusLabel)}</span>
      </a>`;
    }

    /* ─── Interesses (tags lead-tracker) ─── */
    #renderInterests() {
      const tags = this.#client.tags || [];
      // CLI-9 W4 · grupos de comportamento (lead-tracker) · PRODUTOS + ações, ordem lógica.
      // Distingue "baixou" (produto tinha o conteúdo) de "pediu" (gap de conteúdo) — insight de catálogo.
      const GROUP_DEFS = [
        { key: 'interesse',            label: 'Interesses primários' },
        { key: 'wishlist',             label: 'Favoritos ❤' },
        { key: 'bloco-3d',             label: 'Blocos 3D baixados' },
        { key: 'solicitou-3d',         label: 'Pediu 3D · produto ainda sem 3D' },
        { key: 'catalogo',             label: 'Catálogos baixados' },
        { key: 'solicitou-catalogo',   label: 'Pediu catálogo' },
        { key: 'acabamento',           label: 'Acabamentos baixados' },
        { key: 'solicitou-acabamento', label: 'Pediu acabamento' },
        { key: 'categoria',            label: 'Tipos de produto' },
        { key: 'tag-produto',          label: 'Estilos & atributos' },
        { key: 'ambiente',             label: 'Ambientes' },
        { key: 'material',             label: 'Materiais' },
        { key: 'vendor',               label: 'Marcas curtidas' },
        { key: 'evento',               label: 'Outras ações no site' },
      ];
      const fmtChip = (v) => v.replace(/-/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
      const buckets = Object.fromEntries(GROUP_DEFS.map((g) => [g.key, []]));
      for (const t of tags) {
        const i = t.indexOf(':');
        if (i < 0) continue;
        const k = t.slice(0, i), v = t.slice(i + 1);
        if (buckets[k]) buckets[k].push(v);
      }
      const sections = GROUP_DEFS
        .filter((g) => buckets[g.key].length > 0)
        .map((g) => `
          <section class="tsf-cli360__section">
            <h2 class="tsf-cli360__section-title"><span>${g.label} · ${buckets[g.key].length}</span></h2>
            <div class="tsf-cli360__chips">
              ${buckets[g.key].map((v) => `<span class="tsf-cli360__chip">${this.#esc(fmtChip(v))}</span>`).join('')}
            </div>
          </section>
        `).join('');

      // D1.4 · Produtos engajados RICOS (título + fornecedor + ação + data + link) — metafield tsf.produtos_engajados
      const ACAO_LBL = {
        'bloco-3d|baixou': 'Baixou o 3D',         'bloco-3d|pediu': 'Pediu o 3D',
        'catalogo|baixou': 'Baixou o catálogo',   'catalogo|pediu': 'Pediu o catálogo',
        'acabamento|baixou': 'Baixou acabamento', 'acabamento|pediu': 'Pediu acabamento',
        'wishlist|favoritou': 'Favoritou',          'whatsapp|chamou': 'Chamou no WhatsApp',
      };
      const prod = Array.isArray(this.#client.produtos_engajados) ? this.#client.produtos_engajados : [];
      const fmtData = (d) => { try { return new Date(d).toLocaleDateString('pt-BR'); } catch (e) { return ''; } };
      const prodSection = prod.length ? `
        <section class="tsf-cli360__section">
          <h2 class="tsf-cli360__section-title tsf-mkt__behavior-head"><span>Produtos que baixou / pediu · ${prod.length}</span><span class="tsf-mkt__auto-tag">acionável · lead-tracker</span></h2>
          <div style="display:flex;flex-direction:column;gap:8px;">
            ${prod.map((p) => {
              const lbl = ACAO_LBL[(p.tipo || '') + '|' + (p.acao || '')] || this.#esc(p.acao || '');
              const handle = String(p.h || '');
              // 2026-06-27 · Camada 1 · subline = TIPO do produto + estilos/tags (até 4)
              const subline = [p.tp, ...(Array.isArray(p.tg) ? p.tg.slice(0, 4) : [])].filter(Boolean).join(' · ');
              return `<a href="/products/${this.#esc(handle)}" target="_blank" rel="noopener" style="display:flex;align-items:baseline;gap:10px;padding:11px 13px;border:1px solid var(--tsf-admin-line,rgba(26,25,24,.1));border-radius:10px;text-decoration:none;color:inherit;background:var(--tsf-admin-surface,#fff);">
                <span style="font-size:9.5px;font-weight:600;text-transform:uppercase;letter-spacing:.07em;color:var(--tsf-admin-accent,#A16207);white-space:nowrap;flex:0 0 auto;min-inline-size:96px;">${lbl}</span>
                <span style="flex:1 1 auto;line-height:1.3;min-inline-size:0;">
                  <span style="font-size:13px;font-weight:500;display:block;">${this.#esc(p.t || handle)}</span>
                  ${subline ? `<span style="font-size:10.5px;color:var(--tsf-admin-ink-mute,#999);">${this.#esc(subline)}</span>` : ''}
                </span>
                <span style="font-size:11px;color:var(--tsf-admin-ink-mute,#999);white-space:nowrap;flex:0 0 auto;">${p.v ? this.#esc(p.v) + ' · ' : ''}${fmtData(p.d)}</span>
              </a>`;
            }).join('')}
          </div>
        </section>` : '';

      const allSections = prodSection + sections;
      if (!allSections) {
        return `<div class="tsf-cli360__empty">
          <h3 class="tsf-cli360__empty-title">Nenhum interesse capturado ainda</h3>
          <p class="tsf-cli360__empty-lede">Quando o cliente clicar em catálogo, 3D ou acabamento no site, os interesses aparecem aqui.</p>
        </div>`;
      }
      return allSections;
    }

    /* ─── Notas internas ─── */
    #renderNotes() {
      const notes = this.#client.notes || '';
      return `
        <section class="tsf-cli360__section">
          <h2 class="tsf-cli360__section-title">
            <span>Notas internas do time</span>
            <span style="font-family:var(--tsf-font-sans);font-size:10px;color:var(--tsf-admin-ink-mute);letter-spacing:0.04em;text-transform:none;" data-notes-status></span>
          </h2>
          <textarea class="tsf-cli360__data-textarea" data-notes-input
                    style="min-block-size:160px;font-size:13px;"
                    placeholder="Anote preferências, contexto, observações relevantes pra essa relação…">${this.#esc(notes)}</textarea>
          <div class="tsf-cli360__edit-bar">
            <button type="button" class="tsf-cli360__btn tsf-cli360__btn--primary" data-action="save-notes" disabled>Salvar nota</button>
          </div>
        </section>
      `;
    }

    /* ════════ MARKETING & TAGS · CLI-9 W3 ════════ */
    // Categorias editáveis · single = mutuamente exclusiva (setar troca a anterior) · auto = gerada pelo sistema (read-only)
    #tagCats() {
      return [
        { key: 'perfil',    label: 'Perfil',          mode: 'single', auto: true },
        { key: 'tipo',      label: 'Estágio',         mode: 'single', auto: true },
        { key: 'valor',     label: 'Valor (LTV)',     mode: 'single', auto: false, presets: ['vip', 'alto', 'padrao', 'baixo'] },
        { key: 'atividade', label: 'Atividade',       mode: 'single', auto: true,  presets: ['hot', 'warm', 'cool'] },
        { key: 'estado',    label: 'Estado',          mode: 'single', auto: false, presets: ['sp','rj','mg','es','pr','sc','rs','ba','go','df','pe','ce','pa','am','mt','ms'] },
        { key: 'email',     label: 'Segmento e-mail', mode: 'single', auto: false, presets: ['pessoal','corporativo','arquitetura','construcao','imobiliario','hospitalidade','educacao'] },
      ];
    }
    #tagValLabel(cat, val) {
      if (cat === 'perfil') return this.#getPerfilLabel(val);
      const M = {
        tipo: { 'b2c-pesquisando':'B2C · pesquisando', 'b2c-comprador-unico':'B2C · comprou', 'b2b-pesquisando':'B2B · pesquisando', 'b2b-comprador-unico':'B2B · comprou', 'b2b-recorrente':'B2B · recorrente', 'interno':'Interno' },
        valor: { vip:'VIP', alto:'Alto valor', padrao:'Padrão', baixo:'Baixo' },
        atividade: { hot:'Quente', warm:'Morno', cool:'Frio' },
        email: { pessoal:'Pessoal', corporativo:'Corporativo', arquitetura:'Arquitetura', construcao:'Construção', imobiliario:'Imobiliário', hospitalidade:'Hospitalidade', educacao:'Educação' },
      };
      if (M[cat] && M[cat][val]) return M[cat][val];
      if (cat === 'estado') return String(val).toUpperCase();
      return String(val).replace(/-/g, ' ');
    }
    // Sinais de match pra Meta/Google — quanto mais, melhor o casamento da conversão
    #computeMatchQuality() {
      const c = this.#client || {};
      const cep = String(c.cep || c.endereco?.cep || c.endereco_fiscal?.cep || '').replace(/\D/g, '');
      const sig = {
        email: !!(c.email && /@/.test(c.email)),
        phone: String(c.whatsapp || '').replace(/\D/g, '').length >= 10,
        doc:   (String(c.cpf || '').replace(/\D/g, '').length >= 11) || (String(c.cnpj || '').replace(/\D/g, '').length >= 14),
        cep:   cep.length === 8,
      };
      const score = Object.values(sig).filter(Boolean).length;
      const label = ['Fraco', 'Fraco', 'Médio', 'Bom', 'Forte'][score] || 'Fraco';
      const slug = label.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
      return { sig, score, label, slug };
    }
    #consentState() {
      const tags = this.#client?.tags || [];
      if (tags.includes('consentimento:marketing-ok')) return 'ok';
      if (tags.includes('consentimento:marketing-pendente')) return 'pendente';
      return 'none';
    }
    #heroBadgesHtml() {
      const tags = this.#client?.tags || [];
      const primary = this.#getPrimaryPerfil();
      const atividade = (tags.find(t => t.startsWith('atividade:')) || '').replace('atividade:', '');
      const valor = (tags.find(t => t.startsWith('valor:')) || '').replace('valor:', '');
      const specTier = ((tags.find(t => /^specifica-(gold|black|comunidade)$/.test(t)) || '').replace('specifica-', ''));
      return [
        `<span class="tsf-cli-badge tsf-cli-badge--${this.#esc(primary.replace('cliente-', ''))}">${this.#esc(this.#getPerfilLabel(primary))}</span>`,
        specTier ? `<span class="tsf-cli-badge tsf-cli-badge--specifica-${this.#esc(specTier)}">Specifica ${this.#esc(specTier)}</span>` : '',
        atividade ? `<span class="tsf-cli-badge tsf-cli-badge--${this.#esc(atividade)}">${this.#esc(atividade)}</span>` : '',
        valor ? `<span class="tsf-cli-badge tsf-cli-badge--${this.#esc(valor)}">${this.#esc(valor)}</span>` : '',
      ].filter(Boolean).join('');
    }
    // Mantém o hero coerente quando o usuário edita tags (perfil/valor/atividade) sem full re-render
    #syncHero() {
      const badgesEl = this.querySelector('.tsf-cli360__hero-badges');
      if (badgesEl) badgesEl.innerHTML = this.#heroBadgesHtml();
      const valor = ((this.#client?.tags || []).find(t => t.startsWith('valor:')) || '').replace('valor:', '');
      const av = this.querySelector('.tsf-cli360__hero-avatar');
      if (av) av.classList.toggle('tsf-cli360__hero-avatar--vip', valor === 'vip');
    }

    // CLI-9 W4 · Funil do cliente · jornada Visitou→Carrinho→Checkout→Pagamento→Comprou.
    // Lógica de funil: um estágio acende se ELE ou QUALQUER posterior tem sinal (atingir checkout
    // implica passou pelo carrinho — robusto a gaps de captura). "Comprou" = pedido/venda/LTV real.
    #renderFunnel() {
      const tags = Array.isArray(this.#client?.tags) ? this.#client.tags : [];
      const has = (t) => tags.includes(t);
      const ltv = Number(this.#client?.lifetime_value_centavos || 0);
      const comprou = this.#ordersTotal > 0 || (this.#sales?.length > 0) || ltv > 0;
      const visitou = comprou || tags.some((t) => /^(interesse|categoria|material|ambiente|vendor|evento|bloco-3d|catalogo|acabamento|wishlist|solicitou-|funil):/.test(t));
      const raw = { visitou, carrinho: has('funil:carrinho'), checkout: has('funil:checkout'), pagamento: has('funil:pagamento'), comprou };
      const ORDER = [
        { key: 'visitou',   label: 'Visitou',    icon: '◷' },
        { key: 'carrinho',  label: 'Carrinho',   icon: '🛒' },
        { key: 'checkout',  label: 'Checkout',   icon: '🧾' },
        { key: 'pagamento', label: 'Pagamento',  icon: '💳' },
        { key: 'comprou',   label: 'Comprou',    icon: '✓' },
      ];
      const reachedIdx = ORDER.reduce((acc, s, i) => (raw[s.key] ? i : acc), -1);
      if (reachedIdx < 0) return ''; // sem nenhuma pegada → não mostra o funil
      const nodes = ORDER.map((s, i) => {
        const on = i <= reachedIdx;
        const cur = i === reachedIdx;
        return `<div class="tsf-funnel__node ${on ? 'is-on' : 'is-off'}${cur ? ' is-current' : ''}">
            <span class="tsf-funnel__dot">${on ? s.icon : ''}</span>
            <span class="tsf-funnel__lbl">${s.label}</span>
          </div>`;
      }).join('<span class="tsf-funnel__bar" aria-hidden="true"></span>');
      const hint = comprou ? 'Cliente <b>comprou</b> — momento de recompra / cross-sell.'
        : raw.pagamento ? '⚠ Chegou no <b>pagamento</b> e não fechou — altíssima intenção. Vale um WhatsApp agora.'
        : raw.checkout ? 'Chegou no <b>checkout</b> e parou — bom momento pra abordar.'
        : raw.carrinho ? 'Montou <b>carrinho</b> — interesse concreto.'
        : 'Navegou / baixou conteúdo — em qualificação.';
      return `
        <section class="tsf-funnel">
          <span class="tsf-funnel__eyebrow">Jornada do cliente</span>
          <div class="tsf-funnel__track">${nodes}</div>
          <p class="tsf-funnel__hint">${hint}</p>
        </section>`;
    }

    #renderMarketing() {
      const tags = Array.isArray(this.#client.tags) ? this.#client.tags : [];
      const q = this.#computeMatchQuality();
      const consent = this.#consentState();

      const sigRow = [
        ['E-mail', q.sig.email], ['Telefone', q.sig.phone], ['CPF/CNPJ', q.sig.doc], ['CEP', q.sig.cep],
      ].map(([lbl, on]) => `
        <div class="tsf-mkt__signal ${on ? 'is-on' : 'is-off'}">
          <span class="tsf-mkt__signal-dot">${on ? '✓' : '○'}</span>
          <span class="tsf-mkt__signal-lbl">${lbl}</span>
        </div>`).join('');

      const consentLabel = consent === 'ok' ? 'Marketing OK' : consent === 'pendente' ? 'Pendente' : 'Definir';
      const qualityCard = `
        <section class="tsf-mkt__quality tsf-mkt__quality--${q.slug}">
          <div class="tsf-mkt__quality-head">
            <div class="tsf-mkt__quality-headline">
              <span class="tsf-mkt__quality-eyebrow">Qualidade pra remarketing</span>
              <strong class="tsf-mkt__quality-score">${q.label} · ${q.score}/4 sinais</strong>
            </div>
            <div class="tsf-mkt__consent">
              <span class="tsf-mkt__consent-lbl">Consentimento marketing</span>
              <button type="button" class="tsf-mkt__consent-toggle is-${consent}" data-action="toggle-consent">${consentLabel}</button>
            </div>
          </div>
          <div class="tsf-mkt__signals">${sigRow}</div>
        </section>`;

      const used = new Set();
      const groupHtml = this.#tagCats().map(cat => {
        const vals = tags.filter(t => t.startsWith(cat.key + ':')).map(t => { used.add(t); return t.slice(cat.key.length + 1); });
        const chips = vals.map(v => {
          const variant = (cat.key === 'atividade' || cat.key === 'valor') ? ` tsf-tagchip--${cat.key}-${this.#esc(v)}` : '';
          const x = cat.auto ? '' : `<button type="button" class="tsf-tagchip__x" data-tag-remove="${this.#esc(cat.key + ':' + v)}" aria-label="remover">×</button>`;
          return `<span class="tsf-tagchip tsf-tagchip--${cat.key}${variant}">${this.#esc(this.#tagValLabel(cat.key, v))}${x}</span>`;
        }).join('');
        const presetBtns = (!cat.auto && cat.presets)
          ? cat.presets.filter(p => !vals.includes(p)).map(p => `<button type="button" class="tsf-tagadd" data-tag-set="${this.#esc(cat.key)}" data-tag-val="${this.#esc(p)}">+ ${this.#esc(this.#tagValLabel(cat.key, p))}</button>`).join('')
          : '';
        return `
          <div class="tsf-mkt__group">
            <span class="tsf-mkt__group-lbl">${cat.label}${cat.auto ? ' <em>auto</em>' : ''}</span>
            <div class="tsf-mkt__group-chips">
              ${chips || '<span class="tsf-mkt__group-empty">—</span>'}
              ${presetBtns}
            </div>
          </div>`;
      }).join('');

      const KNOWN = ['perfil','tipo','valor','atividade','estado','email','cohort','consentimento','interesse','categoria','material','ambiente','vendor','bloco-3d','catalogo','acabamento','evento','wishlist','solicitou-3d','solicitou-catalogo','solicitou-acabamento','lifecycle','specifica'];
      const custom = tags.filter(t => {
        if (used.has(t)) return false;
        if (/^specifica-/.test(t)) return false;
        if (KNOWN.includes(t.split(':')[0])) return false;
        return true;
      });
      const customChips = custom.map(t => `<span class="tsf-tagchip tsf-tagchip--campanha">${this.#esc(t)}<button type="button" class="tsf-tagchip__x" data-tag-remove="${this.#esc(t)}" aria-label="remover">×</button></span>`).join('');
      const campaignBox = `
        <div class="tsf-mkt__group">
          <span class="tsf-mkt__group-lbl">Campanhas & personalizadas</span>
          <div class="tsf-mkt__group-chips">
            ${customChips}
            <span class="tsf-mkt__campaign">
              <input type="text" class="tsf-mkt__campaign-input" data-tag-campaign placeholder="ex: natal-2026" maxlength="40" autocomplete="off">
              <button type="button" class="tsf-tagadd tsf-tagadd--go" data-action="add-campaign">adicionar</button>
            </span>
          </div>
          <span class="tsf-mkt__campaign-hint" data-campaign-hint></span>
        </div>`;

      // 2026-06-27 · "Comportamento no site" (produtos engajados + interesses) saiu daqui pra a ABA
      //   Interesses (acesso 1-clique, visível). Aqui fica só o funil + o card de qualidade + as tags.
      const funnelHtml = this.#renderFunnel();
      return `
        ${(funnelHtml && funnelHtml.trim()) ? '<p class="tsf-cli360__group-eyebrow">Atividade</p>' : ''}
        ${funnelHtml}
        <p class="tsf-cli360__group-eyebrow">Marketing</p>
        ${qualityCard}
        <section class="tsf-cli360__section">
          <h2 class="tsf-cli360__section-title"><span>Tags & segmentação</span><span class="tsf-mkt__save-status" data-tags-status></span></h2>
          ${groupHtml}
          ${campaignBox}
        </section>`;
    }

    // Frente 2 · publica/despublica o especificador na vitrine (POST /client/vitrine → metaobjeto DRAFT↔ACTIVE)
    async #setVitrine(publish) {
      const btn = this.querySelector('[data-action="vitrine-publish"], [data-action="vitrine-unpublish"]');
      if (btn) { btn.disabled = true; btn.textContent = publish ? 'Publicando…' : 'Removendo…'; }
      const prev = Array.isArray(this.#client.tags) ? [...this.#client.tags] : [];
      try {
        const res = await fetch(`${CLIENT_ENDPOINT}/vitrine`, {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: this.#targetId, publish }),
        });
        const data = await res.json();
        if (!data.ok) throw new Error(data.error || 'falha');
        // Fonte da verdade = metaobjeto (já atualizado no servidor); espelha a tag local p/ re-render imediato.
        const tags = prev.filter(t => t !== 'vitrine:publicada');
        if (publish) tags.push('vitrine:publicada');
        this.#client.tags = tags;
        this.#refreshPane('overview');
        this.#syncHero();
      } catch (e) {
        this.#refreshPane('overview'); // reverte o visual (a tag local não mudou)
        alert('Não foi possível atualizar a vitrine: ' + (e?.message || 'erro de rede'));
      }
    }

    // Grava tags · otimista (atualiza local na hora, reverte se o servidor falhar)
    async #saveTags({ add = [], remove = [] }) {
      const prev = Array.isArray(this.#client.tags) ? [...this.#client.tags] : [];
      const norm = (t) => String(t || '').trim().toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9:_-]/g, '');
      const next = prev.filter(t => !remove.includes(t));
      for (const a of add) { const n = norm(a); if (n && !next.includes(n)) next.push(n); }
      this.#client.tags = next;
      this.#refreshPane('overview');
      this.#syncHero();
      const statusEl = this.querySelector('[data-tags-status]');
      if (statusEl) statusEl.textContent = 'salvando…';
      try {
        const res = await fetch(`${CLIENT_ENDPOINT}/tags`, {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: this.#targetId, add, remove }),
        });
        const data = await res.json();
        if (!data.ok) throw new Error(data.error || 'falha');
        this.#client.tags = Array.isArray(data.tags) ? data.tags : next;
        this.#refreshPane('overview');
        this.#syncHero();
        const s2 = this.querySelector('[data-tags-status]');
        if (s2) { s2.textContent = '✓ salvo'; setTimeout(() => { const e = this.querySelector('[data-tags-status]'); if (e) e.textContent = ''; }, 2500); }
      } catch (err) {
        this.#client.tags = prev;
        this.#refreshPane('overview');
        this.#syncHero();
        const s2 = this.querySelector('[data-tags-status]');
        if (s2) s2.textContent = 'erro ao salvar';
        alert('Erro ao salvar tag: ' + (err?.message || 'falha'));
      }
    }
    #toggleConsent() {
      const cur = this.#consentState();
      const add = [cur === 'ok' ? 'consentimento:marketing-pendente' : 'consentimento:marketing-ok'];
      const remove = (this.#client.tags || []).filter(t => t.startsWith('consentimento:'));
      this.#saveTags({ add, remove });
    }
    #addCampaign() {
      const input = this.querySelector('[data-tag-campaign]');
      const raw = (input?.value || '').trim();
      if (!raw) return;
      this.#saveTags({ add: [raw] });
    }

    /* ─── EVENTS ─── */
    #bindEvents() {
      const sig = this.#abortController.signal;

      // Tab navigation
      this.querySelectorAll('[data-tab]').forEach(btn => {
        btn.addEventListener('click', () => this.#switchTab(btn.getAttribute('data-tab')), { signal: sig });
      });

      // Actions delegate
      this.addEventListener('click', (e) => {
        // CLI-9 · tag manager · remover chip
        const rm = e.target.closest('[data-tag-remove]');
        if (rm) { this.#saveTags({ remove: [rm.getAttribute('data-tag-remove')] }); return; }
        // CLI-9 · tag manager · setar preset (single = troca o anterior da categoria)
        const setBtn = e.target.closest('[data-tag-set]');
        if (setBtn) {
          const cat = setBtn.getAttribute('data-tag-set');
          const val = setBtn.getAttribute('data-tag-val');
          const existing = (this.#client.tags || []).filter(t => t.startsWith(cat + ':'));
          this.#saveTags({ add: [cat + ':' + val], remove: existing });
          return;
        }
        const action = e.target.closest('[data-action]')?.getAttribute('data-action');
        if (!action) return;
        if (action === 'toggle-edit')   { this.#editMode = !this.#editMode; this.#dirty = false; this.#refreshPane('overview'); }
        else if (action === 'cancel-edit') { this.#editMode = false; this.#dirty = false; this.#refreshPane('overview'); }
        else if (action === 'save-edit')   { this.#saveEdit(); }
        else if (action === 'save-notes')  { this.#saveNotes(); }
        else if (action === 'new-quote')   { this.#newQuote(); }
        else if (action === 'new-sale')    { this.#newSale(); }
        else if (action === 'toggle-consent') { this.#toggleConsent(); }
        else if (action === 'add-campaign')   { this.#addCampaign(); }
        else if (action === 'vitrine-publish')   { this.#setVitrine(true); }
        else if (action === 'vitrine-unpublish') { this.#setVitrine(false); }
      }, { signal: sig });

      // Dirty tracking on edit inputs
      this.addEventListener('input', (e) => {
        if (e.target.matches('[data-field]')) {
          this.#dirty = true;
          const btn = this.querySelector('[data-action="save-edit"]');
          if (btn) btn.disabled = false;
          // 2026-06-29 · CEP completo → preenche cidade/UF/logradouro/bairro sozinho (paridade c/ venda e orçamento)
          if (e.target.getAttribute('data-field') === 'endereco.cep') {
            const digits = (e.target.value || '').replace(/\D/g, '');
            clearTimeout(this.#cep360Timer);
            if (digits.length === 8) this.#cep360Timer = setTimeout(() => this.#lookupCep360(digits), 250);
          }
        } else if (e.target.matches('[data-notes-input]')) {
          const btn = this.querySelector('[data-action="save-notes"]');
          if (btn) btn.disabled = false;
        } else if (e.target.matches('[data-tag-campaign]')) {
          // CLI-9 · preview da normalização anti-typo da tag de campanha
          const hint = this.querySelector('[data-campaign-hint]');
          const raw = e.target.value.trim();
          const norm = raw.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9:_-]/g, '');
          if (hint) hint.textContent = (norm && norm !== raw.toLowerCase()) ? `vai virar: ${norm}` : '';
        }
      }, { signal: sig });

      // CLI-9 · Enter no input de campanha adiciona a tag
      this.addEventListener('keydown', (e) => {
        if (e.target.matches('[data-tag-campaign]') && e.key === 'Enter') { e.preventDefault(); this.#addCampaign(); }
      }, { signal: sig });
    }

    #switchTab(tab) {
      this.#activeTab = tab;
      // Update URL
      const url = new URL(window.location.href);
      url.searchParams.set('tab', tab);
      window.history.replaceState({}, '', url.toString());

      this.querySelectorAll('[data-tab]').forEach(b => {
        b.setAttribute('aria-selected', String(b.getAttribute('data-tab') === tab));
      });
      this.querySelectorAll('[data-pane]').forEach(p => {
        p.setAttribute('data-active', String(p.getAttribute('data-pane') === tab));
      });
    }

    #refreshPane(name) {
      const pane = this.querySelector(`[data-pane="${name}"]`);
      if (!pane) return;
      if (name === 'overview') pane.innerHTML = this.#renderOverview();
      else if (name === 'interests') pane.innerHTML = this.#renderInterests();
      else if (name === 'orders') pane.innerHTML = this.#renderOrders();
      else if (name === 'quotes') pane.innerHTML = this.#renderQuotes();
      else if (name === 'sales')  pane.innerHTML = this.#renderSales();
      else if (name === 'notes')  pane.innerHTML = this.#renderNotes();
    }

    async #saveEdit() {
      if (this.#saving) return;
      this.#saving = true;
      const btn = this.querySelector('[data-action="save-edit"]');
      if (btn) { btn.disabled = true; btn.textContent = 'Salvando…'; }

      // Coletar fields editados
      const payload = { id: this.#targetId };
      this.querySelectorAll('[data-field]').forEach(el => {
        const k = el.getAttribute('data-field');
        const val = el.value || '';
        // 2026-06-29 · chaves com ponto (ex.: endereco.cep) viram objeto aninhado — o back-end espera `endereco: {...}`
        if (k.includes('.')) {
          const [parent, child] = k.split('.');
          if (!payload[parent] || typeof payload[parent] !== 'object') payload[parent] = {};
          payload[parent][child] = val;
        } else {
          payload[k] = val;
        }
      });

      try {
        const res = await fetch(`${CLIENT_ENDPOINT}/upsert`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        });
        const data = await res.json();
        if (!data.ok) throw new Error(data.error || 'falha');
        // Atualizar local + sair do edit mode
        this.#client = data.client || this.#client;
        // 2026-06-29 · o endereço recém-salvo aparece NA HORA (o metafield tsf.endereco_fiscal pode ter
        // consistência eventual no Shopify; merge otimista evita a tela voltar "em branco" após salvar).
        if (payload.endereco && Object.keys(payload.endereco).length) {
          this.#client = { ...this.#client, endereco: { ...((this.#client && this.#client.endereco) || {}), ...payload.endereco } };
        }
        this.#editMode = false;
        this.#dirty = false;
        this.#render();
        this.#bindEvents();
      } catch (err) {
        alert('Erro ao salvar: ' + err.message);
        if (btn) { btn.disabled = false; btn.textContent = 'Salvar alterações'; }
      } finally {
        this.#saving = false;
      }
    }

    // 2026-06-29 · ViaCEP · preenche os campos de endereço a partir do CEP (não sobrescreve com vazio).
    // Conveniência — se o ViaCEP falhar, o save manual segue normalmente.
    async #lookupCep360(digits) {
      try {
        const res = await fetch(`https://viacep.com.br/ws/${digits}/json/`);
        const data = await res.json();
        if (!data || data.erro) return;
        const set = (key, val) => { const el = this.querySelector(`[data-field="endereco.${key}"]`); if (el && val) el.value = val; };
        set('logradouro', data.logradouro);
        set('bairro', data.bairro);
        set('cidade', data.localidade);
        set('uf', (data.uf || '').toUpperCase());
        this.#dirty = true;
        const btn = this.querySelector('[data-action="save-edit"]');
        if (btn) btn.disabled = false;
      } catch (e) { /* silencioso · CEP é conveniência, não bloqueia o save manual */ }
    }

    async #saveNotes() {
      const input = this.querySelector('[data-notes-input]');
      if (!input) return;
      const value = input.value || '';
      const btn = this.querySelector('[data-action="save-notes"]');
      const statusEl = this.querySelector('[data-notes-status]');
      if (btn) { btn.disabled = true; btn.textContent = 'Salvando…'; }
      if (statusEl) statusEl.textContent = 'salvando…';

      try {
        const res = await fetch(`${CLIENT_ENDPOINT}/upsert`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: this.#targetId, nome: this.#client.nome, notes: value }),
        });
        const data = await res.json();
        if (!data.ok) throw new Error(data.error || 'falha');
        this.#client = data.client;
        if (statusEl) statusEl.textContent = 'salvo · ' + new Date().toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
        if (btn) { btn.textContent = 'Salvar nota'; }
        setTimeout(() => { if (statusEl) statusEl.textContent = ''; }, 4000);
      } catch (err) {
        alert('Erro ao salvar nota: ' + err.message);
        if (btn) { btn.disabled = false; btn.textContent = 'Salvar nota'; }
        if (statusEl) statusEl.textContent = '';
      }
    }

    async #newQuote() {
      // 2026-06-26 · BUGFIX roteamento: ANTES postava /quote/update SEM quote_id → caía no fallback
      //   "draft mais recente" e REATRIBUÍA o orçamento de OUTRO cliente (corrompia + poluía remarketing).
      //   Agora CRIA uma quote nova e vincula ESTE cliente NELA com quote_id explícito (espelha o #newSale).
      try {
        const ctx = (typeof CUSTOMER !== 'undefined' && CUSTOMER) ? CUSTOMER : {};
        // 1. cria a quote em branco (como o TsfQuoteBuilder faz via /quote/create)
        const cr = await fetch(`${QUOTE_ENDPOINT}/create`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            specifier_customer_id: this.#specifierId,
            quote_kind: 'toth_internal',
            specifier_email: ctx.email || null,
          }),
        });
        const cd = await cr.json();
        if (!cd.ok || !cd.quote?.id) throw new Error(cd.error || 'falha ao criar');
        const newId = cd.quote.id;
        // 2. vincula o cliente NESSA quote (quote_id → sem fallback heurístico)
        const c = this.#client || {};
        const addr = c.endereco || {};
        const clientInfo = {
          name: c.nome,
          tipo: ((c.cnpj || '').replace(/\D/g, '').length === 14) ? 'b2b' : 'b2c',
          email: c.email, whatsapp: c.whatsapp, cpf: c.cpf, cnpj: c.cnpj, ie: c.ie, im: c.im,
          cep: addr.cep,
          address: {
            logradouro: addr.logradouro, numero: addr.numero, complemento: addr.complemento,
            bairro: addr.bairro, localidade: addr.cidade || addr.localidade,
            cidade: addr.cidade || addr.localidade, uf: addr.uf,
          },
        };
        const up = await fetch(`${QUOTE_ENDPOINT}/update`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            quote_id: newId,
            specifier_customer_id: this.#specifierId,
            quote_kind: 'toth_internal',
            patch: { customer_id: Number(this.#targetId), customer_snapshot: c, client_info: clientInfo },
          }),
        });
        const ud = await up.json();
        if (!ud.ok) throw new Error(ud.error || 'falha ao vincular cliente');
        window.location.href = `/pages/admin-orcamento?id=${encodeURIComponent(newId)}`;
      } catch (err) {
        alert('Erro ao criar orçamento: ' + err.message);
      }
    }

    async #newSale() {
      const ctx = (typeof CUSTOMER !== 'undefined' && CUSTOMER) ? CUSTOMER : {};
      try {
        const res = await fetch(`${SALE_ENDPOINT}/create-direct`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            specifier_customer_id: this.#specifierId,
            specifier_email: ctx.email || null,
            customer_id: this.#targetId,
          }),
        });
        const data = await res.json();
        if (!data.ok) throw new Error(data.error || 'falha');
        window.location.href = `/pages/admin-venda?id=${encodeURIComponent(data.sale.id)}`;
      } catch (err) {
        alert('Erro ao criar venda direta: ' + err.message);
      }
    }
  }

  /* ════════════════════════════════════════════════════════════════════
     O ACERVO VIVO · Roster (TsfAdminAteliers) + Palco (TsfAtelierStage)
     O metaobjeto `fornecedor` é a espinha única (sync grátis). O admin é o
     galerista que dá ALMA editorial a 28 ateliês — não preenche um CRUD.
     ════════════════════════════════════════════════════════════════════ */
  const ACERVO_ENDPOINT = 'https://pucrgwvcgagbapzvphao.supabase.co/functions/v1/toth-checkout/fornecedor';

  const TSF_ACERVO_CSS = `
    .tsf-acv { display:block; }
    .tsf-acv__head { display:flex; align-items:flex-end; justify-content:space-between; gap:24px; flex-wrap:wrap;
      padding-block-end:22px; margin-block-end:28px; border-block-end:1px solid var(--tsf-border,#e7e3dc); }
    .tsf-acv__eyebrow { font-size:11px; font-weight:600; letter-spacing:.22em; text-transform:uppercase; color:var(--tsf-gold-ink,#8a5406); }
    .tsf-acv__title { font-family:var(--tsf-font-serif,'Cormorant Garamond',Georgia,serif); font-size:clamp(30px,3.2vw,38px);
      font-weight:300; letter-spacing:-0.02em; line-height:1.04; margin:6px 0 8px; color:var(--tsf-text-strong,#2a2723); }
    .tsf-acv__lede { font-size:14px; line-height:1.5; color:var(--tsf-text-muted,#7a746c); max-inline-size:60ch; }
    .tsf-acv__lede strong { color:var(--gold-accent,#A16207); font-weight:600; }
    .tsf-acv__sort { display:inline-flex; gap:4px; background:var(--warm-sand,#f3f1ed); padding:4px; border-radius:999px; }
    .tsf-acv__sort button { appearance:none; border:0; background:transparent; cursor:pointer; padding:7px 15px; border-radius:999px;
      font-size:12px; letter-spacing:0.04em; color:var(--tsf-text-muted,#7a746c); transition:all .3s var(--ease-luxury,ease); }
    .tsf-acv__sort button[aria-pressed="true"] { background:#fff; color:var(--tsf-text-strong,#2a2723); box-shadow:0 1px 3px rgba(40,40,40,.08); }
    .tsf-acv__grid { display:grid; grid-template-columns:repeat(auto-fill,minmax(244px,1fr)); gap:18px; }
    .tsf-acv-card { display:flex; flex-direction:column; gap:11px; padding:22px 20px 20px; border:1px solid var(--tsf-border,#e7e3dc);
      border-radius:12px; background:#fff; text-decoration:none; color:inherit; position:relative; isolation:isolate;
      transition:transform .4s var(--ease-luxury,ease), box-shadow .4s var(--ease-luxury,ease), border-color .4s var(--ease-luxury,ease); }
    .tsf-acv-card:hover { transform:translateY(-3px); box-shadow:0 14px 36px -18px rgba(40,40,40,.30); border-color:var(--gold-accent,#A16207); }
    .tsf-acv-card:focus-visible { outline:2px solid var(--gold-accent,#A16207); outline-offset:3px; }
    .tsf-acv-card--adormecido { background:#fdfcfa; border-color:#e4e0d8; }
    .tsf-acv-card--adormecido .tsf-acv-card__name { color:#3a352f; font-weight:400; }
    .tsf-acv-card--vivo { border-color:rgba(161,98,7,.32); }
    .tsf-acv-card__top { display:flex; align-items:center; justify-content:space-between; }
    .tsf-acv-ringwrap { position:relative; width:64px; height:64px; flex:none; }
    .tsf-acv-ring { display:block; }
    .tsf-acv-ring__track { stroke:#dcd5c8; }
    .tsf-acv-ring__arc { transition:stroke-dashoffset .9s var(--ease-luxury,ease); }
    .tsf-acv-ring--vivo .tsf-acv-ring__arc { stroke:var(--gold-accent,#A16207); }
    .tsf-acv-ring--esbocado .tsf-acv-ring__arc { stroke:#c79a4e; }
    .tsf-acv-ring--adormecido .tsf-acv-ring__arc { stroke:#cfc8bd; }
    .tsf-acv-ring__center { position:absolute; inset:8px; border-radius:50%; overflow:hidden; display:flex; align-items:center; justify-content:center;
      background:var(--warm-sand,#f3f1ed); }
    .tsf-acv-ring__center img { width:100%; height:100%; object-fit:cover; }
    .tsf-acv-ring__center { background:#f1ede4; }
    .tsf-acv-ring__center span { font-family:var(--font-heading-family,Georgia,serif); font-size:25px; font-weight:400; color:#3F4D3A; }
    .tsf-acv-state { font-family:var(--font-heading-family,Georgia,serif); font-style:italic; font-size:14px; letter-spacing:.01em; }
    .tsf-acv-state--vivo { color:var(--gold-accent,#A16207); }
    .tsf-acv-state--esbocado { color:#b07d2e; }
    .tsf-acv-state--adormecido { color:var(--tsf-text-dim,#a8a299); }
    .tsf-acv-card__name { font-family:var(--font-heading-family,Georgia,serif); font-size:19px; font-weight:400; letter-spacing:-0.01em;
      margin:0; color:var(--tsf-text-strong,#2a2723); }
    .tsf-acv-card__bio { font-size:12.5px; line-height:1.5; color:var(--tsf-text-muted,#7a746c); margin:0;
      display:-webkit-box; -webkit-line-clamp:2; -webkit-box-orient:vertical; overflow:hidden; min-height:2.6em; }
    .tsf-acv-empty { color:var(--tsf-text-dim,#a8a299); }
    .tsf-acv-card__chips { display:flex; flex-wrap:wrap; gap:5px; }
    .tsf-acv-chip { font-size:10.5px; letter-spacing:.02em; padding:3px 9px; border-radius:999px; background:var(--warm-sand,#f3f1ed); color:var(--tsf-text-muted,#7a746c); }
    .tsf-acv-card__missing { font-size:11px; letter-spacing:.01em; color:var(--tsf-text-dim,#a8a299); margin:2px 0 0; }
    .tsf-acv-card__missing span { text-transform:uppercase; letter-spacing:.18em; font-weight:600; font-size:9.5px; color:var(--tsf-text-dim,#bdb6ab); margin-inline-end:5px; }
    .tsf-acv-card__missing--ok { color:var(--gold-accent,#A16207); }
    .tsf-acv-skel { background:linear-gradient(90deg,#f0ede8 25%,#f7f5f1 50%,#f0ede8 75%); background-size:200% 100%;
      animation:tsfAcvShimmer 1.4s infinite; border-radius:12px; }
    @keyframes tsfAcvShimmer { 0%{background-position:200% 0} 100%{background-position:-200% 0} }
    .tsf-acv__err { padding:40px; text-align:center; color:var(--tsf-text-muted,#7a746c); }
    .tsf-acv__err button { margin-top:14px; padding:9px 20px; border-radius:999px; border:1px solid var(--tsf-border,#e7e3dc); background:#fff; cursor:pointer; }

    /* ── O Palco · editor ── */
    .tsf-stage { display:block; }
    .tsf-stage__back { display:inline-flex; align-items:center; gap:6px; font-size:12px; letter-spacing:.18em; text-transform:uppercase;
      color:var(--tsf-text-muted,#7a746c); text-decoration:none; margin-block-end:18px; }
    .tsf-stage__back:hover { color:var(--gold-accent,#A16207); }
    .tsf-stage__hero { display:flex; align-items:center; gap:18px; padding-block-end:22px; margin-block-end:8px; border-block-end:1px solid var(--tsf-border,#e7e3dc); }
    .tsf-stage__hero .tsf-acv-ringwrap { width:72px; height:72px; }
    .tsf-stage__heading { flex:1; min-width:0; }
    .tsf-stage__name { font-family:var(--font-heading-family,Georgia,serif); font-size:clamp(26px,4vw,38px); font-weight:300; letter-spacing:-0.02em; margin:0; color:var(--tsf-text-strong,#2a2723); }
    .tsf-stage__meta { display:flex; align-items:center; gap:12px; margin-top:6px; flex-wrap:wrap; }
    .tsf-stage__save { font-size:12px; color:var(--tsf-text-dim,#a8a299); transition:color .3s; }
    .tsf-stage__save--saving { color:#b07d2e; }
    .tsf-stage__save--ok { color:var(--gold-accent,#A16207); }
    .tsf-stage__save--err { color:#c0392b; }
    .tsf-stage__pub { display:inline-flex; align-items:center; gap:7px; font-size:12px; color:var(--tsf-text-muted,#7a746c); cursor:pointer; }
    .tsf-stage__sec { padding-block:24px; border-block-end:1px solid var(--tsf-border,#e7e3dc); }
    .tsf-stage__sec-title { font-size:11px; font-weight:600; letter-spacing:.18em; text-transform:uppercase; color:var(--tsf-text-dim,#a8a299); margin:0 0 16px; }
    .tsf-stage__field { margin-block-end:16px; }
    .tsf-stage__label { display:block; font-size:12.5px; font-weight:500; color:var(--tsf-text-strong,#2a2723); margin-block-end:5px; }
    .tsf-stage__hint { font-size:11px; color:var(--tsf-text-dim,#a8a299); margin:4px 0 0; }
    .tsf-stage input[type=text], .tsf-stage input[type=number], .tsf-stage textarea {
      width:100%; box-sizing:border-box; padding:10px 12px; border:1px solid var(--tsf-border,#e7e3dc); border-radius:10px;
      font:inherit; font-size:14px; background:#fff; color:var(--tsf-text-strong,#2a2723); transition:border-color .3s var(--ease-luxury,ease); }
    .tsf-stage input:focus, .tsf-stage textarea:focus { outline:none; border-color:var(--gold-accent,#A16207); }
    .tsf-stage textarea { resize:vertical; min-height:80px; line-height:1.55; }
    .tsf-stage__tiers { display:flex; gap:8px; flex-wrap:wrap; }
    .tsf-stage__tier { display:inline-flex; align-items:center; gap:7px; padding:8px 14px; border:1px solid var(--tsf-border,#e7e3dc); border-radius:999px; cursor:pointer; font-size:13px; }
    .tsf-stage__tier input { accent-color:var(--gold-accent,#A16207); }
    .tsf-stage__tier--soon { opacity:.55; }
    .tsf-soon { font-size:9px; font-weight:600; letter-spacing:.18em; text-transform:uppercase; color:var(--tsf-text-dim,#a8a299); border:1px solid var(--tsf-border,#e7e3dc); border-radius:999px; padding:2px 7px; margin-left:4px; }
    .tsf-switch { display:inline-flex; align-items:center; gap:10px; cursor:pointer; font-size:13px; margin-top:14px; line-height:1.45; }
    .tsf-switch input { position:absolute; opacity:0; pointer-events:none; }
    .tsf-switch__track { width:38px; height:22px; border-radius:999px; background:var(--tsf-border,#d9d4cb); position:relative; transition:background .25s ease; flex:none; }
    .tsf-switch__track::after { content:''; position:absolute; top:3px; left:3px; width:16px; height:16px; border-radius:50%; background:#fff; box-shadow:0 1px 3px rgba(0,0,0,.25); transition:transform .25s ease; }
    .tsf-switch input:checked + .tsf-switch__track { background:var(--gold-accent,#A16207); }
    .tsf-switch input:checked + .tsf-switch__track::after { transform:translateX(16px); }
    .tsf-switch__lbl b { font-weight:600; color:var(--tsf-text,#2b2926); }
    .tsf-sync-note { display:flex; gap:9px; align-items:flex-start; margin-top:16px; padding:12px 14px; border-radius:12px; background:var(--tsf-bg-soft,#f6f4f0); font-size:12.5px; line-height:1.55; color:var(--tsf-text-muted,#7a746c); }
    .tsf-sync-note--on { background:rgba(63,77,58,.09); color:#3F4D3A; }
    .tsf-sync-note__dot { flex:none; margin-top:5px; width:8px; height:8px; border-radius:50%; background:#b8b2a9; }
    .tsf-sync-note--on .tsf-sync-note__dot { background:#3F4D3A; box-shadow:0 0 0 3px rgba(63,77,58,.14); }
    .tsf-acv2-head { display:block; }
    .tsf-acv2-head__row { display:flex; align-items:flex-end; justify-content:space-between; gap:18px; flex-wrap:wrap; }
    .tsf-acv2-stats { display:grid; grid-template-columns:repeat(auto-fit, minmax(150px, 1fr)); gap:10px; margin-top:18px; }
    .tsf-acv2-stat { display:flex; flex-direction:column; gap:2px; align-items:flex-start; padding:14px 16px; border:1px solid var(--tsf-border,#e7e3dc); border-radius:12px; background:var(--tsf-surface,#fff); cursor:pointer; text-align:left; transition:border-color .25s ease, box-shadow .25s ease, transform .25s ease; font-family:inherit; }
    .tsf-acv2-stat:hover { transform:translateY(-1px); box-shadow:0 6px 16px rgba(26,25,24,.06); }
    .tsf-acv2-stat[aria-pressed="true"] { border-color:var(--gold-accent,#A16207); box-shadow:0 0 0 1px var(--gold-accent,#A16207) inset; }
    .tsf-acv2-stat__n { font-size:26px; font-weight:600; color:var(--tsf-text,#2b2926); line-height:1; }
    .tsf-acv2-stat--noar .tsf-acv2-stat__n { color:var(--gold-accent,#A16207); }
    .tsf-acv2-stat__l { font-size:10px; font-weight:600; letter-spacing:.18em; text-transform:uppercase; color:var(--tsf-text-dim,#a8a299); }
    .tsf-acv2-sync { margin:10px 2px 0; font-size:11.5px; color:var(--tsf-text-dim,#a8a299); }
    .tsf-acv2-grid { display:grid; grid-template-columns:repeat(auto-fill, minmax(290px, 1fr)); gap:18px; margin-top:22px; }
    .tsf-acv2 { position:relative; display:flex; flex-direction:column; border:1px solid var(--tsf-border,#e7e3dc); border-radius:12px; background:var(--tsf-surface,#fff); overflow:hidden; transition:border-color .3s ease, box-shadow .3s ease, transform .3s ease; }
    .tsf-acv2:hover { border-color:rgba(63,77,58,.4); box-shadow:0 14px 30px rgba(26,25,24,.09); transform:translateY(-3px); }
    .tsf-acv2--noar { border-color:rgba(63,77,58,.28); }
    .tsf-acv2--busy { opacity:.6; pointer-events:none; }
    .tsf-acv2__link { display:block; color:inherit; text-decoration:none; flex:1; }
    .tsf-acv2__banda { position:relative; height:150px; background:linear-gradient(135deg, rgba(63,77,58,.10), rgba(63,77,58,.03) 55%, rgba(161,98,7,.06)); overflow:hidden; }
    .tsf-acv2__capa { width:100%; height:100%; object-fit:cover; display:block; transition:transform .7s var(--ease-luxury,ease); }
    .tsf-acv2__mosaico { position:absolute; inset:0; display:grid; grid-template-columns:1fr 1fr; grid-template-rows:1fr 1fr; gap:2px; }
    .tsf-acv2__mosaico img { width:100%; height:100%; object-fit:cover; transition:transform .7s var(--ease-luxury,ease); }
    .tsf-acv2:hover .tsf-acv2__capa, .tsf-acv2:hover .tsf-acv2__mosaico img { transform:scale(1.045); }
    .tsf-acv2__palco { display:flex; align-items:center; justify-content:center; height:100%; }
    .tsf-acv2__palco span { font-size:44px; font-weight:600; color:rgba(63,77,58,.35); }
    .tsf-acv2__pills-l { position:absolute; left:12px; top:12px; }
    .tsf-acv2__pills-r { position:absolute; right:12px; top:12px; }
    .tsf-acv2__pill { display:inline-flex; align-items:center; gap:5px; font-size:9px; font-weight:600; letter-spacing:.18em; text-transform:uppercase; padding:5px 10px; border-radius:999px; box-shadow:0 2px 8px rgba(26,25,24,.25); }
    .tsf-acv2__pill--gold { background:#A16207; color:#fff; }
    .tsf-acv2__pill--musgo { background:#3F4D3A; color:#fff; }
    .tsf-acv2__pill--rascunho { background:rgba(26,25,24,.82); color:#f3f1ed; }
    .tsf-acv2__logo { position:absolute; right:12px; bottom:10px; width:44px; height:44px; border-radius:50%; background:#fff; border:1px solid var(--tsf-border,#e7e3dc); box-shadow:0 3px 10px rgba(26,25,24,.14); overflow:hidden; display:flex; align-items:center; justify-content:center; }
    .tsf-acv2__logo img { width:100%; height:100%; object-fit:cover; }
    .tsf-acv2__body { padding:14px 16px 12px; }
    .tsf-acv2__rowname { display:flex; align-items:center; gap:10px; }
    .tsf-acv2__ring { width:52px; height:52px; }
    .tsf-acv2__ring .tsf-acv-ring__center { font-size:11px; font-weight:600; color:var(--tsf-text-muted,#7a746c); }
    .tsf-acv2__nome { margin:0; font-size:15.5px; font-weight:600; color:var(--tsf-text,#2b2926); flex:1; min-width:0; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; }
    .tsf-acv2__bio { margin:10px 0 0; font-size:12.5px; line-height:1.5; color:var(--tsf-text-muted,#7a746c); display:-webkit-box; -webkit-line-clamp:2; -webkit-box-orient:vertical; overflow:hidden; min-height:2.6em; }
    .tsf-acv-chip--falta { border-color:rgba(192,57,43,.35); color:#a94438; }
    .tsf-acv2__foot { display:flex; align-items:center; gap:10px; padding:10px 16px; border-top:1px solid var(--tsf-border,#e7e3dc); background:var(--tsf-bg-soft,#faf9f6); }
    .tsf-switch--sm { margin-top:0; font-size:11.5px; gap:7px; }
    .tsf-switch--sm .tsf-switch__track { width:32px; height:19px; }
    .tsf-switch--sm .tsf-switch__track::after { width:13px; height:13px; }
    .tsf-switch--sm input:checked + .tsf-switch__track::after { transform:translateX(13px); }
    .tsf-acv2__star { border:none; background:none; font-size:17px; line-height:1; color:#d8d2c7; cursor:pointer; padding:2px 4px; transition:color .25s ease, transform .25s ease; }
    .tsf-acv2__star:hover:not(:disabled) { transform:scale(1.15); }
    .tsf-acv2__star--on { color:#A16207; }
    .tsf-acv2__star:disabled { opacity:.35; cursor:default; }
    .tsf-acv2__nota { flex:1; font-size:10.5px; color:var(--tsf-text-dim,#a8a299); min-width:0; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; }
    .tsf-acv2__nota--err { color:#a94438; }
    .tsf-acv2__editar { font-size:11px; font-weight:600; letter-spacing:.06em; color:var(--tsf-gold-ink,#8a5406); white-space:nowrap; }
    .tsf-steps { margin:16px 0 2px; padding:13px 16px; border:1px dashed rgba(63,77,58,.35); border-radius:12px; background:rgba(63,77,58,.045); }
    .tsf-steps--done { border-style:solid; border-color:rgba(63,77,58,.3); }
    .tsf-steps__eyebrow { display:block; font-size:10px; font-weight:600; letter-spacing:.22em; text-transform:uppercase; color:#3F4D3A; margin-bottom:8px; }
    .tsf-steps--done .tsf-steps__eyebrow { margin-bottom:0; }
    .tsf-steps__chips { display:flex; flex-wrap:wrap; gap:7px; }
    .tsf-steps__chip { font-family:inherit; font-size:11.5px; padding:6px 12px; border-radius:999px; border:1px solid var(--tsf-border,#e7e3dc); background:var(--tsf-surface,#fff); color:var(--tsf-text-muted,#7a746c); cursor:pointer; transition:border-color .25s ease, color .25s ease, transform .25s ease; }
    .tsf-steps__chip:hover { transform:translateY(-1px); border-color:var(--gold-accent,#A16207); color:var(--tsf-text,#2b2926); }
    .tsf-steps__chip[data-w="3"] { border-color:rgba(63,77,58,.45); color:#3F4D3A; font-weight:600; }
    .tsf-sec-flash { animation:tsfSecFlash 1.6s ease; }
    @keyframes tsfSecFlash { 0% { background:rgba(161,98,7,.10); } 100% { background:transparent; } }
    .tsf-stg2-hero { position:relative; border-radius:12px; overflow:hidden; margin:14px 0 20px; background:linear-gradient(120deg,#333f2f,#1a1918 75%); min-height:196px; display:flex; }
    .tsf-stg2-hero__bg { position:absolute; inset:0; width:100%; height:100%; object-fit:cover; }
    .tsf-stg2-hero__scrim { position:absolute; inset:0; background:linear-gradient(180deg, rgba(18,20,16,.30), rgba(18,20,16,.52) 62%, rgba(18,20,16,.82)), linear-gradient(100deg, rgba(18,20,16,.88) 8%, rgba(18,20,16,.55) 48%, rgba(18,20,16,.22) 85%); }
    .tsf-stg2-hero__inner { position:relative; z-index:1; display:flex; align-items:flex-end; justify-content:space-between; gap:18px; padding:26px 28px 22px; width:100%; flex-wrap:wrap; }
    .tsf-stg2-hero__id { display:flex; align-items:center; gap:18px; min-width:0; }
    .tsf-stg2-hero__ring { width:64px; height:64px; background:rgba(18,20,16,.6); border-radius:50%; backdrop-filter:blur(4px); box-shadow:0 4px 16px rgba(0,0,0,.3); }
    .tsf-stg2-hero__ring .tsf-acv-ring__center span { color:#fff; font-size:13px; font-weight:600; }
    .tsf-stg2-hero .tsf-acv-ring__track { stroke:rgba(255,255,255,.30); }
    .tsf-stg2-hero__eyebrow { font-size:10px; font-weight:600; letter-spacing:.22em; text-transform:uppercase; color:rgba(255,255,255,.7); text-shadow:0 1px 6px rgba(0,0,0,.5); }
    .tsf-stg2-hero__name { margin:2px 0 9px; font-size:26px; font-weight:600; color:#fff; line-height:1.15; text-shadow:0 2px 14px rgba(0,0,0,.5); }
    .tsf-stg2-hero__meta { display:flex; align-items:center; gap:14px; flex-wrap:wrap; }
    .tsf-stg2-state { background:rgba(255,255,255,.14); padding:4px 11px; border-radius:999px; color:#fff !important; font-size:11px; letter-spacing:.04em; }
    .tsf-switch--hero { margin:0; color:rgba(255,255,255,.92); font-size:12px; text-shadow:0 1px 6px rgba(0,0,0,.5); }
    .tsf-switch--hero .tsf-switch__track { background:rgba(255,255,255,.28); }
    .tsf-switch--hero input:checked + .tsf-switch__track { background:#A16207; }
    .tsf-stg2-save { color:rgba(255,255,255,.75) !important; font-size:11.5px; }
    .tsf-stg2-hero__actions { display:flex; align-items:center; gap:14px; }
    .tsf-stg2-hero__logo { width:52px; height:52px; border-radius:50%; overflow:hidden; background:#fff; border:2px solid rgba(255,255,255,.85); box-shadow:0 4px 14px rgba(0,0,0,.3); display:flex; align-items:center; justify-content:center; flex:none; }
    .tsf-stg2-hero__logo img { width:100%; height:100%; object-fit:cover; }
    .tsf-stg2-live { background:#A16207; color:#fff; font-size:12px; font-weight:600; padding:11px 18px; border-radius:999px; text-decoration:none; letter-spacing:.04em; white-space:nowrap; transition:transform .25s ease, box-shadow .25s ease; }
    .tsf-stg2-live:hover { transform:translateY(-1px); box-shadow:0 8px 18px rgba(161,98,7,.4); }
    .tsf-stg2-split { display:grid; grid-template-columns:minmax(0,1fr) 330px; gap:20px; align-items:start; }
    .tsf-stg2-cards { display:grid; grid-template-columns:1fr 1fr; gap:16px; min-width:0; }
    .tsf-stg2-card--full { grid-column:1 / -1; }
    .tsf-stg2-card.tsf-stage__sec { padding:20px 20px 16px; border:1px solid var(--tsf-border,#e7e3dc); border-radius:12px; background:var(--tsf-surface,#fff); min-width:0; }
    .tsf-stg2-card .tsf-stage__sec-title { display:flex; align-items:center; font-size:11.5px; margin:0 0 16px; }
    .tsf-stg2-ico { display:inline-flex; width:26px; height:26px; border-radius:8px; background:rgba(63,77,58,.09); color:#3F4D3A; align-items:center; justify-content:center; margin-right:9px; flex:none; }
    .tsf-stage__field input[type="text"], .tsf-stage__field input[type="url"], .tsf-stage__field input[type="number"], .tsf-stage__field textarea, .tsf-stg2-card [data-rich] { width:100%; padding:11px 13px; border:1px solid #e3ded5; border-radius:11px; background:#fff; font-family:inherit; font-size:13.5px; color:var(--tsf-text,#2b2926); transition:border-color .2s ease, box-shadow .2s ease; }
    .tsf-stage__field input:focus, .tsf-stage__field textarea:focus, .tsf-stg2-card [data-rich]:focus { outline:none; border-color:#3F4D3A; box-shadow:0 0 0 3px rgba(63,77,58,.10); }
    .tsf-stg2-card [data-rich] { min-height:170px; line-height:1.6; }
    .tsf-stg2-unitwrap { position:relative; display:block; }
    .tsf-stg2-unit { position:absolute; right:13px; top:50%; transform:translateY(-50%); font-size:11.5px; color:var(--tsf-text-dim,#a8a299); pointer-events:none; }
    .tsf-stg2-urlwrap { position:relative; display:block; }
    .tsf-stg2-urlwrap input { padding-right:44px; }
    .tsf-stg2-open { position:absolute; right:6px; top:50%; transform:translateY(-50%); width:30px; height:30px; border-radius:9px; display:flex; align-items:center; justify-content:center; color:#3F4D3A; background:rgba(63,77,58,.08); text-decoration:none; font-size:13px; transition:background .2s ease; }
    .tsf-stg2-open:hover { background:rgba(63,77,58,.16); }
    .tsf-stg2-open--off { opacity:.25; pointer-events:none; }
    .tsf-tags__box { display:flex; flex-wrap:wrap; gap:7px; padding:8px 10px; border:1px solid #e3ded5; border-radius:12px; background:#fff; cursor:text; min-height:46px; align-items:center; transition:border-color .2s ease, box-shadow .2s ease; }
    .tsf-tags__box:focus-within { border-color:#3F4D3A; box-shadow:0 0 0 3px rgba(63,77,58,.10); }
    .tsf-tags__chip { display:inline-flex; align-items:center; gap:6px; border:1px solid rgba(63,77,58,.25); background:rgba(63,77,58,.06); color:#3F4D3A; font-size:12px; font-weight:500; padding:5px 11px; border-radius:999px; cursor:pointer; font-family:inherit; transition:border-color .2s ease, color .2s ease, background .2s ease; }
    .tsf-tags__chip span { opacity:.55; font-size:10px; }
    .tsf-tags__chip:hover { border-color:rgba(169,68,56,.4); color:#a94438; background:rgba(169,68,56,.06); }
    .tsf-tags__in { flex:1; min-width:110px; border:none !important; box-shadow:none !important; padding:5px 4px !important; font-size:13px; background:transparent !important; font-family:inherit; color:var(--tsf-text,#2b2926); }
    .tsf-tags__in:focus { outline:none; }
    .tsf-stg2-rail { position:sticky; top:16px; display:flex; flex-direction:column; gap:14px; min-width:0; }
    .tsf-stg2-railcard { border:1px solid var(--tsf-border,#e7e3dc); border-radius:12px; background:var(--tsf-surface,#fff); padding:16px; }
    .tsf-stg2-rail__eyebrow { margin:0 0 12px; font-size:10px; font-weight:600; letter-spacing:.22em; text-transform:uppercase; color:var(--tsf-text-dim,#a8a299); }
    .tsf-rail__prog { display:flex; align-items:center; gap:10px; margin-bottom:12px; }
    .tsf-rail__bar { flex:1; height:6px; border-radius:999px; background:#eee9e0; overflow:hidden; }
    .tsf-rail__bar i { display:block; height:100%; background:linear-gradient(90deg,#3F4D3A,#A16207); border-radius:999px; transition:width .6s var(--ease-luxury,ease); }
    .tsf-rail__pct { font-size:12px; font-weight:600; color:#3F4D3A; }
    .tsf-rail__list { display:flex; flex-direction:column; gap:3px; }
    .tsf-rail__item { display:flex; align-items:center; gap:10px; padding:7px 9px; border:none; background:none; border-radius:12px; cursor:pointer; font-family:inherit; font-size:12.5px; color:var(--tsf-text-muted,#7a746c); text-align:left; transition:background .2s ease, color .2s ease; width:100%; }
    .tsf-rail__item:hover { background:rgba(63,77,58,.06); color:var(--tsf-text,#2b2926); }
    .tsf-rail__tick { flex:none; min-width:27px; height:20px; padding:0 5px; border-radius:999px; display:inline-flex; align-items:center; justify-content:center; font-size:10px; font-weight:600; background:rgba(63,77,58,.08); color:#3F4D3A; }
    .tsf-rail__item--ok { opacity:.6; }
    .tsf-rail__item--ok .tsf-rail__tick { background:#3F4D3A; color:#fff; }
    .tsf-rail__item--ok .tsf-rail__lbl { text-decoration:line-through; text-decoration-color:rgba(63,77,58,.35); }
    .tsf-stage__uploads { display:grid; grid-template-columns:1fr 1fr; gap:12px; }
    .tsf-up--wide { grid-column:1 / -1; }
    .tsf-up { border:1.5px dashed #d9d3c8; border-radius:12px; transition:border-color .25s ease, background .25s ease; }
    .tsf-up:hover { border-color:#3F4D3A; background:rgba(63,77,58,.03); }
    .tsf-up--wide .tsf-up__thumb { width:148px; height:84px; }
    @media (max-width: 1180px) { .tsf-stg2-split { grid-template-columns:1fr; } .tsf-stg2-rail { position:static; } }
    @media (max-width: 920px) { .tsf-stg2-cards { grid-template-columns:1fr; } .tsf-stg2-hero__inner { padding:20px; } .tsf-stg2-hero__name { font-size:21px; } }
    .tsf-stage__ro { font-size:13px; color:var(--tsf-text-muted,#7a746c); line-height:1.6; }
    .tsf-stage__thumb-row { display:flex; gap:10px; flex-wrap:wrap; margin-top:8px; }
    .tsf-stage__thumb { width:72px; height:72px; border-radius:10px; object-fit:cover; border:1px solid var(--tsf-border,#e7e3dc); background:var(--warm-sand,#f3f1ed); }
    .tsf-stage__soon { display:inline-block; margin-top:6px; font-size:11px; letter-spacing:.04em; color:var(--tsf-text-dim,#a8a299); font-style:italic; }
    /* ── O Palco · split editor-como-vitrine ── */
    .tsf-stage { max-inline-size:1140px; }
    .tsf-stage__split { display:grid; grid-template-columns:1fr; gap:30px; align-items:start; }
    @media (min-width:1000px){ .tsf-stage__split { grid-template-columns:1.02fr 0.98fr; } .tsf-stage__preview-wrap { position:sticky; top:14px; } }
    .tsf-stage__preview-eyebrow { font-size:10.5px; font-weight:600; letter-spacing:.22em; text-transform:uppercase; color:var(--tsf-text-dim,#a8a299); margin:0 0 11px; display:flex; align-items:center; gap:9px; }
    .tsf-stage__preview-eyebrow::after { content:''; flex:1; height:1px; background:var(--tsf-border,#e7e3dc); }
    .tsf-prev { border:1px solid var(--tsf-border,#e7e3dc); border-radius:12px; overflow:hidden; background:#fff; }
    .tsf-prev__hero { position:relative; min-height:208px; display:flex; align-items:flex-end; background:var(--warm-sand,#f3f1ed); }
    .tsf-prev__hero--empty { background:linear-gradient(135deg,#3F4D3A,#A16207); }
    .tsf-prev__hero-img { position:absolute; inset:0; width:100%; height:100%; object-fit:cover; }
    .tsf-prev__hero-init { position:absolute; inset:0; display:flex; align-items:center; justify-content:center; font-family:var(--font-heading-family,Georgia,serif); font-size:84px; font-weight:200; color:rgba(255,255,255,.92); }
    .tsf-prev__scrim { position:absolute; inset:0; background:linear-gradient(to top, rgba(20,18,16,.74), rgba(20,18,16,0) 62%); }
    .tsf-prev__hero-body { position:relative; padding:20px 22px; color:#fff; width:100%; box-sizing:border-box; }
    .tsf-prev__eyebrow { font-size:10px; font-weight:600; letter-spacing:.22em; text-transform:uppercase; color:rgba(255,255,255,.86); }
    .tsf-prev__name { font-family:var(--font-heading-family,Georgia,serif); font-size:29px; font-weight:300; letter-spacing:-0.02em; margin:5px 0 6px; line-height:1.06; }
    .tsf-prev__bio { font-size:13px; line-height:1.5; color:rgba(255,255,255,.9); max-inline-size:44ch; margin:0; }
    .tsf-prev__body { padding:18px 22px 22px; }
    .tsf-prev__stats { display:flex; gap:24px; padding-block:14px; border-block-end:1px solid var(--tsf-border,#e7e3dc); margin-block-end:16px; flex-wrap:wrap; }
    .tsf-prev__stat-label { font-size:9.5px; letter-spacing:.18em; text-transform:uppercase; color:var(--tsf-text-dim,#a8a299); display:block; margin-block-end:2px; }
    .tsf-prev__stat-val { font-family:var(--font-heading-family,Georgia,serif); font-size:20px; font-weight:300; color:var(--tsf-text-strong,#2a2723); }
    .tsf-prev__sec-title { font-size:10.5px; font-weight:600; letter-spacing:.18em; text-transform:uppercase; color:var(--tsf-text-dim,#a8a299); margin:0 0 9px; }
    .tsf-prev__chips { display:flex; flex-wrap:wrap; gap:6px; margin-block-end:18px; }
    .tsf-prev__chip { font-size:11px; padding:4px 11px; border-radius:999px; background:var(--warm-sand,#f3f1ed); color:var(--tsf-text-muted,#7a746c); }
    .tsf-prev__story { font-size:13px; line-height:1.6; color:var(--tsf-text-muted,#7a746c); font-style:italic; margin:0 0 18px; }
    .tsf-prev__empty { color:var(--tsf-text-dim,#a8a299); font-style:italic; font-size:12.5px; margin:0 0 18px; }
    .tsf-prev__cta { display:inline-block; padding:10px 20px; border-radius:999px; background:var(--gold-accent,#A16207); color:#fff; font-size:12.5px; letter-spacing:.03em; }
    /* ── upload zones ── */
    .tsf-stage__uploads { display:grid; grid-template-columns:repeat(auto-fit,minmax(148px,1fr)); gap:12px; margin-block-end:12px; }
    /* ── COMO CADA TELA VAI VER (03-08) ──────────────────────────────
       A forma da caixa diz o formato do arquivo: deitada = computador,
       em pe = celular. Antes a vertical era um quadradinho de 156px com
       o rotulo quebrado em tres pedacos e o founder nao usava. */
    .tsf-telas { display: grid; gap: 14px; grid-template-columns: minmax(0, 1.7fr) minmax(0, 1fr); align-items: start; margin-block-end: 14px; }
    .tsf-tela__cab { display: flex; align-items: center; gap: 7px; margin-block-end: 7px;
      font: 600 9.5px/1 var(--font-body-family, sans-serif); letter-spacing: .16em; text-transform: uppercase; color: var(--tsf-text-dim, #8b857c); }
    .tsf-tela__cab svg { inline-size: 13px; block-size: 13px; flex: 0 0 auto; }
    .tsf-tela--ok .tsf-tela__cab { color: var(--tsf-admin-accent, #3F4D3A); }
    .tsf-up--h .tsf-up__thumb { aspect-ratio: 16 / 9; }
    .tsf-up--v .tsf-up__thumb { aspect-ratio: 9 / 16; max-block-size: 300px; }
    .tsf-up--h .tsf-up__meta, .tsf-up--v .tsf-up__meta { flex-wrap: wrap; row-gap: 2px; }
    .tsf-up--h .tsf-up__label, .tsf-up--v .tsf-up__label { flex: 1 1 100%; line-height: 1.35; }
    .tsf-up--h .tsf-up__msg, .tsf-up--v .tsf-up__msg { white-space: normal; }
    .tsf-tela__nota { margin: 6px 2px 0; font: 400 11px/1.5 var(--font-body-family, sans-serif); color: var(--tsf-text-dim, #8b857c); }
    .tsf-tela__nota b { color: var(--tsf-gold-ink, #8a5406); font-weight: 400; }
    .tsf-stage__uploads--menores { grid-template-columns: repeat(auto-fit, minmax(150px, 1fr)); }
    @media (max-width: 749px){
      .tsf-telas { grid-template-columns: 1fr; }
      .tsf-up--v .tsf-up__thumb { aspect-ratio: 16 / 10; max-block-size: none; }
    }
    .tsf-up { display:flex; flex-direction:column; border:1px dashed var(--tsf-border,#e7e3dc); border-radius:12px; overflow:hidden; cursor:pointer; background:#fff; transition:border-color .3s var(--ease-luxury,ease); }
    .tsf-up:hover { border-color:var(--gold-accent,#A16207); }
    .tsf-up--filled { border-style:solid; }
    .tsf-up--busy { opacity:.55; pointer-events:none; }
    .tsf-up__thumb { aspect-ratio:16/10; background:var(--warm-sand,#f3f1ed); display:flex; align-items:center; justify-content:center; overflow:hidden; }
    .tsf-up__thumb img { width:100%; height:100%; object-fit:cover; }
    .tsf-up__ico { color:var(--tsf-text-dim,#a8a299); }
    .tsf-up__meta { display:flex; align-items:center; justify-content:space-between; padding:9px 12px; gap:8px; }
    .tsf-up__label { font-size:12px; color:var(--tsf-text-strong,#2a2723); }
    .tsf-up__msg { font-size:11px; letter-spacing:.04em; color:var(--tsf-gold-ink,#8a5406); white-space:nowrap; }
    /* ── peça da casa ── */
    .tsf-stage__peca-btn { appearance:none; border:1px dashed var(--tsf-border,#e7e3dc); background:#fff; cursor:pointer; padding:14px 18px; border-radius:12px; font:inherit; font-size:13px; color:var(--tsf-gold-ink,#8a5406); width:100%; transition:border-color .3s var(--ease-luxury,ease); }
    .tsf-stage__peca-btn:hover { border-color:var(--gold-accent,#A16207); }
    .tsf-stage__peca-chosen { display:flex; gap:14px; align-items:center; padding:12px; border:1px solid var(--tsf-border,#e7e3dc); border-radius:12px; background:#fff; }
    .tsf-stage__peca-thumb { width:64px; height:64px; flex:none; border-radius:10px; overflow:hidden; background:var(--warm-sand,#f3f1ed); }
    .tsf-stage__peca-thumb img { width:100%; height:100%; object-fit:cover; }
    .tsf-stage__peca-info strong { font-size:14px; color:var(--tsf-text-strong,#2a2723); display:block; margin-bottom:6px; }
    .tsf-stage__peca-actions { display:flex; gap:8px; }
    .tsf-stage__peca-actions button { appearance:none; border:1px solid var(--tsf-border,#e7e3dc); background:#fff; cursor:pointer; padding:5px 12px; border-radius:999px; font-size:11.5px; color:var(--tsf-text-muted,#7a746c); }
    .tsf-stage__peca-actions button:hover { border-color:var(--gold-accent,#A16207); color:var(--gold-accent,#A16207); }
    .tsf-prev__peca { margin-block-start:4px; }
    .tsf-prev__peca-card { display:flex; align-items:center; gap:10px; }
    .tsf-prev__peca-card img { width:46px; height:46px; border-radius:8px; object-fit:cover; }
    .tsf-prev__peca-card span { font-family:var(--font-heading-family,Georgia,serif); font-size:14px; color:var(--tsf-text-strong,#2a2723); }
    /* ── picker modal ── */
    .tsf-pmodal { position:fixed; inset:0; z-index:9999; background:rgba(20,18,16,.42); display:flex; align-items:flex-start; justify-content:center; padding-block-start:10vh; }
    .tsf-pmodal__panel { width:min(520px,92vw); background:#fff; border-radius:12px; overflow:hidden; box-shadow:0 30px 80px -30px rgba(0,0,0,.5); }
    .tsf-pmodal__head { display:flex; align-items:center; justify-content:space-between; padding:16px 18px; border-block-end:1px solid var(--tsf-border,#e7e3dc); font-family:var(--font-heading-family,Georgia,serif); font-size:17px; color:var(--tsf-text-strong,#2a2723); }
    .tsf-pmodal__head button { appearance:none; border:0; background:transparent; cursor:pointer; font-size:18px; color:var(--tsf-text-muted,#7a746c); }
    .tsf-pmodal__search { width:100%; box-sizing:border-box; border:0; border-block-end:1px solid var(--tsf-border,#e7e3dc); padding:14px 18px; font:inherit; font-size:15px; outline:none; }
    .tsf-pmodal__results { max-height:48vh; overflow:auto; }
    .tsf-pmodal__item { display:flex; align-items:center; gap:12px; width:100%; text-align:start; appearance:none; border:0; border-block-end:1px solid #f0ece4; background:#fff; cursor:pointer; padding:10px 18px; font:inherit; }
    .tsf-pmodal__item:hover { background:var(--warm-sand,#f3f1ed); }
    .tsf-pmodal__item img { width:42px; height:42px; border-radius:8px; object-fit:cover; flex:none; }
    .tsf-pmodal__noimg { width:42px; height:42px; border-radius:8px; background:var(--warm-sand,#f3f1ed); flex:none; }
    .tsf-pmodal__item span { font-size:13.5px; color:var(--tsf-text-strong,#2a2723); }
    /* ── galeria ── */
    .tsf-gal { display:flex; flex-wrap:wrap; gap:10px; }
    .tsf-gal__item { position:relative; width:84px; height:84px; border-radius:10px; overflow:hidden; border:1px solid var(--tsf-border,#e7e3dc); background:var(--warm-sand,#f3f1ed); }
    .tsf-gal__item img { width:100%; height:100%; object-fit:cover; }
    .tsf-gal__pending { display:block; width:100%; height:100%; background:linear-gradient(90deg,#f0ede8 25%,#f7f5f1 50%,#f0ede8 75%); background-size:200% 100%; animation:tsfAcvShimmer 1.4s infinite; }
    .tsf-gal__rm { position:absolute; top:4px; right:4px; width:20px; height:20px; border-radius:50%; border:0; background:rgba(20,18,16,.6); color:#fff; cursor:pointer; font-size:11px; line-height:1; display:flex; align-items:center; justify-content:center; padding:0; }
    .tsf-gal__rm:hover { background:rgba(20,18,16,.85); }
    .tsf-gal__add { width:84px; height:84px; border-radius:10px; border:1px dashed var(--tsf-border,#e7e3dc); background:#fff; cursor:pointer; display:flex; flex-direction:column; align-items:center; justify-content:center; gap:3px; transition:border-color .3s var(--ease-luxury,ease); }
    .tsf-gal__add:hover { border-color:var(--gold-accent,#A16207); }
    .tsf-gal__add-ico { font-size:22px; color:var(--tsf-text-dim,#a8a299); line-height:1; }
    .tsf-gal__add-msg { font-size:10px; color:var(--tsf-text-muted,#7a746c); text-align:center; padding:0 4px; }
    .tsf-gal__item--vid { background:#1a1a1a; display:flex; align-items:center; justify-content:center; }
    .tsf-gal__vid-ico { color:rgba(255,255,255,.82); font-size:24px; }
    /* ── produtos em destaque (vários) ── */
    .tsf-stage__prodgrid { display:flex; flex-wrap:wrap; gap:12px; }
    .tsf-stage__prodchip { position:relative; width:120px; }
    .tsf-stage__prodchip-thumb { width:120px; height:120px; border-radius:12px; overflow:hidden; background:var(--warm-sand,#f3f1ed); border:1px solid var(--tsf-border,#e7e3dc); }
    .tsf-stage__prodchip-thumb img { width:100%; height:100%; object-fit:cover; }
    .tsf-stage__prodchip-title { display:block; font-size:11.5px; line-height:1.35; color:var(--tsf-text-strong,#2a2723); margin-top:6px; max-height:2.7em; overflow:hidden; }
    .tsf-stage__prodchip-x { position:absolute; top:6px; right:6px; width:22px; height:22px; border-radius:50%; border:0; background:rgba(20,18,16,.6); color:#fff; cursor:pointer; font-size:12px; line-height:1; display:flex; align-items:center; justify-content:center; padding:0; }
    .tsf-stage__prodchip-x:hover { background:rgba(20,18,16,.85); }
    .tsf-stage__prod-add { width:120px; height:120px; flex:none; appearance:none; border:1px dashed var(--tsf-border,#e7e3dc); background:#fff; cursor:pointer; border-radius:12px; font:inherit; font-size:12.5px; color:var(--tsf-gold-ink,#8a5406); transition:border-color .3s var(--ease-luxury,ease); }
    .tsf-stage__prod-add:hover { border-color:var(--gold-accent,#A16207); }
    .tsf-pmodal__item.is-added { background:#f3f7f3; }
    .tsf-pmodal__badge { margin-inline-start:auto; font-size:11px; font-style:normal; color:var(--tsf-gold-ink,#8a5406); white-space:nowrap; }
    .tsf-pmodal__item.is-added .tsf-pmodal__badge { color:#3f7d4f; }
    .tsf-prev__prods { display:flex; flex-wrap:wrap; gap:8px; margin-top:4px; }
    .tsf-prev__prod { width:62px; }
    .tsf-prev__prod img { width:62px; height:62px; border-radius:8px; object-fit:cover; }
    .tsf-prev__prod span { display:block; font-size:9.5px; line-height:1.25; color:var(--tsf-text-muted,#7a746c); margin-top:3px; max-height:2.5em; overflow:hidden; }
    .tsf-prev__live { display:inline-flex; align-items:center; gap:7px; margin-top:6px; padding:11px 18px; border-radius:12px; background:var(--gold-accent,#A16207); color:#fff; text-decoration:none; font-size:13px; font-weight:500; letter-spacing:.02em; transition:filter .2s; }
    .tsf-prev__live:hover { filter:brightness(1.08); }
    .tsf-prev__live-hint { font-size:11.5px; line-height:1.5; color:var(--tsf-text-muted,#7a746c); margin:10px 0 0; }
    /* ── Cockpit de Demanda ── */
    .tsf-cock__intro { font-size:13.5px; color:var(--tsf-text-muted,#7a746c); margin:0 0 18px; }
    .tsf-cock__intro strong { color:var(--gold-accent,#A16207); font-weight:600; }
    .tsf-cock__grid { display:grid; grid-template-columns:repeat(auto-fit,minmax(220px,1fr)); gap:16px; align-items:start; }
    .tsf-cock__card { border:1px solid var(--tsf-border,#e7e3dc); border-radius:16px; background:#fff; padding:20px; }
    .tsf-cock__num { font-family:var(--font-heading-family,Georgia,serif); font-size:40px; font-weight:300; color:var(--gold-accent,#A16207); line-height:1; }
    .tsf-cock__label { font-size:14px; color:var(--tsf-text-strong,#2a2723); margin-top:6px; }
    .tsf-cock__sub { font-size:11.5px; color:var(--tsf-text-muted,#7a746c); margin-top:4px; }
    .tsf-cock__whobtn { margin-top:14px; appearance:none; border:1px solid var(--tsf-border,#e7e3dc); background:#fff; border-radius:999px; padding:7px 14px; font:inherit; font-size:12px; color:var(--tsf-text-muted,#7a746c); cursor:pointer; transition:border-color .3s var(--ease-luxury,ease); }
    .tsf-cock__whobtn:hover { border-color:var(--gold-accent,#A16207); color:var(--gold-accent,#A16207); }
    .tsf-cock__who { margin-top:12px; display:flex; flex-direction:column; }
    .tsf-cock__person { display:flex; align-items:center; justify-content:space-between; gap:10px; padding:9px 0; border-top:1px solid #f0ece4; }
    .tsf-cock__person strong { font-size:13px; color:var(--tsf-text-strong,#2a2723); }
    .tsf-cock__chips { display:flex; gap:5px; margin-top:3px; flex-wrap:wrap; }
    .tsf-cock__chip { font-size:10px; padding:2px 8px; border-radius:999px; background:var(--warm-sand,#f3f1ed); color:var(--tsf-text-muted,#7a746c); }
    .tsf-cock__wa { background:#1c8a4e; color:#fff; font-size:12px; padding:6px 14px; border-radius:999px; text-decoration:none; white-space:nowrap; }
    .tsf-cock__nophone { font-size:11px; color:var(--tsf-text-dim,#a8a299); }
    .tsf-cock__hint { font-size:12px; color:var(--tsf-text-dim,#a8a299); padding:6px 0; margin:0; }
    @media (prefers-reduced-motion: reduce) {
      .tsf-acv-card, .tsf-acv-ring__arc, .tsf-acv-skel { transition:none !important; animation:none !important; }
    }
  `;

  function tsfAcvRing(score, state, r) {
    const rad = r || 26;
    const c = 2 * Math.PI * rad;
    const off = c * (1 - (Math.max(0, Math.min(100, score)) / 100));
    const sz = rad * 2 + 12;
    const ctr = sz / 2;
    return `<svg class="tsf-acv-ring tsf-acv-ring--${state}" width="${sz}" height="${sz}" viewBox="0 0 ${sz} ${sz}" aria-hidden="true">
      <circle class="tsf-acv-ring__track" cx="${ctr}" cy="${ctr}" r="${rad}" fill="none" stroke-width="3"/>
      <circle class="tsf-acv-ring__arc" cx="${ctr}" cy="${ctr}" r="${rad}" fill="none" stroke-width="3" stroke-linecap="round"
        stroke-dasharray="${c.toFixed(1)}" stroke-dashoffset="${off.toFixed(1)}" transform="rotate(-90 ${ctr} ${ctr})"/>
    </svg>`;
  }
  function tsfAcvEsc(s) {
    return String(s ?? '').replace(/[&<>"']/g, c => ({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c]));
  }
  function tsfAcvStateLabel(st) { return st === 'vivo' ? 'Vivo' : st === 'esbocado' ? 'Esboçado' : 'Adormecido'; }
  function tsfAcvInjectStyles() {
    if (document.getElementById('tsf-acervo-style')) return;
    const el = document.createElement('style');
    el.id = 'tsf-acervo-style';
    el.textContent = TSF_ACERVO_CSS;
    document.head.appendChild(el);
  }

  const TSF_STAGE_W = [['imagem_capa',3],['bio_editorial',3],['acabamentos_disponiveis',3],['fotos_ambientadas',2],['video_institucional',2],['produtos_destaque',2],['bio_curta',1],['materiais_caracteristicos',1],['fotos_fabrica',1],['videos_ambientados',1],['videos_fabrica',1],['logo',1],['catalogo_url',1],['prazo_producao_dias',1],['garantia_meses',1],['regioes_entrega',1],['tier_acesso',1]];
  const TSF_STEP_META = { imagem_capa:['Capa','A chegada'], video_institucional:['Filme do ateliê','A chegada'], logo:['Logo','A chegada'], bio_editorial:['A história','A história'], bio_curta:['Apresentação curta','A história'], materiais_caracteristicos:['O ofício · materiais','A história'], acabamentos_disponiveis:['A parede de matéria','A matéria'], fotos_ambientadas:['Fotos · Ambiente','O olhar'], videos_ambientados:['Filmes · Em cena','O olhar'], fotos_fabrica:['Fotos · Na fábrica','O olhar'], videos_fabrica:['Filmes · O processo','O olhar'], produtos_destaque:['As peças da casa','A seleção'], catalogo_url:['Catálogo de produtos','Catálogos & presença'], prazo_producao_dias:['Prazo','O acordo'], garantia_meses:['Garantia','O acordo'], regioes_entrega:['Entrega','O acordo'], tier_acesso:['Comunidade','Bastidores'] };
  function tsfStageFilled(v) {
    const s = String(v ?? '').trim();
    if (!s || s === '[]' || s === '{}' || s === 'null') return false;
    if (s.startsWith('{') && s.includes('"type":"root"')) return /"value"\s*:\s*"[^"]/.test(s);
    return true;
  }
  const tsfStgSvg = (d) => `<span class="tsf-stg2-ico"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">${d}</svg></span>`;
  const TSF_STG_ICO = {
    id: tsfStgSvg('<circle cx="12" cy="8" r="3.4"/><path d="M5 19.5c1.6-3.1 4-4.6 7-4.6s5.4 1.5 7 4.6"/>'),
    com: tsfStgSvg('<circle cx="9" cy="8.5" r="3"/><path d="M3.5 19c1.2-2.6 3.2-3.9 5.5-3.9s4.3 1.3 5.5 3.9"/><circle cx="16.5" cy="9.5" r="2.4"/><path d="M15.5 15.3c2 .2 3.7 1.4 4.9 3.7"/>'),
    hist: tsfStgSvg('<path d="M4 5a2 2 0 0 1 2-2h13v16H6a2 2 0 0 0-2 2z"/><path d="M19 3v16"/>'),
    mat: tsfStgSvg('<path d="M12 3 3 8l9 5 9-5z"/><path d="M3 12l9 5 9-5"/><path d="M3 16l9 5 9-5"/>'),
    op: tsfStgSvg('<circle cx="12" cy="12" r="9"/><path d="M12 7v5l3.2 2"/>'),
    pres: tsfStgSvg('<path d="M10 14a4.5 4.5 0 0 0 6.4 0l3-3a4.5 4.5 0 1 0-6.4-6.4l-1 1"/><path d="M14 10a4.5 4.5 0 0 0-6.4 0l-3 3a4.5 4.5 0 1 0 6.4 6.4l1-1"/>'),
    prod: tsfStgSvg('<path d="m12 3 2.7 5.6 6.1.8-4.5 4.2 1.1 6-5.4-3-5.4 3 1.1-6L3.2 9.4l6.1-.8z"/>'),
    img: tsfStgSvg('<rect x="3" y="3" width="18" height="18" rx="2.5"/><circle cx="8.5" cy="8.5" r="1.6"/><path d="M21 15.5 15.5 10 5 20.5"/>'),
    gal: tsfStgSvg('<rect x="3" y="3" width="7.5" height="7.5" rx="1.6"/><rect x="13.5" y="3" width="7.5" height="7.5" rx="1.6"/><rect x="3" y="13.5" width="7.5" height="7.5" rx="1.6"/><rect x="13.5" y="13.5" width="7.5" height="7.5" rx="1.6"/>'),
    vid: tsfStgSvg('<polygon points="7 4.5 20 12 7 19.5"/>'),
    vamb: tsfStgSvg('<rect x="3" y="4" width="18" height="16" rx="2.5"/><path d="M8 4v16M16 4v16M3 9h5M3 15h5M16 9h5M16 15h5"/>'),
    cheg: tsfStgSvg('<path d="M5 21V11a7 7 0 0 1 14 0v10"/><path d="M3.5 21h17"/>'),
    olho: tsfStgSvg('<path d="M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12z"/><circle cx="12" cy="12" r="3"/>'),
    obra: tsfStgSvg('<path d="M12 21s-6.5-5.4-6.5-10a6.5 6.5 0 1 1 13 0c0 4.6-6.5 10-6.5 10z"/><circle cx="12" cy="11" r="2.3"/>'),
  };

  class TsfAdminAteliers extends HTMLElement {
    #abort = null;
    #ateliers = [];
    #sort = 'curadoria';
    #filter = 'todos';
    #orderFrozen = null; // após um toggle, congela a ordem/presença até o admin mexer em filtro/sort
    #state = 'loading';
    #error = '';

    async connectedCallback() {
      this.#abort = new AbortController();
      tsfAcvInjectStyles();
      this.classList.add('tsf-acv');
      this.#render();
      await this.#fetch();
    }
    disconnectedCallback() { this.#abort?.abort(); }

    async #fetch() {
      this.#state = 'loading'; this.#render();
      try {
        const hubUrl = this.getAttribute('data-hub-json');
        const [res, hub] = await Promise.all([
          fetch(`${ACERVO_ENDPOINT}/list-with-completeness`, { signal: this.#abort.signal }),
          hubUrl ? fetch(hubUrl, { signal: this.#abort.signal }).then(r => r.ok ? r.json() : null).catch(() => null) : Promise.resolve(null),
        ]);
        const data = await res.json();
        if (!data.ok) throw new Error(data.error || 'falha ao carregar o acervo');
        const enrich = window.tsfAcervoEnrich || {};
        const hubFabs = {};
        ((hub && hub.fabricas) || []).forEach(fb => { hubFabs[fb.handle] = fb; });
        this.#ateliers = (data.ateliers || []).map(a => {
          const e = enrich[a.handle] || null;
          const hb = hubFabs[a.handle] || null;
          return Object.assign(a, {
            enrich: e,
            tiers: (e && Array.isArray(e.tiers)) ? e.tiers : null,
            capa: (e && e.capa) || a.capa_url || null,
            logo: (e && e.logo) || a.logo_url || null,
            imgs: hb ? (hb.imagens || []) : [],
            blocos: hb ? hb.blocos : null,
          });
        });
        this.#state = 'ready';
      } catch (err) {
        if (err.name === 'AbortError') return;
        this.#state = 'error'; this.#error = err.message || 'erro';
      }
      this.#render();
    }

    #habilitado(a) { return !!(a.tiers && a.tiers.includes('comunidade')); }
    #noAr(a) { return this.#habilitado(a) && a.status === 'ACTIVE'; }
    #destaque(a) { return !!(a.enrich && a.enrich.destaque === true); }
    #grupo(a) { if (this.#noAr(a)) return 'noar'; return (a.completeness.score >= 25) ? 'prontos' : 'doc'; }
    #rank(a) {
      let r = a.completeness.score;
      if (this.#noAr(a)) r += 2000 + (this.#destaque(a) ? 500 : 0);
      else if (a.completeness.score >= 25) r += 1000;
      return r;
    }

    #visiveis() {
      if (this.#orderFrozen) {
        const byHandle = {}; this.#ateliers.forEach(a => { byHandle[a.handle] = a; });
        return this.#orderFrozen.map(h => byHandle[h]).filter(Boolean);
      }
      let arr = [...this.#ateliers];
      if (this.#filter !== 'todos') arr = arr.filter(a => this.#grupo(a) === this.#filter);
      if (this.#sort === 'az') arr.sort((a, b) => String(a.nome).localeCompare(String(b.nome)));
      else if (this.#sort === 'completude') arr.sort((a, b) => a.completeness.score - b.completeness.score);
      else arr.sort((a, b) => this.#rank(b) - this.#rank(a));
      return arr;
    }

    #head() {
      const n = { noar: 0, prontos: 0, doc: 0 };
      this.#ateliers.forEach(a => { n[this.#grupo(a)] += 1; });
      const total = this.#ateliers.length;
      const stat = (key, num, label, mod) => `
        <button type="button" class="tsf-acv2-stat ${mod || ''}" data-filtro="${key}" aria-pressed="${this.#filter === key}">
          <span class="tsf-acv2-stat__n">${num}</span>
          <span class="tsf-acv2-stat__l">${label}</span>
        </button>`;
      const stats = this.#state === 'ready' ? `
        <div class="tsf-acv2-stats" role="group" aria-label="Filtrar o acervo">
          ${stat('todos', total, 'Ateliês no acervo', '')}
          ${stat('noar', n.noar, 'No ar · Comunidade', 'tsf-acv2-stat--noar')}
          ${stat('prontos', n.prontos, 'Prontos p/ curadoria', '')}
          ${stat('doc', n.doc, 'Em documentação', '')}
        </div>
        <p class="tsf-acv2-sync">Habilitação e destaque valem aqui na hora — o hub da Comunidade absorve na próxima sincronização de dados.</p>`
        : `<p class="tsf-acv__lede">Reunindo o acervo…</p>`;
      return `<header class="tsf-acv__head tsf-acv2-head">
        <div class="tsf-acv2-head__row">
          <div>
            <span class="tsf-acv__eyebrow">Acervo · O Palco</span>
            <h1 class="tsf-acv__title">O Acervo</h1>
          </div>
          <div class="tsf-acv__sort" role="group" aria-label="Ordenar ateliês">
            <button type="button" data-sort="curadoria" aria-pressed="${this.#sort === 'curadoria'}">Curadoria</button>
            <button type="button" data-sort="completude" aria-pressed="${this.#sort === 'completude'}">Por completude</button>
            <button type="button" data-sort="az" aria-pressed="${this.#sort === 'az'}">A–Z</button>
          </div>
        </div>
        ${stats}
      </header>`;
    }

    #banda(a) {
      const noAr = this.#noAr(a);
      let visual;
      if (a.capa) visual = `<img class="tsf-acv2__capa" src="${tsfAcvEsc(a.capa)}" alt="" loading="lazy">`;
      else if (a.imgs && a.imgs.length >= 4) visual = `<div class="tsf-acv2__mosaico">${a.imgs.slice(0, 4).map(u => `<img src="${tsfAcvEsc(u)}" alt="" loading="lazy">`).join('')}</div>`;
      else if (a.imgs && a.imgs.length > 0) visual = `<img class="tsf-acv2__capa" src="${tsfAcvEsc(a.imgs[0])}" alt="" loading="lazy">`;
      else visual = `<div class="tsf-acv2__palco"><span>${tsfAcvEsc(String(a.nome || '?').slice(0, 1).toUpperCase())}</span></div>`;
      const pillEsq = this.#destaque(a) && noAr
        ? '<span class="tsf-acv2__pill tsf-acv2__pill--gold">★ Destaque</span>'
        : (noAr ? '<span class="tsf-acv2__pill tsf-acv2__pill--musgo">No ar</span>' : '');
      const pillDir = a.status !== 'ACTIVE' ? '<span class="tsf-acv2__pill tsf-acv2__pill--rascunho">Rascunho</span>' : '';
      const logo = a.logo ? `<span class="tsf-acv2__logo"><img src="${tsfAcvEsc(a.logo)}" alt="" loading="lazy"></span>` : '';
      return `<div class="tsf-acv2__banda">${visual}${pillEsq ? `<span class="tsf-acv2__pills-l">${pillEsq}</span>` : ''}${pillDir ? `<span class="tsf-acv2__pills-r">${pillDir}</span>` : ''}${logo}</div>`;
    }

    #card(a) {
      const st = a.completeness.state;
      const noAr = this.#noAr(a);
      const hab = this.#habilitado(a);
      const bio = a.bio_curta ? tsfAcvEsc(a.bio_curta) : '<em class="tsf-acv-empty">Aguardando história</em>';
      const chips = [];
      if (a.produtos_count != null && a.produtos_count > 0) chips.push(`<span class="tsf-acv-chip">${a.produtos_count} produtos</span>`);
      if (a.blocos != null && a.blocos > 0) chips.push(`<span class="tsf-acv-chip">${a.blocos} blocos 3D</span>`);
      if (a.enrich && noAr && !a.enrich.catalogo) chips.push('<span class="tsf-acv-chip tsf-acv-chip--falta">sem catálogo</span>');
      if (a.enrich && noAr && !a.enrich.acabamentos) chips.push('<span class="tsf-acv-chip tsf-acv-chip--falta">sem acabamentos</span>');
      const falta = (a.completeness.missing || []).slice(0, 2).join(' · ');
      const faltaLine = falta
        ? `<p class="tsf-acv-card__missing"><span>Falta</span>${tsfAcvEsc(falta)}</p>`
        : '<p class="tsf-acv-card__missing tsf-acv-card__missing--ok">Pronto para a vitrine</p>';
      const nota = (hab && a.status !== 'ACTIVE') ? '<span class="tsf-acv2__nota">rascunho — fora do hub</span>' : '<span class="tsf-acv2__nota" data-cardmsg></span>';
      return `<article class="tsf-acv2 tsf-acv-card--${st} ${noAr ? 'tsf-acv2--noar' : ''}" data-handle="${tsfAcvEsc(a.handle)}">
        <a class="tsf-acv2__link" href="/pages/admin-atelier?handle=${encodeURIComponent(a.handle)}" aria-label="Editar ${tsfAcvEsc(a.nome)}">
          ${this.#banda(a)}
          <div class="tsf-acv2__body">
            <div class="tsf-acv2__rowname">
              <div class="tsf-acv-ringwrap tsf-acv2__ring">${tsfAcvRing(a.completeness.score, st, 20)}<div class="tsf-acv-ring__center"><span>${a.completeness.score}</span></div></div>
              <h3 class="tsf-acv2__nome">${tsfAcvEsc(a.nome)}</h3>
              <span class="tsf-acv-state tsf-acv-state--${st}">${tsfAcvStateLabel(st)}</span>
            </div>
            <p class="tsf-acv2__bio">${bio}</p>
            ${chips.length ? `<div class="tsf-acv-card__chips">${chips.join('')}</div>` : ''}
            ${faltaLine}
          </div>
        </a>
        <div class="tsf-acv2__foot">
          <label class="tsf-switch tsf-switch--sm" title="${hab ? 'Tirar da Comunidade' : 'Habilitar para a Comunidade'}">
            <input type="checkbox" data-hab ${hab ? 'checked' : ''}>
            <span class="tsf-switch__track"></span>
            <span class="tsf-switch__lbl">Comunidade</span>
          </label>
          <button type="button" class="tsf-acv2__star ${this.#destaque(a) ? 'tsf-acv2__star--on' : ''}" data-star ${hab ? '' : 'disabled'} title="${this.#destaque(a) ? 'Tirar o destaque' : 'Dar destaque no Acervo da Comunidade'}">★</button>
          ${nota}
          <span class="tsf-acv2__editar">Editar →</span>
        </div>
      </article>`;
    }

    #render() {
      let content = '';
      if (this.#state === 'loading') {
        content = `<div class="tsf-acv2-grid">${Array.from({ length: 8 }).map(() => `
          <article class="tsf-acv2"><div class="tsf-acv-skel" style="width:100%;height:150px;border-radius:14px 14px 0 0"></div>
          <div style="padding:14px"><div class="tsf-acv-skel" style="width:60%;height:18px;margin-bottom:10px"></div><div class="tsf-acv-skel" style="width:100%;height:30px"></div></div></article>`).join('')}</div>`;
      } else if (this.#state === 'error') {
        content = `<div class="tsf-acv__err"><p>Não consegui reunir o acervo.<br><small>${tsfAcvEsc(this.#error)}</small></p><button type="button" data-retry>Tentar de novo</button></div>`;
      } else {
        const vis = this.#visiveis();
        content = vis.length
          ? `<div class="tsf-acv2-grid">${vis.map(a => this.#card(a)).join('')}</div>`
          : '<p class="tsf-acv__lede" style="padding:30px 0">Nenhum ateliê neste grupo.</p>';
      }
      this.innerHTML = this.#head() + content;
      this.#wire();
    }

    #wire() {
      const opts = { signal: this.#abort.signal };
      this.querySelectorAll('[data-sort]').forEach(b => b.addEventListener('click', () => {
        this.#sort = b.getAttribute('data-sort'); this.#orderFrozen = null; this.#render();
      }, opts));
      this.querySelectorAll('[data-filtro]').forEach(b => b.addEventListener('click', () => {
        this.#filter = b.getAttribute('data-filtro'); this.#orderFrozen = null; this.#render();
      }, opts));
      this.querySelector('[data-retry]')?.addEventListener('click', () => this.#fetch(), opts);
      this.querySelectorAll('.tsf-acv2').forEach(card => {
        const handle = card.getAttribute('data-handle');
        const a = this.#ateliers.find(x => x.handle === handle);
        if (!a) return;
        const foot = card.querySelector('.tsf-acv2__foot');
        foot?.addEventListener('click', (e) => { e.stopPropagation(); }, opts);
        card.querySelector('[data-hab]')?.addEventListener('change', (e) => {
          e.stopPropagation(); this.#toggleComunidade(a, e.target.checked, card);
        }, opts);
        card.querySelector('[data-star]')?.addEventListener('click', (e) => {
          e.preventDefault(); e.stopPropagation(); this.#toggleDestaque(a, card);
        }, opts);
      });
    }

    #freeze() {
      if (!this.#orderFrozen) this.#orderFrozen = this.#visiveis().map(a => a.handle);
    }
    #msg(card, txt, err) {
      const el = card.querySelector('[data-cardmsg]');
      if (!el) return;
      el.textContent = txt || '';
      el.classList.toggle('tsf-acv2__nota--err', !!err);
      if (txt) setTimeout(() => { if (el.textContent === txt) el.textContent = ''; }, 4000);
    }
    #rerenderStable(card) {
      this.#freeze();
      const y = window.scrollY;
      this.#render();
      window.scrollTo(0, y);
    }

    async #tiersAtuais(a) {
      if (a.tiers) return [...a.tiers];
      const r = await fetch(`${ACERVO_ENDPOINT}/get?handle=${encodeURIComponent(a.handle)}`, { signal: this.#abort.signal });
      const d = await r.json();
      if (!d.ok) throw new Error(d.error || 'falha ao ler o ateliê');
      let cur = []; try { cur = JSON.parse(d.atelier?.fields?.tier_acesso || '[]'); } catch { cur = []; }
      return Array.isArray(cur) ? cur : [];
    }

    async #toggleComunidade(a, ligar, card) {
      const sw = card.querySelector('[data-hab]');
      sw.disabled = true; card.classList.add('tsf-acv2--busy');
      try {
        let tiers = await this.#tiersAtuais(a);
        tiers = tiers.filter(t => t !== 'comunidade');
        if (ligar) tiers.unshift('comunidade');
        const res = await fetch(`${ACERVO_ENDPOINT}/update`, {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ handle: a.handle, fields: { tier_acesso: JSON.stringify(tiers) } }),
          signal: this.#abort.signal,
        });
        const out = await res.json();
        if (!out.ok) throw new Error(out.error || 'falha ao salvar');
        a.tiers = tiers;
        a.enrich = a.enrich || {}; a.enrich.tiers = tiers;
        if (!ligar && a.enrich.destaque) { /* destaque sem comunidade não aparece — mantém o dado, o hub ignora */ }
        this.#rerenderStable(card);
        const novo = this.querySelector(`.tsf-acv2[data-handle="${CSS.escape(a.handle)}"]`);
        if (novo) this.#msg(novo, ligar ? (a.status === 'ACTIVE' ? 'No ar para a Comunidade' : 'Habilitado — publique para entrar no ar') : 'Fora da Comunidade');
      } catch (err) {
        if (err.name === 'AbortError') return;
        sw.checked = !ligar; sw.disabled = false; card.classList.remove('tsf-acv2--busy');
        this.#msg(card, 'Erro — tente de novo', true);
      }
    }

    async #toggleDestaque(a, card) {
      const btn = card.querySelector('[data-star]');
      const ligar = !this.#destaque(a);
      btn.disabled = true; card.classList.add('tsf-acv2--busy');
      try {
        const res = await fetch(`${ACERVO_ENDPOINT}/update`, {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ handle: a.handle, fields: { destaque_specifica: ligar ? 'true' : 'false' } }),
          signal: this.#abort.signal,
        });
        const out = await res.json();
        if (!out.ok) throw new Error(out.error || 'falha ao salvar');
        a.enrich = a.enrich || {}; a.enrich.destaque = ligar;
        this.#rerenderStable(card);
        const novo = this.querySelector(`.tsf-acv2[data-handle="${CSS.escape(a.handle)}"]`);
        if (novo) this.#msg(novo, ligar ? 'Em destaque no Acervo' : 'Destaque removido');
      } catch (err) {
        if (err.name === 'AbortError') return;
        btn.disabled = false; card.classList.remove('tsf-acv2--busy');
        this.#msg(card, 'Erro — tente de novo', true);
      }
    }
  }

  class TsfAtelierStage extends HTMLElement {
    #abort = null;
    #handle = '';
    #atelier = null;
    #state = 'loading';
    #error = '';
    #saveTimer = null;
    #pending = {};
    #saving = false;
    #onPageHide = null;
    #gotoWired = false;

    async connectedCallback() {
      this.#abort = new AbortController();
      this.#onPageHide = () => this.#flushBeacon();
      window.addEventListener('pagehide', this.#onPageHide);
      tsfAcvInjectStyles();
      this.classList.add('tsf-stage');
      this.#injectPalcoCss();
      this.#gotoWired = false;
      this.#handle = new URLSearchParams(location.search).get('handle') || '';
      if (!this.#handle) { this.#state = 'error'; this.#error = 'Sem ?handle na URL.'; this.#render(); return; }
      this.#render();
      await this.#fetch();
    }
    disconnectedCallback() {
      clearTimeout(this.#saveTimer);
      this.#flushBeacon();
      this.#abort?.abort();
      if (this.#onPageHide) window.removeEventListener('pagehide', this.#onPageHide);
    }

    async #fetch() {
      try {
        /* /fornecedor/grupos (EF v213) mata o teto de 50 do Liquid: TODOS os
           grupos com dono. Corre em paralelo com o /get; se falhar, o mapa
           Liquid embutido na página segue como reserva. */
        const [res, gr] = await Promise.all([
          fetch(`${ACERVO_ENDPOINT}/get?handle=${encodeURIComponent(this.#handle)}`, { signal: this.#abort.signal }),
          fetch(`${ACERVO_ENDPOINT}/grupos`, { signal: this.#abort.signal }).then((r) => r.ok ? r.json() : null).catch(() => null)
        ]);
        const data = await res.json();
        if (!data.ok) throw new Error(data.error || 'ateliê não encontrado');
        if (gr && gr.ok && gr.grupos && Object.keys(gr.grupos).length) this.#matCache = gr.grupos;
        this.#choices = data.choices || {};
        this.#atelier = data.atelier;
        this.#state = 'ready';
      } catch (err) {
        if (err.name === 'AbortError') return;
        this.#state = 'error'; this.#error = err.message || 'erro';
      }
      this.#render();
    }

    #listToText(v) { try { const a = JSON.parse(v); return Array.isArray(a) ? a.join(', ') : (v || ''); } catch { return v || ''; } }
    #textToList(t) { return JSON.stringify(String(t || '').split(/[,\n]/).map(s => s.trim()).filter(Boolean)); }
    #normUrl(v) { v = String(v || '').trim(); if (!v) return ''; if (/^https?:\/\//i.test(v)) return v; return 'https://' + v.replace(/^\/+/, ''); }

    // rich_text (bio_editorial): JSON {root → paragraph → text} ⇄ texto plano (parágrafos por linha em branco)
    #richToText(v) {
      if (!v) return '';
      try {
        const doc = typeof v === 'string' ? JSON.parse(v) : v;
        const walk = (n) => {
          if (!n) return '';
          if (n.type === 'text') return n.value || '';
          const kids = (n.children || []).map(walk).join('');
          return (n.type === 'paragraph' || n.type === 'heading') ? kids + '\n\n' : kids;
        };
        return walk(doc).replace(/\n{3,}/g, '\n\n').trim();
      } catch { return typeof v === 'string' ? v : ''; }
    }
    #textToRich(t) {
      const paras = String(t || '').split(/\n{2,}/).map(s => s.trim()).filter(Boolean);
      const children = paras.length
        ? paras.map(p => ({ type: 'paragraph', children: [{ type: 'text', value: p }] }))
        : [{ type: 'paragraph', children: [{ type: 'text', value: '' }] }];
      return JSON.stringify({ type: 'root', children });
    }

    async #openProdutoPicker() {
      this.querySelector('[data-prod-modal]')?.remove();
      const ov = document.createElement('div');
      ov.setAttribute('data-prod-modal', '');
      ov.className = 'tsf-pmodal';
      ov.innerHTML = `<div class="tsf-pmodal__panel">
        <div class="tsf-pmodal__head"><span>Produtos em destaque</span><button type="button" data-prod-close aria-label="Fechar">✕</button></div>
        <input type="search" class="tsf-pmodal__search" placeholder="Buscar produto pelo nome…" data-prod-q>
        <div class="tsf-pmodal__results" data-prod-results><p class="tsf-stage__hint" style="padding:14px">Busque e clique para adicionar. Pode escolher vários — clique ✕ no fim.</p></div>
      </div>`;
      this.appendChild(ov);
      const opts = { signal: this.#abort.signal };
      ov.addEventListener('click', (e) => { if (e.target === ov) ov.remove(); }, opts);
      ov.addEventListener('keydown', (e) => { if (e.key === 'Escape') ov.remove(); }, opts);
      ov.querySelector('[data-prod-close]').addEventListener('click', () => ov.remove(), opts);
      const q = ov.querySelector('[data-prod-q]');
      let t;
      q.addEventListener('input', () => { clearTimeout(t); t = setTimeout(() => this.#produtoSearch(q.value, ov), 280); }, opts);
      q.focus();
    }
    async #produtoSearch(term, ov) {
      const box = ov.querySelector('[data-prod-results]');
      const v = String(term || '').trim();
      if (v.length < 2) { box.innerHTML = '<p class="tsf-stage__hint" style="padding:14px">Digite ao menos 2 letras.</p>'; return; }
      box.innerHTML = '<p class="tsf-stage__hint" style="padding:14px">Buscando…</p>';
      try {
        const url = `/search/suggest.json?q=${encodeURIComponent(v)}&resources[type]=product&resources[limit]=10`;
        const res = await fetch(url, { signal: this.#abort.signal });
        if (!res.ok) throw new Error('http ' + res.status);
        const data = await res.json();
        const prods = (data?.resources?.results?.products) || [];
        if (!prods.length) { box.innerHTML = '<p class="tsf-stage__hint" style="padding:14px">Nada encontrado.</p>'; return; }
        const chosen = new Set((this.#atelier.produtos || []).map((p) => p.gid));
        box.innerHTML = prods.map((p) => {
          const img = (p.featured_image && p.featured_image.url) || p.image || '';
          const id = String(p.id || '').replace(/\D/g, '');
          const has = chosen.has(`gid://shopify/Product/${id}`);
          return `<button type="button" class="tsf-pmodal__item${has ? ' is-added' : ''}" data-prod-id="${id}" data-prod-title="${tsfAcvEsc(p.title)}" data-prod-img="${tsfAcvEsc(img)}">
            ${img ? `<img src="${tsfAcvEsc(img)}" alt="">` : '<span class="tsf-pmodal__noimg"></span>'}
            <span>${tsfAcvEsc(p.title)}</span><em class="tsf-pmodal__badge">${has ? '✓ Adicionado' : '+ Adicionar'}</em></button>`;
        }).join('');
        box.querySelectorAll('[data-prod-id]').forEach((b) => b.addEventListener('click', () => {
          this.#addProduto(b.getAttribute('data-prod-id'), b.getAttribute('data-prod-title'), b.getAttribute('data-prod-img'), b);
        }, { signal: this.#abort.signal }));
      } catch (err) {
        if (err.name === 'AbortError') return;
        box.innerHTML = '<p class="tsf-stage__hint" style="padding:14px">Erro na busca.</p>';
      }
    }
    #addProduto(id, title, img, btn) {
      if (!id) return;
      const gid = `gid://shopify/Product/${id}`;
      this.#atelier.produtos = this.#atelier.produtos || [];
      if (this.#atelier.produtos.some((p) => p.gid === gid)) return; // já escolhido
      this.#atelier.produtos.push({ gid, title, image: img || '' });
      if (btn) { btn.classList.add('is-added'); const e = btn.querySelector('.tsf-pmodal__badge'); if (e) e.textContent = '✓ Adicionado'; }
      this.#refreshProdutos();
      this.#saveProdutos();
    }
    #removeProduto(gid) {
      this.#atelier.produtos = (this.#atelier.produtos || []).filter((p) => p.gid !== gid);
      this.#refreshProdutos();
      this.#saveProdutos();
    }
    #saveProdutos() {
      const gids = (this.#atelier.produtos || []).map((p) => p.gid);
      this.#atelier.fields.produtos_destaque = JSON.stringify(gids);
      this.#queueSave('produtos_destaque', JSON.stringify(gids));
    }
    #produtosGridHtml() {
      const prods = this.#atelier.produtos || [];
      const cards = prods.map((p) => `<div class="tsf-stage__prodchip">
        <div class="tsf-stage__prodchip-thumb">${p.image ? `<img src="${tsfAcvEsc(p.image)}" alt="">` : ''}</div>
        <span class="tsf-stage__prodchip-title">${tsfAcvEsc(p.title || '')}</span>
        <button type="button" class="tsf-stage__prodchip-x" data-prod-remove="${tsfAcvEsc(p.gid)}" aria-label="Remover">✕</button>
      </div>`).join('');
      return cards + `<button type="button" class="tsf-stage__prod-add" data-prod-pick>+ Adicionar produto</button>`;
    }
    #refreshProdutos() {
      const grid = this.querySelector('[data-produtos-grid]');
      if (grid) grid.innerHTML = this.#produtosGridHtml();
      this.querySelectorAll('[data-prod-pick]').forEach((b) => { b.onclick = () => this.#openProdutoPicker(); });
      this.querySelectorAll('[data-prod-remove]').forEach((b) => { b.onclick = () => this.#removeProduto(b.getAttribute('data-prod-remove')); });
      this.#syncPreview();
    }

    #videoGalleryHtml() {
      const vids = this.#atelier.videos || [];
      const items = vids.map((v) => `<div class="tsf-gal__item tsf-gal__item--vid">${v.poster ? `<img src="${tsfAcvEsc(v.poster)}" alt="">` : '<span class="tsf-gal__vid-ico">▶</span>'}<button type="button" class="tsf-gal__rm" data-vid-rm="${tsfAcvEsc(v.gid)}" aria-label="Remover">✕</button></div>`).join('');
      return `<div class="tsf-gal" data-videos-grid>${items}<label class="tsf-gal__add" data-videozone><span class="tsf-gal__add-ico">+</span><span class="tsf-gal__add-msg" data-vidmsg>Adicionar vídeo</span><input type="file" accept="video/*,.mp4,.mov,.m4v,.webm" multiple data-videofile hidden></label></div>`;
    }
    #refreshVideos() {
      const wrap = this.querySelector('[data-videos-grid]');
      if (wrap) wrap.outerHTML = this.#videoGalleryHtml();
      this.#wireVideos();
      this.#syncPreview();
    }
    #wireVideos() {
      this.querySelectorAll('[data-videofile]').forEach((inp) => { inp.onchange = (e) => { if (e.target.files && e.target.files.length) this.#uploadVideos(e.target.files); }; });
      this.querySelectorAll('[data-vid-rm]').forEach((b) => { b.onclick = () => this.#removeVideo(b.getAttribute('data-vid-rm')); });
    }
    async #uploadVideos(files) {
      const flist = Array.from(files || []);
      if (!flist.length) return;
      const msg = this.querySelector('[data-vidmsg]');
      const setMsg = (t) => { if (msg) msg.textContent = t; };
      let gids = [];
      try { gids = JSON.parse(this.#atelier.fields['videos_fabrica'] || '[]'); if (!Array.isArray(gids)) gids = []; } catch { gids = []; }
      this.#atelier.videos = this.#atelier.videos || [];
      let done = 0, erro = null;
      for (const file of flist){
        if (!this.#tipoDe(file).video) { erro = file.name.slice(0, 24) + ': não é um vídeo'; continue; }
        const veto = this.#limite(file);
        if (veto) { erro = veto; continue; }
        try {
          setMsg((done + 1) + '/' + flist.length + ' — enviando…');
          const pronto = await this.#enviaDireto(file, (p) => setMsg((done + 1) + '/' + flist.length + ' — ' + p + '%'));
          setMsg((done + 1) + '/' + flist.length + ' — processando…');
          const fim = await this.#registra(pronto);
          gids.push(fim.file);
          this.#atelier.videos.push({ gid: fim.file, url: '', poster: fim.url || '' });
          done++;
        } catch (e) { if (e.name === 'AbortError') return; erro = String(e.message || e).slice(0, 80); }
      }
      this.#atelier.fields['videos_fabrica'] = JSON.stringify(gids);
      try {
        const res = await fetch(`${ACERVO_ENDPOINT}/update`, {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ handle: this.#handle, fields: { videos_fabrica: JSON.stringify(gids) } }), signal: this.#abort.signal,
        });
        const data = await res.json();
        if (!data.ok) throw new Error(data.error || 'falha');
        this.#setSave(erro ? 'err' : 'ok', erro ? (done + ' enviado(s) · ' + erro) : (done + ' filme(s) enviado(s) · processando'));
      } catch (err) { if (err.name !== 'AbortError') this.#setSave('err', 'Erro ao salvar os filmes'); }
      this.#refreshVideos();
    }
    #removeVideo(gid) {
      let gids = [];
      try { gids = JSON.parse(this.#atelier.fields['videos_fabrica'] || '[]'); if (!Array.isArray(gids)) gids = []; } catch { gids = []; }
      gids = gids.filter((g) => g !== gid);
      this.#atelier.fields['videos_fabrica'] = JSON.stringify(gids);
      this.#atelier.videos = (this.#atelier.videos || []).filter((v) => v.gid !== gid);
      this.#queueSave('videos_fabrica', JSON.stringify(gids));
      this.#refreshVideos();
    }

    #videoAmbGalleryHtml() {
      const vids = this.#atelier.videosAmbientados || [];
      const items = vids.map((v) => `<div class="tsf-gal__item tsf-gal__item--vid">${v.poster ? `<img src="${tsfAcvEsc(v.poster)}" alt="">` : '<span class="tsf-gal__vid-ico">▶</span>'}<button type="button" class="tsf-gal__rm" data-vidamb-rm="${tsfAcvEsc(v.gid)}" aria-label="Remover">✕</button></div>`).join('');
      return `<div class="tsf-gal" data-videosamb-grid>${items}<label class="tsf-gal__add" data-videoambzone><span class="tsf-gal__add-ico">+</span><span class="tsf-gal__add-msg" data-vidambmsg>Adicionar vídeo</span><input type="file" accept="video/*,.mp4,.mov,.m4v,.webm" multiple data-videoambfile hidden></label></div>`;
    }
    #refreshVideosAmb() {
      const wrap = this.querySelector('[data-videosamb-grid]');
      if (wrap) wrap.outerHTML = this.#videoAmbGalleryHtml();
      this.#wireVideosAmb();
      this.#syncPreview();
    }
    #wireVideosAmb() {
      this.querySelectorAll('[data-videoambfile]').forEach((inp) => { inp.onchange = (e) => { if (e.target.files && e.target.files.length) this.#uploadVideosAmb(e.target.files); }; });
      this.querySelectorAll('[data-vidamb-rm]').forEach((b) => { b.onclick = () => this.#removeVideoAmb(b.getAttribute('data-vidamb-rm')); });
    }
    async #uploadVideosAmb(files) {
      const flist = Array.from(files || []);
      if (!flist.length) return;
      const msg = this.querySelector('[data-vidambmsg]');
      const setMsg = (t) => { if (msg) msg.textContent = t; };
      let gids = [];
      try { gids = JSON.parse(this.#atelier.fields['videos_ambientados'] || '[]'); if (!Array.isArray(gids)) gids = []; } catch { gids = []; }
      this.#atelier.videosAmbientados = this.#atelier.videosAmbientados || [];
      let done = 0, erro = null;
      for (const file of flist){
        if (!this.#tipoDe(file).video) { erro = file.name.slice(0, 24) + ': não é um vídeo'; continue; }
        const veto = this.#limite(file);
        if (veto) { erro = veto; continue; }
        try {
          setMsg((done + 1) + '/' + flist.length + ' — enviando…');
          const pronto = await this.#enviaDireto(file, (p) => setMsg((done + 1) + '/' + flist.length + ' — ' + p + '%'));
          setMsg((done + 1) + '/' + flist.length + ' — processando…');
          const fim = await this.#registra(pronto);
          gids.push(fim.file);
          this.#atelier.videosAmbientados.push({ gid: fim.file, url: '', poster: fim.url || '' });
          done++;
        } catch (e) { if (e.name === 'AbortError') return; erro = String(e.message || e).slice(0, 80); }
      }
      this.#atelier.fields['videos_ambientados'] = JSON.stringify(gids);
      try {
        const res = await fetch(`${ACERVO_ENDPOINT}/update`, {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ handle: this.#handle, fields: { videos_ambientados: JSON.stringify(gids) } }), signal: this.#abort.signal,
        });
        const data = await res.json();
        if (!data.ok) throw new Error(data.error || 'falha');
        this.#setSave(erro ? 'err' : 'ok', erro ? (done + ' enviado(s) · ' + erro) : (done + ' filme(s) enviado(s) · processando'));
      } catch (err) { if (err.name !== 'AbortError') this.#setSave('err', 'Erro ao salvar os filmes'); }
      this.#refreshVideosAmb();
    }
    #removeVideoAmb(gid) {
      let gids = [];
      try { gids = JSON.parse(this.#atelier.fields['videos_ambientados'] || '[]'); if (!Array.isArray(gids)) gids = []; } catch { gids = []; }
      gids = gids.filter((g) => g !== gid);
      this.#atelier.fields['videos_ambientados'] = JSON.stringify(gids);
      this.#atelier.videosAmbientados = (this.#atelier.videosAmbientados || []).filter((v) => v.gid !== gid);
      this.#queueSave('videos_ambientados', JSON.stringify(gids));
      this.#refreshVideosAmb();
    }

    #queueSave(key, value) {
      this.#pending[key] = value;
      clearTimeout(this.#saveTimer);
      this.#setSave('saving', 'Salvando…');
      this.#saveTimer = setTimeout(() => this.#flush(), 650);
    }
    async #flush() {
      // serializa: se já há um save em voo, re-tenta logo depois (evita corrida de respostas fora de ordem)
      if (this.#saving) { clearTimeout(this.#saveTimer); this.#saveTimer = setTimeout(() => this.#flush(), 200); return; }
      const fields = this.#pending;
      if (!Object.keys(fields).length) return;
      this.#pending = {};
      this.#saving = true;
      try {
        const res = await fetch(`${ACERVO_ENDPOINT}/update`, {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ handle: this.#handle, fields }), signal: this.#abort.signal,
        });
        const data = await res.json();
        if (!data.ok) throw new Error(data.error || 'falha');
        const now = new Date();
        this.#setSave('ok', `Salvo ${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}`);
      } catch (err) {
        if (err.name !== 'AbortError') {
          // não perde o que não salvou: devolve à fila (sem pisar em edições mais novas) e re-tenta sozinho
          this.#pending = Object.assign({}, fields, this.#pending);
          this.#setSave('err', 'Sem conexão — tentando salvar de novo…');
          clearTimeout(this.#saveTimer);
          this.#saveTimer = setTimeout(() => this.#flush(), 4000);
        }
      } finally {
        this.#saving = false;
      }
    }
    // Salva o pendente ao sair da página (o admin navega por full-page load) — sendBeacon não perde o último texto digitado
    #flushBeacon() {
      const fields = this.#pending; this.#pending = {};
      if (!Object.keys(fields).length) return;
      try {
        const body = JSON.stringify({ handle: this.#handle, fields });
        if (navigator.sendBeacon) {
          navigator.sendBeacon(`${ACERVO_ENDPOINT}/update`, new Blob([body], { type: 'text/plain' }));
        } else {
          fetch(`${ACERVO_ENDPOINT}/update`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body, keepalive: true });
        }
      } catch (e) { /* best-effort no unload */ }
    }
    #setSave(mod, txt) {
      const el = this.querySelector('[data-save]');
      if (!el) return;
      el.className = 'tsf-stage__save' + (mod ? ` tsf-stage__save--${mod}` : '');
      el.textContent = txt;
    }

    async #togglePublish(publish) {
      this.#setSave('saving', publish ? 'Publicando…' : 'Recolhendo…');
      try {
        const res = await fetch(`${ACERVO_ENDPOINT}/update`, {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ handle: this.#handle, status: publish ? 'ACTIVE' : 'DRAFT' }), signal: this.#abort.signal,
        });
        const data = await res.json();
        if (!data.ok) throw new Error(data.error || 'falha');
        this.#atelier.status = publish ? 'ACTIVE' : 'DRAFT';
        this.#setSave('ok', publish ? 'No acervo (visível)' : 'Em rascunho (oculto)');
        this.#syncNote();
      } catch (err) {
        if (err.name === 'AbortError') return;
        const cb = this.querySelector('[data-pub]'); if (cb) cb.checked = !publish; // não deixa o checkbox mentir
        this.#setSave('err', 'Erro ao publicar — tente de novo');
      }
    }

    #syncNote() {
      const el = this.querySelector('[data-sync-note]');
      if (!el) return;
      const chosen = [...this.querySelectorAll('[data-tier]')].filter(c => c.checked).map(c => c.getAttribute('data-tier'));
      const com = chosen.includes('comunidade');
      const pub = this.#atelier.status === 'ACTIVE';
      const dest = !!this.querySelector('[data-destaque]')?.checked;
      const on = com && pub;
      el.className = 'tsf-sync-note' + (on ? ' tsf-sync-note--on' : '');
      const msg = on
        ? `No ar para a Comunidade${dest ? ' — em destaque, primeiro da fila' : ''}. Este ateliê entra no Acervo de Fábricas, e os produtos com bloco 3D e os catálogos dele alimentam a Biblioteca 3D e os Catálogos do hub.`
        : !com
          ? 'Fora do hub da Comunidade — marque "Comunidade" acima para este ateliê entrar no Acervo dos especificadores.'
          : 'Habilitado para a Comunidade, mas em rascunho — ligue "No acervo (visível)" no topo para entrar no ar.';
      el.innerHTML = `<span class="tsf-sync-note__dot"></span><span>${msg}</span>`;
    }

    #field(label, key, type, hint, unit) {
      const v = this.#atelier.fields[key];
      const isList = type === 'list';
      const val = isList ? this.#listToText(v) : (v || '');
      let ctrl;
      if (type === 'textarea') {
        ctrl = `<textarea data-field="${key}" data-kind="text">${tsfAcvEsc(val)}</textarea>`;
      } else if (type === 'number') {
        ctrl = `<span class="tsf-stg2-unitwrap"><input type="number" data-field="${key}" data-kind="text" value="${tsfAcvEsc(val)}">${unit ? `<span class="tsf-stg2-unit">${tsfAcvEsc(unit)}</span>` : ''}</span>`;
      } else if (type === 'url') {
        const tem = String(val).trim();
        ctrl = `<span class="tsf-stg2-urlwrap"><input type="url" inputmode="url" data-field="${key}" data-kind="url" value="${tsfAcvEsc(val)}" placeholder="https://…"><a class="tsf-stg2-open ${tem ? '' : 'tsf-stg2-open--off'}" data-openurl href="${tem ? tsfAcvEsc(this.#normUrl(val)) : '#'}" target="_blank" rel="noopener" title="Abrir link" aria-label="Abrir link">↗</a></span>`;
      } else if (isList && Array.isArray(this.#choices[key]) && this.#choices[key].length) {
        /* SELECIONAR, NUNCA DIGITAR: as opções vêm da definição do metaobjeto
           (via EF). Para acrescentar uma, o founder edita a definição na origem
           e ela aparece aqui sozinha. Valor legado fora da lista continua
           visível, marcado — nada some sem alguém ver. */
        let sel = [];
        try { const a = JSON.parse(v || '[]'); sel = Array.isArray(a) ? a : []; } catch { sel = []; }
        const opts = this.#choices[key];
        const legado = sel.filter(x => !opts.includes(x));
        const todos = key === 'regioes_entrega';
        ctrl = `<div class="tsf-p3-esc" data-esc="${key}">
          ${todos ? `<button type="button" class="tsf-p3-esc__all" data-esc-all="${key}">${sel.length >= opts.length ? 'Limpar' : 'Brasil inteiro'}</button>` : ''}
          ${opts.map(o => `<button type="button" class="tsf-p3-esc__o${sel.includes(o) ? ' is-on' : ''}" data-esc-v="${tsfAcvEsc(o)}" aria-pressed="${sel.includes(o) ? 'true' : 'false'}">${tsfAcvEsc(o)}</button>`).join('')}
          ${legado.map(o => `<button type="button" class="tsf-p3-esc__o is-on tsf-p3-esc__o--velho" data-esc-v="${tsfAcvEsc(o)}" aria-pressed="true" title="Fora da lista padrão — toque para remover">${tsfAcvEsc(o)} &#9888;</button>`).join('')}
        </div>`;
      } else if (isList) {
        const itens = String(val).split(/[,\n]/).map(s => s.trim()).filter(Boolean);
        ctrl = `<div class="tsf-tags" data-tags="${key}">
          <input type="text" data-field="${key}" data-kind="list" value="${tsfAcvEsc(val)}" hidden>
          <div class="tsf-tags__box" data-tags-box>
            ${itens.map(t => `<button type="button" class="tsf-tags__chip" data-tag-rm="${tsfAcvEsc(t)}">${tsfAcvEsc(t)}<span aria-hidden="true">✕</span></button>`).join('')}
            <input type="text" class="tsf-tags__in" data-tags-in placeholder="${itens.length ? 'Adicionar…' : 'Digite e aperte Enter'}">
          </div>
        </div>`;
      } else {
        ctrl = `<input type="text" data-field="${key}" data-kind="text" value="${tsfAcvEsc(val)}">`;
      }
      return `<div class="tsf-stage__field">
        <label class="tsf-stage__label">${tsfAcvEsc(label)}</label>
        ${ctrl}
        ${hint ? `<p class="tsf-stage__hint">${tsfAcvEsc(hint)}</p>` : ''}
      </div>`;
    }

    #uploadZone(field, label, currentUrl, kind, ehFilme, forma) {
      /* O seletor do Windows ESCONDE arquivo de tipo desconhecido quando o
         accept só tem image/*,video/* — as extensões explícitas trazem os
         .MOV e .MP4 exportados de celular de volta pra janela. */
      const EXTV = '.mp4,.mov,.m4v,.webm,.avi,.mkv';
      const EXTI = '.jpg,.jpeg,.png,.webp,.gif,.heic,.avif';
      const accept = kind === 'video' ? 'video/*,' + EXTV
        : kind === 'midia' ? 'image/*,video/*,' + EXTI + ',' + EXTV
        : 'image/*,' + EXTI;
      /* 04-08: video tambem tem cartaz (preview do Shopify). Antes a zona
         do filme ficava com o icone de play num quadrado cinza e o founder
         achava que nao tinha nada la. */
      const hasImg = !!currentUrl;
      const filledNow = currentUrl || (kind === 'video' && this.#atelier.fields[field]);
      const ico = kind === 'video'
        ? `<span class="tsf-up__ico"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><polygon points="6 4 20 12 6 20 6 4"/></svg></span>`
        : `<span class="tsf-up__ico"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="M21 15l-5-5L5 21"/></svg></span>`;
      const thumb = hasImg ? `<img src="${tsfAcvEsc(currentUrl)}" alt="">` : ico;
      return `<label class="tsf-up ${filledNow ? 'tsf-up--filled' : ''}${forma ? ' tsf-up--' + forma : ''}" data-upzone="${field}">
        <div class="tsf-up__thumb">${thumb}</div>
        <div class="tsf-up__meta">
          <span class="tsf-up__label">${tsfAcvEsc(label)}${ehFilme ? ' <b class="tsf-up__flag">filme</b>' : ''}</span>
          <span class="tsf-up__msg" data-upmsg>${filledNow ? 'Trocar' : (kind === 'midia' ? 'Enviar foto ou vídeo' : 'Enviar')}</span>
        </div>
        <input type="file" accept="${accept}" data-upfile="${field}" hidden>
      </label>`;
    }

    /* ── ENVIO DIRETO (03-08) ─────────────────────────────────────────
       O arquivo ia como TEXTO (base64) pela nossa função: 33% mais pesado,
       lento e travado em 20MB. Agora o navegador pede o destino, manda os
       BYTES direto pro Shopify com progresso, e só avisa o fim. */
    async #enviaDireto(file, onPct) {
      const alvo = await fetch(`${ACERVO_ENDPOINT}/upload-target`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ filename: file.name, mime: this.#tipoDe(file).mime || file.type, size: String(file.size) }),
        signal: this.#abort.signal,
      }).then((r) => r.json());
      if (!alvo.ok) throw new Error(alvo.error || 'nao consegui preparar o envio');
      const t = alvo.target;
      const fd = new FormData();
      (t.parameters || []).forEach((p) => fd.append(p.name, p.value));
      fd.append('file', file);
      await new Promise((ok, falha) => {
        const x = new XMLHttpRequest();
        x.open('POST', t.url, true);
        x.upload.onprogress = (e) => { if (e.lengthComputable && onPct) onPct(Math.round(e.loaded / e.total * 100)); };
        x.onload = () => (x.status >= 200 && x.status < 400) ? ok() : falha(new Error('o envio foi recusado (HTTP ' + x.status + ')'));
        x.onerror = () => falha(new Error('a conexao caiu no meio do envio'));
        x.send(fd);
      });
      return { resourceUrl: t.resourceUrl, mime: this.#tipoDe(file).mime || file.type, alt: this.#atelier.nome };
    }
    async #registra(pronto, extra) {
      const d = await fetch(`${ACERVO_ENDPOINT}/upload-finish`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(Object.assign({}, pronto, extra || {})), signal: this.#abort.signal,
      }).then((r) => r.json());
      if (!d.ok) throw new Error(d.error || 'o Shopify recusou o arquivo');
      return d;
    }
    /* O tipo vem do navegador OU da extensão: no Windows um .MOV/.MP4
       exportado de celular chega com type VAZIO e era recusado como
       "não é imagem nem vídeo". A extensão salva o dia. */
    #tipoDe(file) {
      const t = String(file.type || '').toLowerCase();
      if (t.startsWith('video/')) return { mime: t, video: true };
      if (t.startsWith('image/')) return { mime: t, video: false };
      const ext = String(file.name || '').toLowerCase().split('.').pop();
      const VID = { mp4: 'video/mp4', mov: 'video/quicktime', m4v: 'video/x-m4v', webm: 'video/webm', avi: 'video/x-msvideo', mkv: 'video/x-matroska', mpeg: 'video/mpeg', mpg: 'video/mpeg', hevc: 'video/mp4' };
      const IMG = { jpg: 'image/jpeg', jpeg: 'image/jpeg', png: 'image/png', webp: 'image/webp', gif: 'image/gif', heic: 'image/heic', heif: 'image/heif', avif: 'image/avif' };
      if (VID[ext]) return { mime: VID[ext], video: true };
      if (IMG[ext]) return { mime: IMG[ext], video: false };
      return { mime: '', video: false, desconhecido: true };
    }
    #limite(file) {
      const t = this.#tipoDe(file);
      if (t.desconhecido) return file.name.slice(0, 26) + ': não reconheci o formato (use JPG, PNG, MP4 ou MOV)';
      const max = t.video ? 200 : 25;
      if (file.size > max * 1024 * 1024) return file.name.slice(0, 22) + ': ' + (file.size / 1048576).toFixed(0) + 'MB passa do limite de ' + max + 'MB';
      return null;
    }

    async #uploadAsset(field, file) {
      if (!file) return;
      const isVideo = this.#tipoDe(file).video;
      const zone = this.querySelector(`[data-upzone="${field}"]`);
      const setMsg = (t) => { const m = zone?.querySelector('[data-upmsg]'); if (m) m.textContent = t; };
      const veto = this.#limite(file);
      if (veto) { setMsg(veto); return; }
      zone?.classList.add('tsf-up--busy');
      const mb = (file.size / 1048576).toFixed(1);
      setMsg('Enviando ' + mb + 'MB… 0%');
      try {
        const pronto = await this.#enviaDireto(file, (p) => setMsg('Enviando ' + mb + 'MB… ' + p + '%'));
        setMsg(isVideo ? 'Enviado — o Shopify esta processando…' : 'Enviado — finalizando…');
        this.#setSave('saving', isVideo ? 'Processando o filme (pode levar alguns minutos)…' : 'Salvando…');
        const fim = await this.#registra(pronto, { handle: this.#handle, field: field });
        this.#atelier.fields[field] = fim.file;
        this.#atelier.refs = this.#atelier.refs || {};
        if (fim.url) {
          this.#atelier.refs[field] = isVideo
            ? { sources: [{ url: '', mimeType: file.type }], preview: { image: { url: fim.url } } }
            : { image: { url: fim.url } };
        }
        this.#setSave('ok', isVideo ? (fim.url ? 'Filme no ar' : 'Filme enviado — aparece quando o Shopify terminar') : 'Imagem salva');
        this.#render();
      } catch (err) {
        if (err.name === 'AbortError') return;
        zone?.classList.remove('tsf-up--busy');
        setMsg(String(err.message || err).slice(0, 90));
        this.#setSave('err', String(err.message || err).slice(0, 90));
      }
    }

    #gallery(field, label) {
      let gids = [];
      try { gids = JSON.parse(this.#atelier.fields[field] || '[]'); if (!Array.isArray(gids)) gids = []; } catch { gids = []; }
      const media = this.#atelier.media || {};
      const thumbs = gids.map((g) => {
        const url = media[g];
        return `<div class="tsf-gal__item">${url ? `<img src="${tsfAcvEsc(url)}" alt="">` : '<span class="tsf-gal__pending"></span>'}<button type="button" class="tsf-gal__rm" data-gal-rm="${field}" data-gal-gid="${tsfAcvEsc(g)}" aria-label="Remover">✕</button></div>`;
      }).join('');
      return `<div class="tsf-stage__field">
        <label class="tsf-stage__label">${tsfAcvEsc(label)}</label>
        <div class="tsf-gal" data-gal="${field}">
          ${thumbs}
          <label class="tsf-gal__add" data-galzone="${field}">
            <span class="tsf-gal__add-ico">+</span>
            <span class="tsf-gal__add-msg" data-galmsg>Adicionar</span>
            <input type="file" accept="image/*,.jpg,.jpeg,.png,.webp,.heic,.avif" multiple data-galfile="${field}" hidden>
          </label>
        </div>
      </div>`;
    }
    async #uploadGallery(field, files) {
      const list = Array.from(files || []);
      if (!list.length) return;
      const zone = this.querySelector(`[data-galzone="${field}"]`);
      const setMsg = (t) => { const m = zone?.querySelector('[data-galmsg]'); if (m) m.textContent = t; };
      zone?.classList.add('tsf-up--busy');
      let gids = [];
      try { gids = JSON.parse(this.#atelier.fields[field] || '[]'); if (!Array.isArray(gids)) gids = []; } catch { gids = []; }
      this.#atelier.media = this.#atelier.media || {};
      let done = 0, erro = null;
      for (const file of list){
        const veto = this.#limite(file);
        if (veto) { erro = veto; continue; }
        try {
          setMsg((done + 1) + '/' + list.length + ' — enviando…');
          const pronto = await this.#enviaDireto(file, (p) => setMsg((done + 1) + '/' + list.length + ' — ' + p + '%'));
          const fim = await this.#registra(pronto);
          gids.push(fim.file);
          if (fim.url) this.#atelier.media[fim.file] = fim.url;
          done++;
        } catch (e) { if (e.name === 'AbortError') return; erro = String(e.message || e).slice(0, 80); }
      }
      this.#atelier.fields[field] = JSON.stringify(gids);
      try {
        await fetch(`${ACERVO_ENDPOINT}/update`, {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ handle: this.#handle, fields: { [field]: JSON.stringify(gids) } }), signal: this.#abort.signal,
        });
        this.#setSave(erro ? 'err' : 'ok', erro ? (done + ' salva(s) · ' + erro) : (done + ' foto(s) salva(s)'));
      } catch (e) { this.#setSave('err', 'Erro ao salvar a galeria'); }
      this.#render();
    }
    async #removeFromGallery(field, gid) {
      let gids = [];
      try { gids = JSON.parse(this.#atelier.fields[field] || '[]'); if (!Array.isArray(gids)) gids = []; } catch { gids = []; }
      gids = gids.filter((g) => g !== gid);
      this.#atelier.fields[field] = JSON.stringify(gids);
      this.#setSave('saving', 'Removendo…');
      try {
        await fetch(`${ACERVO_ENDPOINT}/update`, {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ handle: this.#handle, fields: { [field]: JSON.stringify(gids) } }), signal: this.#abort.signal,
        });
        this.#setSave('ok', 'Foto removida');
      } catch (err) { this.#setSave('', 'Erro ao remover'); }
      this.#render();
    }

    /* ═══ O PALCO v3 · A matéria (parede) + Em campo (obras) ═══ */
    #choices = {};
    /* refs de capa podem ser MediaImage OU Video — o /get resolve os dois.
       Devolve {url (pra mostrar), video (bool)}. */
    #midiaRef(r) {
      if (!r) return null;
      if (r.image && r.image.url) return { url: r.image.url, video: false };
      const src = (r.sources || []).find((x) => (x.mimeType || '').startsWith('video/')) || (r.sources || [])[0];
      const cartaz = r.preview && r.preview.image ? r.preview.image.url : '';
      if (src || cartaz) return { url: cartaz, video: true, src: src ? src.url : '' };
      return null;
    }
    #matQ = '';
    #matCache = null;
    #nomeLimpoAdm(n) { return String(n || '').replace(/\s*[-–]\s*[A-Z]{2,4}\s*$/, ''); }
    #materiaMapa() {
      if (this.#matCache) return this.#matCache;
      let m = {};
      try { m = JSON.parse(document.querySelector('[data-palco-materia-map]')?.textContent || '{}'); } catch (e) { m = {}; }
      this.#matCache = m; return m;
    }
    #obrasMapa() {
      try { const a = JSON.parse(document.querySelector('[data-palco-obras-map]')?.textContent || '[]'); return Array.isArray(a) ? a : []; } catch (e) { return []; }
    }
    #matSel() {
      try { const a = JSON.parse(this.#atelier.fields.acabamentos_disponiveis || '[]'); return Array.isArray(a) ? a : []; } catch (e) { return []; }
    }
    #matCard(gid, g, pos) {
      const ROM = ['i','ii','iii','iv','v','vi','vii','viii','ix','x','xi','xii'];
      const on = pos != null;
      const nome = this.#nomeLimpoAdm((g && g.n) || '');
      const thumb = g ? (g.v0 || g.img) : '';
      const vtxt = g ? (g.v ? g.v + (g.v === 1 ? ' variação' : ' variações') : 'sem variações — só a capa') : 'grupo em rascunho no Shopify';
      return `<button type="button" class="tsf-p3-mat__cel${on ? ' is-on' : ''}" data-mat-toggle="${tsfAcvEsc(gid)}" aria-pressed="${on ? 'true' : 'false'}">
        <span class="tsf-p3-mat__thumb">${thumb ? `<img src="${tsfAcvEsc(thumb)}" alt="" loading="lazy">` : `<span class="tsf-p3-mat__ph">${tsfAcvEsc((nome || '?').slice(0, 1))}</span>`}</span>
        ${on ? `<span class="tsf-p3-mat__pos">${ROM[pos] || (pos + 1)}</span>` : ''}
        <span class="tsf-p3-mat__n">${tsfAcvEsc(nome || 'Sem nome')}</span>
        <span class="tsf-p3-mat__v">${tsfAcvEsc(vtxt)}</span>
        <span class="tsf-p3-mat__acao">${on ? '✓ na parede' : '+ pôr na parede'}</span>
      </button>`;
    }
    #matParedeHtml() {
      const mapa = this.#materiaMapa();
      const sel = this.#matSel();
      if (!sel.length) return `<p class="tsf-p3-vazio">A parede está nua — escolha as matérias abaixo. Sem grupos, o capítulo "A matéria" simplesmente não aparece na página.</p>`;
      return sel.map((gid, i) => this.#matCard(gid, mapa[gid] || null, i)).join('');
    }
    #matLivresHtml() {
      const mapa = this.#materiaMapa();
      if (!Object.keys(mapa).length) return `<p class="tsf-p3-vazio">O mapa dos acabamentos não chegou — recarregue a página.</p>`;
      const sel = new Set(this.#matSel());
      const q = this.#matQ.trim().toLowerCase();
      const daCasa = Object.keys(mapa).filter(gid => (mapa[gid].forn || '') === this.#handle);
      if (!daCasa.length) return `<p class="tsf-p3-vazio">Nenhum grupo de acabamento cadastrado para esta casa — eles nascem no metaobjeto <b>Grupo de Acabamentos</b>, com o campo <b>Fornecedor</b> apontando pra cá.</p>`;
      const livres = daCasa
        .filter(gid => !sel.has(gid))
        .filter(gid => !q || String(mapa[gid].n || '').toLowerCase().includes(q))
        .sort((a, b) => String(mapa[a].n || '').localeCompare(String(mapa[b].n || ''), 'pt-BR'));
      if (!livres.length) return `<p class="tsf-p3-vazio">${q ? 'Nada com esse nome.' : 'Todos os grupos desta casa já estão na parede.'}</p>`;
      return livres.map(gid => this.#matCard(gid, mapa[gid], null)).join('');
    }
    #matContaTxt() {
      const mapa = this.#materiaMapa();
      const sel = this.#matSel();
      const vs = sel.reduce((t, gid) => t + ((mapa[gid] || {}).v || 0), 0);
      return sel.length ? `${sel.length} ${sel.length === 1 ? 'grupo' : 'grupos'} na parede · ${vs} variações na gaveta` : 'Parede vazia';
    }
    #refreshMateria() {
      const p = this.querySelector('[data-mat-parede]'); if (p) p.innerHTML = this.#matParedeHtml();
      const l = this.querySelector('[data-mat-livres]'); if (l) l.innerHTML = this.#matLivresHtml();
      const c = this.querySelector('[data-mat-conta]'); if (c) c.textContent = this.#matContaTxt();
    }
    #toggleMateria(gid) {
      if (!gid || !this.#atelier) return;
      const arr = this.#matSel();
      const i = arr.indexOf(gid);
      if (i > -1) arr.splice(i, 1); else arr.push(gid);
      const v = JSON.stringify(arr);
      this.#atelier.fields.acabamentos_disponiveis = v;
      this.#queueSave('acabamentos_disponiveis', v);
      this.#refreshMateria();
      this.#refreshChecklist();
    }
    #obrasHtml() {
      const obras = this.#obrasMapa().filter(o => (o.f || []).indexOf(this.#handle) > -1);
      if (!obras.length) return `<p class="tsf-p3-vazio">Nenhum projeto vincula este ateliê ainda. O vínculo nasce no projeto — metaobjeto <b>Toth Projects</b>, campo <b>Fornecedores</b> — e este capítulo acende sozinho aqui e na página.</p>`;
      return `<div class="tsf-p3-obras">` + obras.map(o => `<a class="tsf-p3-obra" href="/pages/projeto/${encodeURIComponent(o.h)}" target="_blank" rel="noopener">
        ${o.img ? `<img src="${tsfAcvEsc(o.img)}" alt="" loading="lazy">` : ''}
        <span class="tsf-p3-obra__veu" aria-hidden="true"></span>
        <span class="tsf-p3-obra__id"><span class="tsf-p3-obra__t">${tsfAcvEsc(o.t)}</span><span class="tsf-p3-obra__ir">Ver o projeto ↗</span></span>
      </a>`).join('') + `</div>`;
    }
    #injectPalcoCss() {
      if (document.getElementById('tsf-palco-v3')) return;
      const el = document.createElement('style');
      el.id = 'tsf-palco-v3';
      el.textContent = `
  .tsf-p3-chap{ position: relative; }
  .tsf-p3-chap::after{ content: attr(data-folio); position: absolute; inset-block-start: 12px; inset-inline-end: 18px;
    font: italic 400 26px/1 var(--tsf-font-serif, 'Cormorant Garamond', serif); color: var(--tsf-admin-accent, #3F4D3A); opacity: .5; pointer-events: none; }
  .tsf-p3-eco{ margin: 2px 0 16px; font: italic 400 13.5px/1.6 var(--tsf-font-serif, 'Cormorant Garamond', serif);
    color: var(--tsf-text-dim, #8b857c); max-inline-size: 62ch; }
  .tsf-p3-eti{ display: flex; align-items: center; gap: 7px; margin: 16px 0 8px;
    font: 600 9.5px/1 ui-monospace, Menlo, monospace; letter-spacing: .18em; text-transform: uppercase; color: var(--tsf-admin-accent, #3F4D3A); }
  .tsf-p3-eti::before{ content: ''; inline-size: 14px; block-size: 1px; background: currentColor; }
  .tsf-p3-eti em{ font-style: normal; color: var(--tsf-text-dim, #a8a299); letter-spacing: .06em; text-transform: none; }
  .tsf-p3-vazio{ margin: 8px 0; font: 400 12.5px/1.6 var(--font-body-family, sans-serif); color: var(--tsf-text-dim, #8b857c); }
  .tsf-p3-busca{ inline-size: 100%; margin: 4px 0 10px; padding: 9px 12px; border: 1px solid var(--tsf-line, #e5e0d8);
    border-radius: 10px; font: 400 13px/1.4 var(--font-body-family, sans-serif); background: var(--tsf-card, #fff); color: inherit; }
  .tsf-p3-busca:focus-visible{ outline: 2px solid var(--tsf-admin-accent, #3F4D3A); outline-offset: 1px; }
  .tsf-p3-mat{ display: grid; grid-template-columns: repeat(auto-fill, minmax(150px, 1fr)); gap: 10px; }
  .tsf-p3-mat--todos{ max-block-size: 430px; overflow: auto; padding-inline-end: 4px; scrollbar-width: thin; }
  .tsf-p3-mat__cel{ position: relative; text-align: start; padding: 0 0 10px; cursor: pointer;
    border: 1px solid var(--tsf-line, #e5e0d8); border-radius: 12px; overflow: hidden; background: var(--tsf-card, #fff);
    transition: translate .2s ease, box-shadow .2s ease, border-color .2s ease; }
  .tsf-p3-mat__cel:hover{ translate: 0 -2px; box-shadow: 0 6px 18px rgba(26,25,24,.08); }
  .tsf-p3-mat__cel:focus-visible{ outline: 2px solid var(--tsf-admin-accent, #3F4D3A); outline-offset: 2px; }
  .tsf-p3-mat__cel.is-on{ border-color: var(--tsf-admin-accent, #3F4D3A); box-shadow: inset 0 0 0 1px var(--tsf-admin-accent, #3F4D3A); }
  .tsf-p3-mat__cel:not(.is-on) .tsf-p3-mat__thumb{ filter: saturate(.82); }
  .tsf-p3-mat__thumb{ display: block; aspect-ratio: 4 / 3; background: #efece6; }
  .tsf-p3-mat__thumb img{ inline-size: 100%; block-size: 100%; object-fit: cover; display: block; }
  .tsf-p3-mat__ph{ display: flex; align-items: center; justify-content: center; block-size: 100%;
    font: italic 400 30px/1 var(--tsf-font-serif, 'Cormorant Garamond', serif); color: #b7b0a5; text-transform: uppercase; }
  .tsf-p3-mat__pos{ position: absolute; inset-block-start: 8px; inset-inline-start: 8px; min-inline-size: 26px; block-size: 26px;
    padding: 0 8px; display: inline-flex; align-items: center; justify-content: center;
    background: var(--tsf-admin-accent, #3F4D3A); color: #f4f2ec; border-radius: 999px;
    font: italic 500 14px/1 var(--tsf-font-serif, 'Cormorant Garamond', serif); }
  .tsf-p3-mat__n{ display: block; margin: 9px 10px 0; font: 600 10.5px/1.35 var(--font-body-family, sans-serif);
    letter-spacing: .07em; text-transform: uppercase; color: var(--tsf-text-strong, #2a2723);
    white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
  .tsf-p3-mat__v{ display: block; margin: 3px 10px 0; font: 400 10.5px/1.3 ui-monospace, Menlo, monospace; color: var(--tsf-text-dim, #a8a299); }
  .tsf-p3-mat__acao{ display: block; margin: 8px 10px 0; font: 600 9.5px/1 var(--font-body-family, sans-serif);
    letter-spacing: .1em; text-transform: uppercase; color: var(--tsf-text-dim, #a8a299); transition: color .2s ease; }
  .tsf-p3-mat__cel.is-on .tsf-p3-mat__acao, .tsf-p3-mat__cel:hover .tsf-p3-mat__acao{ color: var(--tsf-admin-accent, #3F4D3A); }
  .tsf-up__flag{
    display: inline-block; margin-inline-start: 6px; padding: 1px 6px; border-radius: 999px;
    background: var(--tsf-admin-accent, #3F4D3A); color: #f4f2ec; font-weight: 400;
    font-size: 9px; letter-spacing: .12em; text-transform: uppercase; vertical-align: 1px;
  }
  .tsf-p3-esc{ display: flex; flex-wrap: wrap; gap: 6px; }
  .tsf-p3-esc__o, .tsf-p3-esc__all{
    padding: 7px 12px; border-radius: 999px; cursor: pointer;
    border: 1px solid var(--tsf-line, #e5e0d8); background: var(--tsf-card, #fff);
    font: 500 12px/1 var(--font-body-family, sans-serif); color: var(--tsf-text-dim, #8b857c);
    transition: background .18s ease, color .18s ease, border-color .18s ease;
  }
  .tsf-p3-esc__o:hover{ border-color: var(--tsf-admin-accent, #3F4D3A); color: var(--tsf-text-strong, #2a2723); }
  .tsf-p3-esc__o:focus-visible, .tsf-p3-esc__all:focus-visible{ outline: 2px solid var(--tsf-admin-accent, #3F4D3A); outline-offset: 2px; }
  .tsf-p3-esc__o.is-on{ background: var(--tsf-admin-accent, #3F4D3A); border-color: var(--tsf-admin-accent, #3F4D3A); color: #f4f2ec; }
  .tsf-p3-esc__o--velho{ background: #8a5406; border-color: #8a5406; color: #fff; }
  .tsf-p3-esc__all{ font-weight: 600; letter-spacing: .04em; color: var(--tsf-admin-accent, #3F4D3A); border-style: dashed; }
  .tsf-p3-obras{ display: grid; grid-template-columns: repeat(auto-fill, minmax(210px, 1fr)); gap: 10px; }
  .tsf-p3-obra{ position: relative; aspect-ratio: 16 / 10; border-radius: 12px; overflow: hidden;
    text-decoration: none; background: #141312; isolation: isolate; transition: translate .2s ease, box-shadow .2s ease; }
  .tsf-p3-obra:hover{ translate: 0 -2px; box-shadow: 0 8px 20px rgba(26,25,24,.14); }
  .tsf-p3-obra:focus-visible{ outline: 2px solid var(--tsf-admin-accent, #3F4D3A); outline-offset: 2px; }
  .tsf-p3-obra img{ position: absolute; inset: 0; inline-size: 100%; block-size: 100%; object-fit: cover; }
  .tsf-p3-obra__veu{ position: absolute; inset: 0; background: linear-gradient(180deg, rgba(20,19,18,0) 40%, rgba(20,19,18,.78) 100%); }
  .tsf-p3-obra__id{ position: absolute; inset-block-end: 10px; inset-inline: 12px; display: flex; flex-direction: column; gap: 2px; }
  .tsf-p3-obra__t{ font: 600 12.5px/1.3 var(--font-body-family, sans-serif); color: #fff; }
  .tsf-p3-obra__ir{ font: 400 10px/1 var(--font-body-family, sans-serif); color: #cfd8c8; }
  .tsf-p3-chap--bast{ border-style: dashed; }
  .tsf-p3-ridx{ display: flex; align-items: baseline; gap: 8px; margin: 13px 2px 4px; }
  .tsf-p3-ridx:first-child{ margin-block-start: 2px; }
  .tsf-p3-ridx__rom{ font: italic 500 15px/1 var(--tsf-font-serif, 'Cormorant Garamond', serif); color: var(--tsf-admin-accent, #3F4D3A); min-inline-size: 16px; }
  .tsf-p3-ridx__cap{ font: 600 9.5px/1 var(--font-body-family, sans-serif); letter-spacing: .14em; text-transform: uppercase; color: var(--tsf-text-dim, #a8a299); }
  .tsf-p3-ridx--ok .tsf-p3-ridx__cap{ color: var(--tsf-admin-accent, #3F4D3A); }
  @media (max-width: 749px){
    .tsf-p3-mat{ grid-template-columns: repeat(2, minmax(0, 1fr)); }
    .tsf-p3-chap::after{ font-size: 20px; }
    .tsf-p3-mat--todos{ max-block-size: 380px; }
  }
  @media (prefers-reduced-motion: reduce){
    .tsf-p3-mat__cel, .tsf-p3-obra, .tsf-p3-mat__acao{ transition: none; }
  }
`;
      document.head.appendChild(el);
    }

    #currentValues() {
      const f = this.#atelier.fields;
      const get = (k) => { const el = this.querySelector(`[data-field="${k}"]`); return el ? el.value : (f[k] || ''); };
      const list = (k) => {
        const el = this.querySelector(`[data-field="${k}"]`);
        const raw = el ? el.value : this.#listToText(f[k]);
        return String(raw).split(/[,\n]/).map((s) => s.trim()).filter(Boolean);
      };
      const histEl = this.querySelector('[data-rich="bio_editorial"]');
      const historia = histEl ? histEl.value : this.#richToText(f.bio_editorial);
      return {
        nome: this.#atelier.nome,
        bio_curta: get('bio_curta'),
        vipex: get('vipex_origem'),
        prazo: get('prazo_producao_dias'),
        garantia: get('garantia_meses'),
        materiais: list('materiais_caracteristicos'),
        capaUrl: (this.#midiaRef(this.#atelier.refs?.imagem_capa) || {}).url || null,
        historia,
        produtos: (this.#atelier.produtos || []).slice(0, 8),
      };
    }

    #previewHtml(v) {
      const esc = tsfAcvEsc;
      const heroCls = v.capaUrl ? '' : 'tsf-prev__hero--empty';
      const heroInner = v.capaUrl
        ? `<img class="tsf-prev__hero-img" src="${esc(v.capaUrl)}" alt="">`
        : `<div class="tsf-prev__hero-init">${esc(String(v.nome || '?').slice(0, 1).toUpperCase())}</div>`;
      const bio = v.bio_curta ? `<p class="tsf-prev__bio">${esc(v.bio_curta)}</p>` : '';
      const stat = (label, val) => val ? `<div><span class="tsf-prev__stat-label">${label}</span><span class="tsf-prev__stat-val">${esc(val)}</span></div>` : '';
      const stats = [
        stat('Produção', v.prazo ? `${v.prazo}d` : ''),
        stat('Garantia', v.garantia ? `${v.garantia} ${String(v.garantia) === '1' ? 'mês' : 'meses'}` : ''),
        stat('Origem', v.vipex),
      ].join('');
      const handle = new URLSearchParams(location.search).get('handle') || '';
      const liveUrl = handle ? `/pages/atelie?handle=${encodeURIComponent(handle)}` : '/pages/atelies';
      return `
        <div class="tsf-prev__hero ${heroCls}">
          ${heroInner}
          <div class="tsf-prev__scrim"></div>
          <div class="tsf-prev__hero-body">
            <div class="tsf-prev__eyebrow">Ateliê · apresentado pela Toth</div>
            <div class="tsf-prev__name">${esc(v.nome || 'Ateliê')}</div>
            ${bio}
          </div>
        </div>
        <div class="tsf-prev__body">
          ${stats ? `<div class="tsf-prev__stats">${stats}</div>` : ''}
          <a class="tsf-prev__live" href="${liveUrl}" target="_blank" rel="noopener">Ver página completa ao vivo ↗</a>
          <p class="tsf-prev__live-hint">A prévia acompanha a edição. O botão abre a página real — A Visita completa, capítulo por capítulo, exatamente como o cliente vê.</p>
        </div>`;
    }

    #syncPreview() {
      const el = this.querySelector('[data-preview]');
      if (el) el.innerHTML = this.#previewHtml(this.#currentValues());
    }

    #railItemsHtml() {
      const f = this.#atelier.fields;
      const caps = ['A chegada', 'A história', 'A matéria', 'O olhar', 'A seleção', 'Catálogos & presença', 'O acordo', 'Bastidores'];
      const rom = ['i', 'ii', 'iii', 'iv', 'v', 'vii', 'viii', 'ix'];
      return caps.map((cap, ci) => {
        const its = TSF_STAGE_W.filter(x => (TSF_STEP_META[x[0]] || [])[1] === cap);
        if (!its.length) return '';
        const okAll = its.every(x => tsfStageFilled(f[x[0]]));
        const rows = its.map(x => {
          const m = TSF_STEP_META[x[0]];
          const done = tsfStageFilled(f[x[0]]);
          return `<button type="button" class="tsf-rail__item ${done ? 'tsf-rail__item--ok' : ''}" data-goto="${tsfAcvEsc(m[1])}">
            <span class="tsf-rail__tick">${done ? '✓' : '+' + x[1]}</span>
            <span class="tsf-rail__lbl">${tsfAcvEsc(m[0])}</span>
          </button>`;
        }).join('');
        return `<div class="tsf-p3-ridx${okAll ? ' tsf-p3-ridx--ok' : ''}"><span class="tsf-p3-ridx__rom">${rom[ci]}</span><span class="tsf-p3-ridx__cap">${tsfAcvEsc(cap)}</span></div>` + rows;
      }).join('');
    }

    #refreshChecklist() {
      const f = this.#atelier.fields;
      const tot = TSF_STAGE_W.reduce((s, x) => s + x[1], 0);
      const got = TSF_STAGE_W.reduce((s, x) => s + (tsfStageFilled(f[x[0]]) ? x[1] : 0), 0);
      const score = Math.round(got / tot * 100);
      const st = score >= 70 ? 'vivo' : score >= 25 ? 'esbocado' : 'adormecido';
      const ringEl = this.querySelector('[data-hero-ring]');
      if (ringEl) ringEl.innerHTML = `${tsfAcvRing(score, st, 26)}<div class="tsf-acv-ring__center"><span>${score}</span></div>`;
      const stEl = this.querySelector('[data-hero-state]');
      if (stEl) { stEl.className = `tsf-acv-state tsf-acv-state--${st} tsf-stg2-state`; stEl.textContent = tsfAcvStateLabel(st); }
      const bar = this.querySelector('[data-rail-bar]'); if (bar) bar.style.width = score + '%';
      const pct = this.querySelector('[data-rail-pct]'); if (pct) pct.textContent = score + '%';
      const list = this.querySelector('[data-rail-list]'); if (list) list.innerHTML = this.#railItemsHtml();
    }

    #wireTags() {
      const opts = { signal: this.#abort.signal };
      this.querySelectorAll('[data-tags]').forEach(wrap => {
        const hidden = wrap.querySelector('[data-field]');
        const box = wrap.querySelector('[data-tags-box]');
        const inp = wrap.querySelector('[data-tags-in]');
        if (!hidden || !box || !inp) return;
        const items = () => String(hidden.value).split(/[,\n]/).map(s => s.trim()).filter(Boolean);
        const paint = () => {
          const arr = items();
          box.querySelectorAll('[data-tag-rm]').forEach(b => b.remove());
          arr.forEach(t => {
            const b = document.createElement('button');
            b.type = 'button'; b.className = 'tsf-tags__chip'; b.setAttribute('data-tag-rm', t);
            b.innerHTML = `${tsfAcvEsc(t)}<span aria-hidden="true">✕</span>`;
            box.insertBefore(b, inp);
          });
          inp.placeholder = arr.length ? 'Adicionar…' : 'Digite e aperte Enter';
        };
        const commit = (arr) => { hidden.value = arr.join(', '); hidden.dispatchEvent(new Event('input')); paint(); };
        const addFromInput = () => {
          const t = inp.value.replace(/,+/g, ' ').trim();
          if (!t) { inp.value = ''; return; }
          const arr = items();
          if (!arr.some(x => x.toLowerCase() === t.toLowerCase())) arr.push(t);
          inp.value = '';
          commit(arr);
        };
        inp.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ',') { e.preventDefault(); addFromInput(); }
          else if (e.key === 'Backspace' && !inp.value) { const arr = items(); if (arr.length) { arr.pop(); commit(arr); } }
        }, opts);
        inp.addEventListener('blur', () => addFromInput(), opts);
        box.addEventListener('click', (e) => {
          const chip = e.target.closest('[data-tag-rm]');
          if (chip) { const t = chip.getAttribute('data-tag-rm'); commit(items().filter(x => x !== t)); inp.focus(); }
          else inp.focus();
        }, opts);
      });
    }

    #wireUrlOpens() {
      const opts = { signal: this.#abort.signal };
      this.querySelectorAll('.tsf-stg2-urlwrap').forEach(w => {
        const inp = w.querySelector('input');
        const abrir = w.querySelector('[data-openurl]');
        if (!inp || !abrir) return;
        inp.addEventListener('input', () => {
          const v = inp.value.trim();
          if (v) { abrir.href = this.#normUrl(v); abrir.classList.remove('tsf-stg2-open--off'); }
          else { abrir.href = '#'; abrir.classList.add('tsf-stg2-open--off'); }
        }, opts);
      });
    }

    #render() {
      if (this.#state === 'loading') { this.innerHTML = `<p class="tsf-stage__ro">Abrindo o ateliê…</p>`; return; }
      if (this.#state === 'error') { this.innerHTML = `<a class="tsf-stage__back" href="/pages/admin-ateliers">← Voltar ao Acervo</a><div class="tsf-acv__err"><p>${tsfAcvEsc(this.#error)}</p></div>`; return; }
      const a = this.#atelier;
      const f = a.fields;
      const tot = TSF_STAGE_W.reduce((t, x) => t + x[1], 0);
      const got = TSF_STAGE_W.reduce((t, x) => t + (tsfStageFilled(f[x[0]]) ? x[1] : 0), 0);
      const score = Math.round(got / tot * 100);
      const st = score >= 70 ? 'vivo' : score >= 25 ? 'esbocado' : 'adormecido';
      const capaM = this.#midiaRef(a.refs?.imagem_capa);
      const capaV = this.#midiaRef(a.refs?.capa_vertical);
      const filmeInst = this.#midiaRef(a.refs?.video_institucional);
      const capa = capaM ? capaM.url : null;
      const logo = a.refs?.logo?.image?.url;
      const tiers = ['comunidade', 'gold', 'black'];
      let curTiers = []; try { curTiers = JSON.parse(f.tier_acesso || '[]'); } catch { curTiers = []; }
      const pub = a.status === 'ACTIVE';
      const semPreco = String(f.hide_price_default) === 'true';
      const nMidia = ['fotos_ambientadas', 'fotos_fabrica'].reduce((t, k) => { try { const x = JSON.parse(f[k] || '[]'); return t + (Array.isArray(x) ? x.length : 0); } catch { return t; } }, 0)
        + (a.videos || []).length + (a.videosAmbientados || []).length;

      this.innerHTML = `
        <a class="tsf-stage__back" href="/pages/admin-ateliers">← Voltar ao Acervo</a>

        <div class="tsf-stg2-hero ${capa ? '' : 'tsf-stg2-hero--flat'}">
          ${capa ? `<img class="tsf-stg2-hero__bg" src="${tsfAcvEsc(capa)}" alt="">` : ''}
          <div class="tsf-stg2-hero__scrim"></div>
          <div class="tsf-stg2-hero__inner">
            <div class="tsf-stg2-hero__id">
              <div class="tsf-acv-ringwrap tsf-stg2-hero__ring" data-hero-ring>${tsfAcvRing(score, st, 26)}<div class="tsf-acv-ring__center"><span>${score}</span></div></div>
              <div class="tsf-stg2-hero__txt">
                <span class="tsf-stg2-hero__eyebrow">O Palco · o espelho da página</span>
                <h1 class="tsf-stg2-hero__name">${tsfAcvEsc(a.nome)}</h1>
                <div class="tsf-stg2-hero__meta">
                  <span class="tsf-acv-state tsf-acv-state--${st} tsf-stg2-state" data-hero-state>${tsfAcvStateLabel(st)}</span>
                  <label class="tsf-switch tsf-switch--hero"><input type="checkbox" data-pub ${pub ? 'checked' : ''}><span class="tsf-switch__track"></span><span class="tsf-switch__lbl">No acervo</span></label>
                  <span class="tsf-stage__save tsf-stg2-save" data-save></span>
                </div>
              </div>
            </div>
            <div class="tsf-stg2-hero__actions">
              ${logo ? `<span class="tsf-stg2-hero__logo"><img src="${tsfAcvEsc(logo)}" alt=""></span>` : ''}
              <a class="tsf-stg2-live" href="/pages/atelie?handle=${encodeURIComponent(this.#handle)}" target="_blank" rel="noopener">Ver a página ao vivo ↗</a>
            </div>
          </div>
        </div>

        <div class="tsf-stg2-split">
          <div class="tsf-stg2-cards">

            <section class="tsf-stage__sec tsf-stg2-card tsf-stg2-card--full tsf-p3-chap" data-folio="i">
              <h2 class="tsf-stage__sec-title">${TSF_STG_ICO.cheg}A chegada</h2>
              <p class="tsf-p3-eco">O primeiro segundo da página. Com filme, a chegada é uma cascata de cinema; sem filme, a capa vira o palco; sem os dois, as próprias peças abrem a casa. O logo assina o hero.</p>
              <div class="tsf-telas">
                <div class="tsf-tela${capaM ? ' tsf-tela--ok' : ''}">
                  <p class="tsf-tela__cab"><svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><rect x="2.5" y="4" width="19" height="13" rx="2" stroke="currentColor" stroke-width="1.6"/><path d="M8 20h8" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>No computador</p>
                  ${this.#uploadZone('imagem_capa', 'Capa deitada', capa, 'midia', capaM && capaM.video, 'h')}
                  <p class="tsf-tela__nota">${capaM ? (capaM.video ? 'Abre com o filme rodando, tela cheia.' : 'Abre com esta foto em movimento lento.') : 'Sem capa: abre com as próprias peças da casa.'}</p>
                </div>
                <div class="tsf-tela${capaV ? ' tsf-tela--ok' : ''}">
                  <p class="tsf-tela__cab"><svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><rect x="6.5" y="2.5" width="11" height="19" rx="2.5" stroke="currentColor" stroke-width="1.6"/><path d="M11 18.5h2" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>No celular</p>
                  ${this.#uploadZone('capa_vertical', 'Capa em pé', capaV ? capaV.url : null, 'midia', capaV && capaV.video, 'v')}
                  <p class="tsf-tela__nota">${capaV ? (capaV.video ? 'Filme em pé, tela cheia — o formato que prende.' : 'Foto em pé, tela cheia.') : (capaM ? '<b>Hoje o celular corta a deitada.</b> Uma peça em pé ocupa a tela inteira.' : 'Sem capa: abre com as próprias peças.')}</p>
                </div>
              </div>
              <div class="tsf-stage__uploads tsf-stage__uploads--menores">
                ${this.#uploadZone('logo', 'Logo', logo, 'image')}
                ${this.#uploadZone('video_institucional', 'Filme do ateliê', filmeInst ? filmeInst.url : null, 'video', !!filmeInst)}
              </div>
              <p class="tsf-stage__hint">Cada tela recebe a sua: as duas aceitam <b>foto ou vídeo</b>. <b>Foto até 25MB · vídeo até 200MB.</b> O envio mostra a porcentagem; depois o Shopify leva alguns minutos processando o filme antes de ele aparecer.</p>
            </section>

            <section class="tsf-stage__sec tsf-stg2-card tsf-stg2-card--full tsf-p3-chap" data-folio="ii">
              <h2 class="tsf-stage__sec-title">${TSF_STG_ICO.hist}A história</h2>
              <p class="tsf-p3-eco">O texto vira o capítulo "A história"; os materiais, estilos e tipos viram os selos d'"O ofício" logo abaixo dele.</p>
              <div class="tsf-stage__field">
                <label class="tsf-stage__label">A história do ateliê</label>
                <textarea data-rich="bio_editorial" rows="7" placeholder="Conte a origem, o ofício, o que torna este ateliê único. Separe parágrafos com uma linha em branco.">${tsfAcvEsc(this.#richToText(f.bio_editorial))}</textarea>
              </div>
              ${this.#field('Apresentação curta', 'bio_curta', 'textarea', 'Uma ou duas frases — aparece sob o nome, no hero da página.')}
              <div class="tsf-p3-eti">O ofício <em>· os selos sob a história</em></div>
              ${this.#field('Materiais característicos', 'materiais_caracteristicos', 'list', 'Ex: Madeira maciça, Couro natural, Latão')}
              ${this.#field('Estilos', 'estilos', 'list', 'Ex: Contemporâneo, Orgânico')}
              ${this.#field('Tipos de produtos', 'tipos_de_produtos', 'list', 'Ex: Sofás, Mesas, Poltronas')}
            </section>

            <section class="tsf-stage__sec tsf-stg2-card tsf-stg2-card--full tsf-p3-chap" data-folio="iii">
              <h2 class="tsf-stage__sec-title">${TSF_STG_ICO.mat}A matéria</h2>
              <p class="tsf-p3-eco">A parede de texturas de borda a borda. Cada grupo escolhido vira um painel que abre ao toque; as variações são a gaveta de amostras — clicar troca a amostra com a imagem grande. <b data-mat-conta>${this.#matContaTxt()}</b></p>
              <div class="tsf-p3-eti">Na parede <em>· na ordem em que aparecem</em></div>
              <div class="tsf-p3-mat" data-mat-parede>${this.#matParedeHtml()}</div>
              <div class="tsf-p3-eti">Os grupos desta casa <em>· toque para pôr na parede</em></div>
              <input type="search" class="tsf-p3-busca" data-mat-q placeholder="Buscar grupo da casa pelo nome…" autocomplete="off">
              <div class="tsf-p3-mat tsf-p3-mat--todos" data-mat-livres>${this.#matLivresHtml()}</div>
            </section>

            <section class="tsf-stage__sec tsf-stg2-card tsf-stg2-card--full tsf-p3-chap" data-folio="iv">
              <h2 class="tsf-stage__sec-title">${TSF_STG_ICO.olho}O olhar</h2>
              <p class="tsf-p3-eco">Um único trilho de cinema — fotos e filmes lado a lado, cada um com sua etiqueta, nesta ordem. Hoje: <b>${nMidia}</b> ${nMidia === 1 ? 'item' : 'itens'} no trilho.</p>
              <div class="tsf-p3-eti">Ambiente <em>· as peças em projetos reais</em></div>
              ${this.#gallery('fotos_ambientadas', 'Fotos ambientadas')}
              <div class="tsf-p3-eti">Em cena <em>· filmes das peças ambientadas</em></div>
              ${this.#videoAmbGalleryHtml()}
              <div class="tsf-p3-eti">Na fábrica <em>· o lugar e as mãos</em></div>
              ${this.#gallery('fotos_fabrica', 'Fotos da fábrica')}
              <div class="tsf-p3-eti">O processo <em>· filmes do ofício acontecendo</em></div>
              ${this.#videoGalleryHtml()}
              <p class="tsf-stage__hint">Vídeos até 20MB cada — rodam mudos, em loop, na altura das fotos.</p>
            </section>

            <section class="tsf-stage__sec tsf-stg2-card tsf-stg2-card--full tsf-p3-chap" data-folio="v">
              <h2 class="tsf-stage__sec-title">${TSF_STG_ICO.prod}A seleção</h2>
              <p class="tsf-p3-eco">As pranchas numeradas. As suas escolhas abrem o trilho; a busca da loja completa sozinha com até 10 peças do ateliê, e o selo conta o catálogo.</p>
              <div class="tsf-stage__prodgrid" data-produtos-grid>${this.#produtosGridHtml()}</div>
              <label class="tsf-switch" style="margin-block-start:14px">
                <input type="checkbox" data-priceoff ${semPreco ? 'checked' : ''}>
                <span class="tsf-switch__track"></span>
                <span class="tsf-switch__lbl"><b>Preço sob consulta</b> — esconde os preços das pranchas desta casa</span>
              </label>
            </section>

            <section class="tsf-stage__sec tsf-stg2-card tsf-stg2-card--full tsf-p3-chap" data-folio="vi">
              <h2 class="tsf-stage__sec-title">${TSF_STG_ICO.obra}Em campo</h2>
              <p class="tsf-p3-eco">Capítulo automático — os projetos do acervo Toth que levam peças desta casa.</p>
              ${this.#obrasHtml()}
            </section>

            <section class="tsf-stage__sec tsf-stg2-card tsf-p3-chap" data-folio="vii">
              <h2 class="tsf-stage__sec-title">${TSF_STG_ICO.pres}Catálogos &amp; presença</h2>
              <p class="tsf-p3-eco">Os dois links viram os cards de "Material técnico" no fim da página.</p>
              ${this.#field('Catálogo de produtos (link)', 'catalogo_url', 'url', 'Linha completa do ateliê.')}
              ${this.#field('Catálogo de acabamentos (link)', 'acabamentos_url', 'url', 'Cores e texturas.')}
              <div class="tsf-p3-eti">Presença <em>· alimenta o hub da Comunidade</em></div>
              ${this.#field('Instagram', 'instagram', 'url')}
              ${this.#field('Site oficial', 'site_oficial', 'url')}
            </section>

            <section class="tsf-stage__sec tsf-stg2-card tsf-p3-chap" data-folio="viii">
              <h2 class="tsf-stage__sec-title">${TSF_STG_ICO.op}O acordo</h2>
              <p class="tsf-p3-eco">Os números grandes que fecham a página — a promessa da casa.</p>
              ${this.#field('Prazo de produção', 'prazo_producao_dias', 'number', null, 'dias')}
              ${this.#field('Garantia', 'garantia_meses', 'number', null, 'meses')}
              ${this.#field('Regiões de entrega', 'regioes_entrega', 'list', 'Ex: Sudeste, Sul, Brasil inteiro.')}
            </section>

            <section class="tsf-stage__sec tsf-stg2-card tsf-p3-chap tsf-p3-chap--bast" data-folio="ix">
              <h2 class="tsf-stage__sec-title">${TSF_STG_ICO.com}Bastidores</h2>
              <p class="tsf-p3-eco">Só o time vê — visibilidade no hub da Comunidade e origem.</p>
              <div class="tsf-stage__field">
                <label class="tsf-stage__label">Quem vê este ateliê</label>
                <div class="tsf-stage__tiers">
                  ${tiers.map(t => { const soon = t !== 'comunidade'; return `<label class="tsf-stage__tier${soon ? ' tsf-stage__tier--soon' : ''}"><input type="checkbox" data-tier="${t}" ${curTiers.includes(t) ? 'checked' : ''}> ${t.charAt(0).toUpperCase() + t.slice(1)}${soon ? '<span class="tsf-soon">em breve</span>' : ''}</label>`; }).join('')}
                </div>
                <p class="tsf-stage__hint">Gold e Black são os futuros planos pagos — por enquanto, deixe só "Comunidade".</p>
              </div>
              <label class="tsf-switch">
                <input type="checkbox" data-destaque ${f.destaque_specifica === 'true' ? 'checked' : ''}>
                <span class="tsf-switch__track"></span>
                <span class="tsf-switch__lbl"><b>Destaque no Acervo</b> — aparece primeiro, com estrela, no hub da Comunidade</span>
              </label>
              <div class="tsf-sync-note" data-sync-note></div>
              ${this.#field('Origem (VIPEX)', 'vipex_origem', 'text')}
            </section>
          </div>

          <aside class="tsf-stg2-rail">
            <div class="tsf-stg2-railcard">
              <p class="tsf-stg2-rail__eyebrow">A página · espelho vivo</p>
              <div class="tsf-prev" data-preview>${this.#previewHtml(this.#currentValues())}</div>
            </div>
            <div class="tsf-stg2-railcard">
              <p class="tsf-stg2-rail__eyebrow">O índice da visita</p>
              <div class="tsf-rail__prog"><div class="tsf-rail__bar"><i data-rail-bar style="width:${score}%"></i></div><span class="tsf-rail__pct" data-rail-pct>${score}%</span></div>
              <div class="tsf-rail__list" data-rail-list>${this.#railItemsHtml()}</div>
            </div>
          </aside>
        </div>
      `;

      const opts = { signal: this.#abort.signal };
      this.querySelectorAll('[data-field]').forEach(inp => {
        inp.addEventListener('input', () => {
          const key = inp.getAttribute('data-field');
          const kind = inp.getAttribute('data-kind');
          const value = kind === 'list' ? this.#textToList(inp.value) : kind === 'url' ? this.#normUrl(inp.value) : inp.value;
          this.#queueSave(key, value);
          this.#atelier.fields[key] = value;
          this.#syncPreview();
          this.#refreshChecklist();
        }, opts);
      });
      this.querySelectorAll('[data-tier]').forEach(cb => {
        cb.addEventListener('change', () => {
          const chosen = [...this.querySelectorAll('[data-tier]')].filter(c => c.checked).map(c => c.getAttribute('data-tier'));
          const val = JSON.stringify(chosen);
          this.#queueSave('tier_acesso', val);
          this.#atelier.fields.tier_acesso = val;
          this.#syncNote();
          this.#refreshChecklist();
        }, opts);
      });
      this.querySelector('[data-destaque]')?.addEventListener('change', (e) => {
        this.#queueSave('destaque_specifica', e.target.checked ? 'true' : 'false');
        this.#atelier.fields.destaque_specifica = e.target.checked ? 'true' : 'false';
        this.#syncNote();
      }, opts);
      this.querySelector('[data-priceoff]')?.addEventListener('change', (e) => {
        const v = e.target.checked ? 'true' : 'false';
        this.#queueSave('hide_price_default', v);
        this.#atelier.fields.hide_price_default = v;
        this.#setSave('ok', e.target.checked ? 'Preços escondidos nesta casa' : 'Preços visíveis nesta casa');
      }, opts);
      this.querySelector('[data-pub]')?.addEventListener('change', (e) => this.#togglePublish(e.target.checked), opts);
      this.#syncNote();
      this.querySelectorAll('[data-upfile]').forEach((inp) => {
        inp.addEventListener('change', (e) => {
          const file = e.target.files && e.target.files[0];
          if (file) this.#uploadAsset(inp.getAttribute('data-upfile'), file);
        }, opts);
      });
      const histInp = this.querySelector('[data-rich="bio_editorial"]');
      if (histInp) histInp.addEventListener('input', () => {
        const rich = this.#textToRich(histInp.value);
        this.#queueSave('bio_editorial', rich);
        this.#atelier.fields.bio_editorial = rich;
        this.#syncPreview();
        this.#refreshChecklist();
      }, opts);
      this.querySelectorAll('[data-esc]').forEach((box) => {
        const key = box.getAttribute('data-esc');
        const leia = () => [...box.querySelectorAll('[data-esc-v].is-on')].map(b => b.getAttribute('data-esc-v'));
        const grava = () => {
          const val = JSON.stringify(leia());
          this.#atelier.fields[key] = val;
          this.#queueSave(key, val);
          this.#syncPreview();
          this.#refreshChecklist();
        };
        box.addEventListener('click', (e) => {
          const all = e.target.closest('[data-esc-all]');
          if (all) {
            const ligar = leia().length < box.querySelectorAll('[data-esc-v]').length;
            box.querySelectorAll('[data-esc-v]').forEach(b => {
              b.classList.toggle('is-on', ligar);
              b.setAttribute('aria-pressed', ligar ? 'true' : 'false');
            });
            all.textContent = ligar ? 'Limpar' : 'Brasil inteiro';
            grava(); return;
          }
          const b = e.target.closest('[data-esc-v]');
          if (!b) return;
          const on = !b.classList.contains('is-on');
          b.classList.toggle('is-on', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
          if (!on && b.classList.contains('tsf-p3-esc__o--velho')) b.remove();
          grava();
        }, opts);
      });
      const matQ = this.querySelector('[data-mat-q]');
      if (matQ) { let tq; matQ.addEventListener('input', () => { clearTimeout(tq); tq = setTimeout(() => { this.#matQ = matQ.value; const l = this.querySelector('[data-mat-livres]'); if (l) l.innerHTML = this.#matLivresHtml(); }, 140); }, opts); }
      if (!this.#gotoWired) {
        this.#gotoWired = true;
        this.addEventListener('click', (e) => {
          const mt = e.target.closest('[data-mat-toggle]');
          if (mt) { this.#toggleMateria(mt.getAttribute('data-mat-toggle')); return; }
          const b = e.target.closest('[data-goto]');
          if (!b) return;
          const alvo = b.getAttribute('data-goto');
          const sec = [...this.querySelectorAll('.tsf-stage__sec-title')].find(h => h.textContent.trim() === alvo)?.closest('section');
          if (!sec) return;
          sec.scrollIntoView({ behavior: 'smooth', block: 'start' });
          sec.classList.remove('tsf-sec-flash'); void sec.offsetWidth; sec.classList.add('tsf-sec-flash');
        }, { signal: this.#abort.signal });
      }
      this.#wireTags();
      this.#wireUrlOpens();
      this.#refreshProdutos();
      this.#wireVideos();
      this.#wireVideosAmb();
      this.querySelectorAll('[data-galfile]').forEach((inp) => {
        inp.addEventListener('change', (e) => { if (e.target.files && e.target.files.length) this.#uploadGallery(inp.getAttribute('data-galfile'), e.target.files); }, opts);
      });
      this.querySelectorAll('[data-gal-rm]').forEach((b) => {
        b.addEventListener('click', () => this.#removeFromGallery(b.getAttribute('data-gal-rm'), b.getAttribute('data-gal-gid')), opts);
      });
    }
  }

  class TsfDemandCockpit extends HTMLElement {
    #abort = null;
    #signals = null;
    #state = 'loading';
    #error = '';
    #open = {};

    async connectedCallback() {
      this.#abort = new AbortController();
      tsfAcvInjectStyles();
      this.classList.add('tsf-acv');
      this.#render();
      await this.#fetch();
    }
    disconnectedCallback() { this.#abort?.abort(); }

    async #fetch() {
      this.#state = 'loading'; this.#render();
      try {
        const res = await fetch(`${ACERVO_ENDPOINT}/demand`, { signal: this.#abort.signal });
        const d = await res.json();
        if (!d.ok) throw new Error(d.error || 'falha ao carregar a demanda');
        this.#signals = d.signals || [];
        // 02-08 · o card precisa contar O QUE DÁ PRA FAZER. O agregado /demand
        // discordava da lista (dizia 142 e abria 0; dizia 31 e listava 40) e
        // mandava vip/hot sempre zerados. Buscando as pessoas aqui, o número do
        // card e a lista saem da MESMA fonte — não existe contrato pra desalinhar.
        await Promise.all(this.#signals.map(async (s) => {
          try {
            const r = await fetch(`${ACERVO_ENDPOINT}/demand?who=${encodeURIComponent(s.key)}`, { signal: this.#abort.signal });
            const j = await r.json();
            s._people = j.people || [];
          } catch { s._people = null; }   // null = não consegui apurar (≠ vazio)
          if (s._people) {
            s._chamaveis = s._people.filter((p) => p && p.phone).length;
            s._semtel = s._people.length - s._chamaveis;
            s._vip = s._people.filter((p) => String(p.valor || '').includes('vip')).length;
            s._hot = s._people.filter((p) => String(p.atividade || '') === 'hot').length;
          }
        }));
        this.#state = 'ready';
      } catch (err) { if (err.name === 'AbortError') return; this.#state = 'error'; this.#error = err.message || 'erro'; }
      this.#render();
    }

    async #loadWho(tag, card) {
      const box = card.querySelector('[data-who]');
      const btn = card.querySelector('[data-whobtn]');
      if (this.#open[tag]) { delete this.#open[tag]; box.innerHTML = ''; box.hidden = true; btn.textContent = 'Ver quem ↓'; return; }
      box.hidden = false; box.innerHTML = '<p class="tsf-cock__hint">Buscando…</p>';
      try {
        const res = await fetch(`${ACERVO_ENDPOINT}/demand?who=${encodeURIComponent(tag)}`, { signal: this.#abort.signal });
        const d = await res.json();
        const people = d.people || [];
        this.#open[tag] = people;
        box.innerHTML = people.length ? people.map((p) => this.#person(p)).join('') : '<p class="tsf-cock__hint">Sem clientes listáveis.</p>';
        btn.textContent = 'Esconder ↑';
      } catch (err) { if (err.name === 'AbortError') return; box.innerHTML = '<p class="tsf-cock__hint">Erro ao buscar.</p>'; }
    }

    #person(p) {
      const digits = String(p.phone || '').replace(/\D/g, '');
      const wa = digits ? (digits.length <= 11 ? '55' + digits : digits) : '';
      const chips = [p.valor && `valor:${p.valor}`, p.atividade && `atividade:${p.atividade}`].filter(Boolean)
        .map((c) => `<span class="tsf-cock__chip">${tsfAcvEsc(c)}</span>`).join('');
      const cta = wa
        ? `<a class="tsf-cock__wa" href="https://wa.me/${wa}?text=${encodeURIComponent('Olá ' + (p.nome || '') + ', tudo bem? Sou da Toth Móveis.')}" target="_blank" rel="noopener">WhatsApp</a>`
        : `<span class="tsf-cock__nophone">sem telefone</span>`;
      return `<div class="tsf-cock__person"><div><strong>${tsfAcvEsc(p.nome)}</strong>${chips ? `<div class="tsf-cock__chips">${chips}</div>` : ''}</div>${cta}</div>`;
    }

    #render() {
      // 02-08 · era um segundo <h1> no meio da página (46px Montserrat), competindo
      // com o título real. Rebaixado a SEÇÃO do padrão do admin.
      const head = `<header class="tsf-acv__head tsfsec__head"><div>
        <span class="tsfsec__eyebrow">Cockpit de Demanda</span>
        <h2 class="tsf-acv__title tsfsec__title">Sinais de Demanda</h2>
        <p class="tsf-acv__lede">Clientes que demonstraram interesse e ainda não foram chamados. O dado vira conversa — o humano fecha no WhatsApp.</p>
      </div></header>`;
      let content = '';
      if (this.#state === 'loading') {
        content = `<div class="tsf-cock__grid">${Array.from({ length: 4 }).map(() => '<div class="tsf-cock__card"><div class="tsf-acv-skel" style="height:64px;border-radius:8px"></div></div>').join('')}</div>`;
      } else if (this.#state === 'error') {
        content = `<div class="tsf-acv__err"><p>Não consegui ler os sinais.<br><small>${tsfAcvEsc(this.#error)}</small></p></div>`;
      } else {
        const sigs = this.#signals || [];
        const totalLeads = sigs.reduce((a, s) => a + (s.total || 0), 0);
        // 02-08 · antes dizia "504 sinais · priorize vip e ativos" — volume, não decisão.
        // O número que muda o dia é quantos viram CONVERSA, e o que trava o resto.
        const chamaveis = sigs.reduce((a, s) => a + (s._chamaveis || 0), 0);
        const travados = sigs.reduce((a, s) => a + (s._people ? (s._semtel || 0) : 0), 0);
        content = `<p class="tsf-cock__intro">${totalLeads} sinais registrados${
          chamaveis || travados
            ? ` — mas só <strong>${chamaveis}</strong> ${chamaveis === 1 ? 'vira' : 'viram'} conversa hoje.` +
              (travados ? ` <strong class="tsf-cock__gap">${travados} ${travados === 1 ? 'pessoa demonstrou interesse e não deixou' : 'pessoas demonstraram interesse e não deixaram'} telefone</strong> — é aí que está o maior ganho.` : '')
            : '.'
        }</p>
          <div class="tsf-cock__grid">${sigs.map((s) => `
          <div class="tsf-cock__card" data-sig="${s.key}">
            <div class="tsf-cock__num">${s._people ? s._chamaveis : s.total}</div>
            <div class="tsf-cock__label">${tsfAcvEsc(s.label)}</div>
            <div class="tsf-cock__sub">${!s._people
              ? 'não consegui apurar'
              : s._people.length === 0
                ? 'sem sinais ainda'
                : s._chamaveis === 0
                  ? `<span class="tsf-cock__gap">ninguém deixou telefone</span> · ${s._people.length} ${s._people.length === 1 ? 'pessoa parada' : 'pessoas paradas'}`
                  : `${s._chamaveis === 1 ? 'pessoa com telefone' : 'pessoas com telefone'}, de ${s._people.length}` +
                    (s._semtel ? ` · <span class="tsf-cock__gap">${s._semtel} sem</span>` : '')}</div>
            ${(s._people ? s._people.length : s.total) > 0 ? `<button type="button" class="tsf-cock__whobtn" data-whobtn data-tag="${tsfAcvEsc(s.key)}">Ver quem ↓</button>` : ''}
            <div class="tsf-cock__who" data-who hidden></div>
          </div>`).join('')}</div>`;
      }
      this.innerHTML = head + content;
      const opts = { signal: this.#abort.signal };
      this.querySelectorAll('[data-whobtn]').forEach((b) => b.addEventListener('click', () => this.#loadWho(b.getAttribute('data-tag'), b.closest('.tsf-cock__card')), opts));
    }
  }

  /* ════════════════════════════════════════════════════════════════════
     VIKTOR · Dashboard de inteligência comercial (Fase 0)
     Lê /sale/list + /quote/list do toth-checkout já-pronto.
     Read-only, sem backend novo.
     ════════════════════════════════════════════════════════════════════ */

  const TSF_VIKTOR_CSS = `
    .tsf-vik { color:var(--tsf-text-strong,#2a2723); }

    /* ── Header (alinhado ao padrão tsf-acv__head do DemandCockpit) ── */
    .tsf-vik__head { padding-block-end:22px; margin-block-end:28px; border-block-end:1px solid var(--tsf-border,#e7e3dc); }
    .tsf-vik__eyebrow { font-size:11px; font-weight:600; letter-spacing:.22em; text-transform:uppercase; color:var(--tsf-gold-ink,#8a5406); }
    .tsf-vik__title { font-family:var(--font-heading-family,'Montserrat',sans-serif); font-size:clamp(28px,3.8vw,42px); font-weight:300; letter-spacing:-0.02em; line-height:1.08; margin:6px 0 8px; color:var(--tsf-text-strong,#2a2723); }
    .tsf-vik__lede { font-size:14px; line-height:1.5; color:var(--tsf-text-muted,#7a746c); max-inline-size:58ch; margin:0; }

    /* ── Period filter ── */
    .tsf-vik__period { margin-bottom:32px; }

    /* ── KPI cards grid ── */
    .tsf-vik__grid { display:grid; grid-template-columns:repeat(auto-fit,minmax(180px,1fr)); gap:18px; margin-bottom:36px; }
    .tsf-vik__card { background:#fff; border:1px solid var(--tsf-border,#e7e3dc); border-radius:16px; padding:22px 20px 20px;
      transition:transform .4s var(--ease-luxury,ease), box-shadow .4s var(--ease-luxury,ease), border-color .4s var(--ease-luxury,ease); }
    .tsf-vik__card:hover { transform:translateY(-3px); box-shadow:0 14px 36px -18px rgba(40,40,40,.12); border-color:var(--gold-accent,#A16207); }
    .tsf-vik__card-label { font-size:10.5px; font-weight:600; text-transform:uppercase; letter-spacing:.18em; color:var(--tsf-text-dim,#a8a299); margin-bottom:10px; }
    .tsf-vik__card-value { font-family:var(--font-heading-family,'Montserrat',sans-serif); font-size:36px; font-weight:300; color:var(--tsf-text-strong,#2a2723); line-height:1; letter-spacing:-0.02em; }
    .tsf-vik__card-sub { font-size:12px; color:var(--tsf-text-muted,#7a746c); margin-top:8px; }
    .tsf-vik__card--hero .tsf-vik__card-value { font-size:42px; color:var(--gold-accent,#A16207); }
    .tsf-vik__card--hero { border-color:var(--gold-accent,#A16207); border-width:1px 1px 1px 3px; }

    /* ── Sections ── */
    .tsf-vik__section { margin-bottom:36px; min-inline-size:0; } /* 02-08 · 1fr = minmax(AUTO,1fr): a coluna nao encolhe abaixo do min-content do filho, entao nome longo de produto estourava o grid (886+697 num container de 1184). minmax(0,1fr) + min-inline-size:0 e o remedio. O defeito era latente: so apareceu quando o padrao de periodo passou a trazer dado real. */
    .tsf-vik__section-eyebrow { font-size:10.5px; font-weight:600; text-transform:uppercase; letter-spacing:.22em; color:var(--tsf-gold-ink,#8a5406); margin-bottom:6px; }
    .tsf-vik__section-title { font-family:var(--font-heading-family,'Montserrat',sans-serif); font-size:22px; font-weight:400; letter-spacing:-0.01em; color:var(--tsf-text-strong,#2a2723); margin:0 0 18px; }
    .tsf-vik__two-col { display:grid; grid-template-columns:minmax(0,1fr) minmax(0,1fr); gap:var(--tsf-sp-4,16px); margin-bottom:36px; }
    @media (max-width:680px) { .tsf-vik__two-col { grid-template-columns:1fr; } }

    /* ── Box (card de seção) ── */
    .tsf-vik__box { background:#fff; border:1px solid var(--tsf-border,#e7e3dc); border-radius:16px; padding:22px 20px 20px; }

    /* ── Stat rows ── */
    .tsf-vik__stat-row { display:flex; justify-content:space-between; align-items:baseline; padding:10px 0; border-bottom:1px solid var(--warm-sand,#f3f1ed); }
    .tsf-vik__stat-row:last-child { border-bottom:none; }
    .tsf-vik__stat-label { font-size:13px; color:var(--tsf-text-muted,#7a746c); }
    .tsf-vik__stat-value { font-size:14px; font-weight:600; color:var(--tsf-text-strong,#2a2723); }
    .tsf-vik__stat-value--gold { color:var(--gold-accent,#A16207); font-weight:600; }

    /* ── Progress bar ── */
    .tsf-vik__bar { height:6px; border-radius:999px; background:var(--warm-sand,#f3f1ed); margin-top:14px; overflow:hidden; }
    .tsf-vik__bar-fill { height:100%; border-radius:999px; background:#3F4D3A; transition:width .9s var(--ease-luxury,ease); }
    .tsf-vik__bar-legend { font-size:11px; color:var(--tsf-text-dim,#a8a299); margin-top:6px; text-align:right; }

    /* ── Funnel ── */
    .tsf-vik__funnel-step { display:flex; align-items:center; gap:14px; padding:12px 0; }
    .tsf-vik__funnel-num { font-family:var(--font-heading-family,'Montserrat',sans-serif); font-size:32px; font-weight:300; color:var(--tsf-text-strong,#2a2723); min-width:56px; text-align:right; line-height:1; }
    .tsf-vik__funnel-num--gold { color:var(--gold-accent,#A16207); }
    .tsf-vik__funnel-label { font-size:13px; color:var(--tsf-text-muted,#7a746c); }
    .tsf-vik__funnel-arrow { display:flex; align-items:center; padding:2px 0 2px 24px; }
    .tsf-vik__funnel-arrow svg { color:var(--tsf-border,#e7e3dc); }

    /* ── Rankings ── */
    .tsf-vik__rank { list-style:none; margin:0; padding:0; }
    .tsf-vik__rank li { display:flex; align-items:center; padding:10px 0; border-bottom:1px solid var(--warm-sand,#f3f1ed);
      transition:background .3s var(--ease-luxury,ease); }
    .tsf-vik__rank li:last-child { border-bottom:none; }
    .tsf-vik__rank li:hover { background:var(--warm-sand,#f3f1ed); margin-inline:-8px; padding-inline:8px; border-radius:8px; }
    .tsf-vik__rank-pos { width:24px; height:24px; border-radius:999px; background:var(--warm-sand,#f3f1ed); display:inline-flex; align-items:center; justify-content:center; font-size:11px; font-weight:600; color:var(--tsf-text-muted,#7a746c); margin-right:12px; flex-shrink:0;
      transition:all .3s var(--ease-luxury,ease); }
    .tsf-vik__rank-pos--1 { background:var(--gold-accent,#A16207); color:#fff; }
    .tsf-vik__rank-name { flex:1; min-width:0; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; font-size:13.5px; color:var(--tsf-text-strong,#2a2723); }
    .tsf-vik__rank-val { font-family:var(--font-heading-family,'Montserrat',sans-serif); font-size:15px; font-weight:400; color:var(--tsf-text-strong,#2a2723); margin-left:14px; white-space:nowrap; }

    /* ── Empty / Error ── */
    .tsf-vik__empty { text-align:center; padding:36px 16px; color:var(--tsf-text-dim,#a8a299); font-size:13px; font-style:italic; }
    .tsf-vik__err { text-align:center; padding:40px 16px; color:var(--tsf-text-muted,#7a746c); }
    .tsf-vik__err small { color:var(--tsf-text-dim,#a8a299); }

    /* ── Skeleton ── */
    .tsf-vik-skel { background:linear-gradient(90deg, var(--warm-sand,#f3f1ed) 25%, var(--tsf-border,#e7e3dc) 50%, var(--warm-sand,#f3f1ed) 75%); background-size:200% 100%; animation:tsf-vik-shimmer 1.8s ease infinite; border-radius:12px; }
    @keyframes tsf-vik-shimmer { 0%{background-position:200% 0} 100%{background-position:-200% 0} }

    /* ── Divider entre seções maiores ── */
    .tsf-vik__divider { border:0; border-top:1px solid var(--tsf-border,#e7e3dc); margin:8px 0 36px; }

    /* ── Interest tabs (pill toggle, padrão tsf-acv__sort) ── */
    .tsf-vik__tabs { display:inline-flex; gap:4px; background:var(--warm-sand,#f3f1ed); padding:4px; border-radius:999px; margin-bottom:22px; flex-wrap:wrap; }
    .tsf-vik__tab { appearance:none; border:0; background:transparent; cursor:pointer; padding:8px 18px; border-radius:999px;
      font:inherit; font-size:12.5px; letter-spacing:0.03em; color:var(--tsf-text-muted,#7a746c);
      transition:all .3s var(--ease-luxury,ease); white-space:nowrap; }
    .tsf-vik__tab[aria-pressed="true"] { background:#fff; color:var(--tsf-text-strong,#2a2723); box-shadow:0 1px 3px rgba(40,40,40,.08); }
    .tsf-vik__tab:hover:not([aria-pressed="true"]) { color:var(--tsf-text-strong,#2a2723); }
    .tsf-vik__tab-badge { font-size:10px; font-weight:600; background:var(--gold-accent,#A16207); color:#fff; padding:1px 6px; border-radius:999px; margin-left:6px; vertical-align:1px; }

    /* ── Signal summary cards (horizontal, compact) ── */
    .tsf-vik__signals { display:grid; grid-template-columns:repeat(auto-fit,minmax(140px,1fr)); gap:14px; margin-bottom:24px; }
    .tsf-vik__signal { background:#fff; border:1px solid var(--tsf-border,#e7e3dc); border-radius:12px; padding:16px 14px; text-align:center;
      transition:all .3s var(--ease-luxury,ease); cursor:pointer; }
    .tsf-vik__signal:hover { border-color:var(--gold-accent,#A16207); transform:translateY(-2px); box-shadow:0 8px 24px -12px rgba(40,40,40,.10); }
    .tsf-vik__signal[aria-pressed="true"] { border-color:var(--gold-accent,#A16207); border-width:2px; padding:15px 13px; }
    .tsf-vik__signal-num { font-family:var(--font-heading-family,'Montserrat',sans-serif); font-size:32px; font-weight:300; color:var(--tsf-text-strong,#2a2723); line-height:1; }
    .tsf-vik__signal-label { font-size:12px; color:var(--tsf-text-muted,#7a746c); margin-top:6px; }
    .tsf-vik__signal-meta { font-size:10.5px; color:var(--tsf-text-dim,#a8a299); margin-top:4px; }

    /* ── Interest detail (lazy-loaded content under tabs) ── */
    .tsf-vik__interest-detail { min-height:80px; }
    .tsf-vik__interest-loading { text-align:center; padding:32px; color:var(--tsf-text-dim,#a8a299); font-size:13px; font-style:italic; }

    /* ── Geo bar (inline bar + label) ── */
    .tsf-vik__geo-row { display:flex; align-items:center; gap:12px; padding:9px 0; border-bottom:1px solid var(--warm-sand,#f3f1ed); }
    .tsf-vik__geo-row:last-child { border-bottom:none; }
    .tsf-vik__geo-label { font-size:13px; color:var(--tsf-text-strong,#2a2723); min-width:80px; flex-shrink:0; }
    .tsf-vik__geo-bar-wrap { flex:1; height:6px; border-radius:999px; background:var(--warm-sand,#f3f1ed); overflow:hidden; }
    .tsf-vik__geo-bar-fill { height:100%; border-radius:999px; background:#3F4D3A; transition:width .9s var(--ease-luxury,ease); }
    .tsf-vik__geo-val { font-size:12.5px; font-weight:600; color:var(--tsf-text-strong,#2a2723); min-width:48px; text-align:right; white-space:nowrap; }
    .tsf-vik__geo-count { font-size:11px; color:var(--tsf-text-dim,#a8a299); min-width:32px; text-align:right; }
  `;

  function tsfVikInjectStyles() {
    if (document.getElementById('tsf-viktor-style')) return;
    const el = document.createElement('style');
    el.id = 'tsf-viktor-style';
    el.textContent = TSF_VIKTOR_CSS;
    document.head.appendChild(el);
  }

  class TsfViktor extends HTMLElement {
    #abort = null;
    #state = 'loading';
    #error = '';
    #period = '30d';
    #sales = [];
    #quotes = [];
    #customerId = null;
    #demand = [];
    #activeInterest = 'bloco-3d';
    #whoCache = new Map();
    #whoState = 'idle';

    async connectedCallback() {
      this.#abort = new AbortController();
      this.#customerId = this.getAttribute('data-customer-id');
      tsfVikInjectStyles();
      this.classList.add('tsf-vik');
      if (!this.#customerId) {
        this.#state = 'error';
        this.#error = 'Customer ID ausente · faça login novamente.';
        this.#render();
        return;
      }
      const urlPeriod = new URLSearchParams(window.location.search).get('period');
      if (urlPeriod && TsfPeriodFilter.isValidPeriod(urlPeriod)) this.#period = urlPeriod;
      this.#render();
      await this.#fetchAll();
    }

    disconnectedCallback() { this.#abort?.abort(); }

    async #fetchAll() {
      this.#state = 'loading';
      this.#render();
      try {
        const signal = this.#abort.signal;
        const params = new URLSearchParams({ scope: 'all', specifier_customer_id: this.#customerId });
        const [sRes, qRes, dRes] = await Promise.allSettled([
          fetch(`${SALE_ENDPOINT}/list?${params}`, { signal }),
          fetch(`${QUOTE_ENDPOINT}/list?${params}`, { signal }),
          fetch(`${ACERVO_ENDPOINT}/demand${this.#demandPeriodQS()}`, { signal }),
        ]);
        if (sRes.status === 'fulfilled') {
          const sData = await sRes.value.json();
          if (sData.ok) this.#sales = sData.sales || [];
        }
        if (qRes.status === 'fulfilled') {
          const qData = await qRes.value.json();
          if (qData.ok) this.#quotes = qData.quotes || [];
        }
        if (dRes.status === 'fulfilled') {
          const dData = await dRes.value.json();
          if (dData.ok) this.#demand = dData.signals || [];
        }
        this.#whoCache.clear();
        this.#state = 'ready';
      } catch (err) {
        if (err.name === 'AbortError') return;
        this.#state = 'error';
        this.#error = err.message || 'erro';
      }
      this.#render();
      if (this.#state === 'ready') this.#loadWho(this.#activeInterest);
    }

    async #loadWho(key) {
      if (this.#whoCache.has(key)) {
        this.#renderInterestDetail();
        return;
      }
      this.#whoState = 'loading';
      this.#renderInterestDetail();
      try {
        var since = this.#sinceParam();
        var until = this.#untilParam();
        var detailUrl = ACERVO_ENDPOINT + '/demand-detail?interest=' + encodeURIComponent(key);
        if (since) detailUrl += '&since=' + since;
        if (until) detailUrl += '&until=' + until;
        var res = await fetch(detailUrl, { signal: this.#abort.signal });
        var d = await res.json();
        if (d.ok && d.total_events > 0) {
          this.#whoCache.set(key, { source: 'detail', products: d.products || [], vendors: d.vendors || [], total: d.total_events || 0 });
        } else if (since) {
          // 2026-06-29 · ETAPA 4 · período ativo + sem evento no período → NÃO cair nas tags do cliente
          //   (elas não têm timestamp → mostrariam gente fora do período). Vazio honesto, fiel ao período.
          this.#whoCache.set(key, { source: 'detail', products: [], vendors: [], total: 0 });
        } else {
          // Sem período (TUDO) → fallback nas tags do cliente (sem timestamp, mas "tudo" é coerente)
          var tag = 'interesse:' + key;
          var whoRes = await fetch(ACERVO_ENDPOINT + '/demand?who=' + encodeURIComponent(tag), { signal: this.#abort.signal });
          var whoData = await whoRes.json();
          this.#whoCache.set(key, { source: 'who', people: whoData.people || [] });
        }
        this.#whoState = 'ready';
      } catch (err) {
        if (err.name === 'AbortError') return;
        this.#whoState = 'error';
      }
      this.#renderInterestDetail();
    }

    #dateRange() { return TsfPeriodFilter.dateRange(this.#period); }

    #sinceParam() {
      const [start] = this.#dateRange();
      if (!start) return '';
      const y = start.getFullYear();
      const m = String(start.getMonth() + 1).padStart(2, '0');
      const d = String(start.getDate()).padStart(2, '0');
      return y + '-' + m + '-' + d;
    }

    // 2026-06-29 · ETAPA 2 · "fim" da janela (data do end do range, sempre meia-noite SP limpa) → fecha o período
    //   pelo fim (essencial p/ meses passados, ex.: month-2026-05). O back compara `created_at < until` (SP).
    #untilParam() {
      const [, end] = this.#dateRange();
      if (!end) return '';
      const y = end.getFullYear();
      const mo = String(end.getMonth() + 1).padStart(2, '0');
      const d = String(end.getDate()).padStart(2, '0');
      return y + '-' + mo + '-' + d;
    }

    #demandPeriodQS() {
      const s = this.#sinceParam();
      const u = this.#untilParam();
      const parts = [];
      if (s) parts.push('since=' + s);
      if (u) parts.push('until=' + u);
      return parts.length ? '?' + parts.join('&') : '';
    }

    #filterByPeriod(list, dateFn) {
      const [start, end] = this.#dateRange();
      if (!start || !end) return list;
      return list.filter(item => {
        const d = dateFn(item);
        return d && d >= start && d < end;
      });
    }

    #saleDate(s) {
      const raw = s.confirmed_at || s.created_at;
      return raw ? new Date(raw) : null;
    }

    #quoteDate(q) {
      // 2026-06-29 · ETAPA 5 · conta o orçamento pela data de CRIAÇÃO (quando entrou no pipeline), não de edição.
      //   Com updated_at, editar um orçamento antigo o fazia "aparecer" no período de hoje (infiel ao período).
      //   Reversível: trocar pra `q.updated_at || q.created_at` volta ao comportamento anterior.
      const raw = q.created_at || q.updated_at;
      return raw ? new Date(raw) : null;
    }

    #saleTotal(s) {
      if (s.total_centavos && s.total_centavos > 0) return s.total_centavos;
      return tsfDocTotalCentavos(s);
    }

    #quoteTotal(q) {
      return tsfDocTotalCentavos(q);
    }

    #isPJ(ci) {
      const cnpj = ((ci && ci.cnpj) || '').replace(/\D/g, '');
      return cnpj.length === 14;
    }

    #esc(s) { const d = document.createElement('div'); d.textContent = s; return d.innerHTML; }

    #computeKPIs() {
      const sales = this.#filterByPeriod(
        this.#sales.filter(s => s.status === 'confirmada'), // 2026-06-29 · FASE 4 · receita só de venda CONFIRMADA (não rascunho/pendente)
        s => this.#saleDate(s)
      );
      const quotes = this.#filterByPeriod(this.#quotes, q => this.#quoteDate(q));
      const openQuotes = quotes.filter(q => q.status === 'draft' || q.status === 'sent');

      const receita = sales.reduce((a, s) => a + this.#saleTotal(s), 0);
      const vendas = sales.length;
      const ticket = vendas > 0 ? Math.round(receita / vendas) : 0;
      const pipeline = openQuotes.reduce((a, q) => a + this.#quoteTotal(q), 0);
      const orcAbertos = openQuotes.length;

      const totalQuotes = quotes.length;
      const wonQuotes = quotes.filter(q => q.status === 'won' || q.status === 'closed').length;
      const convRate = totalQuotes > 0 ? Math.round((wonQuotes / totalQuotes) * 100) : 0;

      let pfCount = 0, pjCount = 0, pfReceita = 0, pjReceita = 0;
      const customerMap = new Map();
      for (const s of sales) {
        const ci = s.client_info || {};
        const pj = this.#isPJ(ci);
        const total = this.#saleTotal(s);
        if (pj) { pjCount++; pjReceita += total; }
        else { pfCount++; pfReceita += total; }
        const key = (ci.email || ci.name || s.id).toLowerCase();
        customerMap.set(key, (customerMap.get(key) || 0) + 1);
      }
      const recompra = [...customerMap.values()].filter(n => n >= 2).length;

      const prodVendidos = new Map();
      const prodCotados = new Map();
      for (const s of sales) {
        for (const it of (s.items || [])) {
          const name = (it.snapshot && it.snapshot.title) || it.title || 'Sem nome';
          const qty = it.qty || 1;
          prodVendidos.set(name, (prodVendidos.get(name) || 0) + qty);
        }
      }
      for (const q of quotes) {
        for (const it of (q.items || [])) {
          const name = (it.snapshot && it.snapshot.title) || it.title || 'Sem nome';
          const qty = it.qty || 1;
          prodCotados.set(name, (prodCotados.get(name) || 0) + qty);
        }
      }
      const topVendidos = [...prodVendidos.entries()].sort((a, b) => b[1] - a[1]).slice(0, 5);
      const topCotados = [...prodCotados.entries()].sort((a, b) => b[1] - a[1]).slice(0, 5);

      return { receita, vendas, ticket, pipeline, orcAbertos, totalQuotes, wonQuotes, convRate,
               pfCount, pjCount, pfReceita, pjReceita, recompra, topVendidos, topCotados };
    }

    #aggregateFromTags(people, prefix) {
      const map = new Map();
      for (const p of people) {
        for (const t of (p.tags || [])) {
          if (t.startsWith(prefix)) {
            const slug = t.slice(prefix.length);
            if (slug) map.set(slug, (map.get(slug) || 0) + 1);
          }
        }
      }
      return [...map.entries()]
        .sort((a, b) => b[1] - a[1])
        .slice(0, 7)
        .map(([slug, count]) => [slug.replace(/-/g, ' ').replace(/\b\w/g, c => c.toUpperCase()), count]);
    }

    #geoFromSales() {
      const activeSales = this.#filterByPeriod(
        this.#sales.filter(s => s.status === 'confirmada'), // 2026-06-29 · FASE 4 · receita só de venda CONFIRMADA (não rascunho/pendente)
        s => this.#saleDate(s)
      );
      const estados = new Map();
      const cidades = new Map();
      for (const s of activeSales) {
        const ci = s.client_info || {};
        const addr = ci.address || ci.endereco || {};
        const uf = (addr.uf || addr.provinceCode || '').toUpperCase();
        const cidade = addr.cidade || addr.localidade || addr.city || '';
        const total = this.#saleTotal(s);
        if (uf) {
          const prev = estados.get(uf) || { revenue: 0, count: 0 };
          estados.set(uf, { revenue: prev.revenue + total, count: prev.count + 1 });
        }
        if (cidade) {
          const prev = cidades.get(cidade) || { revenue: 0, count: 0 };
          cidades.set(cidade, { revenue: prev.revenue + total, count: prev.count + 1 });
        }
      }
      const sortByRev = (a, b) => b[1].revenue - a[1].revenue;
      return {
        estados: [...estados.entries()].sort(sortByRev).slice(0, 7),
        cidades: [...cidades.entries()].sort(sortByRev).slice(0, 7),
      };
    }

    #geoRankHtml(items) {
      if (!items.length) return '<div class="tsf-vik__empty">Sem dados no período</div>';
      const maxRev = items[0][1].revenue;
      return items.map(([name, data]) => {
        const pct = maxRev > 0 ? Math.round((data.revenue / maxRev) * 100) : 0;
        return `<div class="tsf-vik__geo-row">
          <span class="tsf-vik__geo-label">${this.#esc(name)}</span>
          <div class="tsf-vik__geo-bar-wrap"><div class="tsf-vik__geo-bar-fill" style="width:${pct}%"></div></div>
          <span class="tsf-vik__geo-val">${money(data.revenue)}</span>
          <span class="tsf-vik__geo-count">${data.count}×</span>
        </div>`;
      }).join('');
    }

    #renderInterestDetail() {
      var el = this.querySelector('[data-vik-interest-detail]');
      if (!el) return;
      if (this.#whoState === 'loading') {
        el.innerHTML = '<div class="tsf-vik__interest-loading">Carregando detalhes…</div>';
        return;
      }
      var cached = this.#whoCache.get(this.#activeInterest);
      if (!cached) {
        el.innerHTML = '<div class="tsf-vik__empty">Nenhum dado de interesse no período</div>';
        return;
      }

      var topProdutos, topFornecedores, countNote = '';

      if (cached.source === 'detail') {
        topProdutos = (cached.products || []).map(function(p) {
          var name = (p.title || p.handle || '').replace(/-/g, ' ').replace(/\b\w/g, function(c) { return c.toUpperCase(); });
          return [name, p.count];
        });
        topFornecedores = (cached.vendors || []).map(function(v) {
          var name = (v.vendor || '').replace(/-/g, ' ').replace(/\b\w/g, function(c) { return c.toUpperCase(); });
          return [name, v.count];
        });
        if (cached.total > 0) {
          countNote = '<div style="font-size:11px;color:var(--tsf-text-dim,#a8a299);margin-bottom:14px">'
            + cached.total + ' interações no período</div>';
        }
        if (!topProdutos.length && !topFornecedores.length) {
          el.innerHTML = '<div class="tsf-vik__empty">Sem dados de interesse no período selecionado</div>';
          return;
        }
      } else {
        var people = cached.people || [];
        if (!people.length) {
          el.innerHTML = '<div class="tsf-vik__empty">Nenhum cliente com esse interesse</div>';
          return;
        }
        var prefix = this.#activeInterest + ':';
        if (this.#activeInterest === 'whatsapp') {
          var all = new Map();
          for (var px of ['catalogo:', 'bloco-3d:', 'acabamento:', 'whatsapp:']) {
            for (var pair of this.#aggregateFromTags(people, px)) {
              all.set(pair[0], (all.get(pair[0]) || 0) + pair[1]);
            }
          }
          topProdutos = [...all.entries()].sort(function(a, b) { return b[1] - a[1]; }).slice(0, 7);
        } else {
          topProdutos = this.#aggregateFromTags(people, prefix);
        }
        topFornecedores = this.#aggregateFromTags(people, 'vendor:');
      }

      var prodContent = topProdutos.length
        ? this.#rankHtml(topProdutos, 'downloads')
        : '<div class="tsf-vik__empty">Sem dados de produto</div>';
      var vendorContent = topFornecedores.length
        ? this.#rankHtml(topFornecedores, 'downloads')
        : '<div class="tsf-vik__empty">Sem dados de fornecedor</div>';

      el.innerHTML = countNote
        + '<div class="tsf-vik__two-col"><div>'
        + '<div class="tsf-vik__section-eyebrow">Produtos</div>'
        + '<h3 class="tsf-vik__section-title">Top Produtos</h3>'
        + '<div class="tsf-vik__box">' + prodContent + '</div>'
        + '</div><div>'
        + '<div class="tsf-vik__section-eyebrow">Fornecedores</div>'
        + '<h3 class="tsf-vik__section-title">Top Ateliês</h3>'
        + '<div class="tsf-vik__box">' + vendorContent + '</div>'
        + '</div></div>';
    }

    #onInterestChange(key) {
      if (key === this.#activeInterest) return;
      this.#activeInterest = key;
      this.querySelectorAll('[data-vik-interest]').forEach(b => {
        const isActive = b.getAttribute('data-vik-interest') === key;
        b.setAttribute('aria-pressed', String(isActive));
      });
      this.#loadWho(key);
    }

    async #onPeriodChange(newPeriod) {
      this.#period = newPeriod;
      TsfPeriodFilter.syncActiveState(this, newPeriod);
      const dash = this.querySelector('[data-vik-dashboard]');
      if (dash) dash.innerHTML = this.#dashboardHtml();
      try {
        const url = new URL(window.location.href);
        if (newPeriod !== 'month') url.searchParams.set('period', newPeriod);
        else url.searchParams.delete('period');
        window.history.replaceState({}, '', url.toString());
      } catch {}
      const interestEl = this.querySelector('[data-vik-interest-signals]');
      if (interestEl) interestEl.style.opacity = '0.4';
      const detailEl = this.querySelector('[data-vik-interest-detail]');
      if (detailEl) detailEl.innerHTML = '<div class="tsf-vik__interest-loading">Atualizando…</div>';
      this.#whoCache.clear();
      try {
        const since = this.#sinceParam();
        const dUrl = ACERVO_ENDPOINT + '/demand' + (since ? '?since=' + since : '');
        const res = await fetch(dUrl, { signal: this.#abort.signal });
        const dData = await res.json();
        if (dData.ok) {
          this.#demand = dData.signals || [];
          if (dash) dash.innerHTML = this.#dashboardHtml();
        }
      } catch (err) {
        if (err.name === 'AbortError') return;
      }
      this.#loadWho(this.#activeInterest);
    }

    #rankHtml(items, unit) {
      if (!items.length) return '<div class="tsf-vik__empty">Sem dados no período</div>';
      return `<ol class="tsf-vik__rank">${items.map(([name, val], i) => `
        <li>
          <span class="tsf-vik__rank-pos${i === 0 ? ' tsf-vik__rank-pos--1' : ''}">${i + 1}</span>
          <span class="tsf-vik__rank-name" title="${this.#esc(name)}">${this.#esc(name)}</span>
          <span class="tsf-vik__rank-val">${val} ${unit}</span>
        </li>`).join('')}</ol>`;
    }

    #funnelArrow() {
      return `<div class="tsf-vik__funnel-arrow"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M12 5v14"/><path d="M19 12l-7 7-7-7"/></svg></div>`;
    }

    #dashboardHtml() {
      const k = this.#computeKPIs();
      const pLabel = TsfPeriodFilter.periodLabel(this.#period);
      const suffix = pLabel ? ` ${pLabel}` : '';
      const pjPct = k.vendas > 0 ? Math.round((k.pjCount / k.vendas) * 100) : 0;

      return `
        <div class="tsf-vik__grid">
          <div class="tsf-vik__card tsf-vik__card--hero">
            <div class="tsf-vik__card-label">Receita${suffix}</div>
            <div class="tsf-vik__card-value">${money(k.receita)}</div>
            <div class="tsf-vik__card-sub">${k.vendas} venda${k.vendas !== 1 ? 's' : ''} fechada${k.vendas !== 1 ? 's' : ''}</div>
          </div>
          <div class="tsf-vik__card">
            <div class="tsf-vik__card-label">Ticket Médio</div>
            <div class="tsf-vik__card-value">${money(k.ticket)}</div>
            <div class="tsf-vik__card-sub">${k.vendas > 0 ? 'por venda' : '—'}</div>
          </div>
          <div class="tsf-vik__card">
            <div class="tsf-vik__card-label">Pipeline</div>
            <div class="tsf-vik__card-value">${money(k.pipeline)}</div>
            <div class="tsf-vik__card-sub">${k.orcAbertos} orçamento${k.orcAbertos !== 1 ? 's' : ''} aberto${k.orcAbertos !== 1 ? 's' : ''}</div>
          </div>
          <div class="tsf-vik__card">
            <div class="tsf-vik__card-label">Conversão</div>
            <div class="tsf-vik__card-value">${k.convRate}<span style="font-size:20px;font-weight:400;margin-left:2px">%</span></div>
            <div class="tsf-vik__card-sub">${k.wonQuotes} de ${k.totalQuotes} orçamento${k.totalQuotes !== 1 ? 's' : ''}</div>
          </div>
        </div>

        <div class="tsf-vik__two-col">
          <div class="tsf-vik__section">
            <div class="tsf-vik__section-eyebrow">Clientes</div>
            <h3 class="tsf-vik__section-title">Perfil de Venda</h3>
            <div class="tsf-vik__box">
              <div class="tsf-vik__stat-row">
                <span class="tsf-vik__stat-label">Pessoa Física</span>
                <span class="tsf-vik__stat-value">${k.pfCount} · ${money(k.pfReceita)}</span>
              </div>
              <div class="tsf-vik__stat-row">
                <span class="tsf-vik__stat-label">Pessoa Jurídica</span>
                <span class="tsf-vik__stat-value">${k.pjCount} · ${money(k.pjReceita)}</span>
              </div>
              ${k.vendas > 0 ? `<div class="tsf-vik__bar"><div class="tsf-vik__bar-fill" style="width:${pjPct}%"></div></div>
              <div class="tsf-vik__bar-legend">${pjPct}% PJ · ${100 - pjPct}% PF</div>` : ''}
              <div class="tsf-vik__stat-row" style="margin-top:10px">
                <span class="tsf-vik__stat-label">Recompra (2+ pedidos)</span>
                <span class="tsf-vik__stat-value tsf-vik__stat-value--gold">${k.recompra}</span>
              </div>
            </div>
          </div>

          <div class="tsf-vik__section">
            <div class="tsf-vik__section-eyebrow">Pipeline</div>
            <h3 class="tsf-vik__section-title">Funil de Conversão</h3>
            <div class="tsf-vik__box">
              <div class="tsf-vik__funnel-step">
                <span class="tsf-vik__funnel-num">${k.totalQuotes}</span>
                <span class="tsf-vik__funnel-label">orçamentos${suffix}</span>
              </div>
              ${this.#funnelArrow()}
              <div class="tsf-vik__funnel-step">
                <span class="tsf-vik__funnel-num">${k.wonQuotes}</span>
                <span class="tsf-vik__funnel-label">convertidos em venda</span>
              </div>
              ${this.#funnelArrow()}
              <div class="tsf-vik__funnel-step">
                <span class="tsf-vik__funnel-num tsf-vik__funnel-num--gold">${k.vendas}</span>
                <span class="tsf-vik__funnel-label">vendas totais (incl. diretas)</span>
              </div>
              ${k.totalQuotes > 0 ? `<div class="tsf-vik__bar"><div class="tsf-vik__bar-fill" style="width:${k.convRate}%"></div></div>
              <div class="tsf-vik__bar-legend">${k.convRate}% de conversão</div>` : ''}
            </div>
          </div>
        </div>

        <div class="tsf-vik__two-col">
          <div class="tsf-vik__section">
            <div class="tsf-vik__section-eyebrow">Catálogo</div>
            <h3 class="tsf-vik__section-title">Top Produtos Vendidos</h3>
            <div class="tsf-vik__box">${this.#rankHtml(k.topVendidos, 'un')}</div>
          </div>
          <div class="tsf-vik__section">
            <div class="tsf-vik__section-eyebrow">Demanda</div>
            <h3 class="tsf-vik__section-title">Top Produtos Cotados</h3>
            <div class="tsf-vik__box">${this.#rankHtml(k.topCotados, 'un')}</div>
          </div>
        </div>

        ${this.#interestSectionHtml()}

        ${this.#geoSectionHtml()}
      `;
    }

    #interestSectionHtml() {
      // 2026-06-29 · FASE 4 · seção SEMPRE visível (sumia quando vazia → o dono não achava o WhatsApp).
      let cardsHtml = '';
      for (const s of this.#demand) {
        const pressed = s.key === this.#activeInterest ? 'true' : 'false';
        cardsHtml += '<div class="tsf-vik__signal" data-vik-interest="' + s.key + '" role="button" aria-pressed="' + pressed + '" tabindex="0">'
          + '<div class="tsf-vik__signal-num">' + s.total + '</div>'
          + '<div class="tsf-vik__signal-label">' + this.#esc(s.label) + '</div>'
          + '<div class="tsf-vik__signal-meta">cliente' + (s.total !== 1 ? 's' : '') + ' no período</div>'
          + '</div>';
      }
      return '<hr class="tsf-vik__divider">'
        + '<div class="tsf-vik__section">'
        + '<div class="tsf-vik__section-eyebrow">Comportamento</div>'
        + '<h3 class="tsf-vik__section-title">Interesse dos Clientes</h3>'
        + '<div class="tsf-vik__signals" data-vik-interest-signals style="transition:opacity .3s ease">' + (cardsHtml || '<div class="tsf-vik__empty">Sem interações registradas no período.</div>') + '</div>'
        + '<div data-vik-interest-detail class="tsf-vik__interest-detail"></div>'
        + '</div>';
    }

    #geoSectionHtml() {
      const geo = this.#geoFromSales();
      // 2026-06-29 · FASE 4 · seção sempre visível (os boxes internos já têm estado vazio próprio)
      return `
        <hr class="tsf-vik__divider">
        <div class="tsf-vik__section">
          <div class="tsf-vik__section-eyebrow">Geografia</div>
          <h3 class="tsf-vik__section-title">De Onde Vêm as Vendas</h3>
          <div class="tsf-vik__two-col">
            <div>
              <div class="tsf-vik__section-eyebrow">Por Estado</div>
              <div class="tsf-vik__box">${geo.estados.length ? this.#geoRankHtml(geo.estados) : '<div class="tsf-vik__empty">Sem dados de estado</div>'}</div>
            </div>
            <div>
              <div class="tsf-vik__section-eyebrow">Por Cidade</div>
              <div class="tsf-vik__box">${geo.cidades.length ? this.#geoRankHtml(geo.cidades) : '<div class="tsf-vik__empty">Sem dados de cidade</div>'}</div>
            </div>
          </div>
        </div>
      `;
    }

    #render() {
      // 02-08 · PADRÃO DO ADMIN: este é o cabeçalho DA PÁGINA (um H1 só, no topo)
      // e o seletor de período mora nele — antes ficava solto no meio da página.
      // O toggle continua DENTRO do <tsf-viktor> porque os listeners são
      // delegados no host (TsfPeriodFilter.attachListeners(this, …)).
      const head = `<header class="tsf-vik__head tsfph">
        <div class="tsfph__txt">
          <span class="tsf-vik__eyebrow tsfph__eyebrow">Inteligência · Analytics</span>
          <h1 class="tsf-vik__title tsfph__title">Visão Comercial</h1>
          <p class="tsf-vik__lede tsfph__lede">Receita, pipeline, conversão e perfil de venda — dados reais do seu atelier.</p>
        </div>
        <div class="tsf-vik__period tsfph__tools">${TsfPeriodFilter.renderToggle(this.#period)}</div>
      </header>`;

      if (this.#state === 'loading') {
        this.innerHTML = head + `
          <div class="tsf-vik__grid">
            ${Array.from({ length: 4 }).map(() => '<div class="tsf-vik__card"><div class="tsf-vik-skel" style="height:80px"></div></div>').join('')}
          </div>
          <div class="tsf-vik__two-col">
            <div class="tsf-vik__box"><div class="tsf-vik-skel" style="height:180px"></div></div>
            <div class="tsf-vik__box"><div class="tsf-vik-skel" style="height:180px"></div></div>
          </div>`;
        return;
      }

      if (this.#state === 'error') {
        this.innerHTML = head + `<div class="tsf-vik__err"><p>Não consegui carregar os dados.<br><small>${this.#esc(this.#error)}</small></p></div>`;
        return;
      }

      this.innerHTML = head +
        `<div data-vik-dashboard>${this.#dashboardHtml()}</div>`;

      const signal = this.#abort.signal;
      TsfPeriodFilter.attachListeners(
        this,
        () => this.#period,
        (p) => this.#onPeriodChange(p),
        signal,
      );
      this.addEventListener('click', (e) => {
        const sig = e.target.closest?.('[data-vik-interest]');
        if (sig) {
          e.preventDefault();
          this.#onInterestChange(sig.getAttribute('data-vik-interest'));
        }
      }, { signal });
    }
  }

  /* ════════════════════════════════════════════════════════════════════
     5. Auto-init on DOM ready
     ════════════════════════════════════════════════════════════════════ */
  function init() {
    if (!customElements.get('tsf-companion')) {
      customElements.define('tsf-companion', TsfCompanion);
    }
    if (!customElements.get('tsf-quote-builder')) {
      customElements.define('tsf-quote-builder', TsfQuoteBuilder);
    }
    if (!customElements.get('tsf-pedido-app')) {
      customElements.define('tsf-pedido-app', TsfPedidoApp);
    }
    if (!customElements.get('tsf-admin-orcamentos')) {
      customElements.define('tsf-admin-orcamentos', TsfAdminOrcamentos);
    }
    if (!customElements.get('tsf-admin-vendas')) {
      customElements.define('tsf-admin-vendas', TsfAdminVendas);
    }
    if (!customElements.get('tsf-admin-venda-editor')) {
      customElements.define('tsf-admin-venda-editor', TsfAdminVendaEditor);
    }
    if (!customElements.get('tsf-admin-cliente-editor')) {
      customElements.define('tsf-admin-cliente-editor', TsfAdminClienteEditor);
    }
    if (!customElements.get('tsf-admin-cliente-360')) {
      customElements.define('tsf-admin-cliente-360', TsfAdminCliente360);
    }
    if (!customElements.get('tsf-admin-clientes')) {
      customElements.define('tsf-admin-clientes', TsfAdminClientes);
    }
    if (!customElements.get('tsf-admin-ateliers')) {
      customElements.define('tsf-admin-ateliers', TsfAdminAteliers);
    }
    if (!customElements.get('tsf-atelier-stage')) {
      customElements.define('tsf-atelier-stage', TsfAtelierStage);
    }
    if (!customElements.get('tsf-demand-cockpit')) {
      customElements.define('tsf-demand-cockpit', TsfDemandCockpit);
    }
    if (!customElements.get('tsf-viktor')) {
      customElements.define('tsf-viktor', TsfViktor);
    }
    if (!customElements.get('tsf-admin-segmentos')) {
      // Paleta de tags (português) pro editor de critério in-admin — fonte da verdade da UI.
      const TSF_SEG_PALETTE = [
        { group: 'E-mail · setor', tags: [
          ['email:arquitetura', 'E-mail de arquiteto'],
          ['email:construcao', 'E-mail de construtora/engenharia'],
          ['email:imobiliario', 'E-mail de imobiliária/incorporadora'],
          ['email:hospitalidade', 'E-mail de hotel/restaurante'],
          ['email:educacao', 'E-mail de educação'],
          ['email:corporativo', 'E-mail corporativo'],
          ['email:pessoal', 'E-mail pessoal'],
        ] },
        { group: 'Perfil · profissão', tags: [
          ['perfil:arquiteto', 'Arquiteto confirmado'],
          ['perfil:designer', 'Designer'],
          ['perfil:construtora', 'Construtora'],
          ['perfil:incorporadora', 'Incorporadora'],
          ['perfil:marcenaria', 'Marcenaria'],
          ['perfil:cliente-b2c', 'Pessoa física (B2C)'],
          ['perfil:cliente-b2b', 'Empresa (B2B)'],
        ] },
        { group: 'Interesse · comportamento', tags: [
          ['interesse:bloco-3d', 'Baixou bloco 3D'],
          ['interesse:catalogo', 'Baixou catálogo'],
          ['interesse:acabamento', 'Pediu amostra de acabamento'],
          ['interesse:whatsapp', 'Clicou no WhatsApp'],
        ] },
        { group: 'Valor · LTV', tags: [
          ['valor:vip', 'VIP (LTV ≥ R$ 10k)'],
          ['valor:alto', 'Alto valor (≥ R$ 5k)'],
          ['valor:padrao', 'Padrão (≥ R$ 1k)'],
        ] },
        { group: 'Atividade', tags: [
          ['atividade:hot', 'Ativo (0–30 dias)'],
          ['atividade:warm', 'Esfriando (31–60 dias)'],
          ['atividade:cool', 'Último contato (61–90 dias)'],
        ] },
        { group: 'Tipo de cliente', tags: [
          ['tipo:b2b-recorrente', 'B2B recorrente (2+ compras)'],
          ['tipo:b2b-comprador-unico', 'B2B comprou 1x'],
          ['tipo:b2c-comprador-unico', 'B2C comprou 1x'],
          ['tipo:interno', 'Conta interna Toth'],
        ] },
        { group: 'Specifica', tags: [
          ['specifica-comunidade', 'Specifica Comunidade'],
          ['specifica-gold', 'Specifica Gold'],
          ['specifica-black', 'Specifica Black'],
          ['specifica-active', 'Specifica ativo'],
        ] },
      ];
      const TSF_SEG_TAGLABEL = {};
      for (const g of TSF_SEG_PALETTE) for (const pair of g.tags) TSF_SEG_TAGLABEL[pair[0]] = pair[1];

      // ── SEGMENTOS · gerenciador transparente (lê segmentos nativos Shopify) ──
      class TsfAdminSegmentos extends HTMLElement {
        #abort = null;
        #segments = [];
        #error = null;
        #counts = new Map();        // id(string) -> number | 'err'
        #countsStarted = false;
        #view = 'grid';            // 'grid' | 'detail'
        #current = null;           // segmento aberto no detalhe
        #members = [];
        #cursor = null;
        #hasNext = false;
        #loadingMore = false;
        #enteredViaGrid = false;
        #onPop = null;
        #FN = 'https://pucrgwvcgagbapzvphao.supabase.co/functions/v1/toth-checkout';
        #STORE = 'tothmoveis';      // handle admin.shopify.com (deep-link de edição)
        #editConds = [];            // condições do editor de critério
        #editAdvanced = false;      // regra com parênteses → textarea avançado
        #editRaw = '';              // query crua (modo avançado)
        #editPreview = null;        // última contagem válida do preview
        #previewTimer = null;       // debounce do preview

        async connectedCallback() {
          this.#abort = new AbortController();
          this.classList.add('tsf-segs');
          this.#onPop = () => this.#routeFromUrl();
          window.addEventListener('popstate', this.#onPop);
          this.#renderShell();
          await this.#fetch();
        }
        disconnectedCallback() {
          this.#abort?.abort();
          if (this.#onPop) window.removeEventListener('popstate', this.#onPop);
        }

        #esc(s) {
          return String(s ?? '').replace(/[&<>"']/g, c => ({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c]));
        }
        #fmtInt(n) { try { return new Intl.NumberFormat('pt-BR').format(Number(n) || 0); } catch { return String(n); } }
        #fmtMoney(n, cur) { try { return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: cur || 'BRL' }).format(Number(n) || 0); } catch { return 'R$ ' + (Number(n) || 0).toFixed(2); } }
        #cleanName(s) { return this.#esc((s.name || '').replace(/^\[TOTH\]\s*/, '')); }

        async #fetch() {
          try {
            const res = await fetch(`${this.#FN}/segments/list`, { signal: this.#abort.signal });
            if (!res.ok) throw new Error('HTTP ' + res.status);
            const data = await res.json();
            this.#segments = Array.isArray(data.segments) ? data.segments : [];
            this.#routeFromUrl();
          } catch (e) {
            if (e?.name === 'AbortError') return;
            this.#error = e?.message || 'erro';
            this.#renderError();
          }
        }

        // ── roteamento por URL (?seg=ID) · suporta back/forward do navegador ──
        #routeFromUrl() {
          const seg = new URLSearchParams(location.search).get('seg');
          if (seg) {
            const found = this.#segments.find(s => String(s.id) === String(seg));
            if (found) { this.#showDetail(found); return; }
          }
          this.#showGrid();
        }

        #renderShell() {
          this.innerHTML = `
            <header class="tsf-segs__head" data-segs-head></header>
            <div class="tsf-segs__body" data-segs-body>${this.#skeleton()}</div>`;
        }

        #skeleton() {
          const card = `<div class="tsf-segs__card tsf-segs__card--sk" aria-hidden="true"><span class="tsf-segs__sk tsf-segs__sk--title"></span><span class="tsf-segs__sk"></span><span class="tsf-segs__sk tsf-segs__sk--short"></span></div>`;
          return `<div class="tsf-segs__grid">${card.repeat(6)}</div>`;
        }

        #renderError() {
          const head = this.querySelector('[data-segs-head]');
          const body = this.querySelector('[data-segs-body]');
          if (head) head.innerHTML = `<div class="tsf-segs__heading"><span class="tsf-segs__eyebrow">Atelier · Inteligência</span><h1 class="tsf-segs__title">Segmentos</h1></div>`;
          if (body) body.innerHTML = `<div class="tsf-segs__empty"><p class="tsf-segs__empty-title">Não foi possível carregar.</p><p class="tsf-segs__empty-sub">${this.#esc(this.#error)}</p><button type="button" class="tsf-segs__retry" data-segs-retry>Tentar de novo</button></div>`;
          this.querySelector('[data-segs-retry]')?.addEventListener('click', () => { this.#error = null; this.querySelector('[data-segs-body]').innerHTML = this.#skeleton(); this.#fetch(); }, { once: true });
        }

        // ═══════════════════════ GRID ═══════════════════════
        #showGrid() {
          this.#view = 'grid';
          this.#current = null;
          const head = this.querySelector('[data-segs-head]');
          if (head) head.innerHTML = `
            <div class="tsf-segs__heading">
              <span class="tsf-segs__eyebrow">Atelier · Inteligência</span>
              <h1 class="tsf-segs__title">Segmentos</h1>
              <p class="tsf-segs__lede" data-segs-lede></p>
            </div>`;
          this.#renderList();
          if (!this.#countsStarted) { this.#countsStarted = true; this.#loadCounts(); }
        }

        #renderList() {
          const toth = this.#segments.filter(s => s.is_toth);
          const others = this.#segments.filter(s => !s.is_toth);
          const lede = this.querySelector('[data-segs-lede]');
          if (lede) lede.textContent = `${toth.length} segmentos Toth · clique num card para ver quem está dentro`;
          const body = this.querySelector('[data-segs-body]');
          if (!body) return;
          if (!toth.length && !others.length) {
            body.innerHTML = `<div class="tsf-segs__empty"><p class="tsf-segs__empty-title">Nenhum segmento ainda.</p></div>`;
            return;
          }
          body.innerHTML = `
            <div class="tsf-segs__grid">${toth.map(s => this.#card(s)).join('')}</div>
            ${others.length ? `<details class="tsf-segs__others"><summary class="tsf-segs__others-sum">Segmentos padrão do Shopify <span class="tsf-segs__others-count">${others.length}</span></summary><div class="tsf-segs__grid tsf-segs__grid--muted">${others.map(s => this.#card(s)).join('')}</div></details>` : ''}
            <p class="tsf-segs__note">Os critérios são editáveis nos <strong>Segmentos de clientes do Shopify</strong>. Cada segmento alimenta listas de transmissão: E-mail · Meta · Google · WhatsApp.</p>`;
          for (const el of body.querySelectorAll('[data-seg-card]')) {
            el.addEventListener('click', () => {
              const s = this.#segments.find(x => String(x.id) === el.getAttribute('data-seg-card'));
              if (s) this.#openDetail(s);
            });
            el.addEventListener('keydown', (e) => {
              if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); el.click(); }
            });
          }
          this.#applyCounts();
        }

        #countChip(s) {
          const cnt = this.#counts.get(String(s.id));
          const inner = (cnt == null)
            ? `<span class="tsf-segs__count-sk"></span>`
            : (cnt === 'err' ? '—' : `${this.#fmtInt(cnt)} ${cnt === 1 ? 'cliente' : 'clientes'}`);
          return `<span class="tsf-segs__count${cnt != null && cnt !== 'err' ? ' tsf-segs__count--ready' : ''}" data-count-for="${this.#esc(s.id)}">${inner}</span>`;
        }

        #card(s) {
          const name = this.#cleanName(s);
          const crit = this.#esc(s.criteria_human || s.query || '—').replace(/\n/g, ' ');
          const chans = ['E-mail', 'Meta', 'Google', 'WhatsApp'].map(c => `<span class="tsf-segs__chan">${c}</span>`).join('');
          return `
            <article class="tsf-segs__card" data-seg-card="${this.#esc(s.id)}" role="button" tabindex="0" aria-label="Abrir segmento ${name}">
              <div class="tsf-segs__card-top">
                <h2 class="tsf-segs__name">${name}</h2>
                ${this.#countChip(s)}
              </div>
              <div class="tsf-segs__crit">
                <span class="tsf-segs__crit-label">Critério</span>
                <p class="tsf-segs__crit-text">${crit}</p>
              </div>
              <div class="tsf-segs__card-foot">
                <div class="tsf-segs__channels" aria-label="Canais de transmissão">${chans}</div>
                <span class="tsf-segs__open" aria-hidden="true">Abrir →</span>
              </div>
            </article>`;
        }

        async #loadCounts() {
          // Contagem por-segmento (requisições SEPARADAS = naturalmente espaçadas, evitam o throttle do
          // Shopify que derrubava a rajada). Concorrência 2 + até 3 tentativas por segmento + preenchimento
          // progressivo (cada card mostra assim que chega).
          const segs = this.#segments.slice();
          let i = 0;
          const fetchOne = async (id) => {
            for (let a = 0; a < 3; a++) {
              try {
                const res = await fetch(`${this.#FN}/segments/members?id=${encodeURIComponent(id)}&count_only=1`, { signal: this.#abort.signal });
                if (res.ok) { const d = await res.json(); if (Number.isFinite(d.count)) return d.count; }
              } catch (e) { if (e?.name === 'AbortError') throw e; }
              await new Promise((r) => setTimeout(r, 400 * (a + 1))); // backoff entre tentativas
            }
            return 'err';
          };
          const worker = async () => {
            while (i < segs.length) {
              const id = String(segs[i++].id);
              if (this.#counts.has(id)) { this.#applyCountChip(id); continue; }
              try { this.#counts.set(id, await fetchOne(id)); }
              catch (e) { if (e?.name === 'AbortError') return; this.#counts.set(id, 'err'); }
              this.#applyCountChip(id);
            }
          };
          await Promise.all([worker(), worker()]); // concorrência 2 (baixa = confiável)
        }

        #applyCountChip(id) {
          const el = this.querySelector(`[data-count-for="${(window.CSS && CSS.escape) ? CSS.escape(String(id)) : String(id)}"]`);
          if (!el) return;
          const cnt = this.#counts.get(String(id));
          if (cnt == null) return;
          el.innerHTML = cnt === 'err' ? '—' : `${this.#fmtInt(cnt)} ${cnt === 1 ? 'cliente' : 'clientes'}`;
          if (cnt !== 'err') el.classList.add('tsf-segs__count--ready');
        }
        #applyCounts() { for (const id of this.#counts.keys()) this.#applyCountChip(id); }

        // ═══════════════════════ DETALHE ═══════════════════════
        #openDetail(s) {
          this.#enteredViaGrid = (this.#view === 'grid');
          try { history.pushState({ tsfSeg: s.id }, '', `?seg=${encodeURIComponent(s.id)}`); } catch {}
          this.#showDetail(s);
        }

        #backToGrid() {
          if (this.#enteredViaGrid) {
            history.back(); // dispara popstate → routeFromUrl → grid (history limpo)
          } else {
            try { history.pushState({}, '', location.pathname); } catch {}
            this.#showGrid();
          }
        }

        #showDetail(s) {
          this.#view = 'detail';
          this.#current = s;
          this.#members = [];
          this.#cursor = null;
          this.#hasNext = false;
          this.#loadingMore = false;
          this.#renderDetail();
          this.#fetchMembers(true);
          try { this.scrollIntoView({ block: 'start', behavior: 'instant' }); } catch {}
        }

        #renderDetail() {
          const s = this.#current;
          const name = this.#cleanName(s);
          const head = this.querySelector('[data-segs-head]');
          if (head) {
            head.innerHTML = `
              <button type="button" class="tsf-segs__back" data-segs-back>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="15 18 9 12 15 6"/></svg>
                Segmentos
              </button>
              <div class="tsf-segs__detail-head">
                <div class="tsf-segs__detail-heading">
                  <span class="tsf-segs__eyebrow">${s.is_toth ? 'Segmento Toth' : 'Segmento Shopify'}</span>
                  <h1 class="tsf-segs__title">${name}</h1>
                </div>
                <div class="tsf-segs__detail-count" data-detail-count><span class="tsf-segs__count-sk tsf-segs__count-sk--lg"></span></div>
              </div>`;
            head.querySelector('[data-segs-back]')?.addEventListener('click', () => this.#backToGrid());
          }
          const body = this.querySelector('[data-segs-body]');
          if (!body) return;
          body.innerHTML = `
            <section class="tsf-segs__detail">
              <aside class="tsf-segs__detail-crit" data-segs-crit>${this.#critReadHTML()}</aside>
              <div class="tsf-segs__members" data-segs-members>
                <div class="tsf-segs__members-head">
                  <h2 class="tsf-segs__members-title">Clientes neste segmento</h2>
                  <span class="tsf-segs__members-sub" data-members-sub></span>
                </div>
                <div class="tsf-segs__members-list" data-members-list>${this.#memberSkeleton()}</div>
                <div class="tsf-segs__members-foot" data-members-foot></div>
              </div>
            </section>`;
          this.#wireCritRead();
        }

        // ═══════════════════ CRITÉRIO · leitura + edição in-admin ═══════════════════
        #critReadHTML() {
          const s = this.#current;
          const human = this.#esc(s.criteria_human || '—');
          const raw = this.#esc(s.query || '');
          const chans = ['E-mail', 'Meta', 'Google', 'WhatsApp'].map(c => `<span class="tsf-segs__chan">${c}</span>`).join('');
          return `
            <span class="tsf-segs__crit-label">Critério · o cliente entra se…</span>
            <p class="tsf-segs__detail-crit-text">${human}</p>
            ${raw ? `<details class="tsf-segs__raw"><summary class="tsf-segs__raw-sum">Ver regra técnica (Shopify)</summary><code class="tsf-segs__raw-code">${raw}</code></details>` : ''}
            <div class="tsf-segs__detail-actions">
              <button type="button" class="tsf-segs__act tsf-segs__act--primary" data-segs-edit>Editar critério</button>
              <a href="https://admin.shopify.com/store/${this.#STORE}/customers/segments/${this.#esc(s.id)}" target="_blank" rel="noopener" class="tsf-segs__act tsf-segs__act--ghost">No Shopify ↗</a>
            </div>
            <div class="tsf-segs__detail-chans">
              <span class="tsf-segs__crit-label">Alimenta as listas de</span>
              <div class="tsf-segs__channels">${chans}</div>
            </div>`;
        }
        #wireCritRead() {
          this.querySelector('[data-segs-edit]')?.addEventListener('click', () => this.#startEdit());
        }

        #parseQuery(q) {
          q = String(q || '').trim();
          if (/[()]/.test(q)) return { advanced: true, raw: q, conds: [] };
          if (!q) return { advanced: false, raw: '', conds: [] };
          const parts = q.split(/\s+(AND|OR)\s+/i);
          const conds = [];
          for (let i = 0; i < parts.length; i += 2) {
            const connector = i === 0 ? null : (parts[i - 1] || 'AND').toUpperCase();
            let p = String(parts[i] || '').trim();
            let negated = false;
            if (/^NOT\s+/i.test(p)) { negated = true; p = p.replace(/^NOT\s+/i, '').trim(); }
            const m = p.match(/^customer_tags\s+CONTAINS\s+'([^']*)'$/i);
            if (m) conds.push({ connector, negated, type: 'tag', tag: m[1] });
            else conds.push({ connector, negated, type: 'raw', raw: p });
          }
          return { advanced: false, raw: q, conds };
        }
        #recompose(conds) {
          return conds.map((c, i) => {
            const conn = i === 0 ? '' : (c.connector || 'AND') + ' ';
            const neg = c.negated ? 'NOT ' : '';
            const pred = c.type === 'tag' ? `customer_tags CONTAINS '${c.tag}'` : c.raw;
            return conn + neg + pred;
          }).join(' ');
        }
        #predHuman(raw) {
          return String(raw || '')
            .replace(/number_of_orders\s*>=\s*1/i, 'comprou ao menos 1x')
            .replace(/number_of_orders\s*>\s*1/i, 'comprou 2+ vezes')
            .replace(/number_of_orders\s*=\s*0/i, 'nunca comprou')
            .replace(/amount_spent\s*>=\s*'?(\d+)'?/i, (_m, v) => `gastou ≥ R$ ${v}`)
            .replace(/email_subscription_status\s*=\s*'SUBSCRIBED'/i, 'inscrito no e-mail')
            .replace(/abandoned_checkout_date\s*>=\s*-?(\d+)d/i, 'abandonou checkout (últ. $1 dias)');
        }
        #condLabel(c) {
          if (c.type === 'tag') return TSF_SEG_TAGLABEL[c.tag] || `tem a tag "${c.tag}"`;
          return this.#predHuman(c.raw);
        }
        #humanFromConds(conds) {
          if (!conds.length) return '—';
          return conds.map((c, i) => {
            const conn = i === 0 ? '' : (c.connector === 'OR' ? 'OU ' : 'E ');
            return conn + (c.negated ? 'não ' : '') + this.#condLabel(c);
          }).join(' ');
        }

        #startEdit() {
          const parsed = this.#parseQuery(this.#current.query);
          this.#editAdvanced = parsed.advanced;
          this.#editConds = parsed.conds;
          this.#editRaw = parsed.raw;
          this.#editPreview = null;
          const box = this.querySelector('[data-segs-crit]');
          if (!box) return;
          box.innerHTML = this.#critEditHTML();
          this.#wireCritEdit();
          this.#doPreview();
        }
        #cancelEdit() {
          clearTimeout(this.#previewTimer);
          const box = this.querySelector('[data-segs-crit]');
          if (box) { box.innerHTML = this.#critReadHTML(); this.#wireCritRead(); }
        }
        #paletteOptions(selected) {
          return TSF_SEG_PALETTE.map(g =>
            `<optgroup label="${this.#esc(g.group)}">${g.tags.map(t =>
              `<option value="${this.#esc(t[0])}"${t[0] === selected ? ' selected' : ''}>${this.#esc(t[1])}</option>`).join('')}</optgroup>`
          ).join('');
        }
        #critEditHTML() {
          if (this.#editAdvanced) {
            return `
              <span class="tsf-segs__crit-label">Editar regra (avançada)</span>
              <textarea class="tsf-segs__adv" data-adv rows="4" spellcheck="false">${this.#esc(this.#editRaw)}</textarea>
              <p class="tsf-segs__edit-hint">Esta regra usa parênteses — edite o texto direto. A pré-visualização valida antes de salvar.</p>
              ${this.#editFootHTML()}`;
          }
          const rows = this.#editConds.map((c, i) => this.#condRowHTML(c, i)).join('') ||
            `<p class="tsf-segs__edit-empty">Sem condições — adicione uma abaixo.</p>`;
          return `
            <span class="tsf-segs__crit-label">Critério · o cliente entra se…</span>
            <div class="tsf-segs__conds" data-conds>${rows}</div>
            <select class="tsf-segs__addsel" data-addsel aria-label="Adicionar condição">
              <option value="">+ Adicionar condição…</option>
              ${this.#paletteOptions('')}
            </select>
            ${this.#editFootHTML()}`;
        }
        #condRowHTML(c, i) {
          const conn = i === 0 ? '' :
            `<div class="tsf-segs__conn">
               <button type="button" class="tsf-segs__conn-btn${c.connector !== 'OR' ? ' is-on' : ''}" data-setconn="${i}:AND">E</button>
               <button type="button" class="tsf-segs__conn-btn${c.connector === 'OR' ? ' is-on' : ''}" data-setconn="${i}:OR">OU</button>
             </div>`;
          const body = c.type === 'tag'
            ? `<select class="tsf-segs__cond-tag" data-condtag="${i}">${this.#paletteOptions(c.tag)}${TSF_SEG_TAGLABEL[c.tag] ? '' : `<option value="${this.#esc(c.tag)}" selected>tem a tag "${this.#esc(c.tag)}"</option>`}</select>`
            : `<span class="tsf-segs__cond-raw" title="${this.#esc(c.raw)}">⚙ ${this.#esc(this.#predHuman(c.raw))}</span>`;
          return `${conn}
            <div class="tsf-segs__cond">
              <button type="button" class="tsf-segs__cond-not${c.negated ? ' is-on' : ''}" data-togglenot="${i}" title="Inverter (NÃO)">NÃO</button>
              ${body}
              <button type="button" class="tsf-segs__cond-rm" data-rmcond="${i}" aria-label="Remover">✕</button>
            </div>`;
        }
        #editFootHTML() {
          return `
            <div class="tsf-segs__preview" data-preview><span class="tsf-segs__preview-load">calculando…</span></div>
            <div class="tsf-segs__edit-actions">
              <button type="button" class="tsf-segs__act tsf-segs__act--primary" data-savecrit disabled>Salvar no Shopify</button>
              <button type="button" class="tsf-segs__act tsf-segs__act--ghost" data-cancelcrit>Cancelar</button>
            </div>`;
        }
        #wireCritEdit() {
          const box = this.querySelector('[data-segs-crit]');
          if (!box) return;
          box.querySelector('[data-cancelcrit]')?.addEventListener('click', () => this.#cancelEdit());
          box.querySelector('[data-savecrit]')?.addEventListener('click', () => this.#saveCriteria());
          box.querySelector('[data-addsel]')?.addEventListener('change', (e) => {
            const t = e.target.value; if (!t) return;
            this.#editConds.push({ connector: this.#editConds.length ? 'OR' : null, negated: false, type: 'tag', tag: t });
            this.#rerenderConds();
          });
          const adv = box.querySelector('[data-adv]');
          if (adv) adv.addEventListener('input', () => { this.#editRaw = adv.value; this.#schedulePreview(); });
          for (const b of box.querySelectorAll('[data-rmcond]')) b.addEventListener('click', () => { this.#editConds.splice(+b.dataset.rmcond, 1); this.#rerenderConds(); });
          for (const b of box.querySelectorAll('[data-togglenot]')) b.addEventListener('click', () => { const i = +b.dataset.togglenot; this.#editConds[i].negated = !this.#editConds[i].negated; this.#rerenderConds(); });
          for (const b of box.querySelectorAll('[data-setconn]')) b.addEventListener('click', () => { const [i, v] = b.dataset.setconn.split(':'); this.#editConds[+i].connector = v; this.#rerenderConds(); });
          for (const sel of box.querySelectorAll('[data-condtag]')) sel.addEventListener('change', () => { this.#editConds[+sel.dataset.condtag].tag = sel.value; this.#schedulePreview(); });
        }
        #rerenderConds() {
          const box = this.querySelector('[data-segs-crit]');
          if (!box) return;
          box.innerHTML = this.#critEditHTML();
          this.#wireCritEdit();
          this.#schedulePreview();
        }
        #currentEditQuery() {
          return this.#editAdvanced ? String(this.#editRaw || '').trim() : this.#recompose(this.#editConds);
        }
        #schedulePreview() {
          clearTimeout(this.#previewTimer);
          const el = this.querySelector('[data-preview]');
          if (el) el.innerHTML = `<span class="tsf-segs__preview-load">calculando…</span>`;
          const save = this.querySelector('[data-savecrit]'); if (save) save.disabled = true;
          this.#previewTimer = setTimeout(() => this.#doPreview(), 450);
        }
        async #doPreview() {
          const q = this.#currentEditQuery();
          const el = this.querySelector('[data-preview]');
          const save = this.querySelector('[data-savecrit]');
          if (!q) { if (el) el.innerHTML = `<span class="tsf-segs__preview-warn">regra vazia</span>`; if (save) save.disabled = true; this.#editPreview = null; return; }
          try {
            const res = await fetch(`${this.#FN}/segments/preview?q=${encodeURIComponent(q)}`, { signal: this.#abort.signal });
            const d = await res.json();
            if (!el) return;
            if (d.valid) {
              this.#editPreview = d.count;
              el.innerHTML = `<span class="tsf-segs__preview-ok">✓ essa regra pega <strong>${this.#fmtInt(d.count)}</strong> ${d.count === 1 ? 'cliente' : 'clientes'}</span>`;
              if (save) save.disabled = false;
            } else {
              this.#editPreview = null;
              el.innerHTML = `<span class="tsf-segs__preview-warn">⚠ regra inválida — ${this.#esc(d.error || '')}</span>`;
              if (save) save.disabled = true;
            }
          } catch (e) {
            if (e?.name === 'AbortError') return;
            if (el) el.innerHTML = `<span class="tsf-segs__preview-warn">não deu pra validar agora</span>`;
          }
        }
        async #saveCriteria() {
          const q = this.#currentEditQuery();
          if (!q) return;
          const save = this.querySelector('[data-savecrit]');
          if (save) { save.disabled = true; save.textContent = 'Salvando…'; }
          try {
            const res = await fetch(`${this.#FN}/segments/update`, {
              method: 'POST', headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: this.#current.id, query: q }), signal: this.#abort.signal,
            });
            const d = await res.json();
            if (!d.ok) throw new Error(d.error || 'erro ao salvar');
            this.#current.query = d.segment?.query || q;
            if (!this.#editAdvanced) this.#current.criteria_human = this.#humanFromConds(this.#editConds);
            else this.#current.criteria_human = '(regra personalizada — ver regra técnica)';
            // atualiza a contagem do header na hora (pelo preview) — não espera o Shopify recomputar
            if (Number.isFinite(this.#editPreview)) {
              this.#counts.set(String(this.#current.id), this.#editPreview);
              const dc = this.querySelector('[data-detail-count]');
              if (dc) dc.innerHTML = `<strong>${this.#fmtInt(this.#editPreview)}</strong> ${this.#editPreview === 1 ? 'cliente' : 'clientes'}`;
            }
            this.#cancelEdit();
            const box = this.querySelector('[data-segs-crit]');
            if (box) {
              const flash = document.createElement('div');
              flash.className = 'tsf-segs__saved';
              flash.textContent = '✓ Critério salvo no Shopify';
              box.prepend(flash);
              setTimeout(() => flash.remove(), 3500);
            }
            const sub = this.querySelector('[data-members-sub]');
            if (sub) sub.textContent = 'atualizando lista…';
            // o Shopify recomputa o segmento após mudar a regra — espera ~1,8s antes de recarregar os membros
            setTimeout(() => this.#fetchMembers(true), 1800);
          } catch (e) {
            if (save) { save.disabled = false; save.textContent = 'Salvar no Shopify'; }
            const el = this.querySelector('[data-preview]');
            if (el) el.innerHTML = `<span class="tsf-segs__preview-warn">não foi possível salvar — ${this.#esc(e?.message || '')}</span>`;
          }
        }

        #memberSkeleton() {
          const row = `<div class="tsf-segs__member tsf-segs__member--sk" aria-hidden="true"><span class="tsf-segs__member-avatar tsf-segs__sk"></span><span class="tsf-segs__member-body"><span class="tsf-segs__sk tsf-segs__sk--title"></span><span class="tsf-segs__sk tsf-segs__sk--short"></span></span></div>`;
          return row.repeat(6);
        }

        async #fetchMembers(reset) {
          if (this.#loadingMore) return;
          const seg = this.#current;
          if (!seg) return;
          const segId = String(seg.id);
          if (reset) { this.#members = []; this.#cursor = null; this.#hasNext = false; }
          this.#loadingMore = true;
          if (!reset) this.#renderMembersFoot('loading');
          try {
            const params = new URLSearchParams({ id: segId, first: '24' });
            if (this.#cursor) params.set('after', this.#cursor);
            const res = await fetch(`${this.#FN}/segments/members?${params.toString()}`, { signal: this.#abort.signal });
            if (!res.ok) throw new Error('HTTP ' + res.status);
            const d = await res.json();
            if (String(this.#current?.id) !== segId) return; // navegou pra outro segmento
            this.#members.push(...(Array.isArray(d.members) ? d.members : []));
            this.#cursor = d.end_cursor || null;
            this.#hasNext = !!d.has_next;
            if (Number.isFinite(d.count)) this.#counts.set(segId, d.count);
            this.#renderMembers(d.count);
          } catch (e) {
            if (e?.name === 'AbortError') return;
            if (String(this.#current?.id) !== segId) return;
            this.#renderMembersError(e?.message || 'erro');
          } finally {
            this.#loadingMore = false;
          }
        }

        #renderMembers(total) {
          const dc = this.querySelector('[data-detail-count]');
          if (dc && Number.isFinite(total)) dc.innerHTML = `<strong>${this.#fmtInt(total)}</strong> ${total === 1 ? 'cliente' : 'clientes'}`;
          const sub = this.querySelector('[data-members-sub]');
          if (sub && Number.isFinite(total)) sub.textContent = `mostrando ${this.#fmtInt(this.#members.length)} de ${this.#fmtInt(total)}`;
          const list = this.querySelector('[data-members-list]');
          if (list) {
            list.innerHTML = this.#members.length
              ? this.#members.map(m => this.#memberRow(m)).join('')
              : `<div class="tsf-segs__members-empty">Nenhum cliente neste segmento ainda.</div>`;
          }
          this.#renderMembersFoot(this.#hasNext ? 'more' : 'done');
        }

        #memberRow(m) {
          const initial = this.#esc((m.name || m.email || '?').trim().charAt(0).toUpperCase() || '?');
          const contact = this.#esc(m.email || m.phone || '');
          const meta = [];
          if (m.orders > 0) meta.push(`${this.#fmtInt(m.orders)} ${m.orders === 1 ? 'pedido' : 'pedidos'}`);
          if (m.spent > 0) meta.push(this.#fmtMoney(m.spent, m.currency));
          return `
            <a class="tsf-segs__member" href="/pages/admin-cliente?id=${encodeURIComponent(m.customer_id)}">
              <span class="tsf-segs__member-avatar" aria-hidden="true">${initial}</span>
              <span class="tsf-segs__member-body">
                <span class="tsf-segs__member-name">${this.#esc(m.name || '—')}</span>
                ${contact ? `<span class="tsf-segs__member-contact">${contact}</span>` : ''}
              </span>
              ${meta.length ? `<span class="tsf-segs__member-meta">${meta.map(x => `<span>${this.#esc(x)}</span>`).join('')}</span>` : ''}
              <span class="tsf-segs__member-arrow" aria-hidden="true">→</span>
            </a>`;
        }

        #renderMembersFoot(state) {
          const foot = this.querySelector('[data-members-foot]');
          if (!foot) return;
          if (state === 'loading') { foot.innerHTML = `<span class="tsf-segs__members-loading">Carregando mais…</span>`; return; }
          if (state === 'more') {
            foot.innerHTML = `<button type="button" class="tsf-segs__loadmore" data-loadmore>Carregar mais clientes</button>`;
            foot.querySelector('[data-loadmore]')?.addEventListener('click', () => this.#fetchMembers(false), { once: true });
            return;
          }
          foot.innerHTML = this.#members.length ? `<span class="tsf-segs__members-done">Fim da lista · ${this.#fmtInt(this.#members.length)} ${this.#members.length === 1 ? 'cliente' : 'clientes'}</span>` : '';
        }

        #renderMembersError(msg) {
          const list = this.querySelector('[data-members-list]');
          if (list && !this.#members.length) list.innerHTML = `<div class="tsf-segs__members-empty">Não foi possível carregar os clientes.<br><small>${this.#esc(msg)}</small></div>`;
          const foot = this.querySelector('[data-members-foot]');
          if (foot) {
            foot.innerHTML = `<button type="button" class="tsf-segs__loadmore" data-loadmore>Tentar de novo</button>`;
            foot.querySelector('[data-loadmore]')?.addEventListener('click', () => this.#fetchMembers(this.#members.length === 0), { once: true });
          }
        }
      }
      customElements.define('tsf-admin-segmentos', TsfAdminSegmentos);
    }
    if (!customElements.get('tsf-inline-client')) {
      customElements.define('tsf-inline-client', TsfInlineClient);
    }
    // Pre-instantiate search overlay (faster open response)
    TsfSearchOverlay.getInstance();

    // Cmd/Ctrl+K global + clique no botao "Buscar" da topbar -> abre o SearchOverlay.
    // Fix 22-07: o wiring original vivia no <tsf-companion>, que esta pausado e nunca registra.
    document.addEventListener('keydown', function (e) {
      if ((e.metaKey || e.ctrlKey) && e.key && e.key.toLowerCase() === 'k') {
        if (document.querySelector('tsf-quote-builder')) return; // editor orcamento/venda: Cmd+K e do picker de produto
        e.preventDefault();
        try { TsfSearchOverlay.getInstance().open(); } catch (_) {}
      }
    });
    document.addEventListener('click', function (e) {
      var trg = e.target && e.target.closest && e.target.closest('[data-tsf-admin-search-trigger],[data-tsf-search-trigger]');
      if (trg) { e.preventDefault(); try { TsfSearchOverlay.getInstance().open(); } catch (_) {} }
    });
    // Init pricing main display (slider de markup em produto hide_price)
    for (const root of document.querySelectorAll('[data-tsf-pricing]')) {
      TsfPricingMain.init(root);
    }
    // Quote add-to handler (event delegation pra suportar AJAX re-renders)
    document.addEventListener('click', (e) => {
      const btn = e.target.closest?.('[data-tsf-add-quote]');
      if (btn) {
        e.preventDefault();
        handleQuoteButton(btn);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();

// cache-bump pos-incidente Shopify 2026-06-03 11:40 (forca reprocessamento do asset no CDN; sem mudanca de logica)
